webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "blue_icon.svg?923c5d55d50bb52768cfa7d99096e148";

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_USDT.png?a476e8e079f144e65e714f8d6be5c435";

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa759d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aa759d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stratumblue_white_outline_logo.png?7b76d9cdb4744ab874ffee8c27952690";

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLanguageBar_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e9c3c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLanguageBar_vue__ = __webpack_require__(724);
function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20e9c3c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLanguageBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20e9c3c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLanguageBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BluPricesHeader_vue__ = __webpack_require__(201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9c751e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BluPricesHeader_vue__ = __webpack_require__(725);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BluPricesHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9c751e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BluPricesHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i18n", function() { return i18n; });
/* harmony export (immutable) */ __webpack_exports__["setI18nLanguage"] = setI18nLanguage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguageAsync", function() { return loadLanguageAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveLanguage", function() { return resolveLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_global__ = __webpack_require__(75);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: __WEBPACK_IMPORTED_MODULE_2__languages__["en"].name, // set locale
    fallbackLocale: __WEBPACK_IMPORTED_MODULE_2__languages__["en"].name,
    messages: __WEBPACK_IMPORTED_MODULE_2__languages__["en"].messages
});

var loadedLanguages = [__WEBPACK_IMPORTED_MODULE_2__languages__["en"].name]; // our default language that is preloaded 

function setI18nLanguage(lang) {
    i18n.locale = lang;
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
    return lang;
}

var loadLanguageAsync = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(lang) {
        var msgs;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(i18n.locale !== lang)) {
                            _context.next = 15;
                            break;
                        }

                        if (loadedLanguages.includes(lang)) {
                            _context.next = 14;
                            break;
                        }

                        _context.prev = 2;
                        _context.next = 5;
                        return __webpack_require__(698)("./" + lang);

                    case 5:
                        msgs = _context.sent;

                        i18n.setLocaleMessage(lang, msgs.default);
                        loadedLanguages.push(lang);
                        return _context.abrupt('return', setI18nLanguage(lang));

                    case 11:
                        _context.prev = 11;
                        _context.t0 = _context['catch'](2);

                        setI18nLanguage(loadedLanguages[0]);

                    case 14:
                        return _context.abrupt('return', Promise.resolve(setI18nLanguage(lang)));

                    case 15:
                        return _context.abrupt('return', Promise.resolve(lang));

                    case 16:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[2, 11]]);
    }));

    return function loadLanguageAsync(_x) {
        return _ref.apply(this, arguments);
    };
}();

var resolveLanguage = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var cookieLanguage, browserLanguage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        cookieLanguage = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.languageCookie;

                        if (!cookieLanguage) {
                            _context2.next = 13;
                            break;
                        }

                        _context2.prev = 2;
                        _context2.next = 5;
                        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setLanguageSelected', cookieLanguage);

                    case 5:
                        return _context2.abrupt('return', Promise.resolve());

                    case 8:
                        _context2.prev = 8;
                        _context2.t0 = _context2['catch'](2);

                        console.log(_context2.t0);

                    case 11:
                        _context2.next = 36;
                        break;

                    case 13:
                        browserLanguage = navigator.languages[0];

                        browserLanguage = browserLanguage.indexOf("-") !== -1 ? browserLanguage.split("-")[0] : browserLanguage;

                        if (!__WEBPACK_IMPORTED_MODULE_5__configs_global__["a" /* availableLanguages */].includes(browserLanguage)) {
                            _context2.next = 27;
                            break;
                        }

                        _context2.prev = 16;
                        _context2.next = 19;
                        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setLanguageSelected', browserLanguage);

                    case 19:
                        return _context2.abrupt('return', Promise.resolve());

                    case 22:
                        _context2.prev = 22;
                        _context2.t1 = _context2['catch'](16);

                        console.log(_context2.t1);

                    case 25:
                        _context2.next = 36;
                        break;

                    case 27:
                        _context2.prev = 27;
                        _context2.next = 30;
                        return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setLanguageSelected', __WEBPACK_IMPORTED_MODULE_5__configs_global__["a" /* availableLanguages */][0]);

                    case 30:
                        return _context2.abrupt('return', Promise.resolve());

                    case 33:
                        _context2.prev = 33;
                        _context2.t2 = _context2['catch'](27);

                        console.log(_context2.t2);

                    case 36:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this, [[2, 8], [16, 22], [27, 33]]);
    }));

    return function resolveLanguage() {
        return _ref2.apply(this, arguments);
    };
}();

// export function resolveLanguage(to, next) {
//     if (store.getters.languageCookie) {
//         store.commit("setLanguageSelected", store.getters.languageCookie)
//         store.dispatch('setLanguageAsync', store.getters.languageCookie).then(() => {
//             next()
//         })
//     } else if (store.getters.languageSelected) {
//         store.dispatch('setLanguageAsync', store.getters.languageSelected).then(() => {
//             next()
//         })
//     } else {
//         let browserLanguage = navigator.languages[0];
//         if (browserLanguage.indexOf("-") !== -1) {
//             browserLanguage = browserLanguage.split("-")[0];
//         }
//         store.commit("setLanguageSelected", browserLanguage)
//         store.dispatch('setLanguageAsync', browserLanguage).then(() => {
//             next()
//         }).catch((e) => {
//             next()
//         })
//     }
// }

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return endpoints; });
/* unused harmony export moneyInput */
/* unused harmony export cryptoInput */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return availableLanguages; });
var endpoints = {
    protocol: "https:",
    backendUrl: "bluetoken.io",
    frontendUrl: "bluetoken.io"
};

var moneyInput = {
    decimal: ",",
    thousands: ".",
    // prefix: "U$ ",
    precision: 2,
    masked: false
};

var cryptoInput = {
    decimal: ".",
    thousands: "",
    precision: 8,
    masked: false
};

var availableLanguages = ["en", "es"];

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseWrittenLogo_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5e21d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseWrittenLogo_vue__ = __webpack_require__(721);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseWrittenLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5e21d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseWrittenLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Redeem2fa_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e24da52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Redeem2fa_vue__ = __webpack_require__(951);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Redeem2fa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e24da52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Redeem2fa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "en", function() { return en; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "es", function() { return es; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pt", function() { return pt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "languages", function() { return languages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pt__ = __webpack_require__(129);




var en = {
    name: 'en',
    messages: { "en": __WEBPACK_IMPORTED_MODULE_0__en__["default"] }
};
var es = {
    name: 'es',
    messages: { "es": __WEBPACK_IMPORTED_MODULE_1__es__["default"] }
};

var pt = {
    name: 'pt',
    messages: { "pt": __WEBPACK_IMPORTED_MODULE_2__pt__["default"] }
};

var languages = [en, es];

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _msg;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["default"] = ({
  msg: (_msg = {
    //countdown / time
    seconds: "Seconds",
    minutes: "Minutes",
    hours: "Hours",
    days: "Days",

    //titles / sub
    insights: "Insights",
    fund_holdings: "Holdings",
    charity_sub: "Stratum has donated the following to charity.",
    network_distributions: "Network distributions",
    network_distributions_sub: "Coins earned on network distributions such as airdrops.",
    redemption_sub: "Operation to liquidate BLUE, and receive the equivalent value in dollar-pegged stablecoin Tether (USDT).",
    twofa_info: "To redeem, you must enable 2FA.",
    redemption_sub_one: "Redemptions are available on Wednesdays, from 0h to 17h (UTC -3), and will take 3 business days to credit (D+3).",
    redemption_sub_two: "A same-day payment option is available for a fee.",
    redemption_sub_three: "Redemptions are paid using the Tron network (TRC-20).",

    //a
    alert_created_deposit: "Your wallet has already been created, please refresh the page.",
    alert: "Alert",
    asset_allocation: "Cryptocurrency Allocation",
    amount_below_purchase_limit: "Amount below minimum purchase limit",
    amount_below_minimum_trade_limit: "Amount below minimum trade limit",
    activating_account: "Please wait. Activating account...",
    activation_successful: "Congratulations, your account is now active. You may login now.",
    activation_successful_2fa: "Congratulations, your 2fa code now active. You may proceed to services.",
    activation_link_invalid: "Activation link is invalid",
    apply_filter: "Apply filter",
    add_funds: "Add BLUE",
    address: "Address",
    actions: "Actions",
    action: "Action",
    all: "All",
    all_rights_reserved: "All rights reserved",
    all_transactions: "View all",
    already_member: "Already a member?",
    amount: "Amount",
    approx_value: "Approximated value",
    equivalent_in: "Equivalent in",
    one_blu_equals: "1 BLUE equals",
    equivalence: "Equivalence",
    one_blu: "1 BLUE",
    updated_last: "Updated last",
    all_time: "All times",
    activate: "Activate",
    available_info: "Available for redemption",
    available_to_redeem: "Due to high demand on redemptions, and the current amount of funds locked on exchanges, this redemption will pass our feasible redemption liquidity threshold for this week.  Please try a lower amount, or try  your redemption again next week.",
    available: "Available",
    attention_done: "Attention: Your order has been done",
    attention_cancel: "Attention: Your order has been canceled. If you wish to purchase BLUE, please open a new order",
    attention_waiting_days: "Attention: Your order has {hours} until expiration.",
    attention_waiting_hours: "Attention: Your order has {hours} hours until expiration.",
    attention: "Attention",
    available_balance: "Available Balance: ",
    allocation: "Allocation",
    authenticate: "Authenticate",
    address_empty: "Address is empty",
    average_time: "Deposits may take up to 5 minutes.",

    //b
    balance: "Balance | Balances",
    begins: "Begins",
    bonus: "Bonus",
    buy: "Buy",
    buy_tokens: "Buy BLUE",
    buyer_bonus: "Buyer bonus",
    blank: "",
    bonus_0dot5: "Bonus(0.5%)",
    bonus_1: "Bonus(1%)",
    buy_here: "Buy Here",
    buy_now: "Buy Now",
    bktc: "BKTC",
    back: "Back",
    balance_equivalence: "Balance equivalence in",
    buy_pix: "Buy BLUE with PIX",
    buy_pix_info: "Using SWAPiX, a trusted partner offering fiat-to-crypto exchanges.",
    blue_club_status: "Blue Club Status",

    balance_text_tusd: "TrueUSD Stablecoin pegged to the American Dollar",
    balance_text_btc: "Bitcoin",
    balance_text_rlt: "RealT Stablecoin pegged to the Brazilian Real",
    balance_text_eth: "Ethereum",
    buy_token: "BUY TOKEN",
    boleto: "Boleto",
    best_way_buy: "Best way to buy",
    browser_message: "If you cannot see the document, please use Firefox or Safari.",
    business_day: "BUSINESS DAYS",
    no_additional_fee: "No additional fees.",
    rush_today: "RUSH (Today)",
    receive_today_info: "You will receive in the same calendar day.",
    basket_value: "Basket Value",

    //c
    charity: "Charity",
    clear_filter: "Clear filter",
    cancelled: "Cancelled",
    cancel_purchase: "Cancel Purchase",
    click_on_transaction_to_get_details: "Click on a transaction for more details.",
    chart: "Chart",
    crypto: "Crypto",
    copy_twofa: "Scan the QR code with your cell phone using Google Authenticator or Authy, or type the code.<strong>Keep this code in a safe place in case you lose your phone, and do not share with anyone. You can recover your 2FA using this code.</strong>",
    confirm_delet: "Are you sure?",
    click_here: "Access smartwallet",
    confirm_redeem: "Your redemption is being processed.",
    confirm_withdraw: "Your withdraw is being processed.",
    amount_revice_withdraw: "Amount to receive",
    amount_revice_withdraw_fee: "Fee: ",
    confirm_internal: "Your internal transfer is being processed.",
    can_not_load_data: "Cannot load data.",
    change: "Change",
    coin_slider_BTC: "Bitcoin",
    coin_slider_RAS: "Ras - Stablecoin paired to Brazilian Real",
    coin_slider_BLU: "TrueUSD - Stablecoin paired to American Dollar",
    coin_slider_ETH: "Ethereum",
    coin_slider_ZAR: "RAND - South Africa currency",
    coin_slider_EUR: "Euro - European Union currency",
    coin_slider_GBP: "Pound Sterling - United Kingdom currency",
    coin_slider_CHF: "Swiss Franc - Switzerland currency",
    coin_slider_CNY: "Yuan - Chinese currency",
    coin_slider_CAD: "CA$ - Canadian currency",
    coin_slider_AUD: "A$ - Australian currency",
    coin_slider_HKD: "HK$ - Hong Kong Dollar currency",
    coin_slider_USDT: "USDT - Stablecoin paired to American Dollar",
    cancel: "Cancel",
    contact_us_any_question: "Please feel free to contact us at support@bluetoken.io for any questions.",
    cellphone: "Cellphone",
    cpf: "CPF",
    cep: "CEP",
    complement: "Complement",
    city: "City",
    criptocurrency: "Cryptocurrency",
    chose_two_coins: "Return shown is year-to-date, until December 23rd 2022.",
    click_here_to_vote: "Click here to vote",
    copy_address: "Copy Address",
    create_order: "Create new order",
    cancel_transaction: "Cancel transaction",
    canceling_order: "Cancelled order",
    canceling: "Cancelled",
    checking_open_orders: "Checking open orders",
    copy_alert_info_otc: "Copied - expected amount and estimated amount",
    confirm_recaptcha: "Confirm the CAPTCHA",
    create_deposit_address: "Create deposit address",
    check_info_redeem: "I have verified that the above information is accurate.",
    current_value: "Current Value",
    component_hold: "Component",
    current_weight: "Current Weight",
    currently_generating: "Currently generating daily rewards",
    country_residency: "Country of Residency",
    countries_not_allowed: "USA/China/HK - Countries not allowed to use our services!",
    clain_your_nft: "Claim your NFT",

    //check
    check_your_email: "Please check your email and follow the instructions.",
    check_your_email_for_userid: "You will receive an email with your User ID.",
    check_your_email_for_recovery_link: "You will receive an email with a recovery link.",
    check_your_email_for_pin: "You will receive an email with the PIN to confirm the transaction",
    check_your_email_for_pin_redeem: "You will receive an email with the PIN to confirm the transaction",
    if_no_email_spam: "If you cannot find the email, please check your Spam box.",
    closes: "Closes",
    component: "Component | Components",
    confirm: "Confirm",
    confirm_operation: "Confirm Operation",
    confirmation_pin: "Confirm Your Pin",
    confirmation_pin_email_hint: "Upon continuation you will receive an email with a confirmation pin, required to complete your operation.",
    contact: "Contact",
    continue: "Continue",
    copied: "Copied",
    copy: "Copy",
    currency: "Currency",
    click_here_action: "click here",
    change_withdraw_partner: "To change withdraw partner,",

    //d
    denied: "Denied",
    dashboard: "Dashboard",
    dont_have_btc: "Don't have Bitcoin?",
    details: "Details",
    deposits: "Deposits",
    deposit_amount: "Deposit Amount",
    dear_blu_holder: "Dear BLUE holder",
    district: "District",
    donwload: "Donwload",
    documentation_info: "Fact sheets, methods, calculation and other documents",
    dropdown_header_withdraw: "Send your tokens to an external wallet",
    dropdown_header_deposit: "Receive your tokens from an external wallet",
    dropdown_header_redeem: "Exchange your tokens",
    dropdown_header_internal: "Send BLUE to another user",
    destination_user: "Destination user",
    deposit_received: "Your deposit has been received",
    do_you_want: "Do you want to cancel anyway?",
    download_pdf: "Download PDF",
    blue_team: "BLUE Team",
    deposit_sub: "Deposit is an operation that allows you to receive {coin} from an external wallet.",
    delivery_speed: "Delivery Speed",
    download_csv: "Download CSV",

    //dates
    date_1: "December 4th, 2018",
    date_2: "January 15th, 2019",
    date_3: "January 16th, 2019",
    date_4: "February 15th, 2019",
    date_5: "February 16th, 2019",
    date_6: "April 6th, 2019",
    date_7: "April 11th, 2019",

    days_remaining: "Days remaining",
    deposit: "Deposit",
    disclaimer: "Disclaimer",
    documentation: "Documentation",

    //e
    expire_in: "Expire at",
    expired: "Expired",
    earn_on_referrals: "Earn on referrals",
    earn_bonus_tooltip: "Bonus earned from referral program.",
    email: "Email",
    equals: "Equals",
    export_csv: "Export CSV",
    ends: "Ends",
    explorer: "Explorer",
    equivalent: "Equivalent",
    equivalent_to: "Equivalent to",
    expired_pin: "Expired pin",
    enable_2fa: "Enable 2FA",
    eth_contract_message: "Do not send Ether using a Smart Contract",
    clicl_expand: "Click to expand",
    expand_chart: "Expand Chart",
    estimated_info_modal_equivalent: "Estimated value based on Tether exchange with other currencies",

    //error_message
    error: "Error",
    error_create_address: "Error to create the address, try later",
    error_redeem: "There was an error with your request.",
    error_redeem_amount: "Make sure that you have enough balance available and that the amount requested is above the minimum.",
    error_redeem_amount_no_funds: "You don't have enough unlocked funds to perform this operation",
    error_redeem_amount_below_min: "The amount MUST be above the minimum required.",
    error_redeem_address: "Make sure to use a valid BTC address.",
    error_withdraw_address: "Make sure to use a valid BLUE address.",
    error_redeem_confirm: "An error occurred, check the fields.",
    error_internal_member_not_found: "User ID not found",
    error_pool_avatar: "Avatar already exists.",
    error_pool_avatar_select: "You need to choose an avatar name and icon.",

    //f
    faq: "FAQ",
    fee: "Fee | Fees",
    fees_minimums: "Fees & Minimums",
    forgot_password: "Forgot password",
    forgot_userid: "Forgot User ID",

    fee_1dot5: "Fee 1.5%",
    fee_2dot5: "Fee 2.5%",
    fee_4: "Fee 4%",
    fee_6: "Fee 6%",
    fees_minimum_amount: "Fee is 2 USDT of amount, with a minimun of 2 USDT",
    fund_in_maintenance: "Our system is currently under maintenance, please try your operation at a later time.",
    fill_form_boleto: "Fill the form to generate a Boleto",
    fill_form: "Fill the form",
    fact_sheet: "Fact Sheet",
    finish_Vote: "Finish vote",
    finish: "Finish",
    form_error_fields: "All fields are required!",
    found_member: "Found Member",
    fee_info_redeem_one: "Fee is",
    fee_info_redeem_two: "of amount, with a minimum of",
    fee_redeem_wave_info: "Fee is 2 USDT for redemptions below 50 USDT.",
    error_xgateway: "Our network is currently experiencing issues with the selected crypto. Please try again in a few minutes.",

    //g
    get_pin: "Get pin",
    global_search: "Global search",
    generate_slips: "Generate Boleto",
    g_l: "G/L",
    generating_tokens: "Generating tokens, please wait",

    //h
    help: "Help",
    history: "History",
    hypothetical_portfolio: "Hypothetical components subject to change.",
    home: "Home",
    here: "here",
    how_vote: "How to vote?",
    header_referral: "Did someone refer you?",
    how_it_works: "<a href=https://youtu.be/NujOX3n7d-g target=_blank>How does it work?</a>",

    //i
    input_usdt_address: "Input USDT address",
    input_blue_amount: "Input BLUE amount",
    input_amount_redeem: "Input the amount of BLUE you wish to redeem.",
    input_amount_withdraw: "Input the amount of BLUE you wish to withdraw.",
    input_amount_transfer: "Input the amount of BLUE you wish to transfer to another account",
    info_redeem_step_3: "For your safety, enter the PIN and 2fa.",
    info_redeem_address_step_4: "Address: ",
    info_redeem_email_step_4: "You will receive all the details in your email.",
    info_redeem_step_4: "The process will be completed today.",
    info_redeem_step_5: "The process will take 3 business days.",
    info_withdraw_step_4: "Wait until your transaction is processed by the blockchain.",
    info_2fa_tip: "As a security measure, you must first enable 2FA to transfer or redeem your tokens.",
    inform_the_amount_bitcoin_address: "Inform the amount and your Bitcoin address",
    inform_the_amount_blu_tag: "Input the amount and BLUE address",
    inform_the_amount_user_id: "Inform the BLUE amount and User ID",
    internal: "Internal transfer",
    internal_sub: "Internal Transfer is an operation that allows you to send BLUE to another user within the BLUE platform.",
    internal_steps: "Internal  Transfer steps",
    internal_action_send: "Sent",
    internal_action_receive: "Received",
    info_usdt_blue_purchase: "Send only USDT to this address. You must use the Tron Network (TRC20).",
    input_valid_usdt: "Input a valid Tether (USDT) TRC20 Address",
    send_to_my_usdt: "Send to my Tether wallet",
    usdt_info_trc20: "We use Tron`s TRC20 network. Make sure you only input a TRC20 address.",
    input_text_USDT: "Input the amount and USDT Address",
    input_text_invalid_USDT: "Input the amount of USDT you wish to withdraw.",

    //insert
    insert_bitcoin_address: "Insert Bitcoin Address",
    insert_quantity: "Insert quantity",
    insert_your_pin: "Insert your pin",

    //invalid
    invalid_address: "Invalid Address",
    invalid_amount: "Invalid amount",
    invalid_credentials: "Invalid credentials.",
    invalid_destination_address: "Invalid destination address.",
    invalid_phone: "Invalid phone",
    invalid_phone_country: "Country not allowed to use our services.",
    invalid_email: "Invalid email.",
    invalid_has_accepted_terms: "Please accept the Terms & Conditions.",
    invalid_is_aware_token_redemption: "Please check the checkbox above.",
    invalid_input_amount_crypto: "Invalid amount",
    invalid_is_not_usa_citizen: "Confirm that you are not a citizen or resident of the United States.",
    invalid_is_not_china_citizen: "Confirm that you are not a citizen or resident of Hong Kong.",
    invalid_password: "Invalid password.",
    invalid_password_confirmation: "Invalid password confirmation.",
    invalid_password_old: "Invalid current password",
    invalid_pin: "Invalid PIN.",
    invalid_referral_code: "Invalid referral code.",
    invalid_userid: "Invalid user ID.",
    invalid_user_id: "Invalid user ID.",
    invalid_connetion: "There was a problem authenticating your request, check your connection or your user.",
    invalid_2fa_code: "Incorrect 2fa code",
    insert_referral_code: "Insert referral code (Optional)",
    invalid_has_accepted_privacy_policy: "Please accept the Privacy policy",
    Invalidaddress: "This address is not accepted.",

    //l
    language: "Language | Languages",
    launch: "Launch",
    launch_april: "Launch - APRIL 2019",
    legal: "Legal",
    list: "List",
    last_update: "Last update",
    link_no_account: "If don't have a Stratum account yet, <a href=\"https://auth.stratum.hk/signup.php?lang=en\" target=\"_blank\"> click here </a> to create one.",
    loading_balance: "Loading account balance...",
    live_price: "Live Price",
    last_month_blue_total: "Blue Pool paid a total of",

    //languages
    en: "EN | English",
    es: "ES | Spanish",
    pt: "PT | Portuguese",

    loading: "Loading",
    loading_data: "Loading Purchase Data",
    load_fee: "Load Fee",
    login: "Login",
    login_successful: "Logged in successfully",
    login_here: "Login Here",
    logout: "Logout",
    latest: "Latest",

    //m
    minimum: "Minimum",
    money: "money",
    masternodes: "masternodes",
    make_new_redeem: "Make a new redemption",
    methodology: "Methodology",
    min_amount_is: "The minimum amount is",
    member_not_found: "Member not found.",
    make_sure_address: "Make sure to use a valid BLUE address.",
    my_balances: "My Balances",
    my_balance: "My Balance",
    my_total_value: "My Total Value",
    my_gain_loss: "My Gain/Loss",
    minimum_purchase_USDT: "Minimum required balance is 20 USDT. Please increase your balance.",
    minting: "Minting",
    member_benefits: "Membership Benefits",
    my: "My",

    //n
    name: "Name",
    name_optional: "Name (Optional)",
    next: "Próximo | Prox",
    no_data_found: "No data found",
    no_rec_transactions_found: "No transactions found.",
    not_enough_balance: "Not enough balance",
    not_member_yet: "Not a member yet?",
    next_step: "Next step",
    number: "Number",
    no: "No",
    network: "Network",
    notification: "Notification",
    only_one_day: "Only 1 redemption per day allowed.",

    //o
    of: "of",
    opens: "Opens",
    open_account: "Open Account",
    operations: "operations",
    Operations: "Operations",
    or: "or",
    one_token_equivalence: "One BLUE equivalence in",
    optional: "Optional",
    otc_info: "Please provide the information below. Our OTC desk will get in touch to assist you with your purchase.",
    otc_thank_msg: "Our OTC Desk will contact you shortly.",
    otc_purcahse_info: "Purchase Information",
    otc_purcahse: "OTC Purchase",
    otc_purchase_info_to_user: "Your purchase is being processed by our OTC Desk, please wait.",

    //p
    past_2fa: "Input here the 2FA code with 6 digits",
    pin_already_been_used: "Pin already been used",
    price_graph: "Price Graph",
    portfolio_value: "Crypto-basket Value",
    pay_slip_info: "Pay the boleto to receive your BLUEs",
    purchase_information: "Purchase information",
    please_chose_two_coins: "Please choose 2 cryptocurrencies.",
    phone_optional: "Phone",
    phone_code: "Country Code",
    phone: "Phone",
    purchase_seller_to_user: "Purchase BLUE for other user?",
    purchase_success: "Your purchase have been created for the user.",
    price_history_list: "Price History",
    closing_price: "Closing Price",
    pay_with_USDT: "Pay with USDT balance",

    //password
    change_password: "Change password",
    current_password: "Current Password",
    confirm_password: "Confirm password",
    new_password: "New Password",
    password: "Password",
    password_create: "Create new password",
    password_changed: "Password has been changed",
    password_requirements: "Password must contain at least 8 characters, 1 special character (-_+=,<.>;:^~@#$%&*), 1 lower case letter, 1 capitalized letter and 1 number.",
    recover_password: "Recover Password",
    recover_userid: "Recover User ID",
    password_suggestion: "Use Blue suggested password",
    confirm_password_error: "Confirm your password change.",
    wrong_password_confirmation: "Wrong password confirmation",
    phone_already_registered: "This phone is already registered.",
    email_already_registered: "This email is already registered.",

    pay_with: "Pay with crypto",
    perc_portfolio: "% of Crypto-basket allocation",
    phase: "Phase | Phases",
    portfolio: "Crypto-basket",
    price: "Price",
    pre_sale: "Pre-Sale",
    preferences: "Preferences",
    preferred_language: "Preferred language",
    previous: "Previous | Prev",
    privacy_policy: "Privacy Policy",
    purchase: "Purchase",
    performance: "Price Evolution",
    please_verify_information: "Please verify the information below is accurate.",

    //q
    quantity: "Quantity",

    //r
    receive_calculator_text: "Calculation excludes any fees imposed by your own wallet and the network. We advise to deposit a bit more than the desired amount.",
    receive: "Receive",
    receiving_email: "Receiving email",
    recent_transactions: "Recent transactions",
    redeem: "Redeem",
    referral_award: "Referral Award",
    referrals: "Referrals",
    referral_code: "Referral code",
    report: "Quarterly Report",
    report_link_text: "Launch",
    report_link_download_quarter: "Download the quarterly report October - December 2022 (Q4 2022)",
    report_link_span: "Reports are posted the first week of every quarter.",
    redemptions: "Redemptions",
    redemption: "Redemption",
    redemption_info: "<strong>Fee-less redemptions:</strong> You qualify to redeem up to <strong>50 BLUES</strong> without a fee. Amount must be worth over <strong>1000 TUSD</strong>.",
    redeem_pin: "Input PIN",
    redeem_2fa: "Input 2FA",
    redeem_not_allowed_today: "Redemptions are available Wednesdays, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_1: "Redemptions are not available today. Please refer to the redemption schedule.",
    redeem_not_allowed_today_2: "Redemptions are available Tuesday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_3: "Redemptions are available Wednesdays, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_4: "Redemptions are available Thursday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_5: "Redemptions are available Friday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_6: "Redemptions are available Saturday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_7: "Redemptions are available Sunday, from 00h to 17h (UTC -3).",
    redeem_deleted_success: "Redemption canceled successfully!",
    redeem_deleted_error: "Something wrong, try again later.",
    reedeem_2fa_text: "\n            <p>What is 2FA and why should I use?</p>\n            <p>2FA stands for 2 Factor Authentication. It protects your account by combining something that you know (your password) with something that you have (like your cellphone or security key).</p>\n            <p>After setting up 2FA on your phone, you will see an access code that changes constantly. You must use the 2FA access code every time you redeem tokens; however, you only have to install 2FA once.</p>\n            <p>In case you do not have an authenticator yet, please proceed to use one of the below:</p>\n            <a href=\"https://www.google.com/landing/2step/#tab=how-it-works\" target=\"_blank\">Google Authenticator</a>\n            <a href=\" https://authy.com/download/\" target=\"_blank\">Authy Authenticator</a>\n        ",
    tutorial_tittle: "<p style=\"color:#424b7d\">How to Deposit {coin}?</p>",
    tutorial_deposit: "\n        <p>1. Create a BLUE deposit address;</p>\n        <p>2. Locate the \"SEND\" form on the external wallet;</p>\n        <p>3. Scan or copy the Blue token address into that form.</p><br/>\n        <b>Note:</b>\n        <span>BLUE deposits ara charged a 6% network fee, paid by the sender. <a href=\"https://bluetoken.io/fees\" target=\"_blank\" style=\"margin-top:0px; display: contents;\">Fees.</a></span>\n    ",
    tutorial_deposit_usdt: "\n    <p>1. Create a Tether (USDT) deposit address;</p>\n    <p>2. Locate the \"SEND\" form on the external wallet;</p>\n    <p>3. Scan or copy the Tether (USDT) address into that form.</p><br/>\n    <b>Note:</b>\n    <span>Make sure you select Tron (TRC20) network.</span>\n",
    tutorial_tittle_withdraw: "<p style=\"color:#424b7d\">How to add the Blue Token in external wallets?</p>",
    tutorial_withdraw: "\n        <p>1. Select Binance Smart Chain (BSC) on the external wallet network;</p>\n        <p>2. Copy this Blue token contract address and import on the external wallet;</p>\n    ",
    tutorial_withdraw_pt2: "\n        <b>Note:</b>\n        <p>- Blue Token does not assume responsibility for operations occurring on third party platforms.</p>\n        <p>- All transactions originating outside our platform are charged a 6% network fee. <a href=\"https://bluetoken.io/fees\" target=\"_blank\" style=\"margin-top:0px; display: contents;\">Fees.</a></p>\n    ",
    cancel_redeem: "Cancel Redemption",
    retry: "Retry",
    required_fields: "Required fields",
    recipients_user_id: "Recipient's User ID.",
    staking_rewards: "Recompensas de Staking",
    redeeming: "Redeeming",
    receiving: "Receiving",

    //referral texts
    referral: "Referral",
    referral_text_1: "When you refer people to buy BLUE, you get a reward and they get a bonus, paid in BLUE!",
    referral_text_2: "Give the referral link or code to your friends and family. Rewards and bonuses are unlimited. No matter how many times your referrals buy BLUE, you will get a reward, and they will get a bonus.",
    referral_text_3: "To activate your referral code, first you must purchase BLUEs. Once your purchase BLUEs, come back to this page, and start using your referral code.",
    review_your_purchase: "Review Your Purchase",
    reward: "Reward",
    rows_per_page: "Rows per page",
    redeemed_value: "Redeemed Amount",
    required_fields_amount_uid: "Amount and UID are required for this action.",

    //s
    save: "Save",
    send: "Send",
    settings: "Settings",
    header_settings: "Settings",
    signup: "Sign up",
    something_went_wrong: "Something Went Wrong",
    subtotal: "Subtotal",
    send_to_btc_adress: "Destination Address",
    send_to_btc_adress_destination: "Bitcoin Destination Address",
    send_to_blu_adress: "<strong>BLUE</strong> Destination Address",
    send_to_blu_adress_on: "<strong>BLUE</strong> Destination Address on",
    step_1_withdraw_blue: "1. Select your preferred wallet to Withdraw.",
    allowed_wallets: "*Allowed wallets:",
    step_2_withdraw_blue: "2. Click to copy the Blue Token contract address on the Binance Smart Chain:",
    step_3_withdraw_blue: '3. Click to automatically import the token from Blue on <a href="https://bit.ly/3wMClbk" target="_blank">Metamask</a>',
    step_3_withdraw_blue_p2: "follow the instructions to manually add the token from Blue on:"
  }, _defineProperty(_msg, "or", "or"), _defineProperty(_msg, "contract_address", "0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2"), _defineProperty(_msg, "success", "Successful"), _defineProperty(_msg, "success_create_wallet", "Address created successfully"), _defineProperty(_msg, "session_expired", "Session expired. Please log in again"), _defineProperty(_msg, "services", "Services"), _defineProperty(_msg, "staking_APY", "Staking APY"), _defineProperty(_msg, "submit", "Submit"), _defineProperty(_msg, "months", {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  }), _defineProperty(_msg, "pool", "Pool"), _defineProperty(_msg, "join_pool", "Join & Earn"), _defineProperty(_msg, "monthly_rewards", "{month} Pool Rewards"), _defineProperty(_msg, "my_rewards", "My Estimated Rewards"), _defineProperty(_msg, "qualification_status", "Qualification status"), _defineProperty(_msg, "need_to_qualify", "Need"), _defineProperty(_msg, "to_qualify", "to qualify"), _defineProperty(_msg, "calculating", "calculating..."), _defineProperty(_msg, "posted_soon", "Pool is being calculated and will be posted soon."), _defineProperty(_msg, "nobody_qualified", "Nobody has qualified yet to earn the pool rewards. Be the first and win!"), _defineProperty(_msg, "leaderboard", "Leaderboard"), _defineProperty(_msg, "last_month_winners", "Last month winners"), _defineProperty(_msg, "referral_volume", "Referral Volume"), _defineProperty(_msg, "reward_pool", "Reward %"), _defineProperty(_msg, "estimated_pool", "Estimated"), _defineProperty(_msg, "earned_pool", "Earned"), _defineProperty(_msg, "view_all", "View all"), _defineProperty(_msg, "modal_pool_title", "Blue Pool Rewards"), _defineProperty(_msg, "modal_pool_text", "Every month a pool is created to reward you for your referral's purchases. Participants who accumulate 1 BLUE token or more in referral purchases automatically earn a share of the pool. <a href=https://youtu.be/NujOX3n7d-g target=_blank style='width:auto'>Watch tutorial</a>"), _defineProperty(_msg, "modal_pool_important", "Important"), _defineProperty(_msg, "modal_pool_text2", "To participate, you must first create your avatar."), _defineProperty(_msg, "modal_pool_text3", "Your avatar cannot be changed in the future."), _defineProperty(_msg, "modal_pool_nick", "Create a Nickname"), _defineProperty(_msg, "modal_pool_nick_span", "To protect your privacy. We advise you not to use your real name."), _defineProperty(_msg, "modal_pool_avatar", "Select Avatar"), _defineProperty(_msg, "modal_pool_btn", "JOIN"), _defineProperty(_msg, "modal_pool_welcome", "Welcome to the Blue Pool"), _defineProperty(_msg, "modal_pool_span", "When your referrals accumulate 1 BLUE in purchases, your avatar will show on the leaderboard, securing a share in the pool."), _defineProperty(_msg, "modal_pool_span2", "The more they buy, the bigger your share!"), _defineProperty(_msg, "modal_pool_referral", "Your referral ID:"), _defineProperty(_msg, "modal_pool_referral_link", "Your referral link"), _defineProperty(_msg, "modal_pool_close", "CLOSE"), _defineProperty(_msg, "street_name", "Street name"), _defineProperty(_msg, "state", "State"), _defineProperty(_msg, "select_partner", "Select a partner"), _defineProperty(_msg, "skip", "skip"), _defineProperty(_msg, "start_withdrawal", "Start withdrawal"), _defineProperty(_msg, "start_internal_transfer", "Start Internal Transfer"), _defineProperty(_msg, "internal_transfer", "Internal transfer"), _defineProperty(_msg, "send_exactly", "Send the amount below to the following address:"), _defineProperty(_msg, "seller_buy", "Purchase as the member u want, just need to provide the UID and amount."), _defineProperty(_msg, "sector", "Sector"), _defineProperty(_msg, "step_amount", "Amount"), _defineProperty(_msg, "step_recipient", "Recipient"), _defineProperty(_msg, "step_verification", "Verification"), _defineProperty(_msg, "step_authentication", "Authentication"), _defineProperty(_msg, "status_new", "New"), _defineProperty(_msg, "status_waiting", "Waiting"), _defineProperty(_msg, "status_processing", "Processing"), _defineProperty(_msg, "status_done", "Done"), _defineProperty(_msg, "status_failed", "Failed"), _defineProperty(_msg, "status_cancelled", "Cancelled"), _defineProperty(_msg, "status_denied", "Denied"), _defineProperty(_msg, "status_expired", "Expired"), _defineProperty(_msg, "status_queued", "Queued"), _defineProperty(_msg, "tag", "tag ID"), _defineProperty(_msg, "tag_important", "Make sure to set the right tag ID to ensure that the amount is sent to your address."), _defineProperty(_msg, "terms_and_conditions", "Terms & Conditions"), _defineProperty(_msg, "tokens_go_on_sale", "BLUEs go on sale"), _defineProperty(_msg, "token_presale", "Pre-sale"), _defineProperty(_msg, "token_distribution", "Distribution"), _defineProperty(_msg, "total", "Total"), _defineProperty(_msg, "total_debit", "Total Debit"), _defineProperty(_msg, "total_received", "Total Received"), _defineProperty(_msg, "total_to_transfer", "Total to send"), _defineProperty(_msg, "total_to_pay", "Total to pay"), _defineProperty(_msg, "transaction", "Transaction | Transactions"), _defineProperty(_msg, "transaction_completed", "Transaction Completed"), _defineProperty(_msg, "transaction_details", "Transaction Details"), _defineProperty(_msg, "type", "Type"), _defineProperty(_msg, "token", "Token"), _defineProperty(_msg, "token_info", "Info"), _defineProperty(_msg, "token_supply", "Supply"), _defineProperty(_msg, "token_nav", "NAV"), _defineProperty(_msg, "fund_value", "Fund Value"), _defineProperty(_msg, "token_price", "Price"), _defineProperty(_msg, "transaction_with_wrong_status", "Transaction with incorrect status"), _defineProperty(_msg, "trade_not_found", "Redemption not found. Start again."), _defineProperty(_msg, "transfers", "Transfers"), _defineProperty(_msg, "total_redeem", "Total in BLUE"), _defineProperty(_msg, "total_redeem_USDT", "Total in USDT"), _defineProperty(_msg, "total_plus_block", "Available + blocked"), _defineProperty(_msg, "token_supply_equivalence", "Token supply equivalence in"), _defineProperty(_msg, "transaction_failed_step", "Transaction failed at step {step}, if you have any questions please contact support at support@bluetoken.io"), _defineProperty(_msg, "transfer_blu_stx", "Send your BLUE tokens to <span class='custom_highlight'>StratumX.io</span>. Use to trade BLUE for other cryptos."), _defineProperty(_msg, "transfer_blu_stratum", "Send your BLUE tokens to SmartWallet. Use to sell BLUE, pay bills, plus other services."), _defineProperty(_msg, "transfer_blu_stratum_withdraw_sw", "Send your BLUE tokens to Stratum Advanced Wallet, and enjoy many benefits."), _defineProperty(_msg, "tag_text", "The TAG is a unique identifier to recognize you and made available by the withdrawal partner. The TAG is located at the partner's wallet deposit page."), _defineProperty(_msg, "table_failed_1", "* Incomplete orders"), _defineProperty(_msg, "table_failed_2", "* All Incomplete orders will automatically be cancelled"), _defineProperty(_msg, "thank_you", "Thank you"), _defineProperty(_msg, "thank_you", "Thank you"), _defineProperty(_msg, "temporarily_unavailable", "Temporarily unavailable."), _defineProperty(_msg, "tether_info", "Send via the Tron Network (TRC20), or use your available balance."), _defineProperty(_msg, "token_type", "Token type"), _defineProperty(_msg, "today", "Today"), _defineProperty(_msg, "bep20", "BEP20 (Binance Smart Chain)"), _defineProperty(_msg, "decentralized_ex", "Decentralized Exchanges (DEX)"), _defineProperty(_msg, "metaverse", "Metaverse"), _defineProperty(_msg, "lending", "Lending"), _defineProperty(_msg, "payments", "Payments"), _defineProperty(_msg, "native", "Native"), _defineProperty(_msg, "erc20", "ERC20 (Ethereum)"), _defineProperty(_msg, "todays_market", "Today´s Market"), _defineProperty(_msg, "token_supply", "Token Supply"), _defineProperty(_msg, "smart_contracts", "Smart Contracts"), _defineProperty(_msg, "scaling", "Scaling"), _defineProperty(_msg, "tks_your_payment", "Thanks for your payment."), _defineProperty(_msg, "wait_create_tokens", "Please wait a few minutes while we create your token(s)."), _defineProperty(_msg, "BLU", "BLUE"), _defineProperty(_msg, "BTC", "Bitcoin"), _defineProperty(_msg, "ETH", "Ethereum"), _defineProperty(_msg, "TUSD", "TrueUSD"), _defineProperty(_msg, "createdAt", "Created At"), _defineProperty(_msg, "updatedAt", "Updated At"), _defineProperty(_msg, "status", "Status"), _defineProperty(_msg, "done", "Completed"), _defineProperty(_msg, "pre_done", "Completed"), _defineProperty(_msg, "failed", "Failed"), _defineProperty(_msg, "new", "New"), _defineProperty(_msg, "processing", "Processing"), _defineProperty(_msg, "txid", "TX ID"), _defineProperty(_msg, "start_date", "Start Date"), _defineProperty(_msg, "end_date", "End Date"), _defineProperty(_msg, "use_all", "Use all"), _defineProperty(_msg, "userid", "User ID"), _defineProperty(_msg, "user", "User"), _defineProperty(_msg, "use", "Use"), _defineProperty(_msg, "user_id_inportant", "Make sure to insert the right User ID to ensure that the amount is sent to the correct account"), _defineProperty(_msg, "value", "Value"), _defineProperty(_msg, "view_all_transactions", "View all your transactions"), _defineProperty(_msg, "view_reward_bonus_schedule", "View Reward and Bonus Schedule"), _defineProperty(_msg, "view_status", "View status"), _defineProperty(_msg, "view_status", "View entire history"), _defineProperty(_msg, "voting_info_1", "It's time to vote for 2 cryptocurrencies to add (or keep) as part of the BLUE basket for the first quarter (Q1) of 2023."), _defineProperty(_msg, "voting_info_2", "Lately, government regulators are pursuing cryptocurrency companies that offer returns on arbitrage and similar activities. Compliance to regulators would result in compromising the privacy of our users. As you know, here at Stratum, our user privacy and security have always been our main priority. We decided then, to remove such activities from our portfolio to avoid compliance, and base BLUE on the value of 14 cryptocurrencies instead of 12."), _defineProperty(_msg, "voting_info_3", "Simply click on the button below, and select 2 cryptocurrencies. Voting is not mandatory, but encouraged. We believe any of the options given will be a promising addition to the basket. We will count the votes according to the number of BLUE on your account (each full BLUE on your account gives you 1 vote). Voting will be available until December 30th 23:59h (UTC -3)."), _defineProperty(_msg, "voting_info_4", "We will add more details about this change in an updated whitepaper on our website, such as voting frequency, and its future implementation using blockchain."), _defineProperty(_msg, "vote_bellow", "Vote below"), _defineProperty(_msg, "vote_success", "Voted successfully, Thank you!"), _defineProperty(_msg, "voting_survey", "Voting Survey"), _defineProperty(_msg, "verify_step", "Verify your Redemption"), _defineProperty(_msg, "view_other_currencies", "View other currencies"), _defineProperty(_msg, "verify_your_withdraw", "Verify your withdrawal"), _defineProperty(_msg, "waiting", "Processing"), _defineProperty(_msg, "welcome", "Welcome"), _defineProperty(_msg, "with", "with"), _defineProperty(_msg, "withdrawal", "Withdrawal"), _defineProperty(_msg, "withdraw", "Withdraw"), _defineProperty(_msg, "withdraws", "Withdraws"), _defineProperty(_msg, "withdraw_amount", "Withdraw Amount"), _defineProperty(_msg, "withdraw_transfer", "Withdraw"), _defineProperty(_msg, "was_referred", "Ask your friend for his referral code to earn rewards, or leave blank to donate to Bitgive and B4H"), _defineProperty(_msg, "waiting_for_aprove", "In Order"), _defineProperty(_msg, "waiting_aprove_info", "Available funds only 60 days after each purchase"), _defineProperty(_msg, "w", "W"), _defineProperty(_msg, "withdraw_sub", "Withdrawal is an operation that allows you to send BLUE to a valid and compatible BLUE wallet address."), _defineProperty(_msg, "withdraw_sub_usdt", "Withdrawal is an operation that allows you to send USDT to a valid\n    and compatible USDT wallet address."), _defineProperty(_msg, "withdraw_network_fee", "For withdraws exist the network fee of 0.0005 btc"), _defineProperty(_msg, "we_accet", "We accept"), _defineProperty(_msg, "why_change", "Why the change"), _defineProperty(_msg, "white_paper", "White Paper"), _defineProperty(_msg, "withdrawal_steps", "Withdrawal steps"), _defineProperty(_msg, "withdrawing", "Withdrawing"), _defineProperty(_msg, "yes_cancel_purchase", "Yes, I want to cancel"), _defineProperty(_msg, "you_will_receive", "You will receive"), _defineProperty(_msg, "your_email_shortly", "Your Email should arrive shortly"), _defineProperty(_msg, "you_want_start_new_purchase", "You are canceling a deposit order. If you want to place a new one, start the purchase flow again."), _defineProperty(_msg, "you_must_accpet_terms", "You must agree to our terms and conditions to continue. If you have any questions, please contact support@bluetoken.io."), _defineProperty(_msg, "you_must_accpet_privacy", "You must agree to our privacy policy to continue. If you have any questions, please contact support@bluetoken.io."), _defineProperty(_msg, "yes", "Yes"), _defineProperty(_msg, "beforeSendUnderTitle", "Select amount of BLUE you wish to purchase. The payment must be made with crypto."), _defineProperty(_msg, "blockMsgP", "Minting of new tokens is temporarily unavailable."), _defineProperty(_msg, "amount_in", "Amount in"), _defineProperty(_msg, "estimated_amount_in", "Estimated amount in"), _defineProperty(_msg, "important", "important"), _defineProperty(_msg, "below_button_1", "- The amount of BLUE to credit depends on the amount of crypto we receive. Be aware of any fees your wallet provider might charge you for the transfer. Such charges will decrease the amount of crypto thus decreasing also the amount of tokens."), _defineProperty(_msg, "below_button_2", "- If the amount of BTC we receive is below the minimum required (0.0208 BTC), your BTC will be added to a temporary balance, which you can use on a new order. "), _defineProperty(_msg, "understand_and_agree", "I understand that any amount above the minimum sent to our payment address will be converted to BLUE automatically. "), _defineProperty(_msg, "i_understand", "I understand"), _defineProperty(_msg, "understand_and_agree_button", "I understand and Agree"), _defineProperty(_msg, "understand_and_agree_warning", "Purchase time is between 9am and 5pm (GMT-3), monday to friday. Transactions made outside that time period will be processed in the day after."), _defineProperty(_msg, "waiting_deposit", "Waiting for deposit"), _defineProperty(_msg, "waiting_deposit_otc", "Waiting for OTC confirmation"), _defineProperty(_msg, "transaction_details", "transaction details"), _defineProperty(_msg, "transaction_failed_1", "transaction failed at step "), _defineProperty(_msg, "transaction_failed_2", "if you have any questions please contact support at support@bluetoken.io"), _defineProperty(_msg, "temporary_balance", "Temporary balance"), _defineProperty(_msg, "temporary_balance_substracted", "This temporary balance is subtracted from the total amount to send."), _defineProperty(_msg, "to_send", "to Send"), _defineProperty(_msg, "to_receive", "to Receive"), _defineProperty(_msg, "received", "Received"), _defineProperty(_msg, "expected", "expected"), _defineProperty(_msg, "expected_amount_in", "Expected amount in"), _defineProperty(_msg, "estimated_blu", "estimated BLUE"), _defineProperty(_msg, "estimated", "estimated"), _defineProperty(_msg, "waiting_deposit_undertext", "BLUE amount will be confirmed upon payment\u2019s confirmation on the blockchain."), _defineProperty(_msg, "processing_order", "Processing order"), _defineProperty(_msg, "confirmed_amoutn", "confirmed amount"), _defineProperty(_msg, "follow_transaction_text", "Follow the Transaction"), _defineProperty(_msg, "check_transaction_status", "Check the status of your operation"), _defineProperty(_msg, "new_operation", "New Operation"), _defineProperty(_msg, "order_created", "Order Created"), _defineProperty(_msg, "confirmed_on_blockchain", "Confirmed on the blockchain"), _defineProperty(_msg, "order_completed", "Order Completed"), _defineProperty(_msg, "order_completed_info", "Your BLUE is being created, you will receive a certificate by e-mail when the process is completed."), _defineProperty(_msg, "order_completed_info_title", "Done"), _defineProperty(_msg, "temporary_balance_warning", "Please keep in mind that you have a temporary Balance\n        from previous transactions which will be added to your transfer."), _defineProperty(_msg, "send_btc_to_address", "Send your {coin} to this address in order to receive your BLUES"), _defineProperty(_msg, "purchase_confirmation", "Purchase Confirmation"), _defineProperty(_msg, "min", "min"), _defineProperty(_msg, "btc_sent", "BTC Confirmed"), _defineProperty(_msg, "blu_confirmed", "BLUE Confirmed"), _defineProperty(_msg, "minimum_amount_required", "The amount must be above the minimum."), _defineProperty(_msg, "check_open_orders", "verify open order"), _defineProperty(_msg, "make_new_order", "make new order"), _defineProperty(_msg, "if_no_order", "If no order shows for a long period of time, please make sure you made an order. If needed, make a new one."), _defineProperty(_msg, "confirmed", "Confirmed"), _defineProperty(_msg, "waiting", "Waiting"), _defineProperty(_msg, "action_blocked_purchase", "Our system is currently under maintenance, please try your purchase at a later time."), _defineProperty(_msg, "bktc_text", "Bank to Crypto allows you to quickly buy Bitcoin."), _defineProperty(_msg, "bktc_text2", "To proceed with your transaction, pay with Fiat below"), _defineProperty(_msg, "bktc_only_brazil", "Please beware that this method of payment should only be used by Brazilian customers."), _defineProperty(_msg, "info_link_stratum_wallet", "Access your SmartWallet to buy crypto."), _defineProperty(_msg, "select_coin_payment", "Select a Payment Method"), _defineProperty(_msg, "your_id_is", "Your ID is the 6 digits ID  code sent to your email upon signup."), _defineProperty(_msg, "amount_too_small", "Amount is too small. Minimum purchase is 100 TUSD."), _defineProperty(_msg, "aware_token_redeem", "I am aware tokens may not be transferred until 60 days after purchase."), _defineProperty(_msg, "click_here_phases", "Click here for more details on each phase"), _defineProperty(_msg, "create_new_email_recommendation", "We recommend that you create a new e-mail for each platform.  <span class=\"text_highlight\"> This email will be used to receive your login information and other internal communication.</span>"), _defineProperty(_msg, "current_presale_ends", "Current Pre-Sale Phase 3 ends April 6"), _defineProperty(_msg, "did_someone_referred", "Did someone refer you? (Optional)"), _defineProperty(_msg, "i_read_and_accept", 'I have read and accept the <a href="/terms" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Terms & Conditions</a> and <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Privacy Policy</a>.'), _defineProperty(_msg, "i_read", "I have read and accept the Terms & Conditions."), _defineProperty(_msg, "i_read_privacy", "I have read and accept the Privacy Policy."), _defineProperty(_msg, "not_usa_citizen", "I declare that I am not a citizen or resident of the United States of America."), _defineProperty(_msg, "not_china_citizen", "I declare that I am not a citizen or resident of Hong Kong."), _defineProperty(_msg, "scan_qr_code_or_copy_address", "Scan QR code or copy the address."), _defineProperty(_msg, "warning_60days", "Redemptions and withdraws are not available until 60 days after purchase. Do not send payment if you don't intend to purchase tokens."), _defineProperty(_msg, "portfolio_intro", "Our crypto-basket is made from a selected pool of cryptocurrencies which have verifiable market trust or great growth potential."), _defineProperty(_msg, "text_LUNA", "Terra is a blockchain protocol that uses fiat-pegged stablecoins to power price-stable global payments systems."), _defineProperty(_msg, "text_BTC", "Cryptocurrency with the largest market capitalization. Used for payments and store of value."), _defineProperty(_msg, "text_ETH", "First cryptocurrency platform to create smart contracts and decentralized applications."), _defineProperty(_msg, "text_XRP", "XRP is used by banks and companies for liquidity and transfer settlements."), _defineProperty(_msg, "text_LTC", "Known as the silver to Bitcoins gold. In the early days of crypto, Litecoin was created to be a faster, less expensive version of Bitcoin."), _defineProperty(_msg, "text_BCH", "Bitcoin Cash was created from a Bitcoin fork (coin split). It is a modified version of Bitcoin pursuing faster, less expensive transactions."), _defineProperty(_msg, "text_EOS", "Platform to build decentralized applications, with no transaction fees."), _defineProperty(_msg, "text_XLM", "Lumens are used for remittances, allowing settlements between different currencies."), _defineProperty(_msg, "text_ADA", "Project aiming to develop the most advanced smart contract platform. Its team consists of a large global collective of expert engineers and researchers, including Charles Hoskinson, co-founder of Ethereum."), _defineProperty(_msg, "text_BNB", "Digital Token created by the trading platform Binance, providing several benefits to its traders."), _defineProperty(_msg, "text_TRX", "Decentralized platform to share and monetize digital entertainment."), _defineProperty(_msg, "text_ZCR", "Cryptocurrency created for simplified payments. Services using Zcore include a mobile messenger and masternode system."), _defineProperty(_msg, "text_NXS", "Nexus advanced blockchain architecture provides the highest scalability and security. Nexus also aims to descentralize the internet by providing access via satellites in space."), _defineProperty(_msg, "text_IOTA", "The IOTA project aims to create a secure and decentralized financial ecosystem for the Internet of Things (IoT)."), _defineProperty(_msg, "text_XMR", "Monero excels in privacy and untraceability. Transactions cannot be linked to a particular user or real-world identity."), _defineProperty(_msg, "text_OTC", "Cryptos currently include SafeInsure (SINS), Zcore (ZCR), SmartCash (SMART), DashGreen (DASHG), BitTorrent(BTT), Wink (WIN) and Bitcoin (BTC) ."), _defineProperty(_msg, "text_DASH", "One of the best known cryptocurrencies with a vast growing network of users. Present since the earliest days of crypto, Dash focuses on fast secure payments."), _defineProperty(_msg, "text_LINK", "Ethereum token that powers the Chainlink decentralized oracle network, allowing smart contracts to securely connect to external data sources, APIs, and payment systems."), _defineProperty(_msg, "text_ALGO", "Led by Turing award-winner Silvio Micali, Algorand is an innovative blockchain which cannot be forked, thus avoiding double spending issues. It is used for decentralized exchanges, digital securities, and assets tokenization."), _defineProperty(_msg, "text_MKR", "Digital token created by MakerDAO, the largest decentralized finance platform, providing collateralized loans backed by Ethereum."), _defineProperty(_msg, "text_XTZ", "Native ryptocurrency of the Tezos blockchain,  which focuses on integrating smart contract technology with financial products."), _defineProperty(_msg, "text_LEND", "Digital token used at Aave, one of the fastest growing DeFi lending platforms, providing great benefits to their users."), _defineProperty(_msg, "text_DOT", "Polkadot aims to facilitate a fully functional and user-friendly decentralized web (Web 3.0), enabling cross-blockchain transfers of any type of data or asset."), _defineProperty(_msg, "text_UNI", "Governance token of Uniswap, one of the largest decentralized trading platforms hosted in Ethereum,  which facilitates trading of decentralized finance (DeFi) tokens."), _defineProperty(_msg, "text_FIL", "Filecoin is a decentralized storage system. Unlike cloud storage companies like Amazon or Cloudflare, Filecoin leverages its decentralized nature to protect data's integrity."), _defineProperty(_msg, "text_THETA", "Theta is the native cryptocurrency of the Theta Network, a blockchain for improving the quality and deliverability of streaming video content."), _defineProperty(_msg, "text_MANA", "Digital token used at Decentraland, a virtual reality platform, allowing users to purchase, customize and sell virtual parcels of land as NFTs."), _defineProperty(_msg, "text_CAKE", "Governance token of PancakeSwap, the fastest growing decentralized trading platform (DEX) hosted in the Binance Smart Chain."), _defineProperty(_msg, "text_MATIC", "Governance token of Polygon, a second layer network for Ethereum's scaling and infrastructure development. With Polygon, Ethereum becomes a multi-chain system, facilitating blockchain interoperability, with faster transactions at a lower cost."), _defineProperty(_msg, "text_SOL", "Native token of the Solana network, a fast growing blockchain in the DeFi space, with superb speed and scalability, able to reach up to 65,000 transactions per second."), _defineProperty(_msg, "text_CRV", "Native token of Curve Finance, the decentralized exchange (DEX) with the current highest volume in DeFi. Curve Finance is unique due to its optimization for low slippage swaps between stablecoins or similar assets that peg to the same value."), _defineProperty(_msg, "text_AVAX", "Native token of Avalanche, an up-and-coming smart contracts blockchain in DeFi and the NFT space."), _defineProperty(_msg, "text_MBOX", "Governance token at Mobox, a decentralized play-to-earn gaming app, allowing users to trade NFTs and get rewarded by their participation."), _defineProperty(_msg, "text_USDT", "Stablecoin pegged to the American dollar."), _defineProperty(_msg, "text_TUSD", "Stablecoin pegged to the American dollar."), _defineProperty(_msg, "bitgive_info", "Using bitcoin and blockchain technology to improve public health and the environment worldwide."), _defineProperty(_msg, "b4h_info", "Supports organizations using blockchain technology to bring a positive change to humanity."), _defineProperty(_msg, "tooltip_text_charity", "Up to 50% of our sales fees are donated to Bitgive and Blockchain for Humanity."), _defineProperty(_msg, "tooltip_purchase_referral", "You may fill this field if someone assisted you with the purchase."), _defineProperty(_msg, "tooltip_internal_withdraw", "This is the BLUE user ID of the recipient."), _defineProperty(_msg, "current_balance", "Current Balance"), _defineProperty(_msg, "unlocked_balance", "Unlocked balance"), _defineProperty(_msg, "total_without_fees", "Total without Fees"), _defineProperty(_msg, "total_to_receive", "Total to Receive"), _defineProperty(_msg, "min_length", "Minimum length is"), _defineProperty(_msg, "characters", "characters"), _defineProperty(_msg, "contact_intro", "If you have any questions or issues you need to solve please get in touch in the form below"), _defineProperty(_msg, "email_to_registered", "The email will be sent to your registered email in the platform"), _defineProperty(_msg, "subject", "subject"), _defineProperty(_msg, "message", "message"), _defineProperty(_msg, "form_sent", "Message sent successfully"), _defineProperty(_msg, "form_error", "There was an error sending your message, please try again"), _defineProperty(_msg, "insufficient_funds", "Insufficient Funds"), _defineProperty(_msg, "coin_voting_enj", 'Digital Token used at the ENJIN network, a social gaming platform, allowing users to monetize in-game items, such as NFTs. <a href="https://enjin.io/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_mana", 'Digital token used at Decentraland, a virtual reality platform, allowing users to purchase, customize and sell virtual parcels of land as NFTs. <a href="https://decentraland.org/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_bat", 'Digital token used to reward users and publishers in the growing "Brave" browser. Publishers and creators earn ad revenue as well as tips, while users maintain privacy as they earn BAT for viewing ads. <a href="https://basicattentiontoken.org/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_dash", 'One of the best known cryptocurrencies with a vast growing network of users. Dash focuses on fast and private payments, offering "PrivateSend" to activate untraceable transactions. <a href="https://www.dash.org/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_mkr", 'Digital token created by MakerDAO, one of the largest DeFi platforms, providing collateralized loans backed by Ethereum. <a href="https://makerdao.com/en/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_xtz", 'Native cryptocurrency of the Tezos blockchain,  which focuses on integrating Smart Contract technology with financial products. Lately, several NFT projects, such as the Cleveland Cavaliers, and McLaren, are using Tezos for their collections. <a href="https://tezos.com/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_lend", 'Digital token used at Aave, one of the fastest growing DeFi lending platforms, providing great benefits to AAVE users. <a href="https://aave.com/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_atom", 'Fast growing ecosystem of blockchains that can scale and interoperate with each other, competitor to Polkadot (DOT), Ethereum (ETH) and other major smart contract cryptocurrencies. <a href="https://cosmos.network/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_band", 'Cross-chain data oracle platform that aggregates and connects real-world data and APIs to smart contracts. <a href="https://bandprotocol.com/" target="_blank">Learn more</a>'), _defineProperty(_msg, "coin_voting_aave", 'Digital token used at AAVE, one of the largest DeFi lending platforms. AAVE has recently upgraded to version 3.0, providing "cross-chain" lending and new mechanisms to improve user experience, risk management and capital efficiency. <a href="https://aave.com/" target="blank_">Learn more</a>.'), _defineProperty(_msg, "coin_voting_uni", 'One of the best known decentralized trading platforms, facilitating automated trading of decentralized finance (DeFi) tokens. <a href="https://uniswap.org/" target="blank_">Learn more</a>.'), _defineProperty(_msg, "coin_voting_fil", 'Filecoin is a decentralized storage system. Unlike cloud storage companies like Amazon or Cloudflare, Filecoin leverages its decentralized nature to protect data integrity. <a href="https://filecoin.io/" target="blank_">Learn more</a>.'), _defineProperty(_msg, "coin_voting_cake", 'Governance token of PancakeSwap, the fastest growing decentralized trading platform hosted in the Binance Smart Chain. <a href="https://pancakeswap.finance/" target="blank_">Learn more</a>.'), _defineProperty(_msg, "coin_voting_matic", "Governance token of Polygon, a second layer network for Ethereum's scaling and infrastructure development. With Polygon, Ethereum becomes a multi-chain system, facilitating blockchain interoperability, with faster transactions at a lower cost. <a href=\"https://polygon.technology/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_sand", "Governance token of The Sanbox, a virtual reality world where people can create, share, and sell content as NFTs, such as games and unique experiencies. <a href=\"https://sandbox.game/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_axs", "Governance token of Axie Infinity, the fastest growing \"play-to-earn\" virtual reality game using NFTs. Over 1 million daily active players \"battle\" in Axie Infinity for the chance to earn crypto rewards. <a href=\"https://axieinfinity.com/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_mbox", "Governance token at Mobox, a decentralized play-to-earn gaming app, allowing users to trade NFTs and get rewarded by their participation. <a href=\"https://www.mobox.io/#/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_xmr", "Cryptocurrency focused in privacy. Monero was designed to avoid censorship, with its transactions being fully untraceable. <a href=\"https://monero.org\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_egld", "Elrond is a blockchain designed for high throughput and fast execution speed compared to other smart contract platforms. In order to increase adoption, the project supports developers building on the platform, allowing them to earn 30% of the smart contract fees as royalties. <a href=\"https://elrond.com/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_etc", "Ethereum Classic is the original Ethereum, which still runs with Proof of Work (miners). ETC is used to pay for executing transactions and smart contract functions. <a href=\"https://ethereumclassic.org/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_ton", "Toncoin (TON) is a decentralized layer-1 blockchain developed in 2018 by the encrypted messaging platform Telegram. The project was then abandoned, taken over by the TON Foundation, and renamed from \"Telegram Open Network\" to \"The Open Network\". <a href=\"https://ton.org/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "coin_voting_xlm", "Stellar is an open-source payments network that serves as a distributed intermediary blockchain for global financial systems and circulates a native asset, Stellar Lumens (XLM). <a href=\"https://stellar.org/\" target=\"blank_\">Learn more</a>."), _defineProperty(_msg, "modalNetwork", {
    title: "Announcements",
    text_one: "We are glad to inform you we recently added new features:",

    title_two: "Blue Club",
    text_two: "A Blue Club membership NFT is given to users who purchase 20 BLUE tokens or more. Blue Club members enjoy the following benefits:",
    text_two_t: "You may follow your qualification progress on your Dashboard. We look forward to welcoming you to Blue Club!",
    title_three: "Tether Wallets",
    text_three: "You may now deposit and withdraw Tether (USDT), giving you more investment flexibility. Decide whether is a good time to buy and hold Blue Tokens, or keep Tether at your wallet for when the time is right."
  }), _defineProperty(_msg, "modalBscInfo", {
    title: "Announcements",
    text_one: "As previously informed on our quarterly reports, BLUE will be switching blockchains. The BLUE token will leave the NEM blockchain, to be hosted in the Binance Smart Chain (BSC) blockchain.",

    text_two: "The move has been scheduled for Thursday, November 11th, 2021 at 9:00h (UTC-3). The platform will be unavailable during this transition, which is expected to be 4 days. We expect to have the platform up and running again on Monday, November 15th. During this time, all operations will be unavailable, so please plan accordingly.",

    title_two: "The token price and users balance will not be affected.",
    text_three: "Users will have the same amount of tokens they had before the move. The price of the token will continue to track the 14 cryptocurrencies in our basket during this period.",
    title_four: "We are very excited about the move. BSC will allow easier integration of BLUE with third parties wishing to work with the token. BSC is growing rapidly, currently being the second largest blockchain used on DeFi applications. Due to its low fees, developers and users regard BSC as a cheaper alternative to Ethereum. In addition, BSC was built to host Ethereum projects, which is why developers find it easy to host their projects in Ethereum and BSC.",
    title_five: "As promised, we are constantly working to grow BLUE. This move is a very important step towards our expansion. We are thankful to all our users who continue to support the project."
  }), _defineProperty(_msg, "modalBluePool", {
    title: "Announcements",
    text_one: "We have updated our terms and conditions.",
    title_one: "Purchase fee",
    text_two: "We lowered the BLUE token purchase fee, from 6% to 2%. This will reduce costs to people who wish to purchase BLUE tokens for the first time, and those who usually do monthly contributions.",
    title_two: "Custodial fee",
    text_three: "We raised our custodial fee, from 2.5% to 6% (annual). This will allow us to provide you with better tools, service, and security, plus the creation of a new rewards system.",
    title_four: "New Rewards System: Blue Pool",
    text_four: "We are introducing a new rewards system: Blue Pool. All users are now able to participate in a monthly rewards pool. Rewards are paid to users who refer their friends to purchase BLUE tokens. The first pool has been set at 4.20 BLUE (approximately $1,800 dollars). Earn your share!"
  }), _defineProperty(_msg, "modalDhbtInfo", {
    title: "Announcements",
    text_one: "We have updated our terms and conditions.",
    text_two: "As previously announced, Blue Token is now a product of a newly formed company, Digital Horizon Blockchain Technology, registered in the country of El Salvador.",

    title_two: "The move was due to several benefits given by El Salvador to crypto businesses. El Salvador is the only country in the world that has accepted Bitcoin as legal tender. Its government is incentivizing crypto businesses to invest and flourish, preparing the foundation for future growth in technological innovation and infrastructure.",
    text_three: "We are very excited about the move, and are ready to take advantage of the benefits of El Salvador to take Blue Token to the next level.",
    title_four: "If you have any questions, please email us at support@bluetoken.io.",
    title_one: "Blue is a product of Digital Horizon, based at El Salvador",
    title_five: "Redemption payments and fees",
    text_four: "Starting in February 2nd, all redemptions will be paid out only in USDT (Tether), along with redemptions fees changes:",
    text_six: "Redemption fee: 1% of redemption amount <br/>Minimum redemption fee: 50 USDT",
    text_seven: "Time of payment will continue to be 3 business days. Users will have to option for same-day payment for a fee."
  }), _defineProperty(_msg, "modalBuyBluePix", {
    buy_blue: "Buy BLUE",
    connecting_swapix: "Connecting to SWAPiX",
    only_accepts: "Blue Token only accepts payment in cryptocurrencies.",
    pix_purcase_processed: "Fortunately, Pix purchases are processed by our trusted partner SWAPiX.",
    swapix_terms: "I have read SWAPiX <a class=p5_l href=https://usdt.smartpay.com.vc/static/media/terms_jun.f681a88b.pdf target=blank>terms and conditions</a>.",
    btn_next: "Next",
    welcome: "Welcome to",
    payment_being_processed: "Your payment information is being processed.",
    wait: "Wait a few seconds while we work our magic…",
    payment: "Payment",
    convert_price: "Exchange rate",
    completed_buy: "Your purchase has been completed. If your balance is not up to date, please refresh the page."
  }), _defineProperty(_msg, "modalWarnUser", {
    title: "Withdraw: Important",
    warn1: "Make sure the receiving wallet supports BLUE tokens. Not all BSC wallets support BLUE.",
    warn2: "Blue Token does not assume responsibility for operations occurring on third party platforms.",
    warn3: "All transactions originating outside our platform incur 6% fee.",
    warn4: "Withdrawals are irreversible. Make sure you are sending your tokens to a trusted party.",
    i_understand: "I understand"
  }), _defineProperty(_msg, "modalBlueClub", {
    title: "Membership Benefits",
    subTitle: "A Blue Club membership NFT is given to users who purchase 20 tokens or more.",
    text1: "<div style=\"display:flex\"><a href=\"https://solscan.io/token/AP9rP81KJzPCQFmE4fK9Ue8NWRaXZ5QbqQJn6PKhQP17\" target=\"_blank\" style=\"color: #cb36ee; text-decoration:underline; margin-right:5px\">Blue Club NFT</a> (Non-fungible token).</div>",
    text2: "Priority / VIP access to all our events, including gifts and souvenirs.",
    text3: "Exclusive consulting services.",
    text4: "Rewards from our partners (airdrops, giveaways, promotions).",
    text5: "Invitation to exclusive networking events."
  }), _defineProperty(_msg, "modalClainBlueClub", {
    title: "Claim your Blue Club NFT",
    text2: "Congratulations! You now belong to Blue Token's select VIP club.",
    text3: "You must now claim your NFT, which will give you access to several membership benefits.",
    text4: "Input you Solana Address:",
    text5: "Use an Exodus or Phantom wallet to store your NFT.",
    text6: "For any questions, please contact our support team.",

    text7: "Welcome to Blue Club!",
    text8: "Your NFT is being created. You will receive it within 2 business days.",
    text9: "You will receive a welcome email. Please make sure is not in your spam, since we will keep you posted on events and services in which you will receive VIP treatment.",
    text10: "ok, great!"
  }), _defineProperty(_msg, "settings", {
    title: "Account Settings",
    profile: "Profile",
    security: "Security",
    notifications: "Notifications",

    updateInfoProfile: "Update your basic profile information.",
    updateInfoSecurity: "Update your basic security information.",
    updateInfoNotifications: "Disable or enable your email notifications.",

    currently: "Currently",
    profileStatus: "Profile Status",

    updateProfile: "Click on Save to update your profile information.",
    updateSecurity: "Click on Save to update your security information.",
    updateNotification: "Click on Save to update your notification settings.",

    toggleEmail: "Toggle your email notifications",

    popupSure: "Are you sure?",

    popupChangesApply: "Changes will apply when you log back in."
  }), _msg)
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _msg;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["default"] = ({
  msg: (_msg = {
    //countdown / time
    seconds: "Segundos",
    minutes: "Minutos",
    hours: "Horas",
    days: "D\xEDas",

    //titles / sub
    insights: "Informaciones",
    fund_holdings: "Valores",
    charity: "Caridad",
    charity_sub: "Stratum ha donado lo siguiente a organizaciones benéficas.",
    network_distributions: "Distribuciones de red",
    network_distributions_sub: "Monedas ganadas en distribuciones de red.",
    redemption_sub: "Operation to liquidate BLUE, and receive the equivalent value in dollar-pegged stablecoin Tether (USDT).",
    twofa_info: "Para redimir, debe habilitar 2FA.",
    redemption_sub_one: "Redenciones están disponibles los miércoles, de 0h a 17h (UTC -3), y tardarán 3 días hábiles en abonarse (D+3).",
    redemption_sub_two: "Una opción de pago el mismo día está disponible por una tarifa.",
    redemption_sub_three: "Redenciones se pagan mediante la red Tron (TRC-20).",

    //a
    alert_created_deposit: "Su dirección ya ha sido creada, actualice la página.",
    alert: "Alerta",
    asset_allocation: "Asignación de criptomonedas",
    amount_below_purchase_limit: "Cantidad por debajo del mínimo de compra",
    amount_below_minimum_trade_limit: "Cantidad por debajo del mínimo intercambio",
    activating_account: "Por favor esperar. Activando cuenta...",
    activation_successful: "Felicitaciones, su cuenta ahora está activa. Puede iniciar sesión ahora.",
    activation_successful_2fa: "Felicitaciones, su código 2fa ahora está activo. Puede proceder a los servicios.",
    activation_link_invalid: "El enlace de activación no es válido.",
    apply_filter: "Aplicar filtro",
    add_funds: "Añadir BLUE",
    address: "Dirección",
    actions: "Acciones",
    action: "Acción",
    all: "Todo",
    all_rights_reserved: "Todos los derechos reservados",
    all_transactions: "Todas las transacciones",
    already_member: "¿Ya eres usuario?",
    amount: "Cantidad",
    approx_value: "Valor aproximado",
    equivalent_in: "Equivalente en",
    one_blu_equals: "1 BLUE iguala",
    equivalence: "Equivalencia",
    one_blu: "1 BLUE",
    updated_last: "Última actualización",
    all_time: "Tiempo total",
    activate: "Activar",
    available_info: "Disponible para redención",
    available_to_redeem: "Debido a la gran demanda de redenciones, y la cantidad actual de fondos bloqueados en exchanges, esta redención superará nuestro umbral de liquidez de redención factible para esta semana. Intente con un monto más bajo, o intente su redención nuevamente la próxima semana.",
    available: "Disponible",
    attention_done: "Atención: su pedido se ha realizado",
    attention_cancel: "Atención: su pedido ha sido cancelado. Si desea comprar BLUE, abra un nuevo pedido",
    attention_waiting_hours: "Atención: ¡Su orden de compra vencerá en {horas}! Pasado este tiempo, su pedido se cancelará automáticamente.",
    attention_waiting_days: "Atención: Su pedido tiene {hours} hasta el vencimiento."
  }, _defineProperty(_msg, "attention_waiting_hours", "Atención: Su pedido tiene {hours} hasta el vencimiento."), _defineProperty(_msg, "attention", "Atención"), _defineProperty(_msg, "available_balance", "Saldo disponible: "), _defineProperty(_msg, "allocation", "Asignación"), _defineProperty(_msg, "authenticate", "Autenticar"), _defineProperty(_msg, "address_empty", "La dirección está vacía"), _defineProperty(_msg, "average_time", "Depósitos pueden tardar hasta 5 minutos."), _defineProperty(_msg, "balance", "Balance | Balances"), _defineProperty(_msg, "begins", "Comienza"), _defineProperty(_msg, "bonus", "Bonus"), _defineProperty(_msg, "buy", "Comprar"), _defineProperty(_msg, "buy_tokens", "Comprar BLUE"), _defineProperty(_msg, "buyer_bonus", "Bonus de compra"), _defineProperty(_msg, "blank", ""), _defineProperty(_msg, "bonus_0dot5", "Bonus(0.5%)"), _defineProperty(_msg, "bonus_1", "Bonus(1%)"), _defineProperty(_msg, "bonus", "Bonus"), _defineProperty(_msg, "buy_here", "Compre Aquí"), _defineProperty(_msg, "buy_now", "Compre Ahora"), _defineProperty(_msg, "bktc", "BKTC"), _defineProperty(_msg, "back", "Previo"), _defineProperty(_msg, "balance_equivalence", "Balance equivalente en"), _defineProperty(_msg, "blue_team", "Equipo BLUE"), _defineProperty(_msg, "buy_pix", "Comprar BLUE via PIX"), _defineProperty(_msg, "buy_pix_info", "Utilizando SWAPiX, un socio de confianza que ofrece intercambios de fiat a cripto."), _defineProperty(_msg, "blue_club_status", "Blue Club status"), _defineProperty(_msg, "balance_text_tusd", "TrueUSD Stablecoin al par con el Dólar Americano"), _defineProperty(_msg, "balance_text_btc", "Bitcoin"), _defineProperty(_msg, "balance_text_rlt", "RAS Stablecoin al par con el Real Brasileño"), _defineProperty(_msg, "balance_text_eth", "Ethereum"), _defineProperty(_msg, "buy_token", "COMPRAR TOKEN"), _defineProperty(_msg, "boleto", "Boleto"), _defineProperty(_msg, "best_way_buy", "Mejor manera de comprar"), _defineProperty(_msg, "browser_message", "Si no puede ver el document, por favor use Firefox o Safari."), _defineProperty(_msg, "business_day", "DÍAS HÁBILES"), _defineProperty(_msg, "no_additional_fee", "Sin cargos adicionales."), _defineProperty(_msg, "rush_today", "RUSH (hoy)"), _defineProperty(_msg, "receive_today_info", "Recibirás en el mismo día natural."), _defineProperty(_msg, "basket_value", "Valor de la cesta"), _defineProperty(_msg, "charity", "Caridad"), _defineProperty(_msg, "clear_filter", "Limpiar filtro"), _defineProperty(_msg, "cancelled", "Cancelado"), _defineProperty(_msg, "cancel_purchase", "Cancelar Compra"), _defineProperty(_msg, "click_on_transaction_to_get_details", "Haga clic en una transacci\xF3n para m\xE1s detalles."), _defineProperty(_msg, "chart", "Gráfico"), _defineProperty(_msg, "crypto", "Cripto"), _defineProperty(_msg, "copy_twofa", "Escanee el código QR con su teléfono celular usando Google Authenticator o Authy, o escriba el código. <strong> Mantenga este código en un lugar seguro en caso de que pierda su teléfono, y no lo comparta con nadie. Puede recuperar su 2FA usando este código.</strong>"), _defineProperty(_msg, "confirm_delet", "¿Estás seguro?"), _defineProperty(_msg, "click_here", "Acceder SmartWallet"), _defineProperty(_msg, "confirm_redeem", "Su redención está siendo procesado."), _defineProperty(_msg, "confirm_withdraw", "Su retiro está siendo procesado."), _defineProperty(_msg, "amount_revice_withdraw", "Cantidad a recibir"), _defineProperty(_msg, "amount_revice_withdraw_fee", "Tarifa: "), _defineProperty(_msg, "can_not_load_data", "No se pueden cargar datos."), _defineProperty(_msg, "change", "Cambiar"), _defineProperty(_msg, "coin_slider_BTC", "Bitcoin"), _defineProperty(_msg, "coin_slider_RAS", "Ras - Stablecoin al par con el Real Brasileño"), _defineProperty(_msg, "coin_slider_BLU", "TrueUSD - Stablecoin al par con el Dólar Americano"), _defineProperty(_msg, "coin_slider_ETH", "Ethereum"), _defineProperty(_msg, "coin_slider_ZAR", "RAND - Moneda de Sudáfrica"), _defineProperty(_msg, "coin_slider_EUR", "Euro - Moneda de la Unión Europea"), _defineProperty(_msg, "coin_slider_GBP", "Libra Esterlina - Moneda del Reino Unido"), _defineProperty(_msg, "coin_slider_CHF", "Franco Suizo - Moneda de Suiza"), _defineProperty(_msg, "coin_slider_CAD", "CA$ - Moneda de Canada"), _defineProperty(_msg, "coin_slider_AUD", "A$ - Moneda de Autralia"), _defineProperty(_msg, "coin_slider_CNY", "Yuan - Moneda China"), _defineProperty(_msg, "coin_slider_HKD", "HK$ - Moneda de Honk Kong"), _defineProperty(_msg, "coin_slider_USDT", "USDT - Stablecoin al par con el Dólar Americano"), _defineProperty(_msg, "cancel", "Cancelar"), _defineProperty(_msg, "contact_us_any_question", "No dude en contactarnos en support@bluetoken.io si tiene alguna pregunta."), _defineProperty(_msg, "cellphone", "Celular"), _defineProperty(_msg, "cpf", "CPF"), _defineProperty(_msg, "cep", "CEP"), _defineProperty(_msg, "complement", "Complemento"), _defineProperty(_msg, "city", "Ciudad"), _defineProperty(_msg, "criptocurrency", "Criptomoneda"), _defineProperty(_msg, "chose_two_coins", "Rentabilidad mostrada acumulada este año, hasta 23 de Diciembre de 2022"), _defineProperty(_msg, "click_here_to_vote", "Haga clic aquí para votar"), _defineProperty(_msg, "copy_address", "Copiar dirección"), _defineProperty(_msg, "create_order", "Criar novo pedido"), _defineProperty(_msg, "cancel_transaction", "Cancelar transacción"), _defineProperty(_msg, "canceling_order", "Pedido cancelado"), _defineProperty(_msg, "canceling", "Cancelado"), _defineProperty(_msg, "checking_open_orders", "Comprobación de pedidos abiertos"), _defineProperty(_msg, "copy_alert_info_otc", "Copiado: cantidad esperada y cantidad estimada"), _defineProperty(_msg, "confirm_recaptcha", "Confirme o CAPTCHA"), _defineProperty(_msg, "create_deposit_address", "Crear dirección de depósito"), _defineProperty(_msg, "check_info_redeem", "He verificado que la información anterior es precisa."), _defineProperty(_msg, "current_value", "Valor Actual"), _defineProperty(_msg, "component_hold", "Componente"), _defineProperty(_msg, "current_weight", "Peso actual"), _defineProperty(_msg, "currently_generating", "Actualmente generando recompensas diarias"), _defineProperty(_msg, "country_residency", "País de residencia"), _defineProperty(_msg, "countries_not_allowed", "USA/China/HK - ¡Países que no pueden usar nuestros servicios!"), _defineProperty(_msg, "clain_your_nft", "Obtenga su NFT"), _defineProperty(_msg, "check_your_email", "Por favor revise su correo electrónico y siga las instrucciones."), _defineProperty(_msg, "check_your_email_for_userid", "Recibirá un correo electrónico con su ID de usuario."), _defineProperty(_msg, "check_your_email_for_recovery_link", "Recibirá un correo electrónico con un enlace de recuperación."), _defineProperty(_msg, "check_your_email_for_pin", "Recibirá un correo electrónico con el PIN para confirmar la transacción"), _defineProperty(_msg, "check_your_email_for_pin_redeem", "Recibirá un correo electrónico con el PIN para confirmar la transacción"), _defineProperty(_msg, "if_no_email_spam", "Si no puede encontrar el correo electr\xF3nico, revise su casilla de spam."), _defineProperty(_msg, "closes", "Cierra"), _defineProperty(_msg, "component", "Componente | Componentes"), _defineProperty(_msg, "confirm", "Confirmar"), _defineProperty(_msg, "confirm_operation", "Confirmar Operación"), _defineProperty(_msg, "confirmation_pin", "Confirmar Su Pin"), _defineProperty(_msg, "confirmation_pin_email_hint", "A continuación, recibirá un correo electrónico con un pin de confirmación, requerido para completar su operación."), _defineProperty(_msg, "contact", "Contacto"), _defineProperty(_msg, "continue", "Continuar"), _defineProperty(_msg, "copied", "Copiar"), _defineProperty(_msg, "copy", "Copiar"), _defineProperty(_msg, "currency", "Moneda"), _defineProperty(_msg, "click_here_action", "haga click aquí"), _defineProperty(_msg, "change_withdraw_partner", "Para cambiar de socio de retiro,"), _defineProperty(_msg, "denied", "Negada"), _defineProperty(_msg, "dashboard", "Panel Principal"), _defineProperty(_msg, "dont_have_btc", "\xBFNo tiene Bitcoin?"), _defineProperty(_msg, "details", "Detalles"), _defineProperty(_msg, "deposits", "Depósitos"), _defineProperty(_msg, "deposit_amount", "Cantidad del Depósito"), _defineProperty(_msg, "dear_blu_holder", "Estimado titular de BLUE"), _defineProperty(_msg, "district", "Distrito"), _defineProperty(_msg, "donwload", "Descargar"), _defineProperty(_msg, "documentation_info", "Hojas de datos, métodos, cálculos y otros documentos"), _defineProperty(_msg, "dropdown_header_withdraw", "Envíe sus tokens a una billetera externa"), _defineProperty(_msg, "dropdown_header_deposit", "Reciba sus tokens de una billetera externa"), _defineProperty(_msg, "dropdown_header_redeem", "Intercambie sus tokens"), _defineProperty(_msg, "dropdown_header_internal", "Envíe BLUE a otro usuario"), _defineProperty(_msg, "destination_user", "Usuario de destino"), _defineProperty(_msg, "deposit_received", "Su depósito ha sido recibido"), _defineProperty(_msg, "do_you_want", "¿Quieres cancelar de todos modos?"), _defineProperty(_msg, "download_pdf", "Descargar PDF"), _defineProperty(_msg, "deposit_sub", "El depósito es una operación que le permite recibir {coin} de una billetera externa."), _defineProperty(_msg, "delivery_speed", "Velocidad de entrega"), _defineProperty(_msg, "download_csv", "Descargar CSV"), _defineProperty(_msg, "date_1", "4 de diciembre de 2018"), _defineProperty(_msg, "date_2", "15 de enero de 2019"), _defineProperty(_msg, "date_3", "16 de enero de 2019"), _defineProperty(_msg, "date_4", "15 de febrero de 2019"), _defineProperty(_msg, "date_5", "16 de febrero de 2019"), _defineProperty(_msg, "date_6", "6 de abril de 2019"), _defineProperty(_msg, "date_7", "11 de abril de 2019"), _defineProperty(_msg, "days_remaining", "Días restantes"), _defineProperty(_msg, "deposit", "Depósito"), _defineProperty(_msg, "disclaimer", "Renuncia"), _defineProperty(_msg, "documentation", "Documentación"), _defineProperty(_msg, "expire_in", "Caducar a las"), _defineProperty(_msg, "expired", "Expirado"), _defineProperty(_msg, "earn_on_referrals", "Gane en referencias"), _defineProperty(_msg, "earn_bonus_tooltip", "Bonificación obtenida del programa de referencia."), _defineProperty(_msg, "email", "Email"), _defineProperty(_msg, "equals", "Igual a"), _defineProperty(_msg, "expired", "Expirado"), _defineProperty(_msg, "export_csv", "Exportar CSV"), _defineProperty(_msg, "ends", "Termina"), _defineProperty(_msg, "explorer", "Explorador"), _defineProperty(_msg, "equivalent", "Equivalente"), _defineProperty(_msg, "equivalent_to", "Equivalente a"), _defineProperty(_msg, "expired_pin", "Pin expirado"), _defineProperty(_msg, "enable_2fa", "Habilitar 2FA"), _defineProperty(_msg, "eth_contract_message", "No envíe Ether mediante un Smart Contract"), _defineProperty(_msg, "clicl_expand", "Clic para ampliar"), _defineProperty(_msg, "expand_chart", "Expandir gráfico"), _defineProperty(_msg, "estimated_info_modal_equivalent", "Valor estimado basado en el intercambio de Tether con otras monedas"), _defineProperty(_msg, "error", "Error"), _defineProperty(_msg, "error_create_address", "Error al crear la dirección, inténtalo más tarde"), _defineProperty(_msg, "error_redeem", "Hubo un error con su solicitud."), _defineProperty(_msg, "error_redeem_amount", "Asegúrese de tener suficiente balance disponible y que la cantidad solicitada esté por encima del mínimo."), _defineProperty(_msg, "error_redeem_amount_no_funds", "No tiene suficientes fondos desbloqueados para realizar esta operación."), _defineProperty(_msg, "error_redeem_amount_below_min", "El monto DEBE estar por encima del mínimo requerido."), _defineProperty(_msg, "error_redeem_address", "Asegúrese de usar una dirección BTC válida."), _defineProperty(_msg, "error_withdraw_address", "Asegúrese de usar una dirección BLUE válida."), _defineProperty(_msg, "error_redeem_confirm", "Se produjo un error, verifique los campos."), _defineProperty(_msg, "error_internal_member_not_found", "ID de usuario no encontrado"), _defineProperty(_msg, "error_pool_avatar", "Avatar ya existe."), _defineProperty(_msg, "error_pool_avatar_select", "Debe elegir un nombre de avatar y un icono."), _defineProperty(_msg, "faq", "Preguntas Frecuentes"), _defineProperty(_msg, "fee", "Tarifa | Tarifas"), _defineProperty(_msg, "fees_minimums", "Tarifas & Mínimos"), _defineProperty(_msg, "forgot_password", "Recuperar contraseña"), _defineProperty(_msg, "forgot_userid", "Recuperar User ID"), _defineProperty(_msg, "fees_minimum_amount", "La tarifa es del 2 USDT del monto, con un mínimo de 2 USDT"), _defineProperty(_msg, "fee_1dot5", "Tarifa 1.5%"), _defineProperty(_msg, "fee_2dot5", "Tarifa 2.5%"), _defineProperty(_msg, "fee_4", "Tarifa 4%"), _defineProperty(_msg, "fee_6", "Tarifa 6%"), _defineProperty(_msg, "failed", "falló"), _defineProperty(_msg, "fund_in_maintenance", "Nuestro sistema se encuentra actualmente en mantenimiento, intente su operación más adelante."), _defineProperty(_msg, "fill_form_boleto", "Rellene el formulario para generar un boleto"), _defineProperty(_msg, "fill_form", "Completa el formulario"), _defineProperty(_msg, "fact_sheet", "Hoja Informativa"), _defineProperty(_msg, "finish_Vote", "Finalizar votación"), _defineProperty(_msg, "form_error_fields", "Todos los campos son obligatorios!"), _defineProperty(_msg, "found_member", "Miembro encontrado"), _defineProperty(_msg, "fee_info_redeem_one", "La tarifa es"), _defineProperty(_msg, "fee_info_redeem_two", "de monto, con un mínimo de"), _defineProperty(_msg, "fee_redeem_wave_info", "La tarifa es de 2 USDT para redenciones por debajo de 50 USDT."), _defineProperty(_msg, "error_xgateway", "Nuestra red actualmente está experimentando problemas con la cripto seleccionada. Vuelva a intentar en unos minutos."), _defineProperty(_msg, "get_pin", "Recibir pin"), _defineProperty(_msg, "global_search", "Búsqueda global"), _defineProperty(_msg, "generate_slips", "Generar Boleto"), _defineProperty(_msg, "g_l", "G/P"), _defineProperty(_msg, "generating_tokens", "Generando tokens, por favor espere"), _defineProperty(_msg, "help", "Soporte"), _defineProperty(_msg, "history", "Historia"), _defineProperty(_msg, "hypothetical_portfolio", "Cesta hipot\xE9tica sujeta a cambios."), _defineProperty(_msg, "home", "Inicio"), _defineProperty(_msg, "here", "aquí"), _defineProperty(_msg, "how_vote", "¿Cómo votar?"), _defineProperty(_msg, "header_referral", "¿Alguien te refirió?"), _defineProperty(_msg, "how_it_works", "<a href=https://youtu.be/NujOX3n7d-g target=_blank>¿Como funciona?</a>"), _defineProperty(_msg, "input_usdt_address", "Ingresar dirección de USDT"), _defineProperty(_msg, "input_blue_amount", "Ingrese la cantidad de BLUE"), _defineProperty(_msg, "input_amount_redeem", "Ingrese la cantidad de BLUE que desea redimir."), _defineProperty(_msg, "input_amount_withdraw", "Ingrese la cantidad de BLUE que desea retirar."), _defineProperty(_msg, "input_amount_transfer", "Ingrese la cantidad de BLUE que desea transferir a otra cuenta"), _defineProperty(_msg, "info_redeem_step_3", "Para su seguridad, ingrese el PIN y 2fa."), _defineProperty(_msg, "info_redeem_address_step_4", "Dirección: "), _defineProperty(_msg, "info_redeem_email_step_4", "Recibirá todos los detalles en su correo electrónico."), _defineProperty(_msg, "info_redeem_step_4", "El proceso se completará hoy."), _defineProperty(_msg, "info_redeem_step_5", "El proceso demorará 3 días hábiles."), _defineProperty(_msg, "info_withdraw_step_4", "Epere hasta que blockchain procese su transacción."), _defineProperty(_msg, "info_2fa_tip", "Como medida de segurança, você deve primeiro habilitar o 2FA para transferir ou resgatar seus tokens."), _defineProperty(_msg, "inform_the_amount_bitcoin_address", "Informar el monto y su dirección Bitcoin"), _defineProperty(_msg, "inform_the_amount_blu_tag", "Informar la cantidad y BLUE Dirección"), _defineProperty(_msg, "inform_the_amount_user_id", "Informar el monto de BLUE y el ID del usuario"), _defineProperty(_msg, "internal_transfer", "Transferencia interna"), _defineProperty(_msg, "internal", "Transferencia interna"), _defineProperty(_msg, "internal_sub", "Transferencia Interna es una operación que le permite enviar BLUE a otro usuario dentro de la plataforma Blue."), _defineProperty(_msg, "internal_steps", "Pasos de transferencia interna"), _defineProperty(_msg, "internal_action_send", "Enviado"), _defineProperty(_msg, "internal_action_receive", "Recibido"), _defineProperty(_msg, "info_usdt_blue_purchase", "Envíe solo USDT a esta dirección. Debe utilizar la red Tron (TRC20)."), _defineProperty(_msg, "input_valid_usdt", "Ingrese una dirección Tether (USDT) TRC20 válida"), _defineProperty(_msg, "send_to_my_usdt", "Enviar a mi billetera Tether"), _defineProperty(_msg, "usdt_info_trc20", "Usamos la red TRC20 de Tron. Asegúrese de ingresar solo una dirección TRC20."), _defineProperty(_msg, "input_text_USDT", "Ingrese la cantidad y la dirección USDT"), _defineProperty(_msg, "input_text_invalid_USDT", "Ingrese la cantidad de USDT que desea retirar."), _defineProperty(_msg, "insert_bitcoin_address", "Ingresar dirección de Bitcoin"), _defineProperty(_msg, "insert_quantity", "Ingresar cantidad"), _defineProperty(_msg, "insert_your_pin", "Ingresar pin"), _defineProperty(_msg, "invalid_address", "Dirección inválida"), _defineProperty(_msg, "invalid_amount", "Monto invalido"), _defineProperty(_msg, "invalid_credentials", "Credenciales inválidas."), _defineProperty(_msg, "invalid_destination_address", "Dirección inválida"), _defineProperty(_msg, "invalid_phone", "Teléfono inválido"), _defineProperty(_msg, "invalid_phone_country", "País no permitido para usar nuestros servicios."), _defineProperty(_msg, "invalid_email", "Email inválido."), _defineProperty(_msg, "invalid_has_accepted_terms", "Por favor, acepte los Términos y Condiciones."), _defineProperty(_msg, "invalid_is_aware_token_redemption", "Por favor marque la casilla de verificación de arriba."), _defineProperty(_msg, "invalid_input_amount_crypto", "Monto invalido"), _defineProperty(_msg, "invalid_is_not_usa_citizen", "Confirme que no es ciudadano o residente de los Estados Unidos."), _defineProperty(_msg, "invalid_is_not_china_citizen", "Confirme que no es ciudadano o residente de Hong Kong."), _defineProperty(_msg, "invalid_password", "Contraseña inválida"), _defineProperty(_msg, "invalid_password_confirmation", "Confirmación de contraseña inválida."), _defineProperty(_msg, "invalid_password_old", "Contraseña actual inválida."), _defineProperty(_msg, "invalid_pin", "PIN inválido"), _defineProperty(_msg, "invalid_referral_code", "Código de referencia inválido."), _defineProperty(_msg, "invalid_userid", "Identifición de usuario inválida."), _defineProperty(_msg, "invalid_user_id", "Identifición de usuario inválida."), _defineProperty(_msg, "invalid_connetion", "Hubo un problema al autenticar su solicitud, verifique su conexión o su usuario."), _defineProperty(_msg, "invalid_2fa_code", "Código 2fa incorrecto."), _defineProperty(_msg, "insert_referral_code", "Insertar código de referencia (Opcional)"), _defineProperty(_msg, "Invalidaddress", "Esta dirección no es aceptada."), _defineProperty(_msg, "language", "Idioma | Idiomas"), _defineProperty(_msg, "launch", "Lanzamiento"), _defineProperty(_msg, "launch_april", "Lanzamiento - ABRIL 2019"), _defineProperty(_msg, "legal", "Legal"), _defineProperty(_msg, "list", "Lista"), _defineProperty(_msg, "last_update", "Última Actualización"), _defineProperty(_msg, "link_no_account", "Si a\xFAn no tiene una cuenta Stratum, <a href=\"https://auth.stratum.hk/signup.php?lang=en\" target=\"_blank\"> haga clic aqu\xED </a> para crear uno."), _defineProperty(_msg, "loading_balance", "Cargando el saldo de la cuenta..."), _defineProperty(_msg, "live_price", "Precio en vivo"), _defineProperty(_msg, "last_month_blue_total", "Blue Pool pagó un total de"), _defineProperty(_msg, "en", "EN | English"), _defineProperty(_msg, "es", "ES | Spanish"), _defineProperty(_msg, "pt", "PT | Portuguese"), _defineProperty(_msg, "loading", "Cargando"), _defineProperty(_msg, "loading_data", "Cargando Datos de Compra"), _defineProperty(_msg, "load_fee", "Tarifa de Venta"), _defineProperty(_msg, "login", "Ingresar"), _defineProperty(_msg, "login_successful", "Sesión iniciada con éxito"), _defineProperty(_msg, "login_here", "Ingresar Aquí"), _defineProperty(_msg, "logout", "Salir"), _defineProperty(_msg, "latest", "Último"), _defineProperty(_msg, "minimum", "Mínimo"), _defineProperty(_msg, "money", "dinero"), _defineProperty(_msg, "masternodes", "masternodes"), _defineProperty(_msg, "make_new_redeem", "Hacer una nueva redención"), _defineProperty(_msg, "methodology", "Metodología"), _defineProperty(_msg, "min_amount_is", "El monto m\xEDnimo es"), _defineProperty(_msg, "member_not_found", "Miembro no encontrado."), _defineProperty(_msg, "make_sure_address", "Asegúrese de utilizar una dirección BLUE válida."), _defineProperty(_msg, "my_balances", "Mis saldos"), _defineProperty(_msg, "my_balance", "Mis saldos"), _defineProperty(_msg, "my_total_value", "Mi saldo total"), _defineProperty(_msg, "my_gain_loss", "Mi Ganancia/Pérdida"), _defineProperty(_msg, "minimum_purchase_USDT", "El saldo mínimo requerido es de 20 USDT. Por favor aumente su saldo."), _defineProperty(_msg, "minting", "Creando"), _defineProperty(_msg, "member_benefits", "Beneficios de la Membresía"), _defineProperty(_msg, "my", "Mi"), _defineProperty(_msg, "name", "Nombre"), _defineProperty(_msg, "name_optional", "Nombre (Opcional)"), _defineProperty(_msg, "next", "Próximo | Prox"), _defineProperty(_msg, "no_data_found", "Datos no encontrados"), _defineProperty(_msg, "no_rec_transactions_found", "No se encontraron transacciones."), _defineProperty(_msg, "not_enough_balance", "No hay suficiente balance"), _defineProperty(_msg, "not_member_yet", "¿No eres miembro todavía?"), _defineProperty(_msg, "next_step", "Próximo paso"), _defineProperty(_msg, "number", "Número"), _defineProperty(_msg, "network", "La red"), _defineProperty(_msg, "notification", "Notificación"), _defineProperty(_msg, "only_one_day", "Solo se permite 1 redención por día."), _defineProperty(_msg, "of", "de"), _defineProperty(_msg, "opens", "Abre"), _defineProperty(_msg, "open_account", "Abrir Cuenta"), _defineProperty(_msg, "operations", "Operaciones"), _defineProperty(_msg, "Operations", "Operaciones"), _defineProperty(_msg, "or", "o"), _defineProperty(_msg, "one_token_equivalence", "Un BLUE equivalente en"), _defineProperty(_msg, "optional", "Opcional"), _defineProperty(_msg, "otc_info", "Proporcione la siguiente información. Nuestro mostrador OTC se pondrá en contacto para ayudarlo con su compra."), _defineProperty(_msg, "otc_thank_msg", "Nuestro mostrador de OTC se comunicará con usted a la brevedad."), _defineProperty(_msg, "otc_purcahse_info", "Información de compra"), _defineProperty(_msg, "otc_purcahse", "compra OTC"), _defineProperty(_msg, "otc_purchase_info_to_user", "Nuestra mesa OTC está procesando su compra, por favor espere."), _defineProperty(_msg, "past_2fa", "Ingrese aquí el código 2FA con 6 dígitos"), _defineProperty(_msg, "pin_already_been_used", "Pin ya fue usado"), _defineProperty(_msg, "price_graph", "Gráfico de Precios"), _defineProperty(_msg, "portfolio_value", "Valor de Cripto-cesta"), _defineProperty(_msg, "pay_slip_info", "Pagar el boleto para recibir sus BLUE"), _defineProperty(_msg, "purchase_information", "Informacion de compra"), _defineProperty(_msg, "please_chose_two_coins", "Elija 2 criptomonedas."), _defineProperty(_msg, "phone_optional", "Celular"), _defineProperty(_msg, "phone_code", "Código de país"), _defineProperty(_msg, "phone", "Fone"), _defineProperty(_msg, "purchase_success", "Su compra ha sido creada para el usuario."), _defineProperty(_msg, "price_history_list", "Historial de precios"), _defineProperty(_msg, "please_verify_information", "Por favor verifique la siguiente información en forma precisa."), _defineProperty(_msg, "closing_price", "Precio de cierre"), _defineProperty(_msg, "pay_with_USDT", "Pagar con saldo USDT"), _defineProperty(_msg, "change_password", "Cambiar contraseña"), _defineProperty(_msg, "current_password", "Contraseña actual"), _defineProperty(_msg, "confirm_password", "Confirmar contraseña"), _defineProperty(_msg, "new_password", "Nueva contraseña"), _defineProperty(_msg, "password", "Contraseña"), _defineProperty(_msg, "password_create", "Crear nueva contraseña"), _defineProperty(_msg, "password_changed", "Contraseña ha sido cambiada"), _defineProperty(_msg, "password_requirements", "Contraseña debe contener al menos 8 caracteres, 1 carácter especial (-_+=,<.>;:^~@#$%&*), 1 letra minúscula, 1 letra mayúscula y 1 número."), _defineProperty(_msg, "recover_password", "Recuperar Contraseña"), _defineProperty(_msg, "recover_userid", "Recuperar ID de Usuario"), _defineProperty(_msg, "password_suggestion", "Use la contraseña sugerida de Blue."), _defineProperty(_msg, "confirm_password_error", "Confirme su cambio de contraseña."), _defineProperty(_msg, "wrong_password_confirmation", "Confirmación de contraseña incorrecta"), _defineProperty(_msg, "phone_already_registered", "Este teléfono ya está registrado."), _defineProperty(_msg, "email_already_registered", "Este correo electrónico ya está registrado."), _defineProperty(_msg, "pay_with", "Pagar con cripto"), _defineProperty(_msg, "perc_portfolio", "% of Asignación de cripto-cesta"), _defineProperty(_msg, "phase", "Fase | Fases"), _defineProperty(_msg, "portfolio", "Cripto-cesta"), _defineProperty(_msg, "price", "Precio"), _defineProperty(_msg, "pre_sale", "Pre-Venta"), _defineProperty(_msg, "preferences", "Preferencias"), _defineProperty(_msg, "preferred_language", "Idioma preferido"), _defineProperty(_msg, "previous", "Previos | Prev"), _defineProperty(_msg, "privacy_policy", "Política de Privacidad"), _defineProperty(_msg, "purchase", "Compra"), _defineProperty(_msg, "performance", "Evolución de Precio"), _defineProperty(_msg, "quantity", "Cantidad"), _defineProperty(_msg, "receive_calculator_text", "El c\xE1lculo excluye cualquier tarifa impuesta por su propia cartera y la red. Recomendamos depositar un poco m\xE1s de la cantidad deseada."), _defineProperty(_msg, "receive", "Recibir"), _defineProperty(_msg, "receiving_email", "Recibiendo email"), _defineProperty(_msg, "recent_transactions", "Transacciones recientes"), _defineProperty(_msg, "redeem", "Redimir"), _defineProperty(_msg, "referral_award", "Recompensa de Referencias"), _defineProperty(_msg, "referrals", "Referencias"), _defineProperty(_msg, "referral_code", "Código de referencia"), _defineProperty(_msg, "report", "Informe trimestral"), _defineProperty(_msg, "report_link_text", "Lanzamiento"), _defineProperty(_msg, "report_link_download_quarter", "Descargue el informe trimestral Octubre - Diciembre 2022 (T4 2022)"), _defineProperty(_msg, "report_link_span", "Los informes se publican la primera semana de cada trimestre."), _defineProperty(_msg, "redemptions", "Redenciones"), _defineProperty(_msg, "redemption", "Redención"), _defineProperty(_msg, "redemption_info", "<strong>Redenciones sin cargo:</strong> Usted califica para redimir hasta <strong>50 BLUS</strong> sin tarifa. La cantidad debe valer más de <strong>1000 TUSD</strong>."), _defineProperty(_msg, "redeem_pin", "Ingresar PIN"), _defineProperty(_msg, "redeem_2fa", "Ingresar 2FA"), _defineProperty(_msg, "redeem_not_allowed_today", "Redenciones están disponibles Miércoles, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_1", "Redenciones no están disponibles hoy. Consulte el programa de redención."), _defineProperty(_msg, "redeem_not_allowed_today_2", "Redenciones están disponibles Martes, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_3", "Redenciones están disponibles Miércoles, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_4", "Redenciones están disponibles Jueves, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_5", "Redenciones están disponibles Viernes, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_6", "Redenciones están disponibles Sábado, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_7", "Redenciones están disponibles Domingo, de 00h a 17h (UTC -3)."), _defineProperty(_msg, "redeem_deleted_success", "Redención cancelada con éxito!"), _defineProperty(_msg, "redeem_deleted_error", "Algo salió mal, intente nuevamente más tarde."), _defineProperty(_msg, "reedeem_2fa_text", "\n            <p>\xBFQu\xE9 es 2FA y por qu\xE9 deber\xEDa usarlo?</p>\n            <p>2FA significa Autenticaci\xF3n de 2 factores. Protege su cuenta combinando algo que sabe (su contrase\xF1a) con algo que tiene (como su tel\xE9fono celular o clave de seguridad).</p>\n            <p>Despu\xE9s de configurar 2FA en su tel\xE9fono, ver\xE1 un c\xF3digo de acceso que cambia constantemente. Debe usar el c\xF3digo de acceso 2FA cada vez que redime tokens; sin embargo, solo tiene que instalar 2FA una vez.</p>\n            <p>En caso de que a\xFAn no tenga un autenticador, utilice uno de los siguientes:</p>\n            <a href=\"https://www.google.com/landing/2step/#tab=how-it-works\" target=\"_blank\">Autenticador Google</a>\n            <a href=\" https://authy.com/download/\" target=\"_blank\">Autenticador Authy</a>\n        "), _defineProperty(_msg, "tutorial_tittle", "<p style=\"color:#424b7d\">\xBFC\xF3mo depositar {coin}?</p>"), _defineProperty(_msg, "tutorial_deposit", "\n        <p>1. Crear una direcci\xF3n de dep\xF3sito de BLUE;</p>\n        <p>2. Busque el formulario \"Enviar\" en la cartera externa;</p>\n        <p>3. Escanee o copie la direcci\xF3n del token BLUE en aquel formulario.</p><br/>\n        <b>Nota:</b>\n        <span>A los dep\xF3sitos BLUE se les cobra una tarifa de red del 6%, pagada por el remitente. <a href=\"https://bluetoken.io/fees\" target=\"_blank\" style=\"margin-top:0px; display: contents;\">Tarifa.</a></span>\n    "), _defineProperty(_msg, "tutorial_deposit_usdt", "\n    <p>1. Crear una direcci\xF3n de dep\xF3sito de Tether (USDT);</p>\n    <p>2. Busque el formulario \"Enviar\" en la cartera externa;</p>\n    <p>3. Escanee o copie la direcci\xF3n del Tether (USDT) en aquel formulario.</p><br/>\n    <b>Nota:</b>\n    <span>Aseg\xFArese de seleccionar la red Tron (TRC20).</span>\n"), _defineProperty(_msg, "tutorial_tittle_withdraw", "<p style=\"color:#424b7d\">C\xF3mo agregar el Blue Token en carteras externas?</p>"), _defineProperty(_msg, "tutorial_withdraw", "\n        <p>1. Seleccione Binance Smart Chain (BSC) en la red de cartera externa;</p>\n        <p>2. Copie esta direcci\xF3n de contrato de token Blue e imp\xF3rtela en la cartera externa;</p>\n    "), _defineProperty(_msg, "tutorial_withdraw_pt2", "\n        <b>Note:</b>\n        <p>- Blue Token no asume responsabilidad por las operaciones que ocurren en plataformas de terceros.</p>\n        <p>- Todas las transacciones que se originan fuera de nuestra plataforma tienen un cargo de red del 6%. <a href=\"https://bluetoken.io/fees\" target=\"_blank\" style=\"margin-top:0px; display: contents;\">Tarifa.</a></p>\n    "), _defineProperty(_msg, "cancel_redeem", "Cancelar Redenci\xF3n"), _defineProperty(_msg, "retry", "Re-procesar"), _defineProperty(_msg, "required_fields", "Campos requeridos"), _defineProperty(_msg, "recipients_user_id", "ID de usuario del destinatario."), _defineProperty(_msg, "required_fields_amount_uid", "La cantidad y el UID son necesarios para esta acción."), _defineProperty(_msg, "redeeming", "Redimiendo"), _defineProperty(_msg, "receiving", "Recepción"), _defineProperty(_msg, "referral", "Referencia"), _defineProperty(_msg, "referral_text_1", "Cuando refieres a personas para comprar BLUE, obtienes una recompensa y ellos obtienen un bono, ¡pagado en BLUE!"), _defineProperty(_msg, "referral_text_2", "Entregue el enlace o código de referencia a sus amigos y familiares. Las recompensas y bonificaciones son ilimitadas. No importa cuántas veces sus referidos compren BLUE, obtendrá una recompensa y ellos recibirán una bonificación."), _defineProperty(_msg, "referral_text_3", "Para activar su código de referencia, primero debe comprar BLUE. Una vez que compre BLUE, vuelva a esta página y comience a usar su código de referencia."), _defineProperty(_msg, "review_your_purchase", "Revisar Su Compra"), _defineProperty(_msg, "reward", "Reconpensa"), _defineProperty(_msg, "rows_per_page", "Filas por Página"), _defineProperty(_msg, "redeemed_value", "Monto Redimido"), _defineProperty(_msg, "staking_rewards", "Staking rewards"), _defineProperty(_msg, "save", "Guardar"), _defineProperty(_msg, "send", "Enviar"), _defineProperty(_msg, "settings", "Configuraciones"), _defineProperty(_msg, "header_settings", "Configuraciones"), _defineProperty(_msg, "signup", "Registrarse"), _defineProperty(_msg, "something_went_wrong", "Algo salió mal"), _defineProperty(_msg, "subtotal", "Subtotal"), _defineProperty(_msg, "send_to_btc_adress", "Dirección de Destino"), _defineProperty(_msg, "send_to_blu_adress", "Dirección de Destino <strong>BLUE</strong>"), _defineProperty(_msg, "send_to_blu_adress_on", "Dirección de Destino <strong>BLUE</strong> en"), _defineProperty(_msg, "step_1_withdraw_blue", "1. Seleccione su billetera preferida para retirar."), _defineProperty(_msg, "allowed_wallets", "*Carteras permitidas:"), _defineProperty(_msg, "step_2_withdraw_blue", "2. Haga clic para copiar la dirección del contrato de Blue Token en Binance Smart Chain:"), _defineProperty(_msg, "step_3_withdraw_blue", '3. Haga clic para importar automáticamente el token de Blue en <a href="https://bit.ly/3wMClbk" target="_blank">Metamask</a>'), _defineProperty(_msg, "step_3_withdraw_blue_p2", "siga las instrucciones para agregar manualmente el token de Blue en:"), _defineProperty(_msg, "or", "o"), _defineProperty(_msg, "contract_address", "0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2"), _defineProperty(_msg, "success", "Éxito"), _defineProperty(_msg, "success_create_wallet", "Dirección creada con éxito"), _defineProperty(_msg, "session_expired", "Sesión expirada. Por favor inicie sesión nuevamente."), _defineProperty(_msg, "services", "Servicios"), _defineProperty(_msg, "staking_APY", "Apuesta APY"), _defineProperty(_msg, "submit", "Enviar"), _defineProperty(_msg, "months", {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  }), _defineProperty(_msg, "pool", "Pool"), _defineProperty(_msg, "join_pool", "Registrese y gane"), _defineProperty(_msg, "monthly_rewards", "Recompensas del pool de {month}"), _defineProperty(_msg, "my_rewards", "Estimación de mis recompensas"), _defineProperty(_msg, "qualification_status", "Estado de calificación"), _defineProperty(_msg, "need_to_qualify", "Necesita de"), _defineProperty(_msg, "to_qualify", "para calificar"), _defineProperty(_msg, "calculating", "calculando..."), _defineProperty(_msg, "posted_soon", "El Pool está siendo calculado y se publicará pronto."), _defineProperty(_msg, "nobody_qualified", "Nadie ha calificado aún para ganar las recompensas del pool. ¡Sea el primero y gane!"), _defineProperty(_msg, "leaderboard", "Tabla de líderes"), _defineProperty(_msg, "last_month_winners", "Ganadores del mes pasado"), _defineProperty(_msg, "referral_volume", "Volumen de referencias"), _defineProperty(_msg, "reward_pool", "% de Recompensa"), _defineProperty(_msg, "estimated_pool", "Estimado"), _defineProperty(_msg, "earned_pool", "Ganado"), _defineProperty(_msg, "view_all", "verlo todo"), _defineProperty(_msg, "modal_pool_title", "Recompensas del Blue Pool"), _defineProperty(_msg, "modal_pool_text", "Cada mes se crea un grupo para recompensarlo por las compras de sus referidos. Los participantes que acumulan 1 token BLUE o más en compras por referencias, ganan automáticamente una parte del pool. <a href=https://youtu.be/NujOX3n7d-g target=_blank>Ver tutorial</a>"), _defineProperty(_msg, "modal_pool_important", "Importante"), _defineProperty(_msg, "modal_pool_text2", "Para participar, primero debe crear un avatar."), _defineProperty(_msg, "modal_pool_text3", "Su avatar no se puede cambiar en el futuro."), _defineProperty(_msg, "modal_pool_nick", "Crear un apodo"), _defineProperty(_msg, "modal_pool_nick_span", "Para proteger su privacidad. Le aconsejamos que no utilice su nombre real."), _defineProperty(_msg, "modal_pool_avatar", "Seleccione Avatar"), _defineProperty(_msg, "modal_pool_btn", "PARTICIPAR"), _defineProperty(_msg, "modal_pool_welcome", "Bienvenido(a) a Blue Pool"), _defineProperty(_msg, "modal_pool_span", "Cuando sus referencias acumulen 1 BLUE en las compras, su avatar se mostrará en el tabla de líderes, asegurando una participación en el pool."), _defineProperty(_msg, "modal_pool_span2", "¡Cuanto más compren, mayor será su participación!"), _defineProperty(_msg, "modal_pool_referral", "Su ID de referencia:"), _defineProperty(_msg, "modal_pool_referral_link", "Su enlace de referencia"), _defineProperty(_msg, "modal_pool_close", "CERRAR"), _defineProperty(_msg, "street_name", "Calle"), _defineProperty(_msg, "state", "Estado"), _defineProperty(_msg, "select_partner", "Seleccione un socio"), _defineProperty(_msg, "start_withdrawal", "Iniciar retiro"), _defineProperty(_msg, "start_internal_transfer", "Iniciar transferencia interna"), _defineProperty(_msg, "send_exactly", "Enviar exactamente a la siguiente dirección:"), _defineProperty(_msg, "seller_buy", "Compre como el miembro que desee, solo debe proporcionar el UID y la cantidad."), _defineProperty(_msg, "sector", "Sector"), _defineProperty(_msg, "step_amount", "Monto"), _defineProperty(_msg, "step_recipient", "Destinatario"), _defineProperty(_msg, "step_verification", "Verificación"), _defineProperty(_msg, "step_authentication", "Autenticación"), _defineProperty(_msg, "status_new", "Nuevo"), _defineProperty(_msg, "status_waiting", "Esperando"), _defineProperty(_msg, "status_processing", "Procesando"), _defineProperty(_msg, "status_done", "Completo"), _defineProperty(_msg, "status_failed", "Fallado"), _defineProperty(_msg, "status_cancelled", "Cancelado"), _defineProperty(_msg, "status_denied", "Negado"), _defineProperty(_msg, "status_expired", "Expirado"), _defineProperty(_msg, "status_queued", "En línea"), _defineProperty(_msg, "skip", "passar"), _defineProperty(_msg, "tag", "tag"), _defineProperty(_msg, "tag_important", "Asegúrese de establecer el tag ID correcto para que el monto se envíe a su dirección."), _defineProperty(_msg, "terms_and_conditions", "Términos y condiciones"), _defineProperty(_msg, "tokens_go_on_sale", "BLUE salen a la venta"), _defineProperty(_msg, "token_presale", "Pre-venta"), _defineProperty(_msg, "token_distribution", "Distribución"), _defineProperty(_msg, "total", "Total"), _defineProperty(_msg, "total_debit", "Débito Total"), _defineProperty(_msg, "total_received", "Total Receibido"), _defineProperty(_msg, "total_to_pay", "Total a pagar"), _defineProperty(_msg, "total_to_transfer", "Total a enviar"), _defineProperty(_msg, "transaction", "Transacción | Transacciones"), _defineProperty(_msg, "transaction_completed", "Transacción Completa"), _defineProperty(_msg, "transaction_details", "Detalles de la Transacción"), _defineProperty(_msg, "type", "Tipo"), _defineProperty(_msg, "token", "Token"), _defineProperty(_msg, "token_info", "Info"), _defineProperty(_msg, "token_supply", "Suministro"), _defineProperty(_msg, "token_nav", "NAV"), _defineProperty(_msg, "fund_value", "Valor del Fundo"), _defineProperty(_msg, "token_price", "Precio"), _defineProperty(_msg, "transaction_with_wrong_status", "Transacción con status incorrecto"), _defineProperty(_msg, "trade_not_found", "Redención no encontrada. Empezar de nuevo."), _defineProperty(_msg, "transfers", "Transferencias"), _defineProperty(_msg, "total_redeem", "Total en BLUE"), _defineProperty(_msg, "total_redeem_USDT", "Total en USDT"), _defineProperty(_msg, "total_plus_block", "Disponíble + bloqueado"), _defineProperty(_msg, "token_supply_equivalence", "Suministro de tokens equivalente en"), _defineProperty(_msg, "transaction_failed_step", "la transacción falló en el paso {step}, si tiene alguna pregunta, comuníquese con el soporte al support@bluetoken.io"), _defineProperty(_msg, "transfer_blu_stx", "Envíe sus BLUE tokens a <span class='custom_highlight'>StratumX.io</span>. Use para hacer trading com otras criptos."), _defineProperty(_msg, "transfer_blu_stratum", "Envíe sus BLUE tokens a SmartWallet. Use para vender BLUE, pagar cuentas, y otros servicios."), _defineProperty(_msg, "transfer_blu_stratum_withdraw_sw", "Envíe sus tokens BLUE a Stratum Advanced Wallet y disfrute de muchos beneficios."), _defineProperty(_msg, "tag_text", "El TAG es un identificador único para reconocerlo y puesto a disposición por el socio de retiro. El TAG se encuentra en la página de depósito de la cartera del socio."), _defineProperty(_msg, "table_failed_1", "* Pedidos incompletos"), _defineProperty(_msg, "table_failed_2", "* Todos los pedidos incompletos se cancelarán automáticamente."), _defineProperty(_msg, "thank_you", "Gracias"), _defineProperty(_msg, "temporarily_unavailable", "Temporariamente indisponible."), _defineProperty(_msg, "tether_info", "Envíe a través de la red Tron (TRC20) o use su saldo disponible."), _defineProperty(_msg, "token_type", "Tipo de token"), _defineProperty(_msg, "today", "Hoy"), _defineProperty(_msg, "bep20", "BEP20 (Binance Smart Chain)"), _defineProperty(_msg, "decentralized_ex", "Decentralized Exchanges (DEX)"), _defineProperty(_msg, "metaverse", "Metaverso"), _defineProperty(_msg, "lending", "Préstamos"), _defineProperty(_msg, "payments", "Pagos"), _defineProperty(_msg, "native", "Nativo"), _defineProperty(_msg, "erc20", "ERC20 (Ethereum)"), _defineProperty(_msg, "todays_market", "Mercado de hoy"), _defineProperty(_msg, "token_supply", "Suministro de tokens"), _defineProperty(_msg, "tks_your_payment", "Gracias por su pago."), _defineProperty(_msg, "wait_create_tokens", "Espere unos minutos mientras creamos su(s) token(s)."), _defineProperty(_msg, "BLU", "BLUE"), _defineProperty(_msg, "BTC", "Bitcoin"), _defineProperty(_msg, "ETH", "Ethereum"), _defineProperty(_msg, "TUSD", "TrueUSD"), _defineProperty(_msg, "createdAt", "Creada en"), _defineProperty(_msg, "updatedAt", "Actualizada en"), _defineProperty(_msg, "status", "Status"), _defineProperty(_msg, "done", "Completo"), _defineProperty(_msg, "pre_done", "Completo"), _defineProperty(_msg, "failed", "Fallado"), _defineProperty(_msg, "new", "Nuevo"), _defineProperty(_msg, "processing", "Processando"), _defineProperty(_msg, "txid", "TX ID"), _defineProperty(_msg, "start_date", "Fecha de Inicio"), _defineProperty(_msg, "end_date", "Fecha Final"), _defineProperty(_msg, "use_all", "Usar todo"), _defineProperty(_msg, "userid", "ID de Usuario"), _defineProperty(_msg, "user", "Usuario"), _defineProperty(_msg, "use", "Usar"), _defineProperty(_msg, "user_id_inportant", "Asegúrese de ingresar el ID de usuario correcto para asegurarse de que la cantidad se envíe a la cuenta deseada"), _defineProperty(_msg, "value", "Valor"), _defineProperty(_msg, "view_all_transactions", "Ver todas las transacciones"), _defineProperty(_msg, "view_reward_bonus_schedule", "Ver programa de recompensas y bonificaciones"), _defineProperty(_msg, "view_status", "Ver status"), _defineProperty(_msg, "voting_info_1", "Es hora de votar por 2 criptomonedas para agregar (o mantener) como parte de BLUE para el primer trimestre (T1) del 2023."), _defineProperty(_msg, "voting_info_2", "Últimamente, los reguladores del gobierno están detrás de empresas de criptomonedas que ofrecen beneficios en arbitraje y actividades similares. El cumplimiento de los reguladores daría lugar a comprometer la privacidad de nuestros usuarios. Como saben, aquí en Stratum, nuestra privacidad y seguridad del usuario siempre ha sido nuestra principal prioridad. Entonces decidimos eliminar esas actividades y basar BLUE en el valor de 14 criptomonedas en lugar de 12."), _defineProperty(_msg, "voting_info_3", "Simplemente haga clic en el botón de abajo y seleccione 2 criptomonedas. La votación no es obligatoria, pero recomendada. Creemos que cualquiera de las opciones dadas será una adición prometedora a la cesta BLUE. Contaremos los votos de acuerdo con el número de BLUE en su cuenta (cada BLUE completo en su cuenta le da 1 voto). La votación estará disponible hasta el 30 de Diciembre 23:59h (UTC -3)."), _defineProperty(_msg, "voting_info_4", "Agregaremos más detalles sobre este cambio en un papel blanco actualizado en nuestro sitio web, como la frecuencia de votación y su futura implementación usando blockchain."), _defineProperty(_msg, "vote_bellow", "Vote abajo"), _defineProperty(_msg, "vote_success", "Votó con éxito, gracias!"), _defineProperty(_msg, "voting_survey", "Encuesta de votación"), _defineProperty(_msg, "verify_step", "Verifique su redención"), _defineProperty(_msg, "view_other_currencies", "Ver otras monedas"), _defineProperty(_msg, "verify_your_withdraw", "Verifique su retiro"), _defineProperty(_msg, "waiting", "Procesando"), _defineProperty(_msg, "welcome", "Bienvenido(a)"), _defineProperty(_msg, "with", "con"), _defineProperty(_msg, "withdraw", "Retiro"), _defineProperty(_msg, "withdraws", "Retiros"), _defineProperty(_msg, "withdraw_amount", "Monto de Retiro"), _defineProperty(_msg, "withdraw_transfer", "Retirar"), _defineProperty(_msg, "was_referred", "Pídale a su amigo su código de referencia para ganar recompensas, o déjelo en blanco para donar a Bitgive y B4H."), _defineProperty(_msg, "waiting_for_aprove", "En Orden"), _defineProperty(_msg, "waiting_aprove_info", "Fondos disponibles solo 60 días después de cada compra."), _defineProperty(_msg, "w", "S"), _defineProperty(_msg, "withdraw_sub", "Retiro es una operaci\xF3n que le permite transferir BLUE a una direcci\xF3n de BLUE v\xE1lida y compatible."), _defineProperty(_msg, "withdraw_sub_usdt", "Retiro es una operaci\xF3n que le permite enviar USDT a un y direcci\xF3n de billetera USDT compatible."), _defineProperty(_msg, "withdraw_network_fee", "Para retiros existe la tarifa de red de 0.0005 btc"), _defineProperty(_msg, "we_accet", "Nosotros aceptamos"), _defineProperty(_msg, "why_change", "Por qué el cambio"), _defineProperty(_msg, "white_paper", "Papel Blanco"), _defineProperty(_msg, "withdrawal_steps", "Pasos de retirada"), _defineProperty(_msg, "withdrawal", "Retiro"), _defineProperty(_msg, "withdrawing", "Retiro"), _defineProperty(_msg, "you_will_receive", "Usted recibirá"), _defineProperty(_msg, "your_email_shortly", "Su correo electrónico deberá llegar en breve"), _defineProperty(_msg, "you_want_start_new_purchase", "Está cancelando una orden de depósito, si desea realizar una nueva, inicie el flujo de compra nuevamente."), _defineProperty(_msg, "you_must_accpet_terms", "Debe aceptar nuestros términos y condiciones para continuar. Si tiene alguna pregunta, comuníquese con support@bluetoken.io."), _defineProperty(_msg, "you_must_accpet_privacy", "Debe aceptar nuestros política de privacidad para continuar. Si tiene alguna pregunta, comuníquese con support@bluetoken.io."), _defineProperty(_msg, "yes", "Sí"), _defineProperty(_msg, "no", "No"), _defineProperty(_msg, "beforeSendUnderTitle", "Seleccione la cantidad de BLUE que desea comprar. El pago debe hacerse con criptomoneda."), _defineProperty(_msg, "blockMsgP", "Creaci\xF3n de nuevos tokens esta temporariamente indisponible."), _defineProperty(_msg, "amount_in", "Monto en"), _defineProperty(_msg, "estimated_amount_in", "Monto estimado en"), _defineProperty(_msg, "important", "importante"), _defineProperty(_msg, "below_button_1", "- La cantidad de BLUE para acreditar depende de la cantidad de cripto que recibimos. Tenga en cuenta las tarifas que su cartera podr\xEDa cobrarle por la transferencia. Dichos cargos disminuir\xE1n la cantidad de cripto recibido, disminuyendo as\xED tambi\xE9n la cantidad de tokens."), _defineProperty(_msg, "below_button_2", "- Si la cantidad de BTC que recibimos est\xE1 por debajo del m\xEDnimo requerido (0.0208 BTC), su BTC se agregar\xE1 a un saldo temporal, que puede usar en un nuevo pedido. "), _defineProperty(_msg, "understand_and_agree", "Entiendo que cualquier monto por encima del m\xEDnimo enviado a nuestra direcci\xF3n de pago se convertir\xE1 a BLUE autom\xE1ticamente."), _defineProperty(_msg, "i_understand", "Entiendo"), _defineProperty(_msg, "understand_and_agree_button", "Entiendo y estoy de acuerdo"), _defineProperty(_msg, "understand_and_agree_warning", "El tiempo de compra es entre las 9 a.m. y las 5 p.m. (GMT-3), de lunes a viernes. Las transacciones realizadas fuera de ese per\xEDodo se procesar\xE1n al d\xEDa siguiente."), _defineProperty(_msg, "waiting_deposit", "En espera de dep\xF3sito"), _defineProperty(_msg, "waiting_deposit_otc", "Esperando confirmaci\xF3n de OTC"), _defineProperty(_msg, "transaction_details", "Detalles de la transacci\xF3n"), _defineProperty(_msg, "transaction_failed_1", "transacci\xF3n fall\xF3 en el paso "), _defineProperty(_msg, "transaction_failed_2", "Si tiene alguna pregunta, comun\xEDquese con el soporte t\xE9cnico en support@bluetoken.io"), _defineProperty(_msg, "temporary_balance", "Saldo temporal"), _defineProperty(_msg, "temporary_balance_substracted", "Este saldo temporal se resta del monto total a enviar."), _defineProperty(_msg, "to_send", "para Enviar"), _defineProperty(_msg, "to_receive", "para Recibir"), _defineProperty(_msg, "received", "Recibido"), _defineProperty(_msg, "expected", "anticipado"), _defineProperty(_msg, "expected_amount_in", "Cantidad estimada en"), _defineProperty(_msg, "estimated_blu", "BLUE estimado"), _defineProperty(_msg, "estimated", "estimado"), _defineProperty(_msg, "waiting_deposit_undertext", "El monto de BLUE se confirmar\xE1 con la confirmaci\xF3n del pago en el blockchain."), _defineProperty(_msg, "processing_order", "Procesando orden"), _defineProperty(_msg, "confirmed_amoutn", "monto confirmado"), _defineProperty(_msg, "follow_transaction_text", "Seguir la Transacci\xF3n"), _defineProperty(_msg, "check_transaction_status", "Revisar el status de la operaci\xF3n"), _defineProperty(_msg, "new_operation", "Operaci\xF3n Nueva"), _defineProperty(_msg, "order_created", "Orden Creada"), _defineProperty(_msg, "confirmed_on_blockchain", "Confirmada en el blockchain"), _defineProperty(_msg, "order_completed", "Orden Completa"), _defineProperty(_msg, "order_completed_info", "Se está creando su BLUE, recibirá un certificado por correo electrónico cuando se complete el proceso."), _defineProperty(_msg, "order_completed_info_title", "Completo"), _defineProperty(_msg, "temporary_balance_warning", "Tenga en cuenta que tiene un saldo temporal de transacciones anteriores que se agregar\xE1 a su transferencia."), _defineProperty(_msg, "send_btc_to_address", "Envie su {coin} a esta direccion para recibir sus BLUE"), _defineProperty(_msg, "purchase_confirmation", "Confirmaci\xF3n de Compra"), _defineProperty(_msg, "min", "min"), _defineProperty(_msg, "btc_sent", "BTC Confirmado"), _defineProperty(_msg, "blu_confirmed", "BLUE Confirmado"), _defineProperty(_msg, "minimum_amount_required", "El monto debe ser sobre el m\xEDnimo."), _defineProperty(_msg, "check_open_orders", "verificar orden abierta"), _defineProperty(_msg, "make_new_order", "realizar nueva orden"), _defineProperty(_msg, "if_no_order", "Si no se muestra ning\xFAn pedido durante un per\xEDodo prolongado, aseg\xFArese de haber realizado un pedido. Si es necesario, haga uno nuevo."), _defineProperty(_msg, "confirmed", "Confirmado"), _defineProperty(_msg, "waiting", "Esperando"), _defineProperty(_msg, "action_blocked_purchase", "Nuestro sistema se encuentra actualmente en mantenimiento, por favor intente su compra m\xE1s adelante."), _defineProperty(_msg, "bktc_text", "Bank to Crypto le permite comprar Bitcoin rápidamente."), _defineProperty(_msg, "bktc_text2", "Para continuar con su transacción, pague con Fiat a continuación"), _defineProperty(_msg, "bktc_only_brazil", "Tenga en cuenta que este m\xE9todo de pago solo debe ser utilizado por clientes brasile\xF1os."), _defineProperty(_msg, "info_link_stratum_wallet", "Acceda a su SmartWallet para comprar cripto."), _defineProperty(_msg, "select_coin_payment", "Seleccione un Método de Pago"), _defineProperty(_msg, "your_id_is", "Su identificaci\xF3n es el c\xF3digo de identificaci\xF3n de 6 d\xEDgitos enviado a su correo electr\xF3nico al registrarse."), _defineProperty(_msg, "amount_too_small", "La cantidad es muy pequeña. La compra mínima es de 100TUSD."), _defineProperty(_msg, "aware_token_redeem", "Sé que los tokens no se pueden transferir hasta 60 días después de la compra."), _defineProperty(_msg, "click_here_phases", "Haga clic aquí para obtener más detalles sobre cada fase."), _defineProperty(_msg, "create_new_email_recommendation", "Le recomendamos que cree un nuevo correo electr\xF3nico para cada plataforma. <span class=\"text_highlight\">Este correo electr\xF3nico se utilizar\xE1 para recibir su informaci\xF3n de inicio de sesi\xF3n y otra comunicaci\xF3n interna.</span>"), _defineProperty(_msg, "current_presale_ends", "Actual Pre-Venta Fase 3 finaliza Abril 6"), _defineProperty(_msg, "did_someone_referred", "¿Alguien te refirió? (Opcional)"), _defineProperty(_msg, "i_read_and_accept", 'He leído y acepto los <a href="/terms" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Términos & Condiciones</a> y <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Política de Privacidad</a>.'), _defineProperty(_msg, "i_read", "He leído y acepto los Términos y Condiciones."), _defineProperty(_msg, "i_read_privacy", "He leído y acepto los Política de Privacidad."), _defineProperty(_msg, "not_usa_citizen", "Declaro que no soy ciudadano o residente de los Estados Unidos de Am\xE9rica."), _defineProperty(_msg, "not_china_citizen", "Declaro que no soy ciudadano ni residente de Hong Kong."), _defineProperty(_msg, "scan_qr_code_or_copy_address", "Escanee el código QR o copie la dirección."), _defineProperty(_msg, "warning_60days", "Redenciones y retiros no están disponibles hasta 60 días después de la compra. No envíe el pago si no tiene la intención de comprar tokens."), _defineProperty(_msg, "portfolio_intro", "Nuestra cripto-cesta est\xE1 conformada por un grupo seleccionado de criptomonedas que tienen una confianza de mercado verificable o un gran potencial de crecimiento."), _defineProperty(_msg, "text_LUNA", "Terra es un protocolo blockchain que utiliza stablecoins indexados en fiat para impulsar sistemas de pagos globales con precios estables."), _defineProperty(_msg, "text_BTC", "Criptomoneda con la mayor capitalización de mercado. Utilizado para pagos y como reserva de valor."), _defineProperty(_msg, "text_ETH", "Primera plataforma de criptomonedas para crear contratos inteligentes y aplicaciones descentralizadas."), _defineProperty(_msg, "text_XRP", "XRP es utilizado por bancos y empresas para asegurar liquidez en transferencias."), _defineProperty(_msg, "text_LTC", "Conocido como la plata al oro de Bitcoin. En los primeros días de la criptomonedas, Litecoin se creó para ser una versión más rápida y menos costosa de Bitcoin."), _defineProperty(_msg, "text_BCH", "Bitcoin Cash se creó a partir de un fork de Bitcoin (división de monedas). Es una versión modificada de Bitcoin que busca transacciones más rápidas y menos costosas."), _defineProperty(_msg, "text_EOS", "Plataforma para construir aplicaciones descentralizadas, sin tarifas de transacción."), _defineProperty(_msg, "text_XLM", "Lumens se utilizan para remesas, permitiendo liquidaciones entre diferentes monedas."), _defineProperty(_msg, "text_ADA", "Proyecto destinado a desarrollar la plataforma de contratos inteligentes más avanzada. Su equipo consiste en un gran colectivo global de expertos, incluido Charles Hoskinson, cofundador de Ethereum."), _defineProperty(_msg, "text_BNB", "Token digital creado por la plataforma de negociación Binance, que brinda varios beneficios a sus operadores."), _defineProperty(_msg, "text_TRX", "Plataforma descentralizada para compartir y monetizar el entretenimiento digital."), _defineProperty(_msg, "text_ZCR", "Criptomoneda creada para pagos simplificados. Los servicios que usan Zcore incluyen un sistema de mensajería móvil y masternodes."), _defineProperty(_msg, "text_NXS", "La arquitectura avanzada de blockchain de Nexus proporciona la mayor escalabilidad y seguridad. Nexus también tiene como objetivo descentralizar Internet al proporcionar acceso a través de satélites en el espacio."), _defineProperty(_msg, "text_IOTA", "El proyecto IOTA tiene como objetivo crear un ecosistema financiero seguro y descentralizado para Internet de las cosas (IoT)."), _defineProperty(_msg, "text_XMR", "Monero sobresale en privacidad y no-rastreabilidad. Las transacciones no pueden vincularse a un usuario particular o identidad del mundo real."), _defineProperty(_msg, "text_OTC", "Criptos actualmente incluyen SafeInsure (SINS), Zcore (ZCR), SmartCash (SMART), DashGreen (DASHG), BitTorrent (BTT), Wink (WIN) y Bitcoin (BTC)."), _defineProperty(_msg, "text_DASH", "Una de las criptomonedas más conocidas con una vasta red de usuarios en crecimiento. Presente desde los primeros días de las criptomonedas, Dash se enfoca en pagos rápidos y seguros."), _defineProperty(_msg, "text_LINK", "Token de Ethereum que alimenta la red oracle descentralizada Chainlink, permitiendo que los contratos inteligentes se conecten de forma segura a fuentes de datos externas, API y sistemas de pago."), _defineProperty(_msg, "text_LEND", "Token digital utilizado en Aave, una de las plataformas DeFi de préstamos de más rápido crecimiento, que brinda grandes beneficios a sus usuarios."), _defineProperty(_msg, "text_DOT", "Polkadot tiene como objetivo facilitar una web descentralizada totalmente funcional y fácil de usar (Web 3.0), permitiendo transferencias entre blockchains de cualquier tipo de datos o activos."), _defineProperty(_msg, "text_UNI", "Token de gobernanza de Uniswap, una de las plataformas comerciales descentralizadas más grandes alojadas en Ethereum, que facilita el comercio de tokens de finanzas descentralizadas (DeFi)."), _defineProperty(_msg, "text_FIL", "Filecoin es un sistema de almacenamiento descentralizado. A diferencia de las empresas de almacenamiento en la nube como Amazon o Cloudflare, Filecoin aprovecha su naturaleza descentralizada para proteger la integridad de los datos."), _defineProperty(_msg, "text_THETA", "Theta es la criptomoneda nativa de Theta Network, un blockchain para mejorar la calidad y la capacidad de entrega del contenido de streaming de video."), _defineProperty(_msg, "text_MANA", "Token digital utilizado en Decentraland, una plataforma de realidad virtual, que permite a los usuarios comprar, personalizar y vender terrenos virtuales como NFTs."), _defineProperty(_msg, "text_CAKE", "Token de gobernanza de PancakeSwap, la plataforma de trading descentralizada (DEX) de más rápido crecimiento alojada en Binance Smart Chain."), _defineProperty(_msg, "text_MATIC", "Token de gobernanza de Polygon, una red de segunda capa para el desarrollo de infraestructura y escalamiento de Ethereum. Con Polygon, Ethereum se convierte en un sistema multi-chain, lo que facilita la interoperabilidad del blockchain, con transacciones más rápidas a un costo menor."), _defineProperty(_msg, "text_SOL", "Token nativo de la red Solana, un blockchain de rápido crecimiento en el espacio DeFi, con excelente velocidad y escalabilidad, capaz de alcanzar hasta 65,000 transacciones por segundo."), _defineProperty(_msg, "text_CRV", "Token nativo de Curve Finance, el intercambio descentralizado (DEX) con el mayor volumen actual en DeFi. Curve Finance es único debido a su optimización para intercambios con bajo deslizamiento entre stablecoins o activos similares que se vinculan al mismo valor."), _defineProperty(_msg, "text_AVAX", "Token nativo de Avalanche, un blockchain de contratos inteligentes prometedor en DeFi y el espacio NFT."), _defineProperty(_msg, "text_MBOX", 'Token de gobernanza de en Mobox, una aplicación de juegos descentralizada "play-to-earn", que permite a los usuarios intercambiar NFT y ser recompensados ​​por su participación.'), _defineProperty(_msg, "text_USDT", "Stablecoin al par con el Dólar Americano."), _defineProperty(_msg, "text_TUSD", "Stablecoin al par con el Dólar Americano."), _defineProperty(_msg, "bitgive_info", "Uso de la tecnología bitcoin y blockchain para mejorar la salud pública y el medio ambiente en todo el mundo."), _defineProperty(_msg, "b4h_info", "Apoya a las organizaciones que usan la tecnología blockchain para traer un cambio positivo a la humanidad."), _defineProperty(_msg, "tooltip_text_charity", "Hasta el 50% de nuestras tarifas de venta se donan a Bitgive y Blockchain for Humanity."), _defineProperty(_msg, "tooltip_purchase_referral", "Puede llenar este campo si alguien le ayudó con la compra."), _defineProperty(_msg, "tooltip_internal_withdraw", "Este es el ID de usuario del destinatario."), _defineProperty(_msg, "current_balance", "Saldo actual"), _defineProperty(_msg, "unlocked_balance", "Saldo desbloqueado"), _defineProperty(_msg, "total_without_fees", "Total sin tarifas"), _defineProperty(_msg, "total_to_receive", "Total a Recibir"), _defineProperty(_msg, "min_length", "Longitud m\xEDnima es"), _defineProperty(_msg, "characters", "caracteres"), _defineProperty(_msg, "contact_intro", "Si tiene alguna pregunta o problema que necesita resolver, cont\xE1ctenos en el siguiente formulario"), _defineProperty(_msg, "email_to_registered", "El email se enviar\xE1 a su email registrado en la plataforma."), _defineProperty(_msg, "subject", "asunto"), _defineProperty(_msg, "message", "mensaje"), _defineProperty(_msg, "form_sent", "Mensaje enviado com \xE9xito"), _defineProperty(_msg, "form_error", "Se produjo un error al enviar su mensaje. Vuelva a intentarlo."), _defineProperty(_msg, "insufficient_funds", "Fondos insuficientes"), _defineProperty(_msg, "coin_voting_enj", 'Token digital utilizado en la red ENJIN, una plataforma de social gaming, que permite a los usuarios monetizar elementos del juego, como NFTs. <a href="https://enjin.io/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_mana", 'Token digital utilizado en Decentraland, una plataforma de realidad virtual, que permite a los usuarios comprar, personalizar y vender terrenos virtuales como NFTs. <a href="https://decentraland.org/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_bat", 'Token digital utilizado para recompensar a los usuarios y editores en el creciente navegador "Brave". Los editores y creadores obtienen ingresos por publicidad, así como propinas, mientras que los usuarios mantienen la privacidad a medida que obtienen BAT por ver anuncios. <a href="https://basicattentiontoken.org/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_dash", 'Una de las criptomonedas más conocidas con una vasta red de usuarios en crecimiento. Dash se enfoca en pagos rápidos y privados, ofreciendo "PrivateSend" para activar transacciones imposibles de rastrear. <a href="https://www.dash.org/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_mkr", 'Token digital creado por MakerDAO, una de las mayores plataformas DeFi , que proporciona préstamos respaldados por Ethereum. <a href="https://makerdao.com/en/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_xtz", 'Criptomoneda nativa del blockchain Tezos, que se enfoca en integrar la tecnología de Smart Contracts con productos financieros.Últimamente, varios proyectos de NFT, como los Cleveland Cavaliers y McLaren, están utilizando Tezos para sus colecciones. <a href="https://tezos.com/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_lend", 'Token digital utilizado en Aave, una de las plataformas de préstamos DeFi de más rápido crecimiento, que brinda grandes beneficios a los usuarios de AAVE. <a href="https://aave.com/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_atom", 'Ecosistema de blockchains de rápido crecimiento que pueden escalar e interoperar entre sí, competidor de Polkadot (DOT), Ethereum (ETH) y otras importantes criptomonedas de contratos inteligentes. <a href="https://cosmos.network/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_band", 'Plataforma oracle de cross-chain data que agrega y conecta datos y API del mundo real a Smart Contracts. <a href="https://bandprotocol.com/" target="_blank">Aprenda más</a>'), _defineProperty(_msg, "coin_voting_aave", 'Token digital utilizado en AAVE, una de las mayores plataformas de préstamos DeFi. AAVE se actualizó recientemente a la versión 3.0, proporcionando préstamos "cross-chain" y un nuevos mecanismos para mejorar la experiencia del usuario, la gestión de riesgos y la eficiencia del capital. <a href="https://aave.com/" target="blank_">Aprenda más</a>.'), _defineProperty(_msg, "coin_voting_uni", 'Una de las plataformas de comercio descentralizado más conocidas, que facilita el comercio automatizado de tokens de finanzas descentralizadas (DeFi). <a href="https://uniswap.org/" target="blank_">Aprenda más</a>.'), _defineProperty(_msg, "coin_voting_fil", 'Filecoin es un sistema de almacenamiento descentralizado. A diferencia de las empresas de almacenamiento en la nube como Amazon o Cloudflare, Filecoin aprovecha su naturaleza descentralizada para proteger la integridad de los datos. <a href="https://filecoin.io/" target="blank_">Aprenda más</a>.'), _defineProperty(_msg, "coin_voting_cake", 'Token de gobernanza de PancakeSwap, la plataforma de comercio descentralizada de más rápido crecimiento alojada en Binance Smart Chain. <a href="https://pancakeswap.finance/" target="blank_">Aprenda más</a>.'), _defineProperty(_msg, "coin_voting_matic", "Token de gobernanza de Polygon, una red de segunda capa para el desarrollo de infraestructura y escalamiento de Ethereum. Con Polygon, Ethereum se convierte en un sistema multi-chain, lo que facilita la interoperabilidad del blockchain, con transacciones m\xE1s r\xE1pidas a un costo menor. <a href=\"https://polygon.technology/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_sand", "Token de gobernanza de The Sandbox, un mundo de realidad virtual donde las personas pueden crear, compartir y vender contenido como NFT, como juegos y experiencias \xFAnicas. <a href=\"https://sandbox.game/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_axs", "Token de gobernanza de Axie Infinity, el juego de realidad virtual \"jugar para lucrar\" de m\xE1s r\xE1pido crecimiento que utiliza NFT. M\xE1s de 1 mill\xF3n de jugadores activos diarios \"luchan\" en Axie Infinity por la oportunidad de ganar recompensas en cripto. <a href=\"https://axieinfinity.com/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_mbox", "Token de gobernanza en Mobox, una aplicaci\xF3n de juegos descentralizada de juego para ganar, que permite a los usuarios intercambiar NFT y ser recompensados \u200B\u200Bpor su participaci\xF3n. <a href=\"https://www.mobox.io/#/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_xmr", "Criptomoneda enfocada en la privacidad. Monero fue dise\xF1ado para evitar la censura, y sus transacciones son totalmente imposibles de rastrear. <a href=\"https://monero.org\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_egld", "Elrond es un blockchain dise\xF1ada para un alto rendimiento y una velocidad de ejecuci\xF3n r\xE1pida en comparaci\xF3n con otras plataformas de contratos inteligentes. Para aumentar la adopci\xF3n, el proyecto apoya a los desarrolladores que construyen en la plataforma, lo que les permite ganar el 30 % de las tarifas de los contratos inteligentes como regal\xEDas. <a href=\"https://elrond.com/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_etc", "Ethereum Classic es el Ethereum original, que todav\xEDa funciona con Prueba de trabajo (mineros). ETC se utiliza para pagar la ejecuci\xF3n de transacciones y funciones de contratos inteligentes. <a href=\"https://ethereumclassic.org/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_ton", "Toncoin (TON) es una cadena de bloques de capa 1 descentralizada desarrollada en 2018 por la plataforma de mensajer\xEDa encriptada Telegram. Luego, el proyecto fue abandonado, asumido por la Fundaci\xF3n TON y renombrado de \"Telegram Open Network\" a \"The Open Network\". <a href=\"https://ton.org/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "coin_voting_xlm", "Stellar es una red de pagos de c\xF3digo abierto que sirve como una cadena de bloques intermediaria distribuida para los sistemas financieros globales y hace circular un activo nativo, Stellar Lumens (XLM). <a href=\"https://stellar.org/\" target=\"blank_\">Aprenda m\xE1s</a>."), _defineProperty(_msg, "modalNetwork", {
    title: "Anuncios",
    text_one: "Nos complace informarle que recientemente agregamos nuevos elementos:",
    title_two: "Blue Club",
    text_two: "Se otorga un NFT de membres\xEDa Blue Club a los usuarios que compran 20 tokens BLUE o m\xE1s. Los miembros de Blue Club disfrutan de los siguientes beneficios:",
    text_two_t: "Puede seguir el progreso de su calificaci\xF3n en su Tablero. \xA1Esperamos darle la bienvenida a Blue Club!",
    title_three: "Tether Wallets",
    text_three: "Ahora puede depositar y retirar Tether (USDT), lo que le brinda más flexibilidad de inversión. Decide si es un buen momento para comprar y mantener Blue Tokens, o mantener Tether en tu billetera para cuando sea el momento adecuado."
  }), _defineProperty(_msg, "modalBscInfo", {
    title: "Anuncios",
    text_one: "Como se inform\xF3 anteriormente en nuestros informes trimestrales, BLUE cambiar\xE1 de blockchain. El token BLUE dejar\xE1 el blockchain NEM para alojarse en el blockchain Binance Smart Chain (BSC).",

    text_two: "La mudanza est\xE1 programada para el jueves 11 de noviembre de 2021 a las 9:00h (UTC-3). La plataforma no estar\xE1 disponible durante esta transici\xF3n, que se espera sea de 4 d\xEDas. Esperamos tener la plataforma en funcionamiento nuevamente el lunes 15 de noviembre. Durante este tiempo, todas las operaciones no estar\xE1n disponibles, as\xED que planifique en consecuencia.",

    title_two: "El precio del token y el saldo de los usuarios no se verán afectados.",
    text_three: "Los usuarios tendrán la misma cantidad de tokens que tenían antes de la mudanza. El precio del token continuará rastreando las 14 criptomonedas en nuestra canasta durante este período.",
    title_four: "Estamos muy entusiasmados con la mudanza. BSC permitirá una integración más fácil de BLUE con terceros que deseen trabajar con el token. BSC está creciendo rápidamente, siendo actualmente el segundo blockchain más grande utilizado en aplicaciones DeFi. Debido a sus tarifas bajas, los desarrolladores y usuarios consideran BSC como una alternativa más barata a Ethereum. Además, BSC se creó para alojar proyectos de Ethereum, por lo que a los desarrolladores les resulta  fácil alojar sus proyectos en Ethereum y BSC.",
    title_five: "Como prometimos, trabajamos constantemente para crecer BLUE. Este movimiento es un paso muy importante hacia nuestra expansión. Agradecemos a todos nuestros usuarios que continúan apoyando el proyecto."
  }), _defineProperty(_msg, "modalBluePool", {
    title: "Announcements",
    text_one: "Hemos actualizado nuestros t\xE9rminos y condiciones.",
    title_one: "Tarifa de compra",
    text_two: "Bajamos la tarifa de compra del token BLUE, del 6% al 2% (anual). Esto reducir\xE1 los costos para las personas que deseen comprar tokens BLUE por primera vez, y aquellos que suelen hacer aportes mensuales.",
    title_two: "Tarifa de custodia",
    text_three: "Aumentamos nuestra comisión de custodia del 2,5 % al 6 %. Esto nos permitirá brindarle mejores herramientas, servicio y seguridad, además de la creación de un nuevo sistema de recompensas.",
    title_four: "Nuevo sistema de recompensas: Blue Pool",
    text_four: "Presentamos un nuevo sistema de recompensas: Blue Pool. Todos los usuarios ahora pueden participar en un grupo de recompensas mensuales. Las recompensas se pagan a los usuarios que recomiendan a sus amigos que compren tokens BLUE. El primer “pool” se fijó en 4.20 BLUE (aproximadamente $1,800 dólares). ¡Gane su parte!"
  }), _defineProperty(_msg, "modalClainBlueClub", {
    title: "Obtenga su Blue Club NFT",
    text2: "¡Felicidades! Ahora pertenece al selecto club VIP de Blue Token.",
    text3: "Ahora debe reclamar su NFT, que le dará acceso a varios beneficios de membresía.",
    text4: "Ingrese su dirección de Solana:",
    text5: "Use una billetera Exodus o Phantom para almacenar su NFT.",
    text6: "Si tiene alguna pregunta, comuníquese con nuestro equipo de soporte.",

    text7: "¡Bienvenidos a Blue Club!",
    text8: "Se está creando su NFT. Lo recibirás en 2 días hábiles.",
    text9: "Recibirás un correo electrónico de bienvenida. Por favor, asegúrese de que no esté en su correo spam, ya que lo mantendremos informado sobre eventos y servicios en los que recibirá un trato VIP.",
    text10: "OK, GENIAL!"
  }), _defineProperty(_msg, "modalDhbtInfo", {
    title: "Anuncios",
    text_one: "Hemos actualizado nuestros t\xE9rminos y condiciones.",

    text_two: "Como se anunci\xF3 anteriormente, Blue Token ahora es un producto de una empresa reci\xE9n formada, Digital Horizon Blockchain Technology, registrada en el pa\xEDs de El Salvador.",

    title_two: "La medida se debió a varios beneficios otorgados por El Salvador a las cripto empresas. El Salvador es el único país del mundo que ha aceptado Bitcoin como moneda de curso legal. Su gobierno está incentivando a las empresas de criptomonedas a invertir y prosperar, preparando la base para el crecimiento futuro en innovación tecnológica e infraestructura.",
    text_three: "Estamos muy entusiasmados con el cambio y estamos listos para aprovechar los beneficios de El Salvador para llevar a Blue Token al siguiente nivel.",
    title_four: "Si tiene alguna pregunta, envíenos un e-mail a support@bluetoken.io.",
    title_one: "Blue es un producto de Digital Horizon, con sede en El Salvador",
    title_five: "Pagos y tarifas de redenciones",
    text_four: "A partir del 2 de febrero, todos las redenciones se pagarán solo en USDT (Tether), junto con cambios en las tarifas de redención:",
    text_six: "Tarifa de redenci\xF3n: 1% del valor de redenci\xF3n <br/>Tarifa m\xEDnima de redenci\xF3n: 50 USDT",
    text_seven: "El tiempo de pago seguirá siendo de 3 días hábiles. Los usuarios tendrán la opción de pago el mismo día por una tarifa."
  }), _defineProperty(_msg, "modalBuyBluePix", {
    buy_blue: "Comprar BLUE",
    connecting_swapix: "Conectándose a SWAPiX",
    only_accepts: "Blue Token solo acepta pagos en criptomonedas.",
    pix_purcase_processed: "Afortunadamente, las compras de Pix son procesadas por nuestro socio de confianza SWAPiX.",
    swapix_terms: "He le\xEDdo los <a class=p5_l href=https://usdt.smartpay.com.vc/static/media/terms_jun.f681a88b.pdf target=blank  style=\"margin-right:5px\">t\xE9rminos y condiciones</a> de SWAPiX.",
    btn_next: "Siguiente",
    welcome: "Bienvenido a",
    payment_being_processed: "Su información de pago está siendo procesada.",
    wait: "Espera unos segundos mientras hacemos nuestra magia...",
    payment: "Pago",
    convert_price: "Tipo de cambio",
    completed_buy: "Su compra ha sido completada. Si su saldo no está actualizado, actualice la página."
  }), _defineProperty(_msg, "modalWarnUser", {
    title: "Retirar: Importante",
    warn1: "Asegúrese de que la cartera receptora acepte tokens BLUE. No todas las carteras BSC son compatibles con BLUE",
    warn2: "Blue Token no asume responsabilidad por operaciones que ocurran en plataformas de terceros.",
    warn3: "Todas las transacciones que se originan fuera de nuestra plataforma incurren en una tarifa del 6%.",
    warn4: "Retiros son irreversibles. Asegúrese de enviar sus tokens a una parte confiable.",
    i_understand: "Entiendo"
  }), _defineProperty(_msg, "modalBlueClub", {
    title: "Beneficios de membresía",
    subTitle: "Se otorga un NFT de membresía de Blue Club a los usuarios que compran 20 tokens o más.",
    text1: "<div style=\"display:flex\"><a href=\"https://solscan.io/token/AP9rP81KJzPCQFmE4fK9Ue8NWRaXZ5QbqQJn6PKhQP17\" target=\"_blank\" style=\"color: #cb36ee; text-decoration:underline; margin-right:5px\">Blue Club NFT</a> (Token No-fungible).</div>",
    text2: "Acceso prioritario/VIP a todos nuestros eventos, incluidos regalos y souvenirs.",
    text3: "Servicios exclusivos de consultoría.",
    text4: "Recompensas de nuestros socios (airdrops, obsequios, promociones).",
    text5: "Invitación a eventos exclusivos de networking."
  }), _defineProperty(_msg, "settings", {
    title: "Configuraciones de Cuenta",
    profile: "Perfil",
    security: "Seguridad",
    notifications: "Notificaciones",

    updateInfoProfile: "Actualice la información básica de su perfil.",
    updateInfoSecurity: "Actualice su información básica de seguridad.",
    updateInfoNotifications: "Deshabilite o habilite sus notificaciones por correo electrónico.",

    currently: "Corrientemente",
    profileStatus: "Estado del perfil",

    updateProfile: "Haga clic en Guardar para actualizar la información de su perfil.",
    updateSecurity: "Haga clic en Guardar para actualizar su información de seguridad.",
    updateNotification: "Haga clic en Guardar para actualizar la configuración de sus notificaciones.",

    toggleEmail: "Alternar sus notificaciones de correo electrónico",

    popupSure: "Esta seguro(a)?",
    popupConfirm: "Confirme su cambio de contraseña.",

    popupChangesApply: "Los cambios se aplicarán cuando vuelva a iniciar sesión."
  }), _msg)
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _msg;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* harmony default export */ __webpack_exports__["default"] = ({
  msg: (_msg = {
    //countdown / time
    seconds: "Segundos",
    minutes: "Minutos",
    hours: "Horas",
    days: "Dias",

    //titles / sub
    insights: "Insights",
    fund_holdings: "Holdings",
    charity: "Caridade",
    charity_sub: "A Stratum doou o seguinte para caridade.",
    network_distributions: "Distribuições de Rede",
    network_distributions_sub: "Moedas ganhas em distribuições de rede, como airdrops.",
    redemption_sub: "Operação para liquidar BLUE e receber o valor equivalente em Tether (USDT), stablecoin a par com o dólar americano.",
    twofa_info: "Para resgatar, tem de ativar o 2FA.",
    redemption_sub_one: "Resgates estão disponíveis às quartas-feiras, das 0h às 17h (UTC -3), e demoram 3 dias úteis para serem creditados (D+3).",
    redemption_sub_two: "Uma opção de pagamento no mesmo dia está disponível por uma taxa.",
    redemption_sub_three: "Resgates são pagos através da rede Tron (TRC-20).",

    //a
    alert_created_deposit: "Sua carteira ja foi  criada, por favor atualize a pagina.",
    alert: "Alerta",
    asset_allocation: "Alocaçação de Criptomoeda",
    amount_below_purchase_limit: "Valor abaixo do limite mínimo de compra",
    amount_below_minimum_trade_limit: "Montante abaixo do limite mínimo de negociação",
    activating_account: "Por favor aguarde. Estamos a activar a conta…",
    activation_successful: "Parabéns, a sua conta está agora activa. Pode fazer a autenticação.",
    activation_successful_2fa: "Parabéns, o seu código 2fa está agora ativo. Pode prosseguir para os serviços.",
    activation_link_invalid: "O link de ativação é inválido",
    apply_filter: "Aplicar filtro",
    add_funds: "Adicionar BLUE",
    address: "Endereço",
    actions: "Ações",
    action: "Açõe",
    all: "Todos",
    all_rights_reserved: "Todos os direitos reservados",
    all_transactions: "Todas as transacções",
    already_member: "Já é membro?",
    amount: "Montante",
    approx_value: "Valor aproximado",
    equivalent_in: "Equivalente em",
    one_blu_equals: "1 BLUE igual",
    equivalence: "Equivalência",
    one_blu: "1 BLUE",
    updated_last: "Última atualização",
    all_time: "Todas as vezes",
    activate: "Activar",
    available_info: "Disponível para resgate",
    available_to_redeem: "Disponível para resgate: {amount} USDT",
    available: "Disponível",
    attention_done: "Atenção: sua compra foi concluida",
    attention_cancel: "Atenção: Seu pedido foi cancelado. Se você deseja comprar BLUE, abra um novo pedido",
    attention_waiting_days: "Atenção: Seu pedido tem {hours} até o vencimento.",
    attention_waiting_hours: "Atenção: Seu pedido tem {hours} até o vencimento.",
    attention: "Atenção",
    available_balance: "Saldo disponível: ",
    allocation: "Alocação",
    authenticate: "Autenticar",
    address_empty: "O endereço está vazio",
    average_time: "Depósitos podem demorar até 5 minutos.",

    //b
    balance: "Saldo | Saldos",
    begins: "Começa",
    bonus: "Bónus",
    buy: "Comprar",
    buy_tokens: "Comprar BLUE",
    buyer_bonus: "Bónus do comprador",
    blank: "",
    bonus_0dot5: "Bónus(0.5%)",
    bonus_1: "Bónus(1%)"
  }, _defineProperty(_msg, "bonus", "Bónus"), _defineProperty(_msg, "buy_here", "Compre Aqui"), _defineProperty(_msg, "buy_now", "Compre Agora"), _defineProperty(_msg, "bktc", "BKTC"), _defineProperty(_msg, "back", "Retroceder"), _defineProperty(_msg, "balance_equivalence", "Equivalência do saldo em"), _defineProperty(_msg, "blue_team", "Time BLUE"), _defineProperty(_msg, "buy_pix", "Compre BLUE via PIX"), _defineProperty(_msg, "buy_pix_info", "Usando o SWAPiX, um parceiro confiável que oferece trocas fiat-para-cripto."), _defineProperty(_msg, "blue_club_status", "Blue Club status"), _defineProperty(_msg, "balance_text_tusd", "TrueUSD Stablecoin aliado ao Dólar Americano"), _defineProperty(_msg, "balance_text_btc", "Bitcoin"), _defineProperty(_msg, "balance_text_rlt", "RealT Stablecoin aliado ao Real Brazileiro"), _defineProperty(_msg, "balance_text_eth", "Ethereum"), _defineProperty(_msg, "buy_token", "COMPRAR TOKEN"), _defineProperty(_msg, "boleto", "Guia de Pagamento"), _defineProperty(_msg, "best_way_buy", "Melhor maneira de comprar"), _defineProperty(_msg, "browser_message", "Se não conseguir visualizar o documento, por favor utilize o Firefox ou o Safari."), _defineProperty(_msg, "business_day", "DIAS ÚTEIS"), _defineProperty(_msg, "no_additional_fee", "Sem taxas adicionais."), _defineProperty(_msg, "rush_today", "RUSH (hoje)"), _defineProperty(_msg, "receive_today_info", "Você receberá no mesmo dia do calendário."), _defineProperty(_msg, "basket_value", "Valor da cesta"), _defineProperty(_msg, "charity", "Caridade"), _defineProperty(_msg, "clear_filter", "Limpar filtro"), _defineProperty(_msg, "cancelled", "Cancelado"), _defineProperty(_msg, "cancel_purchase", "Cancelar compra"), _defineProperty(_msg, "click_on_transaction_to_get_details", "Para obter mais detalhes, clique numa transacção."), _defineProperty(_msg, "chart", "Gráfico"), _defineProperty(_msg, "crypto", "Cripto"), _defineProperty(_msg, "copy_twofa", "Digitalize o código QR com o seu telemóvel usando o Google Authenticator ou o Authy, ou então digite o código.<strong>Para o caso de perda do seu telefone, mantenha esse código num local seguro e não o partilhe com ninguém.</strong>"), _defineProperty(_msg, "confirm_delet", "Tem certeza?"), _defineProperty(_msg, "click_here", "Entrar na Stratum smartwallet"), _defineProperty(_msg, "confirm_redeem", "O seu resgate está a ser processado."), _defineProperty(_msg, "confirm_withdraw", "O seu levantamento está a ser processado."), _defineProperty(_msg, "amount_revice_withdraw", "Valor a receber"), _defineProperty(_msg, "amount_revice_withdraw_fee", "Taxa: "), _defineProperty(_msg, "can_not_load_data", "Não é possível carregar os dados."), _defineProperty(_msg, "change", "Alteração"), _defineProperty(_msg, "coin_slider_BTC", "Bitcoin"), _defineProperty(_msg, "coin_slider_RAS", "Ras – Stablecoin a par com o Real Brazileiro"), _defineProperty(_msg, "coin_slider_BLU", "TrueUSD – Stablecoin a par com o Dólar Americano"), _defineProperty(_msg, "coin_slider_ETH", "Ethereum"), _defineProperty(_msg, "coin_slider_ZAR", "RAND – Moeda da África do Sul"), _defineProperty(_msg, "coin_slider_EUR", "Euro – Moeda da União Europeia"), _defineProperty(_msg, "coin_slider_GBP", "Libra Esterlina – Moeda do Reino Unido"), _defineProperty(_msg, "coin_slider_CHF", "Franco Suíço – Moeda da Suíça"), _defineProperty(_msg, "coin_slider_CNY", "Yuan – Moeda da China"), _defineProperty(_msg, "coin_slider_HKD", "HK$ - Moeda do Dólar de Hong Kong"), _defineProperty(_msg, "coin_slider_USDT", "USDT – Stablecoin a par com o Dólar Americano"), _defineProperty(_msg, "cancel", "Cancelar"), _defineProperty(_msg, "contact_us_any_question", "Sinta-se à vontade para nos contatar em support@bluetoken.io se tiver alguma dúvida."), _defineProperty(_msg, "cellphone", "Telemóvel"), _defineProperty(_msg, "cpf", "CPF"), _defineProperty(_msg, "cep", "CEP"), _defineProperty(_msg, "complement", "Complemento"), _defineProperty(_msg, "city", "Cidade"), _defineProperty(_msg, "criptocurrency", "Criptomoeda"), _defineProperty(_msg, "chose_two_coins", "O retorno mostrado é no acumulado do ano, até 23 de Dezembro do 2022"), _defineProperty(_msg, "click_here_to_vote", "Clique aqui para votar"), _defineProperty(_msg, "copy_address", "Copiar Endereço"), _defineProperty(_msg, "create_order", "Criar novo pedido"), _defineProperty(_msg, "cancel_transaction", "Cancelar transacção"), _defineProperty(_msg, "canceling_order", "Pedido cancelado "), _defineProperty(_msg, "canceling", "Cancelado"), _defineProperty(_msg, "checking_open_orders", "Verificando pedidos em aberto"), _defineProperty(_msg, "copy_alert_info_otc", "Copiado - valor esperado e valor estimado"), _defineProperty(_msg, "confirm_recaptcha", "Confirme o CAPTCHA"), _defineProperty(_msg, "create_deposit_address", "Criar endereço de deposito"), _defineProperty(_msg, "check_info_redeem", "Verifiquei que as informações acima são precisas."), _defineProperty(_msg, "current_value", "Valor atual"), _defineProperty(_msg, "component_hold", "Componente"), _defineProperty(_msg, "current_weight", "Peso atual"), _defineProperty(_msg, "currently_generating", "Atualmente gerando recompensas diárias"), _defineProperty(_msg, "country_residency", "País de residência"), _defineProperty(_msg, "countries_not_allowed", "USA/China/HK - Países não autorizados a usar nossos serviços!"), _defineProperty(_msg, "clain_your_nft", "Obtenha seu NFT"), _defineProperty(_msg, "check_your_email", "Por favor, verifique o seu e-mail e siga as instruções."), _defineProperty(_msg, "check_your_email_for_userid", "Vai receber um e-mail com o seu ID de utilizador."), _defineProperty(_msg, "check_your_email_for_recovery_link", "Vai receber um e-mail com o link de recuperação."), _defineProperty(_msg, "check_your_email_for_pin", "Vai receber um e-mail com o PIN para confirmar a transacção"), _defineProperty(_msg, "check_your_email_for_pin_redeem", "Vai receber um e-mail com o PIN para confirmar a transacção"), _defineProperty(_msg, "if_no_email_spam", "Caso não consiga encontrar o e-mail, por favor verifique a sua caixa de spam."), _defineProperty(_msg, "closes", "Fechos"), _defineProperty(_msg, "component", "Componente | Componentes"), _defineProperty(_msg, "confirm", "Confirme"), _defineProperty(_msg, "confirm_operation", "Confirmar Operação"), _defineProperty(_msg, "confirmation_pin", "Confirme o seu PIN"), _defineProperty(_msg, "confirmation_pin_email_hint", "Após a continuação, irá receber um e-mail com o PIN de confirmação, necessário para concluir a sua operação."), _defineProperty(_msg, "contact", "Contacto"), _defineProperty(_msg, "continue", "Continuar"), _defineProperty(_msg, "copied", "Copiado"), _defineProperty(_msg, "copy", "Copiar"), _defineProperty(_msg, "currency", "Moeda"), _defineProperty(_msg, "click_here_action", "Clique aqui"), _defineProperty(_msg, "change_withdraw_partner", "Escolha a entidade de levantamento"), _defineProperty(_msg, "denied", "Negado"), _defineProperty(_msg, "dashboard", "Painel de Controle"), _defineProperty(_msg, "dont_have_btc", "Não tem Bitcoin?"), _defineProperty(_msg, "details", "Detalhes"), _defineProperty(_msg, "deposits", "Depósitos"), _defineProperty(_msg, "deposit_amount", "Valor do depósito"), _defineProperty(_msg, "dear_blu_holder", "Caro titular do BLUE"), _defineProperty(_msg, "district", "Distrito"), _defineProperty(_msg, "donwload", "Donwload"), _defineProperty(_msg, "documentation_info", "Fichas técnicas, métodos, cálculos e outros documentos"), _defineProperty(_msg, "dropdown_header_withdraw", "Envie seus tokens para uma carteira externa"), _defineProperty(_msg, "dropdown_header_deposit", "Receba seus tokens de uma carteira externa"), _defineProperty(_msg, "dropdown_header_redeem", "Troque seus tokens"), _defineProperty(_msg, "dropdown_header_internal", "Envie BLUE para outro usuário"), _defineProperty(_msg, "destination_user", "Usuario de destino"), _defineProperty(_msg, "deposit_received", "Seu depósito foi recebido"), _defineProperty(_msg, "do_you_want", "Deseja cancelar mesmo assim?"), _defineProperty(_msg, "download_pdf", "Baixar PDF"), _defineProperty(_msg, "deposit_sub", "O depósito é uma operação que permite receber o {coin} de uma carteira externa."), _defineProperty(_msg, "internal", "Transferência interna"), _defineProperty(_msg, "delivery_speed", "Velocidade de entrega"), _defineProperty(_msg, "download_csv", "Baixar CSV"), _defineProperty(_msg, "date_1", "4 de Dezembro, 2018"), _defineProperty(_msg, "date_2", "15 de Janeiro, 2019"), _defineProperty(_msg, "date_3", "16 de Janeiro, 2019"), _defineProperty(_msg, "date_4", "15 de Fevereiro, 2019"), _defineProperty(_msg, "date_5", "16 de Fevereiro, 2019"), _defineProperty(_msg, "date_6", "6 de Abril, 2019"), _defineProperty(_msg, "date_7", "11 de Abril, 2019"), _defineProperty(_msg, "days_remaining", "Dias restantes"), _defineProperty(_msg, "deposit", "Depósito"), _defineProperty(_msg, "disclaimer", "Aviso Legal"), _defineProperty(_msg, "documentation", "Documentação"), _defineProperty(_msg, "expire_in", "Expirar em"), _defineProperty(_msg, "expired", "Expirado"), _defineProperty(_msg, "earn_on_referrals", "Ganhe com Indicados"), _defineProperty(_msg, "earn_bonus_tooltip", "Bónus ganhos com o programa de Indicados."), _defineProperty(_msg, "email", "E-Mail"), _defineProperty(_msg, "equals", "Equivalente"), _defineProperty(_msg, "expired", "Expirado"), _defineProperty(_msg, "export_csv", "Exportar CVS"), _defineProperty(_msg, "ends", "Termina"), _defineProperty(_msg, "explorer", "Explorador"), _defineProperty(_msg, "equivalent", "Equivalente"), _defineProperty(_msg, "equivalent_to", "Equivalente a"), _defineProperty(_msg, "expired_pin", "Pin expirado"), _defineProperty(_msg, "enable_2fa", "Activar 2FA"), _defineProperty(_msg, "eth_contract_message", "Não envie Ether usando um Smart Contract"), _defineProperty(_msg, "clicl_expand", "Click para expandir"), _defineProperty(_msg, "expand_chart", "Expandir gráfico"), _defineProperty(_msg, "estimated_info_modal_equivalent", "Valor estimado com base na troca Tether com outras moedas"), _defineProperty(_msg, "error", "Erro"), _defineProperty(_msg, "error_create_address", "Erro ao criar o endereço, tente mais tarde"), _defineProperty(_msg, "error_redeem", "Houve um erro com o seu pedido."), _defineProperty(_msg, "error_redeem_amount", "Verifique se tem saldo suficiente disponível e se o valor solicitado está acima do mínimo."), _defineProperty(_msg, "error_redeem_amount_no_funds", "Não possui fundos suficientes desbloqueados para realizar esta operação"), _defineProperty(_msg, "error_redeem_amount_below_min", "A quantia DEVE estar acima do mínimo exigido."), _defineProperty(_msg, "error_redeem_address", "Certifique-se que está a usar um endereço de BTC válido."), _defineProperty(_msg, "error_withdraw_address", "Certifique-se que está a usar um endereço de BLUE válido."), _defineProperty(_msg, "error_redeem_confirm", "Ocorreu um erro, verifique os campos."), _defineProperty(_msg, "error_internal_member_not_found", "ID do usuário não encontrado"), _defineProperty(_msg, "error_pool_avatar", "Avatar ja existente."), _defineProperty(_msg, "error_pool_avatar_select", "Você precisa escolher um nome e ícone de avatar."), _defineProperty(_msg, "faq", "FAQ"), _defineProperty(_msg, "fee", "Taxa | Taxas"), _defineProperty(_msg, "fees_minimums", "Taxas & Mínimos"), _defineProperty(_msg, "forgot_password", "Esqueceu-se da palavra-passe"), _defineProperty(_msg, "forgot_userid", "Esqueceu-se do ID de utilizador"), _defineProperty(_msg, "fees_minimum_amount", "Taxa é de 2 USDT do valor, com um mínimo de 2 USDT"), _defineProperty(_msg, "fee_1dot5", "Taxa 1.5%"), _defineProperty(_msg, "fee_2dot5", "Taxa 2.5%"), _defineProperty(_msg, "fee_4", "Taxa 4%"), _defineProperty(_msg, "fee_6", "Taxa 6%"), _defineProperty(_msg, "failed", "falhou"), _defineProperty(_msg, "fund_in_maintenance", "O nosso sistema está em manutenção, por favor tente a sua operação mais tarde."), _defineProperty(_msg, "fill_form_boleto", "Preencha o formulário para gerar a guia de pagamento"), _defineProperty(_msg, "fill_form", "Preencha o formulário"), _defineProperty(_msg, "fact_sheet", "Ficha informativa"), _defineProperty(_msg, "finish_Vote", "Concluir votação"), _defineProperty(_msg, "form_error_fields", "Todos os campos são obrigatorios!"), _defineProperty(_msg, "found_member", "Membro encontrado"), _defineProperty(_msg, "fee_info_redeem_one", "A taxa é "), _defineProperty(_msg, "fee_info_redeem_two", "de valor, com um mínimo de"), _defineProperty(_msg, "fee_redeem_wave_info", "A taxa é de 2 USDT para resgates abaixo de 50 USDT."), _defineProperty(_msg, "error_xgateway", "Nossa rede está enfrentando problemas com a cripto selecionada. Por favor, tente novamente em alguns minutos."), _defineProperty(_msg, "get_pin", "Obter pin"), _defineProperty(_msg, "global_search", "Pesquisa global"), _defineProperty(_msg, "generate_slips", "Gerar guia de pagamento"), _defineProperty(_msg, "g_l", "G/P"), _defineProperty(_msg, "generating_tokens", "Gerando tokens, por favor aguarde"), _defineProperty(_msg, "help", "Ajuda"), _defineProperty(_msg, "history", "Histórico"), _defineProperty(_msg, "hypothetical_portfolio", "Componentes hipotéticos sujeitos a alterações."), _defineProperty(_msg, "home", "Página Inicial"), _defineProperty(_msg, "here", "aqui"), _defineProperty(_msg, "how_vote", "Como votar?"), _defineProperty(_msg, "header_referral", "Alguém te indicou?"), _defineProperty(_msg, "how_it_works", "<a href=https://youtu.be/D8P1_01-uF4 target=_blank>Como funciona?</a>"), _defineProperty(_msg, "input_usdt_address", "Insira o address de USDT"), _defineProperty(_msg, "input_blue_amount", "Insira a quantidade de BLUE"), _defineProperty(_msg, "input_amount_redeem", "Insira a quantidade de BLUE que deseja resgatar."), _defineProperty(_msg, "input_amount_withdraw", "Insira a quantidade de BLUE que deseja levantar."), _defineProperty(_msg, "input_amount_transfer", "Insira a quantidade de BLUE que deseja transferir para outra conta"), _defineProperty(_msg, "info_redeem_step_3", "Para sua segurança digite o PIN e o 2fa."), _defineProperty(_msg, "info_redeem_address_step_4", "Endereço: "), _defineProperty(_msg, "info_redeem_email_step_4", "Você receberá todos os detalhes no seu e-mail."), _defineProperty(_msg, "info_redeem_step_4", "O processo será concluído hoje."), _defineProperty(_msg, "info_redeem_step_5", "O processo levará 3 dias úteis."), _defineProperty(_msg, "info_withdraw_step_4", "Aguarde até que a sua transacção seja processada pela blockchain."), _defineProperty(_msg, "info_2fa_tip", "Como medida de segurança, você deve primeiro habilitar o 2FA para transferir ou resgatar seus tokens."), _defineProperty(_msg, "inform_the_amount_bitcoin_address", "Informe o valor e o seu endereço Bitcoin"), _defineProperty(_msg, "inform_the_amount_blu_tag", "Informe a quantiade e o Endereço BLUE"), _defineProperty(_msg, "inform_the_amount_user_id", "Informe a quantidade BLUE e o ID do usuário"), _defineProperty(_msg, "internal_transfer", "Transferência interna"), _defineProperty(_msg, "internal_sub", "Transferência Interna é uma operação que permite enviar BLUE para outro usuário dentro da plataforma Blue."), _defineProperty(_msg, "internal_steps", "Etapas de transferência interna"), _defineProperty(_msg, "internal_action_send", "Enviado"), _defineProperty(_msg, "internal_action_receive", "Recebido"), _defineProperty(_msg, "info_usdt_blue_purchase", "Envie apenas USDT para este endereço. Você deve usar a Rede Tron (TRC20)."), _defineProperty(_msg, "input_valid_usdt", "Insira um endereço TRC20 de Tether (USDT) válido"), _defineProperty(_msg, "send_to_my_usdt", "Enviar para minha carteira Tether"), _defineProperty(_msg, "usdt_info_trc20", "Usamos a rede TRC20 da Tron. Certifique-se de inserir apenas um endereço TRC20."), _defineProperty(_msg, "input_text_USDT", "Insira o valor e o endereço USDT"), _defineProperty(_msg, "input_text_invalid_USDT", "Insira o valor de USDT que você deseja retirar."), _defineProperty(_msg, "insert_bitcoin_address", "Insira o endereço de Bicoin"), _defineProperty(_msg, "insert_quantity", "Insira a quantidade"), _defineProperty(_msg, "insert_your_pin", "Insira o seu pin"), _defineProperty(_msg, "invalid_address", "Endereço inválido"), _defineProperty(_msg, "invalid_amount", "Montante inválido"), _defineProperty(_msg, "invalid_credentials", "Credenciais inválidas."), _defineProperty(_msg, "invalid_destination_address", "Endereço de destino inválido."), _defineProperty(_msg, "invalid_phone", "Telefone inválido."), _defineProperty(_msg, "invalid_phone_country", "País não autorizado a usar nossos serviços."), _defineProperty(_msg, "invalid_email", "E-mail inválido"), _defineProperty(_msg, "invalid_has_accepted_terms", "Por favor, aceite os Termos e Condições."), _defineProperty(_msg, "invalid_is_aware_token_redemption", "Por favor marque a caixa de seleção acima."), _defineProperty(_msg, "invalid_input_amount_crypto", "Montante inválido"), _defineProperty(_msg, "invalid_is_not_usa_citizen", "Confirme que não é cidadão ou residente dos Estados Unidos."), _defineProperty(_msg, "invalid_is_not_china_citizen", "Confirme que não é cidadão ou residente em Hong Kong."), _defineProperty(_msg, "invalid_password", "Senha inválida."), _defineProperty(_msg, "invalid_password_confirmation", "Confirmação de senha inválida."), _defineProperty(_msg, "invalid_password_old", "Senha atual inválida"), _defineProperty(_msg, "invalid_pin", "PIN inválido."), _defineProperty(_msg, "invalid_referral_code", "Código de Indicados inválido."), _defineProperty(_msg, "invalid_userid", "Código de utilizador inválido."), _defineProperty(_msg, "invalid_user_id", "Código de utilizador ID inválido."), _defineProperty(_msg, "invalid_connetion", "Ocorreu um problema ao autenticar o seu pedido, verifique a sua ligação ou o seu nome utilizador."), _defineProperty(_msg, "invalid_2fa_code", "Código 2FA incorrecto"), _defineProperty(_msg, "insert_referral_code", "Inserir código de referência (Opcional)"), _defineProperty(_msg, "Invalidaddress", "Este endereço não é aceito."), _defineProperty(_msg, "language", "Língua | Línguas"), _defineProperty(_msg, "launch", "Lançamento"), _defineProperty(_msg, "launch_april", "Lançamento – ABRIL 2019"), _defineProperty(_msg, "legal", "Legal"), _defineProperty(_msg, "list", "Lista"), _defineProperty(_msg, "last_update", "Última atualização"), _defineProperty(_msg, "link_no_account", 'Se ainda não tem uma conta Stratum, <a href="https://auth.stratum.hk/signup.php?lang=en" target="_blank"> clique aqui </a> para criar uma.'), _defineProperty(_msg, "loading_balance", "Carregando saldo da conta..."), _defineProperty(_msg, "live_price", "Preço ao vivo"), _defineProperty(_msg, "last_month_blue_total", "Blue Pool pagou um total de"), _defineProperty(_msg, "en", "EN | Inglês"), _defineProperty(_msg, "es", "ES | Espanhol"), _defineProperty(_msg, "pt", "PT | Português"), _defineProperty(_msg, "loading", "A carregar"), _defineProperty(_msg, "loading_data", "A carregar os dados da compra"), _defineProperty(_msg, "load_fee", "Taxa de carregamento"), _defineProperty(_msg, "login", "Autenticação"), _defineProperty(_msg, "login_successful", "Autenticado com sucesso"), _defineProperty(_msg, "login_here", "Autenticação Aqui"), _defineProperty(_msg, "logout", "Sair"), _defineProperty(_msg, "latest", "Mais recentes"), _defineProperty(_msg, "minimum", "Mínimo"), _defineProperty(_msg, "money", "Dinheiro"), _defineProperty(_msg, "masternodes", "masternodes"), _defineProperty(_msg, "make_new_redeem", "Faça um novo resgate"), _defineProperty(_msg, "methodology", "Metodologia"), _defineProperty(_msg, "min_amount_is", "O montante mínimo é"), _defineProperty(_msg, "member_not_found", "Membro não encontrado."), _defineProperty(_msg, "make_sure_address", "Certifique-se de usar um endereço BLUE válido."), _defineProperty(_msg, "my_balances", "Meus saldos"), _defineProperty(_msg, "my_balance", "Meus saldo"), _defineProperty(_msg, "my_total_value", "Meu saldo total"), _defineProperty(_msg, "my_gain_loss", "Meu Ganho/Perda"), _defineProperty(_msg, "minimum_purchase_USDT", "O saldo mínimo exigido é de 20 USDT. Aumente seu saldo."), _defineProperty(_msg, "minting", "Criando"), _defineProperty(_msg, "member_benefits", "Benefícios de associação"), _defineProperty(_msg, "my", "Meu"), _defineProperty(_msg, "name", "Nome"), _defineProperty(_msg, "name_optional", "Nome (Opcional)"), _defineProperty(_msg, "next", "Próximo | Prox"), _defineProperty(_msg, "no_data_found", "Nenhum dado encontrado"), _defineProperty(_msg, "no_rec_transactions_found", "Nenhuma transacção encontrada."), _defineProperty(_msg, "not_enough_balance", "Sem saldo suficiente"), _defineProperty(_msg, "not_member_yet", "Ainda não é membro?"), _defineProperty(_msg, "next_step", "Passo seguinte"), _defineProperty(_msg, "number", "Número"), _defineProperty(_msg, "network", "Rede"), _defineProperty(_msg, "notification", "Notificação"), _defineProperty(_msg, "only_one_day", "Apenas 1 resgate por dia permitido."), _defineProperty(_msg, "of", "do"), _defineProperty(_msg, "opens", "Abrir"), _defineProperty(_msg, "open_account", "Abrir Conta"), _defineProperty(_msg, "operations", "operações"), _defineProperty(_msg, "Operations", "Operações"), _defineProperty(_msg, "or", "ou"), _defineProperty(_msg, "one_token_equivalence", "Uma equivalência BLUE em"), _defineProperty(_msg, "optional", "Opcional"), _defineProperty(_msg, "otc_info", "Forneça as informações abaixo. Nosso balcão de atendimento OTC entrará em contato para ajudá-lo com sua compra."), _defineProperty(_msg, "otc_thank_msg", "Nosso balcão OTC entrará em contato com você em breve."), _defineProperty(_msg, "otc_purcahse_info", "Informação da compra"), _defineProperty(_msg, "otc_purcahse", "compra OTC"), _defineProperty(_msg, "otc_purchase_info_to_user", "Sua compra está sendo processada por nossa mesa OTC, por favor aguarde."), _defineProperty(_msg, "past_2fa", "Insira aqui o código 2FA com 6 dígitos"), _defineProperty(_msg, "pin_already_been_used", "O Pin já foi usado"), _defineProperty(_msg, "price_graph", "Gráfico de Preços"), _defineProperty(_msg, "portfolio_value", "Valor da Cripto-Cesta"), _defineProperty(_msg, "pay_slip_info", "Para receber os seus BLUE, pague a guia de pagamento"), _defineProperty(_msg, "please_chose_two_coins", "Escolha 2 criptomoedas."), _defineProperty(_msg, "phone_optional", "Celular"), _defineProperty(_msg, "phone_code", "Código do país"), _defineProperty(_msg, "phone", "Telemóvel"), _defineProperty(_msg, "purchase_success", "Sua compra foi criada para o usuário."), _defineProperty(_msg, "price_history_list", "Histórico de preços"), _defineProperty(_msg, "closing_price", "Preço final"), _defineProperty(_msg, "pay_with_USDT", "Pague com o saldo USDT"), _defineProperty(_msg, "change_password", "Alterar senha"), _defineProperty(_msg, "current_password", "Senha atual"), _defineProperty(_msg, "confirm_password", "Confirme a senha"), _defineProperty(_msg, "new_password", "Nova senha"), _defineProperty(_msg, "password", "Senha"), _defineProperty(_msg, "password_create", "Criar nova senha"), _defineProperty(_msg, "password_changed", "A senha foi alterada"), _defineProperty(_msg, "password_requirements", "A senha deve conter 8 caracteres, 1 caractere especial (-_+=,<.>;:^~@#$%&*), 1 letra minúscula, 1 letra maiúscula e 1 número."), _defineProperty(_msg, "recover_password", "Recuperar Senha"), _defineProperty(_msg, "recover_userid", "Recuperar ID de Utilizador"), _defineProperty(_msg, "password_suggestion", "Utilize a senha sugerida pela Blue"), _defineProperty(_msg, "confirm_password_error", "Confirme sua alteração de senha."), _defineProperty(_msg, "wrong_password_confirmation", "Confirmação de senha errada"), _defineProperty(_msg, "phone_already_registered", "Este telefone já está cadastrado."), _defineProperty(_msg, "email_already_registered", "Este e-mail já está cadastrado."), _defineProperty(_msg, "pay_with", "Pague com cripto"), _defineProperty(_msg, "perc_portfolio", "% da disponibilização da cesta-Cripto"), _defineProperty(_msg, "phase", "Fase | Fases"), _defineProperty(_msg, "portfolio", "Cesta-Cripto"), _defineProperty(_msg, "price", "Preço"), _defineProperty(_msg, "pre_sale", "Pré-Venda"), _defineProperty(_msg, "preferences", "Preferências"), _defineProperty(_msg, "preferred_language", "Língua preferida"), _defineProperty(_msg, "previous", "Anterior | Anterior"), _defineProperty(_msg, "privacy_policy", "Política de Privacidade"), _defineProperty(_msg, "purchase", "Compra"), _defineProperty(_msg, "performance", "Evolução dos Preços"), _defineProperty(_msg, "please_verify_information", "Verifique as informações abaixo com precisão."), _defineProperty(_msg, "quantity", "Quantidade"), _defineProperty(_msg, "receive_calculator_text", "O cálculo exclui quaisquer taxas impostas pela sua carteira e pela rede. Aconselhamos a depositar um pouco mais do que a quantia desejada."), _defineProperty(_msg, "receive", "Receber"), _defineProperty(_msg, "receiving_email", "A receber e-mail"), _defineProperty(_msg, "recent_transactions", "Transacções recentes"), _defineProperty(_msg, "redeem", "Resgate"), _defineProperty(_msg, "referral_award", "Prémio de Indicados"), _defineProperty(_msg, "referrals", "Indicados"), _defineProperty(_msg, "referral_code", "Código de Indicados"), _defineProperty(_msg, "report", "Relatório trimestral"), _defineProperty(_msg, "report_link_text", "Lançamento"), _defineProperty(_msg, "report_link_download_quarter", "Baixe o relatório trimestral de outubro a dezembro de 2022 (T4 de 2022)"), _defineProperty(_msg, "report_link_span", "Os relatórios são publicados na primeira semana de cada trimestre."), _defineProperty(_msg, "redemptions", "Resgates"), _defineProperty(_msg, "redemption", "Resgate"), _defineProperty(_msg, "redemption_info", "<strong>Resgates sem taxas:</strong> Qualifica-se para resgate até <strong>50 BLUES</strong> sem taxa. O valor deve valer mais do que <strong>1000 TUSD</strong>."), _defineProperty(_msg, "redeem_pin", "PIN de entrada"), _defineProperty(_msg, "redeem_2fa", "2FA de entrada"), _defineProperty(_msg, "redeem_not_allowed_today", "Os resgates estão disponíveis às quartas-feiras, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_1", "Os resgates estão disponíveis às segundas-feiras, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_2", "Os resgates estão disponíveis às terças-feiras, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_3", "Os resgates estão disponíveis às quartas-feiras, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_4", "Os resgates estão disponíveis às quintas-feiras, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_5", "Os resgates estão disponíveis às sextas-feiras, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_6", "Os resgates estão disponíveis aos sábados, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_not_allowed_today_7", "Os resgates estão disponíveis aos domingos, das 00h to 17h (UTC -3)."), _defineProperty(_msg, "redeem_deleted_success", "O resgate foi cancelado com sucesso!"), _defineProperty(_msg, "redeem_deleted_error", "Há algo errado, tente novamente mais tarde."), _defineProperty(_msg, "reedeem_2fa_text", "<p>O que \xE9 o 2FA e por que o devo usar?</p>\n            <p>O 2FA significa a Autentica\xE7\xE3o de 2 Factores. Ele protege a sua conta combinando algo que voc\xEA conhece (sua senha), com algo que voc\xEA tem (como o seu telem\xF3vel ou a sua chave de seguran\xE7a).</p>\n            <p>Depois de configurar o 2FA no seu telefone, voc\xEA ver\xE1 um c\xF3digo de acesso que muda constantemente. Voc\xEA deve usar o c\xF3digo de acesso 2FA sempre que resgatar tokens; no entanto, s\xF3 precisa de instalar o 2FA uma vez.</p>\n            <p>Caso ainda n\xE3o tenha um autenticador, por favor continue a utilizar um dos itens abaixo:</p>\n            <a href=https://www.google.com/landing/2step/#tab=how-it-works target=\"_blank\">Google Authenticator</a>\n            <a href=\" https://authy.com/download/\" target=\"_blank\">Authy Authenticator</a>\n        "), _defineProperty(_msg, "tutorial_tittle", "<p style=\"color:#424b7d\">Como depositar {coin}?</p>"), _defineProperty(_msg, "tutorial_deposit", "\n        <p>1. Crie um endere\xE7o de dep\xF3sito BLUE;</p>\n        <p>2. Localize o formul\xE1rio \u201CEnviar\u201D na carteira externa;</p>\n        <p>3. Digitalize ou copie o endere\xE7o do token BLUE nesse formul\xE1rio.</p><br/>\n        <b>Nota:</b>\n        <span>Dep\xF3sitos BLUE s\xE3o cobrados com uma taxa de rede de 6%, paga pelo remetente. <a href=\"https://bluetoken.io/fees\" target=\"_blank\" style=\"margin-top:0px; display: contents;\">Tarifas.</a></span>\n    "), _defineProperty(_msg, "tutorial_deposit_usdt", "\n    <p>1. Crie um endere\xE7o de dep\xF3sito Tether (USDT);</p>\n    <p>2. Localize o formul\xE1rio \u201CEnviar\u201D na carteira externa;</p>\n    <p>3. Digitalize ou copie o endere\xE7o do Tether (USDT) nesse formul\xE1rio.</p><br/>\n    <b>Nota:</b>\n    <span>Certifique-se de selecionar a rede Tron (TRC20).</span>\n"), _defineProperty(_msg, "tutorial_tittle_withdraw", "<p style=\"color:#424b7d\">Como adicionar Blue Token em carteiras externas?</p>"), _defineProperty(_msg, "tutorial_withdraw", "\n        <p>1. Selecione Binance Smart Chain (BSC) na rede de carteira externa;</p>\n        <p>2. Copie este endere\xE7o de contrato de token Blue e importe na carteira externa;</p>\n    "), _defineProperty(_msg, "tutorial_withdraw_pt2", "\n        <b>Note:</b>\n        <p>- A Blue Token n\xE3o assume responsabilidade por opera\xE7\xF5es que ocorrem em plataformas de terceiros.</p>\n        <p>- Todas as transa\xE7\xF5es originadas fora de nossa plataforma s\xE3o cobradas uma taxa de rede de 6%. <a href=\"https://bluetoken.io/fees\" target=\"_blank\" style=\"margin-top:0px; display: contents;\">Tarifas.</a></p>\n    "), _defineProperty(_msg, "cancel_redeem", "Cancelar Resgate"), _defineProperty(_msg, "retry", "Repetir"), _defineProperty(_msg, "required_fields", "Campos obrigatórios"), _defineProperty(_msg, "recipients_user_id", "ID de usuário do destinatário."), _defineProperty(_msg, "required_fields_amount_uid", "Quantidade e UID são necessários para esta ação."), _defineProperty(_msg, "staking_rewards", "Recompensas de Staking"), _defineProperty(_msg, "redeeming", "Resgatando"), _defineProperty(_msg, "receiving", "Recebendo"), _defineProperty(_msg, "referral", "Referência"), _defineProperty(_msg, "referral_text_1", "Quando você indica pessoas para comprarem BLUE, você recebe uma recompensa e essas pessoas recebem um prémio, pago em BLUE!"), _defineProperty(_msg, "referral_text_2", "Dê o link ou o código de indicados aos seus familiares e amigos. As recompensas e os bónus são ilimitados. Não importa quantas vezes os seus indicados comprem BLUE. Sempre que eles comprarem, você receberá uma recompensa e eles receberão um bónus."), _defineProperty(_msg, "referral_text_3", "Para ativar o seu código de indicados, primeiro tem de comprar BLUE. Depois de comprar os BLUE, volte a esta página e comece a utilizar o seu código de indicados."), _defineProperty(_msg, "review_your_purchase", "Reveja a Sua Compra"), _defineProperty(_msg, "reward", "Recompensa"), _defineProperty(_msg, "rows_per_page", "Linhas por página"), _defineProperty(_msg, "redeemed_value", "Valor resgatado"), _defineProperty(_msg, "save", "Salvar"), _defineProperty(_msg, "send", "Enviar"), _defineProperty(_msg, "settings", "Definições"), _defineProperty(_msg, "header_settings", "Configurações"), _defineProperty(_msg, "signup", "Inscreva-se"), _defineProperty(_msg, "something_went_wrong", "Algo correu mal"), _defineProperty(_msg, "subtotal", "Subtotal"), _defineProperty(_msg, "send_to_btc_adress", "Endereço de destino"), _defineProperty(_msg, "send_to_btc_adress_destination", "Endereço de destino Bitcoin"), _defineProperty(_msg, "send_to_blu_adress", "<strong>BLUE</strong> Endereço de destino"), _defineProperty(_msg, "send_to_blu_adress_on", "<strong>BLUE</strong> Endereço de destino activado"), _defineProperty(_msg, "allowed_wallets", "*Carteiras aceitas:"), _defineProperty(_msg, "step_1_withdraw_blue", "1. Selecione a carteira desejada para sacar."), _defineProperty(_msg, "step_2_withdraw_blue", "2. Clique para copiar o endereço do contrato do Blue Token na Binance Smart Chain:"), _defineProperty(_msg, "step_3_withdraw_blue", '3. Clique para importar automaticamente o token do Blue na <a href="https://bit.ly/3wMClbk" target="_blank">Metamask</a>'), _defineProperty(_msg, "step_3_withdraw_blue_p2", "siga as instruções para adicionar manualmente o token do Blue na: "), _defineProperty(_msg, "or", "ou"), _defineProperty(_msg, "contract_address", "0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2"), _defineProperty(_msg, "success", "Sucesso"), _defineProperty(_msg, "success_create_wallet", "Endereço criado com sucesso"), _defineProperty(_msg, "session_expired", "Sessão expirada. Por favor faça login novamente"), _defineProperty(_msg, "services", "Serviços"), _defineProperty(_msg, "staking_APY", "Estacando APY"), _defineProperty(_msg, "submit", "Enviar"), _defineProperty(_msg, "months", {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro"
  }), _defineProperty(_msg, "pool", "Pool"), _defineProperty(_msg, "join_pool", "Registre-se e ganhe"), _defineProperty(_msg, "monthly_rewards", "Recompensas do Pool de {month}"), _defineProperty(_msg, "my_rewards", "Estimativa das minhas recompensas"), _defineProperty(_msg, "qualification_status", "Status de qualificação"), _defineProperty(_msg, "need_to_qualify", "Precisa de"), _defineProperty(_msg, "to_qualify", "para se qualificar"), _defineProperty(_msg, "calculating", "calculando..."), _defineProperty(_msg, "posted_soon", "O Pool está sendo calculado e será postado em breve."), _defineProperty(_msg, "nobody_qualified", "Ninguém se qualificou ainda para ganhar as recompensas do pool. Seja o primeiro e ganhe!"), _defineProperty(_msg, "leaderboard", "Tabela dos líderes"), _defineProperty(_msg, "last_month_winners", "Vencedores do mês passado"), _defineProperty(_msg, "referral_volume", "Volume de indicaçoes"), _defineProperty(_msg, "reward_pool", "% de Recompensa"), _defineProperty(_msg, "estimated_pool", "Estimativa"), _defineProperty(_msg, "view_all", "Ver tudo"), _defineProperty(_msg, "modal_pool_title", "Recompensas da Blue Pool"), _defineProperty(_msg, "modal_pool_text", "Todos os meses, um pool é criado para recompensá-lo pelas compras de sua indicação. Os participantes que acumularem 1 token BLUE ou mais em compras de referência ganham automaticamente uma parte do pool. <a href=https://youtu.be/D8P1_01-uF4 target=_blank style='width:auto'>Assista o tutorial</a>"), _defineProperty(_msg, "modal_pool_important", "Importante"), _defineProperty(_msg, "modal_pool_text2", "Para participar, você deve primeiro cria seu avatar."), _defineProperty(_msg, "modal_pool_text3", "Seu avatar não pode ser mudado no futuro."), _defineProperty(_msg, "modal_pool_nick", "Crie um apelido"), _defineProperty(_msg, "modal_pool_nick_span", "Para proteger sua privacidade, aconselhamos que não use seu nome verdadeiro."), _defineProperty(_msg, "modal_pool_avatar", "Selecione Avatar"), _defineProperty(_msg, "modal_pool_btn", "PARTICIPAR"), _defineProperty(_msg, "modal_pool_welcome", "Bem-vindo à Blue Pool"), _defineProperty(_msg, "modal_pool_span", "Quando suas referências acumularem 1 BLUE em compras, seu avatar vai mostrar na tabela dos líderes, garantindo uma parte na pool."), _defineProperty(_msg, "modal_pool_span2", "Quanto mais eles comprarem, maior será sua parte!"), _defineProperty(_msg, "modal_pool_referral", "Seu ID de indicação:"), _defineProperty(_msg, "modal_pool_referral_link", "Seu link de indicação"), _defineProperty(_msg, "modal_pool_close", "FECHAR"), _defineProperty(_msg, "street_name", "Nome da Rua"), _defineProperty(_msg, "state", "Distrito"), _defineProperty(_msg, "select_partner", "Selecione um parceiro"), _defineProperty(_msg, "start_withdrawal", "Começar Levantamento"), _defineProperty(_msg, "start_internal_transfer", "Iniciar transferencia interna"), _defineProperty(_msg, "send_exactly", "Enviar exatamente para o seguinte endereço:"), _defineProperty(_msg, "seller_buy", "Compre como membro pretendido, bastando fornecer o UID e a quantidade."), _defineProperty(_msg, "sector", "Setor"), _defineProperty(_msg, "step_amount", "Montante"), _defineProperty(_msg, "step_recipient", "Recebedor"), _defineProperty(_msg, "step_verification", "Verificação"), _defineProperty(_msg, "step_authentication", "Autenticação"), _defineProperty(_msg, "status_new", "Novo"), _defineProperty(_msg, "status_waiting", "A aguardar"), _defineProperty(_msg, "status_processing", "A processar"), _defineProperty(_msg, "status_done", "Terminado"), _defineProperty(_msg, "status_failed", "Falhou"), _defineProperty(_msg, "status_cancelled", "Cancelado"), _defineProperty(_msg, "status_denied", "Negado"), _defineProperty(_msg, "status_expired", "Expirado"), _defineProperty(_msg, "status_queued", "A aguardar vez"), _defineProperty(_msg, "tag", "ID da tag"), _defineProperty(_msg, "tag_important", "Certifique-se de definir o correcto ID da tag, para garantir que o valor seja enviado para o seu endereço."), _defineProperty(_msg, "terms_and_conditions", "Termos e Condições"), _defineProperty(_msg, "tokens_go_on_sale", "BLUE à venda"), _defineProperty(_msg, "token_presale", "Pré-venda"), _defineProperty(_msg, "token_distribution", "Distribuição"), _defineProperty(_msg, "total", "Total"), _defineProperty(_msg, "total_debit", "Débito Total"), _defineProperty(_msg, "total_received", "Total Recebido"), _defineProperty(_msg, "total_to_pay", "Total a pagar"), _defineProperty(_msg, "total_to_transfer", "Total a enviar"), _defineProperty(_msg, "transaction", "Transacção | Transacções"), _defineProperty(_msg, "transaction_completed", "Transacção Concluída"), _defineProperty(_msg, "transaction_details", "Detalhes da Transacção"), _defineProperty(_msg, "type", "Tipo"), _defineProperty(_msg, "token", "Token"), _defineProperty(_msg, "token_info", "Informação"), _defineProperty(_msg, "token_supply", "Fornecimento"), _defineProperty(_msg, "token_nav", "NAV"), _defineProperty(_msg, "fund_value", "Valor do Fundo"), _defineProperty(_msg, "token_price", "Preço"), _defineProperty(_msg, "transaction_with_wrong_status", "Transacção com status incorrecto"), _defineProperty(_msg, "trade_not_found", "Resgate não encontrado. Comece de novo."), _defineProperty(_msg, "transfers", "Transferências"), _defineProperty(_msg, "total_redeem", "Total em BLUE"), _defineProperty(_msg, "total_redeem_USDT", "Total em USDT"), _defineProperty(_msg, "total_plus_block", "Disponível + bloqueado"), _defineProperty(_msg, "token_supply_equivalence", "Equivalência de fornecimento de token em"), _defineProperty(_msg, "transaction_failed_step", "A transacção falhou no passo {step}, se tiver alguma dúvida, entre em contacto com o suporte em support@bluetoken.io"), _defineProperty(_msg, "transfer_blu_stx", "Envie os seus tokens BLUE para <span class='custom_highlight'>StratumX.io</span>. Use para trocar BLUE por outras criptos."), _defineProperty(_msg, "transfer_blu_stratum", "Envie os seus tokens BLUE para o SmartWallet. Use para vender BLUE, pagar contas e outros serviços."), _defineProperty(_msg, "transfer_blu_stratum_withdraw_sw", "Envie seus tokens BLUE a Stratum Advanced Wallet e desfrute de muitos benefícios."), _defineProperty(_msg, "tag_text", "O TAG é um identificador exclusivo para o reconhecer e disponibilizado pelo parceiro de levantamento. O TAG está localizado na página de depósito da carteira do parceiro."), _defineProperty(_msg, "table_failed_1", "* Pedidos incompletos"), _defineProperty(_msg, "table_failed_2", "* Todos os pedidos incompletos serão cancelados automáticamente."), _defineProperty(_msg, "thank_you", "Obrigado"), _defineProperty(_msg, "temporarily_unavailable", "Temporariamente indisponível."), _defineProperty(_msg, "tether_info", "Envie através da Rede Tron (TRC20), ou use seu saldo disponível."), _defineProperty(_msg, "token_type", "Tipo de token"), _defineProperty(_msg, "today", "Hoje"), _defineProperty(_msg, "bep20", "BEP20 (Binance Smart Chain)"), _defineProperty(_msg, "decentralized_ex", "Decentralized Exchanges (DEX)"), _defineProperty(_msg, "metaverse", "Metaverso"), _defineProperty(_msg, "lending", "Empréstimos"), _defineProperty(_msg, "payments", "Pagamentos"), _defineProperty(_msg, "native", "Nativo"), _defineProperty(_msg, "erc20", "ERC20 (Ethereum)"), _defineProperty(_msg, "todays_market", "Mercado de hoje"), _defineProperty(_msg, "token_supply", "Fornecimento de tokens"), _defineProperty(_msg, "tks_your_payment", "Obrigado pelo seu pagamento."), _defineProperty(_msg, "wait_create_tokens", "Aguarde alguns minutos enquanto criamos seu(s) token(s)."), _defineProperty(_msg, "BLU", "BLUE"), _defineProperty(_msg, "BTC", "Bitcoin"), _defineProperty(_msg, "ETH", "Ethereum"), _defineProperty(_msg, "TUSD", "TrueUSD"), _defineProperty(_msg, "createdAt", "Criado a"), _defineProperty(_msg, "updatedAt", "Atualizado a"), _defineProperty(_msg, "status", "Status"), _defineProperty(_msg, "done", "Concluído"), _defineProperty(_msg, "pre_done", "Concluído"), _defineProperty(_msg, "failed", "Falhou"), _defineProperty(_msg, "new", "Novo"), _defineProperty(_msg, "processing", "A Processar"), _defineProperty(_msg, "txid", "TX ID"), _defineProperty(_msg, "start_date", "Data de Início"), _defineProperty(_msg, "end_date", "Data Final"), _defineProperty(_msg, "use_all", "Usar todos"), _defineProperty(_msg, "userid", "ID de utilizador"), _defineProperty(_msg, "user", "Utilizador"), _defineProperty(_msg, "use", "Usar"), _defineProperty(_msg, "user_id_inportant", "Tenha atenção ao inserir o ID de usuário, assim como a quantidade que você quer enviar para a conta correta"), _defineProperty(_msg, "value", "Valor"), _defineProperty(_msg, "view_all_transactions", "Ver todas as transações"), _defineProperty(_msg, "view_reward_bonus_schedule", "Visualizar agendamento de recompensas e bónus"), _defineProperty(_msg, "view_status", "Exibir status"), _defineProperty(_msg, "voting_info_1", "É hora de votar em 2 criptomoedas para adicionar (ou manter) como parte da cesta BLUE para o primeiro trimestre (T1) de 2023."), _defineProperty(_msg, "voting_info_2", "Ultimamente, os reguladores governamentais procuram empresas de criptomoedas que oferecem retornos sobre arbitragem e atividades semelhantes. A conformidade com os reguladores comprometeria a privacidade dos nossos utilizadores. Como sabe, aqui na Stratum, a privacidade e segurança dos nossos utilizadores sempre foram a nossa principal preocupação. Decidimos então remover essas atividades do nosso portfólio para evitar a conformidade e basear o BLUE no valor de 14 criptomoedas em vez de 12."), _defineProperty(_msg, "voting_info_3", "Basta clicar no botão abaixo e selecionar 2 criptomoedas. Votaçao não é obrigatória mas incentivamos. Acreditamos que qualquer uma das opções fornecidas será uma adição promissora à cesta. Contaremos os votos de acordo com o número de BLUE em sua conta (cada BLUE completo em sua conta dá a você 1 voto). A votação estará disponível até 30 de Dezembro às 23:59h (UTC -3)."), _defineProperty(_msg, "voting_info_4", "Adicionaremos mais detalhes sobre essa alteração num relatório atualizado no nosso site, como a frequência de votação e a sua futura implementação usando o blockchain."), _defineProperty(_msg, "vote_bellow", "Vote abaixo"), _defineProperty(_msg, "vote_success", "Votado com sucesso, obrigado!"), _defineProperty(_msg, "voting_survey", "Pesquisa de votação"), _defineProperty(_msg, "verify_step", "Verifique seu resgate"), _defineProperty(_msg, "view_other_currencies", "Ver outras moedas"), _defineProperty(_msg, "verify_your_withdraw", "Verifique sua retirada"), _defineProperty(_msg, "waiting", "A Processar"), _defineProperty(_msg, "welcome", "Bem-vindo"), _defineProperty(_msg, "with", "com"), _defineProperty(_msg, "withdraw", "Levantamento"), _defineProperty(_msg, "withdraws", "Levantamentos"), _defineProperty(_msg, "withdraw_amount", "Valor de levantamento"), _defineProperty(_msg, "withdraw_transfer", "Levantamento"), _defineProperty(_msg, "was_referred", "Peça ao seu amigo o código de indicação para ganhar recompensas, ou deixe em branco para doar para Bitgive e B4H."), _defineProperty(_msg, "waiting_for_aprove", "Em Ordem"), _defineProperty(_msg, "waiting_aprove_info", "Os fundos só ficam disponíveis 60 dias após cada compra que faça"), _defineProperty(_msg, "w", "W"), _defineProperty(_msg, "withdraw_sub", "O levantamento é uma operação que permite enviar BLUE para um endereço de carteira BLUE válido e compatível."), _defineProperty(_msg, "withdraw_sub_usdt", "O levantamento \xE9 uma opera\xE7\xE3o que permite enviar USDT para um e endere\xE7o de carteira USDT compat\xEDvel."), _defineProperty(_msg, "withdraw_network_fee", "Para saques existe o network fee de 0.0005 btc"), _defineProperty(_msg, "we_accet", "Nós aceitamos"), _defineProperty(_msg, "why_change", "Porquê a mudança"), _defineProperty(_msg, "white_paper", "Relatório"), _defineProperty(_msg, "withdrawal_steps", "Etapas de levantamento"), _defineProperty(_msg, "withdrawal", "Levantamento"), _defineProperty(_msg, "withdrawing", "Retirada"), _defineProperty(_msg, "you_will_receive", "Você receberá"), _defineProperty(_msg, "your_email_shortly", "O seu E-mail deve chegar brevemente"), _defineProperty(_msg, "you_want_start_new_purchase", "Você está cancelando um pedido de depósito, se quiser fazer um novo, reinicie o fluxo de compra."), _defineProperty(_msg, "you_must_accpet_terms", "Você deve concordar com nossos termos e condições para continuar. Se você tiver alguma dúvida, entre em contato com support@bluetoken.io."), _defineProperty(_msg, "you_must_accpet_privacy", "Você deve concordar com a nossa política de privacidade para continuar. Se você tiver alguma dúvida, entre em contato com support@bluetoken.io."), _defineProperty(_msg, "yes", "Sim"), _defineProperty(_msg, "no", "Não"), _defineProperty(_msg, "beforeSendUnderTitle", "Selecione a quantidade de BLUE que deseja comprar. O pagamento tem de ser feito com cripto."), _defineProperty(_msg, "amount_in", "Montante em"), _defineProperty(_msg, "estimated_amount_in", "Montante estimado em"), _defineProperty(_msg, "important", "importante"), _defineProperty(_msg, "below_button_1", "- A quantidade de BLUE a ser creditada, depende da quantidade de criptos que vai receber. Esteja ciente de quaisquer taxas que o seu provedor de carteira pode cobrar pela transferência. Essas taxas diminuirão a quantidade de criptos e por consequência diminuirão também a quantidade de tokens."), _defineProperty(_msg, "below_button_2", "- Se a quantidade de BTC que recebemos estiver abaixo do mínimo exigido (0.0208 BTC), o seu BTC será adicionado a um saldo temporário, que você poderá usar num novo pedido. "), _defineProperty(_msg, "understand_and_agree", "Entendo que qualquer valor acima do mínimo enviado para o nosso endereço de pagamento, será automaticamente convertido em BLUE. "), _defineProperty(_msg, "i_understand", "Eu entendo"), _defineProperty(_msg, "understand_and_agree_button", "Eu entendo e Concordo"), _defineProperty(_msg, "understand_and_agree_warning", "O tempo de compra é entre as 9:00h e as 17:00h (GMT-3), de segunda-feira a sexta-feira. As transacções realizadas fora desse período serão processadas no dia seguinte."), _defineProperty(_msg, "waiting_deposit", "A aguardar depósito"), _defineProperty(_msg, "waiting_deposit_otc", "Aguardando confirma\xE7\xE3o de OTC"), _defineProperty(_msg, "transaction_details", "Detalhes da transacção"), _defineProperty(_msg, "transaction_failed_1", "A transacção falhou no passo"), _defineProperty(_msg, "transaction_failed_2", "Se tiver alguma dúvida, entre em contacto com o suporte em support@bluetoken.io"), _defineProperty(_msg, "temporary_balance", "Saldo Temporário"), _defineProperty(_msg, "temporary_balance_substracted", "Este saldo temporário é deduzido do valor total a ser enviado."), _defineProperty(_msg, "to_send", "A enviar"), _defineProperty(_msg, "to_receive", "A receber"), _defineProperty(_msg, "received", "Recebido"), _defineProperty(_msg, "expected", "esperado"), _defineProperty(_msg, "expected_amount_in", "Montante esperado em"), _defineProperty(_msg, "estimated_blu", "BLUE estimado"), _defineProperty(_msg, "estimated", "estimado"), _defineProperty(_msg, "earned_pool", "Recebido"), _defineProperty(_msg, "waiting_deposit_undertext", "O valor do BLUE será confirmado após a confirmação do pagamento na Blockchain."), _defineProperty(_msg, "processing_order", "Ordem de processamento"), _defineProperty(_msg, "confirmed_amoutn", "Montante confirmado"), _defineProperty(_msg, "follow_transaction_text", "Siga a Transacção"), _defineProperty(_msg, "check_transaction_status", "Verifique o status da sua operação"), _defineProperty(_msg, "new_operation", "Nova Operação"), _defineProperty(_msg, "order_created", "Ordem Criada"), _defineProperty(_msg, "confirmed_on_blockchain", "Confirmado na blockchain"), _defineProperty(_msg, "order_completed", "Ordem completa"), _defineProperty(_msg, "order_completed_info", "O seu BLUE está a ser criado. Você receberá um certificado por e-mail quando o processo estiver concluído."), _defineProperty(_msg, "order_completed_info_title", "Terminado"), _defineProperty(_msg, "temporary_balance_warning", "Lembre-se de que você tem um saldo temporário de transacções anteriores que será adicionado à sua transferência.."), _defineProperty(_msg, "send_btc_to_address", "Para receber os seus BLUE, envie a sua {coin} para este endereço"), _defineProperty(_msg, "purchase_confirmation", "Confirmação de Compra"), _defineProperty(_msg, "min", "min"), _defineProperty(_msg, "btc_sent", "BTC Confirmado"), _defineProperty(_msg, "blu_confirmed", "BLUE Confirmado"), _defineProperty(_msg, "minimum_amount_required", "O montante tem de estar acima do mínimo."), _defineProperty(_msg, "check_open_orders", "Verifique a ordem em aberto"), _defineProperty(_msg, "make_new_order", "Faça uma nova ordem"), _defineProperty(_msg, "if_no_order", "Se não aparecer nenhuma ordem por um longo período, por favor verifique se realmente fez a ordem. Se necessário, faça uma nova."), _defineProperty(_msg, "confirmed", "Confirmado"), _defineProperty(_msg, "waiting", "A aguardar"), _defineProperty(_msg, "action_blocked_purchase", "Neste momento o nosso sistema encontra-se em manutenção. Por favor tente fazer a sua compra mais tarde."), _defineProperty(_msg, "bktc_text", "O banco para Cripto permite que consiga comprar rapidamente Bitcoin."), _defineProperty(_msg, "bktc_text2", "Para prosseguir com a sua transacção, pague com a Fiat abaixo"), _defineProperty(_msg, "bktc_only_brazil", "Por favor tenha em atenção que este método de pagamento só deve ser utilizado por clientes brasileiros."), _defineProperty(_msg, "info_link_stratum_wallet", "Para comprar criptos aceda à sua SmartWallet."), _defineProperty(_msg, "select_coin_payment", "Selecione um Método de Pagamento"), _defineProperty(_msg, "your_id_is", "O seu ID é o código de 6 dígitos enviado para o seu e-mail na inscrição."), _defineProperty(_msg, "amount_too_small", "O montante é muito baixo. A compra mínima é de 100 TUSD."), _defineProperty(_msg, "aware_token_redeem", "Estou ciente que os tokens não podem ser transferidos até 60 dias após a compra."), _defineProperty(_msg, "click_here_phases", "Para mais detalhes sobre cada fase, clique aqui"), _defineProperty(_msg, "create_new_email_recommendation", "Para cada plataforma, recomendamos que crie um novo e-mail <span class=\"text_highlight\"> Este e-mail ser\xE1 usado para receber as suas informa\xE7\xF5es de login e outras comunica\xE7\xF5es internas.</span>"), _defineProperty(_msg, "current_presale_ends", "A fase atual de Pré.Venda 3, termina a 6 de Abril"), _defineProperty(_msg, "did_someone_referred", "Alguém o indicou? (Opcional)"), _defineProperty(_msg, "i_read_and_accept", 'Li e aceito <a href="/terms" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Termos e Condições</a> e a <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Política de Privacidade</a>.'), _defineProperty(_msg, "i_read", "Li e aceito os Termos e Condições."), _defineProperty(_msg, "i_read_privacy", "Li e aceito os Política de Privacidade."), _defineProperty(_msg, "not_usa_citizen", "Declaro que não sou cidadão ou residente nos Estados Unidos da América."), _defineProperty(_msg, "not_china_citizen", "Declaro que não sou cidadão ou residente em Hong Kong."), _defineProperty(_msg, "scan_qr_code_or_copy_address", "Digitalize o código QR ou copie o endereço."), _defineProperty(_msg, "warning_60days", "Os resgates e levantamentos não estão disponíveis até 60 dias após a compra. Se não tiver interesse em comprar tokens, não envie o pagamento."), _defineProperty(_msg, "portfolio_intro", "A nossa cesta de criptomoedas é feita a partir de um conjunto selecionado de criptomoedas com confiança de mercado verificado ou grande potencial de crescimento."), _defineProperty(_msg, "text_LUNA", "Terra é um protocolo blockchain que usa stablecoins indexados em fiat para alimentar sistemas de pagamentos globais com preços estáveis."), _defineProperty(_msg, "text_BTC", "É a criptomoeda com a maior capitalização de mercado. Usada para pagamentos e reserva de valor."), _defineProperty(_msg, "text_ETH", "É a primeira plataforma de criptomoedas a criar contratos inteligentes e aplicações descentralizadas."), _defineProperty(_msg, "text_XRP", "O XRP é utilizado por bancos e empresas para liquidez e transferências de liquidações."), _defineProperty(_msg, "text_LTC", "Conhecida como a prata para o Bitcoin Gold. Nos primeiros dias de cripto, o Litecoin foi criado para ser uma versão mais rápida e mais económica do Bitcon."), _defineProperty(_msg, "text_BCH", "O Bitcoin Cash foi criado a partir de um fork do Bitcoin (divisão de moeda). É uma versão modificada do Bitcoin que realiza transacções mais rápidas e mais económicas."), _defineProperty(_msg, "text_EOS", "Plataformas para criar aplicações descentralizadas, sem taxas de transacção."), _defineProperty(_msg, "text_XLM", "Os lúmens são usados para remessas, permitindo acordos entre diferentes moedas."), _defineProperty(_msg, "text_ADA", "Projecto que visa desenvolver a mais avançada plataforma de contracto inteligente. A sua equipa consiste num grande conjunto global de engenheiros e pesquisadores especializados, incluindo Charles Hoskinson, co-fundador da Ethereum."), _defineProperty(_msg, "text_BNB", "É um token digital criado pela plataforma de negociação Binance, fornecendo vários benefícios aos seus comerciantes."), _defineProperty(_msg, "text_TRX", "É uma plataforma descentralizada para partilhar e monetizar entretenimento digital."), _defineProperty(_msg, "text_ZCR", "Criptomoeda criada para simplificar pagamentos. Os serviços que usam o Zcore incluem um sistema móvel de mensagens e masternode."), _defineProperty(_msg, "text_NXS", "A arquitectura avançada de blockchain da Nexus fornece a mais alta expansão e segurança. O Nexus também visa descentralizar a Internet, fornecendo acesso via satélite no espaço."), _defineProperty(_msg, "text_IOTA", "O projecto IOTA visa criar um ecossistema financeiro seguro e descentralizado para a Internet of Things (IOT)."), _defineProperty(_msg, "text_XMR", "O Monero prima pela privacidade e não pela rastreabilidade. As transacções não podem ser vinculadas a um utilizador específico ou a uma identidade do mundo real."), _defineProperty(_msg, "text_OTC", "Atualmente, as Criptos incluem o SafeInsure (SINS), Zcore (ZCR), SmartCash (SMART), DashGreen (DASHG), BitTorrent(BTT), Wink (WIN) e o Bitcoin (BTC) ."), _defineProperty(_msg, "text_DASH", "É uma das criptomoedas mais conhecidas com uma vasta rede crescente de utilizadores. Presente desde os primeiros dias da criptografia, o Dash concentra-se em pagamentos rápidos e seguros."), _defineProperty(_msg, "text_LINK", "O token Ethereum alimenta a rede oracle descentralizada Chainlink, permitindo que contratos inteligentes se liguem com segurança a fontes de dados externas, APIs e sistemas de pagamentos,"), _defineProperty(_msg, "text_LEND", "Token digital usado na Aave, uma das plataformas DeFi de empréstimos de crescimento mais rápido, proporcionando grandes benefícios a seus usuários."), _defineProperty(_msg, "text_DOT", "Polkadot visa facilitar uma web descentralizada totalmente funcional e amigável (Web 3.0), permitindo transferências cross-blockchain de qualquer tipo de dados ou ativos."), _defineProperty(_msg, "text_UNI", "Token de governança da Uniswap, uma das maiores plataformas descentralizadas de trading hospedadas em Ethereum, que facilita a negociação de tokens de finanças descentralizadas (DeFi)."), _defineProperty(_msg, "text_FIL", "Filecoin é um sistema de armazenamento descentralizado. Ao contrário de empresas de armazenamento em nuvem como Amazon ou Cloudflare, Filecoin aproveita sua natureza descentralizada para proteger a integridade dos dados."), _defineProperty(_msg, "text_THETA", "Theta é a criptomoeda nativa da Rede Theta, um blockchain para melhorar a qualidade e capacidade de entrega de conteúdo de streaming de vídeo."), _defineProperty(_msg, "text_MANA", "Token digital usado na Decentraland, uma plataforma de realidade virtual que permite aos usuários comprar, personalizar e vender lotes de terra virtuais como NFTs."), _defineProperty(_msg, "text_CAKE", "Token de governança do PancakeSwap, a plataforma de trading descentralizada (DEX) de crescimento mais rápido hospedada na Binance Smart Chain."), _defineProperty(_msg, "text_MATIC", "Token de governança do Polygon, uma rede de segunda camada para dimensionamento e desenvolvimento de infraestrutura da Ethereum. Com o Polygon, o Ethereum torna-se um sistema multi-chain, facilitando a interoperabilidade do blockchain, com transações mais rápidas a um custo menor."), _defineProperty(_msg, "text_SOL", "Token nativo da rede Solana, um blockchain de rápido crescimento no espaço DeFi, com velocidade e escalabilidade excelentes, capaz de atingir até 65.000 transações por segundo."), _defineProperty(_msg, "text_CRV", "Token nativo da Curve Finance, a plataforma de trading descentralizada (DEX) com o maior volume atual em DeFi. O Curve Finance é único devido à sua otimização para swaps com baixo deslizamento entre stablecoins ou ativos semelhantes que atrelam ao mesmo valor."), _defineProperty(_msg, "text_AVAX", "Token nativo do Avalanche, um blockchain de contratos inteligentes emergente no DeFi e no espaço NFT."), _defineProperty(_msg, "text_MBOX", 'Token de governança no Mobox, um aplicativo de jogo descentralizado "play-to-earn" que permite que os usuários negociem NFTs e sejam recompensados por sua participação.'), _defineProperty(_msg, "text_USDT", "Stablecoin a par com o Dólar Americano."), _defineProperty(_msg, "text_TUSD", "Stablecoin a par com o Dólar Americano."), _defineProperty(_msg, "bitgive_info", "Usando a tecnologia bitcoin e blockchain para melhorar a saúde pública e o meio ambiente em todo o mundo."), _defineProperty(_msg, "b4h_info", "Apoia as organizações que usam a tecnologia blockchain para trazer uma mudança positiva à humanidade."), _defineProperty(_msg, "tooltip_text_charity", "Até 50% das nossas taxas das vendas são doadas para a BitGive e Blockchain for Humanity."), _defineProperty(_msg, "tooltip_purchase_referral", "Você pode preencher este campo se alguém o ajudou na compra."), _defineProperty(_msg, "tooltip_internal_withdraw", "Este é o campo do ID de usuário do destinatário."), _defineProperty(_msg, "current_balance", "Saldo Actual"), _defineProperty(_msg, "unlocked_balance", "Saldo desbloqueado"), _defineProperty(_msg, "total_without_fees", "Total sem taxas"), _defineProperty(_msg, "total_to_receive", "Total a receber"), _defineProperty(_msg, "min_length", "O comprimento mínimo é"), _defineProperty(_msg, "characters", "carateres"), _defineProperty(_msg, "contact_intro", "Se tiver alguma dúvida ou problema que precise de resolver, entre em contacto no formulário abaixo"), _defineProperty(_msg, "email_to_registered", "O e-mail será enviado para o e-mail registado na plataforma"), _defineProperty(_msg, "subject", "assunto"), _defineProperty(_msg, "message", "mensagem"), _defineProperty(_msg, "form_sent", "Mensagem enviada com sucesso"), _defineProperty(_msg, "form_error", "Ocorreu um erro ao enviar a sua mensagem. Por favor tente novamente mais tarde."), _defineProperty(_msg, "insufficient_funds", "Fundos Insuficientes"), _defineProperty(_msg, "coin_voting_enj", 'Token digital usado na rede ENJIN, uma plataforma de social gaming, permitindo aos usuários monetizar itens no jogo, como NFTs. <a href="https://enjin.io/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_mana", 'Token digital usado na Decentraland, uma plataforma de realidade virtual que permite aos usuários comprar, personalizar e vender lotes de terra virtuais como NFTs. <a href="https://decentraland.org/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_bat", 'Token digital usado para recompensar usuários e editores no crescente navegador "Brave". Editores e criadores ganham receita de anúncios, bem como gorjetas, enquanto os usuários mantêm a privacidade enquanto ganham BAT para visualizar os anúncios. <a href="https://basicattentiontoken.org/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_dash", 'Uma das criptomoedas mais conhecidas com uma vasta rede crescente de usuários. O Dash se concentra em pagamentos rápidos e privados, oferecendo "PrivateSend" para ativar transações não rastreáveis. <a href="https://www.dash.org/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_mkr", 'Token digital criado pela MakerDAO, uma das maiores plataformas DeFi, que fornece empréstimos garantidos pela Ethereum. <a href="https://makerdao.com/en/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_xtz", 'Criptomoeda nativa da blockchain da Tezos, que se concentra na integração da tecnologia de Smart Contracts com produtos financeiros. Ultimamente, vários projetos NFT, como o Cleveland Cavaliers e o McLaren, estão usando o Tezos para suas coleções. <a href="https://tezos.com/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_lend", 'Token digital usado no Aave, uma das plataformas de empréstimo DeFi de crescimento mais rápido, proporcionando grandes benefícios aos usuários AAVE. <a href="https://aave.com/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_atom", 'Ecossistema de crescimento rápido de blockchains que podem escalar e interoperar entre si, concorrente de Polkadot (DOT), Ethereum (ETH) e outras importantes criptomoedas de contratos inteligentes. <a href="https://cosmos.network/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_band", 'Plataforma oracle de cross-chain data que agrega e conecta dados e APIs do mundo real a Smart Contracts. <a href="https://bandprotocol.com/" target="_blank">Saiba mais</a>'), _defineProperty(_msg, "coin_voting_aave", 'Token digital utilizado na AAVE, uma das maiores plataformas de empréstimo DeFi. A AAVE foi atualizada recentemente para a versão 3.0, fornecendo empréstimos "cross-chain" e um novos mecanismos para melhorar a experiência do usuário, gerenciamento de risco e eficiência de capital. <a href="https://aave.com/" target="blank_">Saiba mais</a>.'), _defineProperty(_msg, "coin_voting_uni", 'Uma das plataformas de negociação descentralizadas mais conhecidas, facilitando a negociação automatizada de tokens de finanças descentralizadas (DeFi). <a href="https://uniswap.org/" target="blank_">Saiba mais</a>.'), _defineProperty(_msg, "coin_voting_fil", 'Filecoin é um sistema de armazenamento descentralizado. Ao contrário de empresas de armazenamento em nuvem como Amazon ou Cloudflare, Filecoin aproveita sua natureza descentralizada para proteger a integridade dos dados. <a href="https://filecoin.io/" target="blank_">Saiba mais</a>.'), _defineProperty(_msg, "coin_voting_cake", 'Token de governança do PancakeSwap, a plataforma de trading descentralizada de crescimento mais rápido hospedada na Binance Smart Chain. <a href="https://pancakeswap.finance/" target="blank_">Saiba mais</a>.'), _defineProperty(_msg, "coin_voting_matic", "Token de governan\xE7a do Polygon, uma rede de segunda camada para dimensionamento e desenvolvimento de infraestrutura da Ethereum. Com o Polygon, o Ethereum torna-se um sistema multi-chain, facilitando a interoperabilidade do blockchain, com transa\xE7\xF5es mais r\xE1pidas a um custo menor. <a href=\"https://polygon.technology/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_sand", "Token de governan\xE7a do The Sandbox, um mundo de realidade virtual onde as pessoas podem criar, compartilhar e vender conte\xFAdo como NFTs, como jogos e experi\xEAncias \xFAnicas. <a href=\"https://sandbox.game/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_axs", "Token de governan\xE7a do Axie Infinity, o jogo de realidade virtual \"jogue para lucrar\" de crescimento mais r\xE1pido usando NFTs. Mais de 1 milh\xE3o de jogadores ativos diariamente \"batalham\" no Axie Infinity pela chance de ganhar recompensas em cripto. <a href=\"https://axieinfinity.com/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_mbox", "Token de governan\xE7a no Mobox, um aplicativo de jogo descentralizado que permite que os usu\xE1rios negociem NFTs e sejam recompensados \u200B\u200Bpor sua participa\xE7\xE3o. <a href=\"https://www.mobox.io/#/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_xmr", "Criptomoeda focada em privacidade. Monero foi projetado para evitar a censura, com suas transa\xE7\xF5es sendo totalmente n\xE3o rastre\xE1veis. <a href=\"https://monero.org\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_egld", "Elrond \xE9 uma blockchain projetada para alto rendimento e velocidade de execu\xE7\xE3o r\xE1pida em compara\xE7\xE3o com outras plataformas de contrato inteligente. Para aumentar a ado\xE7\xE3o, o projeto oferece suporte aos desenvolvedores na plataforma, permitindo que eles ganhem 30% das taxas do contrato inteligente como royalties. <a href=\"https://elrond.com/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_etc", "Ethereum Classic \xE9 o Ethereum original, que ainda roda com Proof of Work (mineradores). O ETC \xE9 usado para pagar pela execu\xE7\xE3o de transa\xE7\xF5es e fun\xE7\xF5es de contrato inteligente. <a href=\"https://ethereumclassic.org/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_ton", "Toncoin (TON) \xE9 uma blockchain de camada 1 descentralizada desenvolvida em 2018 pela plataforma de mensagens criptografadas Telegram. O projeto foi ent\xE3o abandonado, assumido pela TON Foundation e renomeado de \"Telegram Open Network\" para \"The Open Network\". <a href=\"https://ton.org/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "coin_voting_xlm", "Stellar \xE9 uma rede de pagamentos de c\xF3digo aberto que serve como um blockchain intermedi\xE1rio distribu\xEDdo para sistemas financeiros globais e circula um ativo nativo, Stellar Lumens (XLM). <a href=\"https://stellar.org/\" target=\"blank_\">Saiba mais</a>."), _defineProperty(_msg, "modalNetwork", {
    title: "Anúncios",
    text_one: "Temos o prazer de informar que adicionamos recentemente novos recursos:",
    title_two: "Blue Club",
    text_two: "Aos usu\xE1rios que comprarem 20 BLUE tokens ou mais, ganhar\xE3o um NFT como associa\xE7\xE3o ao Blue Club, em que proporcionar\xE1 os benef\xEDcios:",
    text_two_t: "Voc\xEA pode acompanhar o progresso de sua qualifica\xE7\xE3o em seu Painel. Estamos ansiosos para receb\xEA-lo no Blue Club!",
    title_three: "Tether Wallets",
    text_three: "Agora você pode depositar e sacar Tether (USDT), oferecendo mais flexibilidade de investimento. Decida se é um bom momento para comprar e manter Blue Tokens ou manter o Tether em sua carteira para quando for a hora certa."
  }), _defineProperty(_msg, "modalBscInfo", {
    title: "Anúncios",
    text_one: "Conforme informado anteriormente em nossos relat\xF3rios trimestrais, o BLUE estar\xE1 trocando de blockchain. O token BLUE deixar\xE1 o blockchain NEM, para ser hospedado no blockchain Binance Smart Chain (BSC).",

    text_two: "A mudan\xE7a est\xE1 programada para quinta-feira, 11 de novembro de 2021 \xE0s 9h (UTC-3). A plataforma n\xE3o estar\xE1 dispon\xEDvel durante esta transi\xE7\xE3o, que deve durar 4 dias. Esperamos ter a plataforma instalada e funcionando novamente na segunda-feira, 15 de novembro. Durante esse per\xEDodo, todas as opera\xE7\xF5es estar\xE3o indispon\xEDveis, portanto, planeje-se.",

    title_two: "O preço do token e o saldo dos usuários não serão afetados.",
    text_three: "Os usuários terão a mesma quantidade de tokens que tinham antes da mudança. O preço do token continuará sendo rastreado pelas 14 criptomoedas em nossa cesta durante este período.",
    title_four: "Estamos muito entusiasmados com a mudança. O BSC permitirá uma integração mais fácil do BLUE com terceiros que desejam trabalhar com o token. O BSC está crescendo rapidamente, sendo atualmente o segundo maior blockchain usado em aplicativos DeFi. Devido às suas taxas baixas, os desenvolvedores e usuários consideram o BSC como uma alternativa mais barata ao Ethereum. Além disso, o BSC foi construído para hospedar projetos Ethereum, e é por isso que os desenvolvedores acham fácil hospedar seus projetos no Ethereum e BSC.",
    title_five: "Conforme prometido, estamos trabalhando constantemente para crescer o BLUE. Este movimento é um passo muito importante para a nossa expansão. Agradecemos a todos os nossos usuários que continuam apoiando o projeto."
  }), _defineProperty(_msg, "modalBluePool", {
    title: "Announcements",
    text_one: "Atualizamos nossos termos e condi\xE7\xF5es.",
    title_one: "Taxa de compra",
    text_two: "Reduzimos a taxa de compra do token BLUE, de 6% para 2%. Isso reduzir\xE1 custos para pessoas que desejam comprar tokens BLUE pela primeira vez e para aqueles que costumam fazer contribui\xE7\xF5es mensais.",
    title_two: "Taxa de custódia",
    text_three: "Aumentamos nossa taxa de custódia, de 2,5% para 6% (anual). Isso nos permitirá fornecer melhores ferramentas, serviços e segurança, além da criação de um novo sistema de recompensas.",
    title_four: "Novo sistema de recompensas: Blue Pool",
    text_four: "Estamos introduzindo um novo sistema de recompensas: Blue Pool. Todos os usuários agora podem participar de um pool de recompensas mensal. As recompensas são pagas aos usuários que indicam seus amigos para comprar tokens BLUE. A primeira “pool” foi fixada em 4.20 BLUE (aproximadamente $1.800 dólares). Ganhe sua parte!"
  }), _defineProperty(_msg, "modalDhbtInfo", {
    title: "Anúncios",
    text_one: "Atualizamos nossos termos e condi\xE7\xF5es.",

    text_two: "Conforme anunciado anteriormente, o Blue Token agora \xE9 um produto de uma empresa rec\xE9m-formada, a Digital Horizon Blockchain Technology, registrada no pa\xEDs de El Salvador.",

    title_two: "A mudança se deve a vários benefícios dados por El Salvador às empresas de criptomoedas. El Salvador é o único país do mundo que aceitou o Bitcoin como moeda legal. Seu governo está incentivando as empresas de criptomoedas a investir e prosperar, preparando as bases para o crescimento futuro em inovação tecnológica e infraestrutura.",
    text_three: "Estamos muito animados com a mudança e prontos para aproveitar os benefícios de El Salvador para levar o Blue Token ao próximo nível.",
    title_four: "Se você tiver alguma dúvida, envie um email para support@bluetoken.io.",
    title_one: "Blue é um produto da Digital Horizon, com sede em El Salvador",
    title_five: "Pagamento e taxas de resgates",
    text_four: "A partir de 2 de fevereiro, todos os resgates serão pagos apenas em USDT (Tether), juntamente com alterações nas taxas de resgate:",
    text_six: "Taxa de resgate: 1% do valor de resgate <br/>Taxa m\xEDnima de resgate: 50 USDT",
    text_seven: "O prazo de pagamento continuará sendo de 3 dias úteis. Os usuários terão a opção de pagamento no mesmo dia por uma taxa."
  }), _defineProperty(_msg, "modalBuyBluePix", {
    buy_blue: "Comprar BLUE",
    connecting_swapix: "Conectando-se ao SWAPiX",
    only_accepts: "Blue Token só aceita pagamento em criptomoedas.",
    pix_purcase_processed: "Felizmente, as compras do Pix são processadas pelo nosso parceiro confiável SWAPiX.",
    swapix_terms: "Eu li os <a class=p5_l href=https://usdt.smartpay.com.vc/static/media/terms_jun.f681a88b.pdf target=blank style=\"margin-right:5px\">termos e condi\xE7\xF5es</a> da SWAPiX.",
    btn_next: "Próximo",
    welcome: "Bem-vindo ao",
    payment_being_processed: "Suas informações de pagamento estão sendo processadas.",
    wait: "Espere alguns segundos enquanto fazemos nossa mágica…",
    payment: "Pagamento",
    convert_price: "Taxa de câmbio",
    completed_buy: "Sua compra foi finalizada. Em caso seu saldo não estiver atualizado, atualize a página."
  }), _defineProperty(_msg, "modalWarnUser", {
    title: "Saque: Importante",
    warn1: "Certifique-se de que a carteira de recebimento seja compatível com tokens BLUE. Nem todas as carteiras BSC suportam BLUE.",
    warn2: "A Blue Token não assume responsabilidade por operações que ocorram em plataformas de terceiros.",
    warn3: "Todas as transações originadas fora de nossa plataforma incorrem em uma taxa de 6%.",
    warn4: "As retiradas são irreversíveis. Verifique se você está enviando seus tokens para uma parte confiável.",
    i_understand: "Eu entendi"
  }), _defineProperty(_msg, "modalBlueClub", {
    title: "Benefícios de associação",
    subTitle: "Aos usuários que comprarem 20 BLUE tokens ou mais, ganharão um NFT como associação ao Blue Club, em que proporcionará os benefícios:",
    text1: "<div style=\"display:flex\"><a href=\"https://solscan.io/token/AP9rP81KJzPCQFmE4fK9Ue8NWRaXZ5QbqQJn6PKhQP17\" target=\"_blank\" style=\"color: #cb36ee; text-decoration:underline; margin-right:5px\">Blue Club NFT</a> (Token N\xE3o-fung\xEDvel);</div>",
    text2: "Acesso VIP à todos os eventos, incluindo brindes exclusivos;",
    text3: "Serviços de consultoria exclusivos;",
    text4: "Airdrops, brindes e promoções exclusivas de nossos parceiros.",
    text5: "Convite especial para eventos de networking exclusivos."
  }), _defineProperty(_msg, "modalClainBlueClub", {
    title: "Obtenha seu Blue Club NFT",
    text2: "Parabéns! Agora você pertence ao seleto clube VIP do Blue Token.",
    text3: "Agora você deve reivindicar seu NFT, que lhe dará acesso a vários benefícios de associação.",
    text4: "Insira seu endereço de Solana:",
    text5: "Use uma carteira Exodus ou Phantom para armazenar seu NFT.",
    text6: "Para qualquer dúvida, entre em contato com nossa equipe de suporte.",

    text7: "Bem-vindo ao Blue Club!",
    text8: "Seu NFT está sendo criado. Você receberá em até 2 dias úteis.",
    text9: "Você receberá um e-mail de boas-vindas. Certifique-se de que não foi enviado para a caixa de spam, pois iremos mantê-lo informado sobre eventos e serviços em que você receberá tratamento VIP.",
    text10: "ÓTIMO!"
  }), _defineProperty(_msg, "settings", {
    title: "Configurações da Conta",
    profile: "Perfil",
    security: "Segurança",
    notifications: "Notificações",

    updateInfoProfile: "Atualize suas informações básicas de perfil.",
    updateInfoSecurity: "Atualize suas informações básicas de segurança.",
    updateInfoNotifications: "Desative ou ative suas notificações por e-mail.",

    currently: "Atualmente",
    profileStatus: "Status do perfil",

    updateProfile: "Clique em Salvar para atualizar as informações do seu perfil.",
    updateSecurity: "Clique em Salvar para atualizar suas informações de segurança.",
    updateNotification: "Clique em Salvar para atualizar suas configurações de notificações.",

    toggleEmail: "Alterne suas notificações por e-mail",

    popupSure: "Tem certeza?",
    popupConfirm: "Confirme sua alteração de senha.",

    popupChangesApply: "As alterações serão aplicadas quando você fizer login novamente."
  }), _msg)
});

/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-usdt.svg?15d1570aee2d56cc6adf052fcd80bcd0";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar1.svg?b04d6c72cb07eac54b71db6fe0b456c7";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar2.svg?c8c059dfb2ebbdc1ab14850253ae2c75";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar3.svg?560a331413377b0e2a3a393668d81070";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar4.svg?5e3addf946bc3f874c64ab2643d355b7";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar5.svg?dd5c15335c67f51d6247a891aa9fb91e";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar6.svg?121293bf585b49499718db7979051662";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar7.svg?2901525c164f34e24ba12a31922af773";

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar8.svg?b865e7fe27f1247570a0f63a7c995bcf";

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar9.svg?53501cf44aac8db07b51ce368a083014";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "avatar10.svg?7c464ed23bfe6e9e5421ed0ada1d3baa";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "external-link.svg?6aeb2455d78babcadee80b34a6ba3dd3";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow.svg?7fec0a71a6170abd11ddc9d0522ef59f";

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  created: function created() {
    this.checkUrl();
  },
  data: function data() {
    return {};
  },

  methods: {
    notifyErrorForceClose: function notifyErrorForceClose() {
      mainAlert.classList.remove("mainAlertShow");
    },
    checkUrl: function checkUrl() {
      var url = window.location.href;
      if (url.includes("stratumblue") && !url.includes("rc")) {
        window.location.replace("https://bluetoken.io/app/login");
      }
    }
  }
});

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_global__ = __webpack_require__(75);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    authCookie: "",
    languageCookie: "",
    loading: false,
    authorized: false,
    languages: __WEBPACK_IMPORTED_MODULE_5__configs_global__["a" /* availableLanguages */],
    languageSelected: __WEBPACK_IMPORTED_MODULE_5__configs_global__["a" /* availableLanguages */][0],
    member: "",
    accounts: "",
    accountSelected: "",
    fees: "",
    feeRedeem: "",
    feePurchase: "",
    currencies: "",
    bluAccount: "",
    btcAccount: "",
    ethAccount: "",
    realtAccount: "",
    joinPool: false,
    bluValue: "",
    usdtAccount: "",
    btcValue: "",
    ethValue: "",
    xemValue: "",
    zarValue: "",
    eurValue: "",
    gbpValue: "",
    chfValue: "",
    cnyValue: "",
    hkdValue: "",
    rasValue: "",
    cadValue: "",
    audValue: "",
    usdtValue: "",
    assetList: "",
    fundValueBtc: "",
    minimumInvestiment: 250
  },
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.mixin({
            methods: {
                notifyDefault: function notifyDefault() {
                    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "message";
                    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";
                    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;

                    var mainAlert = document.getElementById("mainAlert");
                    var mainAlertTxt = document.getElementById("mainAlertTxt");

                    mainAlertTxt.innerText = message;
                    mainAlert.classList.add("mainAlertShow");
                    mainAlert.classList.add(type);

                    setTimeout(function () {
                        mainAlert.classList.remove("mainAlertShow");
                        mainAlert.classList.remove(type);
                    }, timeout);
                },
                notifyDanger: function notifyDanger() {
                    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "System Error";
                    var timeout = arguments[1];

                    this.notifyDefault(message, 'alert_danger', timeout);
                },
                notifyError: function notifyError(message, timeout) {
                    if (typeof message !== 'string') {
                        message = this.formatErrorMessages(message);
                    }
                    this.notifyDanger(message, timeout);
                },
                notifyWarning: function notifyWarning(message, timeout) {
                    this.notifyDefault(message, 'alert_warning', timeout);
                },
                notifyInfo: function notifyInfo(message, timeout) {
                    message = message.text ? this.$t("msg.copied") + ": " + message.text : message;
                    this.notifyDefault(message, 'alert_info', timeout);
                },
                notifySuccess: function notifySuccess(message, timeout) {
                    this.notifyDefault(message, 'alert_success', timeout);
                },
                onCopySuccess: function onCopySuccess(message) {
                    this.notifyInfo(message);
                },
                onCopySuccessInformation: function onCopySuccessInformation() {
                    this.notifyInfo('Copied');
                },
                onCopySuccessInformationOTC: function onCopySuccessInformationOTC() {
                    this.notifyInfo(this.$t('msg.copy_alert_info_otc'));
                },
                onCopyError: function onCopyError(message) {
                    this.notifyInfo(message);
                },
                formatErrorMessages: function formatErrorMessages(errors) {
                    var message = "";
                    if (Array.isArray(errors)) {
                        errors.forEach(function (item) {
                            var messageArray = [];

                            if (item.message.indexOf(",") !== -1) {
                                messageArray = item.message.split(",");
                                message = message ? message + "\n" + messageArray.join("\n") : message + messageArray.join("\n");
                            } else {
                                message = message ? message + "\n" + item.message : item.message;
                            }
                        });
                    } else {
                        return errors.message;
                    }
                    return message;
                }
            }
        });
    }
});

/***/ }),
/* 197 */,
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_BaseWrittenLogo__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_BaseLanguageBar__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_BluPricesHeader__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var RecoverUserIdFields = function RecoverUserIdFields() {
  _classCallCheck(this, RecoverUserIdFields);

  this.email = "";
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "recoveruserid",
  mounted: function mounted() {
    this.setValidationFields(RecoverUserIdFields);
  },

  data: function data() {
    return {
      recoverUserIdForm: new RecoverUserIdFields()
    };
  },
  methods: {
    submitRecoverUserid: function submitRecoverUserid() {
      var form = this.recoverUserIdForm;

      this.showOrHideError("email", this.validateEmail(form.email));

      this.checkIfFormHasErrorsAndSubmit(form, this.postRecoverUserIdForm, this.afterSubmit, this.afterSubmitError);
    },
    afterSubmit: function afterSubmit() {
      this.notifySuccess(this.$t("msg.check_your_email_for_userid"));
      this.$router.push("login");
    },
    afterSubmitError: function afterSubmitError(error) {
      this.notifyError(error);
    },
    postRecoverUserIdForm: function postRecoverUserIdForm(form) {
      return this.$store.dispatch("postRecoverUid", form.email);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["loading", "currencies"])),
  components: {
    BaseWrittenLogo: __WEBPACK_IMPORTED_MODULE_0__components_public_BaseWrittenLogo__["a" /* default */],
    BaseLanguageBar: __WEBPACK_IMPORTED_MODULE_1__components_public_BaseLanguageBar__["a" /* default */],
    BluPricesHeader: __WEBPACK_IMPORTED_MODULE_2__components_public_BluPricesHeader__["a" /* default */]
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["logoClasses"]
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.languageSelectedOnPage = this.languageSelected;
    this.checkIfMobile();
  },
  created: function created() {
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      languageSelectedOnPage: "",
      isMobile: ""
    };
  },
  methods: {
    changeLanguage: function changeLanguage(lang) {
      this.languageSelectedOnPage = lang;
      this.$store.dispatch("setLanguageSelected", lang);
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;
      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["languages", "languageSelected"]), {
    storeLanguage: {
      get: function get() {
        return this.languageSelectedOnPage;
      },
      set: function set(value) {
        this.changeLanguage(value);
      }
    }
  })
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},

  data: function data() {
    return {};
  },
  methods: {},
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount", "btcAccount", "bluValue", "btcValue", "fundValueBtc"])),
  watch: {
    currencies: function currencies() {
      this.getCoinsAmount();
    }
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ChangePasswordFields = function ChangePasswordFields() {
  _classCallCheck(this, ChangePasswordFields);

  this.password = "";
  this.passwordConfirmation = "";
  this.pinHash = "";
};

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.pinhash = this.$route.params.pinhash;
  },
  mounted: function mounted() {
    this.setValidationFields(ChangePasswordFields);
    console.log("pinhash:", this.pinhash);
  },

  data: function data() {
    return {
      changePasswordForm: new ChangePasswordFields(),
      pinhash: ""
    };
  },
  methods: {
    submitChangePassword: function submitChangePassword() {
      var form = this.changePasswordForm;
      this.showOrHideError("password", this.validatePassword(form.password));
      this.showOrHideError("passwordConfirmation", form.passwordConfirmation && form.passwordConfirmation === form.password);
      form.pinHash = this.pinhash;
      this.checkIfFormHasErrorsAndSubmit(form, this.putChangePasswordConfirm, this.afterSubmitSuccess, this.afterSubmitError);
    },
    putChangePasswordConfirm: function putChangePasswordConfirm(form) {
      return this.$store.dispatch("putRecoverPasswordConfirm", form);
    },
    afterSubmitSuccess: function afterSubmitSuccess() {
      this.notifyDefault(this.$t("msg.password_changed"), "alert_success", 5000);
      this.$router.push("login");
    },
    afterSubmitError: function afterSubmitError(error) {
      this.notifyDanger(error);
    }
  },
  computed: {}
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_BaseWrittenLogo__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_BaseLanguageBar__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_BluPricesHeader__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var RecoverPasswordFields = function RecoverPasswordFields() {
  _classCallCheck(this, RecoverPasswordFields);

  this.userId = "";
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "recoverpassword",
  mounted: function mounted() {
    this.setValidationFields(RecoverPasswordFields);
  },

  data: function data() {
    return {
      recoverPasswordForm: new RecoverPasswordFields()
    };
  },
  methods: {
    submitRecoverPassword: function submitRecoverPassword() {
      var form = this.recoverPasswordForm;

      this.showOrHideError("userId", form.userId);
      this.checkIfFormHasErrorsAndSubmit(form, this.postRecoverPasswordForm, this.afterSubmit, this.afterSubmitError);
    },
    afterSubmit: function afterSubmit() {
      this.notifySuccess(this.$t("msg.check_your_email"));
      this.$router.push("login");
    },
    afterSubmitError: function afterSubmitError(error) {
      this.notifyError(this.$t("msg.invalid_connetion"));
    },
    postRecoverPasswordForm: function postRecoverPasswordForm(form) {
      return this.$store.dispatch("postRecoverPassword", form.userId);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["loading", "currencies"])),
  components: {
    BaseWrittenLogo: __WEBPACK_IMPORTED_MODULE_1__components_public_BaseWrittenLogo__["a" /* default */],
    BaseLanguageBar: __WEBPACK_IMPORTED_MODULE_2__components_public_BaseLanguageBar__["a" /* default */],
    BluPricesHeader: __WEBPACK_IMPORTED_MODULE_3__components_public_BluPricesHeader__["a" /* default */]
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_BaseLoading__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_BaseWrittenLogo__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_BaseLanguageBar__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_public_BluPricesHeader__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_phone_number_input__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input_dist_vue_phone_number_input_css__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input_dist_vue_phone_number_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input_dist_vue_phone_number_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function SignupFields() {
  // this.name = "";
  this.phone = "";
  this.email = "";
  this.password = "";
  this.passwordConfirmation = "";
  this.referralCode = "";
  this.language = "EN";
  this.isNotChinaCitizen = true;
  this.isNotUsaCitizen = true;
  this.hasAcceptedTerms = "";
  this.hasAcceptedPrivacyPolicy = true;
  this.formSent = "";
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "signup",
  created: function created() {
    var _this = this;

    window.addEventListener("resize", this.checkIfMobile);
    this.setCountdown();
    this.generate();
    setTimeout(function () {
      _this.$router.push({ name: "login" });
    }, 1000);
  },
  mounted: function mounted() {
    this.setValidationFields(SignupFields);
    this.signupform.referralCode = this.referCode;
    this.checkIfMobile();
  },

  props: {
    referCode: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      results: "",
      countriesNotAllowed: false,
      checkBoxTerms: false,
      checkBoxPrivacy: false,
      recaptchaToken: "",
      loading: false,
      signupform: new SignupFields(),
      receiveCodeBtnClicked: false,
      receiveCodeCounter: 0,
      isCodeAdded: false,
      isMobile: false,
      passwordSujest: "",
      showBox: false,
      roll: false,
      slide: false,
      size: "17",
      characters: "a-z,A-Z,0-9,#",
      buttonOff: true,
      deadline: "April 6 2019 0:00:00 GMT-0200",
      remainingTime: "",
      countdownInterval: "",
      clock: {
        days: "",
        hours: "",
        minutes: "",
        seconds: "",
        status: ""
      },
      showInfo: {
        "1a": false,
        "1b": false,
        "1c": false
      },
      terms: false,
      privacy: false
    };
  },
  methods: {
    openCheckBox: function openCheckBox(e, el) {
      var eventHref = e.path[0].href;

      if (eventHref.includes("terms")) {
        this.terms = true;
      }

      if (eventHref.includes("privacy")) {
        this.privacy = true;
      }

      if (this.terms && this.privacy) {
        this[el] = true;
      }
    },
    verifyCountry: function verifyCountry($event) {
      this.results = $event.countryCode;

      if (this.results == "CN" || this.results == "HK" || this.results == "US") {
        this.countriesNotAllowed = true;
      } else {
        this.countriesNotAllowed = false;
      }
    },
    toggleBox: function toggleBox() {
      if (!this.signupform.password) {
        this.slide = false;
        this.showBox = true;
      }
    },


    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },

    onCaptchaExpired: function onCaptchaExpired() {
      this.recaptchaToken = "";
      this.$refs.recaptcha.reset();
    },

    toggleRemove: function toggleRemove() {
      this.slide = true;
    },
    generate: function generate() {
      var CharacterSet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789![]{}()%&*$#^<>~@|";
      var password = "";

      for (var i = 0; i < this.size; i++) {
        password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
      }
      this.passwordSujest = password;
    },
    usePasswordSujest: function usePasswordSujest() {
      this.signupform.password = this.passwordSujest;
      this.signupform.passwordConfirmation = this.passwordSujest;
    },
    setCountdown: function setCountdown() {
      var time = Date.parse(this.deadline) - Date.parse(new Date());
      this.remainingTime = time;

      if (time > 0) {
        this.clock.days = Math.floor(time / (1000 * 60 * 60 * 24));
        this.clock.hours = Math.floor(time / (1000 * 60 * 60) % 24);
        this.clock.minutes = Math.floor(time / 1000 / 60 % 60);
        this.clock.seconds = Math.floor(time / 1000 % 60);
        this.setUpdateCountdown();
      }
    },
    setUpdateCountdown: function setUpdateCountdown() {
      var time = Date.parse(this.deadline) - Date.parse(new Date());
      this.remainingTime = time;
      if (time > 0) {
        this.countdownInterval = setInterval(this.updateCountdown, 1000);
      } else {}
    },
    updateCountdown: function updateCountdown() {
      var time = Date.parse(this.deadline) - Date.parse(new Date());
      if (time > 0) {
        this.clock.days = Math.floor(time / (1000 * 60 * 60 * 24));
        this.clock.hours = Math.floor(time / (1000 * 60 * 60) % 24);
        this.clock.minutes = Math.floor(time / 1000 / 60 % 60);
        this.clock.seconds = Math.floor(time / 1000 % 60);
      } else {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    checkIfMobile: function checkIfMobile() {
      if (window.innerWidth > 767) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    validatePhone: function validatePhone(phone) {
      return phone && phone.length > 0 && !this.countriesNotAllowed;
    },
    submitSignup: function submitSignup() {
      var form = this.signupform;
      this.showOrHideError("phone", this.validatePhone(form.phone));
      this.showOrHideError("email", this.validateEmail(form.email));
      this.showOrHideError("password", this.validatePassword(form.password));
      this.showOrHideError("passwordConfirmation", form.passwordConfirmation && form.passwordConfirmation === form.password);
      this.showOrHideError("referralCode", form.referralCode === "" || form.referralCode.length === 8);
      this.showOrHideError("isNotUsaCitizen", true);
      this.showOrHideError("isNotChinaCitizen", true);
      this.showOrHideError("hasAcceptedTerms", form.hasAcceptedTerms);
      this.showOrHideError("hasAcceptedPrivacyPolicy", true);

      var formPayload = {
        // name: form.name,
        phone: form.phone,
        email: form.email,
        password: form.password,
        passwordConfirmation: form.passwordConfirmation,
        referCode: form.referralCode,
        language: form.language,
        optinUSA: form.isNotUsaCitizen,
        optinCN: form.isNotChinaCitizen,
        optinPrivacy: form.hasAcceptedPrivacyPolicy,
        optinTerms: form.hasAcceptedTerms,
        recaptchaToken: this.recaptchaToken
      };

      if (this.buttonOff) {
        this.notifyDanger(this.$t("msg.confirm_recaptcha"), 5000);
      } else {
        this.checkIfFormHasErrorsAndSubmit(formPayload, this.postSignupForm, this.afterSubmitSuccess, this.afterSubmitError);
      }
    },
    postSignupForm: function postSignupForm(form) {
      return this.$store.dispatch("postSignup", form);
    },
    afterSubmitSuccess: function afterSubmitSuccess() {
      this.loading = false;
      this.notifyDefault(this.$t("msg.check_your_email"), "alert_success", 5000);
      this.$router.push("login");
    },
    afterSubmitError: function afterSubmitError(error) {
      this.loading = false;
      this.notifyError(error);
    }
  },
  components: {
    BaseLoading: __WEBPACK_IMPORTED_MODULE_0__components_public_BaseLoading__["a" /* default */],
    BaseWrittenLogo: __WEBPACK_IMPORTED_MODULE_1__components_public_BaseWrittenLogo__["a" /* default */],
    VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_5_vue_phone_number_input___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */],
    BaseLanguageBar: __WEBPACK_IMPORTED_MODULE_3__components_public_BaseLanguageBar__["a" /* default */],
    BluPricesHeader: __WEBPACK_IMPORTED_MODULE_4__components_public_BluPricesHeader__["a" /* default */]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["currencies"])),

  watch: {
    roll: function roll() {
      var _this2 = this;

      setTimeout(function () {
        _this2.roll = false;
      }, 3000);
    },

    recaptchaToken: function recaptchaToken() {
      if (this.recaptchaToken == "") {
        this.buttonOff = true;
      } else {
        this.buttonOff = false;
      }
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLoading_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf883d9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLoading_vue__ = __webpack_require__(734);
function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseLoading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf883d9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseLoading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["text"],
    created: function created() {},
    mounted: function mounted() {
        if (!this.text) {
            this.text = "loading";
        }
    },

    data: function data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {},
    watch: {}
});

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_BaseWrittenLogo__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_BaseLanguageBar__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_BluPricesHeader__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var LoginFields = function LoginFields() {
  _classCallCheck(this, LoginFields);

  this.userid = "";
  this.password = "";
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login",

  created: function created() {
    if (this.$route.query.user) {
      this.loginform.userid = this.$route.query.user;
    }
  },
  mounted: function mounted() {
    if (this.activationHash != "") {
      this.notifySuccess(this.$t("msg.activating_account"), 5000);
      this.activate(this.activationHash);
    }
    this.setValidationFields(LoginFields);
    this.$store.dispatch("getCurrencies");
    this.$store.dispatch("getFundTailsBtc");
  },

  props: {
    activationHash: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      loginform: new LoginFields(),
      loading: false,
      recaptchaToken: "",
      buttonOff: true
    };
  },
  methods: {
    activate: function activate(code) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("putActivateMember", code);

              case 3:
                _this.notifySuccess(_this.$t("msg.activation_successful"), 5000);
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.response.status === 404) {
                  _this.notifyDanger(_this.$t("msg.activation_link_invalid"));
                } else {
                  _this.notifyDanger(_context.t0, 5000);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },


    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },

    onCaptchaExpired: function onCaptchaExpired() {
      this.recaptchaToken = "";
      this.$refs.recaptcha.reset();
    },
    submitLogin: function submitLogin() {
      var form = this.loginform;

      this.showOrHideError("userid", this.validateUserId(form.userid));
      this.showOrHideError("password", form.password);
      var formPayload = {
        id: form.userid,
        password: form.password,
        recaptchaToken: this.recaptchaToken
      };

      if (this.buttonOff) {
        this.notifyDanger(this.$t("msg.confirm_recaptcha"), 5000);
      } else {
        this.checkIfFormHasErrorsAndSubmit(formPayload, this.postLoginForm, this.afterSubmitSuccess, this.afterSubmitError);

        this.onCaptchaExpired();
      }
    },
    afterSubmitSuccess: function afterSubmitSuccess(resp) {
      this.loading = false;
      this.notifySuccess(this.$t("msg.login_successful"));
      this.$store.commit("setAuthCookie", resp.data.access_token);
      this.$store.commit("setAuthorized", true);
      this.$router.push("home");
    },
    afterSubmitError: function afterSubmitError(error) {
      this.loading = false;
      this.showError("userid", "invalid_credentials");
      this.showError("password", "invalid_credentials");
      this.notifyDanger(error);
    },
    postLoginForm: function postLoginForm(form) {
      this.loading = true;
      return this.$store.dispatch("postSignin", form);
    }
  },
  components: {
    BaseWrittenLogo: __WEBPACK_IMPORTED_MODULE_0__components_public_BaseWrittenLogo__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["TheMask"],
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__["a" /* default */],
    BaseLanguageBar: __WEBPACK_IMPORTED_MODULE_1__components_public_BaseLanguageBar__["a" /* default */],
    BluPricesHeader: __WEBPACK_IMPORTED_MODULE_2__components_public_BluPricesHeader__["a" /* default */]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["currencies"])),

  watch: {
    recaptchaToken: function recaptchaToken() {
      if (this.recaptchaToken == "") {
        this.buttonOff = true;
      } else {
        this.buttonOff = false;
      }
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_BaseLanguageBar__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_BaseFooter__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_BluPricesHeader__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch("getCurrencies");
    this.$store.dispatch("getFundTailsBtc");
  },

  components: {
    BaseLanguageBar: __WEBPACK_IMPORTED_MODULE_0__components_public_BaseLanguageBar__["a" /* default */],
    BaseFooter: __WEBPACK_IMPORTED_MODULE_1__components_public_BaseFooter__["a" /* default */],
    BluPricesHeader: __WEBPACK_IMPORTED_MODULE_2__components_public_BluPricesHeader__["a" /* default */]
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["currencies"]))
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseFooter_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43fa82e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseFooter_vue__ = __webpack_require__(742);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43fa82e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spacetime__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      year: __WEBPACK_IMPORTED_MODULE_0_spacetime___default.a.now().year()
    };
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modals_modalVotingTen__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals_modalVotingTwelve__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_BaseFooter__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_BaseHeader__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modals_modalVotingThirteen__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_modalBscInfo__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_modalDhbtInfo__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_modalNetworkDist__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_modalPrivacyPolicy__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_modalTermsConditions__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_modalVotingFourteen_vue__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_modalBluePool_vue__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.$store.dispatch("getMember");
    this.$store.dispatch("updateBluAccount");
    this.$store.dispatch("getFeesFilter");
    this.$store.dispatch("getFundTailsBtc");
    this.getSurveyStatus();
    this.dayBlock();
    this.getVotingStatus();

    this.listNotifications();

    this.getAwnser();

    this.checkActivatedNotifications();
  },
  mounted: function mounted() {},

  components: {
    BaseHeader: __WEBPACK_IMPORTED_MODULE_3__components_public_BaseHeader__["a" /* default */],
    BaseFooter: __WEBPACK_IMPORTED_MODULE_2__components_public_BaseFooter__["a" /* default */],
    modalTermsConditions: __WEBPACK_IMPORTED_MODULE_9__components_modals_modalTermsConditions__["a" /* default */],
    modalNetworkDist: __WEBPACK_IMPORTED_MODULE_7__components_modals_modalNetworkDist__["a" /* default */],
    modalPrivacyPolicy: __WEBPACK_IMPORTED_MODULE_8__components_modals_modalPrivacyPolicy__["a" /* default */],
    modalBscInfo: __WEBPACK_IMPORTED_MODULE_5__components_modals_modalBscInfo__["a" /* default */],
    modalVotingTen: __WEBPACK_IMPORTED_MODULE_0__components_modals_modalVotingTen__["a" /* default */],
    modalDhbtInfo: __WEBPACK_IMPORTED_MODULE_6__components_modals_modalDhbtInfo__["a" /* default */],
    modalVotingTwelve: __WEBPACK_IMPORTED_MODULE_1__components_modals_modalVotingTwelve__["a" /* default */],
    modalPoolInfo: __WEBPACK_IMPORTED_MODULE_11__components_modals_modalBluePool_vue__["a" /* default */],
    modalVotingThirteen: __WEBPACK_IMPORTED_MODULE_4__components_modals_modalVotingThirteen__["a" /* default */],
    modalVotingFourteenVue: __WEBPACK_IMPORTED_MODULE_10__components_modals_modalVotingFourteen_vue__["a" /* default */]
  },
  data: function data() {
    return {
      needVoting: "",
      modal: false,
      activedVolting: "",
      lastVolting: "",
      coinOne: "",
      coinTwo: "",
      user: {
        name: "",
        subject: "",
        message: ""
      },
      minLengthMessage: 10,
      minLengthSubject: 5,
      winnerCoins: [],
      volting: "",
      termsCheck: "",
      privacyCheck: "",
      notifications: "",
      modalNotificationNetwork: false,
      modalNotificationBSC: false,
      modalNotificationBlueClub: false,
      modalNotificationBluePool: false,
      needVotingNetwork: false,
      needVotingBSC: false,
      needVotingBluePool: false,
      needVotingDHBT: false,
      needVotingBlueClub: false
    };
  },
  methods: {
    listNotifications: function listNotifications() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, array, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getNotificationList");

              case 2:
                resp = _context.sent;

                if (resp.status == 200) {
                  array = resp.data;


                  for (i in array) {
                    if (array[i].activated && array[i].title == "blue_club") {
                      _this.needVotingBlueClub = true;
                      _this.networkId = array[i].id;
                    }

                    // if (array[i].activated && array[i].title == "blue_bsc") {
                    //   this.needVotingBSC = true;
                    //   this.bscId = array[i].id;
                    // }

                    // if (array[i].activated && array[i].title == "blue_pool") {
                    //   this.needVotingBluePool = true;
                    //   this.bluePoolId = array[i].id;
                    // }

                    // if (
                    //   array[i].activated &&
                    //   array[i].title == "digital_horizon_blockchain"
                    // ) {
                    //   this.needVotingDHBT = true;
                    //   this.dhbId = array[i].id;
                    // }
                  }

                  _this.notifications = resp.data;

                  _this.checkActivatedNotifications(_this.notifications);
                } else {
                  alert("Something wrong");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toggleModal: function toggleModal() {
      this.user = {
        name: "",
        subject: "",
        message: ""
      }, this.modal = !this.modal;
    },
    closeModalNetwork: function closeModalNetwork() {
      this.modalNotificationNetwork = false;
    },
    checkMember: function checkMember() {
      this.$store.dispatch("getMember");
    },
    checkTerms: function checkTerms() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.member.optinTerms == true) {
          _this2.termsCheck = false;
        } else {
          _this2.termsCheck = true;
        }
      }, 1000);

      setTimeout(function () {
        if (_this2.member.optinPrivacy == true) {
          _this2.privacyCheck = false;
        } else {
          _this2.privacyCheck = true;
        }
      }, 1000);
    },
    postEmail: function postEmail() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userName, form, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userName = "unnamed";

                if (_this3.member.name) {
                  userName = _this3.member.name;
                }
                if (_this3.user.name != "" && _this3.user.name != null) {
                  userName = _this3.user.name;
                }

                form = {
                  to: "support@bluetoken.io",
                  "reply-to": _this3.member.email,
                  cc: "user@example.com",
                  tagSubject: "Blu-form-contact",
                  subject: _this3.user.subject,
                  message: _this3.user.message
                };
                _context2.prev = 4;
                _context2.next = 7;
                return _this3.$store.dispatch("postGenericEmail", form);

              case 7:
                resp = _context2.sent;

                _this3.notifySuccess(_this3.$t("msg.form_sent"), 3000);
                _this3.toggleModal();
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](4);

                _this3.notifyError(_this3.$t("msg.form_error"), 3000);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[4, 12]]);
      }))();
    },
    getSurveyStatus: function getSurveyStatus() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var resp, votings, i;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.$store.dispatch("getSurveyPrototypes");

              case 2:
                resp = _context3.sent;
                votings = resp.data;

                for (i in votings) {
                  if (votings[i].active) {
                    _this4.activedVolting = votings[i];
                    if (votings[parseInt(i + 1)]) {
                      _this4.lastVolting = votings[parseInt(i + 1)];
                    }
                  }
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    compareDates: function compareDates(date1, date2) {
      if (date1 > date2) return "Date1 > Date2";else if (date1 < date2) return "Date2 > Date1";else return "Date1 = Date2";
    },
    dayBlock: function dayBlock() {
      var date = new Date();

      var hour = date.getHours();
      var day = date.getDay() - 1;

      if (day > 11) {
        if (hour > 17) {
          return true;
        }
      } else {
        return false;
      }
    },
    getVotingStatus: function getVotingStatus() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this5.$store.dispatch("getSurveyPrototype");

              case 3:
                resp = _context4.sent;

                if (resp) {
                  _this5.needVoting = false;
                }
                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                _this5.needVoting = true;
                console.log(_context4.t0);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7]]);
      }))();
    },
    checkActivatedNotifications: function checkActivatedNotifications(el) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var notifications, i;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                notifications = el;


                for (i in notifications) {
                  if (notifications[i].activated && notifications[i].title == "net_dist") {
                    _this6.notificationID = notifications[i].id;
                    _this6.getNotificationsAnswers(notifications[i].id);
                  }

                  if (notifications[i].activated && notifications[i].title == "blue_bsc") {
                    _this6.notificationID = notifications[i].id;
                    _this6.getNotificationsAnswersBSC(notifications[i].id);
                  }

                  if (notifications[i].activated && notifications[i].title == "blue_club") {
                    _this6.notificationID = notifications[i].id;
                    _this6.getNotificationsAnswersDHB(notifications[i].id);
                  }

                  if (notifications[i].activated && notifications[i].title == "blue_pool") {
                    console.log(_this6.notificationID, "iiddd notification");
                    _this6.notificationID = notifications[i].id;
                    _this6.getNotificationsBluePool(notifications[i].id);
                  }
                }

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    getNotificationsAnswers: function getNotificationsAnswers(id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var resp, answers, i;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this7.$store.dispatch("getNotificationAnswers");

              case 2:
                resp = _context6.sent;

                if (resp.status == 200) {
                  if (resp.data.length > 0) {
                    answers = resp.data;

                    for (i in answers) {
                      if (answers[i].notificationId == id) {
                        _this7.modalNotificationBlueClub = false;
                      }
                    }
                  } else {
                    _this7.modalNotificationBlueClub = true;
                  }
                } else {
                  alert("something wrong");
                }

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    getNotificationsAnswersBSC: function getNotificationsAnswersBSC(id) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var resp, answers, i;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this8.$store.dispatch("getNotificationAnswers");

              case 2:
                resp = _context7.sent;

                if (resp.status == 200) {
                  if (resp.data.length > 0) {
                    answers = resp.data;

                    for (i in answers) {
                      if (answers[i].notificationId == id) {
                        _this8.modalNotificationBSC = false;
                      } else {
                        _this8.modalNotificationBSC = true;
                      }
                    }
                  }
                } else {
                  alert("something wrong");
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },
    getNotificationsBluePool: function getNotificationsBluePool(id) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var resp, answers, i;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this9.$store.dispatch("getNotificationAnswers");

              case 2:
                resp = _context8.sent;

                if (resp.status == 200) {
                  if (resp.data.length > 0) {
                    answers = resp.data;

                    for (i in answers) {
                      if (answers[i].notificationId == id) {
                        _this9.modalNotificationBluePool = false;
                      } else {
                        _this9.modalNotificationBluePool = true;
                      }
                    }
                  } else {
                    _this9.modalNotificationBluePool = true;
                  }
                } else {
                  alert("something wrong");
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    getNotificationsAnswersDHB: function getNotificationsAnswersDHB(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var resp, answers, i;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this10.$store.dispatch("getNotificationAnswers");

              case 2:
                resp = _context9.sent;

                if (resp.status == 200) {
                  if (resp.data.length > 0) {
                    answers = resp.data;

                    for (i in answers) {
                      if (answers[i].notificationId == id) {
                        _this10.modalNotificationDHBT = false;
                      } else {
                        _this10.modalNotificationDHBT = true;
                      }
                    }
                  } else {
                    _this10.modalNotificationDHBT = true;
                  }
                } else {
                  alert("something wrong");
                }

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    postNotificationConfirm: function postNotificationConfirm() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var id, resp;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                id = _this11.notificationID;
                _context10.next = 3;
                return _this11.$store.dispatch("postNotificationConfirm", id);

              case 3:
                resp = _context10.sent;

                if (resp.status == 200) {
                  _this11.getNotificationsAnswers(id);
                  _this11.getNotificationsAnswersBSC(id);
                  _this11.getNotificationsAnswersDHB(id);
                  _this11.getNotificationsBluePool(id);
                } else {
                  alert("Something wrong");
                }

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    getAwnser: function getAwnser() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var resp;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this12.$store.dispatch("getNotificationAnswers");

              case 2:
                resp = _context11.sent;

                if (resp.status == 200) {
                  _this12.answers = resp.data;
                }

                // console.log(this.answers, 'caralho de asa cara')
                _this12.checkVouting(_this12.answers);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    },
    checkVouting: function checkVouting(el) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var answers, notifications, _loop, i;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                answers = el;
                notifications = _this13.notifications;

                _loop = function _loop(i) {
                  var found = !!answers.find(function (element) {
                    return element.notificationId === notifications[i].id;
                  });

                  if (!found) {
                    if (notifications[i].title == "net_dist") {
                      _this13.modalNotificationNetwork = true;
                    }

                    if (notifications[i].title == "blue_bsc") {
                      _this13.modalNotificationBSC = true;
                    }

                    if (notifications[i].title == "blue_club") {
                      _this13.modalNotificationBlueClub = true;
                    }

                    if (notifications[i].title == "blue_pool") {
                      _this13.modalNotificationBluePool = true;
                    }
                  }

                  if (found) {
                    if (notifications[i].title == "net_dist") {
                      _this13.modalNotificationNetwork = false;
                    }

                    if (notifications[i].title == "blue_bsc") {
                      _this13.modalNotificationBSC = false;
                    }

                    if (notifications[i].title == "blue_club") {
                      _this13.modalNotificationBlueClub = false;
                    }

                    if (notifications[i].title == "blue_pool") {
                      _this13.modalNotificationBluePool = false;
                    }
                  }
                };

                for (i in notifications) {
                  _loop(i);
                }

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this13);
      }))();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["b" /* mapGetters */])(["member", "bluAccount"])),
  watch: {
    member: function member() {
      this.checkTerms();
    }

    // answers: function () {
    //   this.checkVouting();
    // },
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.preSelectedCoins();
  },

  data: function data() {
    return {
      step: 1,
      info: "",
      checkedCoins: [],
      buttonBlock: false,
      coins: [{
        name: "Pancakeswap",
        symbol: "cake",
        percent: +1835,
        sector: "Decentralized Exchanges (DEX)",
        tokenType: "BEP20 (Binance Smart Chain)",
        rewards: "yes"
      }, {
        name: "Polygon",
        symbol: "matic",
        percent: +11844,
        sector: "Scaling",
        tokenType: "Native",
        rewards: "yes"
      }, {
        name: "Axie Infinity",
        symbol: "axs",
        percent: +16566,
        sector: "Metaverse",
        tokenType: "ERC-20 (Ethereum)",
        rewards: "yes"
      }, {
        name: "The Sandbox",
        symbol: "sand",
        percent: +13622,
        sector: "Metaverse",
        tokenType: "ERC-20 (Ethereum)",
        rewards: "yes"
      }, {
        name: "Decentraland",
        symbol: "mana",
        percent: +3855,
        sector: "Metaverse",
        tokenType: "ERC-20 (Ethereum)",
        rewards: "no"
      }, {
        name: "Mobox",
        symbol: "mbox",
        percent: +680,
        sector: "Metaverse",
        tokenType: "BEP20 (Binance Smart Chain)",
        rewards: "no"
      }],
      cake: 0,
      matic: 0,
      axs: 0,
      sand: 0,
      mana: 0,
      mbox: 0
    };
  },
  methods: {
    preSelectedCoins: function preSelectedCoins() {
      this.checkedCoins.push("cake");
      this.checkedCoins.push("matic");
    },
    getInfo: function getInfo(symb) {
      if (this.checkedCoins.length < 2) {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.push(symb);
        }
      } else {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.shift();
          this.checkedCoins.push(symb);
        }
      }
    },
    callNext: function callNext() {
      this.step++;
    },
    postVote: function postVote() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                _this.buttonBlock = true;

                _this.checkedCoins.forEach(function (element) {
                  _this[element]++;
                });

                params = {
                  answer: "{\"cake\":\"" + _this.cake + "\",\"matic\":\"" + _this.matic + "\",\"axs\":\"" + _this.axs + "\",\"sand\":\"" + _this.sand + "\",\"mana\":\"" + _this.mana + "\",\"mbox\":\"" + _this.mbox + "\"}"
                };
                _context.prev = 3;
                _context.next = 6;
                return _this.$store.dispatch("postSurveyPrototype", params).then(_this.notifySuccess(_this.$t("msg.vote_success"), 3000));

              case 6:
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);

                _this.notifyError(_this.$t("msg.form_error"), 3000);
                _this.buttonBlock = false;

              case 12:

                setTimeout(function () {
                  _this.$emit("getVotingStatus");
                }, 1500);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 8]]);
      }))();
    }
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount"]))
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.preSelectedCoins();
  },

  data: function data() {
    return {
      step: 1,
      info: "",
      checkedCoins: [],
      buttonBlock: false,
      coins: [{
        name: "Pancakeswap",
        symbol: "cake",
        percent: -73.61,
        sector: "decentralized_ex",
        tokenType: "bep20",
        rewards: "yes"
      }, {
        name: "Mobox",
        symbol: "mbox",
        percent: -89.06,
        sector: "metaverse",
        tokenType: "bep20",
        rewards: "no"
      }, {
        name: "Tezos",
        symbol: "xtz",
        percent: -68.04,
        sector: "smart_contracts",
        tokenType: "native",
        rewards: "yes"
      }, {
        name: "The Sandbox",
        symbol: "sand",
        percent: -84.34,
        sector: "metaverse",
        tokenType: "erc20",
        rewards: "yes"
      }, {
        name: "Polygon",
        symbol: "matic",
        percent: -83.20,
        sector: "scaling",
        tokenType: "native",
        rewards: "no"
      }, {
        name: "Elrond",
        symbol: "egld",
        percent: -74.80,
        sector: "smart_contracts",
        tokenType: "native",
        rewards: "yes"
      }],
      cake: 0,
      mbox: 0,
      xtz: 0,
      sand: 0,
      matic: 0,
      egld: 0
    };
  },
  methods: {
    preSelectedCoins: function preSelectedCoins() {
      this.checkedCoins.push("cake");
      this.checkedCoins.push("mbox");
    },
    getInfo: function getInfo(symb) {
      if (this.checkedCoins.length < 2) {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.push(symb);
        }
      } else {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.shift();
          this.checkedCoins.push(symb);
        }
      }
    },
    callNext: function callNext() {
      this.step++;
    },
    postVote: function postVote() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                _this.buttonBlock = true;

                _this.checkedCoins.forEach(function (element) {
                  _this[element]++;
                });

                params = {
                  answer: "{\"cake\":\"" + _this.cake + "\",\"mbox\":\"" + _this.mbox + "\",\"xtz\":\"" + _this.xtz + "\",\"sand\":\"" + _this.sand + "\",\"matic\":\"" + _this.matic + "\",\"egld\":\"" + _this.egld + "\"}"
                };
                _context.prev = 3;
                _context.next = 6;
                return _this.$store.dispatch("postSurveyPrototype", params).then(_this.notifySuccess(_this.$t("msg.vote_success"), 3000));

              case 6:
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);

                _this.notifyError(_this.$t("msg.form_error"), 3000);
                _this.buttonBlock = false;

              case 12:

                setTimeout(function () {
                  _this.$emit("getVotingStatus");
                }, 1500);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 8]]);
      }))();
    }
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount"]))
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseLanguageBar__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BluPricesHeader__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseWrittenLogo_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WebBanner__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    window.addEventListener("resize", this.checkIfMobile);
    this.getRoute();

    console.log(this.route);
  },
  mounted: function mounted() {
    this.checkIfMobile();
  },

  data: function data() {
    return {
      fiveMinutesInMiliSeconds: 5 * 60 * 1000,
      isMobile: "",
      openedMobileMenu: false,
      route: "???",
      routeParams: "deposit",
      banner: false,
      toggleService: false,

      services: [{
        type: "deposit",
        link: "/services/deposit",
        icon: "blu_deposit_icon",
        icon_activated: "blu_deposit_icon_green"
      }, {
        type: "withdraw",
        link: "/services/withdraw",
        icon: "blu_withdraw_icon",
        icon_activated: "blu_withdraw_icon_green"
      }, {
        type: "internal",
        link: "/services/internal",
        icon: "internal_icon",
        icon_activated: "internal_icon_green"
      }, {
        type: "redeem",
        link: "/services/redeem",
        icon: "blu_redeem_icon",
        icon_activated: "blu_redeem_icon_green"
      }]
    };
  },
  components: {
    BluPricesHeader: __WEBPACK_IMPORTED_MODULE_1__BluPricesHeader__["a" /* default */],
    BaseWrittenLogo: __WEBPACK_IMPORTED_MODULE_2__BaseWrittenLogo_vue__["a" /* default */],
    BaseLanguageBar: __WEBPACK_IMPORTED_MODULE_0__BaseLanguageBar__["a" /* default */],
    Router: __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */],
    WebBanner: __WEBPACK_IMPORTED_MODULE_3__WebBanner__["a" /* default */]
  },
  methods: {
    toggleServiceDrop: function toggleServiceDrop() {
      this.toggleService = !this.toggleService;
    },
    checkParams: function checkParams(el) {
      if (this.$router.history.current.params) {
        if (this.$router.history.current.params.arg == el) {
          return true;
        }
      }
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;
      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    openMobileMenu: function openMobileMenu() {
      this.openedMobileMenu = true;
    },
    closeMobileMenu: function closeMobileMenu() {
      this.openedMobileMenu = false;
    },
    isActivatedDropItem: function isActivatedDropItem() {},
    logout: function logout() {
      this.$store.dispatch("logout", "Logout");
      this.$router.push("login");
    },
    getRoute: function getRoute() {
      console.log("aquii");
      var current = this.$router.history.current.name;
      this.routeParams = this.$router.history.current.params.arg;
      this.route = current;
    },
    showContact: function showContact() {
      this.$emit("showModal");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["bluValue", "accounts", "currencies", "member"])),
  watch: {
    $route: function $route(to, from) {
      this.getRoute();
      this.closeMobileMenu();
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_banner_stratumblue_web_banner_jpg__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_banner_stratumblue_web_banner_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_banner_stratumblue_web_banner_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_banner_stratumblue_mobile_banner_jpg__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_banner_stratumblue_mobile_banner_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_banner_stratumblue_mobile_banner_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_banner_stratumblue_web_banner_es_jpg__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_banner_stratumblue_web_banner_es_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_banner_stratumblue_web_banner_es_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_banner_stratumblue_mobile_banner_es_jpg__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_banner_stratumblue_mobile_banner_es_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_banner_stratumblue_mobile_banner_es_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      banner: __WEBPACK_IMPORTED_MODULE_0__assets_images_banner_stratumblue_web_banner_jpg___default.a,
      bannerMobile: __WEBPACK_IMPORTED_MODULE_1__assets_images_banner_stratumblue_mobile_banner_jpg___default.a,
      bannerEs: __WEBPACK_IMPORTED_MODULE_2__assets_images_banner_stratumblue_web_banner_es_jpg___default.a,
      bannerMobileEs: __WEBPACK_IMPORTED_MODULE_3__assets_images_banner_stratumblue_mobile_banner_es_jpg___default.a
    };
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["languageSelected"]))
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.preSelectedCoins();
  },

  data: function data() {
    return {
      step: 1,
      info: "",
      checkedCoins: [],
      buttonBlock: false,
      coins: [{
        name: "Pancakeswap",
        symbol: "cake",
        percent: -62.86,
        sector: "decentralized_ex",
        tokenType: "bep20",
        rewards: "yes"
      }, {
        name: "Mobox",
        symbol: "mbox",
        percent: -87.74,
        sector: "metaverse",
        tokenType: "bep20",
        rewards: "no"
      }, {
        name: "Tezos",
        symbol: "xtz",
        percent: -66.82,
        sector: "smart_contracts",
        tokenType: "native",
        rewards: "yes"
      }, {
        name: "Ethereum Classic",
        symbol: "etc",
        percent: -19.48,
        sector: "smart_contracts",
        tokenType: "native",
        rewards: "yes"
      }, {
        name: "The Sandbox",
        symbol: "sand",
        percent: -85.50,
        sector: "metaverse",
        tokenType: "erc20",
        rewards: "yes"
      }, {
        name: "Elrond",
        symbol: "egld",
        percent: -80.50,
        sector: "smart_contracts",
        tokenType: "native",
        rewards: "yes"
      }],
      cake: 0,
      mbox: 0,
      xtz: 0,
      etc: 0,
      sand: 0,
      egld: 0
    };
  },
  methods: {
    preSelectedCoins: function preSelectedCoins() {
      this.checkedCoins.push("cake");
      this.checkedCoins.push("mbox");
    },
    getInfo: function getInfo(symb) {
      if (this.checkedCoins.length < 2) {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.push(symb);
        }
      } else {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.shift();
          this.checkedCoins.push(symb);
        }
      }
    },
    callNext: function callNext() {
      this.step++;
    },
    postVote: function postVote() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                _this.buttonBlock = true;

                _this.checkedCoins.forEach(function (element) {
                  _this[element]++;
                });

                params = {
                  answer: "{\"cake\":\"" + _this.cake + "\",\"mbox\":\"" + _this.mbox + "\",\"xtz\":\"" + _this.xtz + "\",\"etc\":\"" + _this.etc + "\",\"sand\":\"" + _this.sand + "\",\"egld\":\"" + _this.egld + "\"}"
                };
                _context.prev = 3;
                _context.next = 6;
                return _this.$store.dispatch("postSurveyPrototype", params).then(_this.notifySuccess(_this.$t("msg.vote_success"), 3000));

              case 6:
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);

                _this.notifyError(_this.$t("msg.form_error"), 3000);
                _this.buttonBlock = false;

              case 12:

                setTimeout(function () {
                  _this.$emit("getVotingStatus");
                }, 1500);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 8]]);
      }))();
    }
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount"]))
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["bscId"],
  created: function created() {},

  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    closeModalNetwork: function closeModalNetwork() {
      this.loading = true;
      this.$emit("closeModalNetwork", this.bscId);
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__public_Loading__["a" /* default */]
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['closeModalNetwork'],
  props: ["dhbId"],
  created: function created() {},

  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    closeModalNetwork: function closeModalNetwork() {
      this.loading = true;

      console.log('emit id', this.dhbId, 'aquiiiiiiiiii');
      var teste = this.dhbId;
      this.$emit("closeModalNetwork", teste);
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__public_Loading__["a" /* default */]
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["networkId"],
  created: function created() {},

  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    closeModalNetwork: function closeModalNetwork() {
      this.loading = true;
      this.$emit("closeModalNetwork", this.networkId);
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__public_Loading__["a" /* default */]
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkScreen();
  },

  data: function data() {
    return {
      checkTerms: false,
      handleScroll: "",
      batata: "",
      screenMobile: "",
      docOpened: false,
      loading: false
    };
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__public_Loading__["a" /* default */]
  },
  methods: {
    callNext: function callNext() {
      var _this = this;

      this.loading = true;
      try {
        this.$store.dispatch("putAcceptPrivacy");
        setTimeout(function () {
          _this.$emit("closeModal");
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    },
    docIsOpened: function docIsOpened() {
      this.docOpened = true;
    },
    checkScreen: function checkScreen() {
      var screen = window.innerWidth;

      if (screen < 800) {
        this.screenMobile = true;
      } else {
        this.screenMobile = false;
      }
    },
    mapScroll: function mapScroll() {
      var contTerms = document.getElementsByClassName("pdf-container");
      var scrollTop = contTerms[0].scrollTop;
      var contSize = contTerms[0].scrollHeight - 2 - contTerms[0].clientHeight;

      if (scrollTop >= contSize) {
        this.handleScroll = true;
      } else {
        this.handleScroll = false;
      }
    }
  },
  computed: {}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkScreen();
  },

  data: function data() {
    return {
      checkTerms: false,
      handleScroll: "",
      batata: "",
      screenMobile: "",
      docOpened: false,
      loading: false
    };
  },
  methods: {
    callNext: function callNext() {
      var _this = this;

      this.loading = true;
      try {
        this.$store.dispatch("putAcceptTerms");
        setTimeout(function () {
          _this.$emit("closeModal");
        }, 1000);
      } catch (e) {
        console.log(e);
      }
    },
    docIsOpened: function docIsOpened() {
      this.docOpened = true;
    },
    checkScreen: function checkScreen() {
      var screen = window.innerWidth;

      if (screen < 800) {
        this.screenMobile = true;
      } else {
        this.screenMobile = false;
      }
    },
    mapScroll: function mapScroll() {
      var contTerms = document.getElementsByClassName("pdf-container");
      var scrollTop = contTerms[0].scrollTop;
      var contSize = contTerms[0].scrollHeight - 2 - contTerms[0].clientHeight;

      if (scrollTop >= contSize) {
        this.handleScroll = true;
      } else {
        this.handleScroll = false;
      }
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__public_Loading__["a" /* default */]
  },
  computed: {}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.preSelectedCoins();
  },

  data: function data() {
    return {
      step: 1,
      info: "",
      checkedCoins: [],
      buttonBlock: false,
      coins: [{
        name: "Pancakeswap",
        symbol: "cake",
        percent: -71.27,
        sector: "decentralized_ex",
        tokenType: "bep20",
        rewards: "yes"
      }, {
        name: "Mobox",
        symbol: "mbox",
        percent: -92.31,
        sector: "metaverse",
        tokenType: "bep20",
        rewards: "no"
      }, {
        name: "The Sandbox",
        symbol: "sand",
        percent: -92.48,
        sector: "metaverse",
        tokenType: "erc20",
        rewards: "yes"
      }, {
        name: "Stellar",
        symbol: "xlm",
        percent: -75.59,
        sector: "payments",
        tokenType: "native",
        rewards: "no"
      }, {
        name: "Uniswap",
        symbol: "uni",
        percent: -69.3,
        sector: "decentralized_ex",
        tokenType: "erc20",
        rewards: "no"
      }, {
        name: "Toncoin",
        symbol: "ton",
        percent: -30.89,
        sector: "payments",
        tokenType: "native",
        rewards: "no"
      }],
      cake: 0,
      mbox: 0,
      sand: 0,
      xlm: 0,
      uni: 0,
      ton: 0
    };
  },
  methods: {
    preSelectedCoins: function preSelectedCoins() {
      this.checkedCoins.push("cake");
      this.checkedCoins.push("mbox");
    },
    getInfo: function getInfo(symb) {
      if (this.checkedCoins.length < 2) {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.push(symb);
        }
      } else {
        if (this.checkedCoins.includes(symb)) {} else {
          this.checkedCoins.shift();
          this.checkedCoins.push(symb);
        }
      }
    },
    callNext: function callNext() {
      this.step++;
    },
    postVote: function postVote() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.buttonBlock = true;

                _this.checkedCoins.forEach(function (element) {
                  _this[element]++;
                });

                params = {
                  answer: "{\"cake\":\"" + _this.cake + "\",\"mbox\":\"" + _this.mbox + "\",\"sand\":\"" + _this.sand + "\",\"xlm\":\"" + _this.xlm + "\",\"uni\":\"" + _this.uni + "\",\"ton\":\"" + _this.ton + "\"}"
                };
                _context.prev = 3;
                _context.next = 6;
                return _this.$store.dispatch("postSurveyPrototype", params).then(_this.notifySuccess(_this.$t("msg.vote_success"), 3000));

              case 6:
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](3);

                _this.notifyError(_this.$t("msg.form_error"), 3000);
                _this.buttonBlock = false;

              case 12:

                setTimeout(function () {
                  _this.$emit("getVotingStatus");
                }, 1500);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 8]]);
      }))();
    }
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount"]))
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["bscId"],
  created: function created() {},

  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    closeModalNetwork: function closeModalNetwork() {
      this.loading = true;
      this.$emit("closeModalNetwork", this.bscId);
    }
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__public_Loading__["a" /* default */]
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_private_landing_LandingBalance2__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_private_landing_TodaysMarket__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_private_landing_LandingBuyRedeem__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_private_landing_LandingPortfolio__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_private_landing_LandingPortfolioList__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_private_landing_LandingRecentTransactions__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_modalOtherCurrencies_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_modalBlueClubInfo_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_modalClainBlueClubInfo_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getMaintenanceStatus();
    // this.orderAssetList(this.assetListFake);

    this.getAssetsTail();
    this.convertValues();
    this.getAccounts();

    this.getFundTails();
    console.log(this.usdtValue[0].symbol);
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      updateBalance: "", //remove
      balance: "0", //remove
      maintenanceStatus: "",
      state: "list",
      active: false,
      isLanding: true,
      assetList: "",
      type: "",

      cryptoEquivalence: ["BTC", "ETH", "RAS", "USDT"], //remove
      BTC: "", //remove
      ETH: "", //remove
      RAS: "", //remove
      USDT: "",
      balanceBlu: "",
      fundTails: "",
      modalCurrencies: false,
      modalBlueClubInfo: false,
      modalClainBlueClubInfo: false,
      showBalance: true
    };
  },
  components: {
    LandingBalance: __WEBPACK_IMPORTED_MODULE_0__components_private_landing_LandingBalance2__["a" /* default */],
    TodaysMarket: __WEBPACK_IMPORTED_MODULE_1__components_private_landing_TodaysMarket__["a" /* default */],
    LandingBuyRedeem: __WEBPACK_IMPORTED_MODULE_2__components_private_landing_LandingBuyRedeem__["a" /* default */],
    LandingPortfolio: __WEBPACK_IMPORTED_MODULE_3__components_private_landing_LandingPortfolio__["a" /* default */],
    LandingPortfolioList: __WEBPACK_IMPORTED_MODULE_4__components_private_landing_LandingPortfolioList__["a" /* default */],
    LandingRecentTransactions: __WEBPACK_IMPORTED_MODULE_5__components_private_landing_LandingRecentTransactions__["a" /* default */],
    ModalOtherCurrencies: __WEBPACK_IMPORTED_MODULE_6__components_modals_modalOtherCurrencies_vue__["a" /* default */],
    modalBlueClubInfo: __WEBPACK_IMPORTED_MODULE_7__components_modals_modalBlueClubInfo_vue__["a" /* default */],
    modalClainBlueClubInfoVue: __WEBPACK_IMPORTED_MODULE_8__components_modals_modalClainBlueClubInfo_vue__["a" /* default */]
  },
  methods: {
    convertValues: function convertValues() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var currencies, i, resp, j;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currencies = void 0;
                _context.t0 = regeneratorRuntime.keys(_this.cryptoEquivalence);

              case 2:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 10;
                  break;
                }

                i = _context.t1.value;
                _context.next = 6;
                return _this.$store.dispatch("getCurrencyByPair", _this.cryptoEquivalence[i]);

              case 6:
                resp = _context.sent;


                if (resp.status == 200) {
                  currencies = resp.data;
                  for (j in currencies) {
                    if (currencies[j].symbol == "BLU") {
                      _this[_this.cryptoEquivalence[i]] = currencies[j];
                    }
                  }
                } else {
                  console.log("something wrong!");
                }
                _context.next = 2;
                break;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getMaintenanceStatus: function getMaintenanceStatus() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$store.dispatch("getMaintenanceStatus");

              case 3:
                _this2.maintenanceStatus = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                throw _context2.t0;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6]]);
      }))();
    },
    startInterval: function startInterval() {
      this.updateBalance = setInterval(this.getBalance, 30000);
    },
    getBalance: function getBalance() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var bluAccount;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$store.dispatch("updateBluAccount");
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$store.dispatch("getAccountSelected", "BLU");

              case 4:
                bluAccount = _context3.sent;

                _this3.balance = bluAccount.balance;
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                throw _context3.t0;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8]]);
      }))();
    },
    tabSwap: function tabSwap(el) {
      this.state = el;
    },
    maintenanceCheck: function maintenanceCheck(maintananceStatus) {
      this.maintenanceStatus = maintananceStatus;
    },
    getAssetsTail: function getAssetsTail() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, resp, asset;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 50,
                  entryType: "live"
                };
                _context4.next = 3;
                return _this4.$store.dispatch("getAssetsTail", params);

              case 3:
                resp = _context4.sent;
                asset = resp.data;


                _this4.orderAssetList(asset);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    orderAssetList: function orderAssetList(asset) {
      var arrayIndex = asset;
      var arrayOpe = [];

      var otherCrypto = {
        assignedOverallWeight: 0,
        currency: {
          name: "Other cryptos",
          symbol: "OTC"
        },
        quantity: 0,
        pairPriceApplied: ""
      };

      asset.sort(function (a, b) {
        return a.assignedOverallWeight > b.assignedOverallWeight ? -1 : a.assignedOverallWeight < b.assignedOverallWeight ? 1 : 0;
      });

      this.assetList = asset;
      this.$store.commit("setAssetList", this.assetList);
    },
    showModalCurrencies: function showModalCurrencies(el) {
      this.type = el;
      this.modalCurrencies = !this.modalCurrencies;
    },
    showModalBlueClub: function showModalBlueClub(el) {
      this.type = el;
      this.modalBlueClubInfo = !this.modalBlueClubInfo;
    },
    showModalClainBlueClub: function showModalClainBlueClub(el) {
      this.type = el;
      this.modalClainBlueClubInfo = !this.modalClainBlueClubInfo;
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapGetters */])(["bluAccount", "usdtValue"])),
  watch: {}
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_LoadingCoinsSlider_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getRewardCheck();

    this.getAccounts();
    this.checkIfMobile();
    this.getFundTails();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      cryptoEquivalence: ["BTC", "ETH", "RAS", "USDT"], //remove
      BTC: "", //remove
      ETH: "", //remove
      RAS: "", //remove
      USDT: "",
      balanceBlu: "",
      fundTails: "",
      modalCurrencies: false,
      showBalance: true,
      isMobile: false,
      myBalanceExpand: false,
      blueClubInfo: {
        amount: 0,
        received: false,
        staus: "new",
        nftAddress: "",
        asGift: false
      }
    };
  },
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0__public_LoadingCoinsSlider_vue__["a" /* default */]
  },
  methods: (_methods = {
    currencyFormat: function currencyFormat(num, symb) {
      if (symb == "RAS" || symb == "USDT") {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return num.toFixed(8);
      }
    },
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    toggleModalBlueClub: function toggleModalBlueClub() {
      this.$emit("toggleModalBlueClub");
    },
    toggleModalClainBlueClub: function toggleModalClainBlueClub() {
      this.$emit("toggleModalClainBlueClub");
    },
    openSolonaNFT: function openSolonaNFT() {

      console.log(this.blueClubInfo, 'aquiii');
      window.open("https://solscan.io/token/" + this.blueClubInfo.nftAddress, "_blank");
    },
    toggleMenu: function toggleMenu() {
      this.myBalanceExpand = !this.myBalanceExpand;
    },
    getAccounts: function getAccounts() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, accouns;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getAccounts");

              case 2:
                response = _context.sent;

                if (response.status == 200) {
                  accouns = response.data;

                  _this.filterBlueAccounst(accouns);
                } else {
                  alert("error to get balances");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRewardCheck: function getRewardCheck() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getRewardCheck");

              case 2:
                response = _context2.sent;


                console.log(response);

                if (response.status == 200) {
                  if (response.data.amount > 0) {
                    _this2.blueClubInfo.amount = response.data.amount;
                  }
                  if (response.data.received) {
                    _this2.blueClubInfo.received = response.data.received;
                  }

                  if (response.data.status) {
                    _this2.blueClubInfo.staus = response.data.status;
                  }

                  if (response.data.nftAddress) {
                    _this2.blueClubInfo.nftAddress = response.data.nftAddress;
                  }

                  if (response.data.received) {
                    _this2.blueClubInfo.asGift = response.data.received;
                  }
                } else {
                  alert("error to get balances");
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterBlueAccounst: function filterBlueAccounst(el) {
      for (var i in el) {
        if (el[i].currency.symbol == "BLU") {
          this.balanceBlu = el[i];
          console.log(this.balanceBlu);
        }
      }
    },
    returnBySymbol: function returnBySymbol(symbol) {
      if (symbol == "USDT" || symbol == "RAS") {
        if (this[symbol].value) {
          return this[symbol].value.toFixed(2);
        }
      } else {
        if (this[symbol].value) {
          return this[symbol].value.toFixed(8);
        }
      }
    }
  }, _defineProperty(_methods, "currencyFormat", function currencyFormat(num, symb) {
    if (symb == "RAS" || symb == "USDT") {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
      return num.toFixed(8);
    }
  }), _defineProperty(_methods, "getFundTails", function getFundTails() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var params, resp;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              params = {
                offset: 0,
                limit: 50,
                entryType: "live"
              };
              _context3.prev = 1;
              _context3.next = 4;
              return _this3.$store.dispatch("getFundTails", params);

            case 4:
              resp = _context3.sent;

              _this3.fundTails = resp.data;
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);

              console.log("error ", _context3.t0);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[1, 8]]);
    }))();
  }), _defineProperty(_methods, "checkIfMobile", function checkIfMobile() {
    var w = window,
        x = w.innerWidth;

    if (x > 900) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }), _methods),
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["bluAccount", "usdtValue", "bluValue", "usdtAccount"])),
  watch: {}
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ab5aa6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingCoinsSlider_vue__ = __webpack_require__(808);
function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ab5aa6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingCoinsSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eye-show.svg?08bac24a83001cadb05d8ee5e969f933";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eye-hidden.svg?7f1d8b7efd809c06476aba58747ecb89";

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__public_charts_component_ChartLineAll__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__public_charts_component_ChartLineLatest__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_charts_component_ChartLineCustom__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LandingPortfolioList__ = __webpack_require__(374);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getAssetsTail();
    this.checkIfMobile();
  },
  mounted: function mounted() {
    this.toggleChart("days");
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      chartParams: false,
      startDateChartAll: "2018-12-04T00:00:09.0Z",
      positiveTotal: "",
      menuExpand: "",
      chartsHour: {
        data: false,
        step: "",
        type: "hour",
        min: ""
      },
      chartsDay: {
        data: false,
        step: "",
        type: "day",
        min: ""
      },
      chartsWeek: {
        data: false,
        step: "",
        type: "week",
        min: ""
      },

      chartsMonth: {
        data: false,
        step: "",
        type: "month",
        min: ""
      },

      chartsYear: {
        data: false,
        step: "",
        type: "year",
        min: ""
      },

      chartsAll: {
        data: false,
        step: "",
        type: "all",
        min: ""
      },

      chartLoading: true,
      chartMode: "all",
      isMobile: false,
      state: "list",
      assetList: ""
    };
  },
  components: {
    ChartLineAll: __WEBPACK_IMPORTED_MODULE_1__public_charts_component_ChartLineAll__["a" /* default */],
    ChartLineLatest: __WEBPACK_IMPORTED_MODULE_2__public_charts_component_ChartLineLatest__["a" /* default */],
    ChartLineCustom: __WEBPACK_IMPORTED_MODULE_3__public_charts_component_ChartLineCustom__["a" /* default */],
    LandingPortfolioList: __WEBPACK_IMPORTED_MODULE_4__LandingPortfolioList__["a" /* default */]
  },
  methods: {
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    toggleMenu: function toggleMenu() {
      this.menuExpand = !this.menuExpand;
    },
    getPercentChangeAll: function getPercentChangeAll() {
      var firstPrice = this.chartsAll.data[0] ? this.chartsAll.data[0].close : 0;
      var currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeHour: function getPercentChangeHour() {
      var firstPrice = this.chartsHour.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeDay: function getPercentChangeDay() {
      var firstPrice = this.chartsDay.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeYear: function getPercentChangeYear() {
      var firstPrice = this.chartsYear.data[0].close || 0;
      var currentlyPrice = this.bluValue[0].value;
      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeMonth: function getPercentChangeMonth() {
      var firstPrice = this.chartsMonth.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeWeek: function getPercentChangeWeek() {
      var firstPrice = this.chartsWeek.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    setChartLoading: function setChartLoading(bol) {
      this.chartLoading = bol;
    },

    // step 1 ...........................................................................
    toggleChart: function toggleChart(mode) {
      this.chartMode = mode;
      this.getHistoryDay();
    },


    // step 2 ...........................................................................

    getHistoryDay: function getHistoryDay() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                date = new Date();
                endHour = _this.sharedActions.formatDateTimeHistory(date);
                // date.setMonth(-1);

                date.setHours(0);
                date.setMinutes(0);
                startHour = _this.sharedActions.formatDateTimeHistory(date);


                console.log(startHour);
                console.log(endHour);

                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 60,
                  sumbols: "blu"
                };
                _context.next = 10;
                return _this.$store.dispatch("getCurrenciesHistory", params);

              case 10:
                resp = _context.sent;

                if (resp.status == 200) {
                  if (resp.data[0].history) {
                    _this.chartsDay.data = resp.data[0].history;
                    _this.getMinStep(resp.data[0].history, "day");
                  }
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getHistoryAll: function getHistoryAll() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                date = new Date();
                endHour = _this2.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(2018);
                startHour = _this2.sharedActions.formatDateTimeHistory(_this2.startDateChartAll);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context2.next = 7;
                return _this2.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context2.sent;

                _this2.chartsAll.data = resp.data[0].history;

                _this2.getMinStep(resp.data[0].history, "all");

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getMinStep: function getMinStep(resp, type) {
      var max = 0;
      var min = 1000;
      var step = "";

      for (var i in resp) {
        if (resp[i].close < min) {
          min = resp[i].close;
        }
        if (resp[i].close > max) {
          max = resp[i].close;
        }
      }

      var minFixed = min.toFixed();
      min = min.toFixed(2);
      max = max.toFixed(2);
      step = (max - min).toFixed(2) / 2;

      min = min - step * 2;

      if (type == "hour") {
        // min = min + 0.03
        this.chartsHour.min = min.toFixed(2);
        this.chartsHour.step = step;
        this.setChart("hour");
      }

      if (type == "day") {
        this.chartsDay.min = min.toFixed(2);
        this.chartsDay.step = step;
        this.setChart("day");
      }

      if (type == "all") {
        this.chartsAll.min = min.toFixed();
        this.chartsAll.step = step.toFixed();
        this.setChart("all");
      }
    },


    //step 3 ...........................................................................
    setChart: function setChart(mode) {
      if (mode == "hour") {
        this.chartParams = this.chartsHour;
      } else if (mode == "day") {
        this.chartParams = this.chartsDay;
      } else if (mode == "week") {
        this.chartParams = this.chartsWeek;
      } else if (mode == "month") {
        this.chartParams = this.chartsMonth;
      } else if (mode == "year") {
        this.chartParams = this.chartsYear;
      } else if (mode == "all") {
        this.chartParams = this.chartsAll;
      }
    },


    // step4 .........................................................................

    currencyFormat: function currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return 0;
      }
    },
    returnBySymbol: function returnBySymbol(symbol) {
      if (symbol == "USDT") {
        if (this[symbol].value) {
          return this[symbol].value.toFixed(2);
        }
      }
    },
    getAssetsTail: function getAssetsTail() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 50,
                  entryType: "live"
                };
                _context3.next = 3;
                return _this3.$store.dispatch("getAssetsTail", params);

              case 3:
                resp = _context3.sent;

                _this3.assetList = resp.data;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount", "usdtValue", "currencies", "btcValue", "bluValue"])),
  watch: {}
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineAll_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0448eab2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineAll_vue__ = __webpack_require__(813);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineAll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0448eab2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineAll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getFundTailsArchive();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      chart: "",
      selectedChart: "",
      fundTails: "??",
      allPeriod: false,
      lastFiveDays: false,
      fundTailsArchive: '',
      assetsPrices: [],
      assetsLabels: [],
      chartData: {
        labels: [],
        prices: []
      }
    };
  },
  components: {},
  methods: {
    setChartMode: function setChartMode(period) {
      var labels = this.assetsLabels;
      var prices = this.assetsPrices;

      this.allPeriod = true;
      this.lastFiveDays = false;
      this.chartData.labels = labels;
      this.chartData.prices = prices;

      this.setUpChart("2");
    },
    setArraysChart: function setArraysChart() {

      var archives = this.fundTailsArchive.data;
      var self = this;
      var today = new Date();
      var todayMonth = today.getMonth() + 1;

      if (todayMonth < 10) {
        todayMonth = "0" + todayMonth;
      }

      archives.sort(function (a, b) {
        var dataA = new Date(a.createdAt);
        var dataB = new Date(b.createdAt);
        return dataA - dataB;
      });

      for (var i = 0; i < archives.length; i++) {
        if (archives[i].tokenPrice && archives[i].createdAt && self.checkDate(archives[i])) {
          self.assetsPrices.push(archives[i].tokenPrice.toFixed(2));
          var date = new Date(archives[i].createdAt);
          self.assetsLabels.push(date.getDate() + " / " + (date.getMonth() + 1) + " / " + date.getFullYear());
        }
      }

      this.assetsLabels.push(today.getDate() + " / " + todayMonth + " / " + today.getFullYear());
      this.assetsPrices.push(this.bluValue[0].value.toFixed(2));
    },
    checkDate: function checkDate(date) {
      var startLimit = "2019-04-11T10:35:13.000Z";
      if (date.createdAt > startLimit) {
        return true;
      }
    },
    getFundTailsArchive: function getFundTailsArchive() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 50,
                  entryType: "archive"
                };
                _context.prev = 1;
                _context.next = 4;
                return _this.$store.dispatch("getFundTails", params);

              case 4:
                resp = _context.sent;

                _this.fundTailsArchive = resp;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.log("error ", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    setUpChart: function setUpChart(dataSet) {
      this.selectedChart = dataSet;

      var chartData2 = {
        type: "line",
        data: {
          labels: this.chartData.labels,
          datasets: [{
            label: "BLU (TUSD)",
            data: this.chartData.prices,
            backgroundColor: ["#424b7d"],
            borderColor: ["#424b7d"],
            fill: false,
            borderWidth: 2,
            lineTension: 0
          }]
        },
        options: {
          tooltips: {
            enabled: true,
            colors: "red",
            caretSize: 10,
            fill: true,
            displayColors: false,
            mode: "nearest"
          },

          legend: {
            display: false
          },

          elements: {
            point: {
              pointStyle: "circle",
              radius: 4
            }
          },

          scales: {
            xAxes: [{
              display: true
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: 30,
                stepSize: 10,
                callback: function callback(value) {
                  return value + " (TUSD)";
                }
              }
            }]
          }
        }
      };
      if (dataSet == "2") {
        this.createChart("mainChartBlu", chartData2);
      }
    },
    createChart: function createChart(chartId, chartData) {
      setTimeout(function () {
        var ctx = document.getElementById(chartId);
        var nasChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["currencies", "bluValue"])),
  watch: {
    fundTailsArchive: function fundTailsArchive() {
      this.setArraysChart();
      this.setChartMode("all");
    }
  }
});

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineLatest_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b505910e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineLatest_vue__ = __webpack_require__(814);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineLatest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b505910e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineLatest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["fundTailsArchive"],
  created: function created() {
    this.setArraysChart();
    this.setChartMode("latest");
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      chart: "",
      selectedChart: "",
      fundTails: "??",
      allPeriod: false,
      lastFiveDays: false,

      assetsPrices: [],
      assetsLabels: [],
      chartData: {
        labels: [],
        prices: []
      }
    };
  },
  components: {},
  methods: {
    setChartMode: function setChartMode(period) {
      var labels = this.assetsLabels;
      var prices = this.assetsPrices;

      this.allPeriod = false;
      this.lastFiveDays = true;
      this.chartData.labels = labels.slice(Math.max(labels.length - 6, 1));
      this.chartData.prices = prices.slice(Math.max(prices.length - 6, 1));

      this.setUpChart("2");
    },
    setArraysChart: function setArraysChart() {
      var archives = this.fundTailsArchive.data;
      var self = this;
      var today = new Date();
      var todayMonth = today.getMonth() + 1;

      if (todayMonth < 10) {
        todayMonth = "0" + todayMonth;
      }

      archives.sort(function (a, b) {
        var dataA = new Date(a.createdAt);
        var dataB = new Date(b.createdAt);
        return dataA - dataB;
      });

      for (var i = 0; i < archives.length; i++) {
        if (archives[i].tokenPrice && archives[i].createdAt && self.checkDate(archives[i])) {
          self.assetsPrices.push(archives[i].tokenPrice.toFixed(2));
          var date = new Date(archives[i].createdAt);
          self.assetsLabels.push(date.getDate() + " / " + (date.getMonth() + 1) + " / " + date.getFullYear());
        }
      }

      this.assetsLabels.push(today.getDate() + " / " + todayMonth + " / " + today.getFullYear());
      this.assetsPrices.push(this.bluValue[0].value.toFixed(2));
    },
    checkDate: function checkDate(date) {
      var startLimit = "2019-04-11T10:35:13.000Z";
      if (date.createdAt > startLimit) {
        return true;
      }
    },
    setUpChart: function setUpChart(dataSet) {
      this.selectedChart = dataSet;

      var chartData2 = {
        type: "line",
        data: {
          labels: this.chartData.labels,
          datasets: [{
            label: "BLU (TUSD)",
            data: this.chartData.prices,
            backgroundColor: ["#424b7d"],
            borderColor: ["#424b7d"],
            fill: false,
            borderWidth: 2,
            lineTension: 0
          }]
        },
        options: {
          tooltips: {
            enabled: true,
            colors: "red",
            caretSize: 10,
            fill: true,
            displayColors: false,
            mode: "nearest"
          },

          legend: {
            display: false
          },

          elements: {
            point: {
              pointStyle: "circle",
              radius: 4
            }
          },

          scales: {
            xAxes: [{
              display: true
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: 30,
                stepSize: 10,
                callback: function callback(value) {
                  return value + " (TUSD)";
                }
              }
            }]
          }
        }
      };
      if (dataSet == "2") {
        this.createChart("mainChartBlu", chartData2);
      }
    },
    createChart: function createChart(chartId, chartData) {
      setTimeout(function () {
        var ctx = document.getElementById(chartId);
        var nasChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["currencies", "bluValue"])),
  watch: {}
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineCustom_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bfdbc52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineCustom_vue__ = __webpack_require__(817);
function injectStyle (ssrContext) {
  __webpack_require__(815)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineCustom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bfdbc52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineCustom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["chartData", "bluValue"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      chartId: (Math.random() * 100).toFixed(),
      chart: false,
      chartDataOnChart: {
        labels: [],
        prices: []
      },

      stepSize: 10,
      min: 50,
      circle: 2
    };
  },
  components: {},
  methods: {
    setChartData: function setChartData() {
      var _this = this;

      var ghostChart = document.querySelector(".chartjs-size-monitor");
      if (ghostChart) {
        ghostChart.remove();
      }

      this.chartId = (Math.random() * 100).toFixed();

      setTimeout(function () {
        _this.$emit("chartLoaded");
        _this.setUpChart("2", _this.chartData);
      }, 1000);
    },
    setUpChart: function setUpChart(dataSet, chartContent) {
      var maxTicksLimitGraph = chartContent.type == "week" ? 7 : chartContent.type == "year" || chartContent.type == "ytd" ? 12 : chartContent.type == "all" && 5;

      var arr = void 0;

      var labels = this.chartDataOnChart.labels.map(function (el) {
        return el.slice(0, 16);
      });

      var chartData = {
        type: "line",
        data: {
          labels: labels,
          datasets: [{
            label: "BLUE (USDT)",
            data: this.chartDataOnChart.prices,
            backgroundColor: ["#424b7d"],
            borderColor: ["#424b7d"],
            fill: false,
            borderWidth: 2,
            lineTension: 0
          }]
        },
        options: {
          tooltips: {
            enabled: true,
            colors: "red",
            caretSize: 10,
            fill: true,
            displayColors: false,
            mode: "nearest"
          },

          legend: {
            display: false
          },

          elements: {
            point: {
              pointStyle: "circle",
              radius: this.circle
            }
          },

          scales: {
            xAxes: [{
              display: true,

              ticks: {
                display: true,
                autoSkip: false,
                maxTicksLimit: maxTicksLimitGraph,
                maxRotation: 30,

                callback: function callback(value, index) {
                  if (value) {
                    var hourValue = value.slice(11, 16);

                    var valueAll = value.split("/")[2].slice(0, 4);

                    var valueYear = value.split(" ")[0].slice(3, value.length);

                    var valueMonth = value.slice(0, 5);

                    if (chartContent.type == "all") {
                      if (arr != valueAll) {
                        arr = valueAll;
                        if (arr.includes("2018")) {
                          return null;
                        }
                        return arr;
                      }
                    } else if (chartContent.type == "year" || chartContent.type == "ytd") {
                      if (arr != valueYear) {
                        arr = valueYear;

                        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(arr, "MM/YYYY").format("MM/YY");
                      }
                    } else if (chartContent.type == "month" || chartContent.type == "week") {
                      if (arr != valueMonth) {
                        arr = valueMonth;

                        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(arr, "DD/MM/YYYY").format("DD/MM/YY");
                      }
                    } else if (chartContent.type == "day") {
                      if (arr != hourValue) {
                        arr = hourValue;

                        return arr;
                      }
                    } else {
                      if (arr != valueYear) {
                        arr = valueYear;

                        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(arr, "MM/YYYY").format("MM/YY");
                      }
                    }
                  }
                }
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: this.min,
                stepSize: this.stepSize,
                maxTicksLimit: 5,

                callback: function callback(value) {
                  var w = window,
                      x = w.innerWidth;

                  // if (x > 1200) {
                  //   return value + " (USDT)";
                  // } else {
                  //   return value;
                  // }
                  return value;
                }
              }
            }]
          }
        }
      };

      this.createChart("mainChartBlu" + this.chartId, chartData);
      this.chart = true;
    },
    createChart: function createChart(chartId, chartData) {
      setTimeout(function () {
        var ctx = document.getElementById(chartId);
        var nasChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    },
    splitChartData: function splitChartData(chartData) {
      this.chartDataOnChart.prices = [];
      this.chartDataOnChart.labels = [];

      for (var i = 0; i < chartData.length; i++) {
        this.chartDataOnChart.prices.push(chartData[i].close.toFixed(2));
        this.chartDataOnChart.labels.push(this.sharedActions.formatDateTime(chartData[i].at));
      }

      var date = new Date();

      if (this.bluValue) {
        this.chartDataOnChart.prices.push(this.bluValue.value.toFixed(2));
      } else {
        console.log("error blu value");
      }

      date.setHours(date.getHours());
      this.chartDataOnChart.labels.push(this.sharedActions.formatDateTime(date));

      this.chartDataOnChart.labels.push("");

      this.setChartData();
    },
    checkParams: function checkParams() {
      if (this.chartData.type == "all") {
        this.circle = 0;
      } else {
        this.circle = 2;
      }

      if (this.chartData.min != "") {
        if (this.chartData.min < 0) {
          this.min = 0;
        } else {
          this.min = this.chartData.min;
        }
      } else {
        this.min = 40;
      }

      if (this.chartData.step != "") {
        this.stepSize = this.chartData.step;
      } else {
        this.stepSize = 5;
      }
    }
  },
  computed: {},
  watch: {
    chartData: function chartData() {
      if (this.chartData) {
        this.chart = false;
        this.checkParams();
        this.$emit("chartLoading");
        this.splitChartData(this.chartData.data);
      }
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPortfolioList_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f13a0dc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPortfolioList_vue__ = __webpack_require__(820);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPortfolioList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f13a0dc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPortfolioList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public_charts_component_ChartLineMini__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["assetList"],
  created: function created() {
    this.orderArray();
    this.getPriceBySymb();
    this.getAllPricesPercent();
    this.checkIfMobile();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      percentChange: [],
      pair: "USDT",
      isMobile: false
    };
  },
  components: {
    ChartLineMini: __WEBPACK_IMPORTED_MODULE_0__public_charts_component_ChartLineMini__["a" /* default */]
  },
  methods: {
    currencyFormat: function currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    getPercentChangeBySymbol: function getPercentChangeBySymbol(symb) {
      if (this.percentChange) {
        if (symb) {
          var coinPercent = this.percentChange.filter(function (percent) {
            return percent.symbol == symb;
          });
          if (coinPercent[0]) {
            if (coinPercent[0]["24h"]) {
              return coinPercent[0]["24h"].toFixed(2);
            }
          }
        }
      }
    },
    getAllPricesPercent: function getAllPricesPercent() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var symb, i, params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                symb = "";


                for (i in _this.assetList) {
                  if (_this.assetList[i].currency.symbol != "OTC") {
                    symb += _this.assetList[i].currency.symbol + ",";
                  }
                }

                symb = symb.replace(/,\s*$/, "");

                params = {
                  pair: "USDT",
                  symbols: symb
                };
                _context.next = 6;
                return _this.$store.dispatch("getPricePercentChange", params);

              case 6:
                resp = _context.sent;

                _this.percentChange = resp.data;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    orderArray: function orderArray() {
      this.assetList.sort(function (a, b) {
        return a.assignedOverallWeight > b.assignedOverallWeight ? -1 : a.assignedOverallWeight < b.assignedOverallWeight ? 1 : 0;
      });
    },
    getPriceBySymb: function getPriceBySymb(coinSymb) {
      for (var i in this.currencies) {
        if (this.currencies[i].symbol == coinSymb) {
          return this.currencies[i].value;
        }
      }
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(["currencies"])),
  watch: {}
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["coin"],
  created: function created() {
    this.getHistoryDay();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      chartId: (Math.random() * 5000).toFixed(),
      chart: false,
      chartDataOnChart: {
        labels: [],
        prices: []
      }
    };
  },
  components: {},
  methods: {
    getHistoryDay: function getHistoryDay() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                date = new Date();
                endHour = _this.sharedActions.formatDateTimeHistory(date);

                date.setDate(date.getDate() - 7);
                startHour = _this.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 60,
                  sumbols: _this.coin
                };
                _context.next = 7;
                return _this.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context.sent;

                _this.filterChartData(resp.data[0]);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filterChartData: function filterChartData(data) {
      var arrayPrices = [];
      var arrayDates = [];

      for (var i in data.history) {
        arrayPrices.push(data.history[i].close);
      }
      for (var _i in data.history) {
        arrayDates.push(data.history[_i].at);
      }

      this.chartDataOnChart.prices = arrayPrices;
      this.chartDataOnChart.labels = arrayDates;

      this.setUpChart();
    },
    setUpChart: function setUpChart() {
      var chartData = {
        type: "line",
        data: {
          labels: this.chartDataOnChart.labels,
          datasets: [{
            label: "BLU (TUSD)",
            data: this.chartDataOnChart.prices,
            backgroundColor: ["#8a8bbe"],
            borderColor: ["#8a8bbe"],
            fill: false,
            borderWidth: 2,
            lineTension: 0
          }]

        },

        options: {
          tooltips: {
            enabled: false
          },

          legend: {
            display: false
          },

          elements: {
            display: false,
            point: {
              pointStyle: "none",
              radius: 0,
              hitRadius: 0
            }
          },

          scales: {
            xAxes: [{
              display: false
            }],
            yAxes: [{
              display: false,
              legend: false
            }]
          }
        }
      };

      this.createChart("mainChartBlu" + this.chartId, chartData);
      this.chart = true;
    },
    createChart: function createChart(chartId, chartData) {
      setTimeout(function () {
        var ctx = document.getElementById(chartId);
        var nasChart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    }
  },
  computed: {},
  watch: {
    chartData: function chartData() {
      if (this.chartData) {
        this.chart = false;
      }
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_buy_blu_BaseBuyBlu__ = __webpack_require__(825);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      operation: "NEW"
    };
  },
  components: {
    BaseBuyBlu: __WEBPACK_IMPORTED_MODULE_0__base_buy_blu_BaseBuyBlu__["a" /* default */]
  },
  methods: {
    switchTab: function switchTab(tab) {
      this.operation = tab;
    },
    maintenanceCheck: function maintenanceCheck(maintananceStatus) {
      this.$emit("maintenanceCheck", maintananceStatus);
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseBuyBluBuy__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseBuyBluWatch__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__public_LoadingBuyBlu__ = __webpack_require__(380);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getFees();
    this.getPurchases();
    this.checkIfMobile();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      fees: "",
      selectedAccount: "",
      bluAmount: 0,
      btc: "",
      maxBluAmount: 99999999999,
      tooltipBonus: false,
      tooltipStratum: false,
      transactionState: 0,
      tooLong: false,
      btcAccount: "",
      paymentMode: "",
      bluTusd: "",
      purchases: "",
      purchaseWaiting: "",
      loading: true,
      isMobile: false,
      myBalanceExpand: true
    };
  },
  components: {
    baseBuyBluBuy: __WEBPACK_IMPORTED_MODULE_1__BaseBuyBluBuy__["a" /* default */],
    baseBuyBluWatch: __WEBPACK_IMPORTED_MODULE_2__BaseBuyBluWatch__["a" /* default */],
    TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__["TheMask"],
    LoadingBuyBlu: __WEBPACK_IMPORTED_MODULE_4__public_LoadingBuyBlu__["a" /* default */]
  },
  methods: {
    getPurchases: function getPurchases() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getPurchases");

              case 3:
                resp = _context.sent;

                _this.purchases = resp.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                _this.logError(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    toggleMenu: function toggleMenu() {
      this.myBalanceExpand = !this.myBalanceExpand;
    },
    getFees: function getFees() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp, purchaseFee;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$store.dispatch("getFees");

              case 3:
                resp = _context2.sent;
                purchaseFee = resp.data.filter(function (fee) {
                  if (fee.createdAt) {
                    return fee.type == "purchase";
                  }
                });


                purchaseFee.sort(function (a, b) {
                  if (a.startAt > b.startAt) return 1;
                  if (a.startAt < b.startAt) return -1;
                  return 0;
                });

                _this2.fees = purchaseFee[purchaseFee.length - 1];
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.log("could not load fees: ", _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    callNextState: function callNextState(paymentMode, bluTusd) {
      this.bluTusd = bluTusd;
      this.paymentMode = paymentMode;
      this.forceStateChange();
    },
    setTooLongFalse: function setTooLongFalse() {
      this.tooLong = false;
    },
    forceStateChange: function forceStateChange() {
      if (this.transactionState < 1) {
        this.transactionState = this.transactionState + 1;
        this.scrollToAnchor();
      } else {
        this.transactionState = 0;
      }
    },
    scrollToAnchor: function scrollToAnchor() {
      function scrollTo(element) {
        window.scroll({
          behavior: "smooth",
          left: 0,
          top: element.offsetTop - 20
        });
      }
      scrollTo(document.getElementById("landing_buy_blu"));
    },
    checkTranscationStatus: function checkTranscationStatus() {
      var trades = this.purchases;

      // //remover - test p
      // this.transactionState = 1;

      for (var i in trades) {
        if (trades[i].status == "waiting") {
          this.purchaseWaiting = trades[i];
          this.transactionState = 1;
        }
      }
      this.loading = false;
    },
    maintenanceCheck: function maintenanceCheck(maintananceStatus) {
      this.$emit("maintenanceCheck", maintananceStatus);
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["accounts", "currencies"])),
  watch: {
    purchases: function purchases() {
      this.checkTranscationStatus();
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__public_LoadingBuyBlu__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_Loading__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_modalBuyBluePIX_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_coins_bitcoin_buyBlue_svg__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_coins_bitcoin_buyBlue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_coins_bitcoin_buyBlue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_coins_ethereum_buyBlue_svg__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_coins_ethereum_buyBlue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_coins_ethereum_buyBlue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_coins_tether_buyBlue_svg__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_coins_tether_buyBlue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_coins_tether_buyBlue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_coins_pix_buyBlue_svg__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_coins_pix_buyBlue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_coins_pix_buyBlue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_phone_number_input__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_phone_number_input_dist_vue_phone_number_input_css__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_phone_number_input_dist_vue_phone_number_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_phone_number_input_dist_vue_phone_number_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
var _props$created$mounte;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = (_props$created$mounte = {
  props: ["fees"],
  created: function created() {
    var _this = this;

    this.$store.dispatch("updateCurrencies").then(function (resp) {
      _this.getMinBlu();
    });

    this.checkCountry();
    this.getPurchases();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      formFinish: false,
      loading: true,
      loadingButton: false,
      minBlue: null,
      minBtc: 0.02,
      bluAmount: "0.00",
      firstLoad: true,
      bluTusd: "",
      previewData: "...",
      selectedAccount: "",
      locked: "",
      bluAmountValid: false,
      toolTipCharity: false,
      maxBluAmount: 99999999999,
      tooltipBonus: false,
      tooltipStratum: false,
      modalWarning: false,
      stepSellerInfoUid: false,
      purchaseReferral: "",
      newPurchaseReferal: "",
      selectedCurrency: "",
      referStep: false,
      stepForm: false,
      confirTerms: false,
      btc: "",
      blu: "",
      uid: "",
      trade: "",
      temporaryBalance: 0,
      selectWay: "",
      skipReferral: false,
      foundMember: false,
      blockMsg: false,
      currencyList: [{
        name: "Bitcoin",
        symbol: "BTC",
        isAvailable: "",
        img: __WEBPACK_IMPORTED_MODULE_5__assets_images_coins_bitcoin_buyBlue_svg___default.a
      }, {
        name: "Ethereum",
        symbol: "ETH",
        isAvailable: "",
        img: __WEBPACK_IMPORTED_MODULE_6__assets_images_coins_ethereum_buyBlue_svg___default.a
      }, {
        name: "Tether",
        symbol: "USDT",
        isAvailable: "",
        img: __WEBPACK_IMPORTED_MODULE_7__assets_images_coins_tether_buyBlue_svg___default.a
      }],

      name: "",
      email: "",
      phone: "",
      purchases: "",
      isMobile: "",
      memberFound: "",
      modalPIX: false
    };
  },
  components: {
    TheMask: __WEBPACK_IMPORTED_MODULE_1_vue_the_mask__["TheMask"],
    Loading: __WEBPACK_IMPORTED_MODULE_3__public_Loading__["a" /* default */],
    VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_9_vue_phone_number_input___default.a,
    LoadingBuyBlu: __WEBPACK_IMPORTED_MODULE_2__public_LoadingBuyBlu__["a" /* default */],
    Swal: __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a,
    ModalBuyBluePIX: __WEBPACK_IMPORTED_MODULE_4__modals_modalBuyBluePIX_vue__["a" /* default */]
  }
}, _defineProperty(_props$created$mounte, "mounted", function mounted() {
  window.addEventListener("resize", this.checkIfMobile);
  this.checkIfMobile();
}), _defineProperty(_props$created$mounte, "methods", {
  getPurchases: function getPurchases() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var resp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.$store.dispatch("getPurchases");

            case 3:
              resp = _context.sent;

              _this2.purchases = resp.data;
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              _this2.logError(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7]]);
    }))();
  },
  findMember: function findMember() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var uid, resp;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              uid = _this3.uid;
              _context2.next = 3;
              return _this3.$store.dispatch("getMemberByUID", uid);

            case 3:
              resp = _context2.sent;

              if (resp.status == 200) {
                if (resp.data.length > 0) {
                  _this3.foundMember = true;
                  _this3.memberFound = resp.data[0];
                } else {
                  _this3.notifyDanger(_this3.$t("msg.member_not_found"), 5000);
                }
              } else {
                _this3.notifyDanger(_this3.$t("msg.member_not_found"), 5000);
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  postOtcPurchase: function postOtcPurchase() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var body;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this4.bluAmount == "" || _this4.uid == "")) {
                _context3.next = 4;
                break;
              }

              _this4.notifyDanger(_this4.$t("msg.required_fields_amount_uid"), 5000);
              _context3.next = 7;
              break;

            case 4:
              body = {
                memberUID: _this4.memberFound.uid,
                sourceCurrency: _this4.selectedCurrency,
                targetAmount: parseFloat(_this4.bluAmount)
              };
              _context3.next = 7;
              return _this4.$store.dispatch("postSellerPurchase", body).then(function (r) {
                _this4.$emit("callNextState", _this4.paymentMode, _this4.bluTusd.toFixed(2));

                if (r.status == 200) {
                  _this4.notifySuccess(_this4.$t("msg.purchase_success"), 5000);
                  location.reload();
                }
              }).catch(function (e) {
                alert(e);
                _this4.loadingButton = false;
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },
  checkIfMobile: function checkIfMobile() {
    var w = window,
        x = w.innerWidth;

    if (x > 1200) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
  checkTranscationStatus: function checkTranscationStatus() {
    var trades = this.purchases;
    for (var i in trades) {
      if (trades[i].status == "waiting") {
        this.purchaseWaiting = trades[i];
        this.transactionState = 1;
      }
    }
  },
  checkCountry: function checkCountry() {
    console.log();
  },
  firstStep: function firstStep() {
    this.loadingButton = false;
    this.selectWay = false;
    this.modalWarning = false;
    this.stepForm = false;
    this.formFinish = false;
  },
  fillFieldsForm: function fillFieldsForm() {
    this.name = this.member.name;
    this.email = this.member.email;
    this.phone = this.member.phone;
    this.bluAmount;
  },
  sendEmailOtc: function sendEmailOtc() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var email;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this5.loadingButton = true;
              if (!_this5.name || !_this5.email || !_this5.bluAmount || !_this5.phone) {
                alert(_this5.$t("msg.form_error_fields"));
                _this5.loadingButton = false;
              } else {
                email = {
                  to: "edgar@stratum.bt",
                  subject: "OTC - Blu",
                  message: "Name " + _this5.name + " || e-mail: " + _this5.email + " || phone: " + _this5.phone + " || BLU Quantity: " + _this5.bluAmount
                };


                _this5.$store.dispatch("genericMail", email).then(function (resp) {
                  if (resp.status == 200) {
                    _this5.formFinish = true;
                    _this5.loadingButton = false;
                  }
                }, function (error) {
                  alert(error.message);
                  console.log(error);
                  _this5.loadingButton = false;
                });
              }

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  },
  toggleLock: function toggleLock() {
    this.locked = !this.locked;
  },
  showToolTipCharity: function showToolTipCharity() {
    this.toolTipCharity = true;
  },
  hideToolTipCharity: function hideToolTipCharity() {
    this.toolTipCharity = false;
  },
  callReferStep: function callReferStep() {
    this.modalWarning = false;
    this.stepForm = true;
  },
  backReferStep: function backReferStep() {
    this.stepForm = false;
    this.modalWarning = true;
  },
  callPurchasePreview: function callPurchasePreview() {},
  getCurrencyStatus: function getCurrencyStatus() {
    for (var i = 0; i < this.currencyList.length; i++) {
      for (var j = 0; j < this.currencies.length; j++) {
        if (this.currencyList[i].symbol == this.currencies[j].symbol) {
          console.log(this.currencyList[i].symbol, this.currencies[j].symbol, this.currencies[j].isAvailable);
          this.currencyList[i].isAvailable = this.currencies[j].isAvailable;
        }
      }
    }
  },
  selectCurrency: function selectCurrency(selectedCurrency) {
    this.selectedCurrency = selectedCurrency;
  },
  sendToSite: function sendToSite() {
    window.open("https://pix.xchange.ee/?currency=BLUE");
  },
  getMinBluXUsdt: function getMinBluXUsdt() {
    var result = this.bluValue[0].tradeMinimal;
    return result.toFixed();
  },
  getMinBlu: function getMinBlu() {
    var bluMin = this.bluValue[0].tradeMinimal / this.bluValue[0].value;
    bluMin = this.roundUp(bluMin, 6);
    this.minBlue = bluMin;
    if (this.firstLoad) {
      this.setMin();
    }
  },
  setMin: function setMin() {
    this.bluAmount = this.minBlue;
    this.firstLoad = false;
  },
  getTemporaryBalance: function getTemporaryBalance() {
    this.temporaryBalance = this.btcAccount.balance;
  },
  validateAmount: function validateAmount() {
    this.bluAmountValid = false;
    var indices = [];
    var amount = String(this.bluAmount);

    var idx = amount.indexOf(".");
    while (idx != -1) {
      indices.push(idx);
      idx = amount.indexOf(".", idx + 1);
    }
    if (indices.length > 1) {
      var n = amount.lastIndexOf(".");
      amount = amount.slice(0, n);
      this.bluAmountValid = false;
    } else {
      this.bluAmountValid = true;
    }

    this.bluAmount = amount;
  },
  modifyBluAmount: function modifyBluAmount(modifier) {
    if (this.bluAmount == "") {
      this.bluAmount = this.minBlue;
    }

    this.bluAmount = parseFloat(this.bluAmount);
    if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
      this.bluAmount = this.minBlue;
    } else {
      var vm = this;
      if (modifier == "-" && this.bluAmount > 0) {
        var result = this.bluAmount - 1;
        if (result > this.minBlue) {
          result = vm.roundUp(result, 3);
          vm.bluAmount = result;
        } else {
          this.bluAmount = this.minBlue;
        }
      } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
        this.bluAmount = parseFloat(this.bluAmount);
        var _result = vm.roundUp(this.bluAmount + 1, 3);
        this.bluAmount = _result;
      }
    }
  },
  roundUp: function roundUp(num, precision) {
    precision = Math.pow(10, precision);
    return Math.ceil(num * precision) / precision;
  },
  showToolTipBonus: function showToolTipBonus() {
    this.tooltipBonus = true;
  },
  hideToolTipBonus: function hideToolTipBonus() {
    this.tooltipBonus = false;
  },
  showToolTipStratum: function showToolTipStratum() {
    this.tooltipStratum = true;
  },
  hideToolTipStratum: function hideToolTipStratum() {
    this.tooltipStratum = false;
  },
  blockPurchaseInfo: function blockPurchaseInfo() {
    this.blockMsg = true;
  },
  changeModalWarningState: function changeModalWarningState(state, mode) {
    this.selectWay = "crypto";
    this.paymentMode = mode;
    this.modalWarning = state;
    if (mode == "slips") {
      this.callNextState();
    }

    this.selectWay = false;
  },
  changeModalSelectWay: function changeModalSelectWay(state, mode) {
    this.paymentMode = mode;
    this.selectWay = state;
  },
  forceStateChange: function forceStateChange() {
    if (this.transactionState < 3) {
      this.transactionState = this.transactionState + 1;
    } else {
      this.transactionState = 0;
    }
  },
  postTrade: function postTrade() {
    var value = this.bluAmount;
    var form = {
      sourceCurrency: this.selectedCurrency,
      targetAmount: parseFloat(value)
    };

    if (this.purchaseReferral != "") {
      form.referCode = this.purchaseReferral;
    }

    if (this.paymentMode == "slips") {
      form.sourceCurrency = "BRL";
    }

    return this.$store.dispatch("postTrade", form);
  },
  changeStepOtc: function changeStepOtc() {
    this.fillFieldsForm();

    this.modalWarning = false;
    this.stepForm = true;
  },
  callNextState: function callNextState() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var lastCharacter, x;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(_this6.selectedCurrency == "USDT")) {
                _context6.next = 3;
                break;
              }

              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                html: "<span style=\"font-size:1.25em;\">" + _this6.$t("msg.info_usdt_blue_purchase") + "</span>",
                icon: "warning",
                confirmButtonText: _this6.$t("msg.i_understand"),
                confirmButtonColor: "#4e4f99"
              });

            case 3:
              if (!(_this6.member.level == "seller")) {
                _context6.next = 7;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                title: _this6.$t("msg.purchase_confirmation", 1),
                html: "" + _this6.$t("msg.purchase_seller_to_user"),
                icon: "question",
                showCancelButton: true,
                cancelButtonColor: "#3A8CEA",
                confirmButtonColor: "#0CA2B5",
                confirmButtonText: _this6.$t("msg.yes"),
                cancelButtonText: _this6.$t("msg.no")
              }).then(function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(result) {
                  var lastCharacter, x;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!result.isConfirmed) {
                            _context5.next = 4;
                            break;
                          }

                          _this6.stepSellerInfoUid = true;
                          _context5.next = 13;
                          break;

                        case 4:
                          _this6.loadingButton = true;

                          lastCharacter = _this6.bluAmount[_this6.bluAmount.length - 1];


                          if (lastCharacter === ".") {
                            x = _this6.bluAmount.length - 1;

                            _this6.bluAmount = _this6.bluAmount.slice(0, x);
                          }

                          if (!(parseFloat(_this6.bluAmount) > parseFloat(_this6.minBlue - 0.001))) {
                            _context5.next = 12;
                            break;
                          }

                          _context5.next = 10;
                          return _this6.postTrade().then(function (r) {
                            // this.$emit(
                            //   "callNextState",
                            //   this.paymentMode,
                            //   this.bluTusd.toFixed(2)
                            // );

                            location.reload();
                          }).catch(function (e) {
                            __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                              icon: "error",
                              title: _this6.$t("msg.error"),
                              text: _this6.$t("msg.error_xgateway")
                            });
                            console.log(e);
                            _this6.loadingButton = false;
                          });

                        case 10:
                          _context5.next = 13;
                          break;

                        case 12:
                          _this6.notifyError(_this6.$t("msg.minimum_amount_required"), 5000);

                        case 13:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this6);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context6.next = 16;
              break;

            case 7:
              _this6.loadingButton = true;

              lastCharacter = _this6.bluAmount[_this6.bluAmount.length - 1];


              if (lastCharacter === ".") {
                x = _this6.bluAmount.length - 1;

                _this6.bluAmount = _this6.bluAmount.slice(0, x);
              }

              if (!(parseFloat(_this6.bluAmount) > parseFloat(_this6.minBlue - 0.001))) {
                _context6.next = 15;
                break;
              }

              _context6.next = 13;
              return _this6.postTrade().then(function (r) {
                _this6.$emit("callNextState", _this6.paymentMode, _this6.bluTusd.toFixed(2));
              }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  icon: "error",
                  title: _this6.$t("msg.error"),
                  text: _this6.$t("msg.error_xgateway")
                });
                console.log(e);
                _this6.loadingButton = false;
              });

            case 13:
              _context6.next = 16;
              break;

            case 15:
              _this6.notifyError(_this6.$t("msg.minimum_amount_required"), 5000);

            case 16:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  showModalPIX: function showModalPIX() {
    console.log(this.bluAmount, "aqqq");
    console.log(this.bluTusd);
    this.modalPIX = !this.modalPIX;
  },


  isNumber: function isNumber(evt) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      evt.preventDefault();
    } else {
      this.callPurchasePreview();
      return true;
    }
  }
}), _defineProperty(_props$created$mounte, "computed", _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "bluAccount", "btcAccount", "usdtAccount", "bluValue", "btcValue", "currencies", "languageSelected", "minimumInvestiment"]))), _defineProperty(_props$created$mounte, "watch", {
  btcValue: function btcValue() {
    this.getMinBlu();
  },
  bluAmount: function bluAmount() {
    this.validateAmount();
  },

  minBlue: function minBlue() {
    if (this.bluAmount < this.minBlue) {
      this.setMin();
    }
  },
  currencies: function currencies() {
    this.getCurrencyStatus();
  },

  purchases: function purchases() {
    this.checkTranscationStatus();
    this.loading = false;
  }
}), _props$created$mounte);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d31ee7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBuyBlu_vue__ = __webpack_require__(829);
function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d31ee7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBuyBlu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["blueAmount", "usdtAmount"],
  created: function created() {
    // setTimeout(() => {
    //   this.step = 3;
    // }, 4000);
  },

  data: function data() {
    return {
      dateEnd: "",
      timmer: 10,
      connecting: false,
      step: 1,
      purchases: [],
      pixData: "",
      confirTerms: false,
      swapix: {
        a: false,
        b: false,
        c: false
      },
      trade: "",

      testeeeee: {
        emv: "00020101021226910014br.gov.bcb.pix2569api.developer.btgpactual.com/v1/p/v2/b0e0085d8465475d862accd023f727515204000053039865802BR5924Smartpay Pagamentos Ltda6013FLORIANOPOLIS61088805897162070503***630493B8",
        address: "kk6g232xel65a0daee4dd13kk1072266777",
        operation: {
          operation_type: "sell",
          curout: "txusdt",
          curbase: "brl",
          curconv: "txusdt",
          nfe: "in",
          txIn: { message: "TPiXaBPVTJ1M3d8YFrm2YFJEF4hFXpCGVw" },
          operation_id: "1654873710420",
          rate: {
            amount_brl: "499.75",
            price_usd: "4.9970",
            total_brl: "516.74",
            fee_brl: "16.99",
            send_usd: "100.00",
            timeout: 772,
            amount_usd: "100.00",
            price_txusdt: 1,
            value_txusdt: "100.000000",
            send_txusdt: "100.000000"
          },
          remove: "true"
        }
      },

      amountToSend: "",
      addressToSEnd: ""
    };
  },
  methods: {
    toggleModalBuyBluePIX: function toggleModalBuyBluePIX() {
      this.$emit("toggleModalBuyBluePIX");
    },
    getHours: function getHours(teste) {
      var n = teste;
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);

      if (teste > 60) {
        return rhours > 1 ? rhours + " Hs " + rminutes + " Min" : rhours + " H " + rminutes + " Min";
      } else {
        return teste + " Min";
      }
    },
    next: function next() {
      this.step = this.step + 1;

      if (this.step == 2) {
        this.postTrade();
      }
    },
    postTrade: function postTrade() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var value, form;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = _this.blueAmount;
                form = {
                  sourceCurrency: "USDT",
                  targetAmount: parseFloat(value)
                };
                _context.next = 4;
                return _this.$store.dispatch("postTrade", form).then(function (r) {
                  console.log(r);
                  if (r.status == 200) {
                    _this.amountToSend = r.data.estimatedAmount;
                    _this.getPurchases();
                  }
                }).catch(function (e) {
                  __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this.$t("msg.error"),
                    text: _this.$t("msg.error_xgateway")
                  });
                  _this.toggleModalBuyBluePIX();
                  _this.step = 1;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getPurchases: function getPurchases() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$store.dispatch("getPurchases");

              case 3:
                resp = _context2.sent;

                _this2.purchases = resp.data;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                _this2.logError(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    formatDate: function formatDate(value) {
      var s = __WEBPACK_IMPORTED_MODULE_1_spacetime___default()(value);
      var end = s.add(20, "minutes");
      return end.format("dd/MM/yyyy HH:mm:SS");
    },
    checkTranscationStatus: function checkTranscationStatus() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var trades, i, address, tradeId, body, resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                trades = _this3.purchases;
                _context3.t0 = regeneratorRuntime.keys(trades);

              case 2:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 16;
                  break;
                }

                i = _context3.t1.value;

                if (!(trades[i].status == "waiting")) {
                  _context3.next = 14;
                  break;
                }

                console.log(trades[i]);
                address = trades[i].targetAddress;
                tradeId = trades[i].id;

                // let date = new Date(trades[i].createdAt)
                // this.dateEnd = date.setMinutes(10);

                _this3.dateEnd = trades[i].createdAt;

                body = {
                  tradeId: tradeId,
                  address: address,
                  amount: parseFloat(_this3.amountToSend.toFixed(2))
                };
                _context3.next = 12;
                return _this3.$store.dispatch("postPurchasePixGenerate", body);

              case 12:
                resp = _context3.sent;


                if (resp.status == 200) {
                  _this3.step = 3;
                  _this3.pixData = resp.data;
                }

              case 14:
                _context3.next = 2;
                break;

              case 16:
                _this3.loading = false;

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    toggleSwapixContent: function toggleSwapixContent() {},
    checkStep: function checkStep() {
      var _this4 = this;

      if (this.step == 3) {
        setInterval(function () {
          _this4.getTradeTracking();
        }, 10000);
      }
    },
    getTradeTracking: function getTradeTracking() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.$store.dispatch("getTrade");

              case 2:
                resp = _context4.sent;

                _this5.trade = resp.data;
                _this5.checkStatus();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    checkStatus: function checkStatus() {
      if (this.trade.status) {
        if (this.trade.status == "done") {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.fire({
            icon: "success",
            title: this.$t("msg.success"),
            text: this.$t("msg.modalBuyBluePix.completed_buy")
          });

          this.toggleModalBuyBluePIX();
        }
      }
    }
  },
  watch: {
    purchases: function purchases() {
      this.checkTranscationStatus();
    },

    step: function step() {
      this.checkStep();
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "swapix.png?b2321d5d665a8cb88975dc631c148a35";

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pix-buyBlue.svg?6917005c24ee831ec73deb3589c3349c";

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__steps_BluWatchStep1__ = __webpack_require__(841);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["fees", "bluTusd", "purchaseWaiting"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      step: 1,
      fakeQRcode: "54fhdskhfdshfis979f",
      btcAmount: 0,
      trade: false,
      btcAccount: "",
      updateActive: "",
      waitingStepPurchase: false

    };
  },
  components: {
    BluWatchStep1: __WEBPACK_IMPORTED_MODULE_0__steps_BluWatchStep1__["a" /* default */]
  },
  methods: {
    backToStart: function backToStart() {
      this.$emit("backToStart");
    },
    callNextState: function callNextState() {
      this.$emit("callNextState");
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_easy_circular_progress__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_easy_circular_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_easy_circular_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["purchaseHome"],
  data: function data() {
    return {
      requestLoading: false,
      purchase: "",
      details: false,
      createAtPurchase: "",
      finishAtPurchase: "",
      resultPercent: "",
      trade: "",
      cancelOrder: false,
      doneOrder: false,
      qrCodeDiv: false,
      isMobile: "",
      showTooltip: false,
      timer: {
        days: "",
        hours: "",
        minutes: ""
      },
      allowPurchase: false,
      usdtPurchase: false,

      complete: {
        days: "",
        hours: "",
        minutes: ""
      }
    };
  },
  created: function created() {
    var _this = this;

    this.getTradeTracking();
    setInterval(function () {
      _this.getTradeTracking();
    }, 10000);
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.checkIfMobile);
    this.checkIfMobile();
    this.verifyBalanceToPurchase();
  },

  methods: {
    currencyFormat: function currencyFormat(num, symb) {
      if (symb == "RAS" || symb == "USDT") {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return num.toFixed(8);
      }
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 1200) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    purchaseInformation: function purchaseInformation() {
      var _this2 = this;

      if (this.doneOrder) {
        this.$emit("backToStart");
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          title: this.$t("msg.otc_purcahse_info"),
          html: "<p style=\"text-align: initial; margin-top:20px;\" >User ID: " + this.member.uid + "</p>" + ("<p style=\"text-align: initial; margin-top:20px;\" >Email: " + this.member.email + "</p>") + ("<p style=\"text-align: initial; margin-top:20px;\" >" + this.$t("msg.address") + ": " + this.purchaseHome.targetAddress + "</p>") + ("<p style=\"text-align: initial; margin-top:20px;\" >" + this.$t("msg.expected_amount_in") + " " + this.trade.sourceCurrency.symbol + ": " + this.currencyFormat(this.trade.estimatedAmount, this.trade.sourceCurrency.symbol) + "</p>") + ("<p style=\"text-align: initial; margin-top:20px;\" >" + this.$t("msg.estimated_amount_in") + " BLUE: " + this.getEstimatedAmount() + "</p>"),
          icon: "info",
          showCancelButton: true,
          cancelButtonColor: "#3A8CEA",
          confirmButtonColor: "#0CA2B5",
          confirmButtonText: this.$t("msg.copy"),
          cancelButtonText: this.$t("msg.back")
        }).then(function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
            var text;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (result.isConfirmed) {
                      text = "User ID: " + _this2.member.uid + ", Email: " + _this2.member.email + ", " + _this2.$t("msg.address") + ": " + _this2.trade.targetAddress + ", " + _this2.$t("msg.expected_amount_in") + " " + _this2.trade.sourceCurrency.symbol + ": " + _this2.currencyFormat(_this2.trade.estimatedAmount, _this2.trade.sourceCurrency.symbol) + ", " + _this2.$t("msg.estimated_amount_in") + " BLU: " + _this2.getEstimatedAmount();

                      navigator.clipboard.writeText(text);
                    }

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    createNewOrder: function createNewOrder() {
      this.$emit("backToStart");
    },
    verifyBalanceToPurchase: function verifyBalanceToPurchase() {
      return this.usdtAccount.balance > this.bluValue[0].tradeMinimal ? this.allowPurchase = true : this.allowPurchase = false;
    },
    callPayWithBalance: function callPayWithBalance() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var balance, send, payload;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // let balance = this.usdtAccount.balance;
                balance = 200;
                send = void 0;

                if (balance > _this3.trade.estimatedAmount) {
                  send = _this3.trade.estimatedAmount;
                }

                if (balance <= _this3.trade.estimatedAmount) {
                  send = balance;
                }

                payload = {
                  tradeID: _this3.trade.tradeId,
                  amount: send,
                  addressToPay: _this3.purchaseHome.targetAddress
                };
                _context2.next = 7;
                return _this3.$store.dispatch("postPurchaseCurrencyBalance", payload).then(function (resp) {
                  _this3.getTradeById(resp.data);
                  if (resp.status == 200) {
                    __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire(_this3.$t("msg.tks_your_payment"), _this3.$t("msg.wait_create_tokens"), "success");
                    _this3.allowPurchase = false;
                    _this3.usdtPurchase = true;
                  }
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getEstimatedAmount: function getEstimatedAmount() {
      if (this.purchase) {
        var fee = this.trade.confirmedAmount * this.feePurchase.fee / (100 + this.feePurchase.fee) / this.purchase.targetPrice;
        var result = this.trade.confirmedAmount / this.purchase.targetPrice;

        var result3 = result - fee;

        return result3.toFixed(6);
      } else {
        var _fee = this.trade.confirmedAmount * this.feePurchase.fee / (100 + this.feePurchase.fee) / this.purchaseHome.targetPrice;
        var _result = this.trade.confirmedAmount / this.purchaseHome.targetPrice;

        var _result2 = _result - _fee;

        return _result2.toFixed(6);
      }
    },
    qrCodeZoom: function qrCodeZoom() {
      this.qrCodeDiv = !this.qrCodeDiv;
    },


    // async checkTradeObject() {
    //   if (this.purchaseHome) {
    //     this.purchase = this.purchaseHome;
    //     this.trade = await this.$store.dispatch(
    //       "getTradeSearchByTradeId",
    //       this.purchase.id
    //     );
    //   } else {
    //     await this.getPurchases();
    //   }
    // },
    setCancelOrder: function setCancelOrder() {
      this.cancelOrder = true;
    },
    getPurchases: function getPurchases() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this4.$store.dispatch("getPurchases");

              case 3:
                resp = _context3.sent;

                _this4.getTradeById(resp.data);
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this4.logError(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 7]]);
      }))();
    },
    getTradeTracking: function getTradeTracking() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var resp, _resp;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this5.purchaseHome && _this5.member.level == "seller")) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 3;
                return _this5.$store.dispatch("getTradeSearchByTradeId", _this5.purchaseHome.id);

              case 3:
                resp = _context4.sent;

                _this5.trade = resp.data[0];
                _this5.checkPercetToCancelPurchase();
                _this5.checkStatus();
                _this5.checkTime();
                _context4.next = 25;
                break;

              case 10:
                _context4.prev = 10;
                _context4.next = 13;
                return _this5.$store.dispatch("getTrade");

              case 13:
                _resp = _context4.sent;

                _this5.trade = _resp.data;
                _this5.purchaseHome = _resp.data;
                _this5.checkPercetToCancelPurchase();
                _this5.checkStatus();
                _this5.checkTime();
                _this5.getPurchases();
                _context4.next = 25;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](10);

                console.log("could not load fees: ", _context4.t0);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[10, 22]]);
      }))();
    },
    getTradeById: function getTradeById(purchases) {
      for (var i in purchases) {
        if (purchases[i].id == this.trade.tradeId) {
          this.purchase = purchases[i];
          break;
        }
      }
    },
    checkTime: function checkTime() {
      var createAt = new Date(this.purchaseHome.createdAt.substring(0, this.purchaseHome.createdAt.length - 8));

      var tempDate = new Date(this.purchaseHome.createdAt.substring(0, this.purchaseHome.createdAt.length - 8));

      var createAtPurchaseExpireIn = createAt.setMilliseconds(this.purchaseHome.expiresIn);
      var finishAtPurchase = new Date(createAtPurchaseExpireIn);

      var a = __WEBPACK_IMPORTED_MODULE_2_moment___default()(tempDate);
      var b = __WEBPACK_IMPORTED_MODULE_2_moment___default()(finishAtPurchase);

      var diffDaysC = b.diff(a, "days");
      var diffHoursC = b.diff(a, "hours");
      var diffMinC = b.diff(a, "minutes");

      this.complete.days = diffDaysC;
      this.complete.hours = diffHoursC;
      this.complete.minutes = diffMinC;

      var today = new Date();

      var diffDays = b.diff(today, "days");
      var diffHours = b.diff(today, "hours");
      var diffMin = b.diff(today, "minutes");

      this.timer.days = diffDays;
      this.timer.hours = diffHours;
      this.timer.minutes = diffMin;

      if (diffMin < 0) {
        this.$emit("backToStart");
      }
    },
    checkPercetToCancelPurchase: function checkPercetToCancelPurchase() {
      var tempDate = new Date(this.purchaseHome.createdAt.substring(0, this.purchaseHome.createdAt.length - 8));

      var createAtPurchaseExpireIn = __WEBPACK_IMPORTED_MODULE_2_moment___default()(tempDate.setMilliseconds(this.purchaseHome.expiresIn));

      var today = new Date();

      var finishAtPurchase = new Date(createAtPurchaseExpireIn);

      var c = __WEBPACK_IMPORTED_MODULE_2_moment___default()(today);
      var b = __WEBPACK_IMPORTED_MODULE_2_moment___default()(finishAtPurchase);
      var diffDays = b.diff(c);
      this.resultPercent = (this.purchaseHome.expiresIn - diffDays) / this.purchaseHome.expiresIn * 100;
    },
    getHours: function getHours(teste) {
      var n = teste;
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);

      if (teste > 60) {
        return rhours > 1 ? rhours + " Hs " + rminutes + " Min" : rhours + " H " + rminutes + " Min";
      } else {
        return teste + " Min";
      }
    },
    confirmCancelPurchase: function confirmCancelPurchase() {
      var _this6 = this;

      if (this.doneOrder) {
        this.$emit("backToStart");
      } else {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          title: this.$t("msg.attention"),
          html: "<p style=\"text-align: initial; margin-top:20px;\" >" + this.$t("msg.you_want_start_new_purchase") + "</p>" + ("<p style=\"text-align: initial; margin-top:20px; margin-bottom:80px\">" + this.$t("msg.do_you_want") + "</p>"),
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#3A8CEA",
          confirmButtonColor: "#FF5050",
          confirmButtonText: this.$t("msg.yes_cancel_purchase"),
          cancelButtonText: this.$t("msg.back")
        }).then(function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(result) {
            var _result3;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (_this6.requestLoading) {
                      _context5.next = 9;
                      break;
                    }

                    if (!result.isConfirmed) {
                      _context5.next = 9;
                      break;
                    }

                    _this6.requestLoading = true;

                    if (!(_this6.trade.status == "new" || _this6.trade.status == "waiting")) {
                      _context5.next = 8;
                      break;
                    }

                    _context5.next = 6;
                    return _this6.$store.dispatch("putPurchaseCancel", _this6.trade.tradeId);

                  case 6:
                    _result3 = _context5.sent;

                    if (_result3.status == 200) {
                      _this6.getTradeTracking();
                    } else {
                      alert("Something wrong");
                      console.log(_result3);
                    }

                  case 8:
                    _this6.requestLoading = false;

                  case 9:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this6);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    },
    checkStatus: function checkStatus() {
      if (this.trade.status) {
        if (this.trade.status == "cancelled" || this.trade.status == "expired") {
          this.cancelOrder = true;
        }

        if (this.trade.status == "done") {
          this.doneOrder = true;
          this.$store.dispatch("updateUsdtAccount");
        }
      }
    }
  },

  components: {
    Progress: __WEBPACK_IMPORTED_MODULE_1_easy_circular_progress___default.a
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "usdtAccount", "bluValue", "ethValue", "member", "feePurchase", "ethAccount", "currencies"]))
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["assetList"],
  created: function created() {
    var vm = this;
    setTimeout(function () {
      vm.setChartData();
    }, 300);
  },
  mounted: function mounted() {},

  data: function data() {
    return _defineProperty({
      canvasData: "",
      selectedCoin: "BTC",
      colorsArray: [],
      assetsTailStage: [],
      chartLabels: [],
      chartData: [],
      chartSymbol: [],

      coinColors: [{
        symbol: "BTC",
        color: "#ff9a28"
      }, {
        symbol: "ETH",
        color: "#6374bf"
      }, {
        symbol: "LINK",
        color: "#2a5ada"
      }, {
        symbol: "XRP",
        color: "black"
      }, {
        symbol: "DASH",
        color: "#1c81bc"
      }, {
        symbol: "MKR",
        color: "#17ab99"
      }, {
        symbol: "BCH",
        color: "#86cb5c"
      }, {
        symbol: "LTC",
        color: "#345d9d"
      }, {
        symbol: "XLM",
        color: "#000000"
      }, {
        symbol: "ADA",
        color: "#0f9fff"
      }, {
        symbol: "EOS",
        color: "#807979"
      }, {
        symbol: "DOT",
        color: "#e6007a"
      }, {
        symbol: "LEND",
        color: "#149aca"
      }, {
        symbol: "AAVE",
        color: "rgba(182,80,158,1)"
      }, {
        symbol: "BNB",
        color: "#f2c353"
      }, {
        symbol: "UNI",
        color: "#ff0179"
      }, {
        symbol: "FIL",
        color: "rgba(182,80,158,1)"
      }, {
        symbol: "THETA",
        color: "#f2c353"
      }, {
        symbol: "LUNA",
        color: "#172852"
      }, {
        symbol: "MANA",
        color: "#ff3955"
      },

      //out
      {
        symbol: "ALGO",
        color: "black"
      }, {
        symbol: "XMR",
        color: "#FF6501"
      }, {
        symbol: "CAKE",
        color: "#d1884f"
      }, {
        symbol: "SOL",
        color: "#62b9c4"
      }, {
        symbol: "MATIC",
        color: "#9767e9"
      }, {
        symbol: "CRV",
        color: "#c71a16"
      }, {
        symbol: "AVAX",
        color: "#E84142"
      }, {
        symbol: "MBOX",
        color: "#1b53f5"
      }, {
        symbol: "USDT",
        color: "#57ae96"
      }, {
        symbol: "TUSD",
        color: "#57ae96"
      }]

    }, "colorsArray", []);
  },
  components: {},
  methods: {
    sortCurrenciesByPercentage: function sortCurrenciesByPercentage() {
      this.currencies.sort(function (a, b) {
        if (a.marketPercent < b.marketPercent) return 1;
        if (a.marketPercent > b.marketPercent) return -1;
        return 0;
      });
    },
    getPriceBySymbol: function getPriceBySymbol(symb) {
      var coinPrice = this.currencies.filter(function (coin) {
        return coin.symbol == symb;
      });

      return parseFloat(coinPrice[0].value);
    },
    labelClick: function labelClick(value) {
      this.selectedCoin = value;
    },
    bodyClick: function bodyClick(e, value) {
      if (value[0]) {
        this.selectedCoin = value[0]._model.label == 'USDT' ? 'TUSD' : value[0]._model.label;
      }
    },
    fixSymb: function fixSymb(el) {
      if (el == 'TUSD' || el == 'tusd') {
        return 'USDT';
      } else {
        return el;
      }
    },
    setChartData: function setChartData() {
      var functionArray = this.assetList;
      var obj = void 0;

      for (obj in functionArray) {
        this.chartLabels.push(this.fixSymb(functionArray[obj].currency.symbol));
        this.chartData.push(functionArray[obj].assignedOverallWeight);
        this.chartSymbol.push(this.fixSymb(functionArray[obj].currency.symbol));

        var selectedColor = this.coinColors.find(function (element) {
          return element.symbol == functionArray[obj].currency.symbol;
        });

        if (selectedColor) {
          this.colorsArray.push(selectedColor.color);
        }
      }
      this.setUpChart();
    },
    setUpChart: function setUpChart() {
      var chartData = {
        type: "pie",
        legendText: "aa",
        legend: {
          cursor: "pointer"
        },
        data: {
          labels: this.chartLabels,
          datasets: [{
            data: this.chartData,
            backgroundColor: this.colorsArray,
            fill: true,
            borderWidth: 0,
            lineTension: 0
          }]
        },
        options: {
          onHover: this.bodyClick,
          tooltips: {
            enabled: true,
            backgroundColor: "rgba(0,0,0,0.7)"
          },
          elements: {
            arc: {}
          },
          legend: {
            display: false
          },
          plugins: {
            datalabels: {
              formatter: function formatter(value, context) {
                return context.chart.data.labels[context.dataIndex];
              }
            }
          }
        }
      };

      this.createChart("mainChart", chartData);
    },
    createChart: function createChart(chartId, chartData) {
      setTimeout(function () {
        var ctx = document.getElementById(chartId);
        var nasChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options
        });
      }, 100);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["currencies"])),
  watch: {}
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.startInterval();
    this.checkIfMobile();
  },
  mounted: function mounted() {
    this.getRecentTransactions();
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      updateActive: "",
      recentTransactions: "",
      isMobile: "",
      myBalanceExpand: false
    };
  },
  components: {},
  methods: {
    currencyFormat: function currencyFormat(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    toggleMenu: function toggleMenu() {
      this.myBalanceExpand = !this.myBalanceExpand;
    },
    getRecentTransactions: function getRecentTransactions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getTransactions");

              case 3:
                resp = _context.sent;


                _this.recentTransactions = resp.data;
                _this.sortTransactionsByCreatedAt(_this.recentTransactions);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                _this.logError(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    symbAjust: function symbAjust(el) {
      if (el == "BLU") {
        return "BLUE";
      } else {
        return el;
      }
    },
    sortTransactionsByCreatedAt: function sortTransactionsByCreatedAt(transactionsArray) {
      transactionsArray.sort(function (a, b) {
        if (a.createdAt < b.createdAt) return 1;
        if (a.createdAt > b.createdAt) return -1;
        return 0;
      });

      for (var i = 0; i < transactionsArray.length; i++) {
        if (transactionsArray[i].status == "failed") {
          transactionsArray.splice(i, 1);
        }
      }

      if (transactionsArray.length > 6) {
        transactionsArray = transactionsArray.slice(0, 6);
      }
      this.recentTransactions = transactionsArray;
    },
    startInterval: function startInterval() {
      this.updateActive = setInterval(this.getRecentTransactions, 60000);
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalOtherCurrencies_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57924b31_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalOtherCurrencies_vue__ = __webpack_require__(857);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalOtherCurrencies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57924b31_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalOtherCurrencies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["type"],
  created: function created() {
    this.checkCurrencis();

    this.checkType();
  },

  data: function data() {
    return {
      pairs: [],
      pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
      blue: {},
      fundTails: {}
    };
  },
  methods: {
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    checkType: function checkType() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.type);

                if (_this.type == "supply") {
                  _this.getFundTails();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getFundTails: function getFundTails() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 1,
                  entryType: "live"
                };
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$store.dispatch("getFundTails", params);

              case 4:
                resp = _context2.sent;

                _this2.fundTails = resp.data;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                console.log("error ", _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    checkCurrencis: function checkCurrencis() {
      var _this3 = this;

      for (var i in this.currencies) {
        if (this.currencies[i].symbol == "BLU") {
          this.blue = this.currencies[i];
        }
      }

      this.currencies.find(function (el) {
        for (var _i in _this3.pairSymbs) {
          if (el.symbol == _this3.pairSymbs[_i]) {
            _this3.pairs.push(el);
          }
        }
      });

      var fromIndexEther = 3;
      var toIndexEther = 1;

      var elementEther = this.pairs.splice(fromIndexEther, 1)[0];

      this.pairs.splice(toIndexEther, 0, elementEther);
    },
    currencyFormat: function currencyFormat(num, symb) {
      if (num) {
        if (symb == "RAS" || symb == "USDT" || symb == "BRL" || symb == "EUR" || symb == "ZAR" || symb == "GBP") {
          return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        } else {
          return num.toFixed(8);
        }
      } else {
        return 0;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["eurValue", "currencies", "bluAccount"]))
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["type"],
  created: function created() {
    this.checkCurrencis();

    this.checkType();
  },

  data: function data() {
    return {
      pairs: [],
      pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
      blue: {},
      fundTails: {}
    };
  },
  methods: {
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    checkType: function checkType() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.type);

                if (_this.type == "supply") {
                  _this.getFundTails();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getFundTails: function getFundTails() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 1,
                  entryType: "live"
                };
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$store.dispatch("getFundTails", params);

              case 4:
                resp = _context2.sent;

                _this2.fundTails = resp.data;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                console.log("error ", _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    checkCurrencis: function checkCurrencis() {
      var _this3 = this;

      for (var i in this.currencies) {
        if (this.currencies[i].symbol == "BLU") {
          this.blue = this.currencies[i];
        }
      }

      this.currencies.find(function (el) {
        for (var _i in _this3.pairSymbs) {
          if (el.symbol == _this3.pairSymbs[_i]) {
            _this3.pairs.push(el);
          }
        }
      });

      var fromIndexEther = 3;
      var toIndexEther = 1;

      var elementEther = this.pairs.splice(fromIndexEther, 1)[0];

      this.pairs.splice(toIndexEther, 0, elementEther);
    },
    currencyFormat: function currencyFormat(num, symb) {
      if (num) {
        if (symb == "RAS" || symb == "USDT" || symb == "BRL" || symb == "EUR" || symb == "ZAR" || symb == "GBP") {
          return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        } else {
          return num.toFixed(8);
        }
      } else {
        return 0;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["eurValue", "currencies", "bluAccount"]))
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["type"],
  created: function created() {
    this.checkType();
  },

  data: function data() {
    return {
      address: "",
      pairs: [],
      pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
      blue: {},
      fundTails: {},
      step: 1,
      validAddress: false
    };
  },
  methods: {
    validAddressCheck: function validAddressCheck() {
      var WAValidator = __webpack_require__(133);
      var valid = WAValidator.validate(this.address, "sol");

      console.log("aquiii", valid);
      this.validAddress = valid;
    },
    sendEmail: function sendEmail() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var WAValidator, valid, payload, request, msg, form, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                WAValidator = __webpack_require__(133);
                valid = WAValidator.validate(_this.address, "sol");

                if (valid) {
                  _context.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
                  icon: "error",
                  title: _this.$t("msg.error"),
                  text: "Use a sol valid address"
                });
                return _context.abrupt("return");

              case 5:
                payload = {
                  address: _this.address
                };
                _context.next = 8;
                return _this.$store.dispatch("postBlueRewardRequest", payload);

              case 8:
                request = _context.sent;

                console.log(request);

                if (!(request.status == 200)) {
                  _context.next = 20;
                  break;
                }

                msg = "User " + _this.member.uid + " has claim an NFT to address " + _this.address + ". Check admin for more details.";
                form = {
                  to: "support@bluetoken.io",
                  tagSubject: "Blue-form-contact",
                  subject: "New Blue Club NFT claim",
                  message: msg
                };
                _context.next = 15;
                return _this.$store.dispatch("postGenericEmail", form);

              case 15:
                resp = _context.sent;

                console.log(resp);
                if (resp.status == 200) {
                  _this.step = 2;
                }
                _context.next = 21;
                break;

              case 20:
                __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
                  icon: "error",
                  title: _this.$t("msg.error"),
                  text: "Use a sol valid address"
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toggleModalCurrencies: function toggleModalCurrencies() {
      if (this.step == 2) {
        window.location.reload();
      }

      this.$emit("toggleModalCurrencies");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["eurValue", "currencies", "bluAccount", "member"]))
});

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spacetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_private_transactions_TransactionTableProbability__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_private_transactions_TransactionTablePurchase__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_private_transactions_TransactionTableRedeem__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_private_transactions_TransactionTableReferral__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_private_transactions_TransactionTableDeposits__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Transactions_TransactionTableWithdraw__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Transactions_TransactionTableInternal__ = __webpack_require__(938);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkParams();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      tableSelected: ""
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    VueCsvDownloader: __WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader___default.a,
    TransactionTableRedeem: __WEBPACK_IMPORTED_MODULE_5__components_private_transactions_TransactionTableRedeem__["a" /* default */],
    TransactionTableReferral: __WEBPACK_IMPORTED_MODULE_6__components_private_transactions_TransactionTableReferral__["a" /* default */],
    TransactionTablePurchase: __WEBPACK_IMPORTED_MODULE_4__components_private_transactions_TransactionTablePurchase__["a" /* default */],
    TransactionTableDeposits: __WEBPACK_IMPORTED_MODULE_7__components_private_transactions_TransactionTableDeposits__["a" /* default */],
    TransactionTableWithdraw: __WEBPACK_IMPORTED_MODULE_8__components_Transactions_TransactionTableWithdraw__["a" /* default */],
    TransactionTableInternal: __WEBPACK_IMPORTED_MODULE_9__components_Transactions_TransactionTableInternal__["a" /* default */],
    TransactionTableProbability: __WEBPACK_IMPORTED_MODULE_3__components_private_transactions_TransactionTableProbability__["a" /* default */]
  },
  methods: {
    showTable: function showTable(type) {
      this.tableSelected = type;
    },
    checkParams: function checkParams() {
      this.tableSelected = this.$route.params.arg;
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 396 */,
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getDeposits();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      searchBox: "",
      statusFilter: "all",
      filterStartDate: "",
      filterEndDate: "",
      withdraws: [],
      withdrawsOnPage: [],
      columns: [{
        label: "Redemption Date/Time",
        field: "Redemption Date/Time"
      }, {
        label: "Redemption Price",
        field: "Redemption Price"
      }, {
        label: "Average Purchase Price",
        field: "Average Purchase Price",
        type: "number",
        filterable: true
      }, {
        label: "G/L",
        field: "G/L",
        filterable: true
      }, {
        label: "actions",
        field: "actions",
        filterable: false
      }]
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    getDeposits: function getDeposits() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getWithdraws");

              case 3:
                resp = _context.sent;

                _this.withdraws = _this.sortByCreatedAt(resp.data);
                _this.withdrawsOnPage = _this.sortByCreatedAt(resp.data);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    symbAjust: function symbAjust(el) {
      if (el == "BLU") {
        return "BLUE";
      } else {
        return el;
      }
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },
    applyFilter: function applyFilter() {
      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      var date1 = new Date(startDateOnInput);
      var date2 = new Date(endDateOnInput);

      var startDate = date1.getFullYear() + "-" + (date1.getMonth() + 1 < 10 ? "0" + (date1.getMonth() + 1) : date1.getMonth() + 1) + "-" + (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()) + "T00:00:00.000Z";

      var endDate = date2.getFullYear() + "-" + (date2.getMonth() + 1 < 10 ? "0" + (date2.getMonth() + 1) : date2.getMonth() + 1) + "-" + (date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()) + "T23:59:999Z";

      this.filterRowByDate(startDate, endDate);
    },
    filterRowByDate: function filterRowByDate(startDate, endDate) {
      var _this2 = this;

      this.withdrawsOnPage = this.withdraws;

      this.withdrawsOnPage = this.withdrawsOnPage.filter(function (item) {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.withdrawsOnPage = this.withdrawsOnPage.filter(function (item) {
          return item.status == _this2.statusFilter;
        });
      }
    },
    clearFilter: function clearFilter() {
      var vm = this;
      this.withdrawsOnPage = this.withdraws;
      this.statusFilter = "all";
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },
    ajustTokenID: function ajustTokenID(tokenID) {
      var str = tokenID;
      var res = str.substring(0, 15);

      return res + "... [+]";
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_1_spacetime___default()(value).format("dd/MM/yyyy HH:mm:SS");
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransactionDetails__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getPurchases();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      searchBox: "",
      statusFilter: "all",
      filterStartDate: "",
      filterEndDate: "",
      purchases: [],
      purchasesOnPage: [],
      transactionData: "",
      columns: [{
        label: "sourceCurrency",
        field: "sourceCurrency",
        hidden: true
      }, {
        label: "id",
        field: "tokenTxid",
        filterable: true
      }, {
        label: "createdAt",
        field: "createdAt"
      }, {
        label: "updatedAt",
        field: "updatedAt"
      }, {
        label: "targetAmount",
        field: "targetAmount",
        type: "number",
        filterable: true
      }, {
        label: "targetPrice",
        field: "targetPrice",
        type: "number",
        filterable: true
      }, {
        label: "subTotal",
        field: "subTotal",
        filterable: true
      }, {
        label: "fee",
        field: "sourceFee",
        filterable: true
      }, {
        label: "total",
        field: "total",
        filterable: true
      }, {
        label: "status",
        field: "status",
        filterable: true
      }, {
        label: "actions",
        field: "actions",
        filterable: false
      }]
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    TransactionDetails: __WEBPACK_IMPORTED_MODULE_2__TransactionDetails__["a" /* default */]
  },
  methods: {
    totalBlue: function totalBlue(price, amount, fee) {
      var total = 0;

      if (price > 0 && amount > 0 && fee > 0) {
        total = price * amount + fee;
        return total.toFixed(8);
      } else {
        return "-";
      }
    },
    symbAjust: function symbAjust(el) {
      if (el == "BLU") {
        return "BLUE";
      } else {
        return el;
      }
    },
    subTotalBlue: function subTotalBlue(price, amount, symbol) {
      var total = 0;

      if (price > 0 && amount > 0) {
        total = price * amount;
        return total.toFixed(8) + " " + symbol;
      } else {
        return "--";
      }
    },
    getPurchases: function getPurchases() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getPurchases");

              case 3:
                resp = _context.sent;

                _this.purchases = resp.data;

                _this.purchasesOnPage = _this.sortByCreatedAt(_this.purchases);
                // let teste = [
                //   {
                //     createdAt: "2021-05-26T16:27:41.314Z",
                //     expiresIn: 604800000,
                //     id: "702a59e4-be58-11eb-826c-0ff4922e1cc5",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "170.82.175.4",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
                //     sourceAmount: 0.00009433962264150944,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0000056604,
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x3474f6a9be8dce93c556e3d34df0752489c27ed1",
                //     targetAmount: 0.0005729432556363258,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16465788141049567,
                //     type: "purchase",
                //     updatedAt: "2021-05-28T18:18:40.049Z",
                //   },
                //   {
                //     createdAt: "2021-05-13T15:12:25.202Z",
                //     expiresIn: 604800000,
                //     id: "c4fbb126-b416-11eb-92a7-530ef5acc9ef",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.85.159.181",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "0c8bc172-5c1d-11eb-85e9-5be84782a906",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "93dbe750-5c1e-11eb-85eb-630bdf68589d",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "12XZSEzFJPv7XVSFCA384Me3pq9JxLuEKx",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.012438444330022735,
                //     type: "purchase",
                //     updatedAt: "2021-05-13T15:13:50.133Z",
                //   },
                //   {
                //     createdAt: "2021-05-13T17:17:19.975Z",
                //     expiresIn: 604800000,
                //     id: "38373afa-b428-11eb-96a5-2bea9f8b9f27",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.85.159.181",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "0c8bc172-5c1d-11eb-85e9-5be84782a906",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "93dbe750-5c1e-11eb-85eb-630bdf68589d",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1DCzm3phcSW4ML1Ca4hRnh49oGys98i89A",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.01231585600187841,
                //     type: "purchase",
                //     updatedAt: "2021-05-13T17:39:50.193Z",
                //   },
                //   {
                //     createdAt: "2021-05-25T14:16:17.922Z",
                //     expiresIn: 604800000,
                //     id: "eae276bc-bd7c-11eb-b92b-2fbe058ee326",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.85.159.181",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x0df1227eae30065e07470eb3d2f4eebe2843f97b",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16214683570086755,
                //     type: "purchase",
                //     updatedAt: "2021-05-25T14:18:31.223Z",
                //   },
                //   {
                //     createdAt: "2021-05-25T14:18:35.679Z",
                //     expiresIn: 604800000,
                //     id: "3cfe8b84-bd7d-11eb-b642-e7599156ce8b",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.85.159.181",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x135097ba8d50664fd71411b0dbba4f8119df9093",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16308946921348916,
                //     type: "purchase",
                //     updatedAt: "2021-05-25T14:20:37.730Z",
                //   },
                //   {
                //     createdAt: "2021-05-25T14:20:23.995Z",
                //     expiresIn: 604800000,
                //     id: "7d8e481a-bd7d-11eb-95e9-ffc60395ebcb",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "170.82.175.4",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settled: true,
                //     settledAt: "2021-05-27T00:12:20.822Z",
                //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
                //     sourceAmount: 0.0000679245283018868,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0000040755,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x0fad125042af4325489349d0a595bd7224709b36",
                //     targetAmount: 0.00041653325893218685,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16307107978848134,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "d414a31cd24840bc1e54e4018b21c90fb5eff390f9facab07e7d770aea8a0dbb",
                //     type: "purchase",
                //     updatedAt: "2021-05-25T14:39:27.627Z",
                //   },
                //   {
                //     createdAt: "2021-05-25T14:47:13.683Z",
                //     expiresIn: 604800000,
                //     id: "3d0137d6-bd81-11eb-9236-732c3a40e35a",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.85.159.181",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "8b266b08-b434-11eb-9c89-bfdce0d587b5",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "18svbuBgtzDHdxXhkVNbpGh96f7PSHMuYp",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011030473532582262,
                //     type: "purchase",
                //     updatedAt: "2021-05-26T16:14:02.382Z",
                //   },
                //   {
                //     createdAt: "2021-05-26T16:13:29.282Z",
                //     expiresIn: 604800000,
                //     id: "7450b7ea-be56-11eb-a48c-c3bf7242a49f",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "170.82.175.4",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "8b266b08-b434-11eb-9c89-bfdce0d587b5",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "12xkguRYSqCPgZeLwwmDAXsYNxpnSeSQ9n",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011630928598504307,
                //     type: "purchase",
                //     updatedAt: "2021-05-26T16:24:31.755Z",
                //   },
                //   {
                //     createdAt: "2021-05-26T16:25:52.337Z",
                //     expiresIn: 604800000,
                //     id: "2f35c61c-be58-11eb-b374-373755d74cd1",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "170.82.175.4",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x342a8b92597793eb9d3ff2df6354fc93e10aa4bd",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.1640864917994793,
                //     type: "purchase",
                //     updatedAt: "2021-05-26T16:27:41.191Z",
                //   },
                //   {
                //     createdAt: "2021-10-22T12:19:38.836Z",
                //     expiresIn: 604800000,
                //     id: "791143fc-334b-11ec-aff2-c75cc5b026c8",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "200.25.56.71",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1KVBKdMS17AbA7wFmkqsEnm7VGmHdQHkzw",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010945565125877747,
                //     type: "purchase",
                //     updatedAt: "2021-10-22T14:57:12.435Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T19:39:28.687Z",
                //     expiresIn: 604800000,
                //     id: "30415f6e-6441-11ec-ae53-b72d5834fe4e",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settled: true,
                //     settledAt: "2021-12-28T04:03:56.802Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceAmount: 9.433962264150944,
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     sourceFee: 0.5660377358,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TU2bnUaaPb3jZ4HYqHoQPMwqowxMPSpcF6",
                //     targetAmount: 0.014326310041645592,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 658.5060798438027,
                //     tokenStatus: "processing",
                //     tokenStep: "waiting_publish",
                //     tokenTxid:
                //       "0x7b2c8d66cceb4bce67937bc0d3f5726d557b1f4d56b8753bb383936d5da05255",
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:17:42.724Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T19:56:59.383Z",
                //     expiresIn: 604800000,
                //     id: "a284dc0c-6443-11ec-843f-075192fb3e54",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "13aPWdJiZxRcbmFJZYcVcLzxvtE7uL1Eeh",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.012966031147237446,
                //     type: "purchase",
                //     updatedAt: "2021-12-23T21:05:04.905Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T19:48:46.024Z",
                //     expiresIn: 604800000,
                //     id: "7c744b84-6442-11ec-9b1a-9ba8c8f7cef0",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "12xWeoKuDkVN6aN96pDC7nycFSn6uuihip",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.012933205956875624,
                //     type: "purchase",
                //     updatedAt: "2021-12-30T19:49:58.136Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T19:43:59.153Z",
                //     expiresIn: 604800000,
                //     id: "d1774902-6441-11ec-a284-4f36eb3028e3",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settled: true,
                //     settledAt: "2021-12-28T04:03:56.783Z",
                //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
                //     sourceAmount: 0.00010566037735849057,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0000063396,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x0a65b2d82453da3001974b99d3fbde07e1753f9d",
                //     targetAmount: 0.0006597559177007448,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.1601507080477852,
                //     tokenStatus: "processing",
                //     tokenStep: "waiting_publish",
                //     tokenTxid:
                //       "0x7907d423c960acf940d35aa41bd8adffb0ed0bfc11ccd8011b71b7808f217108",
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:17:43.795Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T19:48:47.221Z",
                //     expiresIn: 604800000,
                //     id: "7d2ae3e4-6442-11ec-be88-03c585a6fee0",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "12yJCGdDtHD7GadR9fxk1TuazuBt2EiNEb",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.012933205956875624,
                //     type: "purchase",
                //     updatedAt: "2021-12-23T19:48:58.561Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T19:49:21.140Z",
                //     expiresIn: 604800000,
                //     id: "916271ba-6442-11ec-bdee-fb7e3de44752",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "12yngmW2SRKbk2t7SvtsaYSY7yE7hkPVvB",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.012933205956875624,
                //     type: "purchase",
                //     updatedAt: "2021-12-23T19:55:11.232Z",
                //   },
                //   {
                //     createdAt: "2021-12-23T21:04:02.924Z",
                //     expiresIn: 604800000,
                //     id: "00bcdc76-644d-11ec-a060-af1189fc5638",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settled: true,
                //     settledAt: "2021-12-28T04:03:09.917Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceAmount: 11.320754726415096,
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     sourceFee: 0.6792452836,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TMS9dw1wavkEpFNp9nej6qEyw39oEWCrYq",
                //     targetAmount: 0.017183835346580786,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 658.802560551052,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x65e312b44dc774fac4acbb80a6b55e6ec6f83a60ac034c62372aa4163b56943b",
                //     type: "purchase",
                //     updatedAt: "2021-12-23T21:18:05.792Z",
                //   },
                //   {
                //     createdAt: "2022-01-25T16:07:34.506Z",
                //     id: "0da25d24-7e12-11ec-9cac-8359caea2aec",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011579060224284751,
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:07:37.880Z",
                //   },
                //   {
                //     createdAt: "2022-01-25T16:08:23.167Z",
                //     id: "2aa3b0bc-7e12-11ec-b166-077c5abe9a16",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011579060224284751,
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:08:25.792Z",
                //   },
                //   {
                //     createdAt: "2022-01-25T16:11:25.741Z",
                //     id: "9775fa2e-7e12-11ec-9130-638eaf871e39",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011552460913745542,
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:11:29.302Z",
                //   },
                //   {
                //     createdAt: "2022-01-25T16:15:59.631Z",
                //     id: "3ab65a58-7e13-11ec-8ee6-7733ae2039c7",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011529030746038869,
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:16:03.479Z",
                //   },
                //   {
                //     createdAt: "2022-01-25T16:18:36.974Z",
                //     id: "987ee90c-7e13-11ec-8fa6-2752dd816a6c",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011528734557363432,
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:18:40.008Z",
                //   },
                //   {
                //     createdAt: "2022-01-25T16:18:56.322Z",
                //     id: "a4073c66-7e13-11ec-88a2-079879b4ed5d",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011528734557363432,
                //     type: "purchase",
                //     updatedAt: "2022-01-25T16:18:58.861Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T16:25:25.332Z",
                //     id: "b650252a-7edd-11ec-ab83-8ff8cd1af139",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011544857616739606,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T16:25:29.099Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T16:26:20.780Z",
                //     id: "d75cea1e-7edd-11ec-b9ab-1b1bf5577935",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.01152178147967622,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T16:26:23.360Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T16:27:02.828Z",
                //     id: "f06d809a-7edd-11ec-a8e8-63db4f5bb9f0",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.01152178147967622,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T16:27:05.444Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T16:33:38.362Z",
                //     id: "dc2de326-7ede-11ec-a793-ffb7af90ea1f",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011668909159847704,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T16:33:41.511Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T16:36:16.582Z",
                //     id: "3a7bd0f0-7edf-11ec-96cd-7bf813ca8d81",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011632091079697536,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T16:36:19.711Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T16:36:35.693Z",
                //     id: "45dff174-7edf-11ec-9feb-93fb82f48b52",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011632091079697536,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T16:36:38.632Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T17:27:57.661Z",
                //     id: "72d8e1fc-7ee6-11ec-8020-7376b5dcbd21",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011430673576903541,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T17:28:01.533Z",
                //   },
                //   {
                //     createdAt: "2022-01-26T17:31:30.364Z",
                //     id: "f1a0991c-7ee6-11ec-8901-7b81dc0f3361",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "failed",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.011466869331457978,
                //     type: "purchase",
                //     updatedAt: "2022-01-26T17:31:33.677Z",
                //   },
                //   {
                //     createdAt: "2022-02-03T17:37:17.253Z",
                //     expiresIn: 7200000,
                //     id: "13ba4cb4-8531-11ec-801e-b70c74c53e0f",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceAmount: 0.0004716981132075472,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.0000283019,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1Ckcf533hQxrcd1okSDspWqGipA5ZY1JoV",
                //     targetAmount: 0.043058635898780076,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010954785337751752,
                //     tokenStatus: "processing",
                //     tokenStep: "waiting_publish",
                //     tokenTxid:
                //       "0x425d7085ae1d3b6d64e3815347153648564fedb0894ddf228b6e181199ee618f",
                //     type: "purchase",
                //     updatedAt: "2022-02-03T17:44:03.704Z",
                //   },
                //   {
                //     createdAt: "2022-02-03T17:50:38.640Z",
                //     expiresIn: 7200000,
                //     id: "f1646c1a-8532-11ec-b6b4-77792b3f8dd7",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
                //     sourceAmount: 0.00009623584905660377,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0000057742,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x452d598056aa21c9388ee7543536fd9cd853cc9c",
                //     targetAmount: 0.0006255795319207052,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.15383471508591823,
                //     tokenStatus: "processing",
                //     tokenStep: "waiting_publish",
                //     tokenTxid:
                //       "0x59f1f319c6c949b73ba5030c4989183649a026cf0edf9cda53b83ddc71dfcc81",
                //     type: "purchase",
                //     updatedAt: "2022-02-03T17:55:26.645Z",
                //   },
                //   {
                //     createdAt: "2022-02-03T17:58:48.831Z",
                //     expiresIn: 7200000,
                //     id: "1591bcc2-8534-11ec-8e16-7fae56adedf3",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceAmount: 8.49056603773585,
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     sourceFee: 0.5094339623,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TGMAXQPaQEW6SPe1nKAEEevfJTE44hVAQo",
                //     targetAmount: 0.02131295070091143,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 398.3759056587485,
                //     tokenStatus: "processing",
                //     tokenStep: "waiting_publish",
                //     tokenTxid:
                //       "0x6c03ac5c816e1f95fa6bd78b49711e4632a280044519d39cb3693d4ddef4c055",
                //     type: "purchase",
                //     updatedAt: "2022-02-03T18:02:47.883Z",
                //   },
                //   {
                //     createdAt: "2022-02-24T11:38:56.937Z",
                //     expiresIn: 7200000,
                //     id: "7f32c0da-957f-11ec-bd99-abbfd43ec26f",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceAmount: 8.823529411764707,
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     sourceFee: 0.1764705882,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TKNrv3wg6nLjNvjUze9cj4rBx7uqe4ea8U",
                //     targetAmount: 0.023774966489100244,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 371.1268916324193,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xd89a5cf8a8815ae3edd5f0f700998d7b66a9760915887363c36e1183c766651e",
                //     type: "purchase",
                //     updatedAt: "2022-02-24T12:33:25.995Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T16:31:17.476Z",
                //     expiresIn: 7200000,
                //     id: "a97f9930-9bf1-11ec-9067-8ba37f180cbb",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceAmount: 98.03921569607843,
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     sourceFee: 1.9607843139,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TWwNX6BPLJmNHSWKFCwaaUDZtUk8DF2Zuo",
                //     targetAmount: 0.23146369297611374,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 432.03320021467937,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xb94bc177f413b649938c4ab0e7d2431e6d2ca573b54e5cadc6ee79b624e8ccf4",
                //     type: "purchase",
                //     updatedAt: "2022-03-04T16:34:53.031Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T18:10:44.502Z",
                //     expiresIn: 7200000,
                //     id: "8e1f6ec8-9bff-11ec-a2a4-dfd5d7b250f0",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0xbdf98dd22c106feec93a4a872ed126bca4441f8b",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16294389571789933,
                //     type: "purchase",
                //     updatedAt: "2022-03-04T20:11:56.064Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T18:10:45.721Z",
                //     expiresIn: 7200000,
                //     id: "8ed97250-9bff-11ec-ab62-e314ab249af6",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x6967a8d5b432862bee3c43c8196c952fe5139d9a",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16294389571789933,
                //     type: "purchase",
                //     updatedAt: "2022-03-04T18:12:04.459Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T18:11:16.895Z",
                //     expiresIn: 7200000,
                //     id: "a16e705a-9bff-11ec-b585-a3e2e070ca2c",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
                //     sourceAmount: 0.0027622735849056603,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0000552455,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x79109ab0bc2062624e9f8685ac5013911bf0985c",
                //     targetAmount: 0.017303198489055288,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16283226980767818,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x7ec5e31b1203c8407df37ef459af88e65c1e80a9864aef18ea9d99f11163923b",
                //     type: "purchase",
                //     updatedAt: "2022-03-04T18:15:04.911Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T18:26:30.432Z",
                //     expiresIn: 7200000,
                //     id: "c1f0eb3a-9c01-11ec-aa0c-731d6be8b07c",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "e41ca790-4336-11ec-a15b-6f3fa2f6a17d",
                //     sourceAmount: 0.0035412641509433964,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0000708253,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x79109ab0bc2062624e9f8685ac5013911bf0985c",
                //     targetAmount: 0.02219746497434476,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16272531368415957,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xe8f450f065c5c5b7fbd9bc7811bc78c22cd07e7bdd81adccd870add697ccdd91",
                //     type: "purchase",
                //     updatedAt: "2022-03-04T18:30:26.868Z",
                //   },
                //   {
                //     createdAt: "2022-03-07T15:05:30.471Z",
                //     expiresIn: 7200000,
                //     id: "2ce23b4c-9e41-11ec-9940-37bb77382f49",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceAmount: 0.002,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.00004,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1CFaRTSCmdvcBGZ1tDG8xV14hFXx11nHZJ",
                //     targetAmount: 0.18995459047257354,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010739408797254331,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x159e907e97513dbb7dde8232b09dd43285f1e50d14a8147c903f7aaa4b152751",
                //     type: "purchase",
                //     updatedAt: "2022-03-07T15:23:16.919Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T18:10:41.769Z",
                //     expiresIn: 7200000,
                //     id: "8c7e54b2-9bff-11ec-8117-87b666c8a03e",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x5984ca9af2bb416fae50cb2c19e3d872badb21a4",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16294389571789933,
                //     type: "purchase",
                //     updatedAt: "2022-03-04T20:11:57.946Z",
                //   },
                //   {
                //     createdAt: "2022-03-04T18:10:45.512Z",
                //     expiresIn: 7200000,
                //     id: "8eb97fea-9bff-11ec-ab67-bf0f4aaed8c2",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0xcda2a4350373262d6728936b01e1c297a4df3399",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16294389571789933,
                //     type: "purchase",
                //     updatedAt: "2022-03-04T20:11:54.034Z",
                //   },
                //   {
                //     createdAt: "2022-03-07T15:30:14.109Z",
                //     expiresIn: 7200000,
                //     id: "a1337684-9e44-11ec-96cf-af86fec21b1f",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "e3f60928-4336-11ec-a1e4-8fe66e6e8235",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "18fk3cqJEMsoaGnHNww1NeSTHVrbfA28cj",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010715786027751698,
                //     type: "purchase",
                //     updatedAt: "2022-03-07T15:33:00.195Z",
                //   },
                //   {
                //     createdAt: "2022-03-07T15:32:26.850Z",
                //     expiresIn: 7200000,
                //     id: "f0520fd2-9e44-11ec-9216-efc45a12ccf2",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "e3f60928-4336-11ec-a1e4-8fe66e6e8235",
                //     sourceAmount: 0.002,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.00004,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "18fk3cqJEMsoaGnHNww1NeSTHVrbfA28cj",
                //     targetAmount: 0.19057815344551501,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010704269944473054,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x8d755cef4ba4186230f437661b5e929f050740519adf1dad9e4aad8418a6e0aa",
                //     type: "purchase",
                //     updatedAt: "2022-03-07T15:35:34.406Z",
                //   },
                //   {
                //     createdAt: "2022-03-07T16:25:36.146Z",
                //     expiresIn: 7200000,
                //     id: "5d49e2a2-9e4c-11ec-bd9c-9713c1f5efa9",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "8c5d50f8-43e6-11ec-916b-5b4b67b11c32",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settled: true,
                //     settledAt: "2022-03-08T09:56:00.219Z",
                //     sourceAccountId: "98f35876-43e6-11ec-8965-1b0530cda71a",
                //     sourceAmount: 0.0020188679245283017,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.0000403774,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1Q7VTVWaoc4RYjmhYtvgs7BNrNAbq6Y3vU",
                //     targetAmount: 0.19248025178257636,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.01069847584600213,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x02c491093f6e0c88f413f37706a7318e45aaeee3774fbfb6011324ad34bee350",
                //     type: "purchase",
                //     updatedAt: "2022-03-07T16:29:52.290Z",
                //   },
                //   {
                //     createdAt: "2022-03-08T13:50:36.500Z",
                //     expiresIn: 7200000,
                //     id: "e0ae9ed6-9eff-11ec-8c75-a7d63c98340c",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settled: true,
                //     settledAt: "2022-03-08T16:50:59.878Z",
                //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
                //     sourceAmount: 0.02830188679245283,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0005660377,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0xcda2a4350373262d6728936b01e1c297a4df3399",
                //     targetAmount: 0.17913173802423613,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16115471669541365,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xf90c6b51a4569d32dd853a4c1f9537ea0d179dca89d47d9e9911ab502f098487",
                //     type: "purchase",
                //     updatedAt: "2022-03-08T13:55:56.044Z",
                //   },
                //   {
                //     createdAt: "2022-03-08T14:04:47.630Z",
                //     expiresIn: 7200000,
                //     id: "dbfe555a-9f01-11ec-ad32-ff8ff7f58250",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "64295ab8-1b7b-11ea-9d70-9ba1b056b4f5",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "cb9b6c04-1b7b-11ea-9d72-7b7a61a5f57a",
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0xcda2a4350373262d6728936b01e1c297a4df3399",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16044588000319096,
                //     type: "purchase",
                //     updatedAt: "2022-03-08T14:06:14.298Z",
                //   },
                //   {
                //     createdAt: "2022-03-08T14:05:36.112Z",
                //     expiresIn: 7200000,
                //     id: "f8e40732-9f01-11ec-8cea-9b31dbceceb4",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "64295ab8-1b7b-11ea-9d70-9ba1b056b4f5",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settled: true,
                //     settledAt: "2022-03-08T16:50:59.855Z",
                //     sourceAccountId: "cb6b3c5a-1b7b-11ea-a7bf-6311c9c3df90",
                //     sourceAmount: 0.0028301886792452833,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.0000566038,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1DiSXSs5CTLzKHo8gNjitD93pRBRm617p",
                //     targetAmount: 0.27057970787361457,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010668917125868429,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xd04ca8b2958a401d9c9a1d0b401515bb1c23a0a53cf3ea070ecbad3d08a36bd8",
                //     type: "purchase",
                //     updatedAt: "2022-03-08T14:09:15.824Z",
                //   },
                //   {
                //     createdAt: "2022-03-08T14:18:40.603Z",
                //     expiresIn: 7200000,
                //     id: "cc7bdb3c-9f03-11ec-88f8-43db0310eda5",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1BujobWrgiBDxLyvCey1VfeVGABatSQG76",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010669242247409063,
                //     type: "purchase",
                //     updatedAt: "2022-03-08T14:20:25.437Z",
                //   },
                //   {
                //     createdAt: "2022-03-08T14:20:17.680Z",
                //     expiresIn: 7200000,
                //     id: "06589d90-9f04-11ec-9269-974673111050",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settled: true,
                //     settledAt: "2022-03-08T16:50:59.832Z",
                //     sourceAccountId: "496790aa-a6c1-11eb-b320-bb3daaad15cb",
                //     sourceAmount: 0.01905238679245283,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0003810477,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0xcd8d921f32462a2c0064c543117e606474581b6f",
                //     targetAmount: 0.12161981705516148,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.15978838780557175,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x0a30da8b9c213e5f67203e84d918b7ea524250cc48e2478abd0842609af2a810",
                //     type: "purchase",
                //     updatedAt: "2022-03-08T14:25:37.073Z",
                //   },
                //   {
                //     createdAt: "2022-03-08T15:26:11.414Z",
                //     expiresIn: 7200000,
                //     id: "3af490dc-9f0d-11ec-ac4d-2f8bdc393802",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settled: true,
                //     settledAt: "2022-03-08T16:50:59.809Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceAmount: 0.0010588235294117646,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.0000211765,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "18fk3cqJEMsoaGnHNww1NeSTHVrbfA28cj",
                //     targetAmount: 0.10015962799097962,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.0107827879463473,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xf9e2f08cdbbfd54cecea9f051b3d56caf4f893e20ca37ede6d9bcb6591ba7031",
                //     type: "purchase",
                //     updatedAt: "2022-03-08T15:35:56.779Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T17:14:16.694Z",
                //     expiresIn: 7200000,
                //     id: "7ee5a046-9fe5-11ec-9a33-b3b773af548b",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
                //     sourceAmount: 0.02071772549019608,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0004143545,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x5984ca9af2bb416fae50cb2c19e3d872badb21a4",
                //     targetAmount: 0.12826366177861961,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16475500307070295,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xbb63f34d8d3c00398594aa36ccb78ba691bd1864cd1f0ee6538a1c9c9681d395",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T17:17:47.312Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T18:19:12.465Z",
                //     expiresIn: 7200000,
                //     id: "90f53e28-9fee-11ec-978e-5745c9b0b774",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settled: true,
                //     settledAt: "2022-03-09T20:27:57.282Z",
                //     sourceAccountId: "e41ca790-4336-11ec-a15b-6f3fa2f6a17d",
                //     sourceAmount: 0.019746725490196078,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0003949345,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x452d598056aa21c9388ee7543536fd9cd853cc9c",
                //     targetAmount: 0.12212344107997931,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16492869683392883,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xf9f38be161ef77db26cecee029894792bd6109bf7bedf930f1fa360160c64f71",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T18:22:17.057Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T19:08:42.196Z",
                //     expiresIn: 7200000,
                //     id: "7b0e5412-9ff5-11ec-a24a-d71fe968c3a5",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     status: "expired",
                //     step: 1,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TJmHcNJM9SaNz7V3Zfmvgn9J9jqAFscY5z",
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 444.646229926697,
                //     type: "purchase",
                //     updatedAt: "2022-03-09T19:30:53.593Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T18:44:38.181Z",
                //     expiresIn: 7200000,
                //     id: "1e5b0c54-9ff2-11ec-a35d-13a21b8c1827",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settled: true,
                //     settledAt: "2022-03-09T20:27:57.261Z",
                //     sourceAccountId: "03f6db3e-852d-11ec-af49-1fbd999ca8b4",
                //     sourceAmount: 0.000980392156862745,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.0000196078,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1CFaRTSCmdvcBGZ1tDG8xV14hFXx11nHZJ",
                //     targetAmount: 0.09410477729431171,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010626452616058542,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x39fba4fe304ee1effea0c84b40a9d1e4de3129376bec60feaaf373dfeff7f306",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T18:48:55.619Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T19:30:44.093Z",
                //     expiresIn: 7200000,
                //     id: "8ef78f5e-9ff8-11ec-aad7-131501a29bb5",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settled: true,
                //     settledAt: "2022-03-09T20:27:57.192Z",
                //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
                //     sourceAmount: 0.000980392156862745,
                //     sourceCurrency: {
                //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Bitcoin",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "BTC",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2020-07-14T00:00:00.000Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 2.4,
                //           rewardReferred: 2,
                //           startAt: "2020-07-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-03-31T18:17:57.882Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-04-11T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-06-19T01:14:00.371Z",
                //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.0010000000474974513,
                //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 0.002,
                //       withdrawMinimal: 0.02,
                //     },
                //     sourceFee: 0.0000196078,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "1DiSXSs5CTLzKHo8gNjitD93pRBRm617p",
                //     targetAmount: 0.09411989155921884,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.010624746164667647,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x4fde6953b84d2a62dc023a07a4c2f1d78fe0cefbab120a55d6fde3da4b386060",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T19:34:22.063Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T20:57:09.038Z",
                //     expiresIn: 7200000,
                //     id: "a16f260e-a004-11ec-8a7a-0f11d8b26105",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "496790aa-a6c1-11eb-b320-bb3daaad15cb",
                //     sourceAmount: 0.0196078431372549,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0003921569,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0xcd8d921f32462a2c0064c543117e606474581b6f",
                //     targetAmount: 0.12211576411648681,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16377901888389124,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x96906ba168b4b83d5dbaedc7a614216db26b5ecc07b70b8d9746d88142f36140",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T21:00:50.802Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T21:43:21.482Z",
                //     expiresIn: 7200000,
                //     id: "15f07c66-a00b-11ec-8405-1f4462f65d1d",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
                //     sourceAmount: 49.01960784313726,
                //     sourceCurrency: {
                //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //       isAvailable: true,
                //       name: "Tether",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "USDT",
                //       taxes: [
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "407d530c-8358-11ec-b72e-775b917068b1",
                //           math: "rush",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-02-01T12:12:40.394Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2022-01-30T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:32.367Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 100,
                //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
                //           math: "rush",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-28T11:26:27.948Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 50,
                //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
                //           math: "absolut",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           createdAt: "2022-01-31T12:38:42.208Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 1,
                //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
                //           math: "percent",
                //           startAt: "2022-01-20T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-06-14T00:00:00.000Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.001,
                //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
                //           math: "absolut",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //         {
                //           bonusRefer: 25,
                //           bonusReferrer: 50,
                //           charityReferred: 3,
                //           charitySimple: 50,
                //           createdAt: "2022-02-18T14:47:59.152Z",
                //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 2,
                //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
                //           math: "percent",
                //           revenue: 50,
                //           revenueAmbassador: 25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-06-14T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //       ],
                //     },
                //     sourceFee: 0.9803921569,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "TFH9ZYmYYxCF3qq1xeMHG99ZcJXT3TnT66",
                //     targetAmount: 0.11247538116212005,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 444.5417253395935,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0x603e355bd377c5b8adfc478b222d0b164fe659cb2c7a338325b67103018a2d99",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T21:46:55.131Z",
                //   },
                //   {
                //     createdAt: "2022-03-09T21:28:38.101Z",
                //     expiresIn: 7200000,
                //     id: "07674474-a009-11ec-88a6-bf4d7e8c0b84",
                //     insertTime: "0001-01-01T00:00:00.000Z",
                //     ip: "187.49.237.178",
                //     lastUpdate: "0001-01-01T00:00:00.000Z",
                //     memberId: "64295ab8-1b7b-11ea-9d70-9ba1b056b4f5",
                //     pinId: "00000000-0000-0000-0000-000000000000",
                //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
                //     settledAt: "0001-01-01T00:00:00.000Z",
                //     sourceAccountId: "cb9b6c04-1b7b-11ea-9d72-7b7a61a5f57a",
                //     sourceAmount: 0.00980392156862745,
                //     sourceCurrency: {
                //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //       isAvailable: true,
                //       marketPercent: 22.5,
                //       name: "Ethereum",
                //       onlyAsset: false,
                //       precision: 8,
                //       symbol: "ETH",
                //       taxes: [
                //         {
                //           bonusRefer: 1,
                //           charityReferred: 3,
                //           charitySimple: 1,
                //           createdAt: "2021-02-01T00:00:00.000Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.25,
                //           rewardAmbassador: 2.75,
                //           rewardReferred: 2,
                //           startAt: "2021-02-01T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusRefer: 1,
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2019-08-01T16:37:25.014Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 6,
                //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
                //           math: "percent",
                //           revenue: 2,
                //           revenueAmbassador: 3.6,
                //           rewardAmbassador: 3,
                //           rewardReferred: 2,
                //           startAt: "2019-03-16T00:00:00.000Z",
                //           type: "purchase",
                //         },
                //         {
                //           bonusReferrer: 1,
                //           charityReferred: 1,
                //           charitySimple: 3,
                //           createdAt: "2021-02-09T15:27:01.495Z",
                //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
                //           endAt: "2090-01-01T00:00:00.000Z",
                //           fee: 0.002,
                //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
                //           math: "absolut",
                //           revenue: 2,
                //           rewardAmbassador: 3,
                //           startAt: "2018-11-01T00:00:00.000Z",
                //           type: "redeem",
                //         },
                //       ],
                //       tradeMinimal: 1e-7,
                //     },
                //     sourceFee: 0.0001960784,
                //     status: "done",
                //     step: 4,
                //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
                //     targetAddress: "0x6967a8d5b432862bee3c43c8196c952fe5139d9a",
                //     targetAmount: 0.060918698487736234,
                //     targetCurrency: {
                //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
                //       isAvailable: true,
                //       name: "Stratumblue",
                //       onlyAsset: false,
                //       precision: 6,
                //       symbol: "BLU",
                //       taxes: null,
                //       tradeMinimal: 2,
                //       withdrawMinimal: 0.01,
                //     },
                //     targetPrice: 0.16415321103159464,
                //     tokenStatus: "done",
                //     tokenStep: "steps_done",
                //     tokenTxid:
                //       "0xb15824ad9e83614fbb341662178bd9f31fd70e28fdd20347f72861faa1ef8ddd",
                //     type: "purchase",
                //     updatedAt: "2022-03-09T21:33:34.252Z",
                //   },
                // ];

                // this.purchasesOnPage = teste;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },
    applyFilter: function applyFilter() {
      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      var date1 = new Date(startDateOnInput);
      var date2 = new Date(endDateOnInput);

      var startDate = date1.getFullYear() + "-" + (date1.getMonth() + 1 < 10 ? "0" + (date1.getMonth() + 1) : date1.getMonth() + 1) + "-" + (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()) + "T00:00:00.000Z";

      var endDate = date2.getFullYear() + "-" + (date2.getMonth() + 1 < 10 ? "0" + (date2.getMonth() + 1) : date2.getMonth() + 1) + "-" + (date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()) + "T23:59:999Z";

      this.filterRowByDate(startDate, endDate);
    },
    filterRowByDate: function filterRowByDate(startDate, endDate) {
      var _this2 = this;

      this.purchasesOnPage = this.purchases;

      this.purchasesOnPage = this.purchasesOnPage.filter(function (item) {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.purchasesOnPage = this.purchasesOnPage.filter(function (item) {
          return item.status == _this2.statusFilter;
        });
      }
    },
    clearFilter: function clearFilter() {
      var vm = this;
      this.purchasesOnPage = this.purchases;
      this.statusFilter = "all";
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },
    ajustTokenID: function ajustTokenID(tokenID) {
      var str = tokenID;
      var res = str.substring(0, 15);

      return res + "... [+]";
    },
    getCertificateByID: function getCertificateByID(transcationId, transactionType) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, resp, url, link;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  type: "trade",
                  id: transcationId
                };
                _context2.prev = 1;
                _context2.next = 4;
                return _this3.$store.dispatch("getCertificateByTypeId", params);

              case 4:
                resp = _context2.sent;
                url = window.URL.createObjectURL(new Blob([resp.data]));
                link = document.createElement("a");

                link.href = url;
                link.setAttribute("download", "certificate_" + transcationId + ".pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](1);

                _this3.logError(_context2.t0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 13]]);
      }))();
    },
    getDetails: function getDetails(params) {
      // this.getTransactionDetails(params.type, params.id);
      console.log(params);

      this.transactionData = params;
    },
    getTransactionDetails: function getTransactionDetails(transactionType, transactionId) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var operation, resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                operation = void 0;

                operation = transactionType.charAt(0).toUpperCase() + transactionType.slice(1);
                _context3.prev = 2;
                _context3.next = 5;
                return _this4.$store.dispatch("get" + operation + "ById", transactionId);

              case 5:
                resp = _context3.sent;

                _this4.transactionData = resp.data;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);

                _this4.logError(_context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[2, 9]]);
      }))();
    },
    clearTransactionData: function clearTransactionData() {
      this.transactionData = "";
    },
    updateCancelled: function updateCancelled(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.clearTransactionData();
                _context4.prev = 1;
                _context4.next = 4;
                return _this5.$store.dispatch("putCancelPurchase", id);

              case 4:
                _this5.$emit("updateCancelled", id);
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);

                console.log(_context4.t0);

              case 10:
                _this5.getTransactions();

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[1, 7]]);
      }))();
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_spacetime___default()(value).format("dd/MM/yyyy HH:mm:SS");
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["transactionData"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {};
  },
  components: {},
  methods: {
    cancelPurchase: function cancelPurchase(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit("updateCancelled", id);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getTotal: function getTotal(total, price) {
      // let sum = 0;
      // if (total > 0 && fee) {
      //   sum = total + fee;
      //   return sum.toFixed(8);
      // }
      var totalT = total * price;
      return totalT.toFixed(6);
    },
    getTotalFee: function getTotalFee(total, price, fee) {
      var totalT = total * price;
      totalT = totalT - fee;
      return totalT.toFixed(6);
    },
    symbAjust: function symbAjust(el) {
      if (el == 'blu' || el == 'BLU') {
        return "BLUE";
      } else {
        return el;
      }
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_0_spacetime___default()(value).format("dd/MM/yyyy HH:mm:SS");
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getRedeem();
    // this.tradeTracking(this.tradeTrackType);
  },
  mounted: function mounted() {},

  data: function data() {
    var _ref;

    return _ref = {
      searchBox: "",
      statusFilter: "all",
      filterStartDateInit: "",
      filterEndDateInit: "",
      filterEndDate: "",
      filterStartDate: ""
    }, _defineProperty(_ref, "filterEndDate", ""), _defineProperty(_ref, "redeems", []), _defineProperty(_ref, "redeemsOnPage", []), _defineProperty(_ref, "tradeTrackType", "redeem"), _defineProperty(_ref, "lastRedeem", ""), _defineProperty(_ref, "keyTable", 0), _defineProperty(_ref, "columns", [{
      label: "address",
      field: "targetAddress",
      filterable: true
    }, {
      label: "txid",
      field: "tokenTxid",
      filterable: true
    }, {
      label: "createdAt",
      field: "createdAt"
    }, {
      label: "updatedAt",
      field: "updatedAt"
    }, {
      label: "amount",
      field: "sourceAmount",
      type: "number",
      filterable: true
    }, {
      label: "amountBTC",
      field: "targetAmount",
      type: "number",
      filterable: true
    }, {
      label: "status",
      field: "status",
      filterable: true
    }]), _ref;
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    getRedeem: function getRedeem() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getRedeems");

              case 3:
                resp = _context.sent;

                _this.redeems = resp.data;
                _this.redeemsOnPage = _this.sortByCreatedAt(_this.redeems);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },


    // async tradeTracking(type){
    //   let resp = await this.$store.dispatch('getTradeType', type);
    //   this.lastRedeem = resp.data;
    // },

    findTradeTrack: function findTradeTrack() {
      for (var i = 0; i < this.redeemsOnPage.length; i++) {
        if (this.redeemsOnPage[i].id == this.lastRedeem.tradeId) {
          this.redeemsOnPage[i].step = this.lastRedeem.step;
          break;
        }
      }
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });
      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },
    applyFilter: function applyFilter() {
      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      var date1 = new Date(startDateOnInput);
      var date2 = new Date(endDateOnInput);

      var startDate = date1.getFullYear() + "-" + (date1.getMonth() + 1 < 10 ? "0" + (date1.getMonth() + 1) : date1.getMonth() + 1) + "-" + (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()) + "T00:00:00.000Z";

      var endDate = date2.getFullYear() + "-" + (date2.getMonth() + 1 < 10 ? "0" + (date2.getMonth() + 1) : date2.getMonth() + 1) + "-" + (date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()) + "T23:59:999Z";

      this.filterRowByDate(startDate, endDate);
    },
    filterRowByDate: function filterRowByDate(startDate, endDate) {
      var _this2 = this;

      this.redeemsOnPage = this.redeems;

      this.redeemsOnPage = this.redeemsOnPage.filter(function (item) {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.redeemsOnPage = this.redeemsOnPage.filter(function (item) {
          return item.status == _this2.statusFilter;
        });
      }
    },
    clearFilter: function clearFilter() {
      var vm = this;
      this.redeemsOnPage = this.redeems;

      this.filterEndDate = this.filterEndDateInit;
      this.filterStartDate = this.filterStartDateInit;

      this.statusFilter = 'all';
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;
        return cellValue;
      }
    },
    ajustTokenID: function ajustTokenID(tokenID) {
      var str = tokenID;
      var res = str.substring(0, 15);
      return res + "... [+]";
    },
    cancelRedeem: function cancelRedeem(id) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, rest;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this3;

                if (!confirm(_this3.$t("msg.confirm_delet"))) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 2;
                _context2.next = 5;
                return _this3.$store.dispatch("putRedeem", id);

              case 5:
                rest = _context2.sent;

                _this3.notifySuccess(_this3.$t("msg.redeem_deleted_success"), 5000);
                // self.keyTable = self.keyTable +1;
                self.keyTable = self.keyTable + 1;
                _this3.getRedeem();
                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);

                _this3.notifyDanger(_this3.$t("msg.redeem_deleted_error"), 5000);
                console.log(_context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 11]]);
      }))();
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_spacetime___default()(value).format("dd/MM/yyyy HH:mm:SS");
    }
  },
  computed: {},
  watch: {
    redeemsOnPage: function redeemsOnPage() {
      // this.findTradeTrack();
      // this.getRedeem();
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import moment from 'moment'

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getRewards();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      rewards: rewards,

      searchBox: "",
      filterType: "all",
      filterStartDate: "",
      filterEndDate: "",
      purchases: [],
      purchasesOnPage: [],
      columns: [{
        label: "id",
        field: "tokenTxid",
        filterable: true
      }, {
        label: "createdAt",
        field: "createdAt",
        filterable: true
      }, {
        label: "updatedAt",
        field: "updatedAt",
        filterable: true
      }, {
        label: "sourceAmount",
        field: "sourceAmount",
        type: "number",
        filterable: true
      }, {
        label: "status",
        field: "status",
        filterable: true
      }, {
        label: "actions",
        field: "actions",
        filterable: false
      }]
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    getRewards: function getRewards() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getRewards");

              case 3:
                resp = _context.sent;

                _this.rewards = resp.data;
                _this.purchasesOnPage = _this.rewards;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });
      return array;
    },
    convertDates: function convertDates() {
      var purchasesFix = this.purchases;
      var self = this;
      purchasesFix.forEach(function (purchase, index) {
        purchase.createdAt = self.filterDate(purchase.createdAt);
        purchase.updatedAt = self.filterDate(purchase.updatedAt);
      });
    },
    filterDate: function filterDate(dateToFilter) {
      var date = new Date(dateToFilter);
      var day = date.getDate();
      var year = date.getFullYear();
      var month = date.getUTCMonth() + 1;
      var hour = date.getUTCHours();
      var minute = date.getUTCMinutes();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      return year + "/" + month + "/" + day + " - " + hour + ":" + minute;
    },
    applyFilter: function applyFilter() {
      var _this2 = this;

      if (this.filterType !== "all") {
        this.purchasesOnPage = this.purchases;
        var newPurchasesOnPage = this.purchasesOnPage.filter(function (item) {
          return item.status == _this2.filterType;
        });

        this.purchasesOnPage = newPurchasesOnPage;
        console.log(this.purchasesOnPage);
      } else {
        this.purchasesOnPage = this.purchases;
        console.log(this.purchasesOnPage);
      }

      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      this.filterRowByDate(endDateOnInput, startDateOnInput);
    },
    filterRowByDate: function filterRowByDate(endDateOnInput, startDateOnInput) {
      console.log(this.purchasesOnPage);
      this.purchasesOnPage = this.purchasesOnPage.filter(function (item) {
        return new Date(item.createdAt) <= endDateOnInput && new Date(item.createdAt) >= startDateOnInput;
      });
      // this.loadingTransactions = false;
    },
    clearFilter: function clearFilter() {
      var vm = this;
      this.purchasesOnPage = this.transactions;
      // this.filterType = "all";
      // this.filterStartDate = new Date(vm.purchasesOnPage[0].createdAt);
      // this.filterEndDate = new Date();
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount"])),
  watch: {
    purchases: function purchases() {
      this.convertDates();
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getDeposits();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      searchBox: "",
      statusFilter: "all",
      filterStartDate: "",
      filterEndDate: "",
      deposits: [],
      depositsOnPage: [],
      columns: [
      // {
      //   label: "id",
      //   field: "txID",
      //   filterable: true,
      // },
      {
        label: "createdAt",
        field: "createdAt"
      },
      // {
      //   label: "updatedAt",
      //   field: "updatedAt",
      // },
      {
        label: "amount",
        field: "amount",
        type: "number",
        filterable: true
      }, {
        label: "status",
        field: "status",
        filterable: true
      }]
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    getDeposits: function getDeposits() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getDeposits");

              case 3:
                resp = _context.sent;

                _this.deposits = resp.data;
                _this.depositsOnPage = _this.sortByCreatedAt(_this.deposits);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    fixedAmountBySymbol: function fixedAmountBySymbol(value, symbol) {
      if (symbol == "BRL") {
        return value.toFixed(2);
      } else {
        return value.toFixed(8);
      }
    },
    returnSymb: function returnSymb(el) {
      if (el == 'blu' || el == 'BLU') {
        return 'BLUE';
      } else {
        return el;
      }
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },
    applyFilter: function applyFilter() {
      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      var date1 = new Date(startDateOnInput);
      var date2 = new Date(endDateOnInput);

      var startDate = date1.getFullYear() + "-" + (date1.getMonth() + 1 < 10 ? "0" + (date1.getMonth() + 1) : date1.getMonth() + 1) + "-" + (date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()) + "T00:00:00.000Z";

      var endDate = date2.getFullYear() + "-" + (date2.getMonth() + 1 < 10 ? "0" + (date2.getMonth() + 1) : date2.getMonth() + 1) + "-" + (date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()) + "T23:59:999Z";

      this.filterRowByDate(startDate, endDate);
    },
    filterRowByDate: function filterRowByDate(startDate, endDate) {
      var _this2 = this;

      this.depositsOnPage = this.deposits;

      this.depositsOnPage = this.depositsOnPage.filter(function (item) {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.depositsOnPage = this.depositsOnPage.filter(function (item) {
          return item.status == _this2.statusFilter;
        });
      }
    },
    clearFilter: function clearFilter() {
      var vm = this;
      this.depositsOnPage = this.deposits;
      this.statusFilter = "all";
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },
    ajustTokenID: function ajustTokenID(tokenID) {
      var str = tokenID;
      var res = str.substring(0, 15);

      return res + "... [+]";
    },
    getSlipsLink: function getSlipsLink(obj) {
      var jsonObjt = JSON.parse(obj);
      return jsonObjt.document_pdf;
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_spacetime___default()(value).format("dd/MM/yyyy HH:mm:SS");
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getDeposits();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      searchBox: "",
      statusFilter: "all",
      filterStartDate: "",
      filterEndDate: "",
      withdraws: [],
      withdrawsOnPage: [],
      columns: [{
        label: "id",
        field: "blochchainOpeation.operationEtxid",
        filterable: true
      }, {
        label: "createdAt",
        field: "createdAt"
      }, {
        label: "updatedAt",
        field: "updatedAt"
      }, {
        label: "amount",
        field: "amount",
        type: "number",
        filterable: true
      }, {
        label: "status",
        field: "status",
        filterable: true
        // {
        //   label: "actions",
        //   field: "actions",
        //   filterable: false
        // }
      }]
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    getDeposits: function getDeposits() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getWithdraws");

              case 3:
                resp = _context.sent;

                _this.withdraws = _this.sortByCreatedAt(resp.data);
                _this.withdrawsOnPage = _this.sortByCreatedAt(resp.data);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    symbAjust: function symbAjust(el) {
      if (el == 'BLU') {
        return 'BLUE';
      } else {
        return el;
      }
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },
    applyFilter: function applyFilter() {
      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      var date1 = new Date(startDateOnInput);
      var date2 = new Date(endDateOnInput);

      var startDate = date1.getFullYear() + "-" + (date1.getMonth() + 1 < 10 ? '0' + (date1.getMonth() + 1) : date1.getMonth() + 1) + "-" + (date1.getDate() < 10 ? '0' + date1.getDate() : date1.getDate()) + "T00:00:00.000Z";

      var endDate = date2.getFullYear() + "-" + (date2.getMonth() + 1 < 10 ? '0' + (date2.getMonth() + 1) : date2.getMonth() + 1) + "-" + (date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()) + "T23:59:999Z";

      this.filterRowByDate(startDate, endDate);
    },
    filterRowByDate: function filterRowByDate(startDate, endDate) {
      var _this2 = this;

      this.withdrawsOnPage = this.withdraws;

      this.withdrawsOnPage = this.withdrawsOnPage.filter(function (item) {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.withdrawsOnPage = this.withdrawsOnPage.filter(function (item) {
          return item.status == _this2.statusFilter;
        });
      }
    },
    clearFilter: function clearFilter() {
      var vm = this;
      this.withdrawsOnPage = this.withdraws;
      this.statusFilter = "all";
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },
    ajustTokenID: function ajustTokenID(tokenID) {
      var str = tokenID;
      var res = str.substring(0, 15);

      return res + "... [+]";
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_spacetime___default()(value).format('dd/MM/yyyy HH:mm:SS');
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_spacetime__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import moment from 'moment'


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getWithdraws();
    this.getAccountsVersion();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      internalWithdraws: "",
      searchBox: "",
      statusFilter: "all",
      filterStartDate: "",
      filterEndDate: "",
      withdraws: [],
      depositsOnPage: [],
      accountVersion: [],
      internalReceive: [],
      totalArray: [],
      tableRows: [],
      columns: [
      // {
      //   label: "id",
      //   field: "blochchainOpeation.operationEtxid",
      //   filterable: true
      // },
      {
        label: "memberUID",
        field: "memberUID",
        hidden: true
      }, {
        label: "address",
        field: "address"
      }, {
        label: "createdAt",
        field: "createdAt"
      }, {
        label: "updatedAt",
        field: "updatedAt"
      }, {
        label: "amount",
        field: "amount",
        type: "number",
        filterable: true
      }, {
        label: "status",
        field: "status",
        filterable: true
      }, {
        label: "action",
        field: "action",
        filterable: true
      }]
    };
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
  },
  methods: {
    symbAjust: function symbAjust(el) {
      if (el == 'BLU') {
        return 'BLUE';
      } else {
        return el;
      }
    },
    getWithdraws: function getWithdraws() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$store.dispatch("getWithdraws");

              case 3:
                resp = _context.sent;

                _this.withdraws = resp.data;

                // this.internalWithdraws = this.sortByCreatedAt(this.withdraws);
                _this.internalWithdraws = _this.withdraws;

                _this.filterInternalWithdraws(_this.internalWithdraws);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    getAccountsVersion: function getAccountsVersion() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getAccountsVersions").then(function (resp) {
                  _this2.accountVersion = resp.data;

                  _this2.appendArray();
                }).catch(function (e) {
                  console.log(e);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterInternalWithdraws: function filterInternalWithdraws(withdraws) {
      var array = [];
      for (var i in withdraws) {
        if (withdraws[i].type == "internal") {
          array.push(withdraws[i]);
          withdraws[i].action = 'send';
        }
      }

      this.internalWithdraws = array;

      // this.appendArray();
    },
    sortByCreatedAt: function sortByCreatedAt(array) {
      array.sort(function (a, b) {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;

      return array;
    },
    applyFilter: function applyFilter() {
      var startDateOnInput = this.filterStartDate;
      var endDateOnInput = this.filterEndDate;

      var date1 = new Date(startDateOnInput);
      var date2 = new Date(endDateOnInput);

      var startDate = date1.getFullYear() + "-" + (date1.getMonth() + 1 < 10 ? '0' + (date1.getMonth() + 1) : date1.getMonth() + 1) + "-" + (date1.getDate() < 10 ? '0' + date1.getDate() : date1.getDate()) + "T00:00:00.000Z";

      var endDate = date2.getFullYear() + "-" + (date2.getMonth() + 1 < 10 ? '0' + (date2.getMonth() + 1) : date2.getMonth() + 1) + "-" + (date2.getDate() < 10 ? '0' + date2.getDate() : date2.getDate()) + "T23:59:999Z";

      this.filterRowByDate(startDate, endDate);
    },
    filterRowByDate: function filterRowByDate(startDate, endDate) {
      var _this3 = this;

      this.tableRows = this.totalArray;

      this.tableRows = this.tableRows.filter(function (item) {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.tableRows = this.tableRows.filter(function (item) {
          return item.status == _this3.statusFilter;
        });
      }
    },
    clearFilter: function clearFilter() {
      this.tableRows = this.totalArray;
      this.statusFilter != "all";
    },
    customSearch: function customSearch(row, col, cellValue, searchTerm) {
      var vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },
    ajustTokenID: function ajustTokenID(tokenID) {
      var str = tokenID;
      var res = str.substring(0, 15);

      return res + "... [+]";
    },
    formatDate: function formatDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_spacetime___default()(value).format("dd/MM/yyyy HH:mm:SS");
    },
    linkVersionToWithdraw: function linkVersionToWithdraw(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.$store.dispatch('getWithdrawById', id);

              case 2:
                resp = _context3.sent;

                if (!(resp.status == 200)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", resp);

              case 7:
                console.log('error');

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    appendArray: function appendArray() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var moves, i, resp, internal, receive;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                moves = _this5.accountVersion;
                _context4.t0 = regeneratorRuntime.keys(moves);

              case 2:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 12;
                  break;
                }

                i = _context4.t1.value;

                if (!(moves[i].modifiableType == "withdraw_done" && moves[i].balance > 0)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return _this5.linkVersionToWithdraw(moves[i].modifiableId);

              case 7:
                resp = _context4.sent;

                resp.data.action = 'receive';
                _this5.internalReceive.push(resp.data);

              case 10:
                _context4.next = 2;
                break;

              case 12:
                _context4.next = 14;
                return _this5.internalWithdraws;

              case 14:
                internal = _context4.sent;
                _context4.next = 17;
                return _this5.internalReceive;

              case 17:
                receive = _context4.sent;


                _this5.totalArray = receive.concat(internal);
                _this5.tableRows = receive.concat(internal);

                _this5.sortByCreatedAt(_this5.totalArray);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_public_BaseLoading__ = __webpack_require__(205);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getReferrals();
  },
  mounted: function mounted() {
    this.getReferrals();
  },

  data: function data() {
    return {
      loadingRewards: false,
      hasReferrals: true,
      referralURI: "/app/referralcode=",
      referralColumns: [{
        label: "createdAt",
        field: "createdAt",
        sortable: true
      },
      // {
      //   label: "updatedAt",
      //   field: "updatedAt",
      //   sortable: true,
      // },
      {
        label: "amount",
        field: "amount"
      }, {
        label: "currencySymbol",
        field: "currencySymbol"
      }, {
        label: "status",
        field: "status"
      }],
      referrals: false
    };
  },
  components: {
    VueCsvDownloader: __WEBPACK_IMPORTED_MODULE_1_vue_csv_downloader___default.a,
    BaseLoading: __WEBPACK_IMPORTED_MODULE_2__components_public_BaseLoading__["a" /* default */]
  },
  methods: {
    getReferrals: function getReferrals() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingRewards = true;
                _context.prev = 1;
                _context.next = 4;
                return _this.$store.dispatch("getTransactionsByType", "reward");

              case 4:
                resp = _context.sent;

                _this.referrals = resp.data;
                _this.loadingRewards = false;
                // console.log(this.referrals);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);

                _this.logError(_context.t0);
                _this.loadingRewards = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },
    simbAjust: function simbAjust(el) {
      if (el == 'BLU') {
        return 'BLUE';
      } else {
        return el;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member"]), {
    referralFullLink: function referralFullLink() {
      return window.location.origin + this.referralURI + this.member.referCode;
    }
  }),
  watch: {}
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_phone_number_input_dist_vue_phone_number_input_css__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_phone_number_input_dist_vue_phone_number_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_phone_number_input_dist_vue_phone_number_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function SignupFields() {
  this.phone = "";
  this.email = "";
  this.currentPassword = "";
  this.newPassword = "";
  this.confirmPassword = "";
  this.isNotChinaCitizen = true;
  this.isNotUsaCitizen = true;
  // this.formSent = "";
}

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.setValues();
  },
  mounted: function mounted() {
    this.setValidationFields(SignupFields);
    this.initTitleItems();
    this.signupform.email = this.member.email;
    this.signupform.phone = this.member.phone;
  },

  data: function data() {
    return {
      // selectedSettings: "security",
      // selectedSubject: "password",
      notify: "",
      passwordOld: "",

      password: "",
      passwordConfirmation: "",

      phoneFormat: "",
      validPhone: true,

      countriesNotAllowed: false,
      signupform: new SignupFields(),

      showInfo: {
        "1a": false,
        "1b": false,
        "1c": false
      },
      active: 0,
      items: []
    };
  },
  components: {
    // SettingsPreferences,
    // SettingsSecurity,
    VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input___default.a
  },
  methods: {
    initTitleItems: function initTitleItems() {
      this.items = [this.$t("msg.settings.profile"), this.$t("msg.settings.security"), this.$t("msg.settings.notifications")];
    },
    verifyCountry: function verifyCountry($event) {
      console.log($event);

      this.results = $event.countryCode;
      this.phoneFormat = $event.formattedNumber;
      this.validPhone = $event.isValid;

      if (this.results == "CN" || this.results == "HK" || this.results == "US") {
        this.countriesNotAllowed = true;
      } else {
        this.countriesNotAllowed = false;
      }
    },
    setValues: function setValues() {
      if (this.member.notify) {
        this.notify = true;
      } else {
        this.notify = false;
      }
    },
    callChangeInfo: function callChangeInfo() {
      var _this = this;

      var email = this.signupform.email;
      var phone = this.phoneFormat;
      var valid = this.validPhone;

      if (phone && !valid) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: this.$t("msg.invalid_phone")
        });
        return;
      }

      var payload = {
        newEmail: email,
        newPhone: phone && phone.replace("+", ""),
        password: ""
      };

      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
        title: this.$t("msg.password"),
        input: "password",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(login) {
          payload.password = login;
        },
        allowOutsideClick: function allowOutsideClick() {
          return !__WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.isLoading();
        }
      }).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!result.isConfirmed) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return _this.$store.dispatch("putChangeInfo", payload).then(function (r) {
                    if (r.status == 200) {
                      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                        icon: "success",
                        title: _this.$t("msg.status_done"),
                        text: _this.$t("msg.settings.popupChangesApply")
                      });
                    }
                  }).catch(function (e) {
                    console.log(e.message);
                    __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                      icon: "error",
                      title: _this.$t("msg.error"),
                      text: e.message
                    });
                  });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    callChangePass: function callChangePass() {
      var _this2 = this;

      var form = this.signupform;
      var validatePassword = this.validatePassword(this.password);

      this.showOrHideError("password", validatePassword);
      this.showOrHideError("passwordConfirmation", form.passwordConfirmation && form.passwordConfirmation === form.password);

      var payload = {
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
        passwordOld: this.passwordOld
      };

      if (validatePassword && !this.passwordConfirmation) {
        this.showInfo["1c"] = true;
        this.showInfo["1b"] = false;
      }

      if (!validatePassword) {
        this.showInfo["1b"] = true;
      }

      if (validatePassword && this.passwordConfirmation) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          title: this.$t("msg.settings.popupSure"),
          text: this.$t("msg.confirm_password_error"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("msg.yes"),
          cancelButtonText: this.$t("msg.cancel")
        }).then(function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(result) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!result.isConfirmed) {
                      _context2.next = 3;
                      break;
                    }

                    _context2.next = 3;
                    return _this2.$store.dispatch("putChangePassword", payload).then(function (r) {
                      console.log(r);
                      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire(_this2.$t("msg.status_done"), _this2.$t("msg.settings.popupChangesApply"), "success");
                    }).catch(function (e) {
                      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                        icon: "error",
                        title: _this2.$t("msg.error"),
                        text: _this2.$t("msg.wrong_password_confirmation")
                      });

                      console.log(e);
                    });

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    },
    callChangeNotify: function callChangeNotify() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.notify) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return _this3.$store.dispatch("putChangeNotifyOn").then(function (r) {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire(_this3.$t("msg.status_done"), _this3.$t("msg.settings.popupChangesApply"), "success");
                  console.log(r);
                }).catch(function (e) {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this3.$t("msg.error"),
                    text: _this3.$t("msg.redeem_deleted_error")
                  });
                  console.log(e);
                });

              case 3:
                if (!_this3.notify) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this3.$store.dispatch("putChangeNotifyOff").then(function (r) {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire(_this3.$t("msg.status_done"), _this3.$t("msg.settings.popupChangesApply"), "success");
                  console.log(r);
                }).catch(function (e) {
                  __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this3.$t("msg.error"),
                    text: _this3.$t("msg.redeem_deleted_error")
                  });
                  console.log(e);
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(["member"])),
  watch: {
    "$i18n.locale": function $i18nLocale() {
      this.initTitleItems();
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  computed: {},
  watch: {}
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_private_services_WithdrawMain__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_private_services_DepositMain__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_private_services_RedemptionMain__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_private_services_RedemptionBalance__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_private_services_InternalMain__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_private_services_FailedTable__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getOtpStatus();
    this.$store.dispatch("updateBluAccount");

    this.getWithdraws();
    this.getRedeems();

    this.getWithdrawsTotal();

    this.mode = this.$route.params.arg;
    this.type = this.$route.params.arg;

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  mounted: function mounted() {},

  data: function data() {
    var _ref;

    return _ref = {
      authorized: false
    }, _defineProperty(_ref, "authorized", false), _defineProperty(_ref, "mode", "withdraw"), _defineProperty(_ref, "type", "withdraw"), _defineProperty(_ref, "withdraws", ""), _defineProperty(_ref, "redeems", ""), _defineProperty(_ref, "failedOrders", ""), _defineProperty(_ref, "internals", ""), _defineProperty(_ref, "internalArray", ""), _defineProperty(_ref, "openOrder", ""), _defineProperty(_ref, "tutorial", false), _defineProperty(_ref, "isWeb", false), _defineProperty(_ref, "selectedBlue", true), _defineProperty(_ref, "coin", "BLUE"), _defineProperty(_ref, "howDepositCoin", "Blue"), _defineProperty(_ref, "stepWithdraw", 3), _ref;
  },
  components: {
    RedemptionMain: __WEBPACK_IMPORTED_MODULE_2__components_private_services_RedemptionMain__["a" /* default */],
    RedemptionBalance: __WEBPACK_IMPORTED_MODULE_3__components_private_services_RedemptionBalance__["a" /* default */],
    WithdrawMain: __WEBPACK_IMPORTED_MODULE_0__components_private_services_WithdrawMain__["a" /* default */],
    FailedTable: __WEBPACK_IMPORTED_MODULE_5__components_private_services_FailedTable__["a" /* default */],
    InternalMain: __WEBPACK_IMPORTED_MODULE_4__components_private_services_InternalMain__["a" /* default */],
    DepositMain: __WEBPACK_IMPORTED_MODULE_1__components_private_services_DepositMain__["a" /* default */]
  },
  methods: {
    toggleTutorial: function toggleTutorial() {
      this.tutorial = !this.tutorial;
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 1200) {
        console.log("aqqqqqq");
        this.isWeb = true;
      } else {
        this.isWeb = false;
      }
    },
    continueTransaction: function continueTransaction(el) {
      this.openOrder = el;
    },
    getOtpStatus: function getOtpStatus() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getOtpStatus");

              case 2:
                resp = _context.sent;

                _this.authorized = resp.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setMode: function setMode(selectedMode) {
      this.mode = selectedMode;
    },
    getRedeems: function getRedeems() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getTransactionsByType", "redeem");

              case 2:
                resp = _context2.sent;

                if (resp.status == 200) {
                  _this2.redeems = resp.data;
                } else {
                  console.log("no withdraws");
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getWithdraws: function getWithdraws() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch("getTransactionsByType", "withdraw");

              case 2:
                resp = _context3.sent;

                if (resp.status == 200) {
                  _this3.withdraws = resp.data;
                } else {
                  console.log("no withdraws");
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getWithdrawsTotal: function getWithdrawsTotal() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.$store.dispatch("getWithdraws");

              case 2:
                resp = _context4.sent;

                if (resp.status == 200) {
                  _this4.internals = resp.data;

                  _this4.iternalTransfers();
                } else {
                  console.log("no withdraws");
                }

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    iternalTransfers: function iternalTransfers() {
      // let array = this.internals.concat(this.redeems);
      var array = this.internals;
      var internalArray = [];

      array.forEach(function (element) {
        if (element.status == "new") {
          internalArray.push(element);
        }
      });

      this.internalArray = internalArray;
    },
    checkRunningWithdraws: function checkRunningWithdraws() {
      var withdraws = this.withdraws;
      var openWithdraws = [];

      for (var i in withdraws) {
        if (withdraws[i].status == "new") {
          openWithdraws.push(withdraws[i]);
        }
      }

      if (openWithdraws.length > 0) {
        for (var _i in openWithdraws) {
          this.cancelOpenWithdraws(openWithdraws[_i].id);
        }
      }
    },
    checkFailedOrder: function checkFailedOrder() {
      var orderArray = this.withdraws.concat(this.redeems);

      var failed = [];
      for (var i in orderArray) {
        if (orderArray[i].status == "failed") {
          failed.push(orderArray[i]);
        }
      }
      this.failedOrders = failed.concat(this.internalArray);
    },
    cancelOpenWithdraws: function cancelOpenWithdraws(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var body, i;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                body = {
                  e2faCode: "000000",
                  id: id,
                  pinCode: "000000"
                };
                i = 0;

              case 2:
                if (!(i < 6)) {
                  _context5.next = 14;
                  break;
                }

                _context5.prev = 3;
                _context5.next = 6;
                return _this5.$store.dispatch("putWithdrawConfirm", body);

              case 6:
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](3);

                console.log(_context5.t0);

              case 11:
                i++;
                _context5.next = 2;
                break;

              case 14:

                setTimeout(function () {
                  window.location.reload();
                }, 3000);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[3, 8]]);
      }))();
    },
    toogleCoin: function toogleCoin(coin) {
      if (this.stepWithdraw == 4) {
        this.stepWithdraw = 3;
      }

      if (coin == "blue") {
        this.selectedBlue = true;
        this.coin = "BLUE";
        this.howDepositCoin = "Blue";
      } else {
        this.selectedBlue = false;
        this.coin = "USDT";
        this.howDepositCoin = "Tether (USDT)";
      }
    }
  },
  watch: {
    withdraws: function withdraws() {
      // this.checkRunningWithdraws();
      // this.checkFailedOrder(this.withdraws);

      this.iternalTransfers();
    },

    redeems: function redeems() {
      this.checkFailedOrder();
    },

    $route: function $route() {
      this.mode = this.$route.params.arg;
      this.type = this.$route.params.arg;
    },

    mode: function mode(newMode, oldMode) {
      if (newMode !== oldMode) {
        this.selectedBlue = true;
      }
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redeem_steps_Redeem2fa__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withdraw_steps_WithdrawStep0__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withdraw_steps_WithdrawStep02__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withdraw_steps_WithdrawStep03__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withdraw_steps_WithdrawStep1__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withdraw_steps_WithdrawStep2__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withdraw_steps_WithdrawStep3__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withdraw_steps_WithdrawStep4__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withdraw_steps_WithdrawStep9__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withdraw_steps_WithdrawStepStart__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__configs_global_js__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getOtpStatus();

    // this.getWithdraws();
  },

  props: ["selectedBlue", "step"],
  mounted: function mounted() {},

  data: function data() {
    return {
      amountToSend: "",
      addressToSend: "",
      withdraws: "",
      redeemInfo: "",
      previewData: "",
      withdrawData: "",
      address: "",
      externalId: "",
      authorized: "",
      error: "",
      feeRedeem: "",
      preview: {
        targetAmount: "",
        sourceCurrency: "BLU"
      },
      type: "withdraw",
      withdraw: {
        amount: "",
        address: "",
        currency: "BLU",
        externalId: ""
      },
      selectedPartner: ""
    };
  },
  components: {
    Redeem2fa: __WEBPACK_IMPORTED_MODULE_0__redeem_steps_Redeem2fa__["a" /* default */],
    WithdrawStep0: __WEBPACK_IMPORTED_MODULE_1__withdraw_steps_WithdrawStep0__["a" /* default */],
    WithdrawStep02: __WEBPACK_IMPORTED_MODULE_2__withdraw_steps_WithdrawStep02__["a" /* default */],
    WithdrawStep03: __WEBPACK_IMPORTED_MODULE_3__withdraw_steps_WithdrawStep03__["a" /* default */],
    WithdrawStep1: __WEBPACK_IMPORTED_MODULE_4__withdraw_steps_WithdrawStep1__["a" /* default */],
    WithdrawStep2: __WEBPACK_IMPORTED_MODULE_5__withdraw_steps_WithdrawStep2__["a" /* default */],
    WithdrawStep3: __WEBPACK_IMPORTED_MODULE_6__withdraw_steps_WithdrawStep3__["a" /* default */],
    WithdrawStep4: __WEBPACK_IMPORTED_MODULE_7__withdraw_steps_WithdrawStep4__["a" /* default */],
    WithdrawStep9: __WEBPACK_IMPORTED_MODULE_8__withdraw_steps_WithdrawStep9__["a" /* default */],
    WithdrawStepStart: __WEBPACK_IMPORTED_MODULE_9__withdraw_steps_WithdrawStepStart__["a" /* default */]
  },
  methods: {
    getWithdraws: function getWithdraws() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getTransactionsByType", _this.type);

              case 2:
                resp = _context.sent;

                if (resp.status == 200) {
                  _this.withdraws = resp.data;
                } else {
                  console.log("no withdraws");
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkRunningWithdraws: function checkRunningWithdraws() {
      var withdraws = this.withdraws;
      var openWithdraws = [];

      for (var i in withdraws) {
        if (withdraws[i].status == "new") {
          openWithdraws.push(withdraws[i]);
        }
      }
      console.log(openWithdraws);
      // alert('open withdraws:'+ openWithdraws.length);

      if (openWithdraws.length > 0) {
        for (var _i in openWithdraws) {
          this.cancelOpenWithdraws(openWithdraws[_i].id);
        }
      }
    },
    callFirstStep: function callFirstStep() {
      this.step = 3;
    },
    cancelOpenWithdraws: function cancelOpenWithdraws(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var body, i, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                body = {
                  e2faCode: "000000",
                  id: id,
                  pinCode: "000000"
                };
                i = 0;

              case 2:
                if (!(i < 3)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return _this2.$store.dispatch("putWithdrawConfirm", body);

              case 5:
                resp = _context2.sent;

              case 6:
                i++;
                _context2.next = 2;
                break;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    callWithdrawUsdt: function callWithdrawUsdt() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var payload, resp, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = {
                  address: _this3.usdtAccount.address,
                  addressTo: _this3.addressToSend,
                  amount: _this3.amountToSend,
                  currency: "USDT"
                };
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$store.dispatch("postWithdrawSmartpay", payload);

              case 4:
                resp = _context3.sent;
                _context3.next = 7;
                return _this3.$store.dispatch("updateUsdtAccount");

              case 7:
                _this3.withdrawData = resp.data;

                if (!(resp.status == 200)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 11;
                return _this3.$store.dispatch("updateUsdtAccount");

              case 11:
                _this3.step = 6;
                _context3.next = 15;
                break;

              case 14:
                _this3.step = 9;

              case 15:
                _context3.next = 22;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](1);
                res = String(_context3.t0).split(":");

                _this3.error = res[1];
                _this3.step = 9;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 17]]);
      }))();
    },
    resetRedeem: function resetRedeem() {
      this.step = 3;
      this.previewData = "";
    },
    callStepSelect: function callStepSelect(amount) {
      this.withdraw.amount = parseFloat(amount);
      this.step = 3;
    },
    backToPartners: function backToPartners() {
      this.step = 3;
    },
    callStepConfirmation: function callStepConfirmation(partner) {
      this.selectedPartner = partner;
      this.step = 3;
    },
    callStepPreview: function callStepPreview(amount, address, externalId) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log(amount, address, externalId, "??????");
                _this4.address = address;
                _this4.externalId = externalId;

                _this4.withdraw.amount = parseFloat(amount);
                _this4.withdraw.address = address;
                _this4.withdraw.externalId = externalId;

                if (!_this4.selectedBlue) {
                  _this4.withdraw.currency = "USDT";
                }

                // console.log(this.withdraw, "postWithdrawPreview");

                _context4.prev = 7;
                _context4.next = 10;
                return _this4.$store.dispatch("postWithdrawPreview", _this4.withdraw);

              case 10:
                resp = _context4.sent;

                _this4.previewData = resp.data;
                _this4.step = 4;
                _context4.next = 18;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](7);

                console.log(_context4.t0);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[7, 15]]);
      }))();
    },
    callStepWithdraw: function callStepWithdraw(params) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var resp, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.addressToSend = params.address;
                _this5.amountToSend = params.amount - 2;

                if (!_this5.selectedBlue) {
                  _context5.next = 19;
                  break;
                }

                console.log(params, "postWithdraw");
                _context5.prev = 4;
                _context5.next = 7;
                return _this5.$store.dispatch("postWithdraw", params).then(_this5.$store.dispatch("updateBluAccount"));

              case 7:
                resp = _context5.sent;

                _this5.withdrawData = resp.data;
                if (resp.status == 200) {
                  _this5.step = 5;
                  _this5.notifySuccess(_this5.$t("msg.check_your_email_for_pin_redeem"), 5000);
                } else {
                  _this5.step = 9;
                }
                _context5.next = 17;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](4);
                res = String(_context5.t0).split(":");


                _this5.error = res[1];
                _this5.step = 9;

              case 17:
                _context5.next = 20;
                break;

              case 19:
                _this5.step = 5;

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[4, 12]]);
      }))();
    },
    withdrawConfirm: function withdrawConfirm(withdraw) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var type, resp, error, array, msgErro;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                type = "withdraw";


                console.log(withdraw, "putWithdrawConfirm");
                _context6.prev = 2;
                _context6.next = 5;
                return _this6.$store.dispatch("putWithdrawConfirm", withdraw).then(_this6.$store.dispatch("updateBluAccount"));

              case 5:
                resp = _context6.sent;

                _this6.step = 6;
                _context6.next = 17;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](2);
                error = String(_context6.t0);
                array = error.split(" ");
                msgErro = "";


                array.shift();
                msgErro = array.join("_");

                _this6.notifyDanger(_this6.$t("msg." + msgErro.toLowerCase()), 5000);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[2, 9]]);
      }))();
    },
    setFirstStep: function setFirstStep() {
      this.step = 3;
    },
    getOtpStatus: function getOtpStatus() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var resp;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.$store.dispatch("getOtpStatus");

              case 2:
                resp = _context7.sent;

                _this7.authorized = resp.data;
                _this7.$emit("updateOptStatus");

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapGetters */])(["accounts", "usdtAccount"])),
  watch: {
    withdraws: function withdraws() {
      this.checkRunningWithdraws();
    }
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getOtpCode();
    this.getOtpImage();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      otpCode: "",
      twoFA: "",
      qrcode: ""
    };
  },
  components: {},
  methods: {
    getOtpCode: function getOtpCode() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getOtpCode");

              case 2:
                resp = _context.sent;

                _this.otpCode = resp.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getOtpImage: function getOtpImage() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp, url, link;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.$store.dispatch("getOtpImage");

              case 3:
                resp = _context2.sent;
                url = window.URL.createObjectURL(new Blob([resp.data]));
                link = document.createElement("img");

                link.href = url;
                _this2.qrcode = link;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);

                _this2.logError(_context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    postOptConfirm: function postOptConfirm(twoFA) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.$store.dispatch("postOptConfirm", twoFA);

              case 3:
                resp = _context3.sent;

                _this3.notifySuccess(_this3.$t("msg.activation_successful_2fa"), 5000);
                _this3.$emit("getOptStatus");
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                _this3.notifyDanger(_this3.$t("msg.invalid_2fa_code"), 5000);
                _this3.getOtpCode();
                _this3.getOtpImage();

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 8]]);
      }))();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {}
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      redeem_error: "",
      bluAmount: 0,
      minBlue: 0,
      maxBluAmount: 99999999999,
      address: "",
      unLockedBalance: "",
      externalId: "",
      feeWithdraw: "",
      validation: {
        amount: false,
        address: false
      },
      withdraws: '',
      openWithdraws: ''
    };
  },
  components: {},
  methods: {
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep: function callNextStep() {
      this.$emit("callNext", this.bluAmount);
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    },
    getWithdrawFee: function getWithdrawFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "withdraw") {
                    arrayFee.push(fees[i].fee);
                  }
                }
                _this.feeWithdraw = arrayFee[arrayFee.length - 1];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    xemToBlu: function xemToBlu(amount) {
      var xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },
    checkAmount: function checkAmount() {

      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }

      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },
    isNumberCheck: function isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    validateAdress: function validateAdress(address) {
      if (address.length > 10 && address.charAt(0) === "N" || address.charAt(0) === "T") {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = this.minBlue;
      } else {
        var vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount", "ethValue", "xemValue"])),
  watch: {
    withdraws: function withdraws() {
      this.checkRunningWithdraws();
    },

    bluAmount: function bluAmount() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function feeWithdraw() {
      this.setMinAmount();
    }

  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      selectedPartner: ""
    };
  },
  components: {},
  methods: {
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    selectPartner: function selectPartner(partner) {
      this.selectedPartner = partner;
      this.callNextStep();
    },
    callNextStep: function callNextStep() {
      this.$emit("callNext", this.selectedPartner);
    },
    getWithdrawFee: function getWithdrawFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "withdraw") {
                    arrayFee.push(fees[i].fee);
                  }
                }
                _this.feeWithdraw = arrayFee[arrayFee.length - 1];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    xemToBlu: function xemToBlu(amount) {
      var xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },
    checkAmount: function checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },
    isNumberCheck: function isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    validateAdress: function validateAdress(address) {
      if (address.length > 10 && address.charAt(0) === "N" || address.charAt(0) === "T") {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = this.minBlue;
      } else {
        var vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount", "ethValue", "xemValue"])),
  watch: {
    bluAmount: function bluAmount() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function feeWithdraw() {
      this.setMinAmount();
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_modalWarnWithdraw_vue__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["setAmount", "selectedPartner", "selectedBlue"],
  created: function created() {
    this.checkAmount();
    this.getWithdrawFee();
    this.setMinAmount();
    this.validateAdress('');
    this.bluAmount = this.minBlue;
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      redeem_error: "",
      bluAmount: "",
      minBlue: "",
      usdtAmount: 2,
      minUSDT: 2,
      maxBluAmount: 99999999999,
      address: "",
      unLockedBalance: "",
      externalId: "",
      feeWithdraw: 0.01,
      validation: {
        amount: false,
        address: false
      },
      tooltipBonus: false,
      modalWarn: false,
      amountToSend: 0,
      onLoadValidation: true
    };
  },
  components: {
    ModalWarnWithdraw: __WEBPACK_IMPORTED_MODULE_1__modals_modalWarnWithdraw_vue__["a" /* default */]
  },
  methods: {
    showToolTipBonus: function showToolTipBonus() {
      this.tooltipBonus = true;
    },
    hideToolTipBonus: function hideToolTipBonus() {
      this.tooltipBonus = false;
    },
    getPartnerAddress: function getPartnerAddress() {
      if (this.selectedPartner == "stratum") {
        this.address = "NCYTV3UMZKBCIXXWGQPPH2QMSPL6L4FX67IGIP2J";
      } else if (this.selectedPartner == "stratumx") {
        this.address = "NAP55LGGGWPM37ZULDVOR5R6VHMFLT3XWWLGUFKI";
      }
    },
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep: function callNextStep() {
      if (this.selectedBlue) {
        this.toggleModalWarn();

        this.amountToSend = this.bluAmount;
        if (this.amountToSend > this.bluAccount.balanceAvailable) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            icon: "error",
            title: this.$t("msg.error"),
            text: this.$t("msg.not_enough_balance")
          });
          return;
        }
      } else {
        this.amountToSend = this.usdtAmount;
        if (this.amountToSend > this.usdtAccount.balanceAvailable) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            icon: "error",
            title: this.$t("msg.error"),
            text: this.$t("msg.not_enough_balance")
          });
          return;
        }
      }

      if (this.validation.address) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: this.$t("msg.invalid_address")
        });
        return;
      }

      if (!this.selectedBlue) {
        this.$emit("callNext", this.amountToSend, this.address, this.externalId);
      }
    },
    backToPartnerSelect: function backToPartnerSelect() {
      this.$emit("backToPartners");
    },
    getWithdrawFee: function getWithdrawFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "withdraw") {
                    arrayFee.push(fees[i].fee);
                  }
                }
                _this.feeWithdraw = arrayFee[arrayFee.length - 1];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    xemToBlu: function xemToBlu(amount) {
      var xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      // this.bluAmount = this.minBlue;
    },
    checkAmount: function checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },
    isNumberCheck: function isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    validateAdress: function validateAdress(address) {
      var pattern = /[(){}[\]\s/^~<>?:;|!@#$%¨&*=+'".,_-]/;
      var result = event.target.value.replace(pattern, '');
      this.address = result;

      if (this.selectedBlue) {
        if (address.length > 41 && address.charAt(0) === "0" && address.charAt(1) === "x") {
          this.validation.address = false;
        } else {
          this.validation.address = true;
        }
      } else {
        var WAValidator = __webpack_require__(133);
        var valid = WAValidator.validate(address, "trx");

        console.log(valid);
        this.validation.address = !valid;
      }
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = this.minBlue;
      } else {
        var vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },
    modifyUSDTAmount: function modifyUSDTAmount(modifier) {
      if (this.usdtAmount == false || this.usdtAmount < this.minUSDT || this.usdtAmount == "") {
        this.usdtAmount = this.minUSDT;
      } else {
        var vm = this;
        if (modifier == "-" && this.usdtAmount > 0) {
          var result = this.usdtAmount - 1;
          if (result > this.minUSDT) {
            this.usdtAmount = vm.roundUp(this.usdtAmount - 1, 3);
          } else {
            this.usdtAmount = vm.roundUp(vm.minUSDT, 3);
          }
        } else if (modifier == "+" && this.usdtAmount < this.maxBluAmount) {
          this.usdtAmount = parseFloat(this.usdtAmount) + 1;
          this.usdtAmount = vm.roundUp(this.usdtAmount, 3);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    },
    toggleModalWarn: function toggleModalWarn() {
      this.modalWarn = !this.modalWarn;
    },
    understandModalWarn: function understandModalWarn() {
      this.$emit("callNext", this.amountToSend, this.address, this.externalId);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "usdtValue", "bluAccount", "usdtAccount", "ethValue", "xemValue", "rasValue"])),
  watch: {
    bluAmount: function bluAmount() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function feeWithdraw() {
      this.setMinAmount();
    },

    minBlue: function minBlue() {
      this.bluAmount = this.minBlue;
    },

    selectedBlue: function selectedBlue() {
      this.address = "";
    },

    address: function address() {
      this.onLoadValidation = false;
      this.validateAdress(this.address);
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getMember();
  },

  data: function data() {
    return {};
  },
  methods: {
    closeModalWarnWithdraw: function closeModalWarnWithdraw() {
      this.$emit("closeModalWarnWithdraw");
    },
    understandWarnWithdraw: function understandWarnWithdraw() {
      this.$emit("understandWarnWithdraw");
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1.png?583ae952e133b26b8b1d4f7680b6bb3a";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "new-binance-chain-logo.png?9e9caaa2cd4a41828d5c9d77d38e073a";

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      redeem_error: "",
      bluAmount: 0,
      minBlue: 0,
      maxBluAmount: 99999999999,
      address: "",
      unLockedBalance: "",
      externalId: "",
      feeWithdraw: "",
      validation: {
        amount: false,
        address: false
      }
    };
  },
  components: {},
  methods: {
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep: function callNextStep() {
      this.$emit("callNext", this.bluAmount, this.address, this.externalId);
    },
    getWithdrawFee: function getWithdrawFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "withdraw") {
                    arrayFee.push(fees[i].fee);
                  }
                }
                _this.feeWithdraw = arrayFee[arrayFee.length - 1];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    xemToBlu: function xemToBlu(amount) {
      var xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },
    checkAmount: function checkAmount() {

      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },
    isNumberCheck: function isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    validateAdress: function validateAdress(address) {
      if (address.length > 10 && address.charAt(0) === "N" || address.charAt(0) === "T") {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = this.minBlue;
      } else {
        var vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount", "ethValue", "xemValue"])),
  watch: {
    bluAmount: function bluAmount() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function feeWithdraw() {
      this.setMinAmount();
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["previewData", "address", "externalId", "selectedBlue"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      feeRedeem: "",
      feeUsdt: 2
    };
  },
  components: {},
  methods: {
    callNextStep: function callNextStep() {
      var params = {
        address: this.address,
        amount: this.previewData.amount,
        currency: "BLU"
      };

      this.$emit("callNext", params);
    },
    callBackStep: function callBackStep() {
      this.$emit("resetStep");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "currencies", "bluAccount", "btcAccount", "bluValue", "btcValue"])),
  watch: {}
});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2.png?bd69843d5d6c9b48b253b5ebe4b47e5e";

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["withdrawData", "selectedBlue", "address"],
  created: function created() {
    if (!this.selectedBlue) {
      this.pinGenerate(this.address);
    }
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      pin: "",
      twoFA: ""
    };
  },
  components: {},
  methods: {
    confirmRedeem: function confirmRedeem() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var withdraw, payload;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.selectedBlue) {
                  _context.next = 6;
                  break;
                }

                withdraw = {
                  e2faCode: _this.twoFA,
                  id: _this.withdrawData.id,
                  pinCode: _this.pin
                };

                _this.loading = true;
                _this.$emit("confirmWithdraw", withdraw);
                _context.next = 9;
                break;

              case 6:
                payload = {
                  e2faCode: _this.twoFA,
                  pinCode: _this.pin
                };
                _context.next = 9;
                return _this.$store.dispatch("postPinGenerate", payload).then(function (response) {
                  if (response.status == 200) {
                    _this.$emit("callWithdrawUsdt");
                  }
                }).catch(function (e) {
                  var err = e.message;
                  var text = void 0;
                  if (err == 'Invalid pin hash') {
                    text = _this.$t("msg.invalid_pin");
                  }

                  if (err == 'Invalid 2FA code') {
                    text = _this.$t("msg.invalid_2fa_code");
                  }

                  __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this.$t("msg.error"),
                    text: text
                  });
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pinGenerate: function pinGenerate(el) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getPinGenerate", el);

              case 2:
                resp = _context2.sent;

                if (resp.status == 200) {
                  _this2.notifySuccess(_this2.$t("msg.check_your_email_for_pin_redeem"), 5000);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    cancelRedeem: function cancelRedeem() {
      this.$emit("cancelRedeem");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {
    pin: function pin() {
      this.loading = false;
    },
    twoFA: function twoFA() {
      this.loading = false;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3.png?cdd6f6ed6c47970f2b045f0ffe925a09";

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["withdrawData", "selectedBlue"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {}
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['error', 'dayEnabled'],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      msg: ''
    };
  },
  components: {},
  methods: {
    resetStep: function resetStep() {
      this.$emit('resetStep');
    },
    getMsg: function getMsg() {

      var array = this.error.split(" ");
      var msgErro = '';
      array.shift();
      msgErro = array.join('_');

      this.msg = msgErro.toLowerCase();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {}
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkAmount();
  },

  data: function data() {
    return {};
  },
  methods: {
    callFirstStep: function callFirstStep() {
      this.$emit("callFirstStep");
    }
  }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redeem_steps_Redeem2fa__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deposit_steps_DepoistStepStart__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deposit_steps_DepositStep1__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getOtpStatus();
  },
  updated: function updated() {
    this.checkWallet();
  },

  props: ["selectedBlue"],
  mounted: function mounted() {},

  data: function data() {
    return {
      withdraws: "",
      redeemInfo: "",
      step: "start",
      previewData: "",
      withdrawData: "",
      address: "",
      externalId: "",
      authorized: "",
      error: "",
      feeRedeem: "",
      preview: {
        targetAmount: "",
        sourceCurrency: "BLU"
      },
      type: "withdraw",
      withdraw: {
        amount: "",
        address: "",
        currency: "BLU",
        externalId: ""
      },
      selectedPartner: "",
      blueWallet: "",
      usdtWallet: "",
      blueAddress: "",
      buttonBlock: false
    };
  },
  components: {
    Redeem2fa: __WEBPACK_IMPORTED_MODULE_0__redeem_steps_Redeem2fa__["a" /* default */],
    DepositStepStart: __WEBPACK_IMPORTED_MODULE_1__deposit_steps_DepoistStepStart__["a" /* default */],
    DepositStep1: __WEBPACK_IMPORTED_MODULE_2__deposit_steps_DepositStep1__["a" /* default */]
  },
  methods: {
    checkWallet: function checkWallet() {
      if (this.selectedBlue) {
        this.blueWallet = this.bluAccount;
        if (this.blueWallet.address.length > 0) {
          this.blueAddress = this.blueWallet.address;
          this.step = 1;
        } else {
          this.step = "start";
        }
      } else {
        console.log(this.usdtAccount, "aq??");
        this.usdtWallet = this.usdtAccount;
        if (this.usdtWallet.address) {
          this.blueAddress = this.usdtWallet.address;
          this.step = 1;
        } else {
          this.step = "start";
        }
      }
    },
    callFirstStep: function callFirstStep() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var blueAccount, usdtAccount;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.selectedBlue) {
                  _context.next = 12;
                  break;
                }

                blueAccount = _this.accounts.filter(function (n, i) {
                  return n.currency.symbol === "BLU";
                });


                _this.buttonBlock = true;

                if (!blueAccount[0].address) {
                  _context.next = 8;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                  icon: "warning",
                  title: _this.$t("msg.alert"),
                  text: _this.$t("msg.alert_created_deposit")
                }, 2000);
                return _context.abrupt("return");

              case 8:
                _context.next = 10;
                return _this.$store.dispatch("postCreateAddress").then(function (r) {
                  _this.$store.dispatch("updateBluAccount").then(function () {
                    setTimeout(function () {
                      _this.checkWallet();
                      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                        icon: "success",
                        title: _this.$t("msg.success"),
                        text: _this.$t("msg.success_create_wallet")
                      }, 2000);
                    });
                  });
                }).catch(function (e) {
                  console.log(e);
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this.$t("msg.error"),
                    text: _this.$t("msg.error_create_address")
                  });
                });

              case 10:
                _context.next = 21;
                break;

              case 12:
                usdtAccount = _this.accounts.filter(function (n, i) {
                  return n.currency.symbol === "USDT";
                });


                _this.buttonBlock = true;

                if (!usdtAccount[0].address) {
                  _context.next = 19;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                  icon: "warning",
                  title: _this.$t("msg.alert"),
                  text: _this.$t("msg.alert_created_deposit")
                }, 2000);
                return _context.abrupt("return");

              case 19:
                _context.next = 21;
                return _this.$store.dispatch("postCreateWallet").then(function (r) {
                  _this.$store.dispatch("updateUsdtAccount").then(function () {
                    setTimeout(function () {
                      _this.checkWallet();
                      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                        icon: "success",
                        title: _this.$t("msg.success"),
                        text: _this.$t("msg.success_create_wallet")
                      }, 2000);
                    });
                  });
                }).catch(function (e) {
                  console.log(e);
                  __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this.$t("msg.error"),
                    text: _this.$t("msg.error_create_address")
                  });
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getOtpStatus: function getOtpStatus() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getOtpStatus");

              case 2:
                resp = _context2.sent;

                _this2.authorized = resp.data;
                _this2.$emit("updateOptStatus");

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["accounts", "bluAccount", "usdtAccount"]))
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["buttonBlock"],
  created: function created() {
    // this.checkAmount();
  },

  data: function data() {
    return {};
  },
  methods: {
    callFirstStep: function callFirstStep() {
      this.$emit("callFirstStep");
    }
  }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["address", "selectedBlue"],
  created: function created() {
    this.checkAmount();
    this.getWithdrawFee();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      // address: "bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh",
      redeem_error: "",
      bluAmount: 0,
      minBlue: 0,
      maxBluAmount: 99999999999,
      unLockedBalance: "",
      externalId: "",
      feeWithdraw: "",
      validation: {
        amount: false,
        address: false
      },
      withdraws: "",
      openWithdraws: ""
    };
  },
  components: {},
  methods: {
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep: function callNextStep() {
      this.$emit("callNext", this.bluAmount);
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    },
    getWithdrawFee: function getWithdrawFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "withdraw") {
                    arrayFee.push(fees[i].fee);
                  }
                }
                _this.feeWithdraw = arrayFee[arrayFee.length - 1];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    xemToBlu: function xemToBlu(amount) {
      var xemToBlu = amount / this.bluValue[0].value;
      return xemToBlu;
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },
    checkAmount: function checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }

      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      this.isNumberCheck();
    },
    isNumberCheck: function isNumberCheck() {
      // let newBluAmount = [];
      // for (let i in this.bluAmount) {
      //   if (
      //     ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(
      //       this.bluAmount[i]
      //     )
      //   ) {
      //     newBluAmount.push(this.bluAmount[i]);
      //   }
      // }
      // newBluAmount = newBluAmount.join("");
      // this.bluAmount = newBluAmount;
      // var firstPosition = null;
      // if (newBluAmount.indexOf(".") > 1) {
      //   firstPosition = newBluAmount.indexOf(".");
      // }
      // if (firstPosition) {
      //   let newArray = [];
      //   for (let i in this.bluAmount) {
      //     if (i == firstPosition) {
      //       newArray.push(".");
      //     } else {
      //       if (!isNaN(this.bluAmount[i])) {
      //         newArray.push(this.bluAmount[i]);
      //       }
      //     }
      //   }
      //   newArray = newArray.join("");
      //   this.bluAmount = parseFloat(newArray);
      // }
      // if (this.bluAmount == ".") {
      //   this.bluAmount = "0";
      // }
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    validateAdress: function validateAdress(address) {
      if (address.length > 10 && address.charAt(0) === "N" || address.charAt(0) === "T") {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = this.minBlue;
      } else {
        var vm = this;
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = vm.roundUp(this.bluAmount - 1, 3);
          } else {
            this.bluAmount = vm.roundUp(vm.minBlue, 3);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = vm.roundUp(this.bluAmount, 3);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount", "ethValue", "xemValue"])),
  watch: {
    withdraws: function withdraws() {
      this.checkRunningWithdraws();
    },

    bluAmount: function bluAmount() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function feeWithdraw() {
      this.setMinAmount();
    }
  }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redeem_steps_Redeem2fa__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__redeem_steps_RedeemStep1__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redeem_steps_RedeemStep2__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redeem_steps_RedeemStep25__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redeem_steps_RedeemStep3__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redeem_steps_RedeemStep4__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redeem_steps_RedeemStep9__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__configs_global_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getOtpStatus();
    this.getDayOfWeek();
    this.getFees();

    this.getRedeems();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      mode: "withdraw",
      redeemInfo: "",
      step: 1,
      previewData: "",
      redeemData: "",
      address: "",
      authorized: "",
      error: "",
      loading: false,
      redeemtype: "",
      feeFixed: "",
      blockRedeem: false,
      feeTax: "",
      feeTaxAbsolute: "",
      feeTaxRush: "",

      preview: {
        targetAmount: "",
        sourceCurrency: "BLU"
      },
      redeem: {
        sourceAmount: "",
        targetAddress: "",
        targetCurrency: "USDT"
      }
    };
  },
  components: {
    Redeem2fa: __WEBPACK_IMPORTED_MODULE_0__redeem_steps_Redeem2fa__["a" /* default */],
    RedeemStep1: __WEBPACK_IMPORTED_MODULE_1__redeem_steps_RedeemStep1__["a" /* default */],
    RedeemStep2: __WEBPACK_IMPORTED_MODULE_2__redeem_steps_RedeemStep2__["a" /* default */],
    RedeemStep25: __WEBPACK_IMPORTED_MODULE_3__redeem_steps_RedeemStep25__["a" /* default */],
    RedeemStep3: __WEBPACK_IMPORTED_MODULE_4__redeem_steps_RedeemStep3__["a" /* default */],
    RedeemStep4: __WEBPACK_IMPORTED_MODULE_5__redeem_steps_RedeemStep4__["a" /* default */],
    RedeemStep9: __WEBPACK_IMPORTED_MODULE_6__redeem_steps_RedeemStep9__["a" /* default */]
  },
  methods: {
    getRedeems: function getRedeems() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, redeems, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getRedeems");

              case 2:
                resp = _context.sent;

                if (resp.status == 200) {
                  redeems = resp.data;

                  if (redeems.length > 0) {
                    for (i in redeems) {
                      if (redeems[i].status == "waiting") {
                        _this.blockRedeem = true;
                      }
                    }
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getFees: function getFees() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp, array, arrayRedeem, arrayRedeemAbsolut, arrayRedeemRush, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getFees");

              case 2:
                resp = _context2.sent;

                if (resp.status == 200) {
                  array = resp.data;
                  arrayRedeem = [];
                  arrayRedeemAbsolut = [];
                  arrayRedeemRush = [];


                  for (i in array) {
                    if (array[i].type == "redeem") {
                      if (array[i].math == "percent") {
                        arrayRedeem.push(array[i]);
                      }

                      if (array[i].math == "absolut") {
                        arrayRedeemAbsolut.push(array[i]);
                      }

                      if (array[i].math == "rush") {
                        arrayRedeemRush.push(array[i]);
                      }
                    }
                  }

                  arrayRedeem.sort(function (a, b) {
                    var c = new Date(a.createdAt);
                    var d = new Date(b.createdAt);
                    return d - c;
                  });

                  arrayRedeemAbsolut.sort(function (a, b) {
                    var c = new Date(a.createdAt);
                    var d = new Date(b.createdAt);
                    return d - c;
                  });

                  console.log(arrayRedeemAbsolut);

                  arrayRedeemRush.sort(function (a, b) {
                    var c = new Date(a.createdAt);
                    var d = new Date(b.createdAt);
                    return d - c;
                  });

                  _this2.feeTax = arrayRedeem[0];
                  _this2.feeTaxAbsolute = arrayRedeemAbsolut[0];
                  _this2.feeTaxRush = arrayRedeemRush[0];
                } else {
                  alert("Dont load the fees");
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    resetRedeem: function resetRedeem() {
      this.step = 1;
      this.previewData = "";
    },
    callStepPreview: function callStepPreview(amount, address, fee, data) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.address = address;
                _this3.redeem.sourceAmount = parseFloat(amount);
                _this3.feeFixed = fee;
                _this3.previewData = data;

                if (!_this3.blockRedeem) {
                  _context3.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.fire({
                  icon: "info",
                  title: _this3.$t("msg.notification"),
                  text: _this3.$t("msg.only_one_day")
                });

                return _context3.abrupt("return");

              case 7:

                _this3.step = 2;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    callNextStep: function callNextStep(address, type) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.address = address;
                _this4.redeemtype = type;
                _this4.redeem.targetAddress = address;

                _context4.prev = 3;
                _context4.next = 6;
                return _this4.$store.dispatch("postRedeemPreview", _this4.redeem);

              case 6:
                resp = _context4.sent;

                _this4.previewData = resp.data;
                _this4.step = 2.5;
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](3);

                // this.step = 4
                console.log(_context4.t0);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[3, 11]]);
      }))();
    },
    callStepRedeem: function callStepRedeem() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  sourceAmount: _this5.previewData.sourceAmount,
                  targetAddress: _this5.address,
                  targetCurrency: "USDT",
                  rush: _this5.redeemtype
                };
                _context5.prev = 1;
                _context5.next = 4;
                return _this5.$store.dispatch("postRedeem", params);

              case 4:
                resp = _context5.sent;

                _this5.redeemData = resp.data;
                if (resp.status == 200) {
                  _this5.step = 3;
                  _this5.notifySuccess(_this5.$t("msg.check_your_email_for_pin_redeem"), 5000);
                } else {
                  _this5.step = 9;
                }
                _context5.next = 13;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](1);

                _this5.error = String(_context5.t0);
                _this5.step = 9;

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[1, 9]]);
      }))();
    },
    redeemConfirm: function redeemConfirm(redeem) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var type, resp, trade, _resp, error, array, msgErro;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                type = "redeem";
                _context6.prev = 1;
                _context6.next = 4;
                return _this6.$store.dispatch("getTradeType", type);

              case 4:
                resp = _context6.sent;
                trade = resp.data;

                redeem.id = trade.tradeId;
                _this6.$store.dispatch("updateBluAccount");
                _context6.next = 13;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](1);

                console.log(_context6.t0);

              case 13:
                _context6.prev = 13;
                _context6.next = 16;
                return _this6.$store.dispatch("putRedeemConfirm", redeem);

              case 16:
                _resp = _context6.sent;

                _this6.step = 4;
                _context6.next = 29;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t1 = _context6["catch"](13);
                error = String(_context6.t1);
                array = error.split(" ");
                msgErro = "";


                array.shift();
                msgErro = array.join("_");

                _this6.notifyDanger(_this6.$t("msg." + msgErro.toLowerCase()), 5000);
                _this6.loading = false;

              case 29:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[1, 10], [13, 20]]);
      }))();
    },
    setFirstStep: function setFirstStep() {
      this.step = 1;
    },
    getOtpStatus: function getOtpStatus() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var resp;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.$store.dispatch("getOtpStatus");

              case 2:
                resp = _context7.sent;

                console.log(resp.data);
                _this7.authorized = resp.data;
                _this7.$emit("updateOptStatus");

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    getRedeemInfo: function getRedeemInfo() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var resp, brTime;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this8.$store.dispatch("getRedeemInfo");

              case 2:
                resp = _context8.sent;

                _this8.redeemInfo = resp.data;

                brTime = new Date().toLocaleString("en-US", {
                  timeZone: "America/Sao_Paulo"
                });

                brTime = new Date(brTime);

                console.log(_this8.redeemInfo.todayBlocked);

                if (_this8.redeemInfo.todayBlocked) {
                  _this8.step = 9;
                } else {
                  _this8.step = 1;
                }

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    getDayOfWeek: function getDayOfWeek() {
      var brTime = new Date().toLocaleString("en-US", {
        timeZone: "America/Sao_Paulo"
      });
      brTime = new Date(brTime);
      var dayOfWeek = brTime.getDay();
      var hour = brTime.getHours();
      this.step = 1;
      if (dayOfWeek == 3 && hour < 17) {
        this.step = 1;
      } else {
        this.step = 9;
        //  this.step = 1;
      }
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(["accounts"])),
  watch: {}
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["feeTax", "feeTaxAbsolute", "redeemInfo"],
  created: function created() {
    this.checkAmount();
    this.setMinAmount();
    this.getRedeemFee();
  },

  data: function data() {
    return {
      redeem_error: "",
      WAValidator: __webpack_require__(1000),
      bluAmount: 0,
      minBlue: 0,
      maxBluAmount: 99999999999,
      address: "",
      toolTipRedeem: false,
      unLockedBalance: "",
      redeemPreview: "",
      fee: 0.002,
      feeRedeem: "",
      fixedFee: "",
      validation: {
        amount: false,
        address: false
      },
      redeem: {
        sourceAmount: "",
        targetCurrency: "USDT"
      }
    };
  },
  methods: {
    getTotalWithFee: function getTotalWithFee() {
      var total = this.bluValue[0].value * this.bluAmount;

      if (this.redeemInfo.wave && !(total >= this.redeemInfo.waveRule + 1)) {
        var fee = this.redeemInfo.feeWave;
        this.feeRedeem = fee;
        var result = (total - fee).toFixed(2);
        if (result > 0) {
          return result;
        } else {
          return 0;
        }
      } else {
        var _fee = this.bluValue[0].value * this.bluAmount * this.feeTax.fee / 100;

        if (_fee >= this.feeTaxAbsolute.fee) {
          this.feeRedeem = _fee;
          var _result = (total - _fee).toFixed(2);
          if (_result > 0) {
            return _result;
          } else {
            return 0;
          }
        } else {
          this.feeRedeem = this.feeTaxAbsolute.fee;
          var _result2 = (total - this.feeTaxAbsolute.fee).toFixed(2);
          if (_result2 > 0) {
            return (total - this.feeTaxAbsolute.fee).toFixed(2);
          } else {
            return 0;
          }
        }
      }
    },
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep: function callNextStep() {
      this.$emit("callNext", this.bluAmount, this.address, this.feeRedeem, this.redeemPreview);
    },
    postPreview: function postPreview() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.redeem.sourceAmount = parseFloat(_this.bluAmount);
                _context.next = 3;
                return _this.$store.dispatch("postRedeemPreview", _this.redeem);

              case 3:
                resp = _context.sent;

                _this.redeemPreview = resp.data;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getRedeemFee: function getRedeemFee() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getFees");

              case 2:
                resp = _context2.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "redeem") {
                    arrayFee.push(fees[i].fee);
                  }
                }

                _this2.feeRedeem = 0.001;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.bluValue[0].value;

      console.log(this.bluValue[0].redeemMinimal);

      var redeemMinimun = this.bluValue[0].redeemMinimal;
      var min = redeemMinimun / bluValue;

      this.minBlue = min.toFixed(6);
      this.bluAmount = min.toFixed(6);
      this.postPreview();
    },
    checkAmount: function checkAmount() {
      this.getUnlockedBalance();

      console.log(this.redeemPreview);

      if (this.redeemPreview) {
        if (this.redeemPreview.targetAmount >= 0 && parseFloat(this.bluAmount) <= this.unLockedBalance) {
          this.validation.amount = true;
        } else {
          this.validation.amount = false;
        }
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
        return this.unLockedBalance.toFixed(6);
      }
    },
    validateAdress: function validateAdress(address) {
      var valid = this.WAValidator.validate(address, "BTC");
      if (valid) {
        this.validation.address = true;
      } else {
        this.validation.address = false;
      }
    },
    showToolRedeem: function showToolRedeem() {
      this.toolTipRedeem = true;
    },
    hideToolRedeem: function hideToolRedeem() {
      this.toolTipRedeem = false;
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = parseFloat(this.minBlue).toFixed(4);
      } else {
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = parseFloat(result).toFixed(4);
          } else {
            this.bluAmount = parseFloat(this.minBlue).toFixed(4);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = (parseFloat(this.bluAmount) + 1).toFixed(4);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount", "ethValue", "rasValue"])),
  watch: {
    bluAmount: function bluAmount() {
      this.postPreview();
      this.setRedeemError();
      this.validateAmount();
    },
    redeemPreview: function redeemPreview() {
      this.checkAmount();
    }
  }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["previewData", "address", "feeTaxRush"],
  created: function created() {
    this.getRedeemFee();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      feeRedeem: "",
      usdtAddress: "",
      blockButton: true,
      haveError: false,
      picked: ""
    };
  },
  components: {},
  methods: {
    validateAddress: function validateAddress() {
      if (this.usdtAddress.length < 10 || this.usdtAddress.charAt(0) != "T") {
        this.blockButton = true;
        this.haveError = true;
      } else {
        this.blockButton = false;
        this.haveError = false;
      }
    },
    callNextStep: function callNextStep() {
      this.validateAddress();
      var rush = void 0;

      if (this.picked == 'fast') {
        rush = true;
      } else {
        rush = false;
      }

      if (!this.blockButton) {
        this.$emit("callNext", this.usdtAddress, rush);
      }
    },
    callBackStep: function callBackStep() {
      this.$emit("resetStep");
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;

        return (totalBalance - lockedBalace).toFixed(6);
      }
    },
    getRedeemFee: function getRedeemFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "redeem") {
                    arrayFee.push(fees[i].fee);
                  }
                }

                // this.feeRedeem = arrayFee[arrayFee.length - 1];
                _this.feeRedeem = 0.001;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "currencies", "bluAccount", "btcAccount", "bluValue", "btcValue"])),
  watch: {}
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["previewData", "address", "redeemtype", "feeFixed", "feeTaxRush", "feeTax"],
  created: function created() {
    this.getRedeemFee();
    this.getRedeemInfo();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      feeRedeem: "",
      usdtAddress: "",
      blockButton: true,
      picked: "",
      checked: "",
      redeemInfo: ""
    };
  },
  components: {},
  methods: {
    getRedeemInfo: function getRedeemInfo() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getRedeemInfo");

              case 2:
                resp = _context.sent;

                _this.redeemInfo = resp.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getFeeToShow: function getFeeToShow() {
      var feePecent = this.getTotalFeePerent();
      var fee = void 0;

      if (feePecent > this.feeFixed.fee) {
        fee = feePecent;
      } else {
        fee = this.feeFixed.fee;
      }

      if (this.redeemtype) {
        fee += this.feeTaxRush.fee;
      }

      console.log(this.redeemInfo);

      if (this.redeemInfo.wave) {
        var result = this.previewData.sourceAmount * this.previewData.targetPrice;

        if (result <= this.redeemInfo.waveRule) {
          fee = 2;
        }
      }

      return fee.toFixed(2);
    },
    getTotalFeePerent: function getTotalFeePerent() {
      var totalFeePercent = void 0;
      totalFeePercent = this.previewData.sourceAmount * this.previewData.targetPrice * this.feeTax.fee / 100;

      return totalFeePercent;
    },
    getTotal: function getTotal() {
      var result = void 0;
      var feeForMtm = void 0;
      var fee = this.getTotalFeePerent();

      console.log(fee, "hereeee");

      if (fee > this.feeFixed.fee) {
        feeForMtm = fee;
      } else {
        feeForMtm = this.feeFixed.fee;
      }

      if (this.redeemtype) {
        result = (this.previewData.sourceAmount * this.previewData.targetPrice - (this.feeTaxRush.fee + feeForMtm)).toFixed(2);
      } else {
        result = (this.previewData.sourceAmount * this.previewData.targetPrice - feeForMtm).toFixed(2);
      }

      if (this.redeemInfo.wave) {
        var result1 = this.previewData.sourceAmount * this.previewData.targetPrice;
        if (result1 <= this.redeemInfo.waveRule) {
          result = (this.previewData.sourceAmount * this.previewData.targetPrice - 2).toFixed(2);
        }
      }

      return result;
    },
    validateAddress: function validateAddress() {
      if (this.usdtAddress.length < 10 || this.usdtAddress.charAt(0) != "T") {
        this.blockButton = true;
      } else {
        this.blockButton = false;
      }
    },
    callNextStep: function callNextStep() {
      this.validateAddress();

      console.log('qqqq');

      if (this.checked) {

        console.log(this.redeemtyp, 'red');
        if (this.redeemtype) {
          var total = this.previewData.sourceAmount * this.previewData.targetPrice;
          var feeCompare = this.feeTaxRush.fee;

          if (this.redeemInfo.wave) {
            if (total <= this.redeemInfo.waveRule) {
              feeCompare = 2;
            }
          }

          console.log(feeCompare, 'aqqqqqq');

          if (total < feeCompare) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
              icon: "error",
              title: this.$t("msg.error"),
              text: this.$t("msg.invalid_amount")
            }, 2000);
          } else {
            this.$emit("callNext", this.usdtAddress);
          }
        } else {
          var _total = this.previewData.sourceAmount * this.previewData.targetPrice;
          var _feeCompare = this.feeTaxRush.fee;

          if (this.redeemInfo.wave) {
            if (_total <= this.redeemInfo.waveRule) {
              _feeCompare = 2;
            }
          }

          if (_total < _feeCompare) {
            __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default.a.fire({
              icon: "error",
              title: this.$t("msg.error"),
              text: this.$t("msg.invalid_amount")
            }, 2000);
          } else {
            this.$emit("callNext", this.usdtAddress);
          }
        }
      }
    },
    callBackStep: function callBackStep() {
      this.$emit("resetStep");
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;

        return (totalBalance - lockedBalace).toFixed(6);
      }
    },
    getRedeemFee: function getRedeemFee() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("getFees");

              case 2:
                resp = _context2.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "redeem") {
                    arrayFee.push(fees[i].fee);
                  }
                }

                // this.feeRedeem = arrayFee[arrayFee.length - 1];
                _this2.feeRedeem = 0.001;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "currencies", "bluAccount", "btcAccount", "bluValue", "btcValue"])),
  watch: {}
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["redeemData", "loading"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      pin: "",
      twoFA: ""
    };
  },
  components: {},
  methods: {
    confirmRedeem: function confirmRedeem() {
      var redeem = {
        e2faCode: this.twoFA,
        id: "",
        pinCode: this.pin
      };
      this.loading = true;
      this.$emit("confirmRedeem", redeem);
    },
    cancelRedeem: function cancelRedeem() {
      this.$emit("cancelRedeem");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {
    pin: function pin() {
      this.loading = false;
    },
    twoFA: function twoFA() {
      this.loading = false;
    }
  }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["redeemData", "rush"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {}
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['error', 'dayEnabled'],
  created: function created() {
    this.getMsg();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      msg: ''
    };
  },
  components: {},
  methods: {
    resetStep: function resetStep() {
      this.$emit('resetStep');
    },
    getMsg: function getMsg() {
      var array = this.error.split(" ");
      var msgErro = '';
      array.shift();
      msgErro = array.join('_');

      this.msg = msgErro.toLowerCase();
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {}
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getUnlockedBalance();
    this.createPairCoinsArray();
  },

  props: ["selectedBlue"],
  data: function data() {
    return {
      activatedTeste: "",
      unLockedBalance: "",
      pairCoins: [],
      toggleBalance: false,
      balances: [{
        id: 1,
        type: "available",
        text: "available",
        text_USDT: "available",
        icon: "balance_status_available"
      }, {
        id: 2,
        type: "locked",
        text: "waiting_for_aprove",
        text_USDT: "waiting_for_aprove",
        icon: "balance_status_waiting"
      }, {
        id: 3,
        type: "total",
        text: "total_redeem",
        text_USDT: "total_redeem_USDT",
        icon: "balance_status_total"
      }]
    };
  },
  methods: {
    toggle: function toggle() {
      this.toggleBalance = !this.toggleBalance;
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var balance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    getBalance: function getBalance(type) {
      if (this.bluAccount) {
        if (type == "available") {
          var total = this.bluAccount.balance;
          var locked = this.bluAccount.locked;
          var balance = total - locked;
          return balance.toFixed(6);
        }
        if (type == "locked") {
          var _balance = this.bluAccount.locked;
          return _balance.toFixed(6);
        }
        if (type == "total") {
          var _balance2 = this.bluAccount.balance;
          return _balance2.toFixed(6);
        }
      } else {
        return "balance erro";
      }
    },
    getBalanceUsdt: function getBalanceUsdt(type) {
      if (this.usdtAccount) {
        if (type == "available") {
          var total = this.usdtAccount.balance;
          var locked = this.usdtAccount.locked;
          var balance = total - locked;
          return balance.toFixed(4);
        }
        if (type == "locked") {
          var _balance3 = this.usdtAccount.locked;
          return _balance3.toFixed(4);
        }
        if (type == "total") {
          var _balance4 = this.usdtAccount.balance;
          return _balance4.toFixed(4);
        }
      } else {
        return "balance erro";
      }
    },
    createPairCoinsArray: function createPairCoinsArray() {
      this.pairCoins.push(this.usdtValue[0]);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluAccount", "usdtAccount", "bluValue", "btcValue", "ethValue", "rasValue", "usdtValue"])),
  watch: {
    bluAccount: function bluAccount() {
      this.getUnlockedBalance();
    }
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_steps_internalStepStart__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_steps_internalStepAmount__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_steps_internalStepConfirm__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_steps_pinStep__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_steps_internalStepFinish__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redeem_steps_Redeem2fa__ = __webpack_require__(96);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["openOrder"],
  data: function data() {
    return {
      step: 0,
      internalWhithdraw: "",
      authorized: ""
    };
  },
  components: {
    InternalStepStart: __WEBPACK_IMPORTED_MODULE_0__internal_steps_internalStepStart__["a" /* default */],
    InternalStepAmount: __WEBPACK_IMPORTED_MODULE_1__internal_steps_internalStepAmount__["a" /* default */],
    InternalStepConfirm: __WEBPACK_IMPORTED_MODULE_2__internal_steps_internalStepConfirm__["a" /* default */],
    PinStep: __WEBPACK_IMPORTED_MODULE_3__internal_steps_pinStep__["a" /* default */],
    InternalStepFinish: __WEBPACK_IMPORTED_MODULE_4__internal_steps_internalStepFinish__["a" /* default */],
    Redeem2fa: __WEBPACK_IMPORTED_MODULE_5__redeem_steps_Redeem2fa__["a" /* default */]
  },
  created: function created() {
    this.getOtpStatus();

    console.log(this.$options.propsData);

    console.log(this.openOrder);
  },

  methods: {
    callNext: function callNext() {
      this.step++;
    },
    callBackStep: function callBackStep() {
      this.step = this.step - 1;
    },
    getOtpStatus: function getOtpStatus() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getOtpStatus");

              case 2:
                resp = _context.sent;

                _this.authorized = resp.data;
                _this.$emit("updateOptStatus");

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancelRedeem: function cancelRedeem(el) {
      console.log('tao', el);
      this.$emit('cancelOpenWithdraws', el);
    },
    withdrawInternal: function withdrawInternal(amount, userID) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var withdraw, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                withdraw = {
                  amount: parseFloat(amount),
                  memberUID: userID
                };
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$store.dispatch("postWithdrawInternal", withdraw);

              case 4:
                resp = _context2.sent;

                if (resp.status == 200) {
                  _this2.internalWhithdraw = resp.data;
                  console.log(_this2.internalWhithdraw);
                  _this2.callNext();
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                if (_context2.t0.message == "TargetAddress not allowed") {
                  _this2.notifyError(_this2.$t("msg.error_internal_member_not_found"), 30 * 1000);
                } else if (_context2.t0.message == "Fund in maintenance") {
                  _this2.notifyError(_this2.$t("msg.fund_in_maintenance"), 30 * 1000);
                } else {
                  _this2.notifyError(_this2.$t("msg.error_redeem"), 30 * 1000);
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    confirmWithdrawInternal: function confirmWithdrawInternal(twoFa, pin) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var type, withdraw, resp, error, array, msgErro;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = "withdraw";
                withdraw = {
                  e2faCode: twoFa,
                  id: _this3.internalWhithdraw.id,
                  pinCode: pin
                };
                _context3.prev = 2;
                _context3.next = 5;
                return _this3.$store.dispatch("putWithdrawConfirm", withdraw);

              case 5:
                resp = _context3.sent;

                if (resp.status == 200) {
                  _this3.$store.dispatch("updateBluAccount");
                  _this3.callNext();
                }
                _context3.next = 17;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                error = String(_context3.t0);
                array = error.split(" ");
                msgErro = "";


                array.shift();
                msgErro = array.join("_");

                _this3.notifyDanger(_this3.$t("msg." + msgErro.toLowerCase()), 5000);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[2, 9]]);
      }))();
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    }
  },

  watch: {
    openOrder: function openOrder() {
      this.internalWhithdraw = this.openOrder;
      this.step = 2;
    }
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkAmount();
  },

  data: function data() {
    return {};
  },
  methods: {
    callNext: function callNext() {
      this.$emit("callNext");
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["setAmount", "selectedPartner", "member"],
  created: function created() {
    this.$store.dispatch("updateCurrencies");

    this.checkAmount();
    this.getWithdrawFee();
    this.bluAmount = this.minBlue;
    this.getPartnerAddress();
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      userID: "",
      redeem_error: "",
      bluAmount: "",
      minBlue: "",
      maxBluAmount: 99999999999,
      address: "",
      unLockedBalance: "",
      externalId: "",
      feeWithdraw: "",
      validation: {
        amount: false,
        address: false
      },
      tooltipBonus: false
    };
  },
  components: {},
  methods: {
    showToolTipBonus: function showToolTipBonus() {
      this.tooltipBonus = true;
    },
    hideToolTipBonus: function hideToolTipBonus() {
      this.tooltipBonus = false;
    },
    getPartnerAddress: function getPartnerAddress() {
      if (this.selectedPartner == "stratum") {
        this.address = "NCYTV3UMZKBCIXXWGQPPH2QMSPL6L4FX67IGIP2J";
      } else if (this.selectedPartner == "stratumx") {
        this.address = "NAP55LGGGWPM37ZULDVOR5R6VHMFLT3XWWLGUFKI";
      }
    },
    setRedeemError: function setRedeemError() {
      if (this.bluAmount < this.minBlue) {
        this.redeem_error = "below_min";
      } else {
        this.redeem_error = "no_funds";
      }
    },
    callNextStep: function callNextStep() {
      this.$emit("callNext", this.bluAmount, this.userID);
    },
    backToPartnerSelect: function backToPartnerSelect() {
      this.$emit("backToPartners");
    },
    getWithdrawFee: function getWithdrawFee() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, fees, arrayFee, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getFees");

              case 2:
                resp = _context.sent;
                fees = resp.data;
                arrayFee = [];


                for (i in fees) {
                  if (fees[i].type == "withdraw") {
                    arrayFee.push(fees[i].fee);
                  }
                }
                _this.feeWithdraw = arrayFee[arrayFee.length - 1];

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setMinAmount: function setMinAmount() {
      var bluValue = this.btcValue[0].value / this.bluValue[0].value;
      this.minBlue = this.bluValue[0].withdrawMinimal;
      this.bluAmount = this.minBlue;
    },
    checkAmount: function checkAmount() {
      this.getUnlockedBalance();

      if (this.bluAmount >= 0 && this.bluAmount <= this.unLockedBalance) {
        this.validation.amount = true;
      } else {
        this.validation.amount = false;
      }
    },
    validateAmount: function validateAmount() {
      this.bluAmountValid = false;
      var indices = [];
      var amount = String(this.bluAmount);

      var idx = amount.indexOf(".");
      while (idx != -1) {
        indices.push(idx);
        idx = amount.indexOf(".", idx + 1);
      }
      if (indices.length > 1) {
        var n = amount.lastIndexOf(".");
        amount = amount.slice(0, n);
        this.bluAmountValid = false;
      } else {
        this.bluAmountValid = true;
      }

      this.bluAmount = amount;
      // this.isNumberCheck();
    },
    isNumberCheck: function isNumberCheck() {
      var newBluAmount = [];
      for (var i in this.bluAmount) {
        if (["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(this.bluAmount[i])) {
          newBluAmount.push(this.bluAmount[i]);
        }
      }
      newBluAmount = newBluAmount.join("");
      this.bluAmount = newBluAmount;
      var firstPosition = null;
      if (newBluAmount.indexOf(".") > 1) {
        firstPosition = newBluAmount.indexOf(".");
      }
      if (firstPosition) {
        var newArray = [];
        for (var _i in this.bluAmount) {
          if (_i == firstPosition) {
            newArray.push(".");
          } else {
            if (!isNaN(this.bluAmount[_i])) {
              newArray.push(this.bluAmount[_i]);
            }
          }
        }
        newArray = newArray.join("");
        this.bluAmount = parseFloat(newArray);
      }
      if (this.bluAmount == ".") {
        this.bluAmount = "0";
      }
    },
    getUnlockedBalance: function getUnlockedBalance() {
      if (this.bluAccount) {
        var totalBalance = this.bluAccount.balance;
        var lockedBalace = this.bluAccount.locked;
        var unLockedBalance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },
    validateAdress: function validateAdress(address) {
      if (address.length > 10 && address.charAt(0) === "N" || address.charAt(0) === "T") {
        this.validation.address = false;
      } else {
        this.validation.address = true;
      }
    },
    modifyBluAmount: function modifyBluAmount(modifier) {
      if (this.bluAmount == false || this.bluAmount < this.minBlue || this.bluAmount == "") {
        this.bluAmount = parseFloat(this.minBlue).toFixed(2);
      } else {
        if (modifier == "-" && this.bluAmount > 0) {
          var result = this.bluAmount - 1;
          if (result > this.minBlue) {
            this.bluAmount = parseFloat(result).toFixed(2);
          } else {
            this.bluAmount = parseFloat(this.minBlue).toFixed(2);
          }
        } else if (modifier == "+" && this.bluAmount < this.maxBluAmount) {
          this.bluAmount = parseFloat(this.bluAmount) + 1;
          this.bluAmount = parseFloat(this.bluAmount).toFixed(2);
        }
      }
    },
    roundUp: function roundUp(num, precision) {
      precision = Math.pow(10, precision);
      return Math.ceil(num * precision) / precision;
    },
    isNumber: function isNumber() {
      var evt = window.event;
      var charCode = evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    switchMode: function switchMode() {
      this.$emit("switchMode");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["btcValue", "bluValue", "bluAccount", "ethValue", "xemValue"])),
  watch: {
    bluAmount: function bluAmount() {
      this.setRedeemError();
      this.validateAmount();
      this.checkAmount();
    },

    feeWithdraw: function feeWithdraw() {
      this.setMinAmount();
    },

    minBlue: function minBlue() {
      this.bluAmount = this.minBlue;
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["whithdraw"],
  created: function created() {
    console.log(this.whithdraw);
  },
  mounted: function mounted() {},

  data: function data() {
    return {
      feeRedeem: ""
    };
  },
  components: {},
  methods: {
    callNextStep: function callNextStep() {
      this.$emit("callNext");
    },
    callBackStep: function callBackStep() {
      this.$emit("callBackStep");
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "currencies", "bluAccount", "btcAccount", "bluValue", "btcValue"])),
  watch: {}
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_public_Loading__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["withdrawData"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      pin: '',
      twoFA: '',
      loadingCancel: false
    };
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__components_public_Loading__["a" /* default */]
  },
  methods: {
    confirm: function confirm() {
      this.loading = true;
      this.$emit('confirmWithdraw', this.twoFA, this.pin);
    },
    cancelRedeem: function cancelRedeem(el) {
      this.loadingCancel = true;
      this.$emit('cancelRedeem', el);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])([])),
  watch: {
    pin: function pin() {
      this.loading = false;
    }
  }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["whithdraw"],
  created: function created() {
    console.log(this.whithdraw);
  },
  mounted: function mounted() {},

  data: function data() {
    return {};
  },
  components: {},
  methods: {},
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])([])),
  watch: {}
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spacetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_Loading__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["failedOrders"],
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      loading: false
    };
  },
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_public_Loading__["a" /* default */]
  },
  methods: {
    continueTransaction: function continueTransaction(el) {
      this.$emit("continueTransaction", el);
    },
    cancelTransaction: function cancelTransaction(el) {
      this.loading = true;
      this.$emit("cancelTransaction", el);
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_modalPool__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_public_LoadingCoinsSlider_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_modals_modalLastPool_vue__ = __webpack_require__(1055);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getMember();
    this.getActivePool();
    this.getPoolSummary();
    this.getPoolInfoOfMember();

    this.getCunrrencies();

    this.getSummaryByDate();
  },
  mounted: function mounted() {},


  data: function data() {
    return {
      member: [],
      modalLast: false,
      table: [{
        avatar: "avatar1",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar2",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar3",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar4",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar5",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar6",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar7",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar8",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar9",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar10",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }, {
        avatar: "avatar10",
        referral: "4.45",
        reward: "33.6%",
        estimated: "1.84 BLUE",
        icon: __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default.a,
        blue: "../../assets/images/blue_icon.svg"
      }],
      loadingTable: true,
      membersOnPoolProgram: [],
      pool: [],
      poolMonth: "",
      modal: false,
      memberPoolInfo: [],
      referralVolume: 0,
      lastMonthPools: [],
      pageLoad: false,
      monthToRender: ""
    };
  },

  components: {
    modalPool: __WEBPACK_IMPORTED_MODULE_11__components_modals_modalPool__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_12__components_public_LoadingCoinsSlider_vue__["a" /* default */],
    modalLastPool: __WEBPACK_IMPORTED_MODULE_14__components_modals_modalLastPool_vue__["a" /* default */]
  },

  methods: {
    getActivePool: function getActivePool() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch("getActivePool");

              case 2:
                resp = _context.sent;

                _this.pool = resp.data.filter(function (item) {
                  return item.active;
                })[0];

                if (_this.pool) {
                  _this.poolMonth = __WEBPACK_IMPORTED_MODULE_13_moment___default()(_this.pool.startAt).format("M");
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    toogleModal: function toogleModal() {
      this.modalLast = !this.modalLast;
    },
    getCunrrencies: function getCunrrencies() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$store.dispatch("updateCurrencies");

              case 2:
                resp = _context2.sent;

                console.log(resp, "resp aq");

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getPoolInfoOfMember: function getPoolInfoOfMember() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch("getPoolUser");

              case 2:
                resp = _context3.sent;


                if (resp.status == 200) {
                  _this3.memberPoolInfo = resp.data;
                  resp.data.referralVolume && (_this3.referralVolume = resp.data.referralVolume);
                } else {
                  console.log(resp);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getSummaryByDate: function getSummaryByDate() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var date, month, year, teste, y, m, lastDay, last, start, end, params, resp, allPools, i;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                date = new Date();
                month = date.getMonth();
                year = date.getFullYear();

                _this4.monthToRender = date.getMonth();

                if (month < 10) {
                  month = "0" + month;
                }

                teste = new Date(), y = teste.getFullYear(), m = date.getMonth();
                lastDay = new Date(year, month, 0);
                last = lastDay.getDate();

                _this4.month = month;

                start = year + "-" + month + "-01T00:28:21.0Z";
                end = year + "-" + month + "-" + last + "T23:28:21.0Z";
                params = {
                  startAt: start,
                  endAt: end
                };
                _context4.next = 14;
                return _this4.$store.dispatch("getPoolsSummaryByDate", params);

              case 14:
                resp = _context4.sent;

                if (resp.status == 200) {
                  allPools = resp.data;

                  for (i in allPools) {
                    if (allPools[i].referralVolume >= 1) {
                      _this4.lastMonthPools.push(allPools[i]);

                      _this4.lastMonthPools.sort(function (a, b) {
                        if (a.referralVolume < b.referralVolume) {
                          return 1;
                        }
                        if (a.referralVolume > b.referralVolume) {
                          return -1;
                        }
                        return 0;
                      });
                    }
                    _this4.loadingTable = false;
                  }
                } else {
                  alert("Something wrong");
                }

                _this4.pageLoadingFinish();

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    pageLoadingFinish: function pageLoadingFinish() {
      this.pageLoad = true;
    },
    getPoolSummary: function getPoolSummary() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this5.$store.dispatch("getPoolsSumarry").then(function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(response) {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (response.status == 200) {
                              _this5.membersOnPoolProgram = response.data.filter(function (member) {
                                return member.referralVolume >= 1;
                              });

                              _this5.membersOnPoolProgram.sort(function (a, b) {
                                if (a.referralVolume < b.referralVolume) {
                                  return 1;
                                }
                                if (a.referralVolume > b.referralVolume) {
                                  return -1;
                                }
                                return 0;
                              });

                              _this5.loadingTable = false;
                            } else {
                              console.log(response);
                            }

                          case 1:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this5);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  console.log(err);
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    getMember: function getMember() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this6.$store.dispatch("getMember").then(function (resp) {
                  _this6.member = resp;
                });

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    showModal: function showModal() {
      this.modal = !this.modal;
    },
    getPoolUser: function getPoolUser() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this7.$store.dispatch("getPoolUser").then(function (resp) {
                  _this7.poolUser = resp.data;
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    reloadUsers: function reloadUsers() {
      // this.getMember();
      // this.getPoolSummary();
      // this.getPoolInfoOfMember();

      this.getMember();
      this.getActivePool();
      this.getPoolSummary();
      this.getPoolInfoOfMember();
    },
    renderImage: function renderImage(e) {
      if (e == "avatar1") {
        return __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default.a;
      } else if (e == "avatar2") {
        return __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default.a;
      } else if (e == "avatar3") {
        return __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default.a;
      } else if (e == "avatar4") {
        return __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default.a;
      } else if (e == "avatar5") {
        return __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default.a;
      } else if (e == "avatar6") {
        return __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default.a;
      } else if (e == "avatar7") {
        return __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default.a;
      } else if (e == "avatar8") {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default.a;
      } else if (e == "avatar9") {
        return __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default.a;
      } else if (e == "avatar10") {
        return __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default.a;
      }
    }
  },

  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluValue", "joinPool"])),
  watch: {}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_sweetalert2__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getMember();
  },

  data: function data() {
    return {
      icons: [__WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default.a, __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default.a, __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default.a, __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default.a, __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default.a, __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default.a],
      member: [],
      poolUser: "",
      nickname: "",
      selectedAvatar: "",
      iconToRequest: "",
      firstScreenModal: true,

      memberRespPoolConfirm: ""
    };
  },
  methods: {
    closeModalPool: function closeModalPool() {
      this.$emit("closeModalPool");
    },
    joinPoolAction: function joinPoolAction() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var self, backendAvatar, params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this;


                self.iconToRequest = "avatar" + self.selectedAvatar;

                backendAvatar = "avatar" + (self.selectedAvatar + 1);
                params = {
                  avatar: backendAvatar,
                  nickname: self.nickname
                };


                console.log(params);

                if (!(self.nickname !== "" && self.selectedAvatar !== "")) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return _this.$store.dispatch("addMemberToPool", params).then(function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resp) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(resp.status == 200)) {
                              _context.next = 8;
                              break;
                            }

                            _this.getMember();
                            _this.getPoolUser();

                            self.firstScreenModal = false;

                            _context.next = 6;
                            return _this.$store.dispatch("joinPool");

                          case 6:
                            _this.memberRespPoolConfirm = resp.data;
                            _this.$emit("reloadUser");

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (e) {
                  console.log(e);
                  __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                    icon: "error",
                    title: _this.$t("msg.error"),
                    text: _this.$t("msg.error_pool_avatar")
                  });
                });

              case 8:
                _context2.next = 11;
                break;

              case 10:
                __WEBPACK_IMPORTED_MODULE_11_sweetalert2___default.a.fire({
                  icon: "error",
                  title: _this.$t("msg.error"),
                  text: _this.$t("msg.error_pool_avatar_select")
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getPoolUser: function getPoolUser() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$store.dispatch("getPoolUser").then(function (resp) {
                  _this2.poolUser = resp.data;
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getMember: function getMember() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$store.dispatch("getMember").then(function (resp) {
                  _this3.member = resp;
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    renderImage: function renderImage(e) {
      if (e == "avatar1") {
        return __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default.a;
      } else if (e == "avatar2") {
        return __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default.a;
      } else if (e == "avatar3") {
        return __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default.a;
      } else if (e == "avatar4") {
        return __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default.a;
      } else if (e == "avatar5") {
        return __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default.a;
      } else if (e == "avatar6") {
        return __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default.a;
      } else if (e == "avatar7") {
        return __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default.a;
      } else if (e == "avatar8") {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default.a;
      } else if (e == "avatar9") {
        return __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default.a;
      } else if (e == "avatar10") {
        return __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default.a;
      }
    }
  },
  computed: _extends({
    selectedAvatarStyle: function selectedAvatarStyle() {
      var styleRadarContainerInactive = {
        borderRadius: "2rem",
        border: "2px solid #342365"
      };

      return styleRadarContainerInactive;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["joinPool"])),
  components: {}
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["membersOnPoolProgram", "month"],
  created: function created() {},

  data: function data() {
    return {
      pairs: [],
      pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
      blue: {},
      fundTails: {},
      pools: []
    };
  },
  methods: {
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    totalValue: function totalValue() {
      var total = 0;

      for (var i in this.membersOnPoolProgram) {
        total += this.membersOnPoolProgram[i].estimated;
      }

      return total.toFixed(2);
    },
    renderImage: function renderImage(e) {
      if (e == "avatar1") {
        return __WEBPACK_IMPORTED_MODULE_1__assets_images_Avatar_Blue_Pool_avatar1_svg___default.a;
      } else if (e == "avatar2") {
        return __WEBPACK_IMPORTED_MODULE_2__assets_images_Avatar_Blue_Pool_avatar2_svg___default.a;
      } else if (e == "avatar3") {
        return __WEBPACK_IMPORTED_MODULE_3__assets_images_Avatar_Blue_Pool_avatar3_svg___default.a;
      } else if (e == "avatar4") {
        return __WEBPACK_IMPORTED_MODULE_4__assets_images_Avatar_Blue_Pool_avatar4_svg___default.a;
      } else if (e == "avatar5") {
        return __WEBPACK_IMPORTED_MODULE_5__assets_images_Avatar_Blue_Pool_avatar5_svg___default.a;
      } else if (e == "avatar6") {
        return __WEBPACK_IMPORTED_MODULE_6__assets_images_Avatar_Blue_Pool_avatar6_svg___default.a;
      } else if (e == "avatar7") {
        return __WEBPACK_IMPORTED_MODULE_7__assets_images_Avatar_Blue_Pool_avatar7_svg___default.a;
      } else if (e == "avatar8") {
        return __WEBPACK_IMPORTED_MODULE_8__assets_images_Avatar_Blue_Pool_avatar8_svg___default.a;
      } else if (e == "avatar9") {
        return __WEBPACK_IMPORTED_MODULE_9__assets_images_Avatar_Blue_Pool_avatar9_svg___default.a;
      } else if (e == "avatar10") {
        return __WEBPACK_IMPORTED_MODULE_10__assets_images_Avatar_Blue_Pool_avatar10_svg___default.a;
      }
    }
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_private_insights_InsightsHoldings__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_private_insights_InsightsReports__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_public_GeneralCharts__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_private_insights_InsightsCharity__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_private_insights_InsightsSupply__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modals_modalOtherCurrencies_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modals_modalExpandChart__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modals_modalCurrencyInfo__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_modalPriceHist__ = __webpack_require__(1090);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},
  mounted: function mounted() {},

  data: function data() {
    return {
      modalExpandChart: false,
      modalCurrencies: false,
      modalCurrencyInfo: false,
      modalPriceHist: false,
      type: "",
      selectedCurrency: {},
      priceHistory: {}
    };
  },
  components: {
    InsigthsHoldings: __WEBPACK_IMPORTED_MODULE_1__components_private_insights_InsightsHoldings__["a" /* default */],
    InsightsReports: __WEBPACK_IMPORTED_MODULE_2__components_private_insights_InsightsReports__["a" /* default */],
    GeneralCharts: __WEBPACK_IMPORTED_MODULE_3__components_public_GeneralCharts__["a" /* default */],
    InsightsCharity: __WEBPACK_IMPORTED_MODULE_4__components_private_insights_InsightsCharity__["a" /* default */],
    InsightsSupply: __WEBPACK_IMPORTED_MODULE_5__components_private_insights_InsightsSupply__["a" /* default */],
    ModalOtherCurrencies: __WEBPACK_IMPORTED_MODULE_6__components_modals_modalOtherCurrencies_vue__["a" /* default */],
    modalExpandChart: __WEBPACK_IMPORTED_MODULE_7__components_modals_modalExpandChart__["a" /* default */],
    modalCurrencyInfo: __WEBPACK_IMPORTED_MODULE_8__components_modals_modalCurrencyInfo__["a" /* default */],
    modalPriceHist: __WEBPACK_IMPORTED_MODULE_9__components_modals_modalPriceHist__["a" /* default */]
  },
  methods: {
    showModalCurrencies: function showModalCurrencies(el) {
      this.type = el;
      this.modalCurrencies = !this.modalCurrencies;
    },
    showModalExpandChart: function showModalExpandChart() {
      this.modalExpandChart = !this.modalExpandChart;
    },
    createPriceHist: function createPriceHist(el) {
      this.priceHistory = el;

      console.log(el, "aqqqqqqqqqq");
    },
    showModalCurrencyInfo: function showModalCurrencyInfo(el) {
      this.selectedCurrency = el;
      this.modalCurrencyInfo = !this.modalCurrencyInfo;
    },
    showModalPriceHist: function showModalPriceHist() {
      this.modalPriceHist = !this.modalPriceHist;
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "currencies"])),
  watch: {}
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.orderArray();
    this.checkIfMobile();

    console.log(this.assetList);
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      assetTailsIndex: [],
      assetTailsPicks: [],
      assetTailsOperations: [],
      assets: [],
      isMobile: false,
      selectedCurrency: {},
      modalCurrencyInfo: false
    };
  },
  components: {},
  methods: {
    currencyFormat: function currencyFormat(num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    fixSymb: function fixSymb(el) {
      if (el == "TUSD" || el == "tusd") {
        return "USDT";
      } else {
        return el;
      }
    },
    selectCurrency: function selectCurrency(el) {
      el.apy = el.apyPercent;
      this.$emit("toggleModal", el);
    },
    orderArray: function orderArray() {
      this.assetList.sort(function (a, b) {
        return a.overallWeight > b.overallWeight ? -1 : a.overallWeight < b.overallWeight ? 1 : 0;
      });
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    dailyRewards: function dailyRewards(symbol) {
      if (symbol == "SOL") {
        return symbol = "+7.5%";
      } else if (symbol == "ETH") {
        return symbol = "+4.05%";
      } else if (symbol == "ADA") {
        return symbol = "+6.76%";
      } else if (symbol == "AVAX") {
        return symbol = "+6.28%";
      } else if (symbol == "DOT") {
        return symbol = "+13.95%";
      } else if (symbol == "CAKE") {
        return symbol = "+8.79%";
      } else if (symbol == "ALGO") {
        return symbol = "+7.45%";
      }
    },
    greenDot: function greenDot(el) {
      if (el) {
        return true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["member", "currencies", "assetList"])),
  watch: {}
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkIfMobile();
  },
  mounted: function mounted() {
    this.languageSelectedOnPage = this.languageSelected;
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      languageSelectedOnPage: "",
      isMobile: false
    };
  },
  methods: {
    changeLanguage: function changeLanguage(lang) {
      this.languageSelectedOnPage = lang;
      this.$store.dispatch("setLanguageSelected", lang);
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
    returnLink: function returnLink() {
      if (this.languageSelected == 'en') {
        return '/docs/report_Q4_2022.pdf';
      } else {
        return '/docs/report_Q4_2022.pdf';
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["languages", "languageSelected"]), {
    storeLanguage: {
      get: function get() {
        return this.languageSelectedOnPage;
      },
      set: function set(value) {
        this.changeLanguage(value);
      }
    }
  })
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_component_ChartLineAll__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_component_ChartLineLatest__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charts_component_ChartLineCustom__ = __webpack_require__(372);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.checkIfMobile();
  },
  mounted: function mounted() {
    this.toggleChart("all");
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      chartParams: false,
      startDateChartAll: "2018-12-04T00:00:09.0Z",
      positiveTotal: "",
      chartsHour: {
        data: false,
        step: "",
        type: "hour",
        min: ""
      },
      chartsDay: {
        data: false,
        step: "",
        type: "day",
        min: ""
      },
      chartsWeek: {
        data: false,
        step: "",
        type: "week",
        min: ""
      },

      chartsMonth: {
        data: false,
        step: "",
        type: "month",
        min: ""
      },

      chartsYear: {
        data: false,
        step: "",
        type: "year",
        min: ""
      },

      chartsYTD: {
        data: false,
        step: "",
        type: "ytd",
        min: ""
      },

      chartsAll: {
        data: false,
        step: "",
        type: "all",
        min: ""
      },

      chartLoading: true,
      chartMode: "all",
      isMobile: false
    };
  },
  components: {
    ChartLineAll: __WEBPACK_IMPORTED_MODULE_1__charts_component_ChartLineAll__["a" /* default */],
    ChartLineLatest: __WEBPACK_IMPORTED_MODULE_2__charts_component_ChartLineLatest__["a" /* default */],
    ChartLineCustom: __WEBPACK_IMPORTED_MODULE_3__charts_component_ChartLineCustom__["a" /* default */]
  },
  methods: {
    toggleModalExpandChart: function toggleModalExpandChart() {
      this.$emit("toggleModalExpandChart");
    },
    toggleModalPriceHist: function toggleModalPriceHist() {
      this.$emit("toggleModalPriceHist");
    },
    getPercentChangeAll: function getPercentChangeAll() {
      var firstPrice = this.chartsAll.data[0] ? this.chartsAll.data[0].close : 0;
      var currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeHour: function getPercentChangeHour() {
      var firstPrice = this.chartsHour.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeDay: function getPercentChangeDay() {
      var firstPrice = this.chartsDay.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeYear: function getPercentChangeYear() {
      var firstPrice = this.chartsYear.data[0] ? this.chartsYear.data[0].close : 0;

      var currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeYTD: function getPercentChangeYTD() {
      var firstPrice = this.chartsYTD.data[0] ? this.chartsYTD.data[0].close : 0;

      var currentlyPrice = this.bluValue[0] ? this.bluValue[0].value : 0;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeMonth: function getPercentChangeMonth() {
      var firstPrice = this.chartsMonth.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    getPercentChangeWeek: function getPercentChangeWeek() {
      var firstPrice = this.chartsWeek.data[0].close;
      var currentlyPrice = this.bluValue[0].value;

      var total = (currentlyPrice - firstPrice) / firstPrice * 100;

      if (total >= 0) {
        this.positiveTotal = true;
        return "+" + total.toFixed(2) + "%";
      } else {
        this.positiveTotal = false;
        return total.toFixed(2) + "%";
      }
    },
    setChartLoading: function setChartLoading(bol) {
      this.chartLoading = bol;
    },


    // step 1 ...........................................................................
    toggleChart: function toggleChart(mode) {
      this.chartMode = mode;
      if (mode == "hour") {
        if (!this.chartsHour.data) {
          this.getHistoryHour();
        } else {
          this.setChart("hour");
        }
      }

      if (mode == "day") {
        if (!this.chartsDay.data) {
          this.getHistoryDay();
        } else {
          this.setChart("day");
        }
      }

      if (mode == "week") {
        if (!this.chartsWeek.data) {
          this.getHistoryWeek();
        } else {
          this.setChart("week");
        }
      }

      if (mode == "month") {
        if (!this.chartsMonth.data) {
          this.getHistoryMonth();
        } else {
          this.setChart("month");
        }
      }

      if (mode == "year") {
        if (!this.chartsYear.data) {
          this.getHistoryYear();
        } else {
          this.setChart("year");
        }
      }

      if (mode == "ytd") {
        if (!this.chartsYTD.data) {
          this.getHistoryYTD();
        } else {
          this.setChart("ytd");
        }
      }

      if (mode == "all") {
        if (!this.chartsAll.data) {
          this.getHistoryAll();
        } else {
          this.setChart("all");
        }
      }
    },


    // step 2 ...........................................................................

    getHistoryHour: function getHistoryHour() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dateStart, dateEnd, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dateStart = new Date();
                dateEnd = new Date();

                dateEnd.setHours(dateEnd.getHours() - 1);
                endHour = _this.sharedActions.formatDateTimeHistory(dateEnd);


                dateStart.setHours(dateStart.getHours() - 2);
                startHour = _this.sharedActions.formatDateTimeHistory(dateStart);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 1,
                  sumbols: "blu"
                };
                _context.next = 9;
                return _this.$store.dispatch("getCurrenciesHistory", params);

              case 9:
                resp = _context.sent;


                _this.chartsHour.data = resp.data[0].history;
                _this.getMinStep(resp.data[0].history, "hour");

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getHistoryDay: function getHistoryDay() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                date = new Date();
                endHour = _this2.sharedActions.formatDateTimeHistory(date);

                date.setHours(0);
                date.setMinutes(0);
                startHour = _this2.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 60,
                  sumbols: "blu"
                };
                _context2.next = 8;
                return _this2.$store.dispatch("getCurrenciesHistory", params);

              case 8:
                resp = _context2.sent;

                _this2.chartsDay.data = resp.data[0].history;

                _this2.getMinStep(resp.data[0].history, "day");

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getHistoryWeek: function getHistoryWeek() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                date = new Date();
                endHour = _this3.sharedActions.formatDateTimeHistory(date);

                date.setDate(date.getDate() - 7);
                startHour = _this3.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };


                console.log(startHour);
                console.log(endHour);

                _context3.next = 9;
                return _this3.$store.dispatch("getCurrenciesHistory", params);

              case 9:
                resp = _context3.sent;

                _this3.chartsWeek.data = resp.data[0].history;

                _this3.setChart("week");

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getHistoryMonth: function getHistoryMonth() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                date = new Date();
                endHour = _this4.sharedActions.formatDateTimeHistory(date);

                date.setMonth(date.getMonth() - 1);
                startHour = _this4.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: "1D",
                  sumbols: "blu"
                };
                _context4.next = 7;
                return _this4.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context4.sent;

                _this4.chartsMonth.data = resp.data[0].history;
                _this4.setChart("month");

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getHistoryYear: function getHistoryYear() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                date = new Date();
                endHour = _this5.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(date.getFullYear() - 1);
                startHour = _this5.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context5.next = 7;
                return _this5.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context5.sent;

                _this5.chartsYear.data = resp.data[0].history;
                _this5.setChart("year");

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getHistoryYTD: function getHistoryYTD() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                date = new Date();
                endHour = _this6.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(date.getFullYear(), 0, 1);

                startHour = _this6.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context6.next = 7;
                return _this6.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context6.sent;

                _this6.chartsYTD.data = resp.data[0].history;
                _this6.setChart("ytd");

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getHistoryAll: function getHistoryAll() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                date = new Date();
                endHour = _this7.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(2018);
                startHour = _this7.sharedActions.formatDateTimeHistory(_this7.startDateChartAll);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context7.next = 7;
                return _this7.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context7.sent;

                _this7.chartsAll.data = resp.data[0].history;

                _this7.getMinStep(resp.data[0].history, "all");
                _this7.$emit("createPriceHist", _this7.chartsAll);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    getMinStep: function getMinStep(resp, type) {
      var max = 0;
      var min = 1000;
      var step = "";

      for (var i in resp) {
        if (resp[i].close < min) {
          min = resp[i].close;
        }
        if (resp[i].close > max) {
          max = resp[i].close;
        }
      }

      var minFixed = min.toFixed();
      min = min.toFixed(2);
      max = max.toFixed(2);
      step = (max - min).toFixed(2) / 2;

      min = min - step * 2;

      if (type == "hour") {
        // min = min + 0.03
        this.chartsHour.min = min.toFixed(2);
        this.chartsHour.step = step;
        this.setChart("hour");
      }

      if (type == "day") {
        this.chartsDay.min = min.toFixed(2);
        this.chartsDay.step = step;
        this.setChart("day");
      }

      if (type == "all") {
        this.chartsAll.min = min.toFixed();
        this.chartsAll.step = step.toFixed();
        this.setChart("all");
      }
    },


    //step 3 ...........................................................................
    setChart: function setChart(mode) {
      if (mode == "hour") {
        this.chartParams = this.chartsHour;
      } else if (mode == "day") {
        this.chartParams = this.chartsDay;
      } else if (mode == "week") {
        this.chartParams = this.chartsWeek;
      } else if (mode == "month") {
        this.chartParams = this.chartsMonth;
      } else if (mode == "year") {
        this.chartParams = this.chartsYear;
      } else if (mode == "ytd") {
        this.chartParams = this.chartsYTD;
      } else if (mode == "all") {
        this.chartParams = this.chartsAll;
      }
    },


    // step4 .........................................................................

    currencyFormat: function currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return 0;
      }
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["currencies", "btcValue", "bluValue"])),
  watch: {}
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_charity_bitgive_png__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_charity_bitgive_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_charity_bitgive_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_charity_b4h_png__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_charity_b4h_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_charity_b4h_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},

  components: {
    img1: __WEBPACK_IMPORTED_MODULE_0__assets_images_charity_bitgive_png___default.a
  },
  data: function data() {
    return {
      charity: [{
        name: "bitgive",
        amout: "0.0058",
        image: __WEBPACK_IMPORTED_MODULE_0__assets_images_charity_bitgive_png___default.a
      }, {
        name: "b4h",
        amout: "0.0058",
        image: __WEBPACK_IMPORTED_MODULE_1__assets_images_charity_b4h_png___default.a
      }]
    };
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getFundTails();
    this.checkIfMobile();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.checkIfMobile);
  },

  data: function data() {
    return {
      fundTails: "",
      isMobile: false
    };
  },
  methods: {
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    openSite: function openSite() {
      window.open("https://bscscan.com/token/0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2");
    },
    getFundTails: function getFundTails() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 1,
                  entryType: "live"
                };
                _context.prev = 1;
                _context.next = 4;
                return _this.$store.dispatch("getFundTails", params);

              case 4:
                resp = _context.sent;

                _this.fundTails = resp.data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.log("error ", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    currencyFormat: function currencyFormat(num) {
      if (num) {
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        return 0;
      }
    },
    checkIfMobile: function checkIfMobile() {
      var w = window,
          x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluValue"]))
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_public_charts_component_TradeChart__ = __webpack_require__(1076);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.getHistoryAll();
  },

  data: function data() {
    return {
      chartData: [],
      startDateChartAll: "2018-12-04T00:00:09.0Z",
      positiveTotal: "",
      chartsHour: {
        data: false,
        step: "",
        type: "hour",
        min: ""
      },
      chartsDay: {
        data: false,
        step: "",
        type: "day",
        min: ""
      },
      chartsWeek: {
        data: false,
        step: "",
        type: "week",
        min: ""
      },

      chartsMonth: {
        data: false,
        step: "",
        type: "month",
        min: ""
      },

      chartsYear: {
        data: false,
        step: "",
        type: "year",
        min: ""
      },

      chartsYTD: {
        data: false,
        step: "",
        type: "ytd",
        min: ""
      },

      chartsAll: {
        data: false,
        step: "",
        type: "all",
        min: ""
      },

      chartLoading: true,
      chartParams: false,
      chartMode: "all"
    };
  },
  components: {
    TradeChart: __WEBPACK_IMPORTED_MODULE_1__components_public_charts_component_TradeChart__["a" /* default */]
  },
  methods: {
    toggleModalExpandChart: function toggleModalExpandChart() {
      this.$emit("toggleModalExpandChart");
    },
    setChartLoading: function setChartLoading(bol) {
      this.chartLoading = bol;
    },
    toggleChart: function toggleChart(mode) {
      this.chartMode = mode;
      if (mode == "hour") {
        if (!this.chartsHour.data) {
          this.getHistoryHour();
        } else {
          this.setChart("hour");
        }
      }

      if (mode == "day") {
        if (!this.chartsDay.data) {
          this.getHistoryDay();
        } else {
          this.setChart("day");
        }
      }

      if (mode == "week") {
        if (!this.chartsWeek.data) {
          this.getHistoryWeek();
        } else {
          this.setChart("week");
        }
      }

      if (mode == "month") {
        if (!this.chartsMonth.data) {
          this.getHistoryMonth();
        } else {
          this.setChart("month");
        }
      }

      if (mode == "year") {
        if (!this.chartsYear.data) {
          this.getHistoryYear();
        } else {
          this.setChart("year");
        }
      }

      if (mode == "ytd") {
        if (!this.chartsYTD.data) {
          this.getHistoryYTD();
        } else {
          this.setChart("ytd");
        }
      }

      if (mode == "all") {
        if (!this.chartsAll.data) {
          this.getHistoryAll();
        } else {
          this.setChart("all");
        }
      }
    },
    getHistoryHour: function getHistoryHour() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dateStart, dateEnd, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dateStart = new Date();
                dateEnd = new Date();

                dateEnd.setHours(dateEnd.getHours() - 1);
                endHour = _this.sharedActions.formatDateTimeHistory(dateEnd);


                dateStart.setHours(dateStart.getHours() - 2);
                startHour = _this.sharedActions.formatDateTimeHistory(dateStart);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 1,
                  sumbols: "blu"
                };
                _context.next = 9;
                return _this.$store.dispatch("getCurrenciesHistory", params);

              case 9:
                resp = _context.sent;


                _this.chartsHour.data = resp.data[0].history;
                _this.getMinStep(resp.data[0].history, "hour");

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getHistoryDay: function getHistoryDay() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                date = new Date();
                endHour = _this2.sharedActions.formatDateTimeHistory(date);

                date.setHours(0);
                date.setMinutes(0);
                startHour = _this2.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 60,
                  sumbols: "blu"
                };
                _context2.next = 8;
                return _this2.$store.dispatch("getCurrenciesHistory", params);

              case 8:
                resp = _context2.sent;

                _this2.chartsDay.data = resp.data[0].history;

                _this2.getMinStep(resp.data[0].history, "day");

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getHistoryWeek: function getHistoryWeek() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                date = new Date();
                endHour = _this3.sharedActions.formatDateTimeHistory(date);

                date.setDate(date.getDate() - 7);
                startHour = _this3.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context3.next = 7;
                return _this3.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context3.sent;

                _this3.chartsWeek.data = resp.data[0].history;
                _this3.setChart("week");

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getHistoryMonth: function getHistoryMonth() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                date = new Date();
                endHour = _this4.sharedActions.formatDateTimeHistory(date);

                date.setMonth(date.getMonth() - 1);
                startHour = _this4.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: "1D",
                  sumbols: "blu"
                };
                _context4.next = 7;
                return _this4.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context4.sent;

                _this4.chartsMonth.data = resp.data[0].history;
                _this4.setChart("month");

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getHistoryYear: function getHistoryYear() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                date = new Date();
                endHour = _this5.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(date.getFullYear() - 1);
                startHour = _this5.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context5.next = 7;
                return _this5.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context5.sent;

                _this5.chartsYear.data = resp.data[0].history;
                _this5.setChart("year");

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getHistoryYTD: function getHistoryYTD() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                date = new Date();
                endHour = _this6.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(date.getFullYear(), 0, 1);

                startHour = _this6.sharedActions.formatDateTimeHistory(date);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context6.next = 7;
                return _this6.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context6.sent;

                _this6.chartsYTD.data = resp.data[0].history;
                _this6.setChart("ytd");

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getHistoryAll: function getHistoryAll() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var date, endHour, startHour, params, resp;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                date = new Date();
                endHour = _this7.sharedActions.formatDateTimeHistory(date);

                date.setFullYear(2018);

                startHour = _this7.sharedActions.formatDateTimeHistory(_this7.startDateChartAll);
                params = {
                  start: startHour + ".0Z",
                  end: endHour + ".0Z",
                  pair: "usdt",
                  period: 720,
                  sumbols: "blu"
                };
                _context7.next = 7;
                return _this7.$store.dispatch("getCurrenciesHistory", params);

              case 7:
                resp = _context7.sent;

                _this7.chartData = resp.data[0].history;

                _this7.chartsAll.data = resp.data[0].history;

                _this7.getMinStep(resp.data[0].history, "all");

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    getMinStep: function getMinStep(resp, type) {
      var max = 0;
      var min = 1000;
      var step = "";

      for (var i in resp) {
        if (resp[i].close < min) {
          min = resp[i].close;
        }
        if (resp[i].close > max) {
          max = resp[i].close;
        }
      }

      var minFixed = min.toFixed();
      min = min.toFixed(2);
      max = max.toFixed(2);
      step = (max - min).toFixed(2) / 2;

      min = min - step * 2;

      if (type == "hour") {
        // min = min + 0.03
        this.chartsHour.min = min.toFixed(2);
        this.chartsHour.step = step;
        this.setChart("hour");
      }

      if (type == "day") {
        this.chartsDay.min = min.toFixed(2);
        this.chartsDay.step = step;
        this.setChart("day");
      }

      if (type == "year") {
        this.chartsYear.min = min.toFixed(2);
        this.chartsYear.step = step;
        this.setChart("year");
      }

      if (type == "all") {
        this.chartsAll.min = min.toFixed();
        this.chartsAll.step = step.toFixed();
        this.setChart("all");
      }

      console.log(this.chartsYear.min);
      console.log(this.chartsYear.step);

      console.log(this.chartsAll.min);
      console.log(this.chartsAll.step);
    },
    setChart: function setChart(mode) {
      if (mode == "hour") {
        this.chartParams = this.chartsHour;
      } else if (mode == "day") {
        this.chartParams = this.chartsDay;
      } else if (mode == "week") {
        this.chartParams = this.chartsWeek;
      } else if (mode == "month") {
        this.chartParams = this.chartsMonth;
      } else if (mode == "year") {
        this.chartParams = this.chartsYear;
      } else if (mode == "ytd") {
        this.chartParams = this.chartsYTD;
      } else if (mode == "all") {
        this.chartParams = this.chartsAll;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["bluValue"]))
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_klinecharts__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_klinecharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_klinecharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_klinecharts_lib_shape_shapeHelper__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_klinecharts_lib_shape_shapeHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_klinecharts_lib_shape_shapeHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout__ = __webpack_require__(1082);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var icon = "https://bluetoken.io/app/blue_icon_main.png?3284ebff7df94f792898c67564230ad0";

// custom indicator
var emojiTechnicalIndicator = {
  name: "BLUE",
  plots: [{ key: "BLUE" }],
  calcTechnicalIndicator: function calcTechnicalIndicator(kLineDataList) {
    var result = [];
    kLineDataList.forEach(function (kLineData) {
      result.push({
        close: kLineData.close,
        icon: icon
      });
    });
    return result;
  },
  render: function render(_ref) {
    var ctx = _ref.ctx,
        dataSource = _ref.dataSource,
        viewport = _ref.viewport,
        xAxis = _ref.xAxis,
        yAxis = _ref.yAxis;

    ctx.font = viewport.barSpace + "px Helvetica Neue";
    ctx.textAlign = "center";
    for (var i = dataSource.from; i < dataSource.to; i++) {
      var data = dataSource.technicalIndicatorDataList[i];
      var x = xAxis.convertToPixel(i);
      var y = yAxis.convertToPixel(data.close);
      var dataPrice = new Image(15, 20);
      dataPrice.src = icon;
      ctx.drawImage(dataPrice, x, y, dataPrice.width, dataPrice.height);
    }
  }
};

var rect = {
  name: "rect",
  totalStep: 3,
  checkEventCoordinateOnShape: function checkEventCoordinateOnShape(_ref2) {
    var dataSource = _ref2.dataSource,
        eventCoordinate = _ref2.eventCoordinate;

    return Object(__WEBPACK_IMPORTED_MODULE_1_klinecharts_lib_shape_shapeHelper__["checkCoordinateOnSegment"])(dataSource[0], dataSource[1], eventCoordinate);
  },
  createShapeDataSource: function createShapeDataSource(_ref3) {
    var coordinates = _ref3.coordinates;

    if (coordinates.length === 2) {
      return [{
        type: "line",
        isDraw: false,
        isCheck: true,
        dataSource: [[_extends({}, coordinates[0]), { x: coordinates[1].x, y: coordinates[0].y }], [{ x: coordinates[1].x, y: coordinates[0].y }, _extends({}, coordinates[1])], [_extends({}, coordinates[1]), { x: coordinates[0].x, y: coordinates[1].y }], [{ x: coordinates[0].x, y: coordinates[1].y }, _extends({}, coordinates[0])]]
      }, {
        type: "polygon",
        isDraw: true,
        isCheck: false,
        styles: { style: "fill" },
        dataSource: [[_extends({}, coordinates[0]), { x: coordinates[1].x, y: coordinates[0].y }, _extends({}, coordinates[1]), { x: coordinates[0].x, y: coordinates[1].y }]]
      }, {
        type: "polygon",
        isDraw: true,
        isCheck: false,
        dataSource: [[_extends({}, coordinates[0]), { x: coordinates[1].x, y: coordinates[0].y }, _extends({}, coordinates[1]), { x: coordinates[0].x, y: coordinates[1].y }]]
      }];
    }
    return [];
  }
};

var circle = {
  name: "circle",
  totalStep: 3,
  checkEventCoordinateOnShape: function checkEventCoordinateOnShape(_ref4) {
    var dataSource = _ref4.dataSource,
        eventCoordinate = _ref4.eventCoordinate;

    var xDis = Math.abs(dataSource.x - eventCoordinate.x);
    var yDis = Math.abs(dataSource.y - eventCoordinate.y);
    var r = Math.sqrt(xDis * xDis + yDis * yDis);
    return Math.abs(r - dataSource.radius) < 3;
  },
  createShapeDataSource: function createShapeDataSource(_ref5) {
    var coordinates = _ref5.coordinates;

    if (coordinates.length === 2) {
      var xDis = Math.abs(coordinates[0].x - coordinates[1].x);
      var yDis = Math.abs(coordinates[0].y - coordinates[1].y);
      var radius = Math.sqrt(xDis * xDis + yDis * yDis);
      return [{
        type: "arc",
        isDraw: true,
        isCheck: false,
        styles: { style: "fill" },
        dataSource: [_extends({}, coordinates[0], { radius: radius, startAngle: 0, endAngle: Math.PI * 2 })]
      }, {
        type: "arc",
        isDraw: true,
        isCheck: true,
        dataSource: [_extends({}, coordinates[0], { radius: radius, startAngle: 0, endAngle: Math.PI * 2 })]
      }];
    }
    return [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["chartData"],
  name: "TechnicalIndicatorKLineChart",
  components: { Layout: __WEBPACK_IMPORTED_MODULE_3__Layout__["a" /* default */] },
  created: function created() {
    this.getDataPrice();
  },


  data: function data() {
    return {
      dataPrice: [],
      mainTechnicalIndicatorTypes: ["MA", "EMA", "SAR"],
      subTechnicalIndicatorTypes: ["VOL", "MACD", "KDJ"],
      shapes: [{ key: "priceLine", text: "Price line" }, { key: "priceChannelLine", text: "Price channel line" }, { key: "parallelStraightLine", text: "Parallel lines" }, { key: "fibonacciLine", text: "Fibonacci" }, { key: "rect", text: "Rectangle" }, { key: "circle", text: "Circle" }]
    };
  },
  mounted: function mounted() {
    this.kLineChart = Object(__WEBPACK_IMPORTED_MODULE_0_klinecharts__["init"])("technical-indicator-k-line", {
      candle: {
        tooltip: {
          labels: ["time: ", "open: ", "receive: ", "high: ", "low: ", "volume: "]
        }
      }
    });

    this.kLineChart.applyNewData(this.dataPrice);

    ////////////////////////////////////////////////////////////////////////////////emoji
    // this.kLineChart.addTechnicalIndicatorTemplate(emojiTechnicalIndicator);
    // this.paneId = this.kLineChart.createTechnicalIndicator("VOL", false);
    ////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////draw
    this.kLineChart.addShapeTemplate([rect, circle]);
    this.kLineChart.applyNewData(generatedKLineDataList());
    ////////////////////////////////////////////////////////////////////////////////
  },
  methods: {
    getDataPrice: function getDataPrice() {
      this.dataPrice = this.chartData.map(function (item) {
        return {
          timestamp: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.at).valueOf(),
          close: item.close,
          open: item.open,
          low: item.min,
          high: item.max
        };
      });
    },

    // setCandleTechnicalIndicator: function (type) {
    //   this.kLineChart.createTechnicalIndicator(type, false, {
    //     id: "candle_pane",
    //   });
    // },
    // setSubTechnicalIndicator: function (type) {
    //   this.kLineChart.createTechnicalIndicator(type, false, {
    //     id: this.paneId,
    //   });
    // },

    setShapeType: function setShapeType(shapeName) {
      this.kLineChart.createShape(shapeName);
    },
    removeAllShape: function removeAllShape() {
      this.kLineChart.removeShape();
    }
  },
  destroyed: function destroyed() {
    // dispose("technical-indicator-k-line");
    Object(__WEBPACK_IMPORTED_MODULE_0_klinecharts__["dispose"])("draw-shape-k-line");
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Layout',
  props: {
    title: String
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["type", "selectedCurrency"],
  created: function created() {
    this.checkCurrencis();

    this.checkType();
  },

  data: function data() {
    return {
      pairs: [],
      pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
      blue: {},
      fundTails: {}
    };
  },
  methods: {
    toggleModalCurrencies: function toggleModalCurrencies() {
      this.$emit("toggleModalCurrencies");
    },
    checkType: function checkType() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.type);

                if (_this.type == "supply") {
                  _this.getFundTails();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getFundTails: function getFundTails() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, resp;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  offset: 0,
                  limit: 1,
                  entryType: "live"
                };
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$store.dispatch("getFundTails", params);

              case 4:
                resp = _context2.sent;

                _this2.fundTails = resp.data;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                console.log("error ", _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    checkCurrencis: function checkCurrencis() {
      var _this3 = this;

      for (var i in this.currencies) {
        if (this.currencies[i].symbol == "BLU") {
          this.blue = this.currencies[i];
        }
      }

      this.currencies.find(function (el) {
        for (var _i in _this3.pairSymbs) {
          if (el.symbol == _this3.pairSymbs[_i]) {
            _this3.pairs.push(el);
          }
        }
      });

      var fromIndexEther = 3;
      var toIndexEther = 1;

      var elementEther = this.pairs.splice(fromIndexEther, 1)[0];

      this.pairs.splice(toIndexEther, 0, elementEther);
    },
    currencyFormat: function currencyFormat(num, symb) {
      if (num) {
        if (symb == "RAS" || symb == "USDT" || symb == "BRL" || symb == "EUR" || symb == "ZAR" || symb == "GBP") {
          return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        } else {
          return num.toFixed(8);
        }
      } else {
        return 0;
      }
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(["eurValue", "currencies", "bluAccount"]))
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["type", "priceHist"],
  created: function created() {
    this.tableColumns[0].label = this.$t("msg.closing_price");
  },

  data: function data() {
    return {
      prices: [{
        createdAt: "22/07/1994",
        price: 100
      }],
      blue: {},
      fundTails: {},
      tableColumns: [{
        label: "",
        field: "at",
        sortable: true
      }, {
        label: "price",
        field: "max",
        type: "number"
      }]
    };
  },
  methods: {
    toggleModalPriceHist: function toggleModalPriceHist() {
      this.$emit("toggleModal");
    }
  },
  watch: {
    "$i18n.locale": function $i18nLocale() {
      this.tableColumns[0].label = this.$t("msg.closing_price");
    }
  }
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ethereum_coin.svg?7c19954628081bf6fd772fa0d0819547";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_ARB.png?e0e14606f4aab18e3f9aa2e115257fd3";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stellar-xlm-logo.svg?ad29091e7d23481da4685f74853b6ee5";

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_NXS.png?8b36bd6f091fc8ec7384315343af0686";

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "okay.png?016f37e6663c8afbca6d0ab804883d18";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-theta.svg?10898be1127222578099f58973a7a52b";

/***/ }),
/* 463 */,
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(465);
module.exports = __webpack_require__(667);


/***/ }),
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lang_setup_i18n_setup__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_min_css__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_theme_default_css__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_theme_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_filters_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_stratum_utils__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_icons__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_sharedActions__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_the_mask__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_stratum_notify__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_stratum_validation__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_good_table__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chenfengyuan_vue_qrcode__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chenfengyuan_vue_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__chenfengyuan_vue_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_router__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__routes__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_assets_scss_bulma_min_css__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_assets_scss_bulma_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__src_assets_scss_bulma_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_assets_scss_bulma_fixes_scss__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_assets_scss_bulma_fixes_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__src_assets_scss_bulma_fixes_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_assets_scss_summershoe_scss__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_assets_scss_summershoe_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__src_assets_scss_summershoe_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_assets_scss_sheet_scss__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_assets_scss_sheet_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__src_assets_scss_sheet_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_assets_scss_templatepages_scss__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_assets_scss_templatepages_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__src_assets_scss_templatepages_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_sweetalert2_dist_sweetalert2_min_css__);








//............................................................

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2___default.a);
//............................................................

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_clipboard2___default.a);
//............................................................



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__utils_stratum_utils__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__utils_icons__["a" /* default */]);

//............................................................


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__utils_sharedActions__["a" /* default */]);

//............................................................


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_material___default.a);

//............................................................


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_the_mask___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__utils_stratum_notify__["a" /* default */]);
//............................................................

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__utils_stratum_validation__["a" /* default */]);
//............................................................


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_good_table__["a" /* default */]);
//............................................................


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_18__chenfengyuan_vue_qrcode___default.a.name, __WEBPACK_IMPORTED_MODULE_18__chenfengyuan_vue_qrcode___default.a);

//............................................................

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_router__["a" /* default */]);


//.............................................................

// Vue.use(require('vue-moment'));

var router = new __WEBPACK_IMPORTED_MODULE_19_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_20__routes__["a" /* default */],
  mode: 'history',
  base: "/app/"
  //ENABLE BASE TO COMMIT

});

//.................................................................







// ..............................................................

var loadingGif = document.getElementById('load-message-index');
loadingGif.style.display = 'none';

//get the IP addresses associated with an account
// function getIPs(callback){
//   var ip_dups = {};

//   //compatibility for firefox and chrome
//   var RTCPeerConnection = window.RTCPeerConnection
//       || window.mozRTCPeerConnection
//       || window.webkitRTCPeerConnection;
//   var useWebKit = !!window.webkitRTCPeerConnection;

//   //bypass naive webrtc blocking using an iframe
//   if(!RTCPeerConnection){
//       //NOTE: you need to have an iframe in the page right above the script tag
//       //
//       //<iframe id="iframe" sandbox="allow-same-origin" style="display: none"></iframe>
//       //<script>...getIPs called in here...
//       //
//       var win = iframe.contentWindow;
//       RTCPeerConnection = win.RTCPeerConnection
//           || win.mozRTCPeerConnection
//           || win.webkitRTCPeerConnection;
//       useWebKit = !!win.webkitRTCPeerConnection;
//   }

//   //minimal requirements for data connection
//   var mediaConstraints = {
//       optional: [{RtpDataChannels: true}]
//   };

//   var servers = {iceServers: [{urls: "stun:stun.services.mozilla.com"}]};

//   //construct a new RTCPeerConnection
//   var pc = new RTCPeerConnection(servers, mediaConstraints);

//   function handleCandidate(candidate){
//       //match just the IP address
//       var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
//       var ip_addr = ip_regex.exec(candidate)[1];

//       //remove duplicates
//       if(ip_dups[ip_addr] === undefined)
//           callback(ip_addr);

//       ip_dups[ip_addr] = true;
//   }

//   //listen for candidate events
//   pc.onicecandidate = function(ice){

//       //skip non-candidate events
//       if(ice.candidate)
//           handleCandidate(ice.candidate.candidate);
//   };

//   //create a bogus data channel
//   pc.createDataChannel("");

//   //create an offer sdp
//   pc.createOffer(function(result){

//       //trigger the stun server request
//       pc.setLocalDescription(result, function(){}, function(){});

//   }, function(){});

//   //wait for a while to let everything done
//   setTimeout(function(){
//       //read candidate info from local description
//       var lines = pc.localDescription.sdp.split('\n');

//       lines.forEach(function(line){
//           if(line.indexOf('a=candidate:') === 0)
//               handleCandidate(line);
//       });
//   }, 1000);
// }

//Test: Print the IP addresses into the console
// getIPs(function(ip){
//   alert(ip);


//   function resolveRouterGuards(to, from, next) {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       if (!store.getters.authorized) {
//         if (!store.getters.authCookie) {
//           next({ name: "login", replace: true })
//         } else {
//           store.commit("setAuthorized", true)
//           next()
//         }
//       } else {
//         next()
//       }
//     } else {
//       if (store.getters.authCookie) {
//         next({ name: "home", replace: true })
//       }
//       next()
//     }
//   }

//   router.beforeEach((to, from, next) => {
//     resolveRouterGuards(to, from, next)
//   })

//   new Vue({
//     el: '#app',
//     router,
//     store,
//     i18n,
//     render: h => h(App),
//   })


// });


function resolveRouterGuards(to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.authorized) {
      if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.authCookie) {
        next({ name: "login", replace: true });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit("setAuthorized", true);
        next();
      }
    } else {
      next();
    }
  } else {
    if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.authCookie) {
      next({ name: "home", replace: true });
    }
    next();
  }
}

router.beforeEach(function (to, from, next) {
  resolveRouterGuards(to, from, next);
});

// new Vue({
//   el: '#app',
//   router,
//   store,
//   i18n,
//   render: h => h(App),
// })


if (isBlocked) {
  getUserIP(function (ip) {
    console.log("ip: ", ip);
    ip = ip.split(".");
    ip = [ip[0], ip[1], ip[2]].join(".");
    if (ip && ip !== "172.16.16") {
      window.location.href = "https://bluetoken.io/maintenance/";
    } else {

      new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
        el: '#app',
        router: router,
        store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
        i18n: __WEBPACK_IMPORTED_MODULE_3__lang_setup_i18n_setup__["i18n"],
        render: function render(h) {
          return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
        }
      });
    }
  });
} else {

  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: router,
    store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_3__lang_setup_i18n_setup__["i18n"],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
  });
}

function getUserIP(onNewIP) {
  //  onNewIp - your listener function for new IPs
  //compatibility for firefox and chrome
  var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
  var pc = new myPeerConnection({
    iceServers: []
  }),
      noop = function noop() {},
      localIPs = {},
      ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
      key;

  function iterateIP(ip) {
    if (!localIPs[ip]) onNewIP(ip);
    localIPs[ip] = true;
  }

  //create a bogus data channel
  pc.createDataChannel("");

  // create offer and set local description
  pc.createOffer(function (sdp) {
    sdp.sdp.split('\n').forEach(function (line) {
      if (line.indexOf('candidate') < 0) return;
      line.match(ipRegex).forEach(iterateIP);
    });

    pc.setLocalDescription(sdp, noop, noop);
  }, noop);

  //listen for candidate events
  pc.onicecandidate = function (ice) {
    if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
    ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
  };
}

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7eda5b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(692);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7eda5b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("79d7fdc6", content, true, {});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css2?family=Merienda&display=swap);", ""]);

// module
exports.push([module.i, ".warningTemporary{background-color:#3e4969;position:fixed;bottom:10vh;bottom:0;width:100%;text-align:center;color:#fff;font-size:1.2em;padding:12px 0;margin-bottom:0;display:none;animation-name:slowShow;animation-duration:.5s;z-index:99999;padding:25px 10px}.warningTemporary .mainAlertTxtclose{margin:0 10px;background-color:#fff;border-radius:50%;padding:0 6px;color:#1a8f1a;cursor:pointer}.alert_danger{background-color:#d12828!important}.alert_danger .mainAlertTxtclose{color:#d12828}.alert_success{background-color:#3aca1e;background-color:#29d3ae}.alert_success .mainAlertTxtclose{color:#3aca1e;color:#29d3ae}.alert_warning{background-color:#d3bc3c}.alert_warning .mainAlertTxtclose{color:#d3bc3c}.alert_info{background-color:#6d6dd4}.alert_info .mainAlertTxtclose{color:#6d6dd4}.mainAlertShow{display:block}", ""]);

// exports


/***/ }),
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('h1',{staticClass:"warningTemporary",attrs:{"id":"mainAlert"}},[_c('span',{attrs:{"id":"mainAlertTxt"}},[_vm._v("warning")]),_vm._v(" "),_c('span',{staticClass:"mainAlertTxtclose",on:{"click":function($event){return _vm.notifyErrorForceClose()}}},[_vm._v("\n      X\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie__);


/* harmony default export */ __webpack_exports__["a"] = ({
    loading: function loading(state) {
        return state.loading;
    },
    authorized: function authorized(state) {
        return state.authorized;
    },
    languages: function languages(state) {
        return state.languages;
    },
    languageSelected: function languageSelected(state) {
        return state.languageSelected;
    },
    member: function member(state) {
        return state.member;
    },
    accounts: function accounts(state) {
        return state.accounts;
    },
    bluAccount: function bluAccount(state) {
        return state.bluAccount;
    },
    usdtAccount: function usdtAccount(state) {
        return state.usdtAccount;
    },
    btcAccount: function btcAccount(state) {
        return state.btcAccount;
    },
    ethAccount: function ethAccount(state) {
        return state.ethAccount;
    },
    realtAccount: function realtAccount(state) {
        return state.realtAccount;
    },
    joinPool: function joinPool(state) {
        return state.joinPool;
    },
    bluValue: function bluValue(state) {
        return state.bluValue;
    },
    btcValue: function btcValue(state) {
        return state.btcValue;
    },
    ethValue: function ethValue(state) {
        return state.ethValue;
    },
    xemValue: function xemValue(state) {
        return state.xemValue;
    },
    zarValue: function zarValue(state) {
        return state.zarValue;
    },
    eurValue: function eurValue(state) {
        return state.eurValue;
    },
    gbpValue: function gbpValue(state) {
        return state.gbpValue;
    },
    chfValue: function chfValue(state) {
        return state.chfValue;
    },
    cnyValue: function cnyValue(state) {
        return state.cnyValue;
    },
    hkdValue: function hkdValue(state) {
        return state.hkdValue;
    },
    rasValue: function rasValue(state) {
        return state.rasValue;
    },
    cadValue: function cadValue(state) {
        return state.cadValue;
    },
    audValue: function audValue(state) {
        return state.audValue;
    },
    usdtValue: function usdtValue(state) {
        return state.usdtValue;
    },
    accountSelected: function accountSelected(state) {
        return state.accountSelected;
    },
    fees: function fees(state) {
        return state.fees;
    },
    feeRedeem: function feeRedeem(state) {
        return state.feeRedeem;
    },
    feePurchase: function feePurchase(state) {
        return state.feePurchase;
    },
    currencies: function currencies(state) {
        return state.currencies;
    },
    assetList: function assetList(state) {
        return state.assetList;
    },
    fundValueBtc: function fundValueBtc(state) {
        return state.fundValueBtc;
    },
    minimumInvestiment: function minimumInvestiment(state) {
        return state.minimumInvestiment;
    },
    authCookie: function authCookie(state) {
        state.authCookie = __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.get("BLUE");
        return state.authCookie;
    },
    languageCookie: function languageCookie(state) {
        state.languageCookie = __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.get("BLUE-LANG");
        return state.languageCookie;
    }
});

/***/ }),
/* 694 */,
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie__);


/* harmony default export */ __webpack_exports__["a"] = ({
    setLoading: function setLoading(state, payload) {
        state.loading = payload;
    },
    setAuthorized: function setAuthorized(state, payload) {
        state.authorized = payload;
    },
    setAuthCookie: function setAuthCookie(state, payload) {
        __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.set("BLUE", payload, 1);
        state.authCookie = payload;
    },
    deleteAuthCookie: function deleteAuthCookie(state, payload) {
        __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.delete("BLUE");
        state.authCookie = "";
    },
    setLanguageSelected: function setLanguageSelected(state, language) {
        state.languageSelected = language;
        __WEBPACK_IMPORTED_MODULE_0_vue_cookie___default.a.set("BLUE-LANG", language, { expires: '1Y' });
        state.authCookie = language;
    },
    setMember: function setMember(state, payload) {
        state.member = payload;
    },
    setAccounts: function setAccounts(state, payload) {
        state.accounts = payload;
    },
    setAccountSelected: function setAccountSelected(state, payload) {
        state.accountSelected = payload;
    },
    setFees: function setFees(state, payload) {
        state.fees = payload;
    },
    setCurrencies: function setCurrencies(state, payload) {
        state.currencies = payload;
    },
    setBluAccount: function setBluAccount(state, payload) {
        state.bluAccount = payload;
    },
    setUsdtAccount: function setUsdtAccount(state, payload) {
        state.usdtAccount = payload;
    },
    setBtcAccount: function setBtcAccount(state, payload) {
        state.btcAccount = payload;
    },
    setEthAccount: function setEthAccount(state, payload) {
        state.ethAccount = payload;
    },
    setRealtAccount: function setRealtAccount(state, payload) {
        state.realtAccount = payload;
    },
    setJoinPool: function setJoinPool(state, payload) {
        state.joinPool = payload;
    },
    setBluValue: function setBluValue(state, payload) {
        state.bluValue = payload;
    },
    setBtcValue: function setBtcValue(state, payload) {
        state.btcValue = payload;
    },
    setEthValue: function setEthValue(state, payload) {
        state.ethValue = payload;
    },
    setXemValue: function setXemValue(state, payload) {
        state.xemValue = payload;
    },
    setZarValue: function setZarValue(state, payload) {
        state.zarValue = payload;
    },
    setEurValue: function setEurValue(state, payload) {
        state.eurValue = payload;
    },
    setGbpValue: function setGbpValue(state, payload) {
        state.gbpValue = payload;
    },
    setChfValue: function setChfValue(state, payload) {
        state.chfValue = payload;
    },
    setCnyValue: function setCnyValue(state, payload) {
        state.cnyValue = payload;
    },
    setHkdValue: function setHkdValue(state, payload) {
        state.hkdValue = payload;
    },
    setRasValue: function setRasValue(state, payload) {
        state.rasValue = payload;
    },
    setCadValue: function setCadValue(state, payload) {
        state.cadValue = payload;
    },
    setAudValue: function setAudValue(state, payload) {
        state.audValue = payload;
    },
    setFeeRedeem: function setFeeRedeem(state, payload) {
        state.feeRedeem = payload;
    },
    setFeePurchase: function setFeePurchase(state, payload) {
        state.feePurchase = payload;
    },
    setAssetList: function setAssetList(state, payload) {
        state.assetList = payload;
    },
    setFundValueBtc: function setFundValueBtc(state, payload) {
        state.fundValueBtc = payload;
    },

    setUsdtValue: function setUsdtValue(state, payload) {
        state.usdtValue = payload;
    }

});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_setup_i18n_setup__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_stratum_notify__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_global__ = __webpack_require__(75);
var _logout$setLanguageSe;

var publicPostRequest = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee54(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            return _context54.abrupt("return", baseRequest(context, "post", uri, form, false));

          case 1:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54, this);
  }));

  return function publicPostRequest(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var publicGetRequest = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee55(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            return _context55.abrupt("return", baseRequest(context, "get", uri, form, false));

          case 1:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55, this);
  }));

  return function publicGetRequest(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var publicPutRequest = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee56(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            return _context56.abrupt("return", baseRequest(context, "put", uri, form, false));

          case 1:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56, this);
  }));

  return function publicPutRequest(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

var authPostRequest = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee57(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            return _context57.abrupt("return", baseRequest(context, "post", uri, form, true));

          case 1:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57, this);
  }));

  return function authPostRequest(_x10, _x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();

var authPutRequest = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee58(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            return _context58.abrupt("return", baseRequest(context, "put", uri, form, true));

          case 1:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58, this);
  }));

  return function authPutRequest(_x13, _x14, _x15) {
    return _ref5.apply(this, arguments);
  };
}();

var authGetRequest = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee59(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            return _context59.abrupt("return", baseRequest(context, "get", uri, form, true));

          case 1:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59, this);
  }));

  return function authGetRequest(_x16, _x17, _x18) {
    return _ref6.apply(this, arguments);
  };
}();

var authGetRequestOS = function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee60(context, uri, form) {
    return regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            return _context60.abrupt("return", baseRequestOS(context, "get", uri, form, true));

          case 1:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60, this);
  }));

  return function authGetRequestOS(_x19, _x20, _x21) {
    return _ref7.apply(this, arguments);
  };
}();

var baseRequest = function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee61(context, method, uri, form, authenticated) {
    var data, prefix, url, headers, withCredentials, resp;
    return regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            _context61.prev = 0;
            data = {};

            if (form) {
              data = JSON.stringify(form);
            }
            prefix = "";

            if (window.location.origin.includes("www")) {
              prefix = "www.";
            }
            url = void 0;

            if (authenticated) {
              url = __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].protocol + "//" + prefix + __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].backendUrl + "/api/restrict" + uri;
            } else {
              url = __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].protocol + "//" + prefix + __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].backendUrl + "/api/public" + uri;
            }

            headers = {
              "Content-Type": "application/json",
              "Cache-Control": "no-cache",
              "Access-Control-Allow-Origin": "*"
            };
            withCredentials = false;

            if (authenticated) {
              if (!context.getters.authCookie) {
                context.dispatch("logout", this.$t("msg.session_expired"));
              }
              headers = {
                "x-token": context.getters.authCookie,
                "Content-Type": "application/json",
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*"
              };
              withCredentials = true;
            }
            _context61.next = 12;
            return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
              method: method,
              url: url,
              data: data,
              headers: headers,
              withCredentials: withCredentials
            });

          case 12:
            resp = _context61.sent;
            return _context61.abrupt("return", resp);

          case 16:
            _context61.prev = 16;
            _context61.t0 = _context61["catch"](0);

            if (!_context61.t0.response) {
              _context61.next = 24;
              break;
            }

            if (!_context61.t0.response.data) {
              _context61.next = 22;
              break;
            }

            // console.log(error.response.data);
            if (_context61.t0.response.status === 401) {
              //token expired
              context.dispatch("logout", "Session expired. Please log in again");
            }

            throw new Error(_context61.t0.response.data.message);

          case 22:
            _context61.next = 29;
            break;

          case 24:
            if (!_context61.t0.request) {
              _context61.next = 28;
              break;
            }

            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            if (!_context61.t0.status) {
              console.log(_context61.t0);
            }
            // throw new Error(error.request);
            _context61.next = 29;
            break;

          case 28:
            throw new Error(_context61.t0.message);

          case 29:
            throw _context61.t0;

          case 30:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61, this, [[0, 16]]);
  }));

  return function baseRequest(_x22, _x23, _x24, _x25, _x26) {
    return _ref8.apply(this, arguments);
  };
}();

var baseRequestOS = function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee62(context, method, uri, form, authenticated) {
    var data, prefix, url, headers, withCredentials, resp;
    return regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.prev = 0;
            data = JSON.stringify(form);
            prefix = "";

            if (window.location.origin.includes("www")) {
              prefix = "www.";
            }
            // const url = endpoints.protocol + "//" + prefix + endpoints.backendUrl + "/blue" + uri;
            url = void 0;

            if (authenticated) {
              url = __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].protocol + "//" + prefix + __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].backendUrl + "/api/restrict" + uri;
            } else {
              url = __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].protocol + "//" + prefix + __WEBPACK_IMPORTED_MODULE_4__configs_global__["b" /* endpoints */].backendUrl + "/api/public" + uri;
            }
            headers = { "Content-Type": "application/octet-stream" };
            withCredentials = false;

            if (authenticated) {
              if (!context.getters.authCookie) {
                context.dispatch("logout", "Session expired. Please log in again");
              }
              headers = {
                Accept: "application/octet-stream",
                "Content-Type": "application/octet-stream",
                "x-token": context.getters.authCookie
              };
              withCredentials = true;
            }
            _context62.next = 11;
            return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
              method: method,
              url: url,
              data: {},
              headers: headers,
              responseType: "blob",
              withCredentials: withCredentials
            });

          case 11:
            resp = _context62.sent;
            return _context62.abrupt("return", resp);

          case 15:
            _context62.prev = 15;
            _context62.t0 = _context62["catch"](0);

            if (!_context62.t0.response) {
              _context62.next = 23;
              break;
            }

            if (!_context62.t0.response.data) {
              _context62.next = 21;
              break;
            }

            // console.log(error.response.data);
            if (_context62.t0.response.status === 401) {
              //token expired
              context.dispatch("logout", "Session expired. Please log in again");
            }
            throw new Error(_context62.t0.response.data.message);

          case 21:
            _context62.next = 28;
            break;

          case 23:
            if (!_context62.t0.request) {
              _context62.next = 27;
              break;
            }

            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            if (!_context62.t0.status) {
              console.log(_context62.t0);
            }
            // throw new Error(error.request);
            _context62.next = 28;
            break;

          case 27:
            throw new Error(_context62.t0.message);

          case 28:
            throw _context62.t0;

          case 29:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62, this, [[0, 15]]);
  }));

  return function baseRequestOS(_x27, _x28, _x29, _x30, _x31) {
    return _ref9.apply(this, arguments);
  };
}();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__utils_stratum_notify__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post["Content-Type"] = "application/json";
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.put["Content-Type"] = "application/json";

var notifier = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
/* harmony default export */ __webpack_exports__["a"] = (_logout$setLanguageSe = {
  logout: function logout(context, logoutType) {
    context.commit("setAuthorized", false);
    context.commit("deleteAuthCookie");
    notifier.notifyWarning(logoutType, 5000);

    setTimeout(function () {
      window.location.reload();
    }, 2000);
  },
  setLanguageSelected: function setLanguageSelected(context, lang) {
    context.commit("setLanguageSelected", lang);
    Object(__WEBPACK_IMPORTED_MODULE_1__lang_setup_i18n_setup__["loadLanguageAsync"])(lang);
  },
  getAccountSelected: function getAccountSelected(context, coinSymbol) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var accounts, resp, accountSelected;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              accounts = "";
              _context.prev = 1;
              _context.next = 4;
              return context.dispatch("getAccounts");

            case 4:
              resp = _context.sent;

              accounts = resp.data;
              context.commit("setAccounts", accounts);

              console.log('aquiii ó');

              accounts.forEach(function (element) {
                if (element.currency.symbol == "ETH") {
                  context.commit("setEthAccount", element);
                }
                if (element.currency.symbol == "REALT") {
                  context.commit("setRealtAccount", element);
                }
                if (element.currency.symbol == "BTC") {
                  context.commit("setBtcAccount", element);
                }
                if (element.currency.symbol == "BLU") {
                  context.commit("setBluAccount", element);
                }

                // console.log(element)
                if (element.currency.symbol == "USDT") {
                  console.log(element, 'aqq');
                  context.commit("setUsdtAccount", element);
                }
              });

              if (!accounts) {
                _context.next = 14;
                break;
              }

              accountSelected = accounts.find(function (item) {
                return item.currency.symbol === coinSymbol;
              });
              return _context.abrupt("return", accountSelected);

            case 14:
              return _context.abrupt("return", {});

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);
              throw _context.t0;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 17]]);
    }))();
  },
  updateBluAccount: function updateBluAccount(context) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var bluAccount;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return context.dispatch("getAccountSelected", "BLU");

            case 3:
              bluAccount = _context2.sent;

              context.commit("setBluAccount", bluAccount);
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }))();
  },
  updateUsdtAccount: function updateUsdtAccount(context) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var usdtAccount;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return context.dispatch("getAccountSelected", "USDT");

            case 3:
              usdtAccount = _context3.sent;

              context.commit("setUsdtAccount", usdtAccount);
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
              throw _context3.t0;

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[0, 7]]);
    }))();
  },
  getBtcAccount: function getBtcAccount(context) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var btcAccount;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return context.dispatch("getAccountSelected", "BTC");

            case 3:
              btcAccount = _context4.sent;
              return _context4.abrupt("return", btcAccount);

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              throw _context4.t0;

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 7]]);
    }))();
  },
  getFundTails: function getFundTails(context, params) {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return publicGetRequest(context, "/fund?" + "offset=" + params.offset + "&limit=" + params.limit + "&entryType=" + params.entryType);

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
}, _defineProperty(_logout$setLanguageSe, "getFundTails", function getFundTails(context, params) {
  var _this6 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return publicGetRequest(context, "/fund?" + "offset=" + params.offset + "&limit=" + params.limit + "&entryType=" + params.entryType);

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, _this6);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getFundTailsBtc", function getFundTailsBtc(context) {
  var _this7 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    var resp;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return publicGetRequest(context, "/fund?offset=0&limit=10&entryType=live&convert=BTC");

          case 2:
            resp = _context7.sent;

            context.commit("setFundValueBtc", resp.data[0]);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, _this7);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getCertificateByTypeId", function getCertificateByTypeId(context, params) {
  var _this8 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return authGetRequestOS(context, "/purchase/certificate/generate/" + params.type + "/" + params.id);

          case 2:
            return _context8.abrupt("return", _context8.sent);

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, _this8);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getAssetsTail", function getAssetsTail(context, params) {
  var _this9 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", authGetRequest(context, "/assets?" + "offset=" + params.offset + "&limit=" + params.limit + "&entryType=" + params.entryType));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, _this9);
  }))();
}), _defineProperty(_logout$setLanguageSe, "genericMail", function genericMail(context, body) {
  return publicPostRequest(context, "/mail/generic/sent", body);
}), _defineProperty(_logout$setLanguageSe, "postSignup", function postSignup(context, form) {
  return publicPostRequest(context, "/signup", form);
}), _defineProperty(_logout$setLanguageSe, "postSignin", function postSignin(context, form) {
  return publicPostRequest(context, "/signin", form);
}), _defineProperty(_logout$setLanguageSe, "postRecoverUid", function postRecoverUid(context, form) {
  return publicPostRequest(context, "/recover/uid", form);
}), _defineProperty(_logout$setLanguageSe, "postRecoverPassword", function postRecoverPassword(context, form) {
  return publicPostRequest(context, "/recover/password", form);
}), _defineProperty(_logout$setLanguageSe, "postBuyToken", function postBuyToken(context, form) {
  return authPostRequest(context, "/purchase", form);
}), _defineProperty(_logout$setLanguageSe, "postConfirmBuyToken", function postConfirmBuyToken(context, form) {
  return authPutRequest(context, "/purchase/confirm", form);
}), _defineProperty(_logout$setLanguageSe, "postEmail", function postEmail(context, form) {
  return authPostRequest(context, "/messages/mail/send", form);
}), _defineProperty(_logout$setLanguageSe, "postBlueRewardRequest", function postBlueRewardRequest(context, form) {
  return authPostRequest(context, "/reward/request", form);
}), _defineProperty(_logout$setLanguageSe, "postGenericEmail", function postGenericEmail(context, form) {
  return publicPostRequest(context, "/mail/generic/sent", form);
}), _defineProperty(_logout$setLanguageSe, "postRedeemPreview", function postRedeemPreview(context, form) {
  return authPostRequest(context, "/redeem/preview", form);
}), _defineProperty(_logout$setLanguageSe, "postWithdrawPreview", function postWithdrawPreview(context, form) {
  return authPostRequest(context, "/withdraw/preview", form);
}), _defineProperty(_logout$setLanguageSe, "postWithdrawInternal", function postWithdrawInternal(context, form) {
  return authPostRequest(context, "/withdraw/internal", form);
}), _defineProperty(_logout$setLanguageSe, "postWithdrawSmartpay", function postWithdrawSmartpay(context, form) {
  return authPostRequest(context, "/withdraw/smartpay", form);
}), _defineProperty(_logout$setLanguageSe, "postPurchasePreview", function postPurchasePreview(context, form) {
  return authPostRequest(context, "/purchase/preview", form);
}), _defineProperty(_logout$setLanguageSe, "postRedeem", function postRedeem(context, form) {
  return authPostRequest(context, "/redeem", form);
}), _defineProperty(_logout$setLanguageSe, "postWithdraw", function postWithdraw(context, form) {
  return authPostRequest(context, "/withdraw", form);
}), _defineProperty(_logout$setLanguageSe, "putRedeemConfirm", function putRedeemConfirm(context, form) {
  return authPutRequest(context, "/redeem/confirm", form);
}), _defineProperty(_logout$setLanguageSe, "putWithdrawConfirm", function putWithdrawConfirm(context, form) {
  return authPutRequest(context, "/withdraw/confirm", form);
}), _defineProperty(_logout$setLanguageSe, "postTrade", function postTrade(context, form) {
  var _this10 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return authPostRequest(context, "/purchase", form);

          case 2:
            return _context10.abrupt("return", _context10.sent);

          case 3:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, _this10);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getTrade", function getTrade(context) {
  var _this11 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return authGetRequest(context, "/trade/tracking/purchase");

          case 2:
            return _context11.abrupt("return", _context11.sent);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, _this11);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getTradeSearchByTradeId", function getTradeSearchByTradeId(context, trade_id) {
  var _this12 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return authGetRequest(context, "/trade/trackings/seller/search?limit=1&offset=0&trade_id=" + trade_id);

          case 2:
            return _context12.abrupt("return", _context12.sent);

          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, _this12);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getAccountsVersions", function getAccountsVersions(context) {
  var _this13 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return authGetRequest(context, "/accounts/versions/me");

          case 2:
            return _context13.abrupt("return", _context13.sent);

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, _this13);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getTradeType", function getTradeType(context, type) {
  var _this14 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
    return regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return authGetRequest(context, "/trade/tracking/" + type);

          case 2:
            return _context14.abrupt("return", _context14.sent);

          case 3:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, _this14);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getRewards", function getRewards(context) {
  var _this15 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
    return regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return authGetRequest(context, "/rewards");

          case 2:
            return _context15.abrupt("return", _context15.sent);

          case 3:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, _this15);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getPurchases", function getPurchases(context) {
  var _this16 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
    return regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return authGetRequest(context, "/purchases");

          case 2:
            return _context16.abrupt("return", _context16.sent);

          case 3:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, _this16);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getActivePool", function getActivePool(context) {
  var _this17 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
    return regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return publicGetRequest(context, "/pools");

          case 2:
            return _context17.abrupt("return", _context17.sent);

          case 3:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, _this17);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getPoolsSumarry", function getPoolsSumarry(context) {
  var _this18 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return publicGetRequest(context, "/pools/summary");

          case 2:
            return _context18.abrupt("return", _context18.sent);

          case 3:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, _this18);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postPurchasePixGenerate", function postPurchasePixGenerate(context, body) {
  var _this19 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
    return regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return authPostRequest(context, "/purchase/pix/generate", body);

          case 2:
            return _context19.abrupt("return", _context19.sent);

          case 3:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, _this19);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postPurchaseCurrencyBalance", function postPurchaseCurrencyBalance(context, body) {
  var _this20 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return authPostRequest(context, "/purchase/cripto/balance", body);

          case 2:
            return _context20.abrupt("return", _context20.sent);

          case 3:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, _this20);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getPoolsSummaryByDate", function getPoolsSummaryByDate(context, params) {
  var _this21 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return publicGetRequest(context, "/pools/summary?startDate=" + params.startAt + "&endDate=" + params.endAt);

          case 2:
            return _context21.abrupt("return", _context21.sent);

          case 3:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, _this21);
  }))();
}), _defineProperty(_logout$setLanguageSe, "joinPool", function joinPool(context) {
  var _this22 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
    return regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", context.commit("setJoinPool", true));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, _this22);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getPoolUser", function getPoolUser(context) {
  var _this23 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return authGetRequest(context, "/pools/me");

          case 2:
            return _context23.abrupt("return", _context23.sent);

          case 3:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, _this23);
  }))();
}), _defineProperty(_logout$setLanguageSe, "addMemberToPool", function addMemberToPool(context, params) {
  var _this24 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
    return regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return authPostRequest(context, "/pools/member", params);

          case 2:
            return _context24.abrupt("return", _context24.sent);

          case 3:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, _this24);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postSellerPurchase", function postSellerPurchase(context, body) {
  var _this25 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
    return regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return authPostRequest(context, "/seller/purchase", body);

          case 2:
            return _context25.abrupt("return", _context25.sent);

          case 3:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, _this25);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getMemberByUID", function getMemberByUID(context, uid) {
  var _this26 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
    return regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", authGetRequest(context, "/members/search?uid=" + uid));

          case 1:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, _this26);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putPurchaseCancel", function putPurchaseCancel(context, purchaseID) {
  var _this27 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
    return regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.next = 2;
            return authPutRequest(context, "/purchase/cancel/" + purchaseID);

          case 2:
            return _context27.abrupt("return", _context27.sent);

          case 3:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27, _this27);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putChangeInfo", function putChangeInfo(context, body) {
  var _this28 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
    return regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            _context28.next = 2;
            return authPutRequest(context, "/change/info/confirm", body);

          case 2:
            return _context28.abrupt("return", _context28.sent);

          case 3:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, _this28);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putChangePassword", function putChangePassword(context, body) {
  var _this29 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
    return regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return authPutRequest(context, "/change/password/confirm", body);

          case 2:
            return _context29.abrupt("return", _context29.sent);

          case 3:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, _this29);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putChangeNotifyOn", function putChangeNotifyOn(context) {
  var _this30 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
    return regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return authPutRequest(context, "/members/notify/on");

          case 2:
            return _context30.abrupt("return", _context30.sent);

          case 3:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, _this30);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putChangeNotifyOff", function putChangeNotifyOff(context) {
  var _this31 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
    return regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return authPutRequest(context, "/members/notify/off");

          case 2:
            return _context31.abrupt("return", _context31.sent);

          case 3:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31, _this31);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getDeposits", function getDeposits(context) {
  var _this32 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
    return regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return authGetRequest(context, "/deposits");

          case 2:
            return _context32.abrupt("return", _context32.sent);

          case 3:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32, _this32);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getWithdraws", function getWithdraws(context) {
  var _this33 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
    return regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return authGetRequest(context, "/withdraws");

          case 2:
            return _context33.abrupt("return", _context33.sent);

          case 3:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, _this33);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getRedeems", function getRedeems(context) {
  var _this34 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
    return regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return authGetRequest(context, "/redeems");

          case 2:
            return _context34.abrupt("return", _context34.sent);

          case 3:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, _this34);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getNotificationList", function getNotificationList(context) {
  var _this35 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35() {
    return regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            _context35.next = 2;
            return authGetRequest(context, "/notification/list");

          case 2:
            return _context35.abrupt("return", _context35.sent);

          case 3:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, _this35);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getNotificationAnswers", function getNotificationAnswers(context) {
  var _this36 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36() {
    return regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.next = 2;
            return authGetRequest(context, "/notification/answers");

          case 2:
            return _context36.abrupt("return", _context36.sent);

          case 3:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, _this36);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postNotificationConfirm", function postNotificationConfirm(context, id) {
  var _this37 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37() {
    return regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.next = 2;
            return authPostRequest(context, "/notification/confirm", id);

          case 2:
            return _context37.abrupt("return", _context37.sent);

          case 3:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37, _this37);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getRedeemInfo", function getRedeemInfo(context) {
  var _this38 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee38() {
    return regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            _context38.next = 2;
            return publicGetRequest(context, "/redeems/info");

          case 2:
            return _context38.abrupt("return", _context38.sent);

          case 3:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38, _this38);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putAcceptTerms", function putAcceptTerms(context) {
  var _this39 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee39() {
    return regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            _context39.next = 2;
            return authPutRequest(context, "/accept/terms");

          case 2:
            return _context39.abrupt("return", _context39.sent);

          case 3:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39, _this39);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putAcceptPrivacy", function putAcceptPrivacy(context) {
  var _this40 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee40() {
    return regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            _context40.next = 2;
            return authPutRequest(context, "/accept/privacy");

          case 2:
            return _context40.abrupt("return", _context40.sent);

          case 3:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40, _this40);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putRedeem", function putRedeem(context, id) {
  return authPutRequest(context, "/redeem/cancel/" + id);
}), _defineProperty(_logout$setLanguageSe, "getPurchaseById", function getPurchaseById(context, purchaseID) {
  return authGetRequest(context, "/purchase/" + purchaseID);
}), _defineProperty(_logout$setLanguageSe, "getMaintenanceStatus", function getMaintenanceStatus(context) {
  var _this41 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee41() {
    var maintenance;
    return regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.next = 2;
            return publicGetRequest(context, "/fund/maintenance");

          case 2:
            maintenance = _context41.sent;
            return _context41.abrupt("return", maintenance.data);

          case 4:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41, _this41);
  }))();
}), _defineProperty(_logout$setLanguageSe, "putRecoverPasswordConfirm", function putRecoverPasswordConfirm(context, form) {
  return publicPutRequest(context, "/recover/password/confirm", form);
}), _defineProperty(_logout$setLanguageSe, "putActivateMember", function putActivateMember(context, activationCode) {
  return publicPutRequest(context, "/members/activate/" + activationCode);
}), _defineProperty(_logout$setLanguageSe, "putChangePasswordConfirm", function putChangePasswordConfirm(context, form) {
  return authPutRequest(context, "/change/password/confirm", form);
}), _defineProperty(_logout$setLanguageSe, "putCancelPurchase", function putCancelPurchase(context, id) {
  return authPutRequest(context, "/purchase/cancel/" + id);
}), _defineProperty(_logout$setLanguageSe, "getMember", function getMember(context) {
  var _this42 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee42() {
    var resp;
    return regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.prev = 0;
            _context42.next = 3;
            return authGetRequest(context, "/me");

          case 3:
            resp = _context42.sent;

            context.commit("setMember", resp.data);
            return _context42.abrupt("return", resp.data);

          case 8:
            _context42.prev = 8;
            _context42.t0 = _context42["catch"](0);
            throw _context42.t0;

          case 11:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42, _this42, [[0, 8]]);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getWithdrawById", function getWithdrawById(context, id) {
  return authGetRequest(context, "/withdraw/" + id);
}), _defineProperty(_logout$setLanguageSe, "getMemberSimple", function getMemberSimple(context) {
  return authGetRequest(context, "/me");
}), _defineProperty(_logout$setLanguageSe, "getOtpCode", function getOtpCode(context) {
  return authGetRequest(context, "/otp/code");
}), _defineProperty(_logout$setLanguageSe, "getOtpStatus", function getOtpStatus(context) {
  return authGetRequest(context, "/otp/status");
}), _defineProperty(_logout$setLanguageSe, "getPinGenerate", function getPinGenerate(context, address) {
  var _this43 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee43() {
    return regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            return _context43.abrupt("return", authGetRequest(context, "/pin/generate/" + address));

          case 1:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43, _this43);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postCreateAddress", function postCreateAddress(context) {
  var _this44 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee44() {
    return regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.next = 2;
            return authPostRequest(context, "/accounts/create/address");

          case 2:
            return _context44.abrupt("return", _context44.sent);

          case 3:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44, _this44);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postCreateWallet", function postCreateWallet(context) {
  var _this45 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee45() {
    return regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return authPostRequest(context, "/accounts/create/wallet");

          case 2:
            return _context45.abrupt("return", _context45.sent);

          case 3:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45, _this45);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getOtpImage", function getOtpImage(context) {
  var _this46 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee46() {
    return regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.next = 2;
            return authGetRequestOS(context, "/otp/image");

          case 2:
            return _context46.abrupt("return", _context46.sent);

          case 3:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46, _this46);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postOptConfirm", function postOptConfirm(context, params) {
  return authPostRequest(context, "/otp/confirm", params);
}), _defineProperty(_logout$setLanguageSe, "postPinGenerate", function postPinGenerate(context, params) {
  return authPostRequest(context, "/otp/validation", params);
}), _defineProperty(_logout$setLanguageSe, "getAccounts", function getAccounts(context) {
  return authGetRequest(context, "/accounts");
}), _defineProperty(_logout$setLanguageSe, "getRewardCheck", function getRewardCheck(context) {
  var _this47 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee47() {
    return regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            return _context47.abrupt("return", authGetRequest(context, "/reward/check"));

          case 1:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, _this47);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getFees", function getFees(context) {
  var _this48 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee48() {
    return regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            _context48.next = 2;
            return publicGetRequest(context, "/taxes");

          case 2:
            return _context48.abrupt("return", _context48.sent);

          case 3:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48, _this48);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getFeesFilter", function getFeesFilter(context) {
  var _this49 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee49() {
    var resp, redeemFee, redeemPurchase, feePurchase, feeRedeem;
    return regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            _context49.prev = 0;
            _context49.next = 3;
            return publicGetRequest(context, "/taxes");

          case 3:
            resp = _context49.sent;
            redeemFee = resp.data.filter(function (fee) {
              if (fee.createdAt) {
                return fee.type == "redeem";
              }
            });
            redeemPurchase = resp.data.filter(function (fee) {
              if (fee.createdAt) {
                return fee.type == "purchase";
              }
            });


            redeemFee.sort(function (a, b) {
              if (a.startAt > b.startAt) return 1;
              if (a.startAt < b.startAt) return -1;
              return 0;
            });

            redeemPurchase.sort(function (a, b) {
              if (a.startAt > b.startAt) return 1;
              if (a.startAt < b.startAt) return -1;
              return 0;
            });

            feePurchase = redeemPurchase[redeemPurchase.length - 1];
            feeRedeem = redeemFee[redeemFee.length - 1];


            if (!context.getters.feeRedeem) {
              context.commit("setFeeRedeem", feeRedeem);
            }

            if (!context.getters.feePurchase) {
              context.commit("setFeePurchase", feePurchase);
            }
            _context49.next = 17;
            break;

          case 14:
            _context49.prev = 14;
            _context49.t0 = _context49["catch"](0);

            console.log("could not load fees: ", _context49.t0);

          case 17:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49, _this49, [[0, 14]]);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getTransactions", function getTransactions(context) {
  return authGetRequest(context, "/transactions");
}), _defineProperty(_logout$setLanguageSe, "getTransactionsByType", function getTransactionsByType(context, transactionType) {
  return authGetRequest(context, "/transactions/search?type=" + transactionType);
}), _defineProperty(_logout$setLanguageSe, "getPricePercentChange", function getPricePercentChange(context, params) {
  var _this50 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee50() {
    return regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            return _context50.abrupt("return", publicGetRequest(context, "/currencies/price/percent_changes?pair=" + params.pair + "&symbols=" + params.symbols));

          case 1:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50, _this50);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getCurrencyByPair", function getCurrencyByPair(context, pair) {
  var _this51 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee51() {
    return regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            return _context51.abrupt("return", publicGetRequest(context, "/currencies?pair=" + pair));

          case 1:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51, _this51);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getCurrencies", function getCurrencies(context) {
  if (!context.getters.currencies) {
    context.dispatch("updateCurrencies");
    setInterval(function () {
      context.dispatch("updateCurrencies");
      // }, 5 * 60 * 1000)
    }, 80000);
  }
}), _defineProperty(_logout$setLanguageSe, "updateCurrencies", function updateCurrencies(context) {
  var _this52 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee52() {
    var resp, btc, blu, eth, zar, eur, gbp, chf, cny, hkd, xem, ras, cad, aud, usdt;
    return regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            _context52.prev = 0;
            _context52.next = 3;
            return publicGetRequest(context, "/currencies");

          case 3:
            resp = _context52.sent;
            btc = resp.data.filter(function (currency) {
              return currency.symbol == "BTC";
            });
            blu = resp.data.filter(function (currency) {
              return currency.symbol == "BLU";
            });
            eth = resp.data.filter(function (currency) {
              return currency.symbol == "ETH";
            });
            zar = resp.data.filter(function (currency) {
              return currency.symbol == "ZAR";
            });
            eur = resp.data.filter(function (currency) {
              return currency.symbol == "EUR";
            });
            gbp = resp.data.filter(function (currency) {
              return currency.symbol == "GBP";
            });
            chf = resp.data.filter(function (currency) {
              return currency.symbol == "CHF";
            });
            cny = resp.data.filter(function (currency) {
              return currency.symbol == "CNY";
            });
            hkd = resp.data.filter(function (currency) {
              return currency.symbol == "HKD";
            });
            xem = resp.data.filter(function (currency) {
              return currency.symbol == "XEM";
            });
            ras = resp.data.filter(function (currency) {
              return currency.symbol == "RAS";
            });
            cad = resp.data.filter(function (currency) {
              return currency.symbol == "CAD";
            });
            aud = resp.data.filter(function (currency) {
              return currency.symbol == "AUD";
            });
            usdt = resp.data.filter(function (currency) {
              return currency.symbol == "USDT";
            });


            context.commit("setBluValue", blu);
            context.commit("setBtcValue", btc);
            context.commit("setEthValue", eth);
            context.commit("setXemValue", xem);
            context.commit("setZarValue", zar);
            context.commit("setEurValue", eur);
            context.commit("setGbpValue", gbp);
            context.commit("setChfValue", chf);
            context.commit("setCnyValue", cny);

            context.commit("setRasValue", ras);
            context.commit("setCadValue", cad);
            context.commit("setAudValue", aud);

            context.commit("setHkdValue", hkd);
            context.commit("setUsdtValue", usdt);

            context.commit("setCurrencies", resp.data);
            _context52.next = 38;
            break;

          case 35:
            _context52.prev = 35;
            _context52.t0 = _context52["catch"](0);
            throw _context52.t0;

          case 38:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52, _this52, [[0, 35]]);
  }))();
}), _defineProperty(_logout$setLanguageSe, "getSurveyPrototype", function getSurveyPrototype(context) {
  return authGetRequest(context, "/survey/prototype");
}), _defineProperty(_logout$setLanguageSe, "getSurveyPrototypes", function getSurveyPrototypes(context) {
  var _this53 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee53() {
    return regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _context53.next = 2;
            return publicGetRequest(context, "/survey/prototypes");

          case 2:
            return _context53.abrupt("return", _context53.sent);

          case 3:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53, _this53);
  }))();
}), _defineProperty(_logout$setLanguageSe, "postSurveyPrototype", function postSurveyPrototype(context, params) {
  return authPostRequest(context, "/survey/prototype", params);
}), _defineProperty(_logout$setLanguageSe, "getDepositById", function getDepositById(context, depositID) {
  return authGetRequest(context, "/deposit/" + depositID);
}), _defineProperty(_logout$setLanguageSe, "getRewardById", function getRewardById(context, rewardID) {
  return authGetRequest(context, "/rewards/" + rewardID);
}), _defineProperty(_logout$setLanguageSe, "getBonusById", function getBonusById(context, bonusID) {
  return authGetRequest(context, "/bonus/" + bonusID);
}), _defineProperty(_logout$setLanguageSe, "getBalances", function getBalances(context) {}), _defineProperty(_logout$setLanguageSe, "getRecentTransactions", function getRecentTransactions(context) {}), _defineProperty(_logout$setLanguageSe, "getReferrals", function getReferrals(context) {
  return authGetRequest(context, "/transactions/search?type=rewards");
}), _defineProperty(_logout$setLanguageSe, "getTransactionDataById", function getTransactionDataById(context, transaction) {
  return authGetRequest(context, "/" + transaction.type + "/" + transaction.id);
}), _defineProperty(_logout$setLanguageSe, "getCurrenciesHistory", function getCurrenciesHistory(context, params) {
  return publicGetRequest(context, "/currencies/history?start=" + params.start + "&end=" + params.end + "&pair=" + params.pair + "&period=" + params.period + "&symbols=" + params.sumbols);
}), _defineProperty(_logout$setLanguageSe, "postBankSlip", function postBankSlip(context, params) {
  return authPostRequest(context, "/bankslip", params);
}), _logout$setLanguageSe);

/***/ }),
/* 697 */,
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en": [
		127
	],
	"./en-old": [
		463,
		0
	],
	"./en-old.js": [
		463,
		0
	],
	"./en.js": [
		127
	],
	"./es": [
		128
	],
	"./es.js": [
		128
	],
	"./languages": [
		126
	],
	"./languages.js": [
		126
	],
	"./pt": [
		129
	],
	"./pt.js": [
		129
	],
	"./setup/i18n-setup": [
		74
	],
	"./setup/i18n-setup.js": [
		74
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 698;
module.exports = webpackAsyncContext;

/***/ }),
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_spacetime__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('upper', function (value) {
    if (typeof value === 'string') {
        return value.toUpperCase();
    } else {
        return value;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('lower', function (value) {
    if (typeof value === 'string') {
        return value.toLowerCase();
    } else {
        return value;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('capitalize', function (value) {
    if (typeof value === 'string') {
        return value.replace(/\b\w/g, function (l) {
            return l.toUpperCase();
        });
    } else {
        return value;
    }
});

function getNumberOfDecimals(value) {
    value = value.toString();
    if (value.indexOf('.') !== -1) {
        return value.split('.')[1].length;
    } else {
        return 0;
    }
}

function decimalsCrypto(value, decimals) {
    var numberValue = parseFloat(value);
    if (decimals) {
        return parseFloat(numberValue.toFixed(decimals));
    } else {
        if (getNumberOfDecimals(value) < 2) {
            return numberValue.toFixed(2);
        } else {
            return numberValue;
        }
    }
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('decimalsCrypto', function (value, decimals) {
    return decimalsCrypto(value, decimals);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('setDecimalsByCrypto', function (value, coin) {
    if (crypto && crypto.decimals) {
        return decimalsCrypto(value, crypto.decimals);
    } else {
        return decimalsCrypto(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toDate', function (value) {
    // from UNIX
    value = parseInt(value) * 1000;
    return __WEBPACK_IMPORTED_MODULE_1_spacetime___default()(value).format('dd.MM.yyyy');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('toDateTime', function (value) {
    // from UNIX
    value = parseInt(value) * 1000;
    return __WEBPACK_IMPORTED_MODULE_1_spacetime___default()(value).format('dd.MM.yyyy hh:mm');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDateTime', function (value) {
    return __WEBPACK_IMPORTED_MODULE_1_spacetime___default()(value).format('dd.MM.yyyy hh:mm:SS');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('decimals', function (value, decimals) {
    decimals = decimals || 2;
    var n = value ? parseFloat(value).toFixed(decimals) : value;
    return Number(n).toLocaleString("pt", { minimumFractionDigits: decimals });
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('dynamicDecimals', function (value, isNextFiat) {
    if (!isNextFiat) {
        return value ? parseFloat(value).toFixed(8) : value;
    } else {
        var n = value ? parseFloat(value).toFixed(2) : value;
        return Number(n).toLocaleString("pt", { minimumFractionDigits: 2 });
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('percentage', function (value, decimals) {
    if (value) {
        decimals = decimals || 2;
        var formattedValue = parseFloat(value).toFixed(decimals);
        return formattedValue + "%";
    } else {
        return '-';
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('fixAddressWidth', function (address) {
    var maxNumberOfAddressChars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 26;

    return address.length > maxNumberOfAddressChars ? address.substring(0, maxNumberOfAddressChars) : address;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('json', function (value) {
    return JSON.stringify(value, null, 2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('testeFunc', function (value) {
    console.log('testeeeeeee');
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spacetime__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.mixin({
            data: function data() {
                return {};
            },
            methods: {
                isPromise: function isPromise(obj) {
                    return !!obj && ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
                },
                logError: function logError(e) {
                    var failure = ['background: red', 'color: white', 'display: block', 'text-align: center'].join(';');

                    if (Array.isArray(e)) {
                        e.forEach(function (item) {
                            console.log('%c ' + item.key + ' - ' + item.message, failure);
                        });
                    } else {
                        console.log('%c ' + e.message, failure);
                    }
                },
                fixTimeZone: function fixTimeZone(dateUtc) {
                    var localDate = new Date();
                    var localDateTimezone = __WEBPACK_IMPORTED_MODULE_0_spacetime___default()(localDate).timezone().name;
                    var s = __WEBPACK_IMPORTED_MODULE_0_spacetime___default()(dateUtc);
                    if (s.year() < 1000) {
                        return "-";
                    }
                    return s.goto(localDateTimezone).format("dd.MM.yyyy HH:mm:SS");
                },
                fixTimeTest: function fixTimeTest(el) {
                    return __WEBPACK_IMPORTED_MODULE_0_spacetime___default()(el).format('dd/MM/yyyy | HH:mm:SS');
                }
            }
        });
    }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_set1__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_set2__ = __webpack_require__(710);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//cd003 plugins/icons step2



/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.mixin({
            data: function data() {
                return {
                    iconSets: _extends({}, __WEBPACK_IMPORTED_MODULE_0__svg_set1__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__svg_set2__["a" /* default */])

                };
            }
        });
    }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _sample$auth_roadmap$;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//cd003 plugins/icons step1

//icon_s1_1 = icon sample 1

/* harmony default export */ __webpack_exports__["a"] = (_sample$auth_roadmap$ = {

    sample: '<svg viewBox="0 0 576 512">\n                <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/></svg>',

    auth_roadmap: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="600px" viewBox="0 0 100 600" enable-background="new 0 0 100 600" xml:space="preserve">\n    <circle class="c1"   stroke-width="2" stroke-miterlimit="10" cx="76.176" cy="32.414" r="18.274"/>\n    <line fill="none"  stroke-width="2" stroke-miterlimit="10" x1="71.452" y1="50.688" x2="27.798" y2="192.411"/>\n    <circle class="c2"  stroke-width="2" stroke-miterlimit="10" cx="23.747" cy="210.686" r="18.274"/>\n    <circle class="c3"   stroke-width="2" stroke-miterlimit="10" cx="74.304" cy="388.956" r="18.273"/>\n    <line fill="none" stroke-width="2" stroke-miterlimit="10" x1="69.58" y1="370.683" x2="25.925" y2="228.959"/>\n    <circle class="c4"  stroke-width="2" stroke-miterlimit="10" cx="24.421" cy="567.144" r="18.274"/>\n    <line fill="none" stroke-width="2" stroke-miterlimit="10" x1="29.144" y1="548.869" x2="72.798" y2="407.145"/>\n    </svg>',
    roadmap_horizontal: '<svg version="1.1" id="Layer_1" x="0px" y="0px" width="600px" height="110px" viewBox="0 0 600 110" enable-background="new 0 0 600 110" xml:space="preserve">\n    <circle class="c1"  stroke-miterlimit="10" cx="27.464" cy="83.898" r="21.074"/>\n    <line fill="none"  stroke-miterlimit="10" x1="47.005" y1="76.009" x2="188.021" y2="36.57"/>\n    <circle class="c2"  stroke-miterlimit="10" cx="207.758" cy="36.273" r="21.074"/>\n    <line fill="none"  stroke-miterlimit="10" x1="228.658" y1="36.905" x2="368.375" y2="80.724"/>\n    <circle class="c3"  stroke-miterlimit="10" cx="388.901" cy="77.291" r="21.074"/>\n    <line fill="none"  stroke-miterlimit="10" x1="409.781" y1="72.08" x2="550.799" y2="32.64"/>\n    <circle class="c4"  stroke-miterlimit="10" cx="570.534" cy="27.126" r="21.074"/>\n    </svg>',
    roadmap_tall: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="595.28px" viewBox="0 0 100 595.28" enable-background="new 0 0 100 595.28" xml:space="preserve">\n    <path class="c1"  stroke-miterlimit="10" d="M92.227,28.506c0,10.449-8.469,18.919-18.92,18.919  c-10.445,0-18.917-8.47-18.917-18.919c0-10.448,8.472-18.918,18.917-18.918C83.758,9.588,92.227,18.058,92.227,28.506z"/>\n    <line  stroke-miterlimit="10" x1="68.267" y1="45.745" x2="31.587" y2="187.644"/>\n    <circle class="c2"  stroke-miterlimit="10" cx="26.023" cy="204.904" r="18.919"/>\n    <line stroke-miterlimit="10" x1="66.642" y1="365.72" x2="29.963" y2="223.823"/>\n    <circle class="c3"  stroke-miterlimit="10" cx="68.323" cy="384.639" r="18.919"/>\n    <line  stroke-miterlimit="10" x1="68.267" y1="403.556" x2="31.587" y2="545.452"/>\n    <circle class="c4"  stroke-miterlimit="10" cx="27.703" cy="562.713" r="18.918"/>\n    </svg>',
    roadmap_taller: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="70px" height="595.28px" viewBox="0 0 70 595.28" enable-background="new 0 0 70 595.28" xml:space="preserve">\n    <circle class="c1"  stroke-miterlimit="10" cx="45.241" cy="28.303" r="14.79"/>\n    <line  stroke-miterlimit="10" x1="45.241" y1="43.094" x2="23.352" y2="194.542"/>\n    <circle class="c2"  stroke-miterlimit="10" cx="23.352" cy="209.332" r="14.79"/>\n    <line stroke-miterlimit="10" x1="47.301" y1="375.57" x2="25.41" y2="224.122"/>\n    <circle class="c3"  stroke-miterlimit="10" cx="47.3" cy="390.36" r="14.79"/>\n    <line  stroke-miterlimit="10" x1="47.323" y1="405.152" x2="25.433" y2="556.601"/>\n    <circle class="c4"  stroke-miterlimit="10" cx="25.433" cy="571.389" r="14.79"/>\n    </svg>',
    general_menu: '<svg aria-hidden="true" data-prefix="fas" data-icon="bars" role="img"  viewBox="0 0 448 512" class="svg-inline--fa fa-bars fa-w-14 fa-3x"><path fill="currentColor" d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" class=""></path></svg>',
    general_close_2: '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>',
    general_close: '<svg aria-hidden="true" data-prefix="fas" data-icon="times-circle" role="img"  viewBox="0 0 512 512" class="svg-inline--fa fa-times-circle fa-w-16 fa-3x"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" class=""></path></svg>',
    general_arrow_down: '<svg aria-hidden="true" data-prefix="fas" data-icon="angle-down" role="img" viewBox="0 0 320 512" class="svg-inline--fa fa-angle-down fa-w-10 fa-3x"><path fill="#989898" d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" class=""></path></svg>',
    general_arrow_switch: '<svg aria-hidden="true" data-prefix="fas" data-icon="arrows-alt-v" role="img"  viewBox="0 0 256 512" class="svg-inline--fa fa-arrows-alt-v fa-w-8 fa-3x"><path fill="currentColor" d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z" class=""></path></svg>',
    general_arrow_left: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-left fa-w-10 fa-2x"><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" class=""></path></svg>',
    general_arrow_right: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10 fa-2x"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg>',
    general_history: '<svg aria-hidden="true" data-prefix="fas" data-icon="history" role="img"  viewBox="0 0 512 512" class="svg-inline--fa fa-history fa-w-16 fa-3x"><path fill="currentColor" d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z" class=""></path></svg>',
    general_wallet: '<svg aria-hidden="true" data-prefix="fas" data-icon="wallet" role="img"  viewBox="0 0 512 512" class="svg-inline--fa fa-wallet fa-w-16 fa-3x"><path fill="currentColor" d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z" class=""></path></svg>',
    general_wallet_white: '<svg aria-hidden="true" data-prefix="fas" data-icon="wallet" role="img"  viewBox="0 0 512 512" class="svg-inline--fa fa-wallet fa-w-16 fa-3x"><path fill="white" d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z" class=""></path></svg>',
    general_gear: '<svg aria-hidden="true" data-prefix="fas" data-icon="cogs" role="img"  viewBox="0 0 640 512" class="svg-inline--fa fa-cogs fa-w-20 fa-3x"><path fill="currentColor" d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z" class=""></path></svg>',
    general_lock: '<svg aria-hidden="true" data-prefix="fas" data-icon="lock" role="img"  viewBox="0 0 448 512" class="svg-inline--fa fa-lock fa-w-14 fa-3x"><path fill="currentColor" d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z" class=""></path></svg>',
    general_peers: '<svg aria-hidden="true" data-prefix="fas" data-icon="users" role="img"  viewBox="0 0 640 512" class="svg-inline--fa fa-users fa-w-20 fa-3x"><path fill="currentColor" d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z" class=""></path></svg>',
    shield_false: '<?xml version="1.0" encoding="iso-8859-1"?><!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 317.855 317.855" style="enable-background:new 0 0 317.855 317.855;" xml:space="preserve" fill="red"><g><path d="M158.929,317.855c-1.029,0-2.059-0.159-3.051-0.477c-33.344-10.681-61.732-31.168-84.377-60.891c-17.828-23.401-32.103-52.526-42.426-86.566C11.661,112.506,11.461,61.358,11.461,59.209c0-5.15,3.912-9.459,9.039-9.954c0.772-0.075,78.438-8.048,132.553-47.347c3.504-2.546,8.249-2.543,11.753,0.001C218.906,41.207,296.582,49.18,297.36,49.256c5.123,0.5,9.034,4.807,9.034,9.953c0,2.149-0.2,53.297-17.613,110.713c-10.324,34.04-24.598,63.165-42.426,86.566c-22.644,29.723-51.032,50.21-84.376,60.891C160.987,317.696,159.958,317.855,158.929,317.855z M31.748,67.982c0.831,16.784,4.062,55.438,16.604,96.591c21.405,70.227,58.601,114.87,110.576,132.746c52.096-17.916,89.335-62.711,110.713-133.202c12.457-41.074,15.653-79.434,16.472-96.134c-22.404-3.269-80.438-14.332-127.186-45.785C112.175,53.648,54.153,64.713,31.748,67.982z"/><g><path d="M192.732,202.035c-2.56,0-5.118-0.977-7.071-2.929l-67.607-67.609c-3.905-3.905-3.905-10.237,0-14.143c3.907-3.904,10.237-3.903,14.143,0l67.607,67.609c3.905,3.905,3.905,10.237,0,14.143C197.851,201.059,195.291,202.035,192.732,202.035z"/><path d="M125.123,202.035c-2.56,0-5.118-0.977-7.071-2.929c-3.905-3.905-3.905-10.237,0-14.143l67.607-67.609c3.906-3.904,10.236-3.904,14.143,0c3.905,3.905,3.905,10.237,0,14.143l-67.607,67.609C130.241,201.059,127.683,202.035,125.123,202.035z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>\n    ',
    shield_true: '<?xml version="1.0" encoding="iso-8859-1"?>\n    <!-- Generator: Adobe Illustrator 18.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 317.855 317.855" style="enable-background:new 0 0 317.855 317.855;" xml:space="preserve" fill="green"><g><path d="M158.929,317.855c-1.029,0-2.059-0.159-3.051-0.477c-33.344-10.681-61.732-31.168-84.377-60.891c-17.828-23.401-32.103-52.526-42.426-86.566C11.661,112.506,11.461,61.358,11.461,59.209c0-5.15,3.912-9.459,9.039-9.954c0.772-0.075,78.438-8.048,132.553-47.347c3.504-2.546,8.249-2.543,11.753,0.001C218.906,41.207,296.582,49.18,297.36,49.256c5.123,0.5,9.034,4.807,9.034,9.953c0,2.149-0.2,53.297-17.613,110.713c-10.324,34.04-24.598,63.165-42.426,86.566c-22.644,29.723-51.032,50.21-84.376,60.891C160.987,317.696,159.958,317.855,158.929,317.855z M31.748,67.982c0.831,16.784,4.062,55.438,16.604,96.591c21.405,70.227,58.601,114.87,110.576,132.746c52.096-17.916,89.335-62.711,110.713-133.202c12.457-41.074,15.653-79.434,16.472-96.134c-22.404-3.269-80.438-14.332-127.186-45.785C112.175,53.648,54.153,64.713,31.748,67.982z"/> <path d="M153.582,207.625c-2.372,0-4.68-0.844-6.499-2.4l-36.163-30.926c-4.197-3.589-4.69-9.901-1.101-14.099c3.588-4.198,9.901-4.692,14.099-1.101l28.124,24.051l55.743-73.118c3.348-4.392,9.622-5.24,14.015-1.89c4.393,3.348,5.238,9.623,1.89,14.015l-62.155,81.53c-1.667,2.187-4.16,3.591-6.895,3.882C154.287,207.606,153.934,207.625,153.582,207.625z"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g</g><g></g><g></g><g></g><g></g><g></g><g></g></svg>',
    general_plane: '<svg aria-hidden="true" data-prefix="fab" data-icon="telegram-plane" role="img"  viewBox="0 0 448 512" class="svg-inline--fa fa-telegram-plane fa-w-14 fa-2x"><path fill="currentColor" d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z" class=""></path></svg>',
    general_question: '<svg aria-hidden="true" data-prefix="fas" data-icon="question-circle" role="img" viewBox="0 0 512 512" class="svg-inline--fa fa-question-circle fa-w-16 fa-3x"><path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z" class=""></path></svg>',
    general_info: '<svg aria-hidden="true" data-prefix="fas" data-icon="info" role="img"  viewBox="0 0 192 512" class="svg-inline--fa fa-info fa-w-6 fa-3x"><path fill="currentColor" d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z" class=""></path></svg>',
    general_cart_buy: '<svg aria-hidden="true" data-prefix="fas" data-icon="cart-plus"  viewBox="0 0 576 512" class="svg-inline--fa fa-cart-plus fa-w-18 fa-3x"><path fill="currentColor" d="M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z" class=""></path></svg>',
    general_cart: '<svg aria-hidden="true" data-prefix="fas" data-icon="shopping-cart" role="img" viewBox="0 0 576 512" class="svg-inline--fa fa-shopping-cart fa-w-18 fa-3x"><path fill="currentColor" d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z" class=""></path></svg>',
    general_cart_white: '<svg aria-hidden="true" data-prefix="fas" data-icon="shopping-cart" role="img" viewBox="0 0 576 512" class="svg-inline--fa fa-shopping-cart fa-w-18 fa-3x"><path fill="white" d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z" class=""></path></svg>',
    general_math: '<svg aria-hidden="true" data-prefix="fas" data-icon="calculator" role="img"  viewBox="0 0 448 512" class="svg-inline--fa fa-calculator fa-w-14 fa-3x"><path fill="currentColor" d="M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z" class=""></path></svg>',
    general_up: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="60px" height="60px" viewBox="0 0 60 60" enable-background="new 0 0 60 60" xml:space="preserve">\n    <polygon  points="3.486,47.907 30,12.212 56.513,47.907 "/>\n    </svg>',
    general_down: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="60px" height="60px" viewBox="0 0 60 60" enable-background="new 0 0 60 60" xml:space="preserve">\n    <polygon  points="56.513,12.212 30,47.907 3.486,12.212 "/>\n    </svg>',
    step_1: '<svg version="1.1" id="Layer_4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">\n    <g>\n        <path  d="M129.172,54.159c-21.193,0-42.386,0-63.578,0c-2.732,0-4.683,1.945-4.683,4.669c0,27.27,0,54.539,0,81.81   c0,2.725,1.952,4.67,4.681,4.67c21.177,0,42.355,0,63.533,0c2.762,0,4.707-1.938,4.707-4.691c0-13.627,0-27.256,0-40.882   c0-13.642,0-27.285,0-40.927C133.832,56.117,131.868,54.159,129.172,54.159z M79.121,127.055c-3.02,0-6.021,0-9.058,0   c0-3.002,0-6.012,0-9.057c2.997,0,6.008,0,9.058,0C79.121,121.029,79.121,124.029,79.121,127.055z M70.059,108.814   c0-3,0-6.01,0-9.059c3.032,0,6.032,0,9.058,0c0,3.02,0,6.02,0,9.059C76.114,108.814,73.103,108.814,70.059,108.814z    M124.68,127.049c-12.114,0-24.24,0-36.402,0c0-3.035,0-6.035,0-9.061c12.136,0,24.251,0,36.402,0   C124.68,120.992,124.68,124.006,124.68,127.049z M124.68,108.818c-12.114,0-24.24,0-36.402,0c0-3.033,0-6.035,0-9.06   c12.136,0,24.251,0,36.402,0C124.68,102.762,124.68,105.773,124.68,108.818z M124.697,81.479c-18.223,0-36.424,0-54.649,0   c0-3.021,0-6.022,0-9.058c18.204,0,36.406,0,54.649,0C124.697,75.452,124.697,78.454,124.697,81.479z"/>\n        <path  d="M99.156,14.032c-46.779,0-84.701,37.922-84.701,84.701c0,46.778,37.922,84.7,84.701,84.7   c46.78,0,84.702-37.922,84.702-84.7C183.857,51.954,145.936,14.032,99.156,14.032z M142.931,140.559   c-0.008,5.613-2.643,9.752-7.571,12.41c-1.774,0.955-3.709,1.389-5.724,1.451c-0.183,0.006-0.364,0.006-0.546,0.006   c-21.146,0-42.292,0.023-63.438-0.016c-5.613-0.012-9.754-2.648-12.403-7.582c-1.045-1.943-1.456-4.064-1.455-6.271   c0.005-13.613,0.002-27.225,0.002-40.834c0-13.612-0.002-27.224,0.001-40.834c0.002-6.299,4.006-11.615,10.057-13.351   c1.231-0.354,2.496-0.495,3.778-0.494c5.849,0.004,11.697,0.002,17.546,0.002c15.328,0,30.657-0.037,45.984,0.019   c5.576,0.021,9.688,2.663,12.322,7.561c1.03,1.914,1.465,4.001,1.463,6.176c-0.002,3.312,0,6.624,0,9.936   C142.947,92.677,142.968,116.619,142.931,140.559z"/>\n    </g>\n    </svg>',
    step_2: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">\n    <g>\n        <path  d="M134.639,96.063c0.021,0.016,0.037,0.027,0.063,0.045c0.003-0.004,0.007-0.009,0.01-0.014   c-0.012-0.004-0.021-0.009-0.033-0.014C134.664,96.075,134.652,96.069,134.639,96.063z"/>\n        <path d="M120.014,80.282c0.13-4.396-1.637-8.068-5.46-10.025c-7.642-3.91-15.894-3.64-24.206-3.167   c0,8.766,0,16.904,0,26.617c7.936-1.29,15.31-2.068,22.453-3.803C117.264,88.821,119.868,85.178,120.014,80.282z"/>\n        <path  d="M134.639,96.063C134.315,95.828,134.442,95.973,134.639,96.063L134.639,96.063z"/>\n        <path  d="M118.302,108.504c-8.999-3.715-18.417-3.229-27.982-2.828c0,9.445,0,18.457,0,28.117   c9.925-0.068,19.413,0.434,28.349-3.566c4.757-2.131,7.382-5.84,7.206-11.184C125.705,113.887,122.908,110.406,118.302,108.504z"/>\n        <path  d="M99.156,14.032c-46.779,0-84.701,37.922-84.701,84.701c0,46.778,37.922,84.7,84.701,84.7   c46.78,0,84.702-37.922,84.702-84.7C183.857,51.954,145.936,14.032,99.156,14.032z M133.806,145.191   c-6.498,2.113-13.411,2.945-20.715,4.475c0,6.252,0,13.088,0,20.279c-4.406,0-8.35,0-12.849,0c0-6.547,0-13.229,0-20.283   c-3.596,0-6.652,0-10.227,0c0,6.744,0,13.434,0,20.375c-4.451,0-8.394,0-12.842,0c0-6.943,0-13.766,0-21.027   c-8.772,0-17.059,0-25.897,0c0.915-5.381,1.741-10.238,2.628-15.453c3.019,0,5.728-0.012,8.435,0.002   c3.708,0.016,5.553-1.711,5.544-5.525c-0.039-18.281-0.016-36.561-0.019-54.842c0-4.132-2.083-6.56-6.17-6.86   c-3.269-0.241-6.57-0.049-10.22-0.049c0-5.001,0-9.123,0-13.733c8.45,0,16.72,0,25.438,0c0-7.158,0-13.846,0-20.864   c4.392,0,8.348,0,12.905,0c0,6.536,0,13.201,0,20.075c3.55,0,6.508,0,10.147,0c0-6.746,0-13.402,0-20.222c4.513,0,8.349,0,12.908,0   c0,5.762,0.133,11.452-0.055,17.133c-0.096,2.874,0.736,3.967,3.764,4.304c4.107,0.458,8.254,1.357,12.16,2.712   c12.614,4.375,18.83,16.901,13.991,29.082c-1.657,4.171-5.279,7.562-8.021,11.325c12.605,4.909,16.982,10.739,16.842,22.451   C151.387,132.219,145.668,141.338,133.806,145.191z"/>\n    </g>\n    </svg>',
    step_3: '<svg version="1.1" id="Layer_3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">\n    <path  d="M99.156,14.032c-46.779,0-84.701,37.922-84.701,84.701c0,46.778,37.922,84.7,84.701,84.7  c46.78,0,84.702-37.922,84.702-84.7C183.857,51.954,145.936,14.032,99.156,14.032z M149.256,55.696  c-41.781,48.179-63.739,76.368-77.05,98.628c-1.209,2.033-3.506,1.92-4.752-0.031c-2.934-4.66-7.364-11.971-7.485-12.156  c-9.439-16.475-9.74-17.162-18.751-32.896c-0.425-0.773,0.497-1.336,1.119-0.936h0.001c9.736,4.215,17.661,7.596,27.514,11.863  c0.679,0.299,1.368,0.381,2.053-0.219c23.582-22.061,46.634-43.696,70.216-65.759C145.212,51.402,151.164,53.112,149.256,55.696z"/>\n    </svg>',
    loading: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-3x"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>',
    cash: '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="money-bill" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" class="svg-inline--fa fa-money-bill fa-w-20 fa-2x"><path fill="currentColor" d="M320 144c-53 0-96 50.1-96 112 0 61.8 43 112 96 112s96-50.1 96-112-43-112-96-112zm0 192c-35.3 0-64-35.9-64-80s28.7-80 64-80 64 35.9 64 80-28.7 80-64 80zM608 64H32C14.3 64 0 78.3 0 96v320c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM32 96h64c0 35.3-28.7 64-64 64V96zm0 320v-64c35.3 0 64 28.7 64 64H32zm576 0h-64c0-35.3 28.7-64 64-64v64zm0-96c-52.9 0-96 43.1-96 96H128c0-52.9-43.1-96-96-96V192c52.9 0 96-43.1 96-96h384c0 52.9 43.1 96 96 96v128zm0-160c-35.3 0-64-28.7-64-64h64v64z" class=""></path></svg>',

    download: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="file-download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-file-download fa-w-12"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z" class=""></path></svg>',
    plus: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-plus-circle fa-w-16 fa-2x"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" class=""></path></svg>',
    copy: '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="copy" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-copy fa-w-14 fa-2x"><path fill="currentColor" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z" class=""></path></svg>',
    copy_white: '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="copy" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-copy fa-w-14 fa-2x"><path fill="white" d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z" class=""></path></svg>',
    plus_no_circle: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-plus fa-w-14 fa-2x"><path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path></svg>',
    trash: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-trash-alt fa-w-14 fa-2x"><path fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" class=""></path></svg>',
    refresh: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sync-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sync-alt fa-w-16 fa-2x"><path fill="currentColor" d="M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z" class=""></path></svg>',
    stratum_logo: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21.852" height="27.756" viewBox="0 0 21.852 27.756"><defs><clipPath id="clip-path"><path id="Path_3" data-name="Path 3" d="M420.62-79.384l9.664,5.566V-84.95l-5.107,2.942Z" transform="translate(-420.62 84.95)" fill="#fff"/></clipPath><clipPath id="clip-path-2"><path id="Path_5" data-name="Path 5" d="M415.62-31.176v5.9l9.674-5.586-5.112-2.945Z" transform="translate(-415.62 33.81)" fill="#fff"/></clipPath><clipPath id="clip-path-3"><path id="Path_8" data-name="Path 8" d="M386.947-104.1V-110l-9.677,5.587,5.112,2.945Z" transform="translate(-377.27 110)" fill="#fff"/></clipPath><clipPath id="clip-path-4"><path id="Path_11" data-name="Path 11" d="M377.425-36.7v-.005l-5.1,2.942v.013l10.926,6.308v-5.9Z" transform="translate(-372.32 36.71)" fill="#fff"/></clipPath></defs><g id="Group_10" data-name="Group 10" transform="translate(-4666.32 -2487)"><g id="Group_2" data-name="Group 2" transform="translate(4678.507 2493.321)" clip-path="url(#clip-path)"><g id="Group_1" data-name="Group 1" transform="translate(-106.133 -6.321)"><path id="Path_2" data-name="Path 2" d="M-420.62-47.11h120.612v27.756H-420.62Z" transform="translate(420.62 47.11)" fill="#fff"/></g></g><g id="Group_4" data-name="Group 4" transform="translate(4677.246 2506.225)" opacity="0.35" clip-path="url(#clip-path-2)"><g id="Group_3" data-name="Group 3" transform="translate(-104.872 -19.225)"><path id="Path_4" data-name="Path 4" d="M-415.62-93.1h120.612v27.756H-415.62Z" transform="translate(415.62 93.095)" fill="#fff"/></g></g><path id="Path_6" data-name="Path 6" d="M421.438-100.745v.008l5.107-2.942v-.013L415.619-110v5.9Z" transform="translate(4261.626 2597)" fill="#fff" opacity="0.7"/><g id="Group_6" data-name="Group 6" transform="translate(4667.569 2487)" opacity="0.35" clip-path="url(#clip-path-3)"><g id="Group_5" data-name="Group 5" transform="translate(-95.195 0)"><path id="Path_7" data-name="Path 7" d="M-377.27-16.905h120.612V10.851H-377.27Z" transform="translate(377.27 16.905)" fill="#fff"/></g></g><path id="Path_9" data-name="Path 9" d="M381.982-63.614,372.32-69.18v11.135l5.1-2.942Z" transform="translate(4294 2566.48)" fill="#fff"/><g id="Group_8" data-name="Group 8" transform="translate(4666.32 2505.493)" opacity="0.7" clip-path="url(#clip-path-4)"><g id="Group_7" data-name="Group 7" transform="translate(-93.946 -18.493)"><path id="Path_10" data-name="Path 10" d="M-372.32-91.645h120.612v27.756H-372.32Z" transform="translate(372.32 91.645)" fill="#fff"/></g></g></g></svg>',
    btc_icon: '<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="btc" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="svg-inline--fa fa-btc fa-w-12 fa-2x"><path fill="currentColor" d="M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z" class=""></path></svg>',
    email: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-envelope fa-w-16 fa-2x"><path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" class=""></path></svg>',
    blu_wallet: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36" height="36" viewBox="0 0 36 36"><defs><clipPath id="clip-blu_address_icon"><rect width="36" height="36"/></clipPath></defs><g id="blu_address_icon" clip-path="url(#clip-blu_address_icon)"><rect width="36" height="36" fill="#fff"/><g id="Group_9349" data-name="Group 9349" transform="translate(2 16.065)"><path id="Path_4919" data-name="Path 4919" d="M3.18,13.752A3.18,3.18,0,0,1,0,10.572V-5.885A3.18,3.18,0,0,1,.932-8.134,3.182,3.182,0,0,1,3.18-9.066H28.354a3.182,3.182,0,0,1,2.249.932,3.18,3.18,0,0,1,.932,2.249V10.572a3.18,3.18,0,0,1-3.18,3.18ZM30.841-4.077V-5.723a2.648,2.648,0,0,0-2.648-2.648H3.342a2.7,2.7,0,0,0-.385.028,1.3,1.3,0,0,1-.133.048c-.9.3-1.557,1.7-.026,2.24a6,6,0,0,0,1.79.306v.625C2.873-5.2,1.126-5.732,1.259-7.359A2.638,2.638,0,0,0,.694-5.723V10.411a2.648,2.648,0,0,0,2.648,2.648H28.193a2.648,2.648,0,0,0,2.648-2.648v-3.3H25.868A2.308,2.308,0,0,1,23.559,4.8V2.908A2.308,2.308,0,0,1,25.868.6h4.974V-1.75a.9.9,0,0,1-.017-.154,3.327,3.327,0,0,0-.918-2.323,3.6,3.6,0,0,0-2.24-.894v0H4.588V-5.75H27.666v0A4.138,4.138,0,0,1,30.841-4.077ZM11.96-2.057A.152.152,0,0,1,12-2.043l5.017,2.9a.1.1,0,0,1,.059.1V6.749a.1.1,0,0,1-.059.1L12,9.748a.105.105,0,0,1-.119,0l-5.017-2.9a.105.105,0,0,1-.059-.1V.956a.105.105,0,0,1,.059-.1l5.017-2.9A.117.117,0,0,1,11.96-2.057ZM7.309,6.525l.257.148c0-.332-.067-.751.282-.769A.307.307,0,0,1,8.16,6.2v.817l.664.383c0-.781-.018-1.563,0-2.343.024-.306.585-.338.594.011V7.743l.664.383c0-1.317-.04-2.635,0-3.951.025-.306.585-.337.594.012V8.469l1.01.583V4L7.309,1.471Zm4.883,2.527,4.124-2.381L12.192,4.29ZM30.841,1.294h-5.1a1.492,1.492,0,0,0-1.492,1.492V4.922a1.492,1.492,0,0,0,1.492,1.492h5.1ZM12.441,3.85l4.127,2.383V1.471ZM26.176,5.6A1.007,1.007,0,0,1,25.169,4.59V3.117A1.007,1.007,0,0,1,26.176,2.11h.07a1.007,1.007,0,0,1,1.007,1.007V4.59A1.007,1.007,0,0,1,26.246,5.6Zm.384-2.463a.331.331,0,0,0-.331-.331h-.036a.33.33,0,0,0-.33.331V4.573a.33.33,0,0,0,.33.33h.036a.33.33,0,0,0,.331-.33Zm-19-2.1,4.124,2.381V-1.348Zm4.63,2.377,4.124-2.378L12.192-1.348Z" fill="#424b7d" fill-rule="evenodd"/></g></g></svg>',
    password_key: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="key" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-key fa-w-16 fa-2x"><path fill="currentColor" d="M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z" class=""></path></svg>',
    lock_icon_fit: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><g id="Group_9341" data-name="Group 9341" transform="translate(-765 -693)"><g id="lock_icon" transform="translate(770 696)"><g id="Subtraction_2" data-name="Subtraction 2" transform="translate(4)" fill="none"><path d="M8,7H0V4A4,4,0,0,1,8,4V7Z" stroke="none"/><path d="M 7.000100135803223 5.999300003051758 L 7.000100135803223 3.999599933624268 C 7.000100135803223 2.345609903335571 5.654079914093018 1 3.999600172042847 1 C 2.34561014175415 1 1.00000011920929 2.345609903335571 1.00000011920929 3.999599933624268 L 1.00000011920929 5.999300003051758 L 7.000100135803223 5.999300003051758 M 8.000100135803223 6.999300003051758 L 7.999100208282471 6.999300003051758 L 6.790160966829717e-08 6.999300003051758 L 6.790160966829717e-08 3.999599933624268 C 6.790160966829717e-08 1.794209957122803 1.794210076332092 1.525878534636149e-09 3.999600172042847 1.525878534636149e-09 C 6.205480098724365 1.525878534636149e-09 8.000100135803223 1.794209957122803 8.000100135803223 3.999599933624268 L 8.000100135803223 6.998300075531006 L 8.000100135803223 6.999300003051758 Z" stroke="none" fill="#9b9b9b"/></g><g id="Rectangle_17040" data-name="Rectangle 17040" transform="translate(0 6)" fill="none" stroke="#9b9b9b" stroke-width="1"><rect width="16" height="10" rx="3" stroke="none"/><rect x="0.5" y="0.5" width="15" height="9" rx="2.5" fill="none"/></g><g id="Union_400" data-name="Union 400" transform="translate(3 10)" fill="#fff"><path d="M 9.000089645385742 1.5 C 8.72443962097168 1.5 8.500180244445801 1.275699973106384 8.500180244445801 1 C 8.500180244445801 0.7243000268936157 8.72443962097168 0.5 9.000089645385742 0.5 C 9.275739669799805 0.5 9.5 0.7243000268936157 9.5 1 C 9.5 1.275699973106384 9.275739669799805 1.5 9.000089645385742 1.5 Z M 5.000450134277344 1.5 C 4.724299907684326 1.5 4.499639987945557 1.275699973106384 4.499639987945557 1 C 4.499639987945557 0.7243000268936157 4.724299907684326 0.5 5.000450134277344 0.5 C 5.276100158691406 0.5 5.500360012054443 0.7243000268936157 5.500360012054443 1 C 5.500360012054443 1.275699973106384 5.276100158691406 1.5 5.000450134277344 1.5 Z M 0.9999099969863892 1.5 C 0.7242599725723267 1.5 0.5 1.275699973106384 0.5 1 C 0.5 0.7243000268936157 0.7242599725723267 0.5 0.9999099969863892 0.5 C 1.275560021400452 0.5 1.499819993972778 0.7243000268936157 1.499819993972778 1 C 1.499819993972778 1.275699973106384 1.275560021400452 1.5 0.9999099969863892 1.5 Z" stroke="none"/><path d="M 0.9999103546142578 0 C 1.552510261535645 0 1.999819755554199 0.4473400115966797 1.999819755554199 1 C 1.999819755554199 1.55265998840332 1.552510261535645 2 0.9999103546142578 2 C 0.4472999572753906 2 0 1.55265998840332 0 1 C 0 0.4473400115966797 0.4472999572753906 0 0.9999103546142578 0 Z M 5.000450134277344 0 C 5.552159786224365 0 6.000360012054443 0.4473400115966797 6.000360012054443 1 C 6.000360012054443 1.55265998840332 5.552159786224365 2 5.000450134277344 2 C 4.447840213775635 2 3.999639987945557 1.55265998840332 3.999639987945557 1 C 3.999639987945557 0.4473400115966797 4.447840213775635 0 5.000450134277344 0 Z M 9.000089645385742 0 C 9.552700042724609 0 10 0.4473400115966797 10 1 C 10 1.55265998840332 9.552700042724609 2 9.000089645385742 2 C 8.447480201721191 2 8.000180244445801 1.55265998840332 8.000180244445801 1 C 8.000180244445801 0.4473400115966797 8.447480201721191 0 9.000089645385742 0 Z" stroke="none" fill="#9b9b9b"/></g></g><rect id="Rectangle_17044" data-name="Rectangle 17044" transform="translate(765 693)" fill="none"/></g></svg>',
    refresh_fit: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><g id="Group_9342" data-name="Group 9342" transform="translate(-1126 -693)"><g id="Group_9343" data-name="Group 9343"><g id="refresh_icon" transform="translate(1130.999 698)"><path id="Path_4796" data-name="Path 4796" d="M4.141-87.3,4-86.5a.37.37,0,0,0,.06.277.37.37,0,0,0,.238.153h0a.37.37,0,0,0,.277-.06.37.37,0,0,0,.153-.238l.24-1.336.081-.448a.287.287,0,0,0-.232-.333l-1.784-.321a.37.37,0,0,0-.277.06.37.37,0,0,0-.153.238v0a.37.37,0,0,0,.06.277.37.37,0,0,0,.238.153l.688.124A8,8,0,0,0,0-81.28a8,8,0,0,0,8,8h.026a8.04,8.04,0,0,0,1.308-.111.354.354,0,0,0,.248-.176.354.354,0,0,0,.02-.3h0a.533.533,0,0,0-.574-.33A7.079,7.079,0,0,1,8-74.127,7.157,7.157,0,0,1,.847-81.28,7.15,7.15,0,0,1,4.141-87.3Zm8.67,12.413A7.99,7.99,0,0,0,16-81.28a8,8,0,0,0-8-8H7.974q-.3,0-.6.024A.543.543,0,0,0,6.959-89a.543.543,0,0,0-.044.488h0a.212.212,0,0,0,.223.132A7.2,7.2,0,0,1,8-88.433a7.157,7.157,0,0,1,7.153,7.153,7.143,7.143,0,0,1-2.781,5.66l.127-.705a.37.37,0,0,0-.06-.277.37.37,0,0,0-.238-.153h0a.37.37,0,0,0-.277.06.37.37,0,0,0-.153.238l-.321,1.784a.287.287,0,0,0,.047.215.287.287,0,0,0,.185.119l.448.081,1.336.24a.37.37,0,0,0,.277-.06.37.37,0,0,0,.153-.238v0a.37.37,0,0,0-.06-.277.37.37,0,0,0-.238-.153Z" transform="translate(0 89.28)" fill="#084684" stroke="#084684" stroke-width="0.4" fill-rule="evenodd"/></g><rect id="Rectangle_17043" data-name="Rectangle 17043" transform="translate(1126 693)" fill="none"/></g></g></svg>',
    visa_blu: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="58.294" height="18.837" viewBox="0 0 58.294 18.837"><defs><clipPath id="clip-path"><path id="Path_4920" data-name="Path 4920" d="M393.861-172.427a2.161,2.161,0,0,0-2.25,1.5q-3.069,7.319-6.137,14.639c-.286.682-.568,1.366-.865,2.082,1.632,0,3.218,0,4.8-.01.084,0,.206-.134.243-.231.271-.715.536-1.433.779-2.159a.4.4,0,0,1,.453-.329c1.76.014,3.52.02,5.28,0,.353,0,.454.118.51.434.136.761.308,1.516.469,2.288h4.388v-.13c-.142-.615-.294-1.228-.424-1.845q-1.513-7.233-3.019-14.467c-.123-.587-.251-1.174-.378-1.768h-3.853Zm.483,5.061.057.011,1.39,6.667h-3.868Z" transform="translate(-384.609 172.427)" fill="none"/></clipPath><linearGradient id="linear-gradient" x1="0.057" y1="0.509" x2="0.994" y2="0.509" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#25275f"/><stop offset="0.1" stop-color="#272a65"/><stop offset="0.2" stop-color="#292c6b"/><stop offset="0.3" stop-color="#2c2f71"/><stop offset="0.4" stop-color="#2e3277"/><stop offset="0.5" stop-color="#31347d"/><stop offset="0.6" stop-color="#333783"/><stop offset="0.7" stop-color="#363a88"/><stop offset="0.8" stop-color="#383c8e"/><stop offset="0.9" stop-color="#3a3f94"/><stop offset="1" stop-color="#3d429a"/></linearGradient><clipPath id="clip-path-2"><path id="Path_4922" data-name="Path 4922" d="M270.739-175.441a2.4,2.4,0,0,1-.272.065,8.5,8.5,0,0,0-4.522,1.755,5.189,5.189,0,0,0-2.022,4.791,4.266,4.266,0,0,0,1.91,3.034c.8.577,1.7,1.016,2.545,1.531a11.572,11.572,0,0,1,1.588,1.044,1.311,1.311,0,0,1-.147,2.158,3.42,3.42,0,0,1-1.238.517,8.5,8.5,0,0,1-4.811-.6c-.325-.131-.642-.279-.98-.427l-.85,3.979a1.1,1.1,0,0,0,.132.081c.13.053.259.108.392.151a14.919,14.919,0,0,0,6.1.691,8.886,8.886,0,0,0,4.176-1.349,5.483,5.483,0,0,0,2.592-5.6,4.3,4.3,0,0,0-2.069-3.075c-.933-.617-1.941-1.119-2.9-1.7a7,7,0,0,1-1.2-.865,1.024,1.024,0,0,1,.032-1.619,3.02,3.02,0,0,1,1.122-.6,6.112,6.112,0,0,1,2.983.026c.721.159,1.422.407,2.156.622l.822-3.842c-.556-.158-1.069-.327-1.592-.447-.573-.132-1.157-.221-1.736-.328Z" transform="translate(-261.939 175.441)" fill="none"/></clipPath><linearGradient id="linear-gradient-2" x1="0.057" y1="0.502" x2="0.994" y2="0.502" xlink:href="#linear-gradient"/><clipPath id="clip-path-3"><path id="Path_4924" data-name="Path 4924" d="M17.064-172.2q-2.312,5.883-4.641,11.76c-.029.074-.075.143-.139.264-.042-.2-.073-.349-.1-.494q-.938-4.975-1.879-9.951a2.17,2.17,0,0,0-2.261-1.859H.56c-.52,0-.52,0-.527.546l.181.045A23.58,23.58,0,0,1,4.3-170.563a2.48,2.48,0,0,1,1.481,1.817c1.195,4.713,2.423,9.417,3.632,14.127.069.271.168.377.47.373,1.425-.02,2.851-.015,4.277,0a.447.447,0,0,0,.5-.322q3.374-8.088,6.769-16.166c.237-.564.47-1.13.717-1.723-.133-.006-.226-.014-.319-.014H20.6c-1.039,0-2.079,0-3.118-.007h-.008A.374.374,0,0,0,17.064-172.2Z" transform="translate(-0.033 172.481)" fill="none"/></clipPath><linearGradient id="linear-gradient-3" x1="0.057" y1="0.494" x2="0.994" y2="0.494" xlink:href="#linear-gradient"/><clipPath id="clip-path-4"><path id="Path_4926" data-name="Path 4926" d="M191.917-172.246l-3.895,18.2h.388c1.3,0,2.592-.015,3.887.01.361.007.485-.1.558-.452q1.589-7.515,3.2-15.025c.194-.905.386-1.811.583-2.735Z" transform="translate(-188.022 172.246)" fill="none"/></clipPath><linearGradient id="linear-gradient-4" x1="0.057" y1="0.5" x2="0.994" y2="0.5" xlink:href="#linear-gradient"/></defs><g id="Group_9355" data-name="Group 9355" transform="translate(-0.033 175.441)"><g id="Group_9348" data-name="Group 9348" transform="translate(41.401 -175.117)" clip-path="url(#clip-path)"><g id="Group_9347" data-name="Group 9347" transform="translate(-41.496 -0.36) rotate(-0.377)"><path id="Path_4919" data-name="Path 4919" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0)" fill="url(#linear-gradient)"/></g></g><g id="Group_9350" data-name="Group 9350" transform="translate(28.206 -175.441)" clip-path="url(#clip-path-2)"><g id="Group_9349" data-name="Group 9349" transform="translate(-28.301 -0.036) rotate(-0.377)"><path id="Path_4921" data-name="Path 4921" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0 0)" fill="url(#linear-gradient-2)"/></g></g><g id="Group_9352" data-name="Group 9352" transform="translate(0.033 -175.123)" clip-path="url(#clip-path-3)"><g id="Group_9351" data-name="Group 9351" transform="translate(-0.128 -0.354) rotate(-0.377)"><path id="Path_4923" data-name="Path 4923" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0 0)" fill="url(#linear-gradient-3)"/></g></g><g id="Group_9354" data-name="Group 9354" transform="translate(20.255 -175.097)" clip-path="url(#clip-path-4)"><g id="Group_9353" data-name="Group 9353" transform="translate(-20.35 -0.379) rotate(-0.377)"><path id="Path_4925" data-name="Path 4925" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0 0)" fill="url(#linear-gradient-4)"/></g></g></g></svg>',
    visa_white: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="58.294" height="18.837" viewBox="0 0 58.294 18.837"><defs><clipPath id="clip-path"><path id="Path_4920" data-name="Path 4920" d="M393.861-172.427a2.161,2.161,0,0,0-2.25,1.5q-3.069,7.319-6.137,14.639c-.286.682-.568,1.366-.865,2.082,1.632,0,3.218,0,4.8-.01.084,0,.206-.134.243-.231.271-.715.536-1.433.779-2.159a.4.4,0,0,1,.453-.329c1.76.014,3.52.02,5.28,0,.353,0,.454.118.51.434.136.761.308,1.516.469,2.288h4.388v-.13c-.142-.615-.294-1.228-.424-1.845q-1.513-7.233-3.019-14.467c-.123-.587-.251-1.174-.378-1.768h-3.853Zm.483,5.061.057.011,1.39,6.667h-3.868Z" transform="translate(-384.609 172.427)" fill="#fff"/></clipPath><clipPath id="clip-path-2"><path id="Path_4922" data-name="Path 4922" d="M270.739-175.441a2.4,2.4,0,0,1-.272.065,8.5,8.5,0,0,0-4.522,1.755,5.189,5.189,0,0,0-2.022,4.791,4.266,4.266,0,0,0,1.91,3.034c.8.577,1.7,1.016,2.545,1.531a11.572,11.572,0,0,1,1.588,1.044,1.311,1.311,0,0,1-.147,2.158,3.42,3.42,0,0,1-1.238.517,8.5,8.5,0,0,1-4.811-.6c-.325-.131-.642-.279-.98-.427l-.85,3.979a1.1,1.1,0,0,0,.132.081c.13.053.259.108.392.151a14.919,14.919,0,0,0,6.1.691,8.886,8.886,0,0,0,4.176-1.349,5.483,5.483,0,0,0,2.592-5.6,4.3,4.3,0,0,0-2.069-3.075c-.933-.617-1.941-1.119-2.9-1.7a7,7,0,0,1-1.2-.865,1.024,1.024,0,0,1,.032-1.619,3.02,3.02,0,0,1,1.122-.6,6.112,6.112,0,0,1,2.983.026c.721.159,1.422.407,2.156.622l.822-3.842c-.556-.158-1.069-.327-1.592-.447-.573-.132-1.157-.221-1.736-.328Z" transform="translate(-261.939 175.441)" fill="#fff"/></clipPath><clipPath id="clip-path-3"><path id="Path_4924" data-name="Path 4924" d="M17.064-172.2q-2.312,5.883-4.641,11.76c-.029.074-.075.143-.139.264-.042-.2-.073-.349-.1-.494q-.938-4.975-1.879-9.951a2.17,2.17,0,0,0-2.261-1.859H.56c-.52,0-.52,0-.527.546l.181.045A23.58,23.58,0,0,1,4.3-170.563a2.48,2.48,0,0,1,1.481,1.817c1.195,4.713,2.423,9.417,3.632,14.127.069.271.168.377.47.373,1.425-.02,2.851-.015,4.277,0a.447.447,0,0,0,.5-.322q3.374-8.088,6.769-16.166c.237-.564.47-1.13.717-1.723-.133-.006-.226-.014-.319-.014H20.6c-1.039,0-2.079,0-3.118-.007h-.008A.374.374,0,0,0,17.064-172.2Z" transform="translate(-0.033 172.481)" fill="#fff"/></clipPath><clipPath id="clip-path-4"><path id="Path_4926" data-name="Path 4926" d="M191.917-172.246l-3.895,18.2h.388c1.3,0,2.592-.015,3.887.01.361.007.485-.1.558-.452q1.589-7.515,3.2-15.025c.194-.905.386-1.811.583-2.735Z" transform="translate(-188.022 172.246)" fill="#fff"/></clipPath></defs><g id="Group_9355" data-name="Group 9355" transform="translate(-0.033 175.441)"><g id="Group_9348" data-name="Group 9348" transform="translate(41.401 -175.117)" clip-path="url(#clip-path)"><g id="Group_9347" data-name="Group 9347" transform="translate(-41.496 -0.36) rotate(-0.377)"><path id="Path_4919" data-name="Path 4919" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0)" fill="#fff"/></g></g><g id="Group_9350" data-name="Group 9350" transform="translate(28.206 -175.441)" clip-path="url(#clip-path-2)"><g id="Group_9349" data-name="Group 9349" transform="translate(-28.301 -0.036) rotate(-0.377)"><path id="Path_4921" data-name="Path 4921" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0 0)" fill="#fff"/></g></g><g id="Group_9352" data-name="Group 9352" transform="translate(0.033 -175.123)" clip-path="url(#clip-path-3)"><g id="Group_9351" data-name="Group 9351" transform="translate(-0.128 -0.354) rotate(-0.377)"><path id="Path_4923" data-name="Path 4923" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0 0)" fill="#fff"/></g></g><g id="Group_9354" data-name="Group 9354" transform="translate(20.255 -175.097)" clip-path="url(#clip-path-4)"><g id="Group_9353" data-name="Group 9353" transform="translate(-20.35 -0.379) rotate(-0.377)"><path id="Path_4925" data-name="Path 4925" d="M.124,0l58.3.384L58.3,19.291,0,18.908Z" transform="translate(0 0)" fill="#fff"/></g></g></g></svg>',
    master_card: '<svg xmlns="http://www.w3.org/2000/svg" width="30.521" height="18.837" viewBox="0 0 30.521 18.837"><g id="Group_9356" data-name="Group 9356" transform="translate(0 155.928)"><path id="Path_4927" data-name="Path 4927" d="M11.684-146.509a9.4,9.4,0,0,1,3.577-7.385,9.376,9.376,0,0,0-5.842-2.034A9.419,9.419,0,0,0,0-146.509a9.419,9.419,0,0,0,9.419,9.419,9.376,9.376,0,0,0,5.842-2.034,9.4,9.4,0,0,1-3.577-7.385" transform="translate(0 0)" fill="#e30c17"/><path id="Path_4928" data-name="Path 4928" d="M96.719-131.709a9.4,9.4,0,0,0,3.577,7.385,9.4,9.4,0,0,0,3.576-7.385,9.4,9.4,0,0,0-3.576-7.385,9.4,9.4,0,0,0-3.577,7.385" transform="translate(-85.035 -14.8)" fill="#eb6009"/><path id="Path_4929" data-name="Path 4929" d="M132.166-155.928a9.375,9.375,0,0,0-5.842,2.034,9.4,9.4,0,0,1,3.576,7.385,9.4,9.4,0,0,1-3.576,7.385,9.375,9.375,0,0,0,5.842,2.034,9.419,9.419,0,0,0,9.419-9.419,9.419,9.419,0,0,0-9.419-9.419" transform="translate(-111.063 0)" fill="#f59f00"/></g></svg>',
    stratum_logo_complete: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="163px" height="39px" viewBox="0 0 163 39" version="1.1"><defs><linearGradient x1="0.0117493473%" y1="50.0056664%" x2="99.9939948%" y2="50.0056664%" id="linearGradient-1"><stop stop-color="#F27421" offset="0%" /><stop stop-color="#F6901E" offset="100%" /></linearGradient><linearGradient x1="-0.00938967136%" y1="49.9937888%" x2="100.001043%" y2="49.9937888%" id="linearGradient-2"><stop stop-color="#F27421" offset="0%" /><stop stop-color="#F6901E" offset="100%" /></linearGradient><linearGradient x1="0.00677966102%" y1="49.9931973%" x2="99.9906128%" y2="49.9931973%" id="linearGradient-3"><stop stop-color="#FCB315" offset="0%" /><stop stop-color="#F89E1C" offset="100%" /></linearGradient><linearGradient x1="-0.0110854503%" y1="49.991283%" x2="99.9916859%" y2="49.991283%" id="linearGradient-4"><stop stop-color="#FCB315" offset="0%" /><stop stop-color="#F89E1C" offset="100%" /></linearGradient></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Desktop/Header/Content-White" transform="translate(-40.000000, -46.000000)"><g id="Header"><g id="Logos/stratum-for-dark-bg" transform="translate(40.000000, 45.667391)"><g id="stratum-dark"><g id="Group" transform="translate(131.817391, 0.000000)"><polygon id="Path" fill="url(#linearGradient-1)" points="17.3984783 16.777027 30.97 24.5278378 30.97 9.02621622 23.798 13.122973" /><polygon id="Path" fill="url(#linearGradient-2)" points="15.6267391 30.6624324 15.6267391 38.8735135 29.2124348 31.0945946 22.0333478 26.9943243" /><polygon id="Path" fill="#FFD008" points="23.798 13.1124324 23.798 13.122973 30.97 9.02621622 30.97 9.00864865 15.6267391 0.224864865 15.6267391 8.43594595" /><polygon id="Path" fill="url(#linearGradient-3)" points="15.6267391 8.43594595 15.6267391 0.224864865 2.0375 8.00378378 9.21658696 12.1040541" /><polygon id="Path" fill="#FAD638" points="13.8514565 22.3178378 0.283478261 14.567027 0.283478261 30.0721622 7.45193478 25.9754054" /><polygon id="Path" fill="url(#linearGradient-4)" points="7.45193478 25.9824324 7.45193478 25.9754054 0.283478261 30.0721622 0.283478261 30.0897297 15.6267391 38.8735135 15.6267391 30.6624324" /></g><g id="Group" transform="translate(0.000000, 14.405405)" fill="#FFFFFF"><path d="M4.80141304,6.00108108 L4.52502174,5.7972973 C3.81986957,5.26675676 3.39819565,4.55702703 3.39819565,3.89648649 C3.39819565,3.20432432 3.88719565,2.45945946 4.96441304,2.45945946 C5.90697826,2.45945946 6.46684783,2.97243243 7.29956522,4.05108108 L7.51571739,4.33216216 L9.22013043,3.02162162 L9.0146087,2.74756757 C8.07558696,1.47918919 6.93813043,0.305675676 5.0033913,0.305675676 C2.83478261,0.305675676 1.20123913,1.87621622 1.20123913,3.95621622 C1.20123913,5.09108108 1.75402174,6.32081081 2.54067391,6.93918919 C3.02258696,7.32567568 3.46552174,7.67351351 3.86947826,7.99324324 C6.09123913,9.74297297 7.10467391,10.5440541 7.10467391,11.692973 C7.10467391,12.8383784 6.10186957,13.7378378 4.82267391,13.7378378 C3.85530435,13.7378378 2.93754348,12.992973 2.16152174,11.5840541 L1.98434783,11.2608108 L0.170086957,12.3535135 L0.333086957,12.6486486 C1.52369565,14.8094595 2.99069565,15.8178378 4.94315217,15.8178378 C7.34563043,15.8178378 9.29808696,13.9591892 9.29808696,11.6754054 C9.30163043,9.30027027 7.4165,7.91594595 4.80141304,6.00108108 Z" id="Path" /><polygon id="Path" points="16.1653478 2.73702703 19.3721957 2.73702703 19.3721957 15.4664865 21.508913 15.4664865 21.508913 2.73702703 24.6767826 2.73702703 24.6767826 0.660540541 16.1653478 0.660540541" /><path d="M41.2035652,6.66864865 C41.5472826,5.98702703 41.6571304,5.52324324 41.6571304,4.76432432 C41.6571304,3.03216216 40.6968478,1.64081081 39.0881087,1.03648649 C38.393587,0.78 37.3021957,0.660540541 35.6544783,0.660540541 L32.0330435,0.660540541 L32.0330435,15.4664865 L34.1697609,15.4664865 L34.1697609,8.90675676 L34.4532391,8.90675676 L36.7529565,11.8581081 L39.5629348,15.4664865 L42.224087,15.4664865 L37.0789565,8.88567568 C39.2227609,8.76621622 40.5090435,8.06702703 41.2035652,6.66864865 Z M36.1718261,6.84783784 C35.8033043,6.84783784 35.4170652,6.84432432 35.0272826,6.8372973 C34.7438043,6.83378378 34.4532391,6.83027027 34.1697609,6.82675676 L34.1697609,2.73351351 L36.7281522,2.73351351 C38.4928043,2.73351351 39.4637174,3.45378378 39.4637174,4.76081081 C39.4637174,5.36162162 39.1873261,5.95891892 38.7443913,6.31378378 C38.2731087,6.69324324 37.5254348,6.84783784 36.1718261,6.84783784 Z" id="Shape" fill-rule="nonzero" /><polygon id="Path" points="55.5440217 0.660540541 48.4712391 15.4664865 50.8418261 15.4664865 53.79 9.25459459 55.9231739 4.81702703 58.020913 9.25108108 58.3433696 9.10351351 58.0244565 9.25459459 60.9903478 15.4664865 63.2971522 15.4664865 56.3306739 0.660540541" /><polygon id="Path" points="67.5209783 2.73702703 70.7278261 2.73702703 70.7278261 15.4664865 72.8645435 15.4664865 72.8645435 2.73702703 76.0359565 2.73702703 76.0359565 0.660540541 67.5209783 0.660540541" /><path d="M91.3756739,9.96783784 C91.3756739,11.0605405 91.3756739,11.9248649 90.6988696,12.7540541 C90.1673478,13.4181081 89.4267609,13.7413514 88.4416739,13.7413514 C87.456587,13.7413514 86.716,13.4181081 86.1809348,12.7505405 C85.5076739,11.9248649 85.5076739,11.0605405 85.5076739,9.96783784 L85.5076739,0.660540541 L83.3709565,0.660540541 L83.3709565,10.1856757 C83.3709565,13.6605405 85.3127826,15.8213514 88.4416739,15.8213514 C91.5705652,15.8213514 93.5123913,13.6605405 93.5123913,10.1856757 L93.5123913,0.660540541 L91.3756739,0.660540541 L91.3756739,9.96783784 Z" id="Path" /><polygon id="Path" points="116.268609 0.660540541 115.503217 0.660540541 109.996652 11.7843243 104.433391 0.660540541 103.668 0.660540541 101.545457 15.4664865 103.650283 15.4664865 104.904674 6.12054054 109.599783 15.4664865 110.397065 15.4664865 115.014217 6.20135135 116.286326 15.4664865 118.387609 15.4664865" /></g></g></g></g></g></g></svg>',
    button_buy_changelly: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="456" height="105" viewBox="0 0 456 105"><defs><filter id="Rectangle_17062" x="0" y="0" width="456" height="105" filterUnits="userSpaceOnUse"><feOffset dy="8" input="SourceAlpha"/><feGaussianBlur stdDeviation="8" result="blur"/><feFlood flood-color="#014890" flood-opacity="0.569"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs><g id="buycrypto_changelly_button_2" transform="translate(-1210.5 -971.5)"><g transform="matrix(1, 0, 0, 1, 1210.5, 971.5)" filter="url(#Rectangle_17062)"><rect id="Rectangle_17062-2" data-name="Rectangle 17062" width="405" height="54" rx="14" transform="translate(25.5 17.5)" fill="#1e2067" stroke="#404286" stroke-width="3"/></g><g id="Path_4964" data-name="Path 4964" transform="translate(1236 989)" fill="#00aa7c"><path d="M 158.2425537109375 53 L 14.00000095367432 53 C 10.527587890625 53 7.26300048828125 51.64776229858398 4.807609081268311 49.19239044189453 C 2.352239608764648 46.73699951171875 1.000000476837158 43.472412109375 1.000000476837158 40 L 1.000000476837158 14 C 1.000000476837158 10.52758693695068 2.352239608764648 7.263000011444092 4.807609081268311 4.807608604431152 C 7.26300048828125 2.35223913192749 10.527587890625 1 14.00000095367432 1 L 158.2419891357422 1 L 165.5481872558594 27.0367374420166 L 158.2425537109375 53 Z" stroke="none"/><path d="M 14 2 C 10.794677734375 2 7.781204223632812 3.248226165771484 5.51470947265625 5.514728546142578 C 3.24822998046875 7.781227111816406 2 10.79468154907227 2 14 L 2 40 C 2 43.20531845092773 3.24822998046875 46.21877288818359 5.51470947265625 48.48527145385742 C 7.781204223632812 50.75177383422852 10.794677734375 52 14 52 L 157.485107421875 52 L 164.5094604492188 27.03636360168457 L 157.4839782714844 2 L 14 2 M 14 0 L 159 0 L 166.5869140625 27.03711318969727 L 159 54 L 14 54 C 6.26800537109375 54 0 47.73197937011719 0 40 L 0 14 C 0 6.268024444580078 6.26800537109375 0 14 0 Z" stroke="none" fill="#404286"/></g><g id="Group_9362" data-name="Group 9362" transform="translate(92 -128)"><path id="Path_4966" data-name="Path 4966" d="M1.885-14.277H6.123a8.044,8.044,0,0,1,4.263.859A3.009,3.009,0,0,1,11.7-10.7a3.29,3.29,0,0,1-.645,2.08A2.882,2.882,0,0,1,9.2-7.578v.1a3.684,3.684,0,0,1,2.212,1.118A3.382,3.382,0,0,1,12.119-4.1a3.665,3.665,0,0,1-1.343,3.013A5.776,5.776,0,0,1,7.041,0H1.885Zm2.334,5.9H6.465A3.846,3.846,0,0,0,8.6-8.843a1.777,1.777,0,0,0,.674-1.577,1.58,1.58,0,0,0-.728-1.455,4.544,4.544,0,0,0-2.31-.449H4.219Zm0,1.895v4.521H6.7a3.651,3.651,0,0,0,2.212-.562A2.073,2.073,0,0,0,9.658-4.3,1.882,1.882,0,0,0,8.9-5.947a4.037,4.037,0,0,0-2.314-.537ZM22.461,0l-.322-1.416h-.117A3.256,3.256,0,0,1,20.659-.234,4.555,4.555,0,0,1,18.643.2a3.959,3.959,0,0,1-2.93-.977,4.048,4.048,0,0,1-.967-2.959V-10.8h2.314v6.66a2.889,2.889,0,0,0,.508,1.86,1.939,1.939,0,0,0,1.592.62,2.534,2.534,0,0,0,2.124-.864,4.762,4.762,0,0,0,.679-2.9V-10.8h2.3V0ZM25.9-10.8h2.5l2.2,6.123a11.618,11.618,0,0,1,.664,2.461h.078a10.265,10.265,0,0,1,.322-1.3q.234-.767,2.48-7.28h2.48L32,1.436Q30.742,4.8,27.8,4.8a6.608,6.608,0,0,1-1.484-.166V2.822a5.378,5.378,0,0,0,1.182.117,2.42,2.42,0,0,0,2.334-1.924L30.234,0ZM47.813.2a4.729,4.729,0,0,1-3.726-1.431,5.977,5.977,0,0,1-1.274-4.106,6.011,6.011,0,0,1,1.333-4.189A4.945,4.945,0,0,1,48-11a7.22,7.22,0,0,1,3.076.635l-.693,1.846a6.95,6.95,0,0,0-2.4-.566q-2.8,0-2.8,3.721a4.456,4.456,0,0,0,.7,2.729,2.417,2.417,0,0,0,2.046.913,5.87,5.87,0,0,0,2.9-.762v2a4.532,4.532,0,0,1-1.313.518A7.882,7.882,0,0,1,47.813.2ZM58.838-11a5.524,5.524,0,0,1,1.143.1L59.756-8.76a4.337,4.337,0,0,0-1.016-.117,2.939,2.939,0,0,0-2.231.9,3.248,3.248,0,0,0-.854,2.334V0H53.359V-10.8h1.8l.3,1.9h.117a4.279,4.279,0,0,1,1.4-1.533A3.331,3.331,0,0,1,58.838-11Zm1.5.2h2.5l2.2,6.123A11.618,11.618,0,0,1,65.7-2.217h.078a10.265,10.265,0,0,1,.322-1.3q.234-.767,2.48-7.28h2.48L66.445,1.436Q65.186,4.8,62.246,4.8a6.608,6.608,0,0,1-1.484-.166V2.822a5.378,5.378,0,0,0,1.182.117,2.42,2.42,0,0,0,2.334-1.924L64.678,0ZM78.184.2A3.783,3.783,0,0,1,75-1.279h-.137Q75,.088,75,.381V4.8H72.705V-10.8h1.855q.078.3.322,1.445H75A3.6,3.6,0,0,1,78.223-11a3.749,3.749,0,0,1,3.149,1.465A6.6,6.6,0,0,1,82.5-5.42a6.609,6.609,0,0,1-1.147,4.131A3.783,3.783,0,0,1,78.184.2Zm-.557-9.316a2.385,2.385,0,0,0-2,.8A4.15,4.15,0,0,0,75-5.762v.342a5.052,5.052,0,0,0,.625,2.856,2.325,2.325,0,0,0,2.041.884A2.072,2.072,0,0,0,79.5-2.656a5.043,5.043,0,0,0,.645-2.783,4.866,4.866,0,0,0-.64-2.749A2.134,2.134,0,0,0,77.627-9.121ZM89.189-1.66a5.581,5.581,0,0,0,1.68-.264V-.2a4.633,4.633,0,0,1-.981.278A6.762,6.762,0,0,1,88.643.2q-3.262,0-3.262-3.437v-5.82H83.906v-1.016l1.582-.84L86.27-13.2h1.416v2.4h3.076v1.738H87.686v5.781A1.622,1.622,0,0,0,88.1-2.056,1.513,1.513,0,0,0,89.189-1.66Zm13.418-3.76a5.9,5.9,0,0,1-1.357,4.131A4.864,4.864,0,0,1,97.471.2a5.178,5.178,0,0,1-2.676-.684,4.513,4.513,0,0,1-1.787-1.963,6.685,6.685,0,0,1-.625-2.969,5.855,5.855,0,0,1,1.348-4.1A4.886,4.886,0,0,1,97.529-11a4.758,4.758,0,0,1,3.711,1.509A5.828,5.828,0,0,1,102.607-5.42Zm-7.861,0q0,3.74,2.764,3.74,2.734,0,2.734-3.74,0-3.7-2.754-3.7a2.348,2.348,0,0,0-2.095.957A4.87,4.87,0,0,0,94.746-5.42ZM10.5,22,9.1,16.961q-.254-.8-.918-3.721H8.1q-.566,2.637-.9,3.74L5.762,22H3.223L.2,11.2H2.539l1.377,5.322q.469,1.973.664,3.379h.059q.1-.713.3-1.636t.347-1.382L6.924,11.2h2.52l1.592,5.684q.146.479.366,1.465a11.271,11.271,0,0,1,.259,1.533h.078a29.968,29.968,0,0,1,.684-3.359l1.4-5.322h2.3L13.076,22Zm9.775,0H17.979V11.2h2.295ZM17.842,8.338a1.271,1.271,0,0,1,.337-.947,1.313,1.313,0,0,1,.962-.332,1.285,1.285,0,0,1,.942.332,1.271,1.271,0,0,1,.337.947,1.247,1.247,0,0,1-.337.923,1.274,1.274,0,0,1-.942.337,1.3,1.3,0,0,1-.962-.337A1.247,1.247,0,0,1,17.842,8.338Zm9.736,12a5.581,5.581,0,0,0,1.68-.264V21.8a4.633,4.633,0,0,1-.981.278,6.762,6.762,0,0,1-1.245.112q-3.262,0-3.262-3.437v-5.82H22.295V11.922l1.582-.84L24.658,8.8h1.416v2.4H29.15v1.738H26.074v5.781a1.622,1.622,0,0,0,.415,1.226A1.513,1.513,0,0,0,27.578,20.34ZM40.918,22h-2.3V15.359a2.906,2.906,0,0,0-.5-1.865,1.944,1.944,0,0,0-1.6-.615,2.534,2.534,0,0,0-2.124.864,4.762,4.762,0,0,0-.679,2.9V22H31.416V6.8h2.295v3.857a18,18,0,0,1-.117,1.982h.146a3.187,3.187,0,0,1,1.3-1.211A4.2,4.2,0,0,1,36.992,11q3.926,0,3.926,3.955Zm13.867.2A3.783,3.783,0,0,1,51.6,20.721h-.137q.137,1.367.137,1.66V26.8H49.307V11.2h1.855q.078.3.322,1.445H51.6A3.6,3.6,0,0,1,54.824,11a3.749,3.749,0,0,1,3.149,1.465A6.6,6.6,0,0,1,59.1,16.58a6.609,6.609,0,0,1-1.147,4.131A3.783,3.783,0,0,1,54.785,22.2Zm-.557-9.316a2.385,2.385,0,0,0-2,.8,4.15,4.15,0,0,0-.63,2.559v.342a5.052,5.052,0,0,0,.625,2.856,2.325,2.325,0,0,0,2.041.884,2.072,2.072,0,0,0,1.836-.977,5.043,5.043,0,0,0,.645-2.783,4.866,4.866,0,0,0-.64-2.749A2.134,2.134,0,0,0,54.229,12.879ZM68.525,22l-.459-1.5h-.078a4.425,4.425,0,0,1-1.572,1.343,4.972,4.972,0,0,1-2.031.356,3.438,3.438,0,0,1-2.485-.859,3.216,3.216,0,0,1-.894-2.432,2.855,2.855,0,0,1,1.24-2.52,7.151,7.151,0,0,1,3.779-.928l1.865-.059v-.576a2.184,2.184,0,0,0-.483-1.548,1.971,1.971,0,0,0-1.5-.513,5.183,5.183,0,0,0-1.592.244,12.012,12.012,0,0,0-1.465.576l-.742-1.641a7.988,7.988,0,0,1,1.924-.7A8.853,8.853,0,0,1,66.006,11a4.672,4.672,0,0,1,3.11.9,3.518,3.518,0,0,1,1.05,2.822V22Zm-3.418-1.562a2.843,2.843,0,0,0,2.007-.7,2.531,2.531,0,0,0,.757-1.958v-.937l-1.387.059a4.745,4.745,0,0,0-2.358.542,1.647,1.647,0,0,0-.737,1.479,1.444,1.444,0,0,0,.43,1.118A1.846,1.846,0,0,0,65.107,20.438ZM78.848,11a5.524,5.524,0,0,1,1.143.1l-.225,2.139a4.337,4.337,0,0,0-1.016-.117,2.939,2.939,0,0,0-2.231.9,3.247,3.247,0,0,0-.854,2.334V22H73.369V11.2h1.8l.3,1.9h.117a4.279,4.279,0,0,1,1.4-1.533A3.331,3.331,0,0,1,78.848,11Zm7.168,9.336a5.581,5.581,0,0,0,1.68-.264V21.8a4.633,4.633,0,0,1-.981.278,6.762,6.762,0,0,1-1.245.112q-3.262,0-3.262-3.437v-5.82H80.732V11.922l1.582-.84L83.1,8.8h1.416v2.4h3.076v1.738H84.512v5.781a1.622,1.622,0,0,0,.415,1.226A1.513,1.513,0,0,0,86.016,20.34ZM99.355,22h-2.3V15.359a2.906,2.906,0,0,0-.5-1.865,1.944,1.944,0,0,0-1.6-.615,2.539,2.539,0,0,0-2.129.859,4.745,4.745,0,0,0-.674,2.881V22H89.854V11.2h1.8l.322,1.416h.117a3.2,3.2,0,0,1,1.387-1.191A4.647,4.647,0,0,1,95.469,11q3.887,0,3.887,3.955Zm7.91.2a5.225,5.225,0,0,1-3.94-1.47,5.579,5.579,0,0,1-1.421-4.048,6.121,6.121,0,0,1,1.318-4.16A4.554,4.554,0,0,1,106.846,11a4.451,4.451,0,0,1,3.379,1.3,4.963,4.963,0,0,1,1.24,3.574v1.24h-7.2a3.548,3.548,0,0,0,.85,2.417,2.959,2.959,0,0,0,2.256.845,8.328,8.328,0,0,0,1.782-.181,9.342,9.342,0,0,0,1.772-.6v1.865a7.046,7.046,0,0,1-1.7.566A10.419,10.419,0,0,1,107.266,22.2Zm-.42-9.453a2.306,2.306,0,0,0-1.753.693,3.3,3.3,0,0,0-.786,2.021h4.9a2.99,2.99,0,0,0-.645-2.026A2.2,2.2,0,0,0,106.846,12.742ZM119.551,11a5.524,5.524,0,0,1,1.143.1l-.225,2.139a4.337,4.337,0,0,0-1.016-.117,2.939,2.939,0,0,0-2.231.9,3.247,3.247,0,0,0-.854,2.334V22h-2.295V11.2h1.8l.3,1.9h.117a4.279,4.279,0,0,1,1.4-1.533A3.331,3.331,0,0,1,119.551,11Z" transform="translate(1162 1140.082)" fill="#fff"/></g><g id="Group_9365" data-name="Group 9365" transform="translate(968.893 1263.791)"><g id="Group_9363" data-name="Group 9363" transform="translate(521.456 -262.022)"><path id="Path_4932" data-name="Path 4932" d="M834.608-221.765a5.5,5.5,0,0,0-2.222-4.1,6.45,6.45,0,0,0-7.2-.055,22.17,22.17,0,0,0-1.835,1.665c0-.381,0-.737,0-1.093,0-2.3,0-4.6,0-6.893,0-.276.117-.611-.256-.763l-2.062,1.042v20.933h2.32v-.921c0-2.691.006-5.383,0-8.074a4.613,4.613,0,0,1,.482-2.274,4.538,4.538,0,0,1,5.013-2.453,3.671,3.671,0,0,1,3.078,2.413,6.5,6.5,0,0,1,.369,2.406c.006,2.757,0,5.515.006,8.272a6.333,6.333,0,0,0,.064.642h2.283v-1q0-3.693,0-7.386A22.446,22.446,0,0,0,834.608-221.765Z" transform="translate(-803.899 233.019)" fill="#fff"/><path id="Path_4933" data-name="Path 4933" d="M1338.023-200.18l-4.99,12.9-5.645-12.9h-2.607c2.375,5.2,4.714,10.325,7.059,15.46-.733,2.165-2.088,3.908-5.628,2.437l-.767,1.726a1.811,1.811,0,0,0,.265.225,6.789,6.789,0,0,0,3.427.637,4.108,4.108,0,0,0,2.9-1.222,10.963,10.963,0,0,0,2.241-3.874c1.455-3.557,2.892-7.121,4.339-10.681.632-1.557,1.268-3.112,1.921-4.712Z" transform="translate(-1208.396 206.666)" fill="#fff"/><path id="Path_4934" data-name="Path 4934" d="M1007.747-197.945a5.854,5.854,0,0,0-1.472-2.723,5.313,5.313,0,0,0-3.278-1.593,5.9,5.9,0,0,0-5.653,1.939c-.211.25-.457.47-.827.846V-201.9h-2.275v15.516h2.32v-1.141q0-3.889,0-7.778a5.1,5.1,0,0,1,.72-2.708,4.536,4.536,0,0,1,4.126-2.176,3.964,3.964,0,0,1,4.025,3.4c.064.615.16,1.231.164,1.848.019,2.593.007,5.185.01,7.778,0,.252.029.5.045.753h2.271a2.743,2.743,0,0,0,.049-.342c0-3.151.01-6.3-.011-9.452A7.511,7.511,0,0,0,1007.747-197.945Z" transform="translate(-942.98 208.397)" fill="#fff"/><path id="Path_4935" data-name="Path 4935" d="M746.948-190.445a.811.811,0,0,0-.154.069c-.048.043-.089.094-.135.139a5.959,5.959,0,0,1-4.888,2.024,5.414,5.414,0,0,1-4.222-2.495,6.273,6.273,0,0,1-.922-4.945,5.857,5.857,0,0,1,2.7-3.916,5.77,5.77,0,0,1,6.651.689c.286.263.573.524.915.838l1.454-1.525a8.017,8.017,0,0,0-9.45-2.2,8.048,8.048,0,0,0-4.818,8.145,7.9,7.9,0,0,0,5.874,7.288,7.773,7.773,0,0,0,8.471-2.808A6.813,6.813,0,0,0,746.948-190.445Z" transform="translate(-734.055 208.493)" fill="#fff"/><path id="Path_4936" data-name="Path 4936" d="M1300.2-231.949v14.543c0,1.836,0,3.672.005,5.508a6.466,6.466,0,0,0,.1.815h2.215c.169-3.114.094-21.21-.093-22.014Z" transform="translate(-1188.66 233.098)" fill="#fff"/><path id="Path_4937" data-name="Path 4937" d="M1267.178-207.064h2.265v-21l-2.265,1.1Z" transform="translate(-1162.142 229.057)" fill="#fff"/><path id="Path_4938" data-name="Path 4938" d="M1092.159-201.962v2.4l-.219.153a6.274,6.274,0,0,0-.4-.558,7.1,7.1,0,0,0-4.388-2.355,7.38,7.38,0,0,0-8.221,5.27,9.029,9.029,0,0,0-.166,3.218,6.708,6.708,0,0,0,2.455,4.508,7.425,7.425,0,0,0,10.323-.739,7.678,7.678,0,0,1,.6-.543c0,.912.055,1.7-.013,2.48a4.96,4.96,0,0,1-1.373,3.059,5.43,5.43,0,0,1-3.887,1.575,10.157,10.157,0,0,1-5.935-1.673c-.154-.095-.311-.183-.5-.294l-1.053,1.852c.16.091.276.153.387.221a12.435,12.435,0,0,0,9.405,1.629,6.26,6.26,0,0,0,4.183-2.838,8.2,8.2,0,0,0,1.162-4.385q0-6.2,0-12.4c0-.188-.026-.375-.041-.576Zm-2.134,11.177a6.689,6.689,0,0,1-3.488,1.135,5.292,5.292,0,0,1-5.278-4,5.155,5.155,0,0,1,4.689-6.6,5.986,5.986,0,0,1,4.166,1.106A5.113,5.113,0,0,1,1090.026-190.786Z" transform="translate(-1010.79 208.451)" fill="#fff"/><path id="Path_4939" data-name="Path 4939" d="M916.127-200a5.687,5.687,0,0,0-3.514-1.545,17.448,17.448,0,0,0-3.241.009,10.784,10.784,0,0,0-3.966,1.25l.748,1.866c.275-.117.449-.2.628-.267a10.161,10.161,0,0,1,5.441-.717,3.667,3.667,0,0,1,3.13,4.52,17.191,17.191,0,0,0-5.407-.577,8.919,8.919,0,0,0-3.47.906,4.714,4.714,0,0,0-.4,8.039,7.04,7.04,0,0,0,6.912.443,16.9,16.9,0,0,0,2.5-1.649v1.912h2.332c0-1,0-1.881,0-2.765,0-2.394.014-4.789,0-7.183A5.664,5.664,0,0,0,916.127-200Zm-3.48,12.255a6.03,6.03,0,0,1-4.2.059,3.035,3.035,0,0,1-2.035-2.414,3.007,3.007,0,0,1,1.79-2.978,7.261,7.261,0,0,1,3.918-.49l3.228.481C915.978-190.325,914.827-188.537,912.647-187.748Z" transform="translate(-870.525 207.821)" fill="#fff"/><path id="Path_4940" data-name="Path 4940" d="M1185.882-201.679a7.335,7.335,0,0,0-9.845,3.379,8.772,8.772,0,0,0-.831,5.61,7.592,7.592,0,0,0,3.163,5.22,8.062,8.062,0,0,0,8.716.4,6.674,6.674,0,0,0,2.288-1.912l-1.406-1.323c-.254.215-.431.356-.6.507a6.329,6.329,0,0,1-5.416,1.606,5.355,5.355,0,0,1-4.4-5.121h12.274a9.278,9.278,0,0,0-.414-4.112A6.85,6.85,0,0,0,1185.882-201.679Zm-8.385,6.349a6.21,6.21,0,0,1,1.481-3.417,4.621,4.621,0,0,1,4.876-1.491,4.812,4.812,0,0,1,3.393,3.593,11.762,11.762,0,0,1,.248,1.4A74,74,0,0,1,1177.5-195.33Z" transform="translate(-1088.175 208.471)" fill="#fff"/></g><g id="Group_9364" data-name="Group 9364" transform="translate(469.292 -269.119)"><path id="Path_4941" data-name="Path 4941" d="M482.027-120.857a30.1,30.1,0,0,1-9.216.293c.011-.109-.005-.187.026-.232a20.494,20.494,0,0,0,2.715-5.789c.813-2.611,1.669-5.208,2.506-7.811l-.091-.149c-.153.119-.361.206-.451.361a37.66,37.66,0,0,0-2.768,5.653,25.075,25.075,0,0,1-4.231,7.844c-.395.457-.752.946-1.226,1.548,1.555.2,2.96.477,4.375.555a29.758,29.758,0,0,0,6.73-.325,21.731,21.731,0,0,0,6.685-2.268,15.645,15.645,0,0,0,3.061-2.243c.234-.213.533-.427.217-.916A22.019,22.019,0,0,1,482.027-120.857Z" transform="translate(-469.292 161.058)" fill="#0fc270"/><path id="Path_4942" data-name="Path 4942" d="M547.391-269.119c-1.083.064-2.127.068-3.154.2-1.51.195-3.007.484-4.511.728a38.035,38.035,0,0,0-6.651,1.766,31.966,31.966,0,0,0-4.96,2.23,19.064,19.064,0,0,0-4.807,3.795c-.792.869-1.569,1.752-2.337,2.611-1.966.486-3.881.969-5.8,1.431a3.532,3.532,0,0,0-2.422,1.637c-.868,1.486-1.794,2.939-2.683,4.413-.461.765-.9,1.545-1.378,2.381a1.336,1.336,0,0,0,1.005-.232,18.959,18.959,0,0,1,3.822-1.412,4.19,4.19,0,0,1,3.065.022l1.047,4.184c-.174.153-.411.332-.613.545a3.008,3.008,0,0,0-.948,1.887c-.066,1.73-.021,3.464-.021,5.17.1.054.159.108.214.109,1.576.005,3.153.033,4.727-.013a2.667,2.667,0,0,0,1.273-.4,19.574,19.574,0,0,0,1.693-1.315,9.974,9.974,0,0,0,3.864,1.024,2.219,2.219,0,0,1,.388,1.9,15.054,15.054,0,0,1-1.057,3.626c-.376.779-.678,1.594-1.013,2.394l.121.11c.478-.271.963-.533,1.433-.817q2.756-1.665,5.5-3.346a3.366,3.366,0,0,0,1.538-2.177c.487-2.043.982-4.083,1.446-6.012.6-.517,1.074-.968,1.59-1.368a18.634,18.634,0,0,0,4.829-5.727,34.386,34.386,0,0,0,3.306-8.4,49.675,49.675,0,0,0,1.279-6.974c.119-1.131.242-2.262.343-3.394A2.056,2.056,0,0,0,547.391-269.119ZM517.1-251.4a8.517,8.517,0,0,0-4.272.051c.541-.868.985-1.585,1.435-2.3a2.07,2.07,0,0,1,1.5-.967c.983-.173,1.944-.474,2.915-.717a4.628,4.628,0,0,1,.462-.06Zm5.572,10.5c-.488.607-.955,1.3-1.808,1.412a15.215,15.215,0,0,1-1.844.014c1.055-1.539,2.325-2.676,3.184-4.218a1.011,1.011,0,0,0-.919.291q-1.478,1.2-2.962,2.384c-.12.1-.255.173-.467.315a3.782,3.782,0,0,1,.293-2.547,2.365,2.365,0,0,1,.415-.534c1.584-1.25,3.191-2.472,4.767-3.732a5.7,5.7,0,0,1,2.5-1.432c.568-.1,1.129-.245,1.831-.4-.083.5-.148.9-.214,1.294a5.808,5.808,0,0,1-1.317,2.78C524.951-243.837,523.84-242.345,522.676-240.9Zm10.041,4.491-2.79,1.8c-.316-.8.185-1.462.1-2.157s-.137-1.409-.2-2.024l3.84-1.965c.017.027.087.089.077.132C533.417-239.237,533.075-237.859,532.717-236.406Zm11.97-24.891c-.284,1.458-.651,2.906-1.078,4.329a25.676,25.676,0,0,1-4.73,9.316,22.023,22.023,0,0,1-2.928,2.755c-1.154.951-2.375,1.825-3.608,2.672a17.029,17.029,0,0,1-2.292,1.289,6.061,6.061,0,0,1-4.379.328,2.128,2.128,0,0,1-.443-.2c-.048-.027-.072-.1-.137-.2.858-1.08,1.717-2.182,2.6-3.265a6.371,6.371,0,0,0,1.375-2.757c.33-1.573.757-3.126,1.176-4.821-.348.086-.582.146-.817.2-1.418.334-2.83.689-4.254.991a5.579,5.579,0,0,0-2.4,1.231c-1.135.927-2.3,1.815-3.526,2.775a5.111,5.111,0,0,1-.415-3.712,12.21,12.21,0,0,1,1.5-3.266,36.393,36.393,0,0,1,5.022-6.246,18.961,18.961,0,0,1,5.672-3.746,37.037,37.037,0,0,1,7.751-2.507c1.8-.383,3.647-.6,5.473-.881.377-.059.755-.1,1.153-.159.069.167.171.292.155.4C545.28-264.943,545.039-263.109,544.687-261.3Z" transform="translate(-500.925 269.119)" fill="#0fc270"/><path id="Path_4943" data-name="Path 4943" d="M627.914-234.908c-2.916-.01-4.68,1.871-4.884,4.751a4.679,4.679,0,0,0,4.7,4.751,4.586,4.586,0,0,0,4.859-4.764A4.527,4.527,0,0,0,627.914-234.908Zm-.17,7.644a2.871,2.871,0,0,1-2.856-2.941,2.83,2.83,0,0,1,2.96-2.834,2.924,2.924,0,0,1,2.884,2.93A2.971,2.971,0,0,1,627.744-227.264Z" transform="translate(-592.74 241.648)" fill="#0fc270"/></g></g><path id="Union_401" data-name="Union 401" d="M4285,13420.6l11.646-25.631h10.7L4294.6,13420.6Zm11.646-25.631L4285,13369h9.605l12.737,25.972Z" transform="translate(-2896.869 -12378.918)" fill="#00ff80"/></g></svg>',
    crypto_icons: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="auto" viewBox="0 0 211 32"><g id="crypto_icon" clip-path="url(#clip-crypto_icon)"><g id="Group_9441" data-name="Group 9441" transform="translate(-1478.189 -544)"><g id="Group_9389" data-name="Group 9389" transform="translate(1549 567.365)"><path id="Subtraction_3" data-name="Subtraction 3" d="M7204.794,16636.2a12.784,12.784,0,0,1-.019-25.568,12.864,12.864,0,0,1,3.1.383,12.778,12.778,0,0,1,4.718,22.518A12.834,12.834,0,0,1,7204.794,16636.2Zm-2.354-7.861v0c.4.107.79.207,1.118.291l-.572,2.3,1.4.346.581-2.326a9.919,9.919,0,0,0,1.836.2,2.924,2.924,0,0,0,3.112-2.09,2.454,2.454,0,0,0-1.29-3.4,2.239,2.239,0,0,0,1.791-2.059c.22-1.467-.672-2.494-2.81-3.229l.572-2.3-1.4-.346-.56,2.242c-.313-.078-.681-.164-1.123-.262l.564-2.262-1.4-.35-.572,2.3c-.074-.018-.146-.035-.219-.051-.043-.01-.085-.02-.128-.031l-.189-.043c-.122-.027-.242-.055-.362-.084v-.008l-1.933-.484-.372,1.5c.009,0,1.011.232,1.019.256a.741.741,0,0,1,.651.813c-.272,1.088-.5,2-.729,2.924l-.171.688c-.205.824-.419,1.684-.674,2.7a.521.521,0,0,1-.48.355.8.8,0,0,1-.163-.021c-.038,0-.717-.18-.94-.238l-.078-.02-.7,1.605,1.825.455c.182.045.362.092.537.139l.058.016c.138.037.275.072.406.105l-.58,2.33,1.4.35.576-2.307Zm3.059-1.221h-.01a9.685,9.685,0,0,1-2.329-.4l-.066-.016c-.072-.02-.137-.037-.194-.051l.769-3.086.256.059.094.023c.88.2,2.517.564,3.06,1.443a1.259,1.259,0,0,1,.139,1C7207.046,16626.773,7206.468,16627.121,7205.5,16627.121Zm.619-4.586a7.544,7.544,0,0,1-1.862-.318l-.012,0-.225-.059.7-2.8c.077.02.175.041.3.07.764.172,2.04.459,2.5,1.207a1.194,1.194,0,0,1,.124.945C7207.488,16622.211,7206.974,16622.535,7206.117,16622.535Z" transform="translate(-7192 -16610.635)" fill="#fff"/></g><g id="Group_9390" data-name="Group 9390" transform="translate(1497 567)"><path id="Path_2" data-name="Path 2" d="M84.776-413.374a10.372,10.372,0,0,1,2.667-6.943,13.223,13.223,0,0,1,9.865-4.4,13.258,13.258,0,0,1,11.012,5.87,12.446,12.446,0,0,0-8.966-3.715c-6.648,0-12.045,5.006-12.045,11.172a10.853,10.853,0,0,0,4.65,8.8,11.968,11.968,0,0,1-7.183-10.783Z" transform="translate(-84.776 424.72)" fill="#fff" fill-rule="evenodd"/><path id="Path_3" data-name="Path 3" d="M126.183-358.313a10.373,10.373,0,0,1-2.667,6.943,13.223,13.223,0,0,1-9.864,4.4,13.258,13.258,0,0,1-11.012-5.87,12.446,12.446,0,0,0,8.966,3.715c6.648,0,12.045-5.006,12.045-11.172a10.853,10.853,0,0,0-4.65-8.8,11.968,11.968,0,0,1,7.183,10.784Z" transform="translate(-101.294 373.286)" fill="#fff" fill-rule="evenodd"/><path id="Path_4" data-name="Path 4" d="M184.352-321.846h0a2.793,2.793,0,0,1-2.793,2.793h-1.4v6.982a2.793,2.793,0,0,1-.818,1.975,2.793,2.793,0,0,1-1.975.818h0v-9.775H173.18a2.793,2.793,0,0,1,2.793-2.793Z" transform="translate(-166.521 329.594)" fill="#fff" fill-rule="evenodd"/></g><g id="Group_94" data-name="Group 94" transform="translate(1647 567)"><path id="Subtraction_4" data-name="Subtraction 4" d="M7107.042,16637.07a13.031,13.031,0,0,1-12.65-16.186,12.888,12.888,0,0,1,4.678-7.162,12.985,12.985,0,0,1,11.114-2.33,13.028,13.028,0,0,1,4.814,22.957A13.1,13.1,0,0,1,7107.042,16637.07Zm.015-18.67v0l4.375,2.52v6.227l-4.376,2.521v3.457l7.378-4.25v-9.684l-7.378-4.252-7.375,4.252,2.852,1.816,4.522-2.607Zm-.159,1.436-7.266,4.184,2.818,1.791v5.033l3.266,1.85v-8.719l3.979-2.293-2.8-1.846Z" transform="translate(-7094 -16611)" fill="#fff"/></g><g id="Etherium" transform="translate(1619.333 558.333)"><g id="Group_9438" data-name="Group 9438" transform="translate(-18.333 7.667)"><g id="Group_1155" data-name="Group 1155" transform="translate(10.367 16.167)"><path id="Path_4830" data-name="Path 4830" d="M0-91.881v7.631L9.367-97.408Z" transform="translate(0 98.408)" fill="#fff"/></g><g id="Group_1156" data-name="Group 1156" transform="translate(9.367 11.287)"><path id="Path_4831" data-name="Path 4831" d="M0-125.029v9.795l9.367-5.541Z" transform="translate(1 125.029)" fill="#fff"/></g><g id="Group_1157" data-name="Group 1157" transform="translate(10.367 -1)"><path id="Path_4832" data-name="Path 4832" d="M0-198.378v11.287l9.367,4.254Z" transform="translate(0 198.378)" fill="#fff"/></g><g id="Group_1158" data-name="Group 1158" transform="translate(0 17.167)"><path id="Path_4833" data-name="Path 4833" d="M-110.2-91.881v7.631l-9.367-13.157Z" transform="translate(119.57 97.408)" fill="#fff"/></g><g id="Group_1159" data-name="Group 1159" transform="translate(0 11.287)"><path id="Path_4834" data-name="Path 4834" d="M-110.2-125.029v9.795l-9.367-5.541Z" transform="translate(119.568 125.029)" fill="#fff"/></g><g id="Group_1160" data-name="Group 1160" transform="translate(0 -1)"><path id="Path_4835" data-name="Path 4835" d="M-110.2-198.378v11.287l-9.367,4.254Z" transform="translate(119.568 198.378)" fill="#fff"/></g></g></g></g></g></svg>',
    visa_master: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="211" height="72" viewBox="0 0 211 72"><defs><clipPath id="clip-path"><path id="Path_4920" data-name="Path 4920" d="M399.867-172.427a3.563,3.563,0,0,0-3.711,2.473q-5.061,12.071-10.121,24.142c-.472,1.125-.936,2.253-1.426,3.434,2.691,0,5.308.006,7.923-.017.138,0,.339-.221.4-.381.447-1.18.884-2.364,1.284-3.56a.656.656,0,0,1,.748-.542c2.9.023,5.8.032,8.707-.005.581-.007.748.195.841.716.224,1.255.508,2.5.773,3.773h7.237v-.214c-.234-1.014-.485-2.025-.7-3.043q-2.5-11.928-4.98-23.858c-.2-.969-.414-1.935-.624-2.916h-6.354Zm.8,8.347.093.018,2.293,10.994h-6.379Z" transform="translate(-384.609 172.427)" fill="#fff"/></clipPath><clipPath id="clip-path-2"><path id="Path_4922" data-name="Path 4922" d="M276.452-175.441a3.955,3.955,0,0,1-.449.106,14.021,14.021,0,0,0-7.457,2.894,8.557,8.557,0,0,0-3.335,7.9,7.036,7.036,0,0,0,3.15,5c1.32.951,2.8,1.675,4.2,2.525a19.089,19.089,0,0,1,2.619,1.722,2.162,2.162,0,0,1-.243,3.559,5.641,5.641,0,0,1-2.042.852,14.01,14.01,0,0,1-7.934-.989c-.535-.216-1.059-.46-1.617-.7l-1.4,6.562a1.813,1.813,0,0,0,.217.133c.214.087.427.177.647.249a24.6,24.6,0,0,0,10.056,1.14,14.655,14.655,0,0,0,6.888-2.225,9.042,9.042,0,0,0,4.274-9.236,7.087,7.087,0,0,0-3.412-5.072c-1.539-1.017-3.2-1.845-4.785-2.8a11.538,11.538,0,0,1-1.982-1.427,1.688,1.688,0,0,1,.052-2.67,4.982,4.982,0,0,1,1.851-.984,10.079,10.079,0,0,1,4.919.042c1.189.262,2.345.671,3.555,1.026l1.355-6.336c-.917-.261-1.762-.539-2.625-.738-.945-.218-1.908-.364-2.863-.541Z" transform="translate(-261.939 175.441)" fill="#fff"/></clipPath><clipPath id="clip-path-3"><path id="Path_4924" data-name="Path 4924" d="M28.12-172.011q-3.813,9.7-7.654,19.394c-.049.123-.123.236-.23.436-.069-.337-.12-.575-.165-.814q-1.548-8.205-3.1-16.41a3.579,3.579,0,0,0-3.729-3.066q-6.171,0-12.343,0c-.857,0-.857,0-.869.9.1.024.2.051.3.075a38.886,38.886,0,0,1,6.738,2.178,4.091,4.091,0,0,1,2.442,3c1.971,7.772,4,15.531,5.99,23.3.115.447.277.622.775.615,2.351-.032,4.7-.025,7.053-.005a.738.738,0,0,0,.823-.531q5.564-13.338,11.164-26.661c.39-.931.775-1.863,1.182-2.842-.219-.01-.373-.024-.527-.024H33.954c-1.714,0-3.428,0-5.142-.011H28.8A.617.617,0,0,0,28.12-172.011Z" transform="translate(-0.033 172.481)" fill="#fff"/></clipPath><clipPath id="clip-path-4"><path id="Path_4926" data-name="Path 4926" d="M194.445-172.246l-6.423,30.017h.64c2.137,0,4.275-.025,6.411.016.6.012.8-.171.921-.745q2.62-12.394,5.285-24.779c.319-1.493.637-2.987.961-4.51Z" transform="translate(-188.022 172.246)" fill="#fff"/></clipPath><clipPath id="clip-card_flags_icon"><rect width="211" height="72"/></clipPath></defs><g id="card_flags_icon" clip-path="url(#clip-card_flags_icon)"><g id="Group_9391" data-name="Group 9391" transform="translate(-1445 -718)"><g id="Group_9355" data-name="Group 9355" transform="translate(1462.705 738.2)"><g id="Group_9348" data-name="Group 9348" transform="translate(68.224 0.535)" clip-path="url(#clip-path)"><g id="Group_9347" data-name="Group 9347" transform="translate(-68.435 -0.593) rotate(-0.377)"><path id="Path_4919" data-name="Path 4919" d="M.205,0,96.348.633l-.205,31.183L0,31.183Z" transform="translate(0 0)" fill="#fff" stroke="#707070" stroke-width="2"/></g></g><g id="Group_9350" data-name="Group 9350" transform="translate(46.462 0)" clip-path="url(#clip-path-2)"><g id="Group_9349" data-name="Group 9349" transform="translate(-46.673 -0.059) rotate(-0.377)"><path id="Path_4921" data-name="Path 4921" d="M.205,0,96.348.633l-.205,31.183L0,31.183Z" transform="translate(0 0)" fill="#fff" stroke="#707070" stroke-width="2"/></g></g><g id="Group_9352" data-name="Group 9352" transform="translate(0 0.525)" clip-path="url(#clip-path-3)"><g id="Group_9351" data-name="Group 9351" transform="translate(-0.211 -0.584) rotate(-0.377)"><path id="Path_4923" data-name="Path 4923" d="M.205,0,96.348.633l-.205,31.183L0,31.183Z" transform="translate(0 0)" fill="#fff" stroke="#707070" stroke-width="2"/></g></g><g id="Group_9354" data-name="Group 9354" transform="translate(33.349 0.567)" clip-path="url(#clip-path-4)"><g id="Group_9353" data-name="Group 9353" transform="translate(-33.56 -0.625) rotate(-0.377)"><path id="Path_4925" data-name="Path 4925" d="M.205,0,96.348.633l-.205,31.183L0,31.183Z" transform="translate(0 0)" fill="#fff" stroke="#707070" stroke-width="2"/></g></g></g><g id="Group_9356" data-name="Group 9356" transform="translate(1588.609 738.2)"><path id="Path_4927" data-name="Path 4927" d="M19.27-140.395a15.5,15.5,0,0,1,5.9-12.179,15.462,15.462,0,0,0-9.635-3.354A15.533,15.533,0,0,0,0-140.395a15.533,15.533,0,0,0,15.533,15.533,15.462,15.462,0,0,0,9.635-3.354,15.5,15.5,0,0,1-5.9-12.179" transform="translate(0 155.928)" fill="#e30c17"/><path id="Path_4928" data-name="Path 4928" d="M96.719-126.915a15.5,15.5,0,0,0,5.9,12.179,15.5,15.5,0,0,0,5.9-12.179,15.5,15.5,0,0,0-5.9-12.179,15.5,15.5,0,0,0-5.9,12.179" transform="translate(-77.449 142.448)" fill="#eb6009"/><path id="Path_4929" data-name="Path 4929" d="M135.959-155.928a15.462,15.462,0,0,0-9.635,3.354,15.5,15.5,0,0,1,5.9,12.179,15.5,15.5,0,0,1-5.9,12.179,15.461,15.461,0,0,0,9.635,3.354,15.533,15.533,0,0,0,15.533-15.533,15.533,15.533,0,0,0-15.533-15.533" transform="translate(-101.156 155.928)" fill="#f59f00"/></g></g></g></svg>',
    slips_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="211" height="72" viewBox="0 0 211 72"><defs><clipPath id="clip-slips_icon"><rect width="211" height="72"/></clipPath></defs>g id="slips_icon" clip-path="url(#clip-slips_icon)"><g id="Group_9496" data-name="Group 9496" transform="translate(-1479 -846)"><g id="Group_9494" data-name="Group 9494" transform="translate(10.281 -140.877)"><path id="Path_4973" data-name="Path 4973" d="M-17.633-4.361A4.06,4.06,0,0,1-19.164-1.01,6.65,6.65,0,0,1-23.423.215,10,10,0,0,1-27.871-.73V-3.824a18.327,18.327,0,0,0,2.691,1,7.963,7.963,0,0,0,2.014.29,2.864,2.864,0,0,0,1.681-.419A1.433,1.433,0,0,0-20.9-4.2a1.376,1.376,0,0,0-.258-.822,2.885,2.885,0,0,0-.757-.693A19.478,19.478,0,0,0-23.95-6.778a9.649,9.649,0,0,1-2.159-1.3,4.88,4.88,0,0,1-1.149-1.45,4.138,4.138,0,0,1-.43-1.934,4.059,4.059,0,0,1,1.413-3.276,5.87,5.87,0,0,1,3.9-1.192,9.221,9.221,0,0,1,2.336.29,16.06,16.06,0,0,1,2.326.816l-1.074,2.589a15.717,15.717,0,0,0-2.079-.72,6.691,6.691,0,0,0-1.617-.2,2.141,2.141,0,0,0-1.45.44,1.453,1.453,0,0,0-.5,1.149,1.423,1.423,0,0,0,.2.768,2.244,2.244,0,0,0,.65.634,20.1,20.1,0,0,0,2.111,1.1A8.4,8.4,0,0,1-18.45-6.956,4.12,4.12,0,0,1-17.633-4.361ZM-14.787,0V-15.705h3.33V-2.75h6.37V0ZM-2.358,0V-15.705H.972V0ZM8.255-8.314h1.1a3.649,3.649,0,0,0,2.3-.607,2.124,2.124,0,0,0,.763-1.767,2.178,2.178,0,0,0-.639-1.729,3,3,0,0,0-2-.559H8.255Zm7.52-2.492A4.8,4.8,0,0,1,14.19-6.929,6.777,6.777,0,0,1,9.684-5.586H8.255V0H4.925V-15.705H9.942a6.673,6.673,0,0,1,4.345,1.23A4.485,4.485,0,0,1,15.775-10.807ZM28.01-4.361A4.06,4.06,0,0,1,26.479-1.01,6.65,6.65,0,0,1,22.22.215,10,10,0,0,1,17.773-.73V-3.824a18.327,18.327,0,0,0,2.691,1,7.963,7.963,0,0,0,2.014.29,2.864,2.864,0,0,0,1.681-.419A1.433,1.433,0,0,0,24.745-4.2a1.376,1.376,0,0,0-.258-.822,2.885,2.885,0,0,0-.757-.693,19.478,19.478,0,0,0-2.036-1.063,9.649,9.649,0,0,1-2.159-1.3,4.88,4.88,0,0,1-1.149-1.45,4.138,4.138,0,0,1-.43-1.934,4.059,4.059,0,0,1,1.413-3.276,5.87,5.87,0,0,1,3.9-1.192,9.221,9.221,0,0,1,2.336.29,16.06,16.06,0,0,1,2.326.816l-1.074,2.589a15.717,15.717,0,0,0-2.079-.72,6.691,6.691,0,0,0-1.617-.2,2.141,2.141,0,0,0-1.45.44,1.453,1.453,0,0,0-.5,1.149,1.423,1.423,0,0,0,.2.768,2.244,2.244,0,0,0,.65.634,20.1,20.1,0,0,0,2.111,1.1,8.4,8.4,0,0,1,3.019,2.111A4.12,4.12,0,0,1,28.01-4.361Z" transform="translate(1579.199 1029.873)" fill="#fff"/><g id="slips_icon-2" data-name="slips_icon" transform="translate(1484.784 1010.376)"><g id="Rectangle_109" data-name="Rectangle 109" transform="translate(0)" fill="none" stroke="#fff" stroke-width="1"><rect width="61.386" height="22.966" rx="2" stroke="none"/><rect x="0.5" y="0.5" width="60.386" height="21.966" rx="1.5" fill="none"/></g><g id="Group_1014" data-name="Group 1014" transform="translate(5.25 5.578)"><path id="Path_4760" data-name="Path 4760" d="M4.982-5.193V-6.422a1.616,1.616,0,0,1-.843-.5,1.246,1.246,0,0,1-.268-.808,1.142,1.142,0,0,1,.3-.808,1.223,1.223,0,0,1,.808-.377V-9.2h.425v.29a1.258,1.258,0,0,1,.742.318,1.227,1.227,0,0,1,.352.7l-.742.1a.6.6,0,0,0-.352-.469v1.146a1.893,1.893,0,0,1,.959.494,1.168,1.168,0,0,1,.255.778A1.3,1.3,0,0,1,6.3-4.95a1.411,1.411,0,0,1-.893.446v.548H4.982V-4.49a1.357,1.357,0,0,1-.824-.378,1.556,1.556,0,0,1-.4-.894l.765-.082a.975.975,0,0,0,.176.4A.8.8,0,0,0,4.982-5.193Zm0-3.078a.55.55,0,0,0-.276.2.515.515,0,0,0-.1.311.492.492,0,0,0,.094.289.651.651,0,0,0,.284.215Zm.425,3.119a.6.6,0,0,0,.358-.2A.574.574,0,0,0,5.9-5.739a.519.519,0,0,0-.116-.339.741.741,0,0,0-.38-.218Z" transform="translate(-3.754 9.214)" fill="#fff"/><rect id="Rectangle_110" data-name="Rectangle 110" width="11.483" height="3.026" transform="translate(17.805) rotate(90)" fill="#fff"/><rect id="Rectangle_17066" data-name="Rectangle 17066" width="11.483" height="3.026" transform="translate(43.18) rotate(90)" fill="#fff"/><rect id="Rectangle_17065" data-name="Rectangle 17065" width="11.483" height="3.026" transform="translate(33.555) rotate(90)" fill="#fff"/><rect id="Rectangle_111" data-name="Rectangle 111" width="11.483" height="1.276" transform="translate(12.228) rotate(90)" fill="#fff"/><rect id="Rectangle_17063" data-name="Rectangle 17063" width="11.483" height="1.276" transform="translate(22.728) rotate(90)" fill="#fff"/><rect id="Rectangle_17067" data-name="Rectangle 17067" width="11.483" height="1.276" transform="translate(38.478) rotate(90)" fill="#fff"/><rect id="Rectangle_17064" data-name="Rectangle 17064" width="11.483" height="1.276" transform="translate(26.228) rotate(90)" fill="#fff"/><rect id="Rectangle_17068" data-name="Rectangle 17068" width="11.483" height="1.276" transform="translate(47.228) rotate(90)" fill="#fff"/><rect id="Rectangle_17069" data-name="Rectangle 17069" width="11.483" height="1.276" transform="translate(49.853) rotate(90)" fill="#fff"/><rect id="Rectangle_112" data-name="Rectangle 112" width="11.483" height="1.276" transform="translate(8.4) rotate(90)" fill="#fff"/></g></g></g><path id="Path_4974" data-name="Path 4974" d="M-28.277-4.383a12.106,12.106,0,0,1,.605-3.875,9.633,9.633,0,0,1,1.746-3.164h1.266a11.015,11.015,0,0,0-1.691,3.313A12.32,12.32,0,0,0-26.918-4.4,11.844,11.844,0,0,0-26.34-.734a11.375,11.375,0,0,0,1.664,3.266h-1.25a9.207,9.207,0,0,1-1.75-3.1A11.793,11.793,0,0,1-28.277-4.383Zm5.664-7.039h3.227a6.088,6.088,0,0,1,3.289.68,2.4,2.4,0,0,1,1.016,2.148,2.482,2.482,0,0,1-.566,1.676,2.727,2.727,0,0,1-1.652.855v.078q2.6.445,2.6,2.734A2.937,2.937,0,0,1-15.734-.859,4.406,4.406,0,0,1-18.629,0h-3.984Zm1.328,4.891H-19.1a3.561,3.561,0,0,0,2.023-.441,1.7,1.7,0,0,0,.617-1.488,1.506,1.506,0,0,0-.687-1.387,4.3,4.3,0,0,0-2.187-.426h-1.953Zm0,1.125v4.273H-18.9a3.394,3.394,0,0,0,2.082-.535,1.976,1.976,0,0,0,.7-1.676,1.775,1.775,0,0,0-.715-1.562,3.821,3.821,0,0,0-2.176-.5ZM-5.051-4.289A4.724,4.724,0,0,1-6.105-1.02,3.714,3.714,0,0,1-9.02.156a3.86,3.86,0,0,1-2.039-.539A3.558,3.558,0,0,1-12.434-1.93a5.391,5.391,0,0,1-.484-2.359,4.716,4.716,0,0,1,1.047-3.262A3.7,3.7,0,0,1-8.965-8.719a3.622,3.622,0,0,1,2.855,1.2A4.7,4.7,0,0,1-5.051-4.289Zm-6.523,0a4.064,4.064,0,0,0,.656,2.5,2.278,2.278,0,0,0,1.93.859,2.293,2.293,0,0,0,1.934-.855,4.043,4.043,0,0,0,.66-2.5,3.978,3.978,0,0,0-.66-2.48A2.32,2.32,0,0,0-9-7.617a2.283,2.283,0,0,0-1.922.836A4.023,4.023,0,0,0-11.574-4.289ZM-1.48,0h-1.3V-12.156h1.3ZM4.887.156A3.934,3.934,0,0,1,1.891-1a4.476,4.476,0,0,1-1.1-3.211A4.964,4.964,0,0,1,1.813-7.5,3.387,3.387,0,0,1,4.551-8.719,3.229,3.229,0,0,1,7.1-7.66a4.057,4.057,0,0,1,.938,2.793v.82h-5.9A3.394,3.394,0,0,0,2.9-1.758a2.635,2.635,0,0,0,2.035.781,6.9,6.9,0,0,0,2.734-.578V-.4a6.863,6.863,0,0,1-1.3.426A7.31,7.31,0,0,1,4.887.156ZM4.535-7.633a2.118,2.118,0,0,0-1.645.672A3.1,3.1,0,0,0,2.168-5.1H6.645A2.851,2.851,0,0,0,6.1-6.98,1.925,1.925,0,0,0,4.535-7.633ZM13.012-.914a4.236,4.236,0,0,0,.664-.051,4.3,4.3,0,0,0,.508-.105v.992a2.371,2.371,0,0,1-.621.168,4.664,4.664,0,0,1-.738.066q-2.484,0-2.484-2.617V-7.555H9.113V-8.18l1.227-.539.547-1.828h.75v1.984h2.484v1.008H11.637v5.039A1.734,1.734,0,0,0,12-1.328,1.278,1.278,0,0,0,13.012-.914ZM23.285-4.289A4.724,4.724,0,0,1,22.23-1.02,3.714,3.714,0,0,1,19.316.156a3.86,3.86,0,0,1-2.039-.539A3.558,3.558,0,0,1,15.9-1.93a5.391,5.391,0,0,1-.484-2.359,4.716,4.716,0,0,1,1.047-3.262,3.7,3.7,0,0,1,2.906-1.168,3.622,3.622,0,0,1,2.855,1.2A4.7,4.7,0,0,1,23.285-4.289Zm-6.523,0a4.064,4.064,0,0,0,.656,2.5,2.278,2.278,0,0,0,1.93.859,2.293,2.293,0,0,0,1.934-.855,4.043,4.043,0,0,0,.66-2.5,3.978,3.978,0,0,0-.66-2.48,2.32,2.32,0,0,0-1.949-.848,2.283,2.283,0,0,0-1.922.836A4.023,4.023,0,0,0,16.762-4.289Zm11.516-.094a11.773,11.773,0,0,1-.605,3.828,9.157,9.157,0,0,1-1.746,3.086h-1.25A11.253,11.253,0,0,0,26.34-.73,11.881,11.881,0,0,0,26.918-4.4a12.32,12.32,0,0,0-.566-3.711,11.015,11.015,0,0,0-1.691-3.312h1.266a9.584,9.584,0,0,1,1.75,3.176A12.164,12.164,0,0,1,28.277-4.383Z" transform="translate(1648.045 886.746)" fill="#fff"/></g></g></svg>',
    print_slip: '<svg xmlns="http://www.w3.org/2000/svg" width="28.019" height="25.823" viewBox="0 0 28.019 25.823"><g id="Group_9507" data-name="Group 9507" transform="translate(-25 369.495)"><path id="Path_4800" data-name="Path 4800" d="M5.474-365.048a6.347,6.347,0,0,1,.006-.9,3.8,3.8,0,0,1,3.534-3.534l.137,0c3.646-.011,5.895-.011,9.541,0a3.781,3.781,0,0,1,3.675,3.7v.74l1.022,0a4.758,4.758,0,0,1,4.388,3.191,4.71,4.71,0,0,1,.235,1.433c.013,3.947,0,3.7,0,7.649a4.745,4.745,0,0,1-2.024,3.838,4.719,4.719,0,0,1-2.6.814l-.832,0v2.943a1.528,1.528,0,0,1-1.472,1.49c-5.177.033-8.956,0-14.133,0a1.531,1.531,0,0,1-1.49-1.49v-2.945h-.8a4.77,4.77,0,0,1-4.389-3.111,4.706,4.706,0,0,1-.263-1.513c-.012-3.947,0-3.7,0-7.649a4.772,4.772,0,0,1,3.111-4.389,4.7,4.7,0,0,1,1.513-.263Zm1,12.644c0,1.751,0,5.426.011,7.233a.487.487,0,0,0,.464.464c5.174.033,8.951.033,14.125,0a.484.484,0,0,0,.464-.471V-352.4Zm13.662,5.274a.524.524,0,0,0-.524-.524H8.408a.524.524,0,0,0-.371.153.524.524,0,0,0-.153.371h0a.524.524,0,0,0,.524.524h11.2a.524.524,0,0,0,.524-.524Zm2.422-1.967.826,0a3.776,3.776,0,0,0,3.649-3.537c0-.038,0-.076,0-.114.013-3.953.013-3.712,0-7.665a3.77,3.77,0,0,0-3.515-3.648l-.137,0c-6.707-.021-12.017,0-18.724,0a3.779,3.779,0,0,0-3.672,3.515c0,.045,0,.091,0,.137-.012,3.953-.012,3.712,0,7.665A3.771,3.771,0,0,0,4.635-349.1l.826,0V-352.4H4.215a.524.524,0,0,1-.524-.524h0a.524.524,0,0,1,.524-.524H23.8a.524.524,0,0,1,.524.524h0a.524.524,0,0,1-.524.524H22.557Zm-2.422-.933a.524.524,0,0,0-.153-.371.524.524,0,0,0-.371-.153H8.408a.524.524,0,0,0-.371.153.524.524,0,0,0-.153.371h0a.524.524,0,0,0,.524.524h11.2a.524.524,0,0,0,.524-.524Zm4.193-10.517a.524.524,0,0,0-.524-.524h-.723a.524.524,0,0,0-.524.524h0a.524.524,0,0,0,.524.524H23.8a.524.524,0,0,0,.524-.524Zm-2.777-4.5q0-.377,0-.755a2.966,2.966,0,0,0-2.863-2.863c-3.637-.011-5.876,0-9.512,0a2.931,2.931,0,0,0-2.16.974,2.913,2.913,0,0,0-.722,1.908v.737C11.648-365.065,16.214-365.065,21.552-365.051Z" transform="translate(25 0)" fill="#fff" fill-rule="evenodd"/></g></svg>',
    DASH_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-9693,0)"><g id="dash_icon" transform="matrix(0.328474,0,0,0.287282,9623.34,-16.4094)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><clipPath id="_clip1"><rect x="214.268" y="57.119" width="1522.19" height="1740.45"/></clipPath><g clip-path="url(#_clip1)"><g transform="matrix(1.52219,0,0,1.74045,-7631.11,3104.65)"><g transform="matrix(56.9143,0,0,56.9059,-7139.47,-21200.7)"><path d="M233.307,352.699C232.133,357.406 227.366,360.27 222.659,359.097C217.953,357.923 215.089,353.155 216.263,348.449C217.436,343.741 222.203,340.876 226.909,342.05C231.616,343.223 234.481,347.992 233.307,352.699Z" style="fill:rgb(10,110,184);"/></g><g transform="matrix(1,0,0,1,0,34)"><g transform="matrix(2.45736,0,0,2.51765,5465.01,-1086.19)"><path d="M0,-157.931L183.39,-157.931C201.733,-157.931 214.77,-139.978 209.046,-122.52L182.451,-41.392C174.356,-16.698 151.31,0 125.323,0L-51.772,0L-39.011,-38.927L125.828,-38.927L152.015,-118.807L-12.825,-118.807L0,-157.931Z" style="fill:white;"/></g><g transform="matrix(-0.756861,2.39526,2.3379,0.775433,5533.86,-1372.69)"><path d="M39.212,-64.122L76.631,-64.122L46.639,28.523L9.221,28.522L39.212,-64.122Z" style="fill:white;"/></g></g></g></g></g></g></svg>',
    LINK_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 501 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-4653,-6746)"><g id="link_icon" transform="matrix(0.328474,0,0,0.287282,4583.34,6729.59)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><g><g transform="matrix(2.96775,0,0,3.39327,-8198.48,-29500.4)"><g transform="matrix(0.996288,0,0,0.997637,3091.19,8711.67)"><clipPath id="_clip1"><path d="M222,128L-0.003,0.001L-0.003,255.998L222,128Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip1)"><rect x="0" y="0.001" width="222" height="255.997" style="fill:white;fill-opacity:0.45;"/></g></g><g transform="matrix(0.996306,0,0,0.997637,2870.01,8711.67)"><clipPath id="_clip2"><path d="M221.997,0L-0.003,127.999L221.997,256.001L221.997,0Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip2)"><rect x="0" y="0" width="221.997" height="256" style="fill:white;fill-opacity:0.3;"/></g></g><g transform="matrix(0.996288,0,0,0.997637,3091.19,8839.37)"><clipPath id="_clip3"><path d="M-0.003,128.002L221.996,256L221.996,-0.001L-0.003,128.002Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip3)"><rect x="0" y="0" width="221.996" height="256" style="fill:white;fill-opacity:0.6;"/></g></g><g transform="matrix(0.998549,0,0,0.997637,2870.01,8967.07)"><clipPath id="_clip4"><path d="M221.498,0.001L442.995,127.999L221.498,255.998L210.57,249.683L147.812,213.418L131.689,204.1L34.798,148.11L-0.007,127.999L16.1,118.694L105.935,66.78L147.812,42.581L197.968,13.596L221.498,0.001Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip4)"><rect x="0" y="0.001" width="442.995" height="255.997" style="fill:white;fill-opacity:0.8;"/></g></g><g transform="matrix(0.996324,0,0,0.997625,2870,8839.37)"><clipPath id="_clip5"><path d="M16.142,246.698L0.003,255.999L0.003,-0.001L222.003,128.003L167.31,159.541L167.31,159.536L16.142,246.698Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip5)"><rect x="0.003" y="0" width="221.997" height="255.999" style="fill:white;fill-opacity:0.6;"/></g></g><g transform="matrix(4.16667,0,0,4.16667,1382.02,8408.43)"><path d="M394.846,131.782C396.105,131.79 397.121,132.813 397.121,134.072L397.121,187.816L392.541,185.172L392.541,134.072C392.541,132.808 393.566,131.782 394.831,131.782L394.846,131.782ZM380.229,145.702C381.487,145.71 382.504,146.732 382.504,147.992L382.504,178.463C382.504,178.753 382.438,179.026 382.34,179.282L377.924,176.732L377.924,147.992C377.924,146.727 378.949,145.702 380.214,145.702L380.229,145.702ZM367.747,159.01C366.481,159.01 365.457,160.034 365.457,161.3L365.457,169.535L370.037,172.181L370.037,161.3C370.037,160.034 369.013,159.01 367.747,159.01Z" style="fill:white;fill-rule:nonzero;"/></g></g><g transform="matrix(86.6344,0,0,99.0169,-18498.7,-33785.3)"><path d="M233.307,352.699C232.133,357.406 227.366,360.27 222.659,359.097C217.953,357.923 215.089,353.155 216.263,348.449C217.436,343.741 222.203,340.876 226.909,342.05C231.616,343.223 234.481,347.992 233.307,352.699Z" style="fill:rgb(243,241,241);"/></g></g><g transform="matrix(23.3916,0,0,26.7455,-21410.4,-282896)"><path d="M957,10587L978.651,10599.5L978.651,10624.5L957,10637L935.349,10624.5L935.349,10599.5L957,10587ZM957,10596.8L970.128,10604.4L970.128,10619.6L957,10627.2L943.872,10619.6L943.872,10604.4L957,10596.8Z" style="fill:rgb(68,95,172);"/></g></g></g></svg>',
    XEM_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 501 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-18169,0)"><g id="nem_icon" transform="matrix(0.328474,0,0,0.287282,18099.1,-16.4094)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><clipPath id="_clip1"><rect x="214.268" y="57.119" width="1522.19" height="1740.45"/></clipPath><g clip-path="url(#_clip1)"><g transform="matrix(1.024,0,0,1.024,-5.14243,-1.37087)"><g transform="matrix(84.6039,0,0,96.7205,-18060.2,-33000.7)"><path d="M233.307,352.699C232.133,357.406 227.366,360.27 222.659,359.097C217.953,357.923 215.089,353.155 216.263,348.449C217.436,343.741 222.203,340.876 226.909,342.05C231.616,343.223 234.481,347.992 233.307,352.699Z" style="fill:rgb(243,241,241);"/></g><g transform="matrix(2.23415,0,0,2.56403,-7850.99,-6259.2)"><path d="M3942.3,3081.79C3934.61,3077.45 3810.56,3006 3744.35,2873.05C3685.98,2755.83 3691.91,2647 3691.91,2647C3691.91,2647 3752.75,2613.85 3813.41,2597.21C3870.68,2581.5 3942.68,2582 3942.68,2582L3942.89,2582C3947.16,2581.99 4016.46,2581.99 4071.95,2597.21C4132.61,2613.85 4193.44,2647 4193.44,2647C4193.44,2647 4199.37,2755.83 4141,2873.05C4072.66,3010.29 3942.68,3082 3942.68,3082L3942.3,3081.79Z" style="fill:rgb(243,241,241);"/><g transform="matrix(0.99783,0,0,0.993443,8.05367,17.0522)"><path d="M3718.52,2737.53C3710.67,2691.29 3712.36,2660.12 3712.36,2660.12C3712.36,2660.12 3768.09,2629.76 3823.64,2614.52C3876.1,2600.13 3942.04,2600.59 3942.04,2600.59L3942.23,2600.59C3945.23,2600.58 3983.1,2600.58 4023.49,2606.83C3971.58,2623.36 3933.45,2670.92 3930.96,2727.68C3930.96,2729.39 3930.92,2731.1 3930.84,2732.82L3930.84,2733L3930.83,2733C3930,2749.29 3925.41,2765.63 3916.7,2780.72C3887.32,2831.61 3822.15,2849.07 3771.26,2819.69C3740.28,2801.8 3721.69,2770.65 3718.52,2737.53Z" style="fill:rgb(243,175,20);"/><path d="M4009.29,2823.65C4008.1,2823.02 4006.91,2822.37 4005.74,2821.69C3954.85,2792.31 3937.39,2727.14 3966.77,2676.25C3992.02,2632.51 4043.72,2613.47 4090.06,2627.64L4090.12,2627.54C4141.84,2645.08 4173.14,2665.5 4173.14,2665.5C4173.14,2665.5 4171.58,2728.94 4157,2784.67C4143.23,2837.3 4109.86,2894.17 4109.86,2894.17L4109.77,2894.33C4108.28,2896.93 4089.34,2929.73 4063.73,2961.59C4075.05,2909.85 4054.45,2854.73 4009.29,2823.65Z" style="fill:rgb(55,184,123);"/><path d="M4007.65,3011.99C3970.32,3043.34 3941.19,3058.11 3941.19,3058.11C3941.19,3058.11 3887.04,3025.03 3846.06,2984.54C3807.37,2946.3 3774.8,2888.97 3774.8,2888.97L3774.7,2888.8C3773.19,2886.21 3754.26,2853.41 3739.47,2815.31C3779.2,2851.5 3838.37,2860.98 3888.34,2836.06C3920.37,2817.09 3961.44,2815.47 3995.95,2835.39C4046.84,2864.78 4064.3,2929.94 4034.92,2980.83C4027.73,2993.28 4018.4,3003.74 4007.65,3011.99Z" style="fill:rgb(0,141,181);"/></g></g></g></g></g></g></svg>',
    XTZ_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 501 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-7203,-6746)"><g id="xtz_icon" transform="matrix(0.328474,0,0,0.287282,7133.34,6729.59)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><g><g transform="matrix(2.96775,0,0,3.39327,-8198.48,-29500.4)"><g transform="matrix(0.996288,0,0,0.997637,3091.19,8711.67)"><clipPath id="_clip1"><path d="M222,128L-0.003,0.001L-0.003,255.998L222,128Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip1)"><rect x="0" y="0.001" width="222" height="255.997" style="fill:white;fill-opacity:0.45;"/></g></g><g transform="matrix(0.996306,0,0,0.997637,2870.01,8711.67)"><clipPath id="_clip2"><path d="M221.997,0L-0.003,127.999L221.997,256.001L221.997,0Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip2)"><rect x="0" y="0" width="221.997" height="256" style="fill:white;fill-opacity:0.3;"/></g></g><g transform="matrix(0.996288,0,0,0.997637,3091.19,8839.37)"><clipPath id="_clip3"><path d="M-0.003,128.002L221.996,256L221.996,-0.001L-0.003,128.002Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip3)"><rect x="0" y="0" width="221.996" height="256" style="fill:white;fill-opacity:0.6;"/></g></g><g transform="matrix(0.998549,0,0,0.997637,2870.01,8967.07)"><clipPath id="_clip4"><path d="M221.498,0.001L442.995,127.999L221.498,255.998L210.57,249.683L147.812,213.418L131.689,204.1L34.798,148.11L-0.007,127.999L16.1,118.694L105.935,66.78L147.812,42.581L197.968,13.596L221.498,0.001Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip4)"><rect x="0" y="0.001" width="442.995" height="255.997" style="fill:white;fill-opacity:0.8;"/></g></g><g transform="matrix(0.996324,0,0,0.997625,2870,8839.37)"><clipPath id="_clip5"><path d="M16.142,246.698L0.003,255.999L0.003,-0.001L222.003,128.003L167.31,159.541L167.31,159.536L16.142,246.698Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip5)"><rect x="0.003" y="0" width="221.997" height="255.999" style="fill:white;fill-opacity:0.6;"/></g></g><g transform="matrix(4.16667,0,0,4.16667,1382.02,8408.43)"><path d="M394.846,131.782C396.105,131.79 397.121,132.813 397.121,134.072L397.121,187.816L392.541,185.172L392.541,134.072C392.541,132.808 393.566,131.782 394.831,131.782L394.846,131.782ZM380.229,145.702C381.487,145.71 382.504,146.732 382.504,147.992L382.504,178.463C382.504,178.753 382.438,179.026 382.34,179.282L377.924,176.732L377.924,147.992C377.924,146.727 378.949,145.702 380.214,145.702L380.229,145.702ZM367.747,159.01C366.481,159.01 365.457,160.034 365.457,161.3L365.457,169.535L370.037,172.181L370.037,161.3C370.037,160.034 369.013,159.01 367.747,159.01Z" style="fill:white;fill-rule:nonzero;"/></g></g><g transform="matrix(86.6344,0,0,99.0169,-18498.7,-33785.3)"><path d="M233.307,352.699C232.133,357.406 227.366,360.27 222.659,359.097C217.953,357.923 215.089,353.155 216.263,348.449C217.436,343.741 222.203,340.876 226.909,342.05C231.616,343.223 234.481,347.992 233.307,352.699Z" style="fill:rgb(243,241,241);"/></g></g><g transform="matrix(5.88847,0,0,6.73278,-3508.64,-78730.8)"><path d="M726,11766L725.999,11766L725.999,11761C725.999,11761 725.794,11758 724.929,11756.4C722.73,11752.5 720,11752.4 720,11752.4L720,11749L734,11749C734,11749 742.998,11750.1 743,11759.7C743.001,11765.3 743,11771 743,11771L743,11784L816,11784L816,11784C816.482,11784 817.267,11784.2 818.111,11785C819.564,11786.5 820.598,11788.8 821.282,11790.5C821.821,11791.9 821.453,11793.5 820.356,11794.5L779.687,11832C780.275,11832 780.892,11832 781.546,11832C805.516,11832 824.976,11851.9 824.976,11876.5C824.976,11901.1 805.516,11921 781.546,11921C772.371,11921 763.856,11918.1 756.84,11913.1C752.747,11910.1 745.167,11901.2 744.634,11893C744.595,11892.6 744.575,11892.2 744.575,11891.8C744.575,11885.3 749.88,11880 756.414,11880C762.948,11880 768.254,11885.3 768.254,11891.8C768.254,11897.5 764.33,11902.2 759.075,11903.4C760.842,11909.2 770.455,11913 777.019,11913C794.566,11913 808.812,11896.9 808.812,11877C808.812,11857.1 794.566,11841 777.019,11841C775.765,11841 774.655,11841 773.645,11841.1C770.044,11842.2 767.262,11843.8 765.33,11845.3L762.076,11848.3C762.076,11848.3 761.485,11848.8 761.485,11848.8L758.414,11846.4L800.773,11793L743,11793L743,11847C746.167,11874.6 776,11852 776,11852L779,11855C779,11855 773.033,11871.1 749,11871C732.603,11871 725.693,11857.9 726,11849.2L726,11793L698,11793L698,11784L726,11784L726,11766Z" style="fill:rgb(30,88,191);"/></g></g></g></svg>',
    HT_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 501 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-5903,-6746)"><g id="ht_icon" transform="matrix(0.328474,0,0,0.287282,5833.34,6729.59)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><g><g transform="matrix(2.96775,0,0,3.39327,-8198.48,-29500.4)"><g transform="matrix(0.996288,0,0,0.997637,3091.19,8711.67)"><clipPath id="_clip1"><path d="M222,128L-0.003,0.001L-0.003,255.998L222,128Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip1)"><rect x="0" y="0.001" width="222" height="255.997" style="fill:white;fill-opacity:0.45;"/></g></g><g transform="matrix(0.996306,0,0,0.997637,2870.01,8711.67)"><clipPath id="_clip2"><path d="M221.997,0L-0.003,127.999L221.997,256.001L221.997,0Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip2)"><rect x="0" y="0" width="221.997" height="256" style="fill:white;fill-opacity:0.3;"/></g></g><g transform="matrix(0.996288,0,0,0.997637,3091.19,8839.37)"><clipPath id="_clip3"><path d="M-0.003,128.002L221.996,256L221.996,-0.001L-0.003,128.002Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip3)"><rect x="0" y="0" width="221.996" height="256" style="fill:white;fill-opacity:0.6;"/></g></g><g transform="matrix(0.998549,0,0,0.997637,2870.01,8967.07)"><clipPath id="_clip4"><path d="M221.498,0.001L442.995,127.999L221.498,255.998L210.57,249.683L147.812,213.418L131.689,204.1L34.798,148.11L-0.007,127.999L16.1,118.694L105.935,66.78L147.812,42.581L197.968,13.596L221.498,0.001Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip4)"><rect x="0" y="0.001" width="442.995" height="255.997" style="fill:white;fill-opacity:0.8;"/></g></g><g transform="matrix(0.996324,0,0,0.997625,2870,8839.37)"><clipPath id="_clip5"><path d="M16.142,246.698L0.003,255.999L0.003,-0.001L222.003,128.003L167.31,159.541L167.31,159.536L16.142,246.698Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip5)"><rect x="0.003" y="0" width="221.997" height="255.999" style="fill:white;fill-opacity:0.6;"/></g></g><g transform="matrix(4.16667,0,0,4.16667,1382.02,8408.43)"><path d="M394.846,131.782C396.105,131.79 397.121,132.813 397.121,134.072L397.121,187.816L392.541,185.172L392.541,134.072C392.541,132.808 393.566,131.782 394.831,131.782L394.846,131.782ZM380.229,145.702C381.487,145.71 382.504,146.732 382.504,147.992L382.504,178.463C382.504,178.753 382.438,179.026 382.34,179.282L377.924,176.732L377.924,147.992C377.924,146.727 378.949,145.702 380.214,145.702L380.229,145.702ZM367.747,159.01C366.481,159.01 365.457,160.034 365.457,161.3L365.457,169.535L370.037,172.181L370.037,161.3C370.037,160.034 369.013,159.01 367.747,159.01Z" style="fill:white;fill-rule:nonzero;"/></g></g><g transform="matrix(86.6344,0,0,99.0169,-18498.7,-33785.3)"><path d="M233.307,352.699C232.133,357.406 227.366,360.27 222.659,359.097C217.953,357.923 215.089,353.155 216.263,348.449C217.436,343.741 222.203,340.876 226.909,342.05C231.616,343.223 234.481,347.992 233.307,352.699Z" style="fill:rgb(243,241,241);"/></g></g><g transform="matrix(3.85803,0,0,4.41121,29416,-48662)"><g transform="matrix(1,0,0,1,-8028,0)"><path d="M652,11098C652,11098 707.702,11163.9 673,11219C638.298,11274.1 609.27,11292 623,11347C634.043,11391.3 639,11385 639,11385C639,11385 536.788,11340.5 567,11269C589.032,11216.9 628.911,11194.6 643,11155C655.564,11125.7 652,11098 652,11098Z" style="fill:rgb(29,32,66);"/></g><g transform="matrix(1,0,0,1,-8026,0)"><path d="M712,11214C712,11214 715.532,11233.6 685,11268C627.807,11332.5 685,11385.3 685,11385.3C685,11385.3 808.831,11317 712,11214Z" style="fill:rgb(60,166,222);"/></g></g></g>/g></svg>',
    LEO_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 501 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-8453,-6746)"><g id="leo_icon" transform="matrix(0.328474,0,0,0.287282,8383.34,6729.59)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><g><g transform="matrix(2.96775,0,0,3.39327,-8198.48,-29500.4)"><g transform="matrix(0.996288,0,0,0.997637,3091.19,8711.67)"><clipPath id="_clip1"><path d="M222,128L-0.003,0.001L-0.003,255.998L222,128Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip1)"><rect x="0" y="0.001" width="222" height="255.997" style="fill:rgb(12,24,31);fill-opacity:0.45;"/></g></g><g transform="matrix(0.996306,0,0,0.997637,2870.01,8711.67)"><clipPath id="_clip2"><path d="M221.997,0L-0.003,127.999L221.997,256.001L221.997,0Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip2)"><rect x="0" y="0" width="221.997" height="256" style="fill:rgb(12,24,31);fill-opacity:0.3;"/></g></g><g transform="matrix(0.996288,0,0,0.997637,3091.19,8839.37)"><clipPath id="_clip3"><path d="M-0.003,128.002L221.996,256L221.996,-0.001L-0.003,128.002Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip3)"><rect x="0" y="0" width="221.996" height="256" style="fill:rgb(12,24,31);fill-opacity:0.6;"/></g></g><g transform="matrix(0.998549,0,0,0.997637,2870.01,8967.07)"><clipPath id="_clip4"><path d="M221.498,0.001L442.995,127.999L221.498,255.998L210.57,249.683L147.812,213.418L131.689,204.1L34.798,148.11L-0.007,127.999L16.1,118.694L105.935,66.78L147.812,42.581L197.968,13.596L221.498,0.001Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip4)"><rect x="0" y="0.001" width="442.995" height="255.997" style="fill:rgb(12,24,31);fill-opacity:0.8;"/></g></g><g transform="matrix(0.996324,0,0,0.997625,2870,8839.37)"><clipPath id="_clip5"><path d="M16.142,246.698L0.003,255.999L0.003,-0.001L222.003,128.003L167.31,159.541L167.31,159.536L16.142,246.698Z" clip-rule="nonzero"/></clipPath><g clip-path="url(#_clip5)"><rect x="0.003" y="0" width="221.997" height="255.999" style="fill:rgb(12,24,31);fill-opacity:0.6;"/></g></g><g transform="matrix(4.16667,0,0,4.16667,1382.02,8408.43)"><path d="M394.846,131.782C396.105,131.79 397.121,132.813 397.121,134.072L397.121,187.816L392.541,185.172L392.541,134.072C392.541,132.808 393.566,131.782 394.831,131.782L394.846,131.782ZM380.229,145.702C381.487,145.71 382.504,146.732 382.504,147.992L382.504,178.463C382.504,178.753 382.438,179.026 382.34,179.282L377.924,176.732L377.924,147.992C377.924,146.727 378.949,145.702 380.214,145.702L380.229,145.702ZM367.747,159.01C366.481,159.01 365.457,160.034 365.457,161.3L365.457,169.535L370.037,172.181L370.037,161.3C370.037,160.034 369.013,159.01 367.747,159.01Z" style="fill:rgb(12,24,31);fill-rule:nonzero;"/></g></g><g transform="matrix(86.6344,0,0,99.0169,-18498.7,-33785.3)"><path d="M233.307,352.699C232.133,357.406 227.366,360.27 222.659,359.097C217.953,357.923 215.089,353.155 216.263,348.449C217.436,343.741 222.203,340.876 226.909,342.05C231.616,343.223 234.481,347.992 233.307,352.699Z" style="fill:rgb(12,24,31);"/></g></g><g transform="matrix(6.45054,0,0,7.37544,-53582.8,-56218.3)"><path d="M8427.08,7798.32L8456.71,7814.01L8466.7,7809.02L8470.48,7816.57L8456.6,7823.51L8418.64,7803.41L8418.64,7767.36L8427.08,7767.36L8427.08,7798.32ZM8460.88,7774.07L8460.88,7789.59L8478.05,7803.13L8508.1,7781.79L8508.1,7766.66L8516.55,7766.66L8516.55,7786.15C8503.63,7795.32 8490.71,7804.5 8477.79,7813.68L8452.43,7793.69L8452.43,7774.45L8431,7752.19L8481.94,7752.19L8460.88,7774.07ZM8445.72,7747.19L8423.85,7738.29L8399.85,7750.75L8399.85,7779.32L8413.92,7789.7L8408.91,7796.5L8391.4,7783.59L8391.4,7745.62L8421.83,7729.82L8445.72,7729.82L8445.72,7747.19ZM8488.37,7766.56L8516.01,7748.85L8516.01,7719L8502.01,7707.08L8507.49,7700.65C8513.14,7705.46 8518.8,7710.28 8524.46,7715.09L8524.46,7753.48L8493.06,7773.58L8488.37,7766.56ZM8440.02,7682.74L8456.62,7672.69C8469.31,7680.15 8481.99,7687.61 8494.68,7695.07L8494.68,7737.25L8468.59,7747.19L8468.59,7729.82L8486.23,7729.82L8486.23,7699.9L8456.69,7682.53L8448.03,7687.77L8440.02,7682.74ZM8400.25,7733.14L8391.8,7733.14L8391.8,7709.07L8430.78,7684.56C8440.69,7690.62 8450.59,7696.68 8460.5,7702.74L8456.09,7709.95L8430.84,7694.51L8400.25,7713.74L8400.25,7733.14Z" style="fill:rgb(246,212,19);"/></g></g></g></svg>',
    TRX_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-path"><rect id="Rectangle_2" data-name="Rectangle 2" width="499.994" height="499.996" transform="translate(70.381 16.409)"/></clipPath><clipPath id="clip-tron_icon"><rect width="500" height="500"/></clipPath></defs><g id="tron_icon" clip-path="url(#clip-tron_icon)"><g id="tron_icon-2" data-name="tron_icon" transform="translate(-16439.98 -3969.999)"><g id="tron_icon-3" data-name="tron_icon" transform="translate(16369.6 3953.59)"><rect id="Rectangle_1" data-name="Rectangle 1" width="499.994" height="499.996" transform="translate(70.381 16.409)" fill="none"/><g id="Group_4" data-name="Group 4" clip-path="url(#clip-path)"><g id="Group_3" data-name="Group 3"><g id="Group_1" data-name="Group 1" transform="translate(-6076.268 -9708.369)"><path id="Path_1" data-name="Path 1" d="M6639.171,10035.249c-33.408,133.927-169.062,215.415-303.008,182.04-133.918-33.4-215.417-169.066-182.01-302.965,33.38-133.955,169.034-215.473,302.951-182.069C6591.05,9765.63,6672.579,9901.321,6639.171,10035.249Z" fill="#f3f1f1" fill-rule="evenodd"/></g><g id="Group_2" data-name="Group 2" transform="translate(421.572 378.014)"><path id="Path_2" data-name="Path 2" d="M0-185.172c-19.782,16.52-39.165,32.759-58.548,48.974.422.563.821,1.15,1.267,1.737,30.506-5.632,61.012-11.193,92.809-17.013-12.437-11.757-23.889-22.6-35.528-33.7m-17.975-6.336c-55.427-10.114-109.47-19.946-163.465-29.779-.141.7-.375,1.408-.516,2.089,32.876,27.244,65.8,54.442,99.051,81.968,21.448-17.9,42.544-35.6,64.931-54.277M-89.969,13.657c.422.258.821.446,1.267.727C-48.9-34.284-9.1-82.93,31.632-132.725c-3.989,0-6.1-.305-8.072.07-31.28,5.632-62.584,11.264-93.841,17.248-1.854.375-4.271,3.309-4.623,5.35-1.572,9.1-2.511,18.28-3.567,27.479q-5.773,48.118-11.5,96.235m-17.2,1.431c.8-4.083,1.361-6.289,1.6-8.565,4.951-41.254,9.926-82.531,14.6-123.761.258-2.581-1.478-6.406-3.52-8.143q-48.117-40.233-96.634-80.09c-1.291-1.056-2.933-1.807-5.327-3.309,29.919,75.069,59.276,148.659,89.289,223.868m.4,46.346c-11.5-29.239-22.833-58.619-34.5-87.787q-42.556-107.041-85.417-214.012c-.7-1.854-1.314-3.661-2.229-6.242,26.963,4.9,53.151,9.645,79.316,14.455q73.355,13.376,146.734,26.892c3.168.61,6.805,1.572,8.988,3.637,19.36,17.975,38.438,36.255,58.055,54.911-14.408,17.6-28.629,34.988-42.873,52.424q-61.247,74.764-122.4,149.574a68.33,68.33,0,0,0-4.107,6.148Z" fill="#c8382b" fill-rule="evenodd"/></g></g></g></g></g></g></svg>',
    IOTA_icon: '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g transform="matrix(1,0,0,1,-13950,-5360)"><g id="miota_icon" transform="matrix(0.328474,0,0,0.287282,13879.6,5343.59)"><rect x="214.268" y="57.119" width="1522.19" height="1740.45" style="fill:none;"/><clipPath id="_clip1"><rect x="214.268" y="57.119" width="1522.19" height="1740.45"/></clipPath><g clip-path="url(#_clip1)"><g transform="matrix(0.608877,0,0,0.69618,214.268,57.1194)"><circle cx="1250" cy="1250" r="1250"/><circle cx="1677.83" cy="413.3" r="113.3" style="fill:white;"/><circle cx="1708.78" cy="710.525" r="95.925" style="fill:white;"/><circle cx="1960.3" cy="746.45" r="95.7" style="fill:white;"/><circle cx="1929.42" cy="999.925" r="81.85" style="fill:white;"/><circle cx="2130.7" cy="1077.4" r="82.375" style="fill:white;"/><circle cx="1676.42" cy="965.325" r="83.85" style="fill:white;"/><circle cx="1603.3" cy="1169.38" r="70.325" style="fill:white;"/><circle cx="1855.05" cy="1203.8" r="69.8" style="fill:white;"/><circle cx="2056" cy="1280.85" r="70.425" style="fill:white;"/><circle cx="1956.33" cy="1436.2" r="59.4" style="fill:white;"/><circle cx="1754.6" cy="1358.48" r="60.7" style="fill:white;"/><circle cx="1503" cy="1323.6" r="60.15" style="fill:white;"/><circle cx="1642.5" cy="1467.17" r="52.425" style="fill:white;"/><circle cx="1844.23" cy="1544.62" r="52.875" style="fill:white;"/><circle cx="1730.2" cy="1613.1" r="41.675" style="fill:white;"/><circle cx="1622.33" cy="1648.03" r="37.875" style="fill:white;"/><circle cx="1528.45" cy="1537.67" r="44.975" style="fill:white;"/><circle cx="1390.55" cy="1432.75" r="52.3" style="fill:white;"/><circle cx="1803.4" cy="2003.05" r="112.725" style="fill:white;"/><circle cx="1529.1" cy="1883.65" r="94.025" style="fill:white;"/><circle cx="1372.98" cy="2080.18" r="94.825" style="fill:white;"/><circle cx="1325.48" cy="1728.05" r="82.125" style="fill:white;"/><circle cx="1169.42" cy="1928.3" r="81.925" style="fill:white;"/><circle cx="1001.73" cy="2064.47" r="81.65" style="fill:white;"/><circle cx="861.325" cy="1898.6" r="69.6" style="fill:white;"/><circle cx="1029.55" cy="1762.1" r="69.725" style="fill:white;"/><circle cx="1186.48" cy="1561.98" r="69.8" style="fill:white;"/><circle cx="946" cy="1598.08" r="60.4" style="fill:white;"/><circle cx="778.6" cy="1734.4" r="59.9" style="fill:white;"/><circle cx="739.85" cy="1582.65" r="51.85" style="fill:white;"/><circle cx="737.975" cy="1449.58" r="44.475" style="fill:white;"/><circle cx="760.925" cy="1339.35" r="37.85" style="fill:white;"/><circle cx="905.75" cy="1313.5" r="44.975" style="fill:white;"/><circle cx="1064.25" cy="1245.92" r="52.4" style="fill:white;"/><circle cx="1102.28" cy="1397.58" r="59.625" style="fill:white;"/><circle cx="907.85" cy="1446.83" r="51.95" style="fill:white;"/><circle cx="363.225" cy="1318.28" r="112.375" style="fill:white;"/><circle cx="606.15" cy="1141.55" r="96.25" style="fill:white;"/><circle cx="510.9" cy="905.825" r="95.75" style="fill:white;"/><circle cx="745.15" cy="806.45" r="82.075" style="fill:white;"/><circle cx="841.05" cy="1041.58" r="82.35" style="fill:white;"/><circle cx="1054.17" cy="1003.9" r="70.125" style="fill:white;"/><circle cx="1238.48" cy="1013.45" r="60.375" style="fill:white;"/><circle cx="1390.55" cy="1056.55" r="50.85" style="fill:white;"/><circle cx="1410.05" cy="885.2" r="44.35" style="fill:white;"/><circle cx="1293.08" cy="820.925" r="51.375" style="fill:white;"/><circle cx="1142.8" cy="777.95" r="60.05" style="fill:white;"/><circle cx="959.075" cy="768.925" r="70.175" style="fill:white;"/><circle cx="711.3" cy="592.725" r="79.6" style="fill:white;"/><circle cx="924.25" cy="555.025" r="70.225" style="fill:white;"/><circle cx="1108.5" cy="564.7" r="60.55" style="fill:white;"/><circle cx="1259.5" cy="607.85" r="50.975" style="fill:white;"/><circle cx="1375.58" cy="672.325" r="45.575" style="fill:white;"/><circle cx="1460.38" cy="748.025" r="37.5" style="fill:white;"/></g></g></g></g></svg>',
    MKR_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-path"><rect id="Rectangle_4" data-name="Rectangle 4" width="499.994" height="499.996" transform="translate(70.381 16.409)"/></clipPath><clipPath id="clip-mkr_icon"><rect width="500" height="500"/></clipPath></defs><g id="mkr_icon" clip-path="url(#clip-mkr_icon)"><g id="mkr_icon-2" data-name="mkr_icon" transform="translate(-11399.98 -8209.999)"><g id="mkr_icon-3" data-name="mkr_icon" transform="translate(11329.6 8193.59)"><rect id="Rectangle_3" data-name="Rectangle 3" width="499.994" height="499.996" transform="translate(70.381 16.409)" fill="none"/><g id="Group_8" data-name="Group 8" clip-path="url(#clip-path)"><g id="Group_7" data-name="Group 7"><g id="Group_5" data-name="Group 5" transform="translate(-6076.268 -9708.283)"><path id="Path_3" data-name="Path 3" d="M6639.171,10035.249c-33.408,133.927-169.062,215.415-303.008,182.04-133.918-33.4-215.417-169.066-182.01-302.965,33.38-133.955,169.034-215.473,302.951-182.069C6591.05,9765.63,6672.579,9901.321,6639.171,10035.249Z" fill="#17ac9a" fill-rule="evenodd"/></g><g id="Group_6" data-name="Group 6" transform="translate(-21870.059 -18116.25)"><path id="Path_4" data-name="Path 4" d="M22051.455,18469.381h-26.578v-157.512a15.669,15.669,0,0,1,8.859-14.174,15.471,15.471,0,0,1,16.477,1.6l124.557,94.967a14.266,14.266,0,0,1,5.67,11.34v63.783h-26.576v-56.342a2.529,2.529,0,0,0-1.062-2.127c-9.568-7.266-83.8-63.961-98.689-75.3a1.633,1.633,0,0,0-1.77-.178,1.812,1.812,0,0,0-.887,1.42Zm277.992,0h26.574v-157.512a15.982,15.982,0,0,0-8.857-14.174,15.778,15.778,0,0,0-16.654,1.6l-124.381,94.967a14.27,14.27,0,0,0-5.668,11.34v63.783h26.574v-56.342a2.528,2.528,0,0,1,1.066-2.127c9.566-7.266,83.8-63.961,98.686-75.3a1.639,1.639,0,0,1,1.773-.178,1.812,1.812,0,0,1,.887,1.42Z" fill="#f3f1f1" fill-rule="evenodd"/></g></g></g></g></g></g></svg>',
    ALGO_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-path"><rect id="Rectangle_2" data-name="Rectangle 2" width="499.994" height="499.996" transform="translate(70.381 16.409)"/></clipPath><clipPath id="clip-algo_icon"><rect width="500" height="500"/></clipPath></defs><g id="algo_icon" clip-path="url(#clip-algo_icon)"><g id="algo_icon-2" data-name="algo_icon" transform="translate(-12649.98 -8209.999)"><g id="algo_icon-3" data-name="algo_icon" transform="translate(12579.6 8193.59)"><rect id="Rectangle_1" data-name="Rectangle 1" width="499.994" height="499.996" transform="translate(70.381 16.409)" fill="none"/><g id="Group_4" data-name="Group 4" clip-path="url(#clip-path)"><g id="Group_3" data-name="Group 3" transform="translate(0 -0.063)"><g id="Group_1" data-name="Group 1" transform="translate(-6076.268 -9708.283)"><path id="Path_1" data-name="Path 1" d="M6639.171,10035.249c-33.408,133.927-169.062,215.415-303.008,182.04-133.918-33.4-215.417-169.066-182.01-302.965,33.38-133.955,169.034-215.473,302.951-182.069C6591.05,9765.63,6672.579,9901.321,6639.171,10035.249Z" fill="#242424" fill-rule="evenodd"/></g><g id="Group_2" data-name="Group 2" transform="translate(-19601.678 -12727.768)"><path id="Path_2" data-name="Path 2" d="M20010.881,12909.348h44.141l-30.682,52.9,41.969,164.188h-47.9l-27.209-106.994-62.23,106.994h-53.547l99.424-171.078-13.459-52.723-129.961,223.8h-53.547l165.418-285.105h50.219Z" fill="#fff" fill-rule="evenodd"/></g></g></g></g></g></g></svg>',
    MANA_icon: '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400"><defs><linearGradient x1="85.355%" y1="14.645%" x2="14.645%" y2="85.355%" id="a"><stop stop-color="#FF2D55" offset="0%"/><stop stop-color="#FFBC5B" offset="100%"/></linearGradient><linearGradient x1="49.966%" y1="0%" x2="49.966%" y2="100%" id="b"><stop stop-color="#A524B3" offset="0%"/><stop stop-color="#FF2D55" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><circle fill="url(#a)" cx="200" cy="200" r="200"/><path fill="url(#b)" d="M125.7 0v150h125z" transform="translate(16 130)"/><path fill="#FFF" d="M16.7 280h125V130z"/><path d="M40 320c11.4 15.1 24.9 28.6 40 40h240c15.1-11.4 28.6-24.9 40-40H40z" fill="#FC9965"/><path d="M80 360c33.4 25.1 75 40 120 40s86.6-14.9 120-40H80z" fill="#FF2D55"/><path fill="url(#b)" d="M252.3 0v110H344z" transform="translate(16 210)"/><path d="M268.3 280H16.7c6.2 14.3 14.1 27.7 23.3 40h228.4v-40h-.1z" fill="#FFBC5B"/><path fill="#FFF" d="M176.7 320h91.6V210z"/><circle fill="#FFC95B" cx="268.3" cy="130" r="50"/><circle fill="#FFC95B" cx="141.7" cy="75" r="25"/></g></svg>',
    BAT_icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1719" width="2000" height="2000"><path fill="#662d91" d="M2000 1716.64 1004.79 1146.78 0 1719 2000 1716.64z"/><path fill="#9e1f63" d="M1005.11 0 1004.79 1146.78 2000 1716.64 1005.11 0z"/><path fill="#ff5000" d="M0 1719 1004.79 1146.78 1005.11 0 0 1719z"/><path fill="#fff" stroke="#ff5000" stroke-miterlimit="10" stroke-width="25" d="m1002.75 695.67l-410.85 686.25h823.54l-412.69-686.25z"/></svg>',
    ENJ_icon: '<?xml version="1.0" encoding="utf-8"?><!-- Generator: Adobe Illustrator 24.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 141.7 141.7" style="enable-background:new 0 0 141.7 141.7;" xml:space="preserve"><style type="text/css">.st0{fill:#7866D5;}.st1{fill:#FFFFFF;}</style><circle class="st0" cx="70.9" cy="70.9" r="70.9"/><g><path class="st1" d="M99.6,36.4c2.4,0.3,4.9,0.5,7.3,0.9c4.7,0.9,6.3,3.3,5.5,8.1c-0.2,1.8-1.6,3.2-3.4,3.5c-1.1,0.2-2.3,0.3-3.4,0.2c-15.6,0-31.1,0.1-46.7,0.1c-2.3,0-4.7,0.2-7,0.6C44.2,51,41.2,54.2,40.6,62c-0.3,3.6-0.3,3.6,3.4,3.6h62c0.6,0,1.2,0,1.8,0c1,0,1.9,0.3,2.8,0.8c2.8,1.8,2.1,4.7,2,7.3c-0.1,2.1-1.4,3.3-3.6,3.7c-0.9,0.2-1.8,0.2-2.8,0.2c-21.2,0-42.4,0-63.6,0c-2.3,0-2.3,0-2.1,2.3c0.1,2.1,0.3,4.2,0.8,6.3c1,3.8,3.3,6.2,7.2,7.3c4.2,1.2,8.6,1.4,12.9,1.5C76.5,95,91.7,95,106.9,95c1.9,0,3.7,0.2,4.9,2c1.9,3,0.9,6.9-2.1,8.8c-0.4,0.3-0.8,0.5-1.3,0.6c-3.3,1.1-6.7,1.3-10.2,1.4c-14.3,0.3-28.5,0.3-42.7,0c-4.4-0.1-8.8-0.6-13.1-1.5c-10.1-2.1-15.2-7.3-16.9-17.5c-0.4-2.3-0.6-4.7-0.9-7.1V63.1c0.2-1.8,0.4-3.7,0.6-5.5c1.3-11.5,6.5-17.2,17.8-19.8c4-0.9,8.2-1.1,12.2-1.5L99.6,36.4z"/><path class="st1" d="M76.8,109.8c-7.2,0-14.3-0.1-21.4-0.2c-4.5-0.1-9-0.6-13.4-1.6c-10.9-2.3-16.5-8.1-18.3-18.9c-0.3-1.7-0.5-3.4-0.6-5c-0.1-0.7-0.2-1.4-0.3-2.2l0-0.2l0-18.8l0.2-1.8c0.1-1.3,0.3-2.5,0.4-3.7c1.4-12.3,7.2-18.6,19.3-21.3c3.2-0.7,6.3-1,9.4-1.3c1-0.1,2-0.2,3-0.3l0.2,0h44.5l0.1,0c0.7,0.1,1.5,0.2,2.2,0.2c1.7,0.2,3.4,0.3,5.2,0.7c5.7,1.1,7.9,4.3,6.9,10.1c-0.3,2.5-2.3,4.6-5,5c-1.2,0.2-2.4,0.3-3.7,0.3C90,50.9,74.4,51,58.9,51c-2.2,0-4.5,0.2-6.7,0.6c-6.9,1.1-9.2,3.6-9.8,10.6c0,0.6-0.1,1.2-0.1,1.7c0.4,0,1.1,0,1.7,0h63.8l0,0c1.3,0,2.6,0.4,3.7,1c3.4,2.2,3.1,5.5,2.9,7.9c0,0.3-0.1,0.7-0.1,1c-0.2,2.8-1.9,4.7-5,5.3c-1.1,0.2-2.1,0.2-3.1,0.2H42.7c-0.1,0-0.3,0-0.4,0c0,0.1,0,0.2,0,0.3l0,0.1c0.1,2.1,0.3,4.1,0.8,6.1c0.8,3.1,2.7,5,5.9,5.9c4.3,1.2,8.7,1.4,12.5,1.4c11.8,0.1,23.8,0.1,35.5,0.1h10c1.5,0,4.6,0,6.4,2.9c1.2,1.9,1.5,4.1,1,6.2s-1.8,3.9-3.7,5.1c-0.5,0.3-1.1,0.6-1.7,0.8c-3.7,1.2-7.5,1.4-10.7,1.5C91.2,109.7,84,109.8,76.8,109.8zM26.4,81.6c0.1,0.7,0.2,1.4,0.2,2.1c0.2,1.6,0.4,3.2,0.6,4.8c1.6,9.4,6.1,14,15.5,16c4.2,0.9,8.5,1.4,12.8,1.5c14.1,0.3,28.5,0.3,42.7,0c2.9-0.1,6.4-0.3,9.6-1.3c0.3-0.1,0.6-0.3,0.9-0.4c1-0.7,1.8-1.7,2.1-2.9c0.3-1.2,0.1-2.4-0.6-3.5c-0.6-0.9-1.4-1.2-3.3-1.2h-10c-11.6,0-23.7,0-35.5-0.1c-4,0-8.7-0.2-13.4-1.6c-4.5-1.2-7.3-4.1-8.4-8.6c-0.5-2.2-0.8-4.5-0.8-6.7l0-0.1c-0.1-1.4-0.2-2.4,0.6-3.3c0.8-0.9,1.9-0.9,3.3-0.9h63.6c0.8,0,1.7,0,2.5-0.2c1.6-0.3,2-1,2.1-2c0-0.4,0.1-0.7,0.1-1.1c0.2-2.5,0.2-3.7-1.2-4.6c-0.5-0.3-1.2-0.5-1.8-0.5l0,0H44c-2.2,0-3.5,0-4.5-1c-1-1-0.8-2.4-0.7-4.5c0.7-8.6,4.3-12.5,12.8-13.8c2.4-0.4,4.8-0.6,7.3-0.7c15.6,0,31.1-0.1,46.7-0.1c1.1,0,2.1,0,3.1-0.2c1-0.1,1.8-0.9,1.9-1.9c0.7-4-0.3-5.3-4.1-6.1c-1.6-0.3-3.2-0.5-4.8-0.6c-0.7-0.1-1.5-0.2-2.2-0.2H55.3c-1,0.1-2,0.2-3,0.3c-3.1,0.3-6,0.5-9,1.2C32.8,42,28.2,47.1,27,57.9c-0.1,1.2-0.3,2.4-0.4,3.7l-0.2,1.7L26.4,81.6L26.4,81.6z"/></g></svg>',
    exchange_sx_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73" height="73" viewBox="0 0 73 73"><defs><clipPath id="clip-exchange_sx_icon"><rect width="73" height="73"/></clipPath></defs><g id="exchange_sx_icon" clip-path="url(#clip-exchange_sx_icon)"><g id="Group_10422" data-name="Group 10422" transform="translate(-10920 -762.895)"><g id="Group_10409" data-name="Group 10409" transform="translate(-7 2.476)"><g id="Group_10406" data-name="Group 10406" transform="translate(10933 768.419)"><g id="Group_10404" data-name="Group 10404" transform="translate(0 35.918)"><path id="Path_5167" data-name="Path 5167" d="M9.972,28.944,3,21.972,9.972,15" transform="translate(-3 -7.152)" fill="none" stroke="#5296ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path id="Path_5168" data-name="Path 5168" d="M63.844,8.264v7.848a6.972,6.972,0,0,1-6.972,6.972H3" transform="translate(-3 -8.264)" fill="none" stroke="#5296ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g><g id="Group_10405" data-name="Group 10405" transform="translate(0 0)"><path id="Path_5167-2" data-name="Path 5167" d="M3,15l6.972,6.972L3,28.944" transform="translate(50.872 -15)" fill="none" stroke="#5296ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path id="Path_5168-2" data-name="Path 5168" d="M3,23.083V15.236A6.972,6.972,0,0,1,9.972,8.264H63.844" transform="translate(-3 -1.292)" fill="none" stroke="#5296ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></g></g><g id="Group_10416" data-name="Group 10416" transform="translate(10787.82 783.078)"><g id="Path_4946" data-name="Path 4946" transform="translate(-254.325 80.721)" fill="#5296ff" fill-rule="evenodd"><path d="M 423.0133056640625 -47.08764266967773 L 422.9632873535156 -47.11651229858398 L 421.4901123046875 -47.96710205078125 L 409.9266662597656 -54.64319229125977 L 408.4550170898438 -55.49251174926758 L 408.4049987792969 -55.5213737487793 L 408.4049987792969 -55.57912063598633 L 408.4049987792969 -72.3450927734375 L 408.4049987792969 -72.40283203125 L 408.4549865722656 -72.43169403076172 L 411.2504577636719 -74.04550933837891 L 422.9632873535156 -80.80770111083984 L 423.0133056640625 -80.83657073974609 L 423.0632934570312 -80.80770111083984 L 437.5710754394531 -72.43169403076172 L 437.6210632324219 -72.40283203125 L 437.6210632324219 -72.3450927734375 L 437.6210632324219 -55.57912063598633 L 437.6210632324219 -55.52139282226562 L 437.5710754394531 -55.49252319335938 L 436.1002502441406 -54.64319229125977 L 424.5368347167969 -47.96710205078125 L 423.0632934570312 -47.11650085449219 L 423.0133056640625 -47.08764266967773 Z M 410.07666015625 -56.48877334594727 L 423.0133056640625 -49.01976013183594 L 435.9502258300781 -56.48877716064453 L 435.9502258300781 -71.43541717529297 L 423.0133056640625 -78.90448760986328 L 410.07666015625 -71.43541717529297 L 410.07666015625 -69.73918151855469 L 410.07666015625 -56.48877334594727 Z" stroke="none"/><path d="M 423.0133056640625 -80.72111511230469 L 411.3004455566406 -73.95890808105469 L 408.5050048828125 -72.3450927734375 L 408.5050048828125 -55.57912445068359 L 409.9766540527344 -54.72978973388672 L 421.5401000976562 -48.05370330810547 L 423.0133056640625 -47.203125 L 424.48681640625 -48.05370330810547 L 436.0502319335938 -54.72978973388672 L 437.5210571289062 -55.57912445068359 L 437.5210571289062 -72.3450927734375 L 423.0133056640625 -80.72111511230469 M 423.0133056640625 -48.90428924560547 L 409.9766540527344 -56.43104553222656 L 409.9766540527344 -69.73918151855469 L 409.9766540527344 -71.49314880371094 L 423.0133056640625 -79.01995086669922 L 436.0502319335938 -71.49314880371094 L 436.0502319335938 -56.43104553222656 L 423.0133056640625 -48.90428924560547 M 423.0133056640625 -80.95205688476562 L 423.1133117675781 -80.89431762695312 L 437.6210632324219 -72.51830291748047 L 437.7210693359375 -72.46056365966797 L 437.7210693359375 -72.3450927734375 L 437.7210693359375 -55.57912445068359 L 437.7210693359375 -55.46366119384766 L 437.6210632324219 -55.40592193603516 L 436.1502380371094 -54.55659484863281 L 424.5868225097656 -47.8804931640625 L 423.11328125 -47.02991485595703 L 423.0133056640625 -46.97218322753906 L 422.9132995605469 -47.02992248535156 L 421.4400939941406 -47.88050079345703 L 409.8766479492188 -54.55657958984375 L 408.405029296875 -55.40589904785156 L 408.3049926757812 -55.46363067626953 L 408.3049926757812 -55.57912445068359 L 408.3049926757812 -72.3450927734375 L 408.3049926757812 -72.46056365966797 L 408.4049987792969 -72.51830291748047 L 411.200439453125 -74.13212585449219 L 422.9132995605469 -80.89431762695312 L 423.0133056640625 -80.95205688476562 Z M 435.8502197265625 -71.37767791748047 L 423.0133056640625 -78.78901672363281 L 410.1766662597656 -71.377685546875 L 410.1766662597656 -69.73918151855469 L 410.1766662597656 -56.5465087890625 L 423.0133056640625 -49.13523101806641 L 435.8502197265625 -56.54651641845703 L 435.8502197265625 -71.37767791748047 Z" stroke="none" fill="#5296ff"/></g><g id="Path_4947" data-name="Path 4947" transform="translate(-255.766 79.285)" fill="#5296ff"><path d="M 422.119140625 -64.23609161376953 L 422.0339965820312 -64.37451934814453 L 417.7058715820312 -71.41161346435547 L 417.6121520996094 -71.56400299072266 L 417.7910461425781 -71.56400299072266 L 420.4040832519531 -71.56400299072266 L 420.4598083496094 -71.56400299072266 L 420.4891052246094 -71.51661682128906 L 423.5203552246094 -66.61744689941406 L 423.5528259277344 -66.56495666503906 L 423.5204772949219 -66.51241302490234 L 422.2043151855469 -64.37448883056641 L 422.119140625 -64.23609161376953 Z" stroke="none"/><path d="M 422.1191711425781 -64.42691040039062 L 423.4353332519531 -66.56482696533203 L 420.4040832519531 -71.46399688720703 L 417.7910461425781 -71.46399688720703 L 422.1191711425781 -64.42691040039062 M 422.1190795898438 -64.04528045654297 L 421.9488220214844 -64.32212829589844 L 417.6206970214844 -71.35922241210938 L 417.4332275390625 -71.66400146484375 L 417.7910461425781 -71.66400146484375 L 420.4040832519531 -71.66400146484375 L 420.5155334472656 -71.66400146484375 L 420.5741577148438 -71.56922912597656 L 423.6054077148438 -66.67005920410156 L 423.6703491210938 -66.56508636474609 L 423.6056518554688 -66.45997619628906 L 422.2894897460938 -64.32205963134766 L 422.1190795898438 -64.04528045654297 Z" stroke="none" fill="#5296ff"/></g><g id="Path_4948" data-name="Path 4948" transform="translate(-256.89 77.84)" fill="#5296ff"><path d="M 432.7587280273438 -52.04241943359375 L 432.5791625976562 -52.04241943359375 L 429.9415893554688 -52.04241943359375 L 429.8861389160156 -52.04241943359375 L 429.8567810058594 -52.08944702148438 L 424.9541320800781 -59.93906784057617 L 424.9211120605469 -59.99192047119141 L 424.9540100097656 -60.04483795166016 L 426.2956848144531 -62.20299911499023 L 426.3807678222656 -62.33985900878906 L 426.4656066894531 -62.20285797119141 L 432.6641845703125 -52.1950798034668 L 432.7587280273438 -52.04241943359375 Z" stroke="none"/><path d="M 426.380615234375 -62.15019989013672 L 425.0389404296875 -59.99203872680664 L 429.9415893554688 -52.14241790771484 L 432.5791625976562 -52.14241790771484 L 426.380615234375 -62.15019989013672 M 426.3809204101562 -62.52951812744141 L 426.5506286621094 -62.25550842285156 L 432.7492065429688 -52.24773025512695 L 432.9382934570312 -51.94241714477539 L 432.5791625976562 -51.94241714477539 L 429.9415893554688 -51.94241714477539 L 429.8306884765625 -51.94241714477539 L 429.77197265625 -52.03646850585938 L 424.8693237304688 -59.88608932495117 L 424.8032836914062 -59.99179077148438 L 424.8690795898438 -60.09762954711914 L 426.2107543945312 -62.25579071044922 L 426.3809204101562 -62.52951812744141 Z" stroke="none" fill="#5296ff"/></g><g id="Path_4949" data-name="Path 4949" transform="translate(-255.704 79.285)" fill="#5296ff"><path d="M 420.084228515625 -53.48754119873047 L 420.0284729003906 -53.48754119873047 L 417.3909606933594 -53.48754119873047 L 417.2118835449219 -53.48754119873047 L 417.3058471679688 -53.6400032043457 L 422.9780883789062 -62.84434127807617 L 424.2950744628906 -64.98189544677734 L 424.3818054199219 -65.12266540527344 L 424.3825988769531 -65.12133026123047 L 427.3402709960938 -69.93658447265625 L 428.3106384277344 -71.51633453369141 L 428.3399047851562 -71.56399536132812 L 428.3958435058594 -71.56399536132812 L 431.0317077636719 -71.56399536132812 L 431.2101745605469 -71.56399536132812 L 431.1170043945312 -71.41178131103516 L 426.735595703125 -64.25395202636719 L 423.8553161621094 -59.59003067016602 L 420.1135559082031 -53.53497314453125 L 420.084228515625 -53.48754119873047 Z" stroke="none"/><path d="M 428.3958435058594 -71.46400451660156 C 427.0575866699219 -69.28530120849609 425.7192077636719 -67.10655212402344 424.3811340332031 -64.92788696289062 L 424.3802185058594 -64.92942810058594 L 423.0632019042969 -62.7918815612793 L 417.3909606933594 -53.58755493164062 L 420.0284729003906 -53.58755493164062 L 423.7702331542969 -59.64257049560547 L 426.6502990722656 -64.30616760253906 L 431.0317077636719 -71.46400451660156 L 428.3958435058594 -71.46400451660156 M 428.2839660644531 -71.66400146484375 L 428.3958435058594 -71.66400146484375 L 431.0317077636719 -71.66400146484375 L 431.3886108398438 -71.66400146484375 L 431.2022705078125 -71.35958862304688 L 426.8208618164062 -64.20175170898438 L 423.9403991699219 -59.53748321533203 L 420.1986083984375 -53.48241424560547 L 420.1399841308594 -53.38755035400391 L 420.0284729003906 -53.38755035400391 L 417.3909606933594 -53.38755035400391 L 417.0327758789062 -53.38755035400391 L 417.220703125 -53.69248199462891 L 422.8929443359375 -62.89681243896484 L 424.2099304199219 -65.03434753417969 L 424.3833923339844 -65.31588745117188 L 424.3840637207031 -65.31477355957031 L 427.2016296386719 -69.9019775390625 L 428.2254333496094 -71.56867980957031 L 428.2839660644531 -71.66400146484375 Z" stroke="none" fill="#5296ff"/></g></g></g></g></svg>',
    saw_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73" height="73" viewBox="0 0 73 73"><defs><clipPath id="clip-smartwallet_saw_icon"><rect width="73" height="73"/></clipPath></defs><g id="smartwallet_saw_icon" clip-path="url(#clip-smartwallet_saw_icon)"><g id="Group_10399" data-name="Group 10399" transform="translate(-10926.181 -639)"><g id="Group_10397" data-name="Group 10397" transform="translate(10929 648)"><g id="Group_10398" data-name="Group 10398"><g id="Path_4990" data-name="Path 4990" fill="none"><path d="M6.467,0H61.958a6.467,6.467,0,0,1,6.467,6.467v42.5a6.467,6.467,0,0,1-6.467,6.467H6.467A6.467,6.467,0,0,1,0,48.965V6.467A6.467,6.467,0,0,1,6.467,0Z" stroke="none"/><path d="M 6.467060089111328 3 C 4.555320739746094 3 3 4.555316925048828 3 6.467071533203125 L 3 48.96495056152344 C 3 50.87670516967773 4.555320739746094 52.43202209472656 6.467060089111328 52.43202209472656 L 61.95773315429688 52.43202209472656 C 63.86948394775391 52.43202209472656 65.4248046875 50.87670516967773 65.4248046875 48.96495056152344 L 65.4248046875 6.467071533203125 C 65.4248046875 4.555316925048828 63.86948394775391 3 61.95773315429688 3 L 6.467060089111328 3 M 6.467060089111328 0 L 61.95773315429688 0 C 65.52940368652344 0 68.4248046875 2.895401000976562 68.4248046875 6.467071533203125 L 68.4248046875 48.96495056152344 C 68.4248046875 52.5366096496582 65.52940368652344 55.43202209472656 61.95773315429688 55.43202209472656 L 6.467060089111328 55.43202209472656 C 2.895401000976562 55.43202209472656 0 52.5366096496582 0 48.96495056152344 L 0 6.467071533203125 C 0 2.895401000976562 2.895401000976562 0 6.467060089111328 0 Z" stroke="none" fill="#f28e1c"/></g><path id="Path_4991" data-name="Path 4991" d="M10930.5,655.136s0,4.523,7.457,4.51,49.728,0,49.728,0,8.449-.144,8.449,8.166" transform="translate(-10929.115 -648.543)" fill="none" stroke="#f28e1c" stroke-width="3"/></g><line id="Line_21" data-name="Line 21" y2="8.315" transform="translate(56.818 29.102)" fill="none" stroke="#f28e1c" stroke-linecap="round" stroke-width="3"/></g><path id="Path_6021" data-name="Path 6021" d="M274.968-750.351l-13.882,29.183h4.653l5.786-12.244,4.187-8.747,4.117,8.74,5.828,12.251h4.528l-13.673-29.183Z" transform="translate(10685.442 1415.632)" fill="#f28e1c"/></g></g></svg>',
    LEND_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-lend_icon"><rect width="500" height="500"/></clipPath></defs><g id="lend_icon" clip-path="url(#clip-lend_icon)"><g id="Group_105" data-name="Group 105" transform="translate(3458 16293)"><circle id="Ellipse_1" data-name="Ellipse 1" cx="250" cy="250" r="250" transform="translate(-3458 -16293)" fill="#149aca"/><path id="Path_286" data-name="Path 286" d="M681.725,568.181l-97.811,97.808L556.023,635.96,623.8,568.181,553.45,497.827,583.479,467.8Zm57.055-56.2,30.029-30.027L698.448,411.6l67.779-67.782L738.343,313.79,640.1,411.6l98.669,100.381ZM595.92,456.215,694.586,556.6l30.029-30.022L625.949,427.9Z" transform="translate(-3872.77 -16526.715)" fill="#fff"/></g></g></svg>',
    ATOM_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-atom_icon"><rect width="500" height="500"/></clipPath></defs><g id="atom_icon" clip-path="url(#clip-atom_icon)"><g id="Group_104" data-name="Group 104" transform="translate(9347 15066)"><path id="Union_1" data-name="Union 1" d="M0,249.75C0,111.814,111.926,0,250,0S500,111.817,500,249.75,388.073,499.5,250,499.5,0,387.687,0,249.75Z" transform="translate(-9346.999 -15066)" fill="#516ffa"/><path id="Subtraction_5" data-name="Subtraction 5" d="M104.567,329.368h-.044L0,269V60.157l.108.065L104.48,0l66.992,37.344h.021v94.278l-32.6-18.7V56.135l-34.373-19.57L32.576,78.125V251.243L104.523,292.8l71.948-41.431.346-71.14L74.588,120.983l32.835-17.256,101.861,59.334L209.025,269,104.567,329.346v.021ZM74.588,214.915h0v-85.8L100.866,144.6v25.753L124.232,157.9l25.161,14.459-74.8,42.555Z" transform="translate(-9202.005 -14980.934)" fill="#fff"/></g><g id="cosmos-atom-logo" transform="translate(0.063 0.063)"><circle id="Ellipse_2" data-name="Ellipse 2" cx="250" cy="250" r="250" transform="translate(-0.063 -0.063)" fill="#2e3148"/><circle id="Ellipse_3" data-name="Ellipse 3" cx="144.903" cy="144.903" r="144.903" transform="translate(104.802 104.802)" fill="#1b1e36"/><path id="Path_287" data-name="Path 287" d="M1057.045,159.47c-26.957,0-48.815,97.773-48.815,218.383s21.858,218.383,48.815,218.383,48.814-97.773,48.814-218.383S1084,159.47,1057.045,159.47Zm3.37,424.441c-3.083,4.111-6.165,1.027-6.165,1.027-12.414-14.384-18.622-41.107-18.622-41.107-21.714-69.881-16.546-219.923-16.546-219.923,10.2-119.117,28.768-147.257,35.086-153.5a3.854,3.854,0,0,1,4.943-.4c9.166,6.495,16.853,33.657,16.853,33.657,22.7,84.27,20.645,163.4,20.645,163.4,2.056,68.854-11.375,145.93-11.375,145.93C1074.895,571.568,1060.415,583.911,1060.415,583.911Z" transform="translate(-806.826 -127.632)" fill="#6f7390"/><path id="Path_288" data-name="Path 288" d="M676.932,676.58c-13.421-23.39-109.1,6.309-213.766,66.327S284.669,870.546,298.08,893.926s109.1-6.309,213.766-66.327,178.5-127.638,165.087-151.018ZM310.462,890.717c-5.138-.647-3.978-4.871-3.978-4.871,6.3-17.922,26.361-36.606,26.361-36.606C382.677,795.628,515.4,725.447,515.4,725.447c108.389-50.429,142.056-48.3,150.6-45.95a3.854,3.854,0,0,1,2.8,4.111c-1.027,11.188-20.811,31.366-20.811,31.366-61.756,61.65-131.422,99.253-131.422,99.253-58.7,36.06-132.241,62.749-132.241,62.749-55.957,20.164-73.859,13.741-73.859,13.741h0Z" transform="translate(-237.292 -535.039)" fill="#6f7390"/><path id="Path_289" data-name="Path 289" d="M678.284,891.886c13.525-23.328-60.12-91.258-164.42-151.728S313.9,649.621,300.386,672.99s60.12,91.258,164.48,151.728S664.77,915.256,678.284,891.886ZM309.348,682c-2-4.737,2.22-5.878,2.22-5.878,18.672-3.526,44.9,4.509,44.9,4.509,71.352,16.248,198.582,95.945,198.582,95.945,97.959,68.547,112.982,98.74,115.234,107.31a3.854,3.854,0,0,1-2.138,4.481c-10.215,4.677-37.573-2.292-37.573-2.292-84.322-22.609-151.758-64.034-151.758-64.034-60.592-32.68-120.506-82.965-120.506-82.965-45.526-38.332-48.946-57.026-48.946-57.026Z" transform="translate(-239.116 -532.219)" fill="#6f7390"/><circle id="Ellipse_4" data-name="Ellipse 4" cx="25.692" cy="25.692" r="25.692" transform="translate(224.013 224.013)" fill="#b7b9c8"/><ellipse id="Ellipse_5" data-name="Ellipse 5" cx="14.902" cy="15.415" rx="14.902" ry="15.415" transform="translate(340.14 135.632)" fill="#b7b9c8"/><ellipse id="Ellipse_6" data-name="Ellipse 6" cx="14.902" cy="15.415" rx="14.902" ry="15.415" transform="translate(95.552 188.044)" fill="#b7b9c8"/><ellipse id="Ellipse_7" data-name="Ellipse 7" cx="14.902" cy="15.415" rx="14.902" ry="15.415" transform="translate(204.486 377.137)" fill="#b7b9c8"/></g></g></svg>',
    BAND_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-band_icon"><rect width="500" height="500"/></clipPath></defs><g id="band_icon" clip-path="url(#clip-band_icon)"><g id="Group_104" data-name="Group 104" transform="translate(9347 15066)"><path id="Union_1" data-name="Union 1" d="M0,249.75C0,111.814,111.926,0,250,0S500,111.817,500,249.75,388.073,499.5,250,499.5,0,387.687,0,249.75Z" transform="translate(-9346.999 -15066)" fill="#516ffa"/><path id="Subtraction_5" data-name="Subtraction 5" d="M104.567,329.368h-.044L0,269V60.157l.108.065L104.48,0l66.992,37.344h.021v94.278l-32.6-18.7V56.135l-34.373-19.57L32.576,78.125V251.243L104.523,292.8l71.948-41.431.346-71.14L74.588,120.983l32.835-17.256,101.861,59.334L209.025,269,104.567,329.346v.021ZM74.588,214.915h0v-85.8L100.866,144.6v25.753L124.232,157.9l25.161,14.459-74.8,42.555Z" transform="translate(-9202.005 -14980.934)" fill="#fff"/></g></g></svg>',
    smartwallet_stm_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="73" height="73" viewBox="0 0 73 73"><defs><clipPath id="clip-smartwallet_stm_icon"><rect width="73" height="73"/></clipPath></defs><g id="smartwallet_stm_icon" clip-path="url(#clip-smartwallet_stm_icon)"><g id="Group_10421" data-name="Group 10421" transform="translate(-10927 -639)"><g id="Group_10396" data-name="Group 10396" transform="translate(10952.29 667.344)"><path id="Path_101" data-name="Path 101" d="M-18188.91-17822.477l6.777-4.234,8.613,5.07v8.273l-7.166-4.266" transform="translate(18190.947 17826.711)" fill="none" stroke="#f9ac1a" stroke-linecap="round" stroke-width="3"/><path id="Path_102" data-name="Path 102" d="M-18173.52-17817.6l-6.777,4.234-8.613-5.074v-8.27l7.17,4.266" transform="translate(18188.91 17838.131)" fill="none" stroke="#f9ac1a" stroke-linecap="round" stroke-width="3"/></g><g id="Group_10397" data-name="Group 10397" transform="translate(10929 648)"><g id="Group_10398" data-name="Group 10398"><g id="Path_4990" data-name="Path 4990" fill="none"><path d="M6.467,0H61.958a6.467,6.467,0,0,1,6.467,6.467v42.5a6.467,6.467,0,0,1-6.467,6.467H6.467A6.467,6.467,0,0,1,0,48.965V6.467A6.467,6.467,0,0,1,6.467,0Z" stroke="none"/><path d="M 6.467060089111328 3 C 4.555320739746094 3 3 4.555316925048828 3 6.467071533203125 L 3 48.96495056152344 C 3 50.87670516967773 4.555320739746094 52.43202209472656 6.467060089111328 52.43202209472656 L 61.95773315429688 52.43202209472656 C 63.86948394775391 52.43202209472656 65.4248046875 50.87670516967773 65.4248046875 48.96495056152344 L 65.4248046875 6.467071533203125 C 65.4248046875 4.555316925048828 63.86948394775391 3 61.95773315429688 3 L 6.467060089111328 3 M 6.467060089111328 0 L 61.95773315429688 0 C 65.52940368652344 0 68.4248046875 2.895401000976562 68.4248046875 6.467071533203125 L 68.4248046875 48.96495056152344 C 68.4248046875 52.5366096496582 65.52940368652344 55.43202209472656 61.95773315429688 55.43202209472656 L 6.467060089111328 55.43202209472656 C 2.895401000976562 55.43202209472656 0 52.5366096496582 0 48.96495056152344 L 0 6.467071533203125 C 0 2.895401000976562 2.895401000976562 0 6.467060089111328 0 Z" stroke="none" fill="#f9ac1a"/></g><path id="Path_4991" data-name="Path 4991" d="M10930.5,655.136s0,4.523,7.457,4.51,49.728,0,49.728,0,8.449-.144,8.449,8.166" transform="translate(-10929.115 -648.543)" fill="none" stroke="#f9ac1a" stroke-width="3"/></g><line id="Line_21" data-name="Line 21" y2="8.315" transform="translate(56.818 29.102)" fill="none" stroke="#f9ac1a" stroke-linecap="round" stroke-width="3"/></g></g></g></svg>',
    exchange_font: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="170" height="24" viewBox="0 0 170 24"><defs><clipPath id="clip-exchange_font"><rect width="170" height="24"/></clipPath></defs><g id="exchange_font" clip-path="url(#clip-exchange_font)"><path id="Path_5170" data-name="Path 5170" d="M2.2-17.957H12.488v1.77h-8.5v5.615h8.423v1.758H3.992V-1.77h8.423V0H2.2Zm11.6,4.675h2.051L19.36-8.362l3.516-4.919h2.051L20.386-6.97,25.5,0H23.425L19.36-5.579,15.356,0H13.318l5.029-6.97Zm26.4,2.759-1.355.842a5.685,5.685,0,0,0-4.8-2.332,5.551,5.551,0,0,0-4.034,1.563,5.1,5.1,0,0,0-1.605,3.8,5.39,5.39,0,0,0,.739,2.734,5.177,5.177,0,0,0,2.026,1.99,5.892,5.892,0,0,0,2.887.708,5.841,5.841,0,0,0,4.785-2.332l1.355.891A6.39,6.39,0,0,1,37.64-.446a8.2,8.2,0,0,1-3.656.787,7.222,7.222,0,0,1-5.225-2,6.513,6.513,0,0,1-2.075-4.871,6.957,6.957,0,0,1,.97-3.583A6.837,6.837,0,0,1,30.322-12.7a7.782,7.782,0,0,1,3.8-.928,8.106,8.106,0,0,1,2.545.4,7.077,7.077,0,0,1,2.081,1.05A5.71,5.71,0,0,1,40.2-10.522Zm3.284-7.886H45.19V-10.9a7.264,7.264,0,0,1,2.283-2.045,5.555,5.555,0,0,1,2.7-.677,4.709,4.709,0,0,1,2.643.757,4.514,4.514,0,0,1,1.7,2.032,10.773,10.773,0,0,1,.549,4V0H53.357V-6.335A16.2,16.2,0,0,0,53.174-9.4a3.472,3.472,0,0,0-1.154-1.984,3.415,3.415,0,0,0-2.191-.665,4.214,4.214,0,0,0-2.777,1.025,4.8,4.8,0,0,0-1.617,2.539,17.55,17.55,0,0,0-.244,3.613V0H43.481ZM71.96-13.281V0H70.276V-2.283A7.325,7.325,0,0,1,67.865-.317a6.519,6.519,0,0,1-2.924.659A6.485,6.485,0,0,1,60.126-1.7a6.856,6.856,0,0,1-2-4.974,6.73,6.73,0,0,1,2.014-4.907,6.567,6.567,0,0,1,4.846-2.039,6.267,6.267,0,0,1,2.96.7,6.736,6.736,0,0,1,2.325,2.087v-2.441Zm-6.836,1.306a5.158,5.158,0,0,0-2.637.7A5.147,5.147,0,0,0,60.565-9.3a5.4,5.4,0,0,0-.714,2.686,5.405,5.405,0,0,0,.72,2.686,5.244,5.244,0,0,0,1.935,2,5.056,5.056,0,0,0,2.606.714,5.342,5.342,0,0,0,2.661-.708,4.951,4.951,0,0,0,1.935-1.917,5.47,5.47,0,0,0,.677-2.722,5.291,5.291,0,0,0-1.52-3.857A5.034,5.034,0,0,0,65.125-11.975Zm10.681-1.306h1.709v2.38a7.143,7.143,0,0,1,2.271-2.045,5.579,5.579,0,0,1,2.71-.677,4.709,4.709,0,0,1,2.643.757,4.508,4.508,0,0,1,1.7,2.039,10.78,10.78,0,0,1,.549,3.992V0h-1.7V-6.335A15.206,15.206,0,0,0,85.5-9.4a3.4,3.4,0,0,0-1.147-1.984,3.441,3.441,0,0,0-2.2-.665,4.214,4.214,0,0,0-2.777,1.025,4.8,4.8,0,0,0-1.617,2.539,17.659,17.659,0,0,0-.244,3.613V0H75.806Zm26.685,0h1.721V-2.7a12.5,12.5,0,0,1-.488,4.089,5.316,5.316,0,0,1-2.332,2.82A7.663,7.663,0,0,1,97.4,5.2a9.155,9.155,0,0,1-3.07-.482,6.145,6.145,0,0,1-2.216-1.294A7.7,7.7,0,0,1,90.54,1.05H92.4A4.9,4.9,0,0,0,94.348,3a6.274,6.274,0,0,0,2.966.635,6.107,6.107,0,0,0,2.948-.653,4,4,0,0,0,1.715-1.642,7.329,7.329,0,0,0,.513-3.186v-.684a6.468,6.468,0,0,1-2.356,1.874A6.869,6.869,0,0,1,97.18,0a6.893,6.893,0,0,1-3.442-.909,6.458,6.458,0,0,1-2.49-2.448,6.7,6.7,0,0,1-.879-3.381,6.781,6.781,0,0,1,.916-3.436A6.726,6.726,0,0,1,93.817-12.7a6.755,6.755,0,0,1,3.412-.928,6.349,6.349,0,0,1,2.777.616,7.661,7.661,0,0,1,2.484,2.032Zm-5.042,1.306a5.4,5.4,0,0,0-2.7.7A5.086,5.086,0,0,0,92.8-9.332a5.31,5.31,0,0,0-.708,2.679A4.833,4.833,0,0,0,93.555-3.04a5.209,5.209,0,0,0,3.8,1.428,5.161,5.161,0,0,0,3.79-1.416,5,5,0,0,0,1.434-3.723,5.392,5.392,0,0,0-.659-2.679,4.8,4.8,0,0,0-1.868-1.862A5.2,5.2,0,0,0,97.449-11.975Zm21.606,7.568,1.44.757A7.856,7.856,0,0,1,118.86-1.4a6.5,6.5,0,0,1-2.087,1.3,7.275,7.275,0,0,1-2.625.446,6.339,6.339,0,0,1-5.078-2.13A7.19,7.19,0,0,1,107.239-6.6a7.1,7.1,0,0,1,1.55-4.5,6.336,6.336,0,0,1,5.261-2.515,6.544,6.544,0,0,1,5.42,2.576,7.2,7.2,0,0,1,1.465,4.541H109a5.43,5.43,0,0,0,1.477,3.8A4.7,4.7,0,0,0,114-1.221a5.646,5.646,0,0,0,1.971-.354,5.177,5.177,0,0,0,1.63-.94A8,8,0,0,0,119.055-4.407Zm0-3.577a5.672,5.672,0,0,0-.995-2.185,4.708,4.708,0,0,0-1.727-1.318,5.285,5.285,0,0,0-2.258-.5,4.86,4.86,0,0,0-3.357,1.257,5.684,5.684,0,0,0-1.55,2.747Z" transform="translate(-2.197 18.408)" fill="#5296ff"/></g></svg>',
    smartwallet_font: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="170" height="24" viewBox="0 0 170 24"><defs><clipPath id="clip-smartwallet_font"><rect width="170" height="24"/></clipPath></defs><g id="smartwallet_font" clip-path="url(#clip-smartwallet_font)"><path id="Path_5169" data-name="Path 5169" d="M.33-3.345,1.855-4.26Q3.467-1.294,5.579-1.294a3.566,3.566,0,0,0,1.7-.421A2.98,2.98,0,0,0,8.484-2.844a2.922,2.922,0,0,0,.415-1.5,3.044,3.044,0,0,0-.61-1.77A14.626,14.626,0,0,0,5.212-9a15.725,15.725,0,0,1-2.8-2.454A4.486,4.486,0,0,1,1.465-14.2a4.168,4.168,0,0,1,.562-2.136,4,4,0,0,1,1.581-1.52,4.556,4.556,0,0,1,2.216-.555A4.722,4.722,0,0,1,8.2-17.78a8.142,8.142,0,0,1,2.338,2.313L9.07-14.355a7.027,7.027,0,0,0-1.727-1.77,2.976,2.976,0,0,0-1.556-.427,2.465,2.465,0,0,0-1.776.659,2.157,2.157,0,0,0-.69,1.624,2.767,2.767,0,0,0,.244,1.135,4.189,4.189,0,0,0,.891,1.2q.354.342,2.319,1.794a13.055,13.055,0,0,1,3.2,3.064,4.938,4.938,0,0,1,.867,2.7A4.578,4.578,0,0,1,9.357-.989,4.985,4.985,0,0,1,5.75.452,5.292,5.292,0,0,1,2.783-.421,7.986,7.986,0,0,1,.33-3.345Zm14.014-9.937h1.7v2.295a6.614,6.614,0,0,1,1.831-1.855,5.187,5.187,0,0,1,2.722-.781,4.527,4.527,0,0,1,1.831.378,3.937,3.937,0,0,1,1.416,1.007,5.4,5.4,0,0,1,.952,1.8,6.313,6.313,0,0,1,2.136-2.374,5.063,5.063,0,0,1,2.759-.812,4.324,4.324,0,0,1,2.435.7,4.151,4.151,0,0,1,1.569,1.941A10.334,10.334,0,0,1,34.2-7.251V0H32.458V-7.251a9.445,9.445,0,0,0-.305-2.936,2.646,2.646,0,0,0-1.044-1.288,3.125,3.125,0,0,0-1.764-.488,3.845,3.845,0,0,0-2.277.732,4.216,4.216,0,0,0-1.508,1.953A12.34,12.34,0,0,0,25.085-5.2V0h-1.7V-6.8a11.666,11.666,0,0,0-.3-3.265,2.734,2.734,0,0,0-1.044-1.379,3.018,3.018,0,0,0-1.77-.519,3.819,3.819,0,0,0-2.216.714,4.228,4.228,0,0,0-1.526,1.923,10.364,10.364,0,0,0-.494,3.7V0h-1.7Zm36.694,0V0H49.353V-2.283A7.325,7.325,0,0,1,46.942-.317a6.519,6.519,0,0,1-2.924.659A6.485,6.485,0,0,1,39.2-1.7a6.856,6.856,0,0,1-2-4.974,6.73,6.73,0,0,1,2.014-4.907,6.567,6.567,0,0,1,4.846-2.039,6.267,6.267,0,0,1,2.96.7,6.736,6.736,0,0,1,2.325,2.087v-2.441ZM44.2-11.975a5.158,5.158,0,0,0-2.637.7A5.147,5.147,0,0,0,39.642-9.3a5.4,5.4,0,0,0-.714,2.686,5.405,5.405,0,0,0,.72,2.686,5.244,5.244,0,0,0,1.935,2,5.056,5.056,0,0,0,2.606.714,5.342,5.342,0,0,0,2.661-.708,4.951,4.951,0,0,0,1.935-1.917,5.47,5.47,0,0,0,.677-2.722,5.291,5.291,0,0,0-1.52-3.857A5.034,5.034,0,0,0,44.2-11.975Zm10.034-1.306h1.746v1.941a6.128,6.128,0,0,1,1.648-1.715,3.25,3.25,0,0,1,1.807-.568,3.117,3.117,0,0,1,1.514.452l-.891,1.44a2.377,2.377,0,0,0-.9-.232,2.471,2.471,0,0,0-1.648.7A4.438,4.438,0,0,0,56.3-9.082a20.9,20.9,0,0,0-.317,4.59V0H54.236Zm9.656-4.932h1.721v4.932h2.71v1.465h-2.71V0H63.892V-11.816H61.56v-1.465h2.332Zm6.25.256h1.843l3.65,12.939,5.151-12.939h.366l5.09,12.939,3.723-12.939H91.8L86.646,0H86.3L80.981-13.586,75.549,0h-.342Zm37.964,4.675V0h-1.685V-2.283A7.325,7.325,0,0,1,104.01-.317a6.519,6.519,0,0,1-2.924.659A6.485,6.485,0,0,1,96.271-1.7a6.856,6.856,0,0,1-2-4.974,6.73,6.73,0,0,1,2.014-4.907,6.567,6.567,0,0,1,4.846-2.039,6.267,6.267,0,0,1,2.96.7,6.736,6.736,0,0,1,2.325,2.087v-2.441Zm-6.836,1.306a5.158,5.158,0,0,0-2.637.7A5.147,5.147,0,0,0,96.71-9.3,5.4,5.4,0,0,0,96-6.616a5.405,5.405,0,0,0,.72,2.686,5.244,5.244,0,0,0,1.935,2,5.056,5.056,0,0,0,2.606.714,5.342,5.342,0,0,0,2.661-.708,4.951,4.951,0,0,0,1.935-1.917,5.47,5.47,0,0,0,.677-2.722,5.291,5.291,0,0,0-1.52-3.857A5.034,5.034,0,0,0,101.27-11.975Zm10.425-6.433H113.4V0h-1.709Zm5,0h1.709V0H116.7Zm16.443,14,1.44.757A7.856,7.856,0,0,1,132.947-1.4a6.5,6.5,0,0,1-2.087,1.3,7.275,7.275,0,0,1-2.625.446,6.339,6.339,0,0,1-5.078-2.13A7.19,7.19,0,0,1,121.326-6.6a7.1,7.1,0,0,1,1.55-4.5,6.336,6.336,0,0,1,5.261-2.515,6.544,6.544,0,0,1,5.42,2.576,7.2,7.2,0,0,1,1.465,4.541H123.083a5.43,5.43,0,0,0,1.477,3.8,4.7,4.7,0,0,0,3.528,1.483,5.646,5.646,0,0,0,1.971-.354,5.177,5.177,0,0,0,1.63-.94A8,8,0,0,0,133.142-4.407Zm0-3.577a5.672,5.672,0,0,0-.995-2.185,4.708,4.708,0,0,0-1.727-1.318,5.285,5.285,0,0,0-2.258-.5A4.86,4.86,0,0,0,124.8-10.73a5.684,5.684,0,0,0-1.55,2.747ZM139.7-18.213h1.721v4.932h2.71v1.465h-2.71V0H139.7V-11.816h-2.332v-1.465H139.7Z" transform="translate(0 18.408)" fill="#f9ac1a"/></g></svg>',
    lock_auth_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 40 40"><defs><clipPath id="clip-lock_auth_icon"><rect width="40" height="40"/></clipPath></defs><g id="lock_auth_icon" clip-path="url(#clip-lock_auth_icon)"><path id="lock_auth_icon-2" data-name="lock_auth_icon" d="M-6671.374,9557.009a3.626,3.626,0,0,1-3.626-3.626v-11.15a3.627,3.627,0,0,1,3.626-3.627h1.142v-2.115a6.49,6.49,0,0,1,1.9-4.591,6.489,6.489,0,0,1,4.588-1.9h.069a6.493,6.493,0,0,1,4.588,1.9,6.5,6.5,0,0,1,1.9,4.591v2.115h1.144a3.627,3.627,0,0,1,3.626,3.627v11.15a3.626,3.626,0,0,1-3.626,3.626Zm-1.336-16.11a2.109,2.109,0,0,0-.617,1.494v10.832a2.119,2.119,0,0,0,.617,1.494,2.119,2.119,0,0,0,1.494.616h15.017a2.111,2.111,0,0,0,1.492-.616,2.123,2.123,0,0,0,.619-1.494v-10.832a2.113,2.113,0,0,0-.619-1.494,2.114,2.114,0,0,0-1.492-.619h-15.017A2.122,2.122,0,0,0-6672.71,9540.9Zm5.562-7.785a4.815,4.815,0,0,0-1.411,3.4v2.089h9.7v-2.089a4.812,4.812,0,0,0-1.408-3.4,4.811,4.811,0,0,0-3.4-1.408h-.079A4.807,4.807,0,0,0-6667.148,9533.113Zm8.071,16.391-.012-.007a.636.636,0,0,1-.273-.458.641.641,0,0,1,.165-.506l.461-.5s-.314-.067-.641-.142a.648.648,0,0,1-.424-.321.649.649,0,0,1-.039-.53s0,0,0-.007a.645.645,0,0,1,.369-.377.643.643,0,0,1,.528.029l.568.292s-.045-.331-.091-.671a.641.641,0,0,1,.154-.509.635.635,0,0,1,.484-.221h.01a.647.647,0,0,1,.484.221.643.643,0,0,1,.151.513c-.048.339-.093.667-.093.667l.573-.295a.643.643,0,0,1,.528-.026.641.641,0,0,1,.369.379s0,.008,0,.01a.642.642,0,0,1-.041.527.641.641,0,0,1-.422.319c-.324.074-.636.142-.636.142s.228.247.468.5a.654.654,0,0,1,.17.511.644.644,0,0,1-.278.46l-.01.008a.649.649,0,0,1-.508.094.642.642,0,0,1-.415-.314c-.173-.312-.348-.629-.348-.629l-.331.619a.644.644,0,0,1-.415.324.648.648,0,0,1-.15.018A.638.638,0,0,1-6659.077,9549.5Zm-5.888,0-.01-.007a.638.638,0,0,1-.273-.458.635.635,0,0,1,.166-.506l.46-.5s-.314-.067-.64-.142a.643.643,0,0,1-.425-.321.642.642,0,0,1-.038-.53s0,0,0-.007a.653.653,0,0,1,.372-.377.643.643,0,0,1,.528.029l.568.292s-.046-.331-.091-.671a.641.641,0,0,1,.154-.509.634.634,0,0,1,.482-.221h.012a.647.647,0,0,1,.485.221.645.645,0,0,1,.151.513c-.048.339-.1.667-.1.667s.283-.144.576-.295a.641.641,0,0,1,.527-.026.641.641,0,0,1,.37.379.046.046,0,0,0,0,.01.635.635,0,0,1-.039.527.641.641,0,0,1-.424.319c-.322.074-.636.142-.636.142s.23.247.468.5a.635.635,0,0,1,.17.511.633.633,0,0,1-.275.46l-.01.008a.654.654,0,0,1-.511.094.638.638,0,0,1-.413-.314c-.175-.312-.348-.629-.348-.629l-.331.619a.645.645,0,0,1-.415.324.651.651,0,0,1-.15.018A.648.648,0,0,1-6664.965,9549.5Zm-5.886,0-.012-.007a.646.646,0,0,1-.273-.458.642.642,0,0,1,.166-.506l.463-.5s-.314-.067-.641-.142a.638.638,0,0,1-.424-.321.642.642,0,0,1-.039-.53s0,0,0-.007a.648.648,0,0,1,.372-.377.636.636,0,0,1,.525.029l.569.292s-.043-.331-.091-.671a.643.643,0,0,1,.153-.509.64.64,0,0,1,.485-.221h.009a.647.647,0,0,1,.487.221.651.651,0,0,1,.149.513c-.048.339-.094.667-.094.667s.283-.144.576-.295a.642.642,0,0,1,.528-.026.652.652,0,0,1,.369.379.046.046,0,0,0,0,.01.626.626,0,0,1-.041.527.642.642,0,0,1-.422.319c-.324.074-.635.142-.635.142s.23.247.467.5a.644.644,0,0,1,.17.511.647.647,0,0,1-.276.46.031.031,0,0,0-.009.008.658.658,0,0,1-.511.094.639.639,0,0,1-.413-.314c-.175-.312-.35-.629-.35-.629s-.163.31-.329.619a.643.643,0,0,1-.417.324.651.651,0,0,1-.15.018A.646.646,0,0,1-6670.852,9549.5Z" transform="translate(6684 -9523.999)"/></g></svg>',

    unlock_auth_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 40 40"><defs><clipPath id="clip-unlock_auth_icon"><rect width="40" height="40"/></clipPath></defs><g id="unlock_auth_icon" clip-path="url(#clip-unlock_auth_icon)"><path id="unlock_auth_icon-2" data-name="unlock_auth_icon" d="M-6671.374,9557.009a3.626,3.626,0,0,1-3.626-3.626v-11.15a3.627,3.627,0,0,1,3.626-3.627h12.515v-2.089a4.812,4.812,0,0,0-1.408-3.4,4.811,4.811,0,0,0-3.4-1.408h-.079a4.807,4.807,0,0,0-3.4,1.408c-.05.05-.1.1-.149.153a.824.824,0,0,1-1.084.115.4.4,0,0,1-.034-.024.832.832,0,0,1-.345-.588.82.82,0,0,1,.213-.645c.069-.077.142-.151.216-.226a6.489,6.489,0,0,1,4.588-1.9h.069a6.493,6.493,0,0,1,4.588,1.9,6.5,6.5,0,0,1,1.9,4.591v2.115h1.144a3.627,3.627,0,0,1,3.626,3.627v11.15a3.626,3.626,0,0,1-3.626,3.626Zm-1.336-16.11a2.109,2.109,0,0,0-.617,1.494v10.832a2.119,2.119,0,0,0,.617,1.494,2.119,2.119,0,0,0,1.494.616h15.017a2.111,2.111,0,0,0,1.492-.616,2.123,2.123,0,0,0,.619-1.494v-10.832a2.113,2.113,0,0,0-.619-1.494,2.114,2.114,0,0,0-1.492-.619h-15.017A2.122,2.122,0,0,0-6672.71,9540.9Zm13.633,8.605-.012-.007a.636.636,0,0,1-.273-.458.641.641,0,0,1,.165-.506l.461-.5s-.314-.067-.641-.142a.648.648,0,0,1-.424-.321.649.649,0,0,1-.039-.53s0,0,0-.007a.645.645,0,0,1,.369-.377.643.643,0,0,1,.528.029l.568.292s-.045-.331-.091-.671a.641.641,0,0,1,.154-.509.635.635,0,0,1,.484-.221h.01a.647.647,0,0,1,.484.221.643.643,0,0,1,.151.513c-.048.339-.093.667-.093.667l.573-.295a.643.643,0,0,1,.528-.026.641.641,0,0,1,.369.379s0,.008,0,.01a.642.642,0,0,1-.041.527.641.641,0,0,1-.422.319c-.324.074-.636.142-.636.142s.228.247.468.5a.654.654,0,0,1,.17.511.644.644,0,0,1-.278.46l-.01.008a.649.649,0,0,1-.508.094.642.642,0,0,1-.415-.314c-.173-.312-.348-.629-.348-.629l-.331.619a.644.644,0,0,1-.415.324.648.648,0,0,1-.15.018A.638.638,0,0,1-6659.077,9549.5Zm-5.888,0-.01-.007a.638.638,0,0,1-.273-.458.635.635,0,0,1,.166-.506l.46-.5s-.314-.067-.64-.142a.643.643,0,0,1-.425-.321.642.642,0,0,1-.038-.53s0,0,0-.007a.653.653,0,0,1,.372-.377.643.643,0,0,1,.528.029l.568.292s-.046-.331-.091-.671a.641.641,0,0,1,.154-.509.634.634,0,0,1,.482-.221h.012a.647.647,0,0,1,.485.221.645.645,0,0,1,.151.513c-.048.339-.1.667-.1.667s.283-.144.576-.295a.642.642,0,0,1,.527-.026.641.641,0,0,1,.37.379.046.046,0,0,0,0,.01.635.635,0,0,1-.039.527.641.641,0,0,1-.424.319c-.322.074-.636.142-.636.142s.23.247.468.5a.635.635,0,0,1,.17.511.633.633,0,0,1-.275.46l-.01.008a.654.654,0,0,1-.511.094.638.638,0,0,1-.413-.314c-.175-.312-.348-.629-.348-.629l-.331.619a.645.645,0,0,1-.415.324.651.651,0,0,1-.15.018A.648.648,0,0,1-6664.965,9549.5Zm-5.886,0-.012-.007a.646.646,0,0,1-.273-.458.642.642,0,0,1,.166-.506l.463-.5s-.314-.067-.641-.142a.638.638,0,0,1-.424-.321.642.642,0,0,1-.039-.53s0,0,0-.007a.648.648,0,0,1,.372-.377.636.636,0,0,1,.525.029l.569.292s-.043-.331-.091-.671a.643.643,0,0,1,.153-.509.64.64,0,0,1,.485-.221h.009a.647.647,0,0,1,.487.221.651.651,0,0,1,.149.513c-.048.339-.094.667-.094.667s.283-.144.576-.295a.642.642,0,0,1,.528-.026.652.652,0,0,1,.369.379.046.046,0,0,0,0,.01.626.626,0,0,1-.041.527.642.642,0,0,1-.422.319c-.324.074-.635.142-.635.142s.23.247.467.5a.644.644,0,0,1,.17.511.647.647,0,0,1-.276.46.031.031,0,0,0-.009.008.658.658,0,0,1-.511.094.639.639,0,0,1-.413-.314c-.175-.312-.35-.629-.35-.629s-.163.31-.329.619a.643.643,0,0,1-.417.324.651.651,0,0,1-.15.018A.646.646,0,0,1-6670.852,9549.5Z" transform="translate(6684 -9523.999)"/>\n  </g>\n</svg>',
    redemption_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_redeem_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_redeem_icon" clip-path="url(#clip-blu_redeem_icon)"><g id="Blu_Redeem_icon-2" data-name="Blu Redeem icon" transform="translate(0 0)"><rect id="Redeem_Withdra_icon" data-name="Redeem Withdra icon" width="42" height="46" transform="translate(0 0)" fill="none"/><g id="Redeem_Withdra_icon-2" data-name="Redeem Withdra icon" transform="translate(1 15.202)"><path id="Path_6098" data-name="Path 6098" d="M4.931,23.439c1.049,1.363,2.5,3.248,3.251,4.229a1.631,1.631,0,0,1-.3,2.286l-.038.029a1.631,1.631,0,0,1-2.286-.3L.366,22.906a1.776,1.776,0,0,1,0-2.16l5.189-6.774a1.63,1.63,0,0,1,2.286-.3l.038.029a1.631,1.631,0,0,1,.3,2.286L5.076,20.028l28.238,0a2.948,2.948,0,0,0,2.949-2.949V8.261a1.683,1.683,0,0,1,1.683-1.683h.117a1.683,1.683,0,0,1,1.683,1.683v9.075a6.108,6.108,0,0,1-6.108,6.108H28.713ZM25.139,4.234c-.167-1.859-1.767-2.492-3.791-2.681l.016-2.578-1.57-.008-.014,2.509c-.412,0-.835,0-1.253.008l.015-2.525-1.569-.01-.014,2.577c-.342.005-.674.009-1,.007V1.524L13.8,1.51l-.011,1.676s1.159-.015,1.139.006a.808.808,0,0,1,.9.693c-.015,2.6-.026,4.315-.043,7.059a.553.553,0,0,1-.591.516c.019.018-1.141-.007-1.141-.007l-.322,1.871,2.041.013c.379,0,.754.012,1.12.015l-.015,2.607,1.568.011.015-2.579q.645.016,1.253.019l-.015,2.568,1.569.009.016-2.6c2.639-.136,4.489-.788,4.733-3.264a2.671,2.671,0,0,0-2.231-3.257A2.427,2.427,0,0,0,25.139,4.234ZM22.91,9.793c-.011,1.948-3.346,1.706-4.408,1.7l.021-3.453C19.586,8.048,22.922,7.762,22.91,9.793Zm11.9-18.116c-1.049-1.363-2.5-3.248-3.251-4.229a1.63,1.63,0,0,1,.3-2.286l.038-.029a1.631,1.631,0,0,1,2.286.3L39.38-7.789a1.776,1.776,0,0,1,0,2.16L34.19,1.145a1.631,1.631,0,0,1-2.286.3l-.038-.029a1.631,1.631,0,0,1-.3-2.286L34.67-4.912l-28.238,0a2.949,2.949,0,0,0-2.085.864,2.949,2.949,0,0,0-.864,2.085V6.856A1.683,1.683,0,0,1,1.8,8.539H1.683A1.683,1.683,0,0,1,0,6.856V-2.219A6.107,6.107,0,0,1,1.789-6.538,6.107,6.107,0,0,1,6.108-8.328h4.925ZM22.21,4.916c-.012,1.772-2.793,1.549-3.678,1.543l.019-3.132C19.437,3.333,22.221,3.068,22.21,4.916Z" transform="translate(0 0)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    blu_redeem_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_redeem_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_redeem_icon" clip-path="url(#clip-blu_redeem_icon)"><g id="Blu_Redeem_icon-2" data-name="Blu Redeem icon" transform="translate(0 0)"><rect id="Redeem_Withdra_icon" data-name="Redeem Withdra icon" width="42" height="46" transform="translate(0 0)" fill="none"/><g id="Redeem_Withdra_icon-2" data-name="Redeem Withdra icon" transform="translate(1 15.202)"><path id="Path_6098" data-name="Path 6098" d="M4.931,23.439c1.049,1.363,2.5,3.248,3.251,4.229a1.631,1.631,0,0,1-.3,2.286l-.038.029a1.631,1.631,0,0,1-2.286-.3L.366,22.906a1.776,1.776,0,0,1,0-2.16l5.189-6.774a1.63,1.63,0,0,1,2.286-.3l.038.029a1.631,1.631,0,0,1,.3,2.286L5.076,20.028l28.238,0a2.948,2.948,0,0,0,2.949-2.949V8.261a1.683,1.683,0,0,1,1.683-1.683h.117a1.683,1.683,0,0,1,1.683,1.683v9.075a6.108,6.108,0,0,1-6.108,6.108H28.713ZM25.139,4.234c-.167-1.859-1.767-2.492-3.791-2.681l.016-2.578-1.57-.008-.014,2.509c-.412,0-.835,0-1.253.008l.015-2.525-1.569-.01-.014,2.577c-.342.005-.674.009-1,.007V1.524L13.8,1.51l-.011,1.676s1.159-.015,1.139.006a.808.808,0,0,1,.9.693c-.015,2.6-.026,4.315-.043,7.059a.553.553,0,0,1-.591.516c.019.018-1.141-.007-1.141-.007l-.322,1.871,2.041.013c.379,0,.754.012,1.12.015l-.015,2.607,1.568.011.015-2.579q.645.016,1.253.019l-.015,2.568,1.569.009.016-2.6c2.639-.136,4.489-.788,4.733-3.264a2.671,2.671,0,0,0-2.231-3.257A2.427,2.427,0,0,0,25.139,4.234ZM22.91,9.793c-.011,1.948-3.346,1.706-4.408,1.7l.021-3.453C19.586,8.048,22.922,7.762,22.91,9.793Zm11.9-18.116c-1.049-1.363-2.5-3.248-3.251-4.229a1.63,1.63,0,0,1,.3-2.286l.038-.029a1.631,1.631,0,0,1,2.286.3L39.38-7.789a1.776,1.776,0,0,1,0,2.16L34.19,1.145a1.631,1.631,0,0,1-2.286.3l-.038-.029a1.631,1.631,0,0,1-.3-2.286L34.67-4.912l-28.238,0a2.949,2.949,0,0,0-2.085.864,2.949,2.949,0,0,0-.864,2.085V6.856A1.683,1.683,0,0,1,1.8,8.539H1.683A1.683,1.683,0,0,1,0,6.856V-2.219A6.107,6.107,0,0,1,1.789-6.538,6.107,6.107,0,0,1,6.108-8.328h4.925ZM22.21,4.916c-.012,1.772-2.793,1.549-3.678,1.543l.019-3.132C19.437,3.333,22.221,3.068,22.21,4.916Z" transform="translate(0 0)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    blu_redeem_icon_green: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_redeem_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_redeem_icon" clip-path="url(#clip-blu_redeem_icon)"><g id="Blu_Redeem_icon-2" data-name="Blu Redeem icon" transform="translate(0 0)"><rect id="Redeem_Withdra_icon" data-name="Redeem Withdra icon" width="42" height="46" transform="translate(0 0)" fill="none"/><g id="Redeem_Withdra_icon-2" data-name="Redeem Withdra icon" transform="translate(1 15.202)"><path id="Path_6098" data-name="Path 6098" d="M4.931,23.439c1.049,1.363,2.5,3.248,3.251,4.229a1.631,1.631,0,0,1-.3,2.286l-.038.029a1.631,1.631,0,0,1-2.286-.3L.366,22.906a1.776,1.776,0,0,1,0-2.16l5.189-6.774a1.63,1.63,0,0,1,2.286-.3l.038.029a1.631,1.631,0,0,1,.3,2.286L5.076,20.028l28.238,0a2.948,2.948,0,0,0,2.949-2.949V8.261a1.683,1.683,0,0,1,1.683-1.683h.117a1.683,1.683,0,0,1,1.683,1.683v9.075a6.108,6.108,0,0,1-6.108,6.108H28.713ZM25.139,4.234c-.167-1.859-1.767-2.492-3.791-2.681l.016-2.578-1.57-.008-.014,2.509c-.412,0-.835,0-1.253.008l.015-2.525-1.569-.01-.014,2.577c-.342.005-.674.009-1,.007V1.524L13.8,1.51l-.011,1.676s1.159-.015,1.139.006a.808.808,0,0,1,.9.693c-.015,2.6-.026,4.315-.043,7.059a.553.553,0,0,1-.591.516c.019.018-1.141-.007-1.141-.007l-.322,1.871,2.041.013c.379,0,.754.012,1.12.015l-.015,2.607,1.568.011.015-2.579q.645.016,1.253.019l-.015,2.568,1.569.009.016-2.6c2.639-.136,4.489-.788,4.733-3.264a2.671,2.671,0,0,0-2.231-3.257A2.427,2.427,0,0,0,25.139,4.234ZM22.91,9.793c-.011,1.948-3.346,1.706-4.408,1.7l.021-3.453C19.586,8.048,22.922,7.762,22.91,9.793Zm11.9-18.116c-1.049-1.363-2.5-3.248-3.251-4.229a1.63,1.63,0,0,1,.3-2.286l.038-.029a1.631,1.631,0,0,1,2.286.3L39.38-7.789a1.776,1.776,0,0,1,0,2.16L34.19,1.145a1.631,1.631,0,0,1-2.286.3l-.038-.029a1.631,1.631,0,0,1-.3-2.286L34.67-4.912l-28.238,0a2.949,2.949,0,0,0-2.085.864,2.949,2.949,0,0,0-.864,2.085V6.856A1.683,1.683,0,0,1,1.8,8.539H1.683A1.683,1.683,0,0,1,0,6.856V-2.219A6.107,6.107,0,0,1,1.789-6.538,6.107,6.107,0,0,1,6.108-8.328h4.925ZM22.21,4.916c-.012,1.772-2.793,1.549-3.678,1.543l.019-3.132C19.437,3.333,22.221,3.068,22.21,4.916Z" transform="translate(0 0)" fill="#22C8B5" fill-rule="evenodd"/></g></g></g></svg>',
    blu_withdraw_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_withdraw_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_withdraw_icon" clip-path="url(#clip-blu_withdraw_icon)"><g id="Blu_Withdraw_icon-2" data-name="Blu Withdraw icon"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.695v7.3a6.15,6.15,0,0,1-6.15,6.15H28.92v0l-8.906,0-8.906,0v0H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.149,6.149,0,0,1,1.8-8.923a6.15,6.15,0,0,1,4.348-1.8h4.958v0l9.288,0a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5l-13.92,0a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.695Z" transform="translate(0 10.725)" fill="white" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(17.876 10.877)" fill="white" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482l7.761-4.481A.424.424,0,0,1,12.243-8.519ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(7.811 15.167)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    blu_withdraw_icon_green: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_withdraw_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_withdraw_icon" clip-path="url(#clip-blu_withdraw_icon)"><g id="Blu_Withdraw_icon-2" data-name="Blu Withdraw icon"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.695v7.3a6.15,6.15,0,0,1-6.15,6.15H28.92v0l-8.906,0-8.906,0v0H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.149,6.149,0,0,1,1.8-8.923a6.15,6.15,0,0,1,4.348-1.8h4.958v0l9.288,0a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5l-13.92,0a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.695Z" transform="translate(0 10.725)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(17.876 10.877)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482l7.761-4.481A.424.424,0,0,1,12.243-8.519ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(7.811 15.167)" fill="#22C8B5" fill-rule="evenodd"/></g></g></g></svg>',
    withdraw_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_withdraw_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_withdraw_icon" clip-path="url(#clip-blu_withdraw_icon)"><g id="Blu_Withdraw_icon-2" data-name="Blu Withdraw icon"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.695v7.3a6.15,6.15,0,0,1-6.15,6.15H28.92v0l-8.906,0-8.906,0v0H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.149,6.149,0,0,1,1.8-8.923a6.15,6.15,0,0,1,4.348-1.8h4.958v0l9.288,0a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5l-13.92,0a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.695Z" transform="translate(0 10.725)" fill="white" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(17.876 10.877)" fill="white" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482l7.761-4.481A.424.424,0,0,1,12.243-8.519ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(7.811 15.167)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    blu_deposit_icon: '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="46" viewBox="0 0 42 46"><g id="Group_1" data-name="Group 1" transform="translate(-10 -11)"><g id="Blu_Withdraw_component" data-name="Blu Withdraw component" transform="translate(52 57) rotate(180)"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.7v7.3a6.15,6.15,0,0,1-6.15,6.15H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.15,6.15,0,0,1,1.8-8.924a6.15,6.15,0,0,1,4.347-1.8H20.394a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5H6.468a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.7Z" transform="translate(40 22.277) rotate(180)" fill="white" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(-9.505 28.857) rotate(7)" fill="white" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482L11.92-8.449a.424.424,0,0,1,.323-.07ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(33.877 17.166) rotate(180)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    deposit_icon: '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="46" viewBox="0 0 42 46"><g id="Group_1" data-name="Group 1" transform="translate(-10 -11)"><g id="Blu_Withdraw_component" data-name="Blu Withdraw component" transform="translate(52 57) rotate(180)"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.7v7.3a6.15,6.15,0,0,1-6.15,6.15H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.15,6.15,0,0,1,1.8-8.924a6.15,6.15,0,0,1,4.347-1.8H20.394a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5H6.468a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.7Z" transform="translate(40 22.277) rotate(180)" fill="white" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(-9.505 28.857) rotate(7)" fill="white" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482L11.92-8.449a.424.424,0,0,1,.323-.07ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(33.877 17.166) rotate(180)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    blu_deposit_icon_green: '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="46" viewBox="0 0 42 46"><g id="Group_1" data-name="Group 1" transform="translate(-10 -11)"><g id="Blu_Withdraw_component" data-name="Blu Withdraw component" transform="translate(52 57) rotate(180)"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.7v7.3a6.15,6.15,0,0,1-6.15,6.15H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.15,6.15,0,0,1,1.8-8.924a6.15,6.15,0,0,1,4.347-1.8H20.394a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5H6.468a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.7Z" transform="translate(40 22.277) rotate(180)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(-9.505 28.857) rotate(7)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482L11.92-8.449a.424.424,0,0,1,.323-.07ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(33.877 17.166) rotate(180)" fill="#22C8B5" fill-rule="evenodd"/></g></g></g></svg>',
    blu_deposit_icon_blue: '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="46" viewBox="0 0 42 46"><g id="Group_1" data-name="Group 1" transform="translate(-10 -11)"><g id="Blu_Withdraw_component" data-name="Blu Withdraw component" transform="translate(52 57) rotate(180)"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.7v7.3a6.15,6.15,0,0,1-6.15,6.15H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.15,6.15,0,0,1,1.8-8.924a6.15,6.15,0,0,1,4.347-1.8H20.394a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5H6.468a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.7Z" transform="translate(40 22.277) rotate(180)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(-9.505 28.857) rotate(7)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482L11.92-8.449a.424.424,0,0,1,.323-.07ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(33.877 17.166) rotate(180)" fill="#211c54" fill-rule="evenodd"/></g></g></g></svg>',
    blu_redeem_icon_blu: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_redeem_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_redeem_icon" clip-path="url(#clip-blu_redeem_icon)"><g id="Blu_Redeem_icon-2" data-name="Blu Redeem icon" transform="translate(0 0)"><rect id="Redeem_Withdra_icon" data-name="Redeem Withdra icon" width="42" height="46" transform="translate(0 0)" fill="none"/><g id="Redeem_Withdra_icon-2" data-name="Redeem Withdra icon" transform="translate(1 15.202)"><path id="Path_6098" data-name="Path 6098" d="M4.931,23.439c1.049,1.363,2.5,3.248,3.251,4.229a1.631,1.631,0,0,1-.3,2.286l-.038.029a1.631,1.631,0,0,1-2.286-.3L.366,22.906a1.776,1.776,0,0,1,0-2.16l5.189-6.774a1.63,1.63,0,0,1,2.286-.3l.038.029a1.631,1.631,0,0,1,.3,2.286L5.076,20.028l28.238,0a2.948,2.948,0,0,0,2.949-2.949V8.261a1.683,1.683,0,0,1,1.683-1.683h.117a1.683,1.683,0,0,1,1.683,1.683v9.075a6.108,6.108,0,0,1-6.108,6.108H28.713ZM25.139,4.234c-.167-1.859-1.767-2.492-3.791-2.681l.016-2.578-1.57-.008-.014,2.509c-.412,0-.835,0-1.253.008l.015-2.525-1.569-.01-.014,2.577c-.342.005-.674.009-1,.007V1.524L13.8,1.51l-.011,1.676s1.159-.015,1.139.006a.808.808,0,0,1,.9.693c-.015,2.6-.026,4.315-.043,7.059a.553.553,0,0,1-.591.516c.019.018-1.141-.007-1.141-.007l-.322,1.871,2.041.013c.379,0,.754.012,1.12.015l-.015,2.607,1.568.011.015-2.579q.645.016,1.253.019l-.015,2.568,1.569.009.016-2.6c2.639-.136,4.489-.788,4.733-3.264a2.671,2.671,0,0,0-2.231-3.257A2.427,2.427,0,0,0,25.139,4.234ZM22.91,9.793c-.011,1.948-3.346,1.706-4.408,1.7l.021-3.453C19.586,8.048,22.922,7.762,22.91,9.793Zm11.9-18.116c-1.049-1.363-2.5-3.248-3.251-4.229a1.63,1.63,0,0,1,.3-2.286l.038-.029a1.631,1.631,0,0,1,2.286.3L39.38-7.789a1.776,1.776,0,0,1,0,2.16L34.19,1.145a1.631,1.631,0,0,1-2.286.3l-.038-.029a1.631,1.631,0,0,1-.3-2.286L34.67-4.912l-28.238,0a2.949,2.949,0,0,0-2.085.864,2.949,2.949,0,0,0-.864,2.085V6.856A1.683,1.683,0,0,1,1.8,8.539H1.683A1.683,1.683,0,0,1,0,6.856V-2.219A6.107,6.107,0,0,1,1.789-6.538,6.107,6.107,0,0,1,6.108-8.328h4.925ZM22.21,4.916c-.012,1.772-2.793,1.549-3.678,1.543l.019-3.132C19.437,3.333,22.221,3.068,22.21,4.916Z" transform="translate(0 0)" fill="#211c54" fill-rule="evenodd"/></g></g></g></svg>',
    blu_withdraw_icon_blu: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_withdraw_icon"><rect width="42" height="46"/></clipPath></defs><g id="blu_withdraw_icon" clip-path="url(#clip-blu_withdraw_icon)"><g id="Blu_Withdraw_icon-2" data-name="Blu Withdraw icon"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Blu_Wiithdraw_icon-2" data-name="Blu Wiithdraw icon" transform="translate(1 7)"><path id="Path_6095" data-name="Path 6095" d="M38.334,6.466a1.7,1.7,0,0,1,1.695,1.695v7.3a6.15,6.15,0,0,1-6.15,6.15H28.92v0l-8.906,0-8.906,0v0H6.15A6.15,6.15,0,0,1,0,15.458V-4.575A6.149,6.149,0,0,1,1.8-8.923a6.15,6.15,0,0,1,4.348-1.8h4.958v0l9.288,0a1.7,1.7,0,0,1,1.694,1.695v.045a1.694,1.694,0,0,1-.5,1.2,1.7,1.7,0,0,1-1.2.5l-13.92,0a2.97,2.97,0,0,0-2.1.869,2.97,2.97,0,0,0-.869,2.1V15.2a2.969,2.969,0,0,0,2.969,2.969H33.553A2.969,2.969,0,0,0,36.522,15.2V8.161a1.694,1.694,0,0,1,1.694-1.695Z" transform="translate(0 10.725)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6096" data-name="Path 6096" d="M10.736.514a1.694,1.694,0,0,1,.024-2.372l5.256-5.256H10.639A1.767,1.767,0,0,1,8.872-8.881h0a1.767,1.767,0,0,1,1.767-1.767h8.046a3.43,3.43,0,0,1,2.425,1,3.43,3.43,0,0,1,1,2.425V.7a1.767,1.767,0,0,1-1.767,1.767h0A1.767,1.767,0,0,1,18.58.7V-4.68L13.257.643a1.7,1.7,0,0,1-1.215.5,1.693,1.693,0,0,1-1.2-.521Z" transform="translate(17.876 10.877)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6097" data-name="Path 6097" d="M12.243-8.519a.683.683,0,0,1,.24.068l7.771,4.487a.657.657,0,0,1,.277.485V5.485a.654.654,0,0,1-.277.485L12.48,10.458a.658.658,0,0,1-.558,0L4.153,5.97a.658.658,0,0,1-.276-.485V-3.486a.657.657,0,0,1,.282-.482l7.761-4.481A.424.424,0,0,1,12.243-8.519ZM5.591,4.727l.347.2c-.012-.441-.03-.91.415-.933a.449.449,0,0,1,.456.431V5.441l.968.569c0-1.084-.025-2.168,0-3.251.036-.447.853-.493.867.017V6.52l.968.569c0-1.872-.057-3.744,0-5.615.037-.446.853-.491.866.017V7.6l1.474.866V1.216L5.591-2.457Zm7.1,3.592,5.659-3.41L12.69,1.642ZM13.054,1l5.762,3.327V-2.322Zm-1.1-7.45L6.087-3.023,11.952.364ZM12.69.358l5.748-3.314L12.69-6.342Z" transform="translate(7.811 15.167)" fill="#211c54" fill-rule="evenodd"/></g></g></g></svg>',
    bsc_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_withdraw_icon"><rect width="42" height="46" /></clipPath></defs><g><path id="binancedex" class="st0" d="M276.3,477.8V502l-21.1,12.4L234.7,502v-24.2l20.5,12.4L276.3,477.8z M163.4,394.1l20.5,12.4   V448l35.3,21.1v24.2l-55.8-32.9V394.1z M347,394.1v66.4l-56.4,32.9v-24.2l35.3-21.1v-41.5L347,394.1z M290.5,361.2l21.1,12.4l0,0   v24.2l-35.3,21.1V461l-20.5,12.4L235.4,461v-42.2l-36.6-21.1v-24.2l21.1-12.4l35.3,21.1L290.5,361.2z M198.8,415.1l20.5,12.4v24.2   l-20.5-12.4V415.1z M311.6,415.1v24.2l-20.5,12.4v-24.2L311.6,415.1z M183.9,340.1l21.1,12.4l-21.1,12.4v24.2l-20.5-12.4v-24.2   L183.9,340.1z M326.5,340.1l21.1,12.4v24.2l-21.1,12.4v-24.2L306,352.5L326.5,340.1z M255.2,340.1l21.1,12.4l-21.1,12.4l-20.5-12.4   L255.2,340.1z M255.2,298.6l56.4,32.9l-20.5,12.4l-35.3-21.1l-36,21.1l-20.5-12.4L255.2,298.6z"/></g></svg>',
    balance_status_total: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="28" viewBox="0 0 26 28"><defs><clipPath id="clip-balance_status_total_icon"><rect width="26" height="28"/></clipPath></defs><g id="balance_status_total_icon" clip-path="url(#clip-balance_status_total_icon)"><g id="Balance_status_total_icon-2" data-name="Balance status total icon"><rect id="Rectangle_17173" data-name="Rectangle 17173" width="26" height="28" rx="4" fill="#8f969b"/><g id="Group_10905" data-name="Group 10905" transform="translate(-380 -675.533)"><g id="Group_10903" data-name="Group 10903" transform="translate(398 691.533) rotate(90)"><rect id="Rectangle_17174" data-name="Rectangle 17174" width="4" height="10" rx="2" transform="translate(0)" fill="#fff"/></g><g id="Group_10904" data-name="Group 10904" transform="translate(398 683.533) rotate(90)"><rect id="Rectangle_17174-2" data-name="Rectangle 17174" width="4" height="10" rx="2" transform="translate(0)" fill="#fff"/></g></g></g></g></svg>',
    balance_status_waiting: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="28" viewBox="0 0 26 28"><defs><clipPath id="clip-balance_status_waiting_icon"><rect width="26" height="28"/></clipPath></defs><g id="balance_status_waiting_icon" clip-path="url(#clip-balance_status_waiting_icon)"><g id="Balance_status_waiting_icon-2" data-name="Balance status waiting icon"><rect id="Rectangle_17172" data-name="Rectangle 17172" width="26" height="28" rx="4" fill="#e3a00a"/><g id="Group_10902" data-name="Group 10902" transform="translate(-378 -604)"><rect id="Rectangle_17174" data-name="Rectangle 17174" width="6" height="12" rx="3" transform="translate(388 608)" fill="#fff"/><rect id="Rectangle_17175" data-name="Rectangle 17175" width="6" height="6" rx="3" transform="translate(388 623)" fill="#fff"/></g></g></g></svg>',
    balance_status_available: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="28" viewBox="0 0 26 28"><defs><clipPath id="clip-balance_status_available_icon"><rect width="26" height="28"/></clipPath></defs><g id="balance_status_available_icon" clip-path="url(#clip-balance_status_available_icon)"><g id="Balance_status_available_icon-2" data-name="Balance status available icon"><rect id="Rectangle_31" data-name="Rectangle 31" width="26" height="28" rx="4" fill="#02b9a4"/><g id="Group_10910" data-name="Group 10910" transform="translate(7 8)"><g id="Group_10903" data-name="Group 10903" transform="translate(8.182)"><rect id="Rectangle_17174" data-name="Rectangle 17174" width="4" height="12" rx="2" fill="#fff"/></g><g id="Group_10904" data-name="Group 10904" transform="translate(12 0) rotate(90)"><rect id="Rectangle_17174-2" data-name="Rectangle 17174" width="4" height="12" rx="2" fill="#fff"/></g></g></g></g></svg>',
    crypto_wallet_font: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="170" height="24" viewBox="0 0 170 24"><defs><clipPath id="clip-crypto_wallet_font"><rect width="170" height="24"/></clipPath></defs><g id="crypto_wallet_font" clip-path="url(#clip-crypto_wallet_font)"><path id="Path_6022" data-name="Path 6022" d="M15.127-11.7l-1.133.869a6.193,6.193,0,0,0-2.251-1.851,6.586,6.586,0,0,0-2.886-.63,6.378,6.378,0,0,0-3.184.825A5.923,5.923,0,0,0,3.4-10.269,6.132,6.132,0,0,0,2.6-7.139,5.876,5.876,0,0,0,4.4-2.754,6.245,6.245,0,0,0,8.945-1a6.392,6.392,0,0,0,5.049-2.363l1.133.859A7.24,7.24,0,0,1,12.446-.386,8.409,8.409,0,0,1,8.857.361,7.465,7.465,0,0,1,2.91-2.148,7.573,7.573,0,0,1,1.084-7.266,7.115,7.115,0,0,1,3.3-12.573a7.626,7.626,0,0,1,5.542-2.153,8.133,8.133,0,0,1,3.633.8A7.052,7.052,0,0,1,15.127-11.7Zm2.139,1.074h1.4v1.553a4.9,4.9,0,0,1,1.318-1.372,2.6,2.6,0,0,1,1.445-.454,2.494,2.494,0,0,1,1.211.361l-.713,1.152A1.9,1.9,0,0,0,21.2-9.57a1.977,1.977,0,0,0-1.318.562,3.551,3.551,0,0,0-.967,1.743,16.716,16.716,0,0,0-.254,3.672V0h-1.4Zm5.391,0H24.1l3.652,8.184L31.3-10.625h1.455L26.416,3.887H24.971L27.021-.8Zm11.885,0H35.9v1.953a5.491,5.491,0,0,1,1.865-1.67,4.964,4.964,0,0,1,2.354-.557,5.254,5.254,0,0,1,3.877,1.631,5.384,5.384,0,0,1,1.611,3.926,5.485,5.485,0,0,1-1.6,3.979A5.188,5.188,0,0,1,40.156.273a5.184,5.184,0,0,1-2.334-.527A5.878,5.878,0,0,1,35.9-1.826V3.887H34.541ZM40.01-9.58a4.027,4.027,0,0,0-2.993,1.24A4.233,4.233,0,0,0,35.8-5.254a4.376,4.376,0,0,0,.542,2.178A3.952,3.952,0,0,0,37.9-1.543a4.3,4.3,0,0,0,2.134.566A4.027,4.027,0,0,0,42.1-1.548a4.2,4.2,0,0,0,1.548-1.6,4.324,4.324,0,0,0,.576-2.148,4.317,4.317,0,0,0-.571-2.148,4.117,4.117,0,0,0-1.538-1.577A4.126,4.126,0,0,0,40.01-9.58Zm9.346-4.99h1.377v3.945H52.9v1.172H50.732V0H49.355V-9.453H47.49v-1.172h1.865ZM59.971-10.9a5.249,5.249,0,0,1,4.063,1.777A5.535,5.535,0,0,1,65.5-5.283,5.534,5.534,0,0,1,63.95-1.392,5.19,5.19,0,0,1,59.971.273a5.2,5.2,0,0,1-3.989-1.665,5.534,5.534,0,0,1-1.548-3.892A5.522,5.522,0,0,1,55.9-9.111,5.247,5.247,0,0,1,59.971-10.9Zm0,1.338a3.924,3.924,0,0,0-2.92,1.26A4.219,4.219,0,0,0,55.83-5.254a4.333,4.333,0,0,0,.557,2.148,3.951,3.951,0,0,0,1.5,1.538,4.115,4.115,0,0,0,2.08.542,4.115,4.115,0,0,0,2.08-.542,3.951,3.951,0,0,0,1.5-1.538,4.333,4.333,0,0,0,.557-2.148A4.21,4.21,0,0,0,62.886-8.3,3.929,3.929,0,0,0,59.971-9.561Zm13.018-4.8h1.475l2.92,10.352L81.5-14.365H81.8L85.869-4.014l2.979-10.352h1.465L86.191,0h-.273L81.66-10.869,77.314,0h-.273Zm30.371,3.74V0h-1.348V-1.826a5.86,5.86,0,0,1-1.929,1.572,5.215,5.215,0,0,1-2.339.527,5.188,5.188,0,0,1-3.853-1.636,5.485,5.485,0,0,1-1.6-3.979,5.384,5.384,0,0,1,1.611-3.926A5.254,5.254,0,0,1,97.783-10.9a5.013,5.013,0,0,1,2.368.557,5.389,5.389,0,0,1,1.86,1.67v-1.953ZM97.891-9.58a4.126,4.126,0,0,0-2.109.562,4.117,4.117,0,0,0-1.538,1.577,4.317,4.317,0,0,0-.571,2.148,4.324,4.324,0,0,0,.576,2.148,4.2,4.2,0,0,0,1.548,1.6,4.045,4.045,0,0,0,2.085.571,4.274,4.274,0,0,0,2.129-.566,3.961,3.961,0,0,0,1.548-1.533,4.376,4.376,0,0,0,.542-2.178,4.233,4.233,0,0,0-1.216-3.086A4.027,4.027,0,0,0,97.891-9.58Zm8.34-5.146H107.6V0H106.23Zm4,0H111.6V0h-1.367Zm13.154,11.2,1.152.605a6.285,6.285,0,0,1-1.309,1.8,5.2,5.2,0,0,1-1.67,1.04,5.82,5.82,0,0,1-2.1.356,5.072,5.072,0,0,1-4.062-1.7,5.752,5.752,0,0,1-1.465-3.853,5.684,5.684,0,0,1,1.24-3.6,5.069,5.069,0,0,1,4.209-2.012,5.235,5.235,0,0,1,4.336,2.061,5.756,5.756,0,0,1,1.172,3.633h-9.551a4.344,4.344,0,0,0,1.182,3.042,3.762,3.762,0,0,0,2.822,1.187,4.517,4.517,0,0,0,1.577-.283,4.142,4.142,0,0,0,1.3-.752A6.4,6.4,0,0,0,123.389-3.525Zm0-2.861a4.538,4.538,0,0,0-.8-1.748,3.766,3.766,0,0,0-1.382-1.055,4.228,4.228,0,0,0-1.807-.4,3.888,3.888,0,0,0-2.686,1.006,4.547,4.547,0,0,0-1.24,2.2Zm5.244-8.184h1.377v3.945h2.168v1.172H130.01V0h-1.377V-9.453h-1.865v-1.172h1.865Z" transform="translate(0 17)" fill="#fff"/></g></svg>',
    internal_icon: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_internal_transfer"><rect width="42" height="46"/></clipPath></defs><g id="blu_internal_transfer" clip-path="url(#clip-blu_internal_transfer)"><g id="Blu_Internal_Trasnfer_component" data-name="Blu Internal Trasnfer component"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Group_11080" data-name="Group 11080" transform="translate(1 19.594)"><path id="Path_6100" data-name="Path 6100" d="M31.158,3.248a1.378,1.378,0,0,1,1.377,1.377v5.931a5,5,0,0,1-5,5h-4.03l-7.239,0-7.239,0H5a5,5,0,0,1-5-5V-5.726A5,5,0,0,1,1.464-9.261,5,5,0,0,1,5-10.725h4.03l7.55,0a1.377,1.377,0,0,1,1.377,1.377v.037a1.377,1.377,0,0,1-.4.974,1.377,1.377,0,0,1-.974.4H5.264a2.414,2.414,0,0,0-1.706.707A2.414,2.414,0,0,0,2.85-5.519V10.349a2.413,2.413,0,0,0,2.413,2.413H27.272a2.413,2.413,0,0,0,2.413-2.413V4.626a1.377,1.377,0,0,1,1.377-1.377Z" transform="translate(0 4.162)" fill="white" fill-rule="evenodd"/><path id="Path_6101" data-name="Path 6101" d="M9.711-8.519a.555.555,0,0,1,.2.055l6.317,3.647a.533.533,0,0,1,.225.394V2.863a.532.532,0,0,1-.225.394L9.9,6.905a.535.535,0,0,1-.454,0L3.136,3.258a.535.535,0,0,1-.225-.394V-4.428A.535.535,0,0,1,3.14-4.82L9.448-8.462A.345.345,0,0,1,9.711-8.519ZM4.3,2.247l.282.165c-.01-.358-.025-.74.337-.758a.365.365,0,0,1,.37.35v.824l.787.462c0-.881-.021-1.762,0-2.643.029-.363.694-.4.7.013V3.7l.787.462c0-1.521-.046-3.043,0-4.564.03-.362.693-.4.7.014V4.581l1.2.7V-.607L4.3-3.592Zm5.77,2.92,4.6-2.772-4.6-2.656Zm.3-5.949,4.684,2.7v-5.4Zm-.9-6.056L4.707-4.052,9.475-1.3Zm.6,5.534L14.747-4,10.075-6.75Z" transform="translate(4.223 7.36)" fill="white" fill-rule="evenodd"/><path id="Path_6102" data-name="Path 6102" d="M4.269-4.37A1.377,1.377,0,0,1,2.891-5.748V-8.6A5,5,0,0,1,4.355-12.13,5,5,0,0,1,7.89-13.594h4.03l7.239,0,7.239,0h4.03a5,5,0,0,1,3.535,1.464A5,5,0,0,1,35.427-8.6V7.687a5,5,0,0,1-5,5H27.09a1.377,1.377,0,0,1-1.376-1.377V11.27a1.378,1.378,0,0,1,1.378-1.377h3.072A2.413,2.413,0,0,0,32.577,7.48V-8.388a2.413,2.413,0,0,0-.707-1.706,2.412,2.412,0,0,0-1.706-.707H8.155a2.413,2.413,0,0,0-1.706.707,2.414,2.414,0,0,0-.707,1.706v2.64a1.377,1.377,0,0,1-.4.974,1.377,1.377,0,0,1-.974.4Z" transform="translate(4.194 0)" fill="white" fill-rule="evenodd"/><path id="Path_6103" data-name="Path 6103" d="M10.4-1.652a1.377,1.377,0,0,1,.019-1.928l4.272-4.272h-4.37A1.436,1.436,0,0,1,8.885-9.288h0a1.436,1.436,0,0,1,1.436-1.436h6.54a2.789,2.789,0,0,1,1.971.816,2.789,2.789,0,0,1,.816,1.971V-1.5a1.436,1.436,0,0,1-.421,1.015,1.436,1.436,0,0,1-1.015.421h0A1.436,1.436,0,0,1,16.776-1.5v-4.37L12.449-1.547a1.377,1.377,0,0,1-.988.4,1.376,1.376,0,0,1-.979-.423Z" transform="translate(12.887 4.162)" fill="white" fill-rule="evenodd"/></g></g></g></svg>',
    internal_icon_green: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_internal_transfer"><rect width="42" height="46"/></clipPath></defs><g id="blu_internal_transfer" clip-path="url(#clip-blu_internal_transfer)"><g id="Blu_Internal_Trasnfer_component" data-name="Blu Internal Trasnfer component"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Group_11080" data-name="Group 11080" transform="translate(1 19.594)"><path id="Path_6100" data-name="Path 6100" d="M31.158,3.248a1.378,1.378,0,0,1,1.377,1.377v5.931a5,5,0,0,1-5,5h-4.03l-7.239,0-7.239,0H5a5,5,0,0,1-5-5V-5.726A5,5,0,0,1,1.464-9.261,5,5,0,0,1,5-10.725h4.03l7.55,0a1.377,1.377,0,0,1,1.377,1.377v.037a1.377,1.377,0,0,1-.4.974,1.377,1.377,0,0,1-.974.4H5.264a2.414,2.414,0,0,0-1.706.707A2.414,2.414,0,0,0,2.85-5.519V10.349a2.413,2.413,0,0,0,2.413,2.413H27.272a2.413,2.413,0,0,0,2.413-2.413V4.626a1.377,1.377,0,0,1,1.377-1.377Z" transform="translate(0 4.162)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6101" data-name="Path 6101" d="M9.711-8.519a.555.555,0,0,1,.2.055l6.317,3.647a.533.533,0,0,1,.225.394V2.863a.532.532,0,0,1-.225.394L9.9,6.905a.535.535,0,0,1-.454,0L3.136,3.258a.535.535,0,0,1-.225-.394V-4.428A.535.535,0,0,1,3.14-4.82L9.448-8.462A.345.345,0,0,1,9.711-8.519ZM4.3,2.247l.282.165c-.01-.358-.025-.74.337-.758a.365.365,0,0,1,.37.35v.824l.787.462c0-.881-.021-1.762,0-2.643.029-.363.694-.4.7.013V3.7l.787.462c0-1.521-.046-3.043,0-4.564.03-.362.693-.4.7.014V4.581l1.2.7V-.607L4.3-3.592Zm5.77,2.92,4.6-2.772-4.6-2.656Zm.3-5.949,4.684,2.7v-5.4Zm-.9-6.056L4.707-4.052,9.475-1.3Zm.6,5.534L14.747-4,10.075-6.75Z" transform="translate(4.223 7.36)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6102" data-name="Path 6102" d="M4.269-4.37A1.377,1.377,0,0,1,2.891-5.748V-8.6A5,5,0,0,1,4.355-12.13,5,5,0,0,1,7.89-13.594h4.03l7.239,0,7.239,0h4.03a5,5,0,0,1,3.535,1.464A5,5,0,0,1,35.427-8.6V7.687a5,5,0,0,1-5,5H27.09a1.377,1.377,0,0,1-1.376-1.377V11.27a1.378,1.378,0,0,1,1.378-1.377h3.072A2.413,2.413,0,0,0,32.577,7.48V-8.388a2.413,2.413,0,0,0-.707-1.706,2.412,2.412,0,0,0-1.706-.707H8.155a2.413,2.413,0,0,0-1.706.707,2.414,2.414,0,0,0-.707,1.706v2.64a1.377,1.377,0,0,1-.4.974,1.377,1.377,0,0,1-.974.4Z" transform="translate(4.194 0)" fill="#22C8B5" fill-rule="evenodd"/><path id="Path_6103" data-name="Path 6103" d="M10.4-1.652a1.377,1.377,0,0,1,.019-1.928l4.272-4.272h-4.37A1.436,1.436,0,0,1,8.885-9.288h0a1.436,1.436,0,0,1,1.436-1.436h6.54a2.789,2.789,0,0,1,1.971.816,2.789,2.789,0,0,1,.816,1.971V-1.5a1.436,1.436,0,0,1-.421,1.015,1.436,1.436,0,0,1-1.015.421h0A1.436,1.436,0,0,1,16.776-1.5v-4.37L12.449-1.547a1.377,1.377,0,0,1-.988.4,1.376,1.376,0,0,1-.979-.423Z" transform="translate(12.887 4.162)" fill="#22C8B5" fill-rule="evenodd"/></g></g></g></svg>',
    internal_icon_blu: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="46" viewBox="0 0 42 46"><defs><clipPath id="clip-blu_internal_transfer"><rect width="42" height="46"/></clipPath></defs><g id="blu_internal_transfer" clip-path="url(#clip-blu_internal_transfer)"><g id="Blu_Internal_Trasnfer_component" data-name="Blu Internal Trasnfer component"><rect id="Blu_Wiithdraw_icon" data-name="Blu Wiithdraw icon" width="42" height="46" fill="none"/><g id="Group_11080" data-name="Group 11080" transform="translate(1 19.594)"><path id="Path_6100" data-name="Path 6100" d="M31.158,3.248a1.378,1.378,0,0,1,1.377,1.377v5.931a5,5,0,0,1-5,5h-4.03l-7.239,0-7.239,0H5a5,5,0,0,1-5-5V-5.726A5,5,0,0,1,1.464-9.261,5,5,0,0,1,5-10.725h4.03l7.55,0a1.377,1.377,0,0,1,1.377,1.377v.037a1.377,1.377,0,0,1-.4.974,1.377,1.377,0,0,1-.974.4H5.264a2.414,2.414,0,0,0-1.706.707A2.414,2.414,0,0,0,2.85-5.519V10.349a2.413,2.413,0,0,0,2.413,2.413H27.272a2.413,2.413,0,0,0,2.413-2.413V4.626a1.377,1.377,0,0,1,1.377-1.377Z" transform="translate(0 4.162)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6101" data-name="Path 6101" d="M9.711-8.519a.555.555,0,0,1,.2.055l6.317,3.647a.533.533,0,0,1,.225.394V2.863a.532.532,0,0,1-.225.394L9.9,6.905a.535.535,0,0,1-.454,0L3.136,3.258a.535.535,0,0,1-.225-.394V-4.428A.535.535,0,0,1,3.14-4.82L9.448-8.462A.345.345,0,0,1,9.711-8.519ZM4.3,2.247l.282.165c-.01-.358-.025-.74.337-.758a.365.365,0,0,1,.37.35v.824l.787.462c0-.881-.021-1.762,0-2.643.029-.363.694-.4.7.013V3.7l.787.462c0-1.521-.046-3.043,0-4.564.03-.362.693-.4.7.014V4.581l1.2.7V-.607L4.3-3.592Zm5.77,2.92,4.6-2.772-4.6-2.656Zm.3-5.949,4.684,2.7v-5.4Zm-.9-6.056L4.707-4.052,9.475-1.3Zm.6,5.534L14.747-4,10.075-6.75Z" transform="translate(4.223 7.36)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6102" data-name="Path 6102" d="M4.269-4.37A1.377,1.377,0,0,1,2.891-5.748V-8.6A5,5,0,0,1,4.355-12.13,5,5,0,0,1,7.89-13.594h4.03l7.239,0,7.239,0h4.03a5,5,0,0,1,3.535,1.464A5,5,0,0,1,35.427-8.6V7.687a5,5,0,0,1-5,5H27.09a1.377,1.377,0,0,1-1.376-1.377V11.27a1.378,1.378,0,0,1,1.378-1.377h3.072A2.413,2.413,0,0,0,32.577,7.48V-8.388a2.413,2.413,0,0,0-.707-1.706,2.412,2.412,0,0,0-1.706-.707H8.155a2.413,2.413,0,0,0-1.706.707,2.414,2.414,0,0,0-.707,1.706v2.64a1.377,1.377,0,0,1-.4.974,1.377,1.377,0,0,1-.974.4Z" transform="translate(4.194 0)" fill="#211c54" fill-rule="evenodd"/><path id="Path_6103" data-name="Path 6103" d="M10.4-1.652a1.377,1.377,0,0,1,.019-1.928l4.272-4.272h-4.37A1.436,1.436,0,0,1,8.885-9.288h0a1.436,1.436,0,0,1,1.436-1.436h6.54a2.789,2.789,0,0,1,1.971.816,2.789,2.789,0,0,1,.816,1.971V-1.5a1.436,1.436,0,0,1-.421,1.015,1.436,1.436,0,0,1-1.015.421h0A1.436,1.436,0,0,1,16.776-1.5v-4.37L12.449-1.547a1.377,1.377,0,0,1-.988.4,1.376,1.376,0,0,1-.979-.423Z" transform="translate(12.887 4.162)" fill="#211c54" fill-rule="evenodd"/></g></g></g></svg>'
}, _defineProperty(_sample$auth_roadmap$, 'deposit_icon', '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-alt-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-arrow-alt-down fa-w-14 fa-2x"><path fill="#424b7d" d="M400 208h-73.8V80c0-26.5-21.5-48-48-48H169.8c-26.5 0-48 21.5-48 48v128H48.1c-42.6 0-64.2 51.7-33.9 81.9l175.9 176c18.7 18.7 49.1 18.7 67.9 0l176-176c30-30.1 8.7-81.9-34-81.9zM224 432L48 256h121.8V80h108.3v176H400L224 432z" class=""></path></svg>'), _defineProperty(_sample$auth_roadmap$, 'AAVE_icon', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><linearGradient id="linear-gradient" x1="0.854" y1="0.114" x2="0.067" y2="0.904" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#b54f9d"/><stop offset="1" stop-color="#30b8c6"/></linearGradient></defs><g id="Group_114" data-name="Group 114" transform="translate(7938 15258)"><circle id="Ellipse_13" data-name="Ellipse 13" cx="250" cy="250" r="250" transform="translate(-7938 -15258)" fill="url(#linear-gradient)"/><path id="Path_322" data-name="Path 322" d="M436.232-354.9,351.7-559.278C346.928-569.845,339.84-575,330.5-575h-7.474c-9.343,0-16.43,5.155-21.2,15.722l-36.791,89.046H237.2a15.249,15.249,0,0,0-15.142,15.142v.193A15.292,15.292,0,0,0,237.2-439.755h14.948L217.031-354.9A17.725,17.725,0,0,0,216-349.1a16.258,16.258,0,0,0,4.124,11.4c2.642,2.9,6.443,4.317,11.211,4.317a14.99,14.99,0,0,0,8.7-2.9,18.826,18.826,0,0,0,6.057-7.668l38.66-95.876h26.8A15.249,15.249,0,0,0,326.7-454.961v-.387a15.292,15.292,0,0,0-15.142-15.142h-14.3l29.51-73.518,80.412,200a18.826,18.826,0,0,0,6.057,7.668,15.144,15.144,0,0,0,8.7,2.9c4.768,0,8.505-1.418,11.211-4.317a15.973,15.973,0,0,0,4.124-11.4A13.516,13.516,0,0,0,436.232-354.9Z" transform="translate(-8014.825 -14553.489)" fill="#fff"/></g></svg>'), _defineProperty(_sample$auth_roadmap$, 'UNI_icon', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-uni_icon"><rect width="500" height="500"/></clipPath></defs><g id="uni_icon" clip-path="url(#clip-uni_icon)"><g id="Group_112" data-name="Group 112"><circle id="Ellipse_11" data-name="Ellipse 11" cx="250" cy="250" r="250" fill="#f1efef"/><g id="Group_109" data-name="Group 109" transform="translate(113 275.9)"><path id="Path_311" data-name="Path 311" d="M67.133-149.426c-3.406-.487-3.569-.649-1.946-.811,3.082-.487,10.219.162,15.247,1.3,11.679,2.757,22.222,9.895,33.415,22.385l2.92,3.406,4.217-.649c18-2.92,36.5-.649,51.906,6.488,4.217,1.946,10.868,5.839,11.679,6.813a15.679,15.679,0,0,1,1.135,4.542c1.135,7.624.649,13.3-1.784,17.681-1.3,2.433-1.3,3.082-.487,5.191a4.885,4.885,0,0,0,4.38,2.758c3.893,0,7.948-6.164,9.895-14.761l.811-3.406,1.46,1.622c8.273,9.246,14.761,22.06,15.734,31.144l.324,2.433-1.46-2.109a27.389,27.389,0,0,0-7.786-8.273c-5.515-3.731-11.354-4.866-26.764-5.677-13.95-.811-21.9-1.946-29.684-4.542-13.3-4.38-20.114-10.057-35.847-30.982-6.975-9.246-11.354-14.274-15.734-18.492C89.193-142.614,79.623-147.48,67.133-149.426Z" transform="translate(39.931 27.06)" fill="#ff0079"/><path id="Path_312" data-name="Path 312" d="M148.906-130.693c.324-6.164,1.135-10.219,2.92-13.95a11.181,11.181,0,0,1,1.46-2.758c.162,0-.162,1.135-.649,2.433-1.3,3.569-1.46,8.6-.649,14.274,1.135,7.3,1.622,8.273,9.408,16.221,3.569,3.731,7.786,8.435,9.408,10.381l2.758,3.569-2.758-2.6c-3.406-3.244-11.192-9.408-12.977-10.219-1.135-.649-1.3-.649-2.109.162-.649.649-.811,1.622-.811,6.326-.162,7.3-1.135,11.841-3.569,16.545-1.3,2.433-1.46,1.946-.324-.811.811-2.109.973-3.082.973-10.057,0-14.112-1.622-17.518-11.517-23.2-2.433-1.46-6.651-3.569-9.084-4.7a35.931,35.931,0,0,1-4.38-2.109c.324-.324,9.895,2.433,13.625,4.055,5.677,2.271,6.65,2.433,7.3,2.271C148.419-125.34,148.743-126.638,148.906-130.693Z" transform="translate(79.002 28.926)" fill="#ff0079"/><path id="Path_313" data-name="Path 313" d="M74.075-107.519c-6.813-9.408-11.192-24.007-10.219-34.874l.324-3.406,1.622.324a38.066,38.066,0,0,1,10.381,3.893c6.488,3.893,9.408,9.246,12.166,22.547.811,3.893,1.946,8.435,2.433,9.895a58.558,58.558,0,0,0,6.488,11.679c1.784,2.6.649,3.893-3.406,3.569C87.7-94.543,79.428-100.22,74.075-107.519Z" transform="translate(39.639 29.922)" fill="#ff0079"/><path id="Path_314" data-name="Path 314" d="M152.076-60.225C119.959-73.2,108.6-84.393,108.6-103.372c0-2.757.162-5.028.162-5.028a30.478,30.478,0,0,1,2.758,2.109c6.488,5.191,13.788,7.462,34.063,10.381,11.841,1.784,18.654,3.082,24.818,5.191,19.627,6.488,31.793,19.789,34.712,37.794a65.607,65.607,0,0,1-.973,20.276c-1.135,4.055-4.38,11.517-5.191,11.679-.162,0-.487-.811-.487-2.109-.324-6.813-3.731-13.3-9.408-18.329C182.246-47.248,173.487-51.628,152.076-60.225Z" transform="translate(67.559 53.187)" fill="#ff0079"/><path id="Path_315" data-name="Path 315" d="M147.847-71.854a38.424,38.424,0,0,0-1.622-6.813l-.811-2.433,1.46,1.784a28.558,28.558,0,0,1,5.191,9.408c1.135,3.082,1.135,4.055,1.135,9.084,0,4.866-.162,6-1.135,8.759A29.351,29.351,0,0,1,145.252-41.2c-5.839,6-13.463,9.246-24.331,10.706-1.946.162-7.462.649-12.327.973-12.166.649-20.276,1.946-27.575,4.542-.973.324-1.946.649-2.109.487-.324-.324,4.7-3.244,8.759-5.191C93.347-32.438,99.186-33.9,112-36.169c6.325-.973,12.814-2.271,14.436-2.92C142.495-44.117,150.443-56.607,147.847-71.854Z" transform="translate(49.078 70.17)" fill="#ff0079"/><path id="Path_316" data-name="Path 316" d="M132.081-48.6q-6.326-13.869-2.92-26.278c.324-.811.649-1.622.973-1.622a6.977,6.977,0,0,1,2.271,1.135c1.947,1.3,6,3.569,16.383,9.246,13.139,7.137,20.6,12.652,25.791,18.978a40.117,40.117,0,0,1,8.6,19.627c.811,4.38.324,14.923-.811,19.3-3.569,13.788-11.679,24.818-23.52,31.144a22.546,22.546,0,0,1-3.406,1.622,12.9,12.9,0,0,1,1.46-3.569,32.2,32.2,0,0,0,1.46-25.142c-1.784-5.515-5.515-12.166-12.977-23.358C136.461-40.49,134.352-43.9,132.081-48.6Z" transform="translate(79.606 73.031)" fill="#ff0079"/><path id="Path_317" data-name="Path 317" d="M57.311-21.022c12-10.057,26.764-17.194,40.39-19.465,5.839-.973,15.572-.649,20.925.811,8.6,2.271,16.382,7.137,20.437,13.139,3.893,5.839,5.677,10.868,7.462,22.06.649,4.38,1.46,8.921,1.622,9.895,1.3,5.839,3.893,10.381,7.137,12.814,5.028,3.731,13.788,3.893,22.385.649a10.9,10.9,0,0,1,2.758-.811c.324.324-4.055,3.244-6.975,4.7a22.965,22.965,0,0,1-11.679,2.758c-7.786,0-14.436-4.055-19.789-12.166A91.185,91.185,0,0,1,136.629,2.66c-5.677-13.139-8.6-17.032-15.247-21.411-5.839-3.731-13.3-4.542-18.978-1.784C94.943-16.967,93-7.4,98.187-1.557a16.585,16.585,0,0,0,9.246,4.866,9.9,9.9,0,0,0,11.192-9.895c0-3.893-1.46-6.164-5.353-7.948-5.191-2.271-10.868.324-10.706,5.353,0,2.109.973,3.406,3.082,4.38,1.3.649,1.3.649.324.487-4.7-.973-5.839-6.813-2.109-10.543,4.542-4.542,14.112-2.6,17.356,3.731,1.3,2.6,1.46,7.786.324,11.03C118.787,7.04,111,10.771,103.053,8.662,97.7,7.2,95.429,5.742,88.941-.908,77.587-12.587,73.207-14.858,56.986-17.291L53.9-17.778Z" transform="translate(33.532 95.088)" fill="#ff0079"/><path id="Path_318" data-name="Path 318" d="M5.522-186.925c37.794,45.9,96.027,117.276,98.946,121.169,2.433,3.244,1.46,6.326-2.6,8.6a24.821,24.821,0,0,1-9.246,2.6,11.7,11.7,0,0,1-7.786-3.406c-1.46-1.46-7.786-10.706-22.06-32.928C51.913-107.93,42.668-122.042,42.505-122.2c-.649-.324-.649-.324,19.14,35.037C74.136-64.945,78.191-57,78.191-56.024c0,2.109-.649,3.244-3.244,6.164-4.38,4.866-6.326,10.381-7.786,21.9-1.622,12.814-6,21.9-18.492,37.308-7.3,9.084-8.435,10.706-10.219,14.436-2.271,4.542-2.92,7.137-3.244,12.977a40.583,40.583,0,0,0,2.109,15.9c1.622,5.191,3.406,8.6,7.786,15.247,3.731,5.839,6,10.219,6,11.841,0,1.3.324,1.3,6.164,0,13.95-3.244,25.467-8.759,31.793-15.572,3.893-4.217,4.866-6.488,4.866-12.328,0-3.731-.162-4.542-1.135-6.813-1.622-3.569-4.7-6.488-11.354-11.03-8.759-6-12.49-10.868-13.463-17.356C67.161,11.13,68.134,7.4,73-2.82c5.028-10.543,6.326-14.923,7.137-25.629.487-6.813,1.3-9.57,3.244-11.679C85.49-42.4,87.275-43.21,92.3-43.859c8.273-1.135,13.625-3.244,17.843-7.3A15.245,15.245,0,0,0,115.661-63l.162-3.731L113.714-69C106.091-77.76.494-193.9.007-193.9-.155-193.9,2.44-190.818,5.522-186.925ZM55.32,43.733a6.7,6.7,0,0,0-2.109-8.921c-2.758-1.784-6.975-.973-6.975,1.46a1.655,1.655,0,0,0,1.3,1.622c1.46.811,1.622,1.622.487,3.406s-1.135,3.406.324,4.542C50.616,47.626,53.7,46.653,55.32,43.733Z" transform="translate(0 0)" fill="#ff0079" fill-rule="evenodd"/><path id="Path_319" data-name="Path 319" d="M78.09-99.848c-3.893,1.135-7.624,5.353-8.759,9.57-.649,2.6-.324,7.3.811,8.759,1.784,2.271,3.406,2.92,7.948,2.92,8.921,0,16.545-3.893,17.356-8.6.811-3.893-2.6-9.246-7.3-11.679A16.49,16.49,0,0,0,78.09-99.848Zm10.381,8.11c1.3-1.946.811-4.055-1.622-5.515-4.38-2.758-11.03-.487-11.03,3.731,0,2.109,3.406,4.38,6.65,4.38C84.579-89.142,87.5-90.44,88.472-91.738Z" transform="translate(42.923 58.26)" fill="#ff0079" fill-rule="evenodd"/></g></g></g></svg>'), _defineProperty(_sample$auth_roadmap$, 'FIL_icon', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="500" viewBox="0 0 500 500"><defs><clipPath id="clip-fil_icon"><rect width="500" height="500"/></clipPath></defs><g id="fil_icon" clip-path="url(#clip-fil_icon)"><g id="Group_110" data-name="Group 110" transform="translate(0 899.345)"><path id="Path_320" data-name="Path 320" d="M250-399.334c-137.5,0-250-112.5-250-251.25,1.25-137.5,112.5-250,251.25-248.75,137.5,1.25,248.75,112.5,248.75,252.5-1.25,136.25-112.5,247.5-250,247.5" transform="translate(0 0)" fill="#008fff" fill-rule="evenodd"/><path id="Path_321" data-name="Path 321" d="M350.9-640.325c8.564-34.555,29.514-102.44,67.224-113.908,41.667-12.672,56.05,12.147,56.05,12.147,3.4,5.156,2.671,13.338-3.012,17.016-5.156,3.4-13.788,2.555-17.869-3.7-2.484-2.257-9.392-21.379-25.055-16.981-24.026,5.909-37.848,71.6-45.943,110.266l65.552,10.1-2.991,19.965-66.85-10.3-4.342,19.153-1.161,4.962c-1.07,4.569-2.189,9.345-3.335,14.23l69.875,10.762-2.991,19.965-71.519-11.015-.908,3.852c-1.974,8.371-22.67,118.684-71.709,133.6-41.667,12.672-56.05-12.147-56.05-12.147-3.4-5.156-2.671-13.337,3.013-17.016,5.156-3.4,13.787-2.555,17.869,3.7,2.484,2.257,9.392,21.379,25.055,16.98,27.712-6.815,41.847-93.163,49.28-125.843l1.814-8-66.822-10.292,2.991-19.965,68.337,10.525c2.791-11.919,5.929-25.29,9-38.32l-71.524-11.017,2.991-19.965Z" transform="translate(-103.825 -62.833)" fill="#fff" fill-rule="evenodd"/></g></g></svg>'), _defineProperty(_sample$auth_roadmap$, 'MATIC_icon', '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n    viewBox="0 0 38.4 33.5" style="enable-background:new 0 0 38.4 33.5;" xml:space="preserve"><style type="text/css">.st0{fill:#8247E5;}</style><g><path class="st0" d="M29,10.2c-0.7-0.4-1.6-0.4-2.4,0L21,13.5l-3.8,2.1l-5.5,3.3c-0.7,0.4-1.6,0.4-2.4,0L5,16.3c-0.7-0.4-1.2-1.2-1.2-2.1v-5c0-0.8,0.4-1.6,1.2-2.1l4.3-2.5c0.7-0.4,1.6-0.4,2.4,0L16,7.2c0.7,0.4,1.2,1.2,1.2,2.1v3.3l3.8-2.2V7c0-0.8-0.4-1.6-1.2-2.1l-8-4.7c-0.7-0.4-1.6-0.4-2.4,0L1.2,5C0.4,5.4,0,6.2,0,7v9.4c0,0.8,0.4,1.6,1.2,2.1l8.1,4.7c0.7,0.4,1.6,0.4,2.4,0l5.5-3.2l3.8-2.2l5.5-3.2c0.7-0.4,1.6-0.4,2.4,0l4.3,2.5c0.7,0.4,1.2,1.2,1.2,2.1v5c0,0.8-0.4,1.6-1.2,2.1L29,28.8c-0.7,0.4-1.6,0.4-2.4,0l-4.3-2.5c-0.7-0.4-1.2-1.2-1.2-2.1V21l-3.8,2.2v3.3c0,0.8,0.4,1.6,1.2,2.1l8.1,4.7c0.7,0.4,1.6,0.4,2.4,0l8.1-4.7c0.7-0.4,1.2-1.2,1.2-2.1V17c0-0.8-0.4-1.6-1.2-2.1L29,10.2z"/></g></svg>'), _defineProperty(_sample$auth_roadmap$, 'CAKE_icon', '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n    viewBox="0 0 31.7 32" style="enable-background:new 0 0 31.7 32;" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#633001;}.st1{fill:#FEDC90;}.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#D1884F;}.st3{fill:#633001;}</style><path class="st0" d="M5.7,5C5.2,2.4,7.2,0,9.8,0c2.3,0,4.2,1.9,4.2,4.2v5.2c0.6,0,1.2-0.1,1.8-0.1c0.6,0,1.1,0,1.7,0.1V4.2c0-2.3,1.9-4.2,4.2-4.2c2.6,0,4.6,2.4,4.2,5l-1.1,6.1c3.9,1.7,6.9,4.7,6.9,8.4v2.3c0,3.1-2,5.7-4.9,7.4c-2.9,1.8-6.7,2.8-11,2.8s-8.1-1-11-2.8C2,27.5,0,24.9,0,21.8v-2.3c0-3.7,2.9-6.7,6.8-8.4L5.7,5z M23.3,11.9l1.3-7.2c0.3-1.8-1-3.5-2.9-3.5c-1.6,0-2.9,1.3-2.9,2.9v6.6c-0.4-0.1-0.9-0.1-1.3-0.1c-0.6,0-1.1-0.1-1.7-0.1c-0.6,0-1.2,0-1.8,0.1c-0.4,0-0.9,0.1-1.3,0.1V4.2c0-1.6-1.3-2.9-2.9-2.9C8,1.3,6.6,3,7,4.8L8.3,12c-4.2,1.6-7,4.4-7,7.6v2.3c0,4.9,6.5,8.9,14.5,8.9c8,0,14.5-4,14.5-8.9v-2.3C30.4,16.3,27.6,13.5,23.3,11.9z"/><path class="st1" d="M30.4,21.8c0,4.9-6.5,8.9-14.5,8.9c-8,0-14.5-4-14.5-8.9v-2.3h29.1V21.8z"/><path class="st2" d="M7,4.8C6.6,3,8,1.3,9.8,1.3c1.6,0,2.9,1.3,2.9,2.9v6.6c1-0.1,2-0.2,3.1-0.2c1,0,2,0.1,3,0.2V4.2c0-1.6,1.3-2.9,2.9-2.9c1.8,0,3.2,1.7,2.9,3.5l-1.3,7.2c4.2,1.6,7.1,4.4,7.1,7.6c0,4.9-6.5,8.9-14.5,8.9c-8,0-14.5-4-14.5-8.9c0-3.2,2.8-6,7-7.6L7,4.8z"/><path class="st3" d="M11.8,18.9c0,1.3-0.7,2.4-1.6,2.4c-0.9,0-1.6-1.1-1.6-2.4s0.7-2.4,1.6-2.4C11.1,16.5,11.8,17.6,11.8,18.9z"/><path class="st3" d="M22.9,18.9c0,1.3-0.7,2.4-1.6,2.4c-0.9,0-1.6-1.1-1.6-2.4s0.7-2.4,1.6-2.4C22.2,16.5,22.9,17.6,22.9,18.9z"/></svg>'), _defineProperty(_sample$auth_roadmap$, 'SAND_icon', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><style type="text/css">.st0{fill:url(#SVGID_1_);}.st1{fill:#FFFFFF;}</style><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="25.2144" y1="1024.8223" x2="25.8374" y2="1024.1193" gradientTransform="matrix(50 0 0 -50 -1250 51250)"><stop offset="0" style="stop-color:#00ADEF"/><stop offset="1" style="stop-color:#0084FF"/></linearGradient><circle class="st0" cx="25" cy="25" r="25"/><path class="st1" d="M16.6,11.8l-2.7,2.7v10.7l2.7,2.7h10.7v5.4H22v-2.7h-8.1v5.4l2.7,2.7h16.1l2.7-2.7V25.2l-2.7-2.7H22v-5.4h5.4  v2.7h8.1v-5.4l-2.7-2.7H16.6z"/></svg>'), _defineProperty(_sample$auth_roadmap$, 'AXS_icon', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1000.2 1000.1" style="enable-background:new 0 0 1000.2 1000.1;" xml:space="preserve"><g><g><defs><path id="SVGID_1_" d="M500,0c276.1,0,500,223.9,500,500s-223.9,500-500,500S0,776.1,0,500S223.9,0,500,0L500,0z"/></defs><use xlink:href="#SVGID_1_" style="overflow:visible;fill-rule:evenodd;clip-rule:evenodd;fill:#0055D5;"/><clipPath id="SVGID_2_"><use xlink:href="#SVGID_1_" style="overflow:visible;"/></clipPath></g><g><defs><path id="SVGID_3_" d="M272,330.8c0,0-53.8-43-57.5,63.2c-3.7,82.3-3.6,242.1,34.5,317.6c16.1,28.4,37.6,19.7,77.6-8.6c34.8-25.7,160.7-141.7,214-192.6c53.3-50.9,161.4-196.9,183.9-97.7c8.9,41.7,19.9,77.1,11.5,169.6c-2.6,28.5-14.8,50.1-70.4,11.5c-42-27-81.9-56-81.9-56c0,0-7.7-13.8-25.9,8.6c-14.3,17.9-21.5,22.3,1.4,35.9c23,13.6,139.3,93.8,183.9,106.3c36.8,10.7,57.8,10.5,58.9-61.8c-0.2-57.4-3.5-221.7-24.4-291.7c-15.8-43.6-39-63.4-89.1-14.4c-50.1,49-208.1,202.2-294.5,271.6c-57.3,43-81.8,81.8-103.4,10.1c-15.2-54.3-34.9-223.3,27.3-191.1c38.9,18.6,58.3,18.5,43.1,30.2c-15.2,11.6-58.9,51.7-58.9,51.7c0,0-13.5,10.9-7.2,34.5c6.3,16.5,6.3,24.7,40.2-7.2c33.9-31.9,58.9-56,58.9-56s5.4-8.5,21.5,7.2c16.1,15.7,18.7,20.1,18.7,20.1c0,0,4.3,11.7,21.5-8.6c17.3-20.3,28.4-32.7-4.3-51.7C418.8,412.3,272,330.8,272,330.8L272,330.8z"/></defs><use xlink:href="#SVGID_3_" style="overflow:visible;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;"/><clipPath id="SVGID_4_"><use xlink:href="#SVGID_3_" style="overflow:visible;"/></clipPath></g></g></svg>'), _defineProperty(_sample$auth_roadmap$, 'otc_user_icon', '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-tie" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-user-tie fa-w-14 fa-2x"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z" class=""></path></svg>'), _defineProperty(_sample$auth_roadmap$, 'search_plus', '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-search-plus fa-w-16 fa-2x"><path fill="currentColor" d="M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z" class=""></path></svg>'), _defineProperty(_sample$auth_roadmap$, 'search_minus', '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search-minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-search-minus fa-w-16 fa-2x"><path fill="currentColor" d="M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z" class=""></path></svg>'), _defineProperty(_sample$auth_roadmap$, 'search_default', '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-search fa-w-16 fa-2x"><path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" class=""></path></svg>'), _sample$auth_roadmap$);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//cd003 plugins/icons step1

//icon_s2_2 = icon sample 2


/* harmony default export */ __webpack_exports__["a"] = ({

    icon_s2_2: "<svg aria-hidden=\"true\" data-prefix=\"far\" data-icon=\"chart-line\" role=\"img\" viewBox=\"0 0 512 512\" class=\"svg-inline--fa fa-chart-line fa-w-16 fa-3x\"><path fill=\"currentColor\" d=\"M500 400c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v324h452zM468 96H332c-10.7 0-16 12.9-8.5 20.5l52 52L288 256l-64-64L79 334.1l34 33.9 111-110.1 64 62.1 120.8-118.2 50.7 50.7c7.6 7.6 20.5 2.2 20.5-8.5V108c0-6.6-5.4-12-12-12z\" class=\"\"></path></svg>",
    about_2_spy: "<svg version=\"1.1\" x=\"0px\" y=\"0px\" width=\"350px\" height=\"350px\" viewBox=\"0 0 350 350\" enable-background=\"new 0 0 350 350\" xml:space=\"preserve\" class=\"spy\">\n    <g id=\"Layer_7\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M295.793,115.216c-15.946-8.708-31.444-17.188-47.004-25.505   c-3.438-1.838-4.989-4.039-5.794-7.947c-3.953-19.236-8.281-38.396-12.699-57.533c-0.767-3.326-2.596-6.41-4.034-9.838   c-14.806,7.236-28.951,14.088-43.02,21.089c-2.073,1.032-3.667,1.017-5.617-0.129c-5.573-3.28-11.238-6.408-16.867-9.596   c-6.597-3.735-13.196-7.469-19.844-11.231c-0.672,0.767-1.188,1.176-1.469,1.708c-1.184,2.24-2.591,4.419-3.391,6.798   c-6.741,20.058-13.422,40.136-19.956,60.262c-0.842,2.592-1.91,4.504-4.431,5.696c-15.005,7.09-29.94,14.328-44.971,21.363   c-3.091,1.446-6.207,2.836-9.33,4.212c3.625,1.778,7.131,3.805,10.492,6.007c0.409,0.27,0.782,0.555,1.133,0.852h224.366   C293.522,119.151,294.333,116.935,295.793,115.216z\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M241.887,130.983c-9.383-0.033-18.772-0.009-28.16-0.009   c-7.357,0-14.714,0-22.071,0c-11.151,0-12.995,0.374-12.793,8.965h-8.813c-0.025-1.126-0.058-2.252-0.09-3.369   c-0.128-4.33-1.592-5.572-5.898-5.588c-9.388-0.032-18.778-0.011-28.165-0.011c-9.643-0.001-19.284-0.035-28.925,0.015   c-4.26,0.023-5.778,1.635-5.447,5.854c1.495,19.063,18.264,39.355,42.341,35.12c13.883-2.442,23.407-10.286,25.678-22.888   c0.092-0.514,0.132-1.04,0.198-1.558h9.627c1.203,8.966,5.487,16.192,14.089,20.423c29.7,14.606,52.103-7.871,54.193-31.055   C248.047,132.504,246.502,130.999,241.887,130.983z\"/>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M290.509,281.215c0.069-17.443-5.675-32.813-16.398-46.434   c-7.603-9.656-16.556-17.912-26.783-24.633c-3.77-2.477-4.575-5.232-2.897-8.813c1.403-2.99,2.906-5.936,4.462-8.857l-2.106-15.736   c-9.266,0.561-17.817,3.518-25.74,8.49c-4.576,2.871-8.346,6.141-9.175,11.863c-0.158,1.088-0.821,2.119-1.329,3.137   c-8.18,16.402-21.896,27.65-36.318,39.316c-7.344-6.773-14.571-12.977-21.255-19.717c-7.738-7.803-14.2-16.563-17.27-27.404   c-0.32-1.135-1.181-2.287-2.102-3.059c-9.683-8.129-20.851-12.471-33.482-12.838l-1.649,12.334   c2.26,4.365,4.559,8.713,6.535,13.203c1.3,2.949,0.683,5.338-2.518,7.625c-6.478,4.625-12.741,9.689-18.452,15.236   c-16.674,16.193-26.068,35.643-25.43,59.375c0.231,8.627,0.197,17.266-0.007,25.891c-0.093,3.896,1.439,5.896,4.989,7.422   c27.496,11.828,56.583,15.578,86.089,17.27c25.142,1.445,50.23,0.732,75.236-2.277c20.848-2.512,41.305-6.641,60.739-14.982   c3.563-1.533,5.018-3.605,4.935-7.477C290.38,300.51,290.467,290.861,290.509,281.215z\"/>\n    </g></svg>",
    about_2_globe: "<svg version=\"1.1\" x=\"0px\" y=\"0px\" width=\"350px\" height=\"350px\" viewBox=\"0 0 350 350\" enable-background=\"new 0 0 350 350\" xml:space=\"preserve\" class=\"globe\">\n    <g id=\"Layer_6\">\n        <g>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M227.754,85.208c-7.728-5-15.028-9.07-24.465-3.744    c-4.944,2.788-10.963,3.782-16.598,5.154c-1.852,0.452-4.032-0.456-6.067-0.743c-0.262-0.891-0.524-1.78-0.784-2.669    c5.293-2.664,10.596-5.33,17.309-8.704c-5.94-3.859-11.383-7.397-17.859-11.602c-0.061-0.594-0.298-2.984-0.561-5.636    c-7.04,0.379-13.728,0.744-22.39,1.215c4.133-6.904,6.707-11.814,9.979-16.206c0.751-1.007,3.928-0.467,5.938-0.224    c4.844,0.581,9.664,1.408,14.49,2.137c0.44-0.923,0.881-1.849,1.321-2.773c-2.299-1.224-4.597-2.447-6.893-3.672    c0.482-0.88,0.967-1.76,1.45-2.64c17.482-0.687,34.136,3.833,50.067,10.796c34.832,15.22,59.243,40.762,73.006,76.497    c-3.491-3.583-6.983-7.171-11.303-11.605c0.541,8.67,1.492,15.313,1.061,21.868c-0.144,2.21-3.513,5.345-5.927,5.942    c-2.252,0.557-5.896-1.021-7.686-2.864c-3.368-3.463-5.635-7.964-8.756-11.703c-2.076-2.479-4.835-4.381-8.202-5.693    c1.573,9.264,5.868,16.59,12.579,22.528c0.653,0.578,1.671,1.461,1.575,2.052c-1.066,6.672,3.707,5.084,7.01,4.761    c7.46-0.723,9.873,1.596,7.376,8.229c-3.948,10.486-8.399,20.784-12.388,31.26c-0.827,2.168-0.433,4.773-0.814,7.143    c-0.699,4.379-1.704,8.713-2.281,13.102c-0.259,1.965,0.213,4.023,0.257,4.613c-4.676,6.742-9.003,12.764-13.1,18.936    c-7.447,11.217-16.849,19.781-31.544,23.693c-1.621-5.691-3.127-11.195-4.771-16.656c-0.903-3.006-1.684-6.139-3.175-8.854    c-1.655-3.006-7.311-4.084-3.854-9.395c2.028-3.109,2.88-7.166,5.352-9.756c3.84-4.025,1.881-7.811-0.253-10.605    c-6.514-8.545-10.801-17.277-8.181-28.494c0.282-1.208-3.782-3.798-6.176-5.122c-1.192-0.664-4.281,0.702-4.619,0.098    c-4.416-7.949-10.031-2.465-15.306-1.745c-6.025,0.825-12.14,1.805-18.176,1.593c-7.356-0.262-10.006-7.3-14.071-11.951    c-2.568-2.939-4.003-6.869-6.568-11.469c2.015-4.356,7.371-9.955,1.625-16.814c-0.561-0.671-0.411-2.707,0.203-3.479    c5.973-7.496,9.049-17.683,20.298-20.303c3.465-0.811,5.969-5.655,9.45-6.542c7.894-2.018,16.127-2.723,24.104-3.942    c0.688,14.494,14.467,7.885,19.296,15.996c2.33-7.827,6.899-6.593,12.033-6.171c5.888,0.485,11.917-0.752,17.884-1.239    c0.102-1.073,0.209-2.143,0.313-3.215c-7.436-2.937-14.868-5.87-22.469-8.869c2.599-2.126,2.528-9.884,10.014-4.677    c0.829,0.576,3.798-1.928,5.848-3.042c-6.058-8.225-7.771-8.344-14.849-3.153c-1.764,1.293-4.63,1.077-7.887,1.735    c-0.123,0.353-0.65,1.659-1.045,3.001C228.234,82.749,228.032,83.952,227.754,85.208z\"/>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"  d=\"M92.509,266.17c4.456,6.76,8.723,13.238,12.989,19.713    c-6.686-5.107-15.895-6.438-19.378-16.365c-2.587-7.379-8.875-13.371-12.595-20.465c-2.864-5.465-4.337-11.666-6.338-17.57    c-0.68-2.01-0.57-4.467-1.703-6.111c-4.116-5.975-9.035-11.426-12.797-17.598c-2.192-3.6-3.064-8.125-3.992-12.348    c-1.332-6.061-3.845-12.525-2.828-18.281c1.559-8.827-3.782-15.422-4.595-22.883c-0.863-7.894,3.05-16.305,4.875-24.491    c0.853,0.108,1.708,0.217,2.56,0.326c0,7.531,0,15.061,0,23.476c9.487-7.324,15.97-5.769,21.291,3.94    c0.231,0.421,0.196,1.292,0.438,1.353c12.931,3.286,12.635,19.666,24.295,24.398c5.554,2.252,10.531,5.891,15.967,8.488    c4.584,2.191,5.104,5.174,2.158,8.693c-4.395,5.248-5.544,10.117-3.613,17.34c1.441,5.387,0.594,13.057-6.918,16.602    c-1.777,0.838-3.721,3.572-3.746,5.457c-0.086,6.865-6.82,12.859-2.501,20.396C96.582,261.127,94.007,263.777,92.509,266.17z\"/>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"  d=\"M130.163,296.865c9.301-2.084,18.694-4.188,28.776-6.445    c7.446,5.611,16.613-0.498,27.213-0.133c-4.634,3.602-7.92,6.158-11.909,9.258c4.589,1.672,8.313,3.795,12.188,4.109    c1.854,0.15,4.406-2.834,5.9-4.928c2.449-3.426,3.748-6.57,6.929-0.209c0.744,1.488,7.018,1.477,10.03,0.309    c7.193-2.785,13.712-3.023,22.385,2.777c-12.02,3.129-22.127,6.412-32.488,8.316c-21.407,3.93-42.496,1.496-63.167-4.984    C130.514,303.207,130.541,303.127,130.163,296.865z\"/>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"  d=\"M118.578,53.055c-2.083,6.757-3.573,12.524-5.722,18.034    c-0.701,1.804-3.112,2.942-5.552,5.101c-0.332-3.93-0.488-5.775-0.643-7.618c-1.757,0.603-4.258,0.691-5.102,1.921    c-1.435,2.084-1.822,4.887-1.305,7.909c-0.296,0.387-0.695,1.154-0.873,1.106c-11.922-3.23-16.521,7.201-23.608,12.782    c-6.162,4.849-10.807,10.662-12.923,18.765c-0.833,3.181-5.78,5.287-9.343,8.296c4.226,4.702,8.184,9.108,12.09,13.456    c-12.971-2.9-16.9-11.479-10.756-23.123c10.967-20.783,25.919-38.025,45.495-51.07C105.684,55.049,111.314,51.428,118.578,53.055z    \"/>\n        </g>\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"  d=\"M176.002,19.574c-85.841,0-155.428,69.587-155.428,155.427   c0,85.839,69.587,155.425,155.428,155.425c85.837,0,155.424-69.586,155.424-155.425C331.426,89.162,261.839,19.574,176.002,19.574z    M176.002,322.945c-81.708,0-147.945-66.238-147.945-147.944c0-81.708,66.237-147.944,147.945-147.944   c81.704,0,147.942,66.236,147.942,147.944C323.944,256.707,257.706,322.945,176.002,322.945z\"/>\n    </g>\n\n    </svg>",
    about_2_graph: "<svg version=\"1.1\"  x=\"0px\" y=\"0px\" width=\"350px\" height=\"350px\" viewBox=\"0 0 350 350\" enable-background=\"new 0 0 350 350\" xml:space=\"preserve\">\n    <g id=\"Layer_4\">\n        <path fill=\"#8CC440\" d=\"M179.873,37.871c-84.209,0-152.475,68.265-152.475,152.475h152.475V37.871z\"/>\n        <path fill=\"#F05B2A\" d=\"M36.264,189.679c0.096,36.626,14.114,73.362,42.059,101.308l101.55-101.551L36.264,189.679z\"/>\n        <path fill=\"#F59221\" d=\"M181.206,187.386l-92.291,92.358c11.545,11.51,26.296,21.749,42.242,28.48L181.206,187.386z\"/>\n        <path fill=\"#F8AE41\" d=\"M179.873,189.706l-45.18,108.83c13.612,5.532,29.42,8.794,45.019,8.813L179.873,189.706z\"/>\n        <path fill=\"#02A69C\" d=\"M178.964,320.735V28.74c80.633,0,145.997,65.366,145.997,145.998   C324.961,255.371,259.597,320.735,178.964,320.735\"/>\n    </g>\n    </svg>",
    about_2_bull: "<svg version=\"1.1\"  x=\"0px\" y=\"0px\" width=\"350px\" height=\"350px\" viewBox=\"0 0 350 350\" enable-background=\"new 0 0 350 350\" xml:space=\"preserve\" class=\"bull\">\n    <g id=\"Layer_5\">\n        <g>\n            <g id=\"layer1\">\n                <g>\n                    <path  d=\"M327.615,147.272l-0.053,0.016L327.615,147.272L327.615,147.272z M46.027,283.489      c-0.024,0.002-0.048,0.002-0.071,0.003h-0.001C45.979,283.491,46.002,283.491,46.027,283.489L46.027,283.489z M47.738,89.849      c-0.888,0-2.17,0.632-3.848,1.895l-3.221,2.588c-7.438,6.516-11.631,10.1-12.579,10.757c-2.725,2.13-4.664,3.332-5.815,3.605      c-0.292,0.11-0.562,0.166-0.811,0.166c-0.706,0-1.239-0.445-1.601-1.338c-0.375-0.835-0.649-2.189-0.819-4.064l-0.261-4.093      c-0.006-0.314,0.076-0.609,0.25-0.882c-0.23-0.143-0.481-0.214-0.75-0.214c-0.167,0-0.343,0.027-0.526,0.082      c0.253,0.376,0.372,0.653,0.361,0.83c-0.565,2.927-0.802,5.277-0.71,7.048c0.043,1.381,0.357,2.56,0.941,3.535      c0.857,1.264,2.066,1.897,3.624,1.897c1.063,0,2.289-0.294,3.678-0.881c2.528-0.905,8.342-4.668,17.442-11.293h0.001      c-6.017,12.418-5.799,22.614,0.655,30.589c0.232,0.27,0.474,0.538,0.722,0.803h0c2.479,3.71,5.316,6.959,8.511,9.751h-0.001      c2.271,2.525,5.032,5.474,8.288,8.845c0.15,0.151,0.299,0.299,0.447,0.448h-0.001c-2.927,4.383-5.467,9.565-7.615,15.55      c-1.044,3.876-1.374,8.267-0.994,13.172c0.082,3.919,1.365,10.214,3.851,18.879c0.302,1.959,0.279,4.163-0.069,6.614      c-0.641,4.058-1.773,7.35-3.396,9.877c-1.081,2.021-4.061,4.952-8.941,8.796c-0.658,0.717-1.151,1.718-1.477,2.996      c-0.511,0.781-0.415,5.514,0.289,14.197l-0.835,6.179c-2.559,11.405-5.552,19.743-8.979,25.013      c-0.068,0.42,0.793,0.722,2.586,0.907c0.076,4.169-0.239,6.929-0.944,8.28l2.153,2.595c0.719,0.855,3.01,1.378,6.874,1.572      l6.263,0.134c1.774-0.468,2.665-0.869,2.671-1.207c0.892-0.112-0.438-2.265-3.988-6.456c-0.432-0.916-0.624-1.837-0.576-2.761      c0.892-10.589,2.828-19.77,5.805-27.537c3.854-6.685,6.603-10.706,8.247-12.063h-0.001c-0.003,0.001-0.006,0.001-0.01,0.001      c-0.476,0,4.821-4.345,15.891-13.031h0c-1.866,3.083-2.694,5.798-2.483,8.14c3.24,7.46,5.293,21.484,6.163,42.07      c0.103,0.256,0.354,0.414,0.754,0.474c0.632-0.227,1.145-0.339,1.537-0.339c0.44,0,0.728,0.143,0.863,0.43      c2.363,2.924,3.151,4.804,2.368,5.635c0,0.179,0.341,0.269,1.025,0.269c0.154,0,0.326-0.004,0.516-0.012h0.001      c-0.313,0.77,0.099,1.363,1.235,1.777c2.042,0.514,4.023,0.772,5.943,0.772c2.893,0,5.647-0.586,8.262-1.754      c-5.854-3.831-9.512-8.183-10.973-13.057c-0.777-1.324-1.036-5.492-0.78-12.504l-1.453-4.248      c-0.102-0.923,0.382-2.898,1.451-5.934c1.952-5.646,4.145-9.441,6.579-11.386c4.986-3.751,9.628-7.869,13.929-12.356      c2.799-2.196,6.959-3.787,12.479-4.771c1.001-0.462,2.04-1.898,3.111-4.306c13.321,0.368,23.843,1.155,31.567,2.366      c2.067,0.342,3.654,0.722,4.761,1.144c1.259,0.363,2.41,1.119,3.455,2.267c2.334,0.304,3.616,0.736,3.845,1.293      c0.814,0.714,1.635,2.107,2.466,4.182c3.103,10.109,6.615,19.608,10.542,28.497c0.896,2.624,1.621,9.194,2.17,19.712      c0.141-0.057,0.285-0.086,0.432-0.086c1.557,0,3.27,3.267,5.139,9.806c4.975,1.502,8.342,2.41,10.098,2.723      c0.514,0.129,1.008,0.192,1.48,0.192c0.617,0,1.199-0.11,1.748-0.331c2.713-1.265,3.791-2.272,3.236-3.017l-7.953-7.232      c-3.826-8.822-5.889-14.359-6.186-16.613c-0.785-2.887-0.49-7.026,0.887-12.419c-1.207-1.092-1.818-7.654-1.832-19.688      c2.041-0.348,3.131-0.863,3.268-1.543c12.154,11.13,17.654,16.952,16.5,17.463c0.691,0.858,0.041,4.998-1.945,12.419      c-1.707,2.411-2.336,3.833-1.879,4.267c-0.043-0.01-0.088-0.016-0.135-0.016c-0.898,0-2.535,1.777-4.904,5.333l1.094,9.686      c0,0.311,0.186,0.492,0.559,0.547c-0.17-0.515,4.338-4.821,13.518-12.921c1.693-1.751,2.652-3.375,2.871-4.873      c-1.504-7.093-1.012-14.316,1.479-21.673c-0.182-1.15-0.518-2.305-1.01-3.469c-3.189-5.434-5.262-10.117-6.217-14.045h0.002      c2.215,0.29,4.207,0.436,5.977,0.436c2.305,0,4.232-0.248,5.779-0.742c3.242-0.809,7.518-3.894,12.826-9.256l3.729,0.483      l1.635-0.203l0.869,1.601c-0.426,3.325-0.334,5.534,0.277,6.627c2.053,4.097,3.645,6.157,4.771,6.178      c0.436,2.933,1.123,4.604,2.053,5.018c0.926,0.586,1.713,0.88,2.369,0.88c0.031,0,0.061-0.002,0.09-0.003      c0.043,0.001,0.088,0.003,0.131,0.003c1.035,0,2.068-0.433,3.1-1.296c3.273,0.775,5.922,1.163,7.943,1.163      c1.605,0,2.816-0.245,3.631-0.736c0.668-0.303,1.383-1.088,2.146-2.356c2.754-6.462,5.117-11.273,7.09-14.431      c1.139-1.939,3.373-4.983,6.695-9.127c3.328-4.153,5.631-6.718,6.904-7.688c0.871-1.027,2.611-1.617,5.215-1.769      c0.543-0.209,1.023-0.702,1.441-1.48c0.877-5.777-0.406-10.631-3.846-14.559c0.352-0.339,7.533-1.869,21.549-4.586      c2.092-0.548,4.061-2.061,5.906-4.543c0.008-0.531-0.127-0.797-0.416-0.797c-0.076,0-0.164,0.021-0.264,0.06      c-2.922,1.008-5.799,1.512-8.627,1.512c-0.621,0-1.24-0.024-1.857-0.073c-4.631-0.29-9.211-0.996-13.746-2.115      c2.398-1.819,4.51-3.168,6.338-4.046c8.105-2.574,13.24-4.623,15.4-6.147c3.254-1.833,5.273-3.992,6.059-6.477l-0.244-0.192      l-7.365,1.903c-14.826,2.304-23.107,3.862-24.844,4.674c-3.834,1.054-7.395,3.261-10.682,6.62      c-15.51-19.178-26.568-30.234-33.18-33.168l-11.539-6.266l-20.313-7.972c-7.434-2.579-13.916-3.94-19.453-4.083      c-0.699-0.019-1.393-0.029-2.08-0.029c-6.07,0-11.568,0.76-16.496,2.279l-14.627,6.167l-17.314,5.53l-10.627,5.24      c-2.289,0.856-4.713,1.566-7.274,2.132c-18.319,3.515-34.062,5.271-47.226,5.271c-1.104,0-2.191-0.011-3.26-0.037      c-1.74,0.174-3.616,0.748-5.629,1.719c-2.524,1.258-4.897,2.824-7.123,4.698l0,0c-4.987-2.271-8.833-4.314-11.535-6.127      c-4.791-3.075-8.145-6.144-10.065-9.208c-1.731-2.584-2.359-5.876-1.884-9.875c0.58-3.853,1.083-6.483,1.508-7.892      c0.339-1.505,1.541-5.172,3.606-11c0.381-1.33,0.539-2.076,0.473-2.239c-0.595-2.576-2-4.016-4.214-4.324l-0.098-0.001      C47.766,89.849,47.751,89.849,47.738,89.849z\"/>\n                </g>\n            </g>\n        </g>\n    </g>\n    </svg>",
    about_2_relax: "<svg version=\"1.1\"  x=\"0px\" y=\"0px\" width=\"350px\" height=\"350px\" viewBox=\"0 0 350 350\" enable-background=\"new 0 0 350 350\" xml:space=\"preserve\" class=\"relax\">\n    <g id=\"Layer_3\">\n        <g>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M338.095,211.389c-0.512,1.293-0.988,2.6-1.542,3.873    c-3.075,7.057-8.948,9.596-16.141,9.699c-11.793,0.176-23.59,0.135-35.382,0.348c-1.504,0.029-3.269,0.693-4.443,1.643    c-13.344,10.775-26.609,21.648-39.872,32.525c-12.104,9.928-24.233,19.824-36.24,29.865c-7.041,5.887-14.946,8.967-24.174,8.955    c-50.662-0.051-101.322-0.039-151.981-0.006c-7.194,0.002-13.491-1.941-17.584-8.213c-1.644-2.516-2.493-5.553-3.705-8.352    c0-2.467,0-4.936,0-7.404c1.558-3.313,2.662-6.951,4.769-9.869c3.942-5.457,9.95-6.855,16.384-6.826    c4.759,0.025,9.518-0.025,14.275,0.031c1.441,0.018,2.395-0.266,3.1-1.756c2.569-5.426,7.733-8.293,12.178-11.822    c13.221-10.494,26.497-20.92,39.805-31.305c6.934-5.408,13.744-11.025,21.038-15.91c7.76-5.196,15.837-5.168,23.512,0.773    c11.397,8.82,22.875,17.541,34.218,26.432c2.896,2.27,5.419,5.018,8.35,7.77c10.265-8.184,20.481-16.332,30.75-24.521    c-1.954-4.324-3.916-8.525-5.761-12.779c-6.949-16.033-10.611-32.762-10.46-50.274c0.053-6.07,2.333-11.093,7.132-14.921    c2.781-2.219,6.045-2.933,9.431-2.698c12.56,0.87,25.108,1.893,37.663,2.871c0.418,0.033,0.826,0.199,1.602,0.392    c-5.372,10.341-5.952,20.886-1.756,31.998c-6.662-0.615-13.069-1.206-19.446-1.794c-0.872,3.649,4.104,19.968,7.638,25.313    c2.208-1.167,4.355-2.512,6.658-3.483c10.818-4.562,20.64-2.106,29.785,4.502c1.203,0.87,2.503,1.802,3.295,3.009    c2.1,3.188,4.953,3.992,8.577,3.74c3.732-0.258,7.496-0.057,11.774-0.057c-1.514-3.944-2.847-7.424-4.265-11.119    c11.72-4.2,19.544-12.197,24.286-24.108c2.683,5.79,5.838,11.413,7.933,17.407c2.944,8.437,5.098,17.15,7.603,25.742    c0.289,0.988,0.663,1.953,0.998,2.926C338.095,206.453,338.095,208.922,338.095,211.389z M106.923,256.836    c0.081,0.201,0.161,0.4,0.241,0.6c15.05,0,30.1,0,45.15,0c0.288-0.352,0.576-0.705,0.864-1.061    c-0.789-0.373-1.684-0.609-2.349-1.137c-6.535-5.188-13.011-10.449-19.581-15.592c-0.501-0.393-1.838-0.342-2.386,0.053    c-3.484,2.527-6.875,5.186-10.26,7.844C114.69,250.617,110.814,253.736,106.923,256.836z\"/>\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"  d=\"M287.307,177.185c-17.296,0.069-31.672-14.249-31.67-31.541    c0.004-17.307,14.284-31.65,31.547-31.686c17.275-0.035,31.638,14.21,31.67,31.573C318.887,162.819,304.8,177.166,287.307,177.185    z\"/>\n        </g>\n    </g>\n    </svg>",
    about_2_shield: "<svg version=\"1.1\"  x=\"0px\" y=\"0px\" width=\"350px\" height=\"350px\" viewBox=\"0 0 350 350\" enable-background=\"new 0 0 350 350\" xml:space=\"preserve\" class=\"shield\">\n    <g id=\"Layer_2\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\"  d=\"M290.726,65.886c0-2.655,0-5.309,0-7.851   c-42.472-4.282-81.917-15.221-114.919-46.862c-48.31,37.657-59.883,42.986-114.518,52.487c0,3.08,0,5.803,0,8.527   c-0.001,37.898,0.513,75.811-0.176,113.693c-0.484,26.636,6.871,49.562,21.004,69.982c24.529,35.441,56.7,59.458,91.181,79.851   c1.692,1.001,4.759,0.5,6.573-0.617c9.658-5.958,19.333-11.946,28.612-18.641c23.274-16.791,44.84-35.983,61.85-61.198   c13.641-20.221,20.976-42.655,20.562-68.788C290.253,146.288,290.726,106.081,290.726,65.886z M153.824,214.13   c-8.657-8.662-18.066-18.074-27.366-27.378c3.057-3.08,6.587-6.639,11.426-11.513c3.56,4.071,7.199,8.528,11.156,12.682   c4.471,4.694,5.483,4.606,10.114-0.018c20.008-19.981,39.994-39.986,59.992-59.972c1.385-1.385,2.83-2.705,4.479-4.27   c3.987,3.924,7.463,7.341,10.394,10.223C207.085,160.838,180.257,187.681,153.824,214.13z\"/>\n    </g>\n    </svg>"

});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__(712);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.mixin({
            data: function data() {
                return {
                    sharedActions: _extends({}, __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */])
                };
            }
        });
    }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_spacetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_spacetime__);
var _testeFunc$isNumberCh;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = (_testeFunc$isNumberCh = {
  //example: this.sharedActions.testeFunc();
  testeFunc: function testeFunc() {
    console.log("testeeee worksssss");
  },


  // this.bluAmount = this.sharedActions.isNumberCheck(amount);
  isNumberCheck: function isNumberCheck(amount) {
    var result = void 0;
    var amountFiltered = void 0;
    var amountFilteredArray = [];
    var firstDot = amount.indexOf(".");
    for (var i in amount) {
      if (["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."].includes(amount[i])) {
        if (amount[i] != ".") {
          amountFilteredArray.push(amount[i]);
        } else if (firstDot && i == firstDot && firstDot) {
          amountFilteredArray.push(amount[i]);
        }
      }
    }
    amountFiltered = amountFilteredArray.join("");
    result = amountFiltered;

    if (result == "." || !result) {
      result = "0";
    }

    return result;
  },
  formatSuffix: function formatSuffix(coinSymbol) {
    return " " + coinSymbol.toUpperCase();
  },
  currencyFormat: function currencyFormat(num) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  },
  validateAmount: function validateAmount() {
    this.bluAmountValid = false;
    var indices = [];
    var amount = String(this.bluAmount);

    var idx = amount.indexOf(".");
    while (idx != -1) {
      indices.push(idx);
      idx = amount.indexOf(".", idx + 1);
    }
    if (indices.length > 1) {
      var n = amount.lastIndexOf(".");
      amount = amount.slice(0, n);
      this.bluAmountValid = false;
    } else {
      this.bluAmountValid = true;
    }

    this.bluAmount = amount;
    this.isNumberCheck();
  }
}, _defineProperty(_testeFunc$isNumberCh, "currencyFormat", function currencyFormat(num, fix) {
  if (num) {
    var fixed = num.toFixed(fix).replace(/[,.]/g, function (n) {
      return n === "," ? "." : ",";
    });
    return fixed.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  } else {
    return 0;
  }
}), _defineProperty(_testeFunc$isNumberCh, "roundUp", function roundUp(num, precision) {

  precision = Math.pow(10, precision);
  return Math.ceil(num * precision) / precision;
}), _defineProperty(_testeFunc$isNumberCh, "isNumber", function isNumber(evt) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    evt.preventDefault();
  } else {
    this.callPurchasePreview();
    return true;
  }
}), _defineProperty(_testeFunc$isNumberCh, "formatDateTime", function formatDateTime(value) {
  return __WEBPACK_IMPORTED_MODULE_0_spacetime___default()(value).format('dd/MM/yyyy hh:mm:SS');
}), _defineProperty(_testeFunc$isNumberCh, "formatDateTimeHistory", function formatDateTimeHistory(value) {
  return __WEBPACK_IMPORTED_MODULE_0_spacetime___default()(value).format('yyyy-MM-ddTHH:mm:SS');
}), _testeFunc$isNumberCh);

/***/ }),
/* 713 */,
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue, options) {
        Vue.mixin({
            data: function data() {
                return {
                    asErrors: false,
                    hasError: {},
                    errorMsg: {},
                    errorInputStyle: {},
                    hasSuccess: false,
                    successMsg: ""
                };
            },
            methods: {
                checkIfHasAnyError: function checkIfHasAnyError() {
                    this.hasErrors = Object.values(this.hasError).some(function (item) {
                        return item === true;
                    });
                    return this.hasErrors;
                },
                setValidationFields: function setValidationFields(FieldsConstructor) {
                    this.hasError = new FieldsConstructor();
                    this.errorMsg = new FieldsConstructor();
                    this.errorInputStyle = new FieldsConstructor();
                    this.hasSuccess = new FieldsConstructor();
                    this.successMsg = new FieldsConstructor();
                },
                validateEmail: function validateEmail(email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                },
                validatePassword: function validatePassword(password) {
                    var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[,.;\-~:<>'`^|=_+!@#\\$%\\^&\\*])(?=.{8,})/;
                    return re.test(String(password));
                },
                validateUsername: function validateUsername(username) {
                    return username && username.length >= 8;
                },
                validateUserId: function validateUserId(userId) {
                    var re = /\D+/;
                    return userId.length >= 5 && !re.test(userId);
                },
                validateCpfOrCnpj: function validateCpfOrCnpj(value) {
                    return value && (value.length === 11 || value.length === 14);
                },
                showError: function showError(input, message) {
                    this.hasError[input] = true;
                    this.errorMsg[input] = message;
                    // this.msgClass[input] = "is-danger"
                    this.errorInputStyle[input] = {
                        borderColor: "red",
                        color: "red"
                    };
                },
                showSuccess: function showSuccess(input, message) {
                    this.hasSuccess[input] = true;
                    this.successMsg[input] = message;
                    // this.msgClass[input] = "is-success"
                },
                hideSuccess: function hideSuccess(input) {
                    this.hasSuccess[input] = false;
                    this.successMsg[input] = "";
                },
                showOrHideError: function showOrHideError(input, isValid, message) {
                    var errorKey = convertToSnakeCase(input);
                    message = message || "invalid_" + errorKey;
                    this.hasError[input] = isValid ? false : true;
                    this.errorMsg[input] = isValid ? "" : message;
                    this.errorInputStyle[input] = isValid ? { borderColor: "#dad5d5", color: "#888484" } : { borderColor: "red", color: "red" };
                },
                hideError: function hideError(input) {
                    this.hasError[input] = false;
                    this.errorMsg[input] = "";
                    this.errorInputStyle[input] = {
                        borderColor: "grey",
                        color: "black"
                    };
                },
                isNumberValid: function isNumberValid(value) {
                    return value && !isNaN(value);
                },
                removeAllCharsNotNumber: function removeAllCharsNotNumber(event) {
                    var value = event.target.value;
                    if (value) {
                        event.target.value = value.replace(/\D/g, "");
                    }
                },

                // checkIfFormHasErrorsAndSubmit(form, sendFormFunc, afterSubmitFunc, afterSubmitError) {
                //     if (!this.checkIfHasAnyError()) {
                //         afterSubmitFunc = afterSubmitFunc || "";
                //         sendFormFunc(form)
                //             .then(afterSubmitFunc)
                //             .catch(afterSubmitError)
                //     } else {
                //         console.log("has errors:", this.hasError);
                //     }
                // },
                checkIfFormHasErrorsAndSubmit: function checkIfFormHasErrorsAndSubmit(form, sendFormFunc, afterSubmitFunc, afterSubmitError) {
                    var _this = this;

                    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                        var resp;
                        return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                                switch (_context.prev = _context.next) {
                                    case 0:
                                        if (_this.checkIfHasAnyError()) {
                                            _context.next = 14;
                                            break;
                                        }

                                        afterSubmitFunc = afterSubmitFunc || "";
                                        _context.prev = 2;
                                        _context.next = 5;
                                        return sendFormFunc(form);

                                    case 5:
                                        resp = _context.sent;

                                        afterSubmitFunc(resp);
                                        _context.next = 12;
                                        break;

                                    case 9:
                                        _context.prev = 9;
                                        _context.t0 = _context["catch"](2);

                                        afterSubmitError(_context.t0);

                                    case 12:
                                        _context.next = 15;
                                        break;

                                    case 14:
                                        console.log("has errors:", _this.hasError);

                                    case 15:
                                    case "end":
                                        return _context.stop();
                                }
                            }
                        }, _callee, _this, [[2, 9]]);
                    }))();
                },
                checkIfFormHasErrorsAndOpenModal: function checkIfFormHasErrorsAndOpenModal(form, openModal, sendFormFunc) {
                    if (!this.checkIfHasAnyError()) {
                        openModal(form, sendFormFunc);
                    } else {
                        console.log("has errors:", this.hasError);
                    }
                },
                onChangeRemoveError: function onChangeRemoveError(form, item, event) {
                    if (this.hasError[item]) {
                        this.showOrHideError(item, form[item]);
                    }
                    if (event) {
                        this.removeAllCharsNotNumber(event);
                    }
                }
            }
        });
    }
});

function convertToSnakeCase(input) {
    return input.replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
        return "_" + y.toLowerCase();
    }).replace(/^_/, "");
};

/***/ }),
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_public_RecoverUserid__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_public_ChangePassword__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_public_RecoverPassword__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_public_Signup__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_public_Login__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_public_Welcome__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_public_Page404__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_private_Main__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_private_Landing2__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_private_Transactions__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_private_Referrals__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_private_Settings__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_private_Help__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_private_Services__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_private_Pool__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_private_Insights__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lang_setup_i18n_setup__ = __webpack_require__(74);





















/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/',
    redirect: '/login',
    component: __WEBPACK_IMPORTED_MODULE_5__views_public_Welcome__["a" /* default */],
    children: [{ path: '/signup', name: 'signup', component: __WEBPACK_IMPORTED_MODULE_3__views_public_Signup__["a" /* default */], redirect: '/login' }, { path: '/login', name: 'login', component: __WEBPACK_IMPORTED_MODULE_4__views_public_Login__["a" /* default */] }, { path: '/recoveruserid', name: 'recoveruserid', component: __WEBPACK_IMPORTED_MODULE_0__views_public_RecoverUserid__["a" /* default */] }, { path: '/recoverpassword', name: 'recoverpassword', component: __WEBPACK_IMPORTED_MODULE_2__views_public_RecoverPassword__["a" /* default */] }, { path: '/changepassword=:pinhash', name: 'changepassword', component: __WEBPACK_IMPORTED_MODULE_1__views_public_ChangePassword__["a" /* default */], props: true }, { path: '/activate=:activationHash', component: __WEBPACK_IMPORTED_MODULE_4__views_public_Login__["a" /* default */], props: true }, { path: '/referralcode=:referCode', name: 'referralcode', component: __WEBPACK_IMPORTED_MODULE_3__views_public_Signup__["a" /* default */], props: true }]
    // beforeEnter: (to, from, next) => {
    //     resolveLanguage().then(()=>{
    //         next()
    //     })
    // }
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_7__views_private_Main__["a" /* default */],
    redirect: '/home',
    children: [{ path: '/home', name: 'home', component: __WEBPACK_IMPORTED_MODULE_8__views_private_Landing2__["a" /* default */] }, { path: '/transactions/:arg', name: 'transactions', component: __WEBPACK_IMPORTED_MODULE_9__views_private_Transactions__["a" /* default */] }, { path: '/referrals', name: 'referrals', component: __WEBPACK_IMPORTED_MODULE_10__views_private_Referrals__["a" /* default */] }, { path: '/settings', name: 'settings', component: __WEBPACK_IMPORTED_MODULE_11__views_private_Settings__["a" /* default */] }, { path: '/pool', name: 'pool', component: __WEBPACK_IMPORTED_MODULE_14__views_private_Pool__["a" /* default */] }, { path: '/services/:arg', name: 'services', component: __WEBPACK_IMPORTED_MODULE_13__views_private_Services__["a" /* default */] }, { path: '/help', name: 'help', component: __WEBPACK_IMPORTED_MODULE_12__views_private_Help__["a" /* default */] }, { path: '/insights', name: 'insights', component: __WEBPACK_IMPORTED_MODULE_15__views_private_Insights__["a" /* default */] }],
    // beforeEnter: (to, from, next) => {
    //     resolveLanguage().then(()=>{
    //         next()
    //     })
    // },
    meta: {
        requiresAuth: true // change to true in production
    }

}, {
    path: '*', component: __WEBPACK_IMPORTED_MODULE_6__views_public_Page404__["a" /* default */]
}]);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverUserid_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec911138_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverUserid_vue__ = __webpack_require__(726);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverUserid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec911138_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverUserid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.logoClasses,staticStyle:{"width":"130px"},attrs:{"id":"base_written_logo","src":__webpack_require__(66)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(723);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("9ad3ef18", content, true, {});

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "li[data-v-20e9c3c0]{display:inline;margin-right:12px;color:#fff}select[data-v-20e9c3c0]{font-size:18px;padding:0 12px;color:#fff}option[data-v-20e9c3c0],select[data-v-20e9c3c0]{background-color:transparent}", ""]);

// exports


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.storeLanguage),expression:"storeLanguage"}],staticClass:"component_normal_input languageSelector",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.storeLanguage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.languages),function(language){return _c('option',{key:language,domProps:{"value":language}},[_vm._v(_vm._s(_vm.$tc(("msg." + language), 1)))])}),0):_c('ul',{staticClass:"language_selector_mobile"},_vm._l((_vm.languages),function(language){return _c('li',{key:language,class:_vm.storeLanguage == language ? 'router-link-active' : '',attrs:{"value":language},on:{"click":function($event){return _vm.changeLanguage(language)}}},[_vm._v("\n    "+_vm._s(_vm.$tc(("msg." + language), 1))+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.bluValue || !_vm.btcValue)?_c('div',{staticStyle:{"color":"#fff","display":"flex","justify-content":"center","align-items":"center"}},[_vm._v("\n  "+_vm._s(_vm.$t("msg.loading"))+"...\n")]):_c('span',[_c('span',{staticClass:"price"},[_vm._v("\n    "+_vm._s((_vm.bluValue[0].value).toFixed(2))+"\n    "),_c('strong',[_vm._v("USDT")]),_vm._v(" |\n  ")]),_vm._v(" "),(_vm.fundValueBtc)?_c('span',{staticClass:"price"},[_vm._v("\n    "+_vm._s((_vm.fundValueBtc.tokenPrice).toFixed(6))+"\n    "),_c('strong',[_vm._v("BTC")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column",attrs:{"id":"auth_forgot_userid"}},[_c('div',{staticClass:"form_container combo_1"},[_c('div',{staticClass:"language-bar"},[_c('base-language-bar')],1),_vm._v(" "),_c('img',{staticClass:"'mw100 auth_logo combo_1'",attrs:{"src":__webpack_require__(66)}}),_vm._v(" "),_c('div',{staticClass:"blu-prices"},[_c('blu-prices-header')],1),_vm._v(" "),_c('p',{staticClass:"text_md tal_c"},[_vm._v(_vm._s(_vm.$t("msg.forgot_userid")))]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.recoverUserIdForm.email),expression:"recoverUserIdForm.email"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.email),attrs:{"type":"text","placeholder":_vm.$t('msg.email')},domProps:{"value":(_vm.recoverUserIdForm.email)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.recoverUserIdForm, 'email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.recoverUserIdForm, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.email),expression:"hasError.email"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.errorMsg.email)))))]),_vm._v(" "),_c('p',{staticClass:"text_sm main_white_feel tal_l"})]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('button',{staticClass:"regular_submit",attrs:{"type":"submit"},on:{"click":_vm.submitRecoverUserid}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.recover_userid"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"column tal_c"},[_c('router-link',{attrs:{"to":{ name: 'recoverpassword' },"exact":""}},[_c('a',{staticClass:"main_white_fill text_sm combo_1 dis_b m9_t"},[_c('span',{staticClass:"fat underline"},[_vm._v(_vm._s(_vm.$t("msg.recover_password")))])])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'login' },"exact":""}},[_c('a',{staticClass:"main_white_fill text_sm combo_1 dis_b m9_t"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.already_member", 1))+"\n          "),_c('span',{staticClass:"fat underline"},[_vm._v(_vm._s(_vm.$t("msg.login")))])])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'signup' },"exact":""}},[_c('a',{staticClass:"main_white_fill text_sm combo_1 dis_b m9_t"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.not_member_yet"))+"\n          "),_c('span',{staticClass:"fat underline"},[_vm._v(_vm._s(_vm.$t("msg.open_account")))])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed88f258_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(728);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed88f258_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_container combo_1"},[_c('p',{staticClass:"text_lg tal_c"},[_vm._v(_vm._s(_vm.$t("msg.change_password")))]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.changePasswordForm.password),expression:"changePasswordForm.password"}],staticClass:"form_white_border regular_input",style:(_vm.errorInputStyle.password),attrs:{"type":"password","id":"password","placeholder":_vm.$t('msg.password_create')},domProps:{"value":(_vm.changePasswordForm.password)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.changePasswordForm, 'password')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.changePasswordForm, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.password),expression:"hasError.password"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.password)),1)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$tc("msg.password_requirements",1)))])]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.changePasswordForm.passwordConfirmation),expression:"changePasswordForm.passwordConfirmation"}],staticClass:"form_white_border regular_input",style:(_vm.errorInputStyle.passwordConfirmation),attrs:{"type":"password","id":"confirm_password","placeholder":_vm.$t('msg.confirm_password')},domProps:{"value":(_vm.changePasswordForm.passwordConfirmation)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.changePasswordForm, 'passwordConfirmation')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.changePasswordForm, "passwordConfirmation", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.passwordConfirmation),expression:"hasError.passwordConfirmation"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.passwordConfirmation)),1)))])]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('input',{staticClass:"regular_submit",attrs:{"type":"submit","placeholder":_vm.$t('msg.continue')},on:{"click":function($event){return _vm.submitChangePassword()}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4a054c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__ = __webpack_require__(730);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecoverPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4a054c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecoverPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column",attrs:{"id":"auth_forgot_password"}},[_c('div',{staticClass:"form_container combo_1"},[_c('div',{staticClass:"language-bar"},[_c('base-language-bar')],1),_vm._v(" "),_c('img',{staticClass:"'mw100 auth_logo combo_1'",attrs:{"src":__webpack_require__(66)}}),_vm._v(" "),_c('div',{staticClass:"blu-prices"},[_c('blu-prices-header')],1),_vm._v(" "),_c('p',{staticClass:"text_md tal_c"},[_vm._v(_vm._s(_vm.$t("msg.forgot_password")))]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.recoverPasswordForm.userId),expression:"recoverPasswordForm.userId"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.userId),attrs:{"type":"text","placeholder":_vm.$t('msg.userid')},domProps:{"value":(_vm.recoverPasswordForm.userId)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.recoverPasswordForm, 'userId')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.recoverPasswordForm, "userId", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.userId),expression:"hasError.userId"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.errorMsg.userId)))))]),_vm._v(" "),_c('p',{staticClass:"text_sm main_white_feel tal_l"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.check_your_email_for_recovery_link"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"form_block combo_1"},[_c('button',{staticClass:"regular_submit",attrs:{"type":"submit"},on:{"click":_vm.submitRecoverPassword}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.recover_password"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"column tal_c"},[_c('router-link',{attrs:{"to":{ name: 'recoveruserid' },"exact":""}},[_c('a',{staticClass:"main_white_fill text_sm combo_1 dis_b m9_t"},[_c('span',{staticClass:"fat underline"},[_vm._v(_vm._s(_vm.$t("msg.recover_userid")))])])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'login' },"exact":""}},[_c('a',{staticClass:"main_white_fill text_sm combo_1 dis_b m9_t"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.already_member", 1))+"\n          "),_c('span',{staticClass:"fat underline"},[_vm._v(_vm._s(_vm.$t("msg.login")))])])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'signup' },"exact":""}},[_c('a',{staticClass:"main_white_fill text_sm combo_1 dis_b m9_t"},[_vm._v(_vm._s(_vm.$t("msg.not_member_yet"))+"\n          "),_c('span',{staticClass:"fat underline"},[_vm._v(_vm._s(_vm.$t("msg.open_account")))])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be5c82_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(736);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be5c82_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(733);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1cd8596b", content, true, {});

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tal_c",attrs:{"id":"public_loading"}},[_c('p',[_vm._v("\n    "+_vm._s(_vm.$t("msg.loading"))+" \n    "),_c('span',{staticClass:"public_loading_1"},[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"public_loading_2"},[_vm._v(".")]),_vm._v(" "),_c('span',{staticClass:"public_loading_3"},[_vm._v(".")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 735 */,
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns column",attrs:{"id":"auth_signup"}},[_c('div',{staticClass:"column combo_1 p0"},[_c('div',{staticClass:"form_container combo_1"},[_c('div',{staticClass:"language-bar"},[_c('base-language-bar')],1),_vm._v(" "),_c('img',{staticClass:"'mw100 auth_logo combo_1'",attrs:{"src":__webpack_require__(66)}}),_vm._v(" "),_c('div',{staticClass:"blu-prices"},[_c('blu-prices-header')],1),_vm._v(" "),_c('div',{staticClass:"page_banner_countdown"},[(_vm.countdownInterval)?_c('div',{staticClass:"clock"},[_c('div',[_c('span',{staticClass:"days"},[_vm._v(_vm._s(_vm.clock.days))]),_vm._v(" "),_c('div',{staticClass:"smalltext"},[_vm._v(_vm._s(_vm.$t("msg.days")))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"hours"},[_vm._v(_vm._s(_vm.clock.hours))]),_vm._v(" "),_c('div',{staticClass:"smalltext"},[_vm._v(_vm._s(_vm.$t("msg.hours")))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"minutes"},[_vm._v(_vm._s(_vm.clock.minutes))]),_vm._v(" "),_c('div',{staticClass:"smalltext"},[_vm._v(_vm._s(_vm.$t("msg.minutes")))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"seconds"},[_vm._v(_vm._s(_vm.clock.seconds))]),_vm._v(" "),_c('div',{staticClass:"smalltext"},[_vm._v(_vm._s(_vm.$t("msg.seconds")))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"combo_1",staticStyle:{"position":"relative"}},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.country_residency")))]),_vm._v(" "),_c('VuePhoneNumberInput',{staticClass:"VuePhoneNumberInput",attrs:{"border-radius":6,"translations":{
            countrySelectorLabel: _vm.$t('msg.phone_code'),
            phoneNumberLabel: _vm.$t('msg.phone_optional'),
          },"color":"#333364","error":_vm.countriesNotAllowed,"no-example":_vm.countriesNotAllowed},on:{"update":function($event){return _vm.verifyCountry($event)},"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'phone')}},model:{value:(_vm.signupform.phone),callback:function ($$v) {_vm.$set(_vm.signupform, "phone", $$v)},expression:"signupform.phone"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.phone && !_vm.countriesNotAllowed),expression:"hasError.phone && !countriesNotAllowed"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.errorMsg.phone)))))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countriesNotAllowed),expression:"countriesNotAllowed"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t("msg.invalid_phone_country")))])],1),_vm._v(" "),_c('div',{staticClass:"combo_1",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.email")))]),_vm._v(" "),_c('svg',{staticClass:"tooltip_disclaimer_new",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"mouseover":function($event){_vm.showInfo['1a'] = true},"mouseleave":function($event){_vm.showInfo['1a'] = false}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupform.email),expression:"signupform.email"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.email),attrs:{"type":"text","id":"email","placeholder":"Email*"},domProps:{"value":(_vm.signupform.email)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupform, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.email),expression:"hasError.email"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.$t(("msg." + (_vm.errorMsg.email)))))]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showInfo['1a'])?_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t('msg.create_new_email_recommendation'))}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.password")))]),_vm._v(" "),_c('svg',{staticClass:"tooltip_disclaimer_new",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"mouseover":function($event){_vm.showInfo['1b'] = true},"mouseleave":function($event){_vm.showInfo['1b'] = false}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupform.password),expression:"signupform.password"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.password),attrs:{"type":"password","placeholder":_vm.$t('msg.password_create') + '*'},domProps:{"value":(_vm.signupform.password)},on:{"keyup":function($event){_vm.onChangeRemoveError(_vm.signupform, 'password'), _vm.toggleRemove()},"focus":function($event){return _vm.toggleBox()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupform, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.password),expression:"hasError.password"}],staticClass:"help is-danger"},[_vm._v("\n          "+_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.password)), 1))+"\n        ")]),_vm._v(" "),(_vm.showBox)?_c('div',{staticClass:"suggestion-box text_sm",class:_vm.slide ? 'slideOutUp' : ''},[_c('div',{staticClass:"content_lock"},[_c('i',{staticClass:"icon_class_06",domProps:{"innerHTML":_vm._s(_vm.iconSets.lock_icon_fit)}})]),_vm._v(" "),_c('div',{staticClass:"w100 p5_r"},[_c('div',{staticClass:"justify_between_ai_center"},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.password_suggestion"))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"justify_between_ai_center suggestion_input"},[_c('span',{staticClass:"pointer",on:{"click":function($event){return _vm.usePasswordSujest()}}},[_vm._v(_vm._s(_vm.passwordSujest))]),_vm._v(" "),_c('i',{staticClass:"icon_class_1",class:_vm.roll ? 'rool' : '',domProps:{"innerHTML":_vm._s(_vm.iconSets.refresh_fit)},on:{"click":function($event){_vm.generate(), (_vm.roll = true)}}})])])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showInfo['1b'])?_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$tc("msg.password_requirements", 1))}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.confirm_password")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupform.passwordConfirmation),expression:"signupform.passwordConfirmation"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.passwordConfirmation),attrs:{"type":"password","placeholder":_vm.$t('msg.confirm_password') + '*'},domProps:{"value":(_vm.signupform.passwordConfirmation)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'passwordConfirmation')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupform, "passwordConfirmation", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.passwordConfirmation),expression:"hasError.passwordConfirmation"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.passwordConfirmation)), 1)))])]),_vm._v(" "),_c('div',{staticClass:"combo_1",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.did_someone_referred")))]),_vm._v(" "),_c('svg',{staticClass:"tooltip_disclaimer_new",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"mouseover":function($event){_vm.showInfo['1c'] = true},"mouseleave":function($event){_vm.showInfo['1c'] = false}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupform.referralCode),expression:"signupform.referralCode"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.referralCode),attrs:{"type":"referral_code","placeholder":_vm.$t('msg.referral_code'),"readonly":_vm.referCode != ''},domProps:{"value":(_vm.signupform.referralCode)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'referralCode')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupform, "referralCode", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.referralCode),expression:"hasError.referralCode"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.referralCode)), 1)))]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showInfo['1c'])?_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t('msg.was_referred'))}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"form_block combo_1 form_block_checkbox",staticStyle:{"width":"100% !important","align-items":"center !important"}},[_c('label',{staticClass:"combo_1 label_box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupform.hasAcceptedTerms),expression:"signupform.hasAcceptedTerms"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.signupform.hasAcceptedTerms)?_vm._i(_vm.signupform.hasAcceptedTerms,null)>-1:(_vm.signupform.hasAcceptedTerms)},on:{"change":[function($event){var $$a=_vm.signupform.hasAcceptedTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.signupform, "hasAcceptedTerms", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.signupform, "hasAcceptedTerms", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.signupform, "hasAcceptedTerms", $$c)}},function($event){return _vm.onChangeRemoveError(_vm.signupform, 'hasAcceptedTerms')}]}}),_vm._v(" "),_c('span',{staticClass:"control-label",style:(!_vm.checkBoxTerms ? 'border: 1px solid darkgrey;' : '')})]),_vm._v(" "),_c('p',{staticClass:"label_text",staticStyle:{"font-size":"14px !important"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.i_read_and_accept'))},on:{"click":function (e) { return _vm.openCheckBox(e, 'checkBoxTerms'); }}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.hasAcceptedTerms),expression:"hasError.hasAcceptedTerms"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.hasAcceptedTerms)), 1)))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-top":"25px","margin-bottom":"25px"}},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":"6Ld5qccaAAAAAH5xmkU8cw9CA1UwtP66KcL-UP2f","loadRecaptchaScript":true},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.onCaptchaExpired}})],1),_vm._v(" "),_c('div',{staticClass:"combo_1",staticStyle:{"z-index":"10 !important","margin-top":"70px"}},[(_vm.loading)?_c('base-loading',{staticClass:"regular_submit"}):_c('button',{attrs:{"type":"submit"},on:{"click":_vm.submitSignup}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.signup"))+"\n        ")])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.formSent),expression:"hasError.formSent"}],staticClass:"help is-danger"},[_vm._v("\n        "+_vm._s(_vm.$t(("msg." + (_vm.errorMsg.formSent)), 1))+"\n      ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasSuccess.formSent),expression:"hasSuccess.formSent"}],staticClass:"help is-success"},[_vm._v("\n        "+_vm._s(_vm.$t(("msg." + (_vm.successMsg.formSent)), 1))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"not_member_yet"},[_c('router-link',{attrs:{"to":{ name: 'login' },"exact":""}},[_c('a',[_c('span',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.login_here")))])])])],1)])]),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"column tal_c"},[_c('phases')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad228df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(738);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad228df_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auth_login"}},[_c('div',{staticClass:"form_container combo_1"},[_c('div',{staticClass:"language-bar"},[_c('base-language-bar')],1),_vm._v(" "),_c('img',{staticClass:"'mw100 auth_logo combo_1'",attrs:{"src":__webpack_require__(66)}}),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('label'),_vm._v(" "),_c('the-mask',{staticClass:"input_write_form",attrs:{"mask":['######'],"masked":true,"placeholder":"ex:123456"},model:{value:(_vm.loginform.userid),callback:function ($$v) {_vm.$set(_vm.loginform, "userid", $$v)},expression:"loginform.userid"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.userid),expression:"hasError.userid"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.errorMsg.userid)))))]),_vm._v(" "),_c('span',{staticClass:"text_sm tal_c dis_b your_id_is",domProps:{"innerHTML":_vm._s(_vm.$t('msg.your_id_is'))}})],1),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('label',[_vm._v("\n        "+_vm._s(_vm.$t("msg.password"))+"\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginform.password),expression:"loginform.password"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.password),attrs:{"type":"password","placeholder":_vm.$t('msg.password')},domProps:{"value":(_vm.loginform.password)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.loginform, 'password')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginform, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.password),expression:"hasError.password"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$tc(("msg." + (_vm.errorMsg.password)), 1)))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-top":"25px","margin-bottom":"25px","z-index":"1 !important"}},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":"6Ld5qccaAAAAAH5xmkU8cw9CA1UwtP66KcL-UP2f","loadRecaptchaScript":true},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.onCaptchaExpired}})],1),_vm._v(" "),_c('div',{staticClass:"combo_1",staticStyle:{"z-index":"10 !important","margin-top":"70px"}},[(_vm.loading)?_c('button',{staticClass:"regular_submit"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.loading"))+"...\n      ")]):_c('button',{attrs:{"type":"submit"},on:{"click":_vm.submitLogin}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.login"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"tal_c"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between","padding-top":"0.5rem"}},[_c('router-link',{attrs:{"to":{ name: 'recoveruserid' },"exact":""}},[_c('a',{staticClass:"main_white_fill combo_1 dis_b text_sm"},[_c('span',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.recover_userid")))])])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'recoverpassword' },"exact":""}},[_c('a',{staticClass:"main_white_fill combo_1 dis_b text_sm"},[_c('span',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.recover_password")))])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d5770b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__(744);
function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13d5770b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("223dc240", content, true, {});

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"main_footer"}},[_c('img',{attrs:{"src":__webpack_require__(743),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"column footer-content-background"},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"logo-center"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("© "+_vm._s(_vm.year)+" "+_vm._s(_vm.$tc("msg.all_rights_reserved", 1)))])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"/","target":"_blank"}},[_vm._v(_vm._s(_vm.$tc("msg.home", 1)))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://bluetoken.io/Faqs","target":"_blank"}},[_vm._v(_vm._s(_vm.$tc("msg.faq", 1)))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":"https://bluetoken.io/Terms"}},[_vm._v(_vm._s(_vm.$tc("msg.terms_and_conditions", 1)))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://bluetoken.io/Privacy","target":"_blank"}},[_vm._v(_vm._s(_vm.$tc("msg.privacy_policy", 1)))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://bluetoken.io/Fees","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("msg.fees_minimums")))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://bscscan.com/token/0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2","target":"_blank"}},[_vm._v(_vm._s(_vm.$t("msg.explorer")))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/","target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(66)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "waveOk.svg?d6bcfe60af2245ff3b4962fb4746ec04";

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_auth",attrs:{"id":"page_auth"}},[_c('header',{staticClass:"auth_header"},[_c('div',{staticClass:"price_container"}),_vm._v(" "),_c('base-language-bar')],1),_vm._v(" "),_c('div',{staticClass:"auth_body"},[_c('router-view')],1),_vm._v(" "),_c('base-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df15d56_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(746);
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df15d56_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page404",attrs:{"id":"mainwrapper "}},[_c('div',{staticClass:"container-fluid"},[_c('div',{attrs:{"id":"page-wrapper"}},[_c('div',{staticClass:"error404",attrs:{"id":"contentplusfooter"}},[_c('div',{attrs:{"id":"content-wrapper"}},[_c('h1',[_vm._v("Ooops!\n                        "),_c('br'),_c('span',[_vm._v("404")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7cbf642_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(801);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7cbf642_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingTen_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99c87904_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingTen_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingTen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99c87904_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingTen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0ea07d9c", content, true, {});

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}", ""]);

// exports


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v(_vm._s(_vm.$t("msg.voting_survey")))]),_vm._v(" "),(_vm.step == 1)?_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body_modal"},[(_vm.step == 1)?_c('div',[_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_1")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v(_vm._s(_vm.$t("msg.how_vote")))]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_3")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m25_t",on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.click_here_to_vote"))+"\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',[_c('p',{staticClass:"tal_c fat text_purple fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns tal_c p0"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column coins_cont",class:_vm.checkedCoins[0] == coin.symbol || _vm.checkedCoins[1] == coin.symbol
              ? 'selected_coin'
              : '',on:{"click":function($event){return _vm.getInfo(coin.symbol)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',[_c('div',{staticClass:"background_ icon_class_symbol",class:'background_' + coin.symbol,style:('height:40px; width:40px;')})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(coin.symbol.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"column p0 m0 fs_small fat",class:coin.percent > 0 ? 'green' : 'red_color'},[_vm._v("\n            *"+_vm._s(coin.percent)+"% YTD\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"column fs_small tal_c m0 m20_b text_info"},[_vm._v("\n        *"+_vm._s(_vm.$t("msg.please_chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column content_info text_info"},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(coin.name))]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"10px","margin-bottom":"10px"}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.sector"))+":")]),_vm._v(" "+_vm._s(coin.sector)+" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.token_type"))+":")]),_vm._v(" "+_vm._s(coin.tokenType)),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.staking_rewards"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.rewards))))+"\n          ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(("msg.coin_voting_" + (coin.symbol))))}})])}),0),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat",attrs:{"disabled":_vm.checkedCoins.length != 2 || _vm.buttonBlock},on:{"click":function($event){return _vm.postVote()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.finish_Vote"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingTwelve_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a15efcf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingTwelve_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingTwelve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a15efcf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingTwelve_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(754);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("907121e2", content, true, {});

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:300;color:#707070}", ""]);

// exports


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v(_vm._s(_vm.$t("msg.voting_survey")))]),_vm._v(" "),(_vm.step == 1)?_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body_modal"},[(_vm.step == 1)?_c('div',[_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_1")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v(_vm._s(_vm.$t("msg.how_vote")))]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_3")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m25_t",on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.click_here_to_vote"))+"\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',[_c('p',{staticClass:"tal_c fat text_purple fs_small"},[_vm._v("\n        *"+_vm._s(_vm.$t("msg.chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns tal_c p0"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column coins_cont",class:_vm.checkedCoins[0] == coin.symbol || _vm.checkedCoins[1] == coin.symbol
              ? 'selected_coin'
              : '',on:{"click":function($event){return _vm.getInfo(coin.symbol)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',[_c('div',{staticClass:"background_ icon_class_symbol",class:'background_' + coin.symbol,style:('height:40px; width:40px;')})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(coin.symbol.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"column p0 m0 fs_small fat",class:coin.percent > 0 ? 'green' : 'red_color'},[_vm._v("\n            *"+_vm._s(coin.percent)+"% YTD\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"column fs_small tal_c m0 m20_b text_info"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.please_chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column content_info text_info"},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(coin.name))]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"10px","margin-bottom":"10px"}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.sector"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.sector))))+" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.token_type"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.tokenType))))),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.staking_rewards"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.rewards))))+"\n          ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(("msg.coin_voting_" + (coin.symbol))))}})])}),0),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat",attrs:{"disabled":_vm.checkedCoins.length != 2 || _vm.buttonBlock},on:{"click":function($event){return _vm.postVote()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.finish_Vote"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHeader_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50aabf39_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHeader_vue__ = __webpack_require__(765);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50aabf39_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebBanner_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cad1d5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebBanner_vue__ = __webpack_require__(764);
function injectStyle (ssrContext) {
  __webpack_require__(758)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78cad1d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cad1d5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WebBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(759);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("5585b06e", content, true, {});

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".main_web_banner[data-v-78cad1d5]{width:100%;height:100%}.main_web_banner .banner_web[data-v-78cad1d5]{width:100%!important}.main_web_banner .banner_mobile[data-v-78cad1d5]{width:100%!important;display:none}@media only screen and (max-width:880px){.main_web_banner .banner_mobile[data-v-78cad1d5]{display:block}.main_web_banner .banner_web[data-v-78cad1d5]{display:none}}", ""]);

// exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stratumblue_web_banner.jpg?0b3ea068aca1a9a32ef5d7d3b1ce6bb1";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stratumblue_mobile_banner.jpg?7930c1ffed50edbedcaa91e4a67a1dc4";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stratumblue_web_banner_es.jpg?d1c2ffe4b8c505dba5fb5e34fc2d6f3b";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stratumblue_mobile_banner_es.jpg?808717dd240eb4d0b8ebcde7fc4f1360";

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_web_banner"},[(_vm.languageSelected == 'en')?_c('div',[_c('a',{attrs:{"href":"https://www.labitconf.com/","target":"_blank"}},[_c('img',{staticClass:"banner_web",attrs:{"src":_vm.banner}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.labitconf.com/","target":"_blank"}},[_c('img',{staticClass:"banner_mobile",attrs:{"src":_vm.bannerMobile}})])]):_vm._e(),_vm._v(" "),(_vm.languageSelected == 'es')?_c('div',[_c('a',{attrs:{"href":"https://www.labitconf.com/","target":"_blank"}},[_c('img',{staticClass:"banner_web",attrs:{"src":_vm.bannerEs}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.labitconf.com/","target":"_blank"}},[_c('img',{staticClass:"banner_mobile",attrs:{"src":_vm.bannerMobileEs}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"column main_blue_dk_bg p0",attrs:{"id":"main_header"}},[(!_vm.isMobile)?_c('div',{staticClass:"columns m0_b p0_b container_header"},[_c('div',{staticClass:"column main_header_left"},[_c('router-link',{staticClass:"dis_inb",attrs:{"to":"/home"}},[_c('base-written-logo')],1)],1),_vm._v(" "),_c('div',{staticClass:"column main_header_right is-two-thirds tal_r",staticStyle:{"display":"flex","justify-cotent":"center","align-items":"center","justify-content":"end","width":"auto"}},[_c('ul',[_c('li',[_c('router-link',{class:{ active: _vm.route == 'home' },attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$tc("msg.dashboard", 1))+" ")])],1),_vm._v(" "),_c('li',{on:{"mouseleave":function () { return _vm.toggleServiceDrop(); }}},[_c('div',{staticClass:"pointer service-option-nav",class:_vm.route == 'services' ? 'router-link-active' : '',on:{"mouseover":function () { return _vm.toggleServiceDrop(); }}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.services"))+"\n            "),(_vm.toggleService)?_c('span',{staticClass:"icon_class_1",staticStyle:{"transform":"rotate(180deg)"},domProps:{"innerHTML":_vm._s(_vm.iconSets.general_arrow_down)}}):_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_arrow_down)}})]),_vm._v(" "),(_vm.toggleService)?_c('div',{staticClass:"service-dropdown"},_vm._l((_vm.services),function(servico){return _c('div',{key:servico.type,staticClass:"custom_flex_column m10_t pointer",on:{"click":function () { return _vm.toggleServiceDrop(); }}},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"to":servico.link}},[_c('div',{staticClass:"custom_flex_row service-dropdown-item"},[(_vm.checkParams(servico.type))?_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets[servico.icon_activated])}}):_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets[servico.icon])}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.$tc(("msg." + (servico.type)))))])])])],1)}),0):_vm._e()]),_vm._v(" "),_c('li',[_c('router-link',{class:_vm.route == 'transactions' ? 'router-link-active' : '',attrs:{"to":"/transactions/deposits"}},[_vm._v(_vm._s(_vm.$tc("msg.transaction", 2)))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/referrals"}},[_vm._v(_vm._s(_vm.$tc("msg.referrals", 1)))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/insights"}},[_vm._v(_vm._s(_vm.$t("msg.insights")))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings"}},[_vm._v(_vm._s(_vm.$t("msg.header_settings")))])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$tc("msg.logout", 1)))])]),_vm._v(" "),_c('li',[_c('base-language-bar')],1)])])]):_c('div',{staticClass:"mobile_menu"},[(_vm.openedMobileMenu)?_c('div',{staticClass:"mobile_menu_opened"},[_c('div',{staticClass:"mobile_menu_opened_inner"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"menu_icon_close main_white_fill",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_close_2)},on:{"click":function($event){return _vm.closeMobileMenu()}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('ul',{staticClass:"combo_1"},[_c('li',[_c('router-link',{staticClass:"colorred",class:{ active: _vm.route == 'home' },attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.$tc("msg.dashboard", 1)))])],1),_vm._v(" "),_c('li',{staticClass:"m2_t"},[_c('router-link',{attrs:{"to":"/transactions/deposits"}},[_vm._v(_vm._s(_vm.$tc("msg.transaction", 2)))])],1),_vm._v(" "),_c('li',{staticClass:"m2_t"},[_c('router-link',{attrs:{"to":"/referrals"}},[_vm._v(_vm._s(_vm.$tc("msg.referrals", 1)))])],1),_vm._v(" "),_c('li',{staticClass:"m2_t"},[_c('div',{staticClass:"pointer service-option-nav",class:_vm.route == 'services' ? 'router-link-active' : '',staticStyle:{"color":"white"},on:{"click":function () { return _vm.toggleServiceDrop(); }}},[_vm._v("\n                "+_vm._s(_vm.$t("msg.services"))+"\n                "),(_vm.toggleService)?_c('span',{staticClass:"icon_class_1 m9_l",staticStyle:{"fill":"white","color":"white transform: rotate(90deg)"},domProps:{"innerHTML":_vm._s(_vm.iconSets.general_arrow_down)}}):_c('span',{staticClass:"icon_class_1 m9_l",staticStyle:{"fill":"white","color":"white"},domProps:{"innerHTML":_vm._s(_vm.iconSets.general_arrow_down)}})]),_vm._v(" "),(_vm.toggleService)?_c('div',{staticClass:"service-dropdown-mobile"},_vm._l((_vm.services),function(servico){return _c('div',{key:servico.type,staticClass:"custom_flex_column pointer",on:{"click":function () { return _vm.toggleServiceDrop(); }}},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"to":servico.link}},[_c('div',{staticClass:"custom_flex_row service-dropdown-item"},[(_vm.checkParams(servico.type))?_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets[servico.icon_activated])}}):_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets[servico.icon])}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.$tc(("msg." + (servico.type)))))])])])],1)}),0):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"m2_t"},[_c('router-link',{attrs:{"to":"/insights"}},[_vm._v(_vm._s(_vm.$t("msg.insights")))])],1),_vm._v(" "),_c('li',{staticClass:"m2_t"},[_c('router-link',{attrs:{"to":"/settings"}},[_vm._v(_vm._s(_vm.$t("msg.header_settings")))])],1),_vm._v(" "),_c('li',{staticClass:"m2_t"},[_c('a',{on:{"click":function($event){return _vm.logout()}}},[_vm._v(_vm._s(_vm.$tc("msg.logout", 1)))])]),_vm._v(" "),_c('li',{staticClass:"m25_t"},[_c('base-language-bar')],1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-two-thirds"},[_c('router-link',{staticClass:"dis_b combo_1 tal_l",attrs:{"to":"home"}},[_c('base-written-logo',{staticStyle:{"width":"130px"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column tal_r",staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"menu_icon main_white_fill",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_menu)},on:{"click":function($event){return _vm.openMobileMenu()}}})])])]),_vm._v(" "),_c('div',{staticClass:"column columns main_header_bottom m0 p0"},[(!_vm.banner)?_c('div',{staticClass:"column tal_l_b container_header"},[_c('div',{staticClass:"wrapper_user"},[(_vm.member.role == 'adminREMOVETHISPARTSOITWORKS')?_c('span',[_vm._v("\n          Welcome admin\n        ")]):_c('div',{staticClass:"user_id_email"},[_c('div',{staticClass:"user_id"},[_c('span',[_vm._v(" "+_vm._s(_vm.$tc("msg.user", 1))+" ID: ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.member.uid)+" ")])]),_vm._v(" "),_c('span',{staticClass:"member_email"},[_vm._v(_vm._s(_vm.member.email))])])]),_vm._v(" "),(_vm.bluValue)?_c('div',{staticClass:"live_price"},[_c('div',{staticClass:"live_price_btn"},[_c('button'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('msg.live_price')))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.bluValue[0].value.toFixed(2))+" USDT")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.banner)?_c('web-banner'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingThirteen_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d42dfc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingThirteen_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingThirteen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d42dfc8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingThirteen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("46f97586", content, true, {});

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:300;color:#707070}", ""]);

// exports


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v(_vm._s(_vm.$t("msg.voting_survey")))]),_vm._v(" "),(_vm.step == 1)?_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body_modal"},[(_vm.step == 1)?_c('div',[_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_1")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v(_vm._s(_vm.$t("msg.how_vote")))]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_3")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m25_t",on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.click_here_to_vote"))+"\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',[_c('p',{staticClass:"tal_c fat text_purple fs_small"},[_vm._v("\n        *"+_vm._s(_vm.$t("msg.chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns tal_c p0"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column coins_cont",class:_vm.checkedCoins[0] == coin.symbol || _vm.checkedCoins[1] == coin.symbol
              ? 'selected_coin'
              : '',on:{"click":function($event){return _vm.getInfo(coin.symbol)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',[_c('div',{staticClass:"background_ icon_class_symbol",class:'background_' + coin.symbol,style:('height:40px; width:40px;')})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(coin.symbol.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"column p0 m0 fs_small fat",class:coin.percent > 0 ? 'green' : 'red_color'},[_vm._v("\n            *"+_vm._s(coin.percent)+"% YTD\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"column fs_small tal_c m0 m20_b text_info"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.please_chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column content_info text_info"},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(coin.name))]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"10px","margin-bottom":"10px"}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.sector"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.sector))))+" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.token_type"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.tokenType))))),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.staking_rewards"))+":")]),_vm._v(" "+_vm._s(_vm.$t(("msg." + (coin.rewards))))+"\n          ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(("msg.coin_voting_" + (coin.symbol))))}})])}),0),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat",attrs:{"disabled":_vm.checkedCoins.length != 2 || _vm.buttonBlock},on:{"click":function($event){return _vm.postVote()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.finish_Vote"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBscInfo_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462a6eda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBscInfo_vue__ = __webpack_require__(776);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBscInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462a6eda_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBscInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(772);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("03cc5eba", content, true, {});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}#modal_voting .w30{width:18%}", ""]);

// exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(774);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7709c706", content, true, {});

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".lds-ring,.lds-ring div{width:20px;height:20px}.lds-ring div{box-sizing:border-box;display:block;position:absolute;border:2px solid #fff;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#fff transparent transparent}.lds-ring div:first-child{animation-delay:-.45s}.lds-ring div:nth-child(2){animation-delay:-.3s}.lds-ring div:nth-child(3){animation-delay:-.15s}@keyframes lds-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.modalNetwork.title"))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]),_vm._v(" "),_c('div',{staticClass:"body_modal"},[_c('div',[_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBscInfo.text_one'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBscInfo.text_two'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalBscInfo.title_two"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBscInfo.text_three'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalBscInfo.title_four"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalBscInfo.title_five"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.blue_team"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[(!_vm.loading)?_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t",on:{"click":function($event){return _vm.closeModalNetwork()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.continue"))+"\n          ")])]):_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t"},[_c('Loading')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalDhbtInfo_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44de9ace_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalDhbtInfo_vue__ = __webpack_require__(780);
function injectStyle (ssrContext) {
  __webpack_require__(778)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalDhbtInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44de9ace_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalDhbtInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(779);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("70e6a804", content, true, {});

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}#modal_voting .w30{width:18%}", ""]);

// exports


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.modalNetwork.title"))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]),_vm._v(" "),_c('div',{staticClass:"body_modal"},[_c('div',[_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalDhbtInfo.text_one'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalDhbtInfo.title_one'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalDhbtInfo.text_two'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalDhbtInfo.title_two"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalDhbtInfo.text_three'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalDhbtInfo.title_five'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalDhbtInfo.text_four"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalDhbtInfo.text_six'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalDhbtInfo.text_seven"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalDhbtInfo.title_four"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.blue_team"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[(!_vm.loading)?_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t",on:{"click":function($event){return _vm.closeModalNetwork()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.continue"))+"\n          ")])]):_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t"},[_c('Loading')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalNetworkDist_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aebb572a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalNetworkDist_vue__ = __webpack_require__(784);
function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalNetworkDist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aebb572a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalNetworkDist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(783);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("22e885e2", content, true, {});

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}#modal_voting .w30{width:18%}", ""]);

// exports


/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.modalNetwork.title"))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]),_vm._v(" "),_c('div',{staticClass:"body_modal"},[_c('div',[_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalNetwork.text_one'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalNetwork.title_two"))+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalNetwork.text_two'))}}),_vm._v(" "),_c('ul',{staticClass:"tal_l text_grey fs_small",staticStyle:{"list-style":"disc","padding-left":"50px","margin-top":"20px","margin-bottom":"20px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBlueClub.text1'))}}),_vm._v(" "),_c('li',[_vm._v("\n          "+_vm._s(_vm.$t("msg.modalBlueClub.text2"))+"\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          "+_vm._s(_vm.$t("msg.modalBlueClub.text3"))+"\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          "+_vm._s(_vm.$t("msg.modalBlueClub.text4"))+"\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          "+_vm._s(_vm.$t("msg.modalBlueClub.text5"))+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalNetwork.text_two_t'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalNetwork.title_three"))+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalNetwork.text_three'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[(!_vm.loading)?_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t",on:{"click":function($event){return _vm.closeModalNetwork()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.continue"))+"\n          ")])]):_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t"},[_c('Loading')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPrivacyPolicy_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63bd7cec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPrivacyPolicy_vue__ = __webpack_require__(788);
function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63bd7cec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(787);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("78f4aea4", content, true, {});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:80%;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .block-box{opacity:.5;pointer-events:none}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .body_modal .container-text{border:1px solid #000;max-height:650px;overflow:scroll}#modal_voting .body_modal .container-text .pdf-container{height:850px;width:100%;overflow:hidden}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}", ""]);

// exports


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.privacy_policy"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"body_modal"},[(!_vm.screenMobile)?_c('div',{staticClass:"container-text",on:{"scroll":_vm.mapScroll}},[_c('embed',{staticClass:"pdf-container",attrs:{"src":'/privacy_policy.pdf',"type":"application/pdf"},on:{"scroll":_vm.mapScroll}})]):_vm._e(),_vm._v(" "),(_vm.screenMobile)?_c('div',{staticClass:"tal_c"},[_c('a',{attrs:{"href":"/privacy_policy.pdf","target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.privacy_policy'))}})]):_vm._e(),_vm._v(" "),(!_vm.screenMobile)?_c('div',{staticClass:"column tal_c fs_small"},[_c('a',{attrs:{"href":"/privacy_policy.pdf","target":"_blank"},on:{"click":function($event){return _vm.docIsOpened()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.download_pdf'))}})]),_vm._v(" "),_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.you_must_accpet_privacy'))}})]):_vm._e(),_vm._v(" "),(!_vm.screenMobile)?_c('div',{staticClass:"column tal_c",class:_vm.handleScroll || _vm.docOpened ? 'pointer' : 'block-box'},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkTerms),expression:"checkTerms"}],attrs:{"type":"checkbox","name":"checkTerms"},domProps:{"checked":Array.isArray(_vm.checkTerms)?_vm._i(_vm.checkTerms,null)>-1:(_vm.checkTerms)},on:{"change":function($event){var $$a=_vm.checkTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkTerms=$$c}}}}),_vm._v(" "),_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.i_read_privacy'))}})]):_vm._e(),_vm._v(" "),(_vm.screenMobile)?_c('div',{staticClass:"column tal_c"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkTerms),expression:"checkTerms"}],attrs:{"type":"checkbox","name":"checkTerms"},domProps:{"checked":Array.isArray(_vm.checkTerms)?_vm._i(_vm.checkTerms,null)>-1:(_vm.checkTerms)},on:{"change":function($event){var $$a=_vm.checkTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkTerms=$$c}}}}),_vm._v(" "),_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.i_read_privacy'))}})]):_vm._e(),_vm._v(" "),(!_vm.screenMobile)?_c('div',{staticClass:"column tal_c red_color fs_00r"},[_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.browser_message'))}})]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"column tal_c"},[_c('button',{staticClass:"button-slips fat",attrs:{"disabled":!_vm.checkTerms},on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.confirmed"))+"\n      ")])]):_c('div',{staticClass:"column",staticStyle:{"display":"flex","justify-content":"center"}},[_c('button',{staticClass:"button-slips fat m13_t"},[_c('Loading')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalTermsConditions_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f00286_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalTermsConditions_vue__ = __webpack_require__(792);
function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalTermsConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f00286_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalTermsConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(791);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("836968a6", content, true, {});

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:80%;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .block-box{opacity:.5;pointer-events:none}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .body_modal .container-text{border:1px solid #000;max-height:650px;overflow:scroll}#modal_voting .body_modal .container-text .pdf-container{height:850px;width:100%;overflow:hidden}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}", ""]);

// exports


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.terms_and_conditions"))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"body_modal"},[(!_vm.screenMobile)?_c('div',{staticClass:"container-text",on:{"scroll":_vm.mapScroll}},[_c('embed',{staticClass:"pdf-container",attrs:{"src":'/BLUE_T_C_MAY2022.pdf',"type":"application/pdf"},on:{"scroll":_vm.mapScroll}})]):_vm._e(),_vm._v(" "),(_vm.screenMobile)?_c('div',{staticClass:"tal_c"},[_c('a',{attrs:{"href":"/BLUE_T_C_MAY2022.pdf","target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.terms_and_conditions'))}})]):_vm._e(),_vm._v(" "),(!_vm.screenMobile)?_c('div',{staticClass:"column tal_c fs_small"},[_c('a',{attrs:{"href":"/BLUE_T_C_MAY2022.pdf","target":"_blank"},on:{"click":function($event){return _vm.docIsOpened()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.download_pdf'))}})]),_vm._v(" "),_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.you_must_accpet_terms'))}})]):_vm._e(),_vm._v(" "),(!_vm.screenMobile)?_c('div',{staticClass:"column tal_c",class:_vm.handleScroll || _vm.docOpened ? 'pointer' : 'block-box'},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkTerms),expression:"checkTerms"}],attrs:{"type":"checkbox","name":"checkTerms"},domProps:{"checked":Array.isArray(_vm.checkTerms)?_vm._i(_vm.checkTerms,null)>-1:(_vm.checkTerms)},on:{"change":function($event){var $$a=_vm.checkTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkTerms=$$c}}}}),_vm._v(" "),_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.i_read'))}})]):_vm._e(),_vm._v(" "),(_vm.screenMobile)?_c('div',{staticClass:"column tal_c"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkTerms),expression:"checkTerms"}],attrs:{"type":"checkbox","name":"checkTerms"},domProps:{"checked":Array.isArray(_vm.checkTerms)?_vm._i(_vm.checkTerms,null)>-1:(_vm.checkTerms)},on:{"change":function($event){var $$a=_vm.checkTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkTerms=$$c}}}}),_vm._v(" "),_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.i_read'))}})]):_vm._e(),_vm._v(" "),(!_vm.screenMobile)?_c('div',{staticClass:"column tal_c red_color fs_00r"},[_c('span',{attrs:{"for":"checkTerms"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.browser_message'))}})]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"column tal_c"},[_c('button',{staticClass:"button-slips fat",attrs:{"disabled":!_vm.checkTerms},on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.confirmed"))+"\n      ")])]):_c('div',{staticClass:"column",staticStyle:{"display":"flex","justify-content":"center"}},[_c('button',{staticClass:"button-slips fat m13_t"},[_c('Loading')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingFourteen_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_856ce26c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingFourteen_vue__ = __webpack_require__(796);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalVotingFourteen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_856ce26c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalVotingFourteen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(795);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1a20855e", content, true, {});

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:300;color:#707070}", ""]);

// exports


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v(_vm._s(_vm.$t("msg.voting_survey")))]),_vm._v(" "),(_vm.step == 1)?_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body_modal"},[(_vm.step == 1)?_c('div',[_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_1")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v(_vm._s(_vm.$t("msg.how_vote")))]),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v(_vm._s(_vm.$t("msg.voting_info_3")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m25_t",on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.click_here_to_vote"))+"\n          ")])])])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',[_c('p',{staticClass:"tal_c fat text_purple fs_small"},[_vm._v("\n        *"+_vm._s(_vm.$t("msg.chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns tal_c p0"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column coins_cont",class:_vm.checkedCoins[0] == coin.symbol || _vm.checkedCoins[1] == coin.symbol
              ? 'selected_coin'
              : '',on:{"click":function($event){return _vm.getInfo(coin.symbol)}}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',[_c('div',{staticClass:"background_ icon_class_symbol",class:'background_' + coin.symbol,style:('height:40px; width:40px;')})])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(coin.symbol.toUpperCase()))])])]),_vm._v(" "),_c('div',{staticClass:"column p0 m0 fs_small fat",class:coin.percent > 0 ? 'green' : 'red_color'},[_vm._v("\n            *"+_vm._s(coin.percent)+"% YTD\n          ")])])}),0),_vm._v(" "),_c('div',{staticClass:"column fs_small tal_c m0 m20_b text_info"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.please_chose_two_coins"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns"},_vm._l((_vm.coins),function(coin){return _c('div',{key:coin.symbol,staticClass:"column content_info text_info"},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(coin.name))]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"10px","margin-bottom":"10px"}},[_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.sector"))+":")]),_vm._v("\n            "+_vm._s(_vm.$t(("msg." + (coin.sector))))+" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.token_type"))+":")]),_vm._v("\n            "+_vm._s(_vm.$t(("msg." + (coin.tokenType))))),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"500"}},[_vm._v(_vm._s(_vm.$t("msg.staking_rewards"))+":")]),_vm._v("\n            "+_vm._s(_vm.$t(("msg." + (coin.rewards))))+"\n          ")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(("msg.coin_voting_" + (coin.symbol))))}})])}),0),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat",attrs:{"disabled":_vm.checkedCoins.length != 2 || _vm.buttonBlock},on:{"click":function($event){return _vm.postVote()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.finish_Vote"))+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBluePool_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b4d10e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBluePool_vue__ = __webpack_require__(800);
function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBluePool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b4d10e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBluePool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(799);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3043c96b", content, true, {});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#modal_voting{background-color:#fff;margin-top:5vh;width:100%;max-width:1100px;min-height:710px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:20px;font-size:1.2em}#modal_voting .button-slips{background-color:#1e2067;padding:10px 30px;font-size:15px;color:#fff;border:none;border-radius:10px;margin-top:20px;cursor:pointer}#modal_voting .button-slips:active{background-color:#6146ad}#modal_voting .button-slips:disabled{opacity:.5;cursor:not-allowed}#modal_voting .coins_cont{box-shadow:0 2px 4px #041a381a;margin-right:10px;border-radius:21px;border:2px solid transparent;margin-bottom:10px;cursor:pointer}#modal_voting .coins_cont:last-child{margin-right:0}#modal_voting .coins_cont:active{background:#8a65f1}#modal_voting .selected_coin{background:#fff 0 0 no-repeat padding-box;box-shadow:0 20px 40px #041a384d;border:2px solid #c9d1ff;border-radius:21px;opacity:1}#modal_voting .coin_info{background:#f3f3f3;border-radius:3px;min-height:76.95px}#modal_voting .actived_info{background-color:#c5c0c0}#modal_voting .icon_class_symbol svg{width:40px;height:40px}#modal_voting .cont_name{min-height:82px}#modal_voting .green{color:#00b593}#modal_voting .red_color{color:#db1f43}#modal_voting .header_modal{background:#0966aa;color:#fff;min-height:55px;border-radius:7px 7px 0 0;display:flex;justify-content:center;align-items:center}#modal_voting .body_modal{padding:20px 60px}#modal_voting .content_info{border-left:1px solid #d0d4d9;font-size:13px}#modal_voting .content_info:first-child{border-left:none}#modal_voting .text_info{font-weight:100;color:#707070}#modal_voting .w30{width:18%}", ""]);

// exports


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modal_voting"}},[_c('div',{staticClass:"header_modal fs_big tal_c"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.modalNetwork.title"))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"tal_c fat text_purple fs_big m13_t"},[_vm._v("\n    "+_vm._s(_vm.$t("msg.dear_blu_holder"))+",\n  ")]),_vm._v(" "),_c('div',{staticClass:"body_modal"},[_c('div',[_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBluePool.text_one'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBluePool.title_one'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBluePool.text_two'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalBluePool.title_two"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small",domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBluePool.text_three'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l fs_small text_purple fat"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalBluePool.title_four"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.modalBluePool.text_four"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.contact_us_any_question"))+"\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"tal_l text_grey fs_small"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.blue_team"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"columns tal_c"},[(!_vm.loading)?_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t",on:{"click":function($event){return _vm.closeModalNetwork()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.continue"))+"\n          ")])]):_c('div',{staticClass:"column"},[_c('button',{staticClass:"button-slips fat m13_t"},[_c('Loading')],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.termsCheck
      ? 'scroll-hidden'
      : '' || (_vm.activedVolting && _vm.needVoting)
      ? 'scroll-hidden'
      : '',attrs:{"id":"main"}},[(_vm.activedVolting && _vm.needVoting)?_c('div',{staticClass:"backgorund_modal"},[_c('modalVotingFourteenVue',{on:{"getVotingStatus":function($event){return _vm.getVotingStatus()}}})],1):_vm._e(),_vm._v(" "),(_vm.privacyCheck)?_c('div',{staticClass:"backgorund_modal"},[_c('modal-privacy-policy',{on:{"closeModal":function($event){return _vm.checkMember()}}})],1):_vm._e(),_vm._v(" "),(_vm.termsCheck)?_c('div',{staticClass:"backgorund_modal"},[_c('modal-terms-conditions',{on:{"closeModal":function($event){return _vm.checkMember()}}})],1):_vm._e(),_vm._v(" "),(_vm.modalNotificationBlueClub && _vm.needVotingBlueClub)?_c('div',{staticClass:"backgorund_modal"},[_c('modalNetworkDist',{attrs:{"networkId":_vm.networkId},on:{"closeModalNetwork":_vm.postNotificationConfirm}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form_bg",class:{ form_showing: _vm.modal }},[_c('div',{staticClass:"form_outside",on:{"click":_vm.toggleModal}}),_vm._v(" "),_c('div',{staticClass:"contact_form"},[_c('div',{staticClass:"contact_form_body"},[_c('div',{staticClass:"column contact_form_header tal_c"},[_c('h1',{staticClass:"text_lg"},[_c('span',{staticClass:"form_title"},[_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.email)}}),_vm._v("\n              "+_vm._s(_vm.$tc("msg.contact", 1))+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"form_close",on:{"click":_vm.toggleModal}},[_vm._v("X")])])]),_vm._v(" "),_c('div',{staticClass:"contact_form_body_body"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"text_sm"},[_vm._v(_vm._s(_vm.$tc("msg.contact_intro", 1))+".")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',{staticClass:"capitalize text_sm"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("msg.name", 1)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),(_vm.member)?_c('div',{staticClass:"column"},[_c('label',{staticClass:"capitalize text_sm"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("msg.email", 1))+"*")])]),_vm._v(" "),_c('input',{attrs:{"disabled":""},domProps:{"value":_vm.member.email}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',{staticClass:"capitalize text_sm"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("msg.subject", 1))+"*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.subject),expression:"user.subject"}],attrs:{"required":""},domProps:{"value":(_vm.user.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "subject", $event.target.value)}}}),_vm._v(" "),(_vm.user.subject.length < _vm.minLengthSubject)?_c('p',{staticClass:"form_warning"},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.min_length", 1))+" "+_vm._s(_vm.minLengthSubject)+"\n              "+_vm._s(_vm.$tc("msg.characters"))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('label',{staticClass:"capitalize text_sm"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("msg.message", 1))+"*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.message),expression:"user.message"}],attrs:{"required":""},domProps:{"value":(_vm.user.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "message", $event.target.value)}}}),_vm._v(" "),(_vm.user.message.length < _vm.minLengthMessage)?_c('p',{staticClass:"form_warning"},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.min_length", 1))+" "+_vm._s(_vm.minLengthMessage)+"\n              "+_vm._s(_vm.$tc("msg.characters"))+"\n            ")]):_vm._e()]),_vm._v(" "),(_vm.user)?_c('div',{staticClass:"column"},[_c('button',{staticClass:"upper",attrs:{"disabled":_vm.user.message.length < _vm.minLengthMessage ||
                  _vm.user.subject.length < _vm.minLengthSubject},on:{"click":function($event){return _vm.postEmail()}}},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.send", 1))+"\n            ")])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"tal_c column"},[_c('span',{staticClass:"text_sm"},[_vm._v(_vm._s(_vm.$tc("msg.email_to_registered", 1))+".")])])])])])]),_vm._v(" "),_c('base-header',{on:{"showModal":_vm.toggleModal}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('base-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing2_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf3358a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing2_vue__ = __webpack_require__(911);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf3358a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingBalance2_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6d43da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingBalance2_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingBalance2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6d43da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingBalance2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(805);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("982538f2", content, true, {});

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".btn-clain{background:#cb36ee;padding:10px;color:#fff;border-radius:10px;text-align:center;cursor:pointer}.btn-clain:active{opacity:.5}", ""]);

// exports


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(807);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6ab9fd07", content, true, {});

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".lds-ring,.lds-ring div{width:80px;height:80px}.lds-ring div{box-sizing:border-box;display:block;position:absolute;border:4px solid #424b7d!important;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#424b7d transparent transparent!important}.lds-ring div:first-child{animation-delay:-.45s}.lds-ring div:nth-child(2){animation-delay:-.3s}.lds-ring div:nth-child(3){animation-delay:-.15s}@keyframes lds-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","height":"50%","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-top":"20px"}},[_c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',{staticClass:"card-boder-bg"},[(_vm.balanceBlu)?_c('div',{staticClass:"balance_basket"},[_c('div',{staticClass:"wrapper_balance",staticStyle:{"border-radius":"0"}},[_c('div',{staticClass:"balance_title",staticStyle:{"border-radius":"0"}},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.my_balance")))]),_vm._v(" "),(_vm.showBalance)?_c('img',{attrs:{"src":__webpack_require__(230),"alt":"eye-show"},on:{"click":function($event){_vm.showBalance = false}}}):_c('img',{attrs:{"src":__webpack_require__(231),"alt":"eye-hidden"},on:{"click":function($event){_vm.showBalance = true}}})]),_vm._v(" "),_c('div',[(_vm.showBalance)?_c('div',{staticClass:"balance_value"},[_c('div',{staticClass:"my_balance_content"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("decimalsCrypto")(_vm.balanceBlu.balance,6))+" BLUE")])])]):_vm._e(),_vm._v(" "),(_vm.showBalance && _vm.usdtAccount)?_c('div',{staticClass:"balance_value",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"my_balance_content"},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("decimalsCrypto")(_vm.usdtAccount.balance,2))+" USDT")])])]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"wrapper_balance"},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.my_total_value")))]),_vm._v(" "),_c('div',{staticClass:"my_balance_content",staticStyle:{"justify-content":"end","width":"auto"}},[(_vm.showBalance)?_c('div',{staticClass:"balance_value"},[_c('div',{staticClass:"my_balance_content"},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":""}}),_vm._v(" "),(_vm.usdtAccount)?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(
                  _vm.bluAccount.balance * _vm.bluValue[0].value +
                    _vm.usdtAccount.balance,
                  "USDT"
                ))+"\n              USDT")]):_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.bluAccount.balance * _vm.bluValue[0].value, "USDT"))+"\n              USDT")])]),_vm._v(" "),_c('p',{staticClass:"other_currencies",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.view_other_currencies"))+"\n          ")])]):_vm._e()])])]):_c('div',{staticClass:"component_card combo_1 balance_basket"},[_c('loading')],1)]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"balance"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_c('div',{staticStyle:{"display":"flex"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.my_balance"))+"\n        "),(_vm.showBalance)?_c('img',{staticClass:"eye_balance",attrs:{"src":__webpack_require__(230),"alt":"eye-show"},on:{"click":function($event){_vm.showBalance = false}}}):_c('img',{staticClass:"eye_balance",attrs:{"src":__webpack_require__(231),"alt":"eye-hidden"},on:{"click":function($event){_vm.showBalance = true}}})]),_vm._v(" "),(_vm.showBalance)?_c('div',{staticClass:"tab_balance"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("decimalsCrypto")(_vm.balanceBlu.balance,6))+" BLUE")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[(_vm.usdtValue[0])?_c('div',{staticClass:"balance_basket"},[_c('div',{staticClass:"wrapper_balance"},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.my_total_value")))]),_vm._v(" "),_c('div',{staticClass:"my_balance_content",staticStyle:{"justify-content":"end","width":"auto"}},[(_vm.showBalance)?_c('div',{staticClass:"balance_value"},[_c('div',{staticClass:"my_balance_content"},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currencyFormat(
                      _vm.bluAccount.balance * _vm.bluValue[0].value,
                      "USDT"
                    ))+"\n                  USDT")])]),_vm._v(" "),_c('p',{staticClass:"other_currencies",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v("\n                "+_vm._s(_vm.$t("msg.view_other_currencies"))+"\n              ")])]):_vm._e()]),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"wrapper_balance",staticStyle:{"margin-top":"15px"}},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.blue_club_status")))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[(!(_vm.blueClubInfo.amount >= 20) && !_vm.blueClubInfo.asGift)?_c('div',{staticClass:"column qualification_status"},[_c('div',{staticClass:"wrapper_bar"},[_c('div',{staticClass:"bar"},[_c('div',{staticClass:"coin_bar m13_t"},[_c('span',{staticClass:"coin_bar_filled",style:({
                    width: [
                      ((_vm.blueClubInfo.amount / 20) * 100).toFixed(2) + '%' ],
                  })})])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","font-size":"0.7rem"}},[_c('div',{staticClass:"blue_image"},[_c('p',[_vm._v(_vm._s((_vm.blueClubInfo.amount).toFixed(2))+" BLUE")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"left_to_qualification"},[_vm._v("\n                "+_vm._s(_vm.$tc("msg.need_to_qualify", 1))+"\n                "+_vm._s((20 - _vm.blueClubInfo.amount).toFixed(2))+" BLUE\n                "+_vm._s(_vm.$tc("msg.to_qualify", 1))+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"other_currencies",staticStyle:{"text-align":"right"},on:{"click":function($event){return _vm.toggleModalBlueClub()}}},[_vm._v("\n                "+_vm._s(_vm.$t("msg.member_benefits"))+"\n              ")])])])]):_vm._e(),_vm._v(" "),(_vm.blueClubInfo.amount >= 20 && _vm.blueClubInfo.staus == 'new')?_c('div',[_c('div',{staticClass:"btn-clain",on:{"click":function($event){return _vm.toggleModalClainBlueClub()}}},[_vm._v("\n            "+_vm._s(_vm.$t('msg.clain_your_nft'))+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"other_currencies",staticStyle:{"text-align":"right","margin-top":"10px"},on:{"click":function($event){return _vm.toggleModalBlueClub()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.member_benefits"))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.blueClubInfo.amount >= 20 && _vm.blueClubInfo.staus == 'waiting')?_c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"color":"#cb36ee"}},[_vm._v(_vm._s(_vm.$t("msg.minting"))+" NFT")]),_vm._v(" "),_c('img',{staticStyle:{"width":"20px","margin-left":"10px"},attrs:{"src":__webpack_require__(810),"alt":"clock"}})]),_vm._v(" "),_c('p',{staticClass:"other_currencies",staticStyle:{"text-align":"right","margin-top":"10px"},on:{"click":function($event){return _vm.toggleModalBlueClub()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.member_benefits"))+"\n          ")])]):_vm._e(),_vm._v(" "),((_vm.blueClubInfo.amount >= 20 && _vm.blueClubInfo.staus == 'done') || _vm.blueClubInfo.asGift)?_c('div',[_c('div',{staticClass:"btn-clain",on:{"click":function($event){return _vm.openSolonaNFT()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.my"))+" NFT\n          ")]),_vm._v(" "),_c('p',{staticClass:"other_currencies",staticStyle:{"text-align":"right","margin-top":"10px"},on:{"click":function($event){return _vm.toggleModalBlueClub()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.member_benefits"))+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div')])]):_c('div',{staticClass:"component_card combo_1 balance_basket"},[_c('loading')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "clock.svg?99c8deecfe8d39b6b79ca694eb85047f";

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodaysMarket_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44c14a8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodaysMarket_vue__ = __webpack_require__(821);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TodaysMarket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44c14a8c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodaysMarket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 812 */,
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":"mainChartBlu"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":"mainChartBlu"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(816);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("7a3fac3a", content, true, {});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "canvas{max-width:100%}", ""]);

// exports


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.chart)?_c('div',{staticClass:"column loading_block"},[_c('p',[_c('span',{attrs:{"id":"animateLoading"}}),_vm._v("\n      "+_vm._s(_vm.$t("msg.loading"))+"...\n    ")])]):_c('canvas',{staticClass:"miniChart",attrs:{"id":'mainChartBlu' + _vm.chartId}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineMini_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95fd040e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineMini_vue__ = __webpack_require__(819);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartLineMini_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95fd040e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartLineMini_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini_chart",attrs:{"id":'mini_chart_'  + _vm.chartId}},[(!_vm.chart)?_c('div',{staticClass:"column"},[_c('p',[_c('span',{attrs:{"id":"animateLoading"}}),_vm._v("\n      "+_vm._s(_vm.$t('msg.loading'))+"...\n    ")])]):_c('div',{staticClass:"column p10 flex_contant_center h_s"},[_c('canvas',{attrs:{"id":'mainChartBlu'+_vm.chartId}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing_portfolio",attrs:{"id":"portifolio_list"}},[_c('div',{staticClass:"columns is-mobile landing_portfolio_header border_b_2"},[_c('div',{staticClass:"column tal_l fat landing_portfolio_title",staticStyle:{"font-size":"1rem"}},[_c('p',[_vm._v(_vm._s(_vm.$tc("msg.component")))])]),_vm._v(" "),_c('div',{staticClass:"column tal_r fat landing_portfolio_title",staticStyle:{"font-size":"1rem"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.change"))+" (24h)")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column tal_r fat landing_portfolio_title",staticStyle:{"font-size":"1rem"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.price"))+" | USDT")])])]),_vm._v(" "),_vm._l((_vm.assetList),function(coin,index){return (coin.assignedOverallWeight > 0)?_c('div',{key:index,staticClass:"is-mobile landing_portfolio_body custom_flex_block border_b_1 m_text_sm",staticStyle:{"padding":"0 !important"}},[_c('div',{staticClass:"column landing_portfolio_item",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"custom_flex_block"},[_c('div',{staticClass:"block_1"},[_c('div',{staticClass:"landing_portfolio_icon background_",class:'background_' + coin.currency.symbol})]),_vm._v(" "),(!_vm.isMobile)?_c('p',{staticClass:"dis_inb is-one-quarter"},[_c('span',{staticStyle:{"font-size":"1.2rem"}},[_vm._v(_vm._s(coin.currency.name == "TrueUSD" ? "USDT" : coin.currency.name))])]):_c('p',{staticClass:"dis_inb is-one-quarter"},[_c('span',{staticStyle:{"font-size":"1.2rem"}},[_vm._v(_vm._s(coin.currency.name == "TrueUSD" ? "USDT" : coin.currency.name))])])])]),_vm._v(" "),_c('div',{staticClass:"column tal_c landing_portfolio_item"},[_c('div',[(coin.currency.symbol !== 'OTC')?_c('p',{class:{
            percent_positive:
              _vm.getPercentChangeBySymbol(coin.currency.symbol) >= 0,
            percent_negative:
              _vm.getPercentChangeBySymbol(coin.currency.symbol) < 0,
          }},[(_vm.getPercentChangeBySymbol(coin.currency.symbol))?_c('span',{staticStyle:{"font-size":"1.2rem"}},[_vm._v(_vm._s(_vm.getPercentChangeBySymbol(coin.currency.symbol))+"%")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column p0 tal_c val_m m5_t m_hidden"},[_c('div',{staticClass:"column p0"},[(coin.currency.symbol !== 'OTC')?_c('div',{staticClass:"custom_flex_block justify_content_between"},[_c('div',[_c('chart-line-mini',{attrs:{"coin":coin.currency.symbol}})],1)]):_c('div',[_c('div',{staticStyle:{"height":"100px"}})])])]),_vm._v(" "),_c('div',{staticClass:"column is-one-fifth tal_r landing_portfolio_item"},[_c('div',[_c('p',{staticStyle:{"font-size":"1.2rem"}},[_vm._v("\n          "+_vm._s(_vm.currencyFormat(_vm.getPriceBySymb(coin.currency.symbol)))+"\n        ")])])])]):_vm._e()})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column tal_c m_hidden fat landing_portfolio_title",staticStyle:{"font-size":"1rem"}},[_c('p',[_vm._v("7d Graph")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('div',{staticStyle:{"padding":"1rem"}},[_c('div',{staticClass:"wrapper_market"},[_c('div',{staticClass:"todays_market"},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.todays_market")))]),_vm._v(" "),_c('div',{staticClass:"blue_valuation"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":""}}),_vm._v(" "),(_vm.chartsDay.data)?_c('p',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v("\n            "+_vm._s(_vm.getPercentChangeDay())+"\n          ")]):_vm._e()])]),_vm._v(" "),(_vm.bluValue)?_c('div',{staticClass:"wrapper_live_price_market"},[_c('div',{staticClass:"live_price_market"},[_c('div',{staticClass:"live_price"},[_c('button'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.live_price")))])]),_vm._v(" "),_c('div',{staticClass:"live_price_usdt"},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currencyFormat(_vm.bluValue[0].value))+" USDT")])])]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v(_vm._s(_vm.$t("msg.view_other_currencies")))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('chart-line-custom',{attrs:{"chartData":_vm.chartParams,"bluValue":_vm.bluValue[0]},on:{"chartLoaded":function($event){return _vm.setChartLoading(false)},"chartLoading":function($event){return _vm.setChartLoading(true)}}})],1),_vm._v(" "),(_vm.state == 'list' && _vm.assetList)?_c('landing-portfolio-list',{attrs:{"assetList":_vm.assetList}}):_vm._e()],1)]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"todays_market"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_c('div',{staticClass:"todays_market"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.todays_market"))+"\n        "),_c('div',{staticClass:"blue_valuation"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":""}}),_vm._v(" "),(_vm.chartsDay.data)?_c('p',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v("\n            "+_vm._s(_vm.getPercentChangeDay())+"\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"wrapper_market"},[_c('div',{staticClass:"wrapper_live_price_market"},[_c('div',{staticClass:"live_price_market"},[_c('div',{staticClass:"live_price"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.live_price")))]),_vm._v(" "),_c('button')]),_vm._v(" "),_c('div',{staticClass:"live_price_usdt"},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currencyFormat(_vm.bluValue[0].value))+" USDT")])])]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v(_vm._s(_vm.$t("msg.view_other_currencies")))])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('chart-line-custom',{attrs:{"chartData":_vm.chartParams,"bluValue":_vm.bluValue[0]},on:{"chartLoaded":function($event){return _vm.setChartLoading(false)},"chartLoading":function($event){return _vm.setChartLoading(true)}}}),_vm._v(" "),(_vm.state == 'list' && _vm.assetList)?_c('landing-portfolio-list',{attrs:{"assetList":_vm.assetList}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingBuyRedeem_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca903fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingBuyRedeem_vue__ = __webpack_require__(846);
function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingBuyRedeem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca903fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingBuyRedeem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("2a043082", content, true, {});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBuyBlu_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b643af0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBuyBlu_vue__ = __webpack_require__(845);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBuyBlu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b643af0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBuyBlu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBuyBluBuy_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a600473_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBuyBluBuy_vue__ = __webpack_require__(837);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBuyBluBuy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a600473_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBuyBluBuy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6ab14a62", content, true, {});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".lds-ring,.lds-ring div{width:80px;height:80px}.lds-ring div{box-sizing:border-box;display:block;position:absolute;border:4px solid #fff;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#fff transparent transparent!important}.lds-ring div:first-child{animation-delay:-.45s}.lds-ring div:nth-child(2){animation-delay:-.3s}.lds-ring div:nth-child(3){animation-delay:-.15s}@keyframes lds-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","background":"#424b7d","height":"100%","border-radius":"8px 8px 8px 8px","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin":"5px 0","font-size":"1.2rem"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t('msg.checking_open_orders'))+"...")])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","margin":"15px 0"}},[_c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBuyBluePIX_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b59ef0d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBuyBluePIX_vue__ = __webpack_require__(833);
function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBuyBluePIX_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b59ef0d4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBuyBluePIX_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("2dfbf42c", content, true, {});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:fixed;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.loadingspinner{padding:1rem 0;pointer-events:none;width:3rem;height:3rem;border:.3rem solid transparent;border-color:#eee;border-top-color:#342365;border-radius:50%;animation:loadingspin 1s linear infinite}.wrapper_modal{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal .content{position:relative;border-bottom-right-radius:6px;border-bottom-left-radius:6px;border-top-right-radius:10px;border-top-left-radius:10px;max-width:485px;max-height:765px;width:100%;background-color:#fff}.wrapper_modal .content .title_buy_pix{background:#342365;border-top-right-radius:6px;border-top-left-radius:6px;padding:1rem 1.5rem;text-align:start;font-size:1.5rem;margin-bottom:0}.wrapper_modal .content .x_icon{position:absolute;top:1.2rem;width:1.2rem;right:1rem;cursor:pointer}.wrapper_modal .content .x_icon:hover{opacity:.7}.wrapper_modal .content .connecting{display:flex;align-items:center;justify-content:center;flex-direction:column;padding:1.5rem 0;width:100%;max-width:400px;margin:auto}.wrapper_modal .content .connecting p{color:#342365;font-size:1.4rem;font-weight:600;margin-bottom:0}.wrapper_modal .content .connecting .connecting_content{position:relative;display:flex;align-items:center;justify-content:space-evenly;width:100%;margin-top:1rem}.wrapper_modal .content .connecting .connecting_content img{width:3rem}.wrapper_modal .content .connecting .connecting_content img:last-child{width:6rem}.wrapper_modal .content .connecting .connecting_content .b{display:inline-block;position:relative;width:80px;height:80px}.wrapper_modal .content .connecting .connecting_content .b div{position:absolute;top:33px;width:10px;height:10px;border-radius:50%;background:#342365;animation-timing-function:cubic-bezier(0,1,1,0)}.wrapper_modal .content .connecting .connecting_content .b div:first-child{left:8px;animation:b1 .6s infinite}.wrapper_modal .content .connecting .connecting_content .b div:nth-child(2){left:8px;animation:b2 .6s infinite}.wrapper_modal .content .connecting .connecting_content .b div:nth-child(3){left:32px;animation:b2 .6s infinite}.wrapper_modal .content .connecting .connecting_content .b div:nth-child(4){left:56px;animation:b3 .6s infinite}@keyframes b1{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes b3{0%{transform:scale(1)}to{transform:scale(0)}}@keyframes b2{0%{transform:translate(0)}to{transform:translate(24px)}}.wrapper_modal .content .connecting .connecting_warning{display:flex;flex-direction:column;align-items:flex-start}.wrapper_modal .content .connecting .connecting_warning span{margin-top:1rem;color:#000}.wrapper_modal .content .swapix{flex-direction:column;padding:1rem;width:100%;max-width:400px;margin:auto}.wrapper_modal .content .swapix,.wrapper_modal .content .swapix .welcome_swapix{display:flex;align-items:center;justify-content:center}.wrapper_modal .content .swapix .welcome_swapix p{color:#342365;font-size:1.4rem;font-weight:600;margin-bottom:0;margin-right:8px}.wrapper_modal .content .swapix .welcome_swapix img{width:6rem}.wrapper_modal .content .swapix .content_swapix{display:flex;justify-content:start;flex-direction:column}.wrapper_modal .content .swapix .swapix_a{display:flex;align-items:center;justify-content:center;flex-direction:column;padding:1rem}.wrapper_modal .content .swapix .swapix_a p{color:#000;margin-bottom:0}.wrapper_modal .content .swapix .swapix_a span{color:#342365;margin-top:1rem}.wrapper_modal .content .swapix .swapix_a .total{margin-top:1rem;font-size:1.1rem}.wrapper_modal .content .swapix .swapix_a .total_in_BRL{font-weight:600;margin-top:0;font-size:1.1rem}.wrapper_modal .content .swapix .swapix_a .qrcode{width:9rem;color:#000;margin-top:1rem}.wrapper_modal .content .swapix .swapix_a .pix_ID{margin-top:0;font-weight:600}.wrapper_modal .content .swapix .swapix_a .loading{color:#000;width:1.5rem;margin:1rem 0}.wrapper_modal .content .swapix .swapix_a .waiting_deposit{text-align:center;font-size:1.1rem}.wrapper_modal .content .swapix .swapix_b{display:flex;align-items:center;justify-content:center;flex-direction:column;padding:1rem}.wrapper_modal .content .swapix .swapix_b p{color:#000;margin-bottom:0}.wrapper_modal .content .swapix .swapix_b .payment_being_processed{display:flex;align-items:center;justify-content:space-around;width:100%;margin:1rem 0}.wrapper_modal .content .swapix .swapix_b .payment_being_processed .swapix_b_arrow{color:#342365;width:2.5rem}.wrapper_modal .content .swapix .swapix_b .payment_being_processed .processed_coin{width:3.5rem}.wrapper_modal .content .swapix .swapix_b .loadingspinner{padding:1rem 0;pointer-events:none;width:3rem;height:3rem;border:.3rem solid transparent;border-color:#eee;border-top-color:#342365;border-radius:50%;animation:loadingspin 1s linear infinite}@keyframes loadingspin{to{transform:rotate(1turn)}}.wrapper_modal .content .swapix .swapix_c{display:flex;align-items:center;justify-content:center;flex-direction:column;padding:1rem}.wrapper_modal .content .swapix .swapix_c p{color:#000;margin-bottom:0}.wrapper_modal .content .swapix .swapix_c button{margin-top:1.5rem;padding:8px 25px;color:#fff;background:#342365;cursor:pointer;border-radius:4px;font-weight:600;font-size:1rem;transition:all .2s ease-in-out}.wrapper_modal .content .swapix .swapix_c button:hover{background:rgba(52,35,101,.95)}@media only screen and (max-width:900px){.wrapper_modal .content{padding:2rem 1.5rem;max-width:350px}}@media only screen and (max-width:350px){.wrapper_modal .content{max-width:300px}}", ""]);

// exports


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask"},[_c('div',{staticClass:"wrapper_modal"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title_buy_pix"},[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.buy_blue")))]),_vm._v(" "),_c('svg',{staticClass:"x_icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalBuyBluePIX()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),(_vm.step == 1)?_c('div',{staticClass:"connecting"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.connecting_swapix")))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"connecting_warning"},[_c('span',[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.only_accepts")))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.pix_purcase_processed")))])]),_vm._v(" "),_c('div',{staticClass:"mw100 combo_0",staticStyle:{"display":"flex","align-items":"center","padding":"10px","margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirTerms),expression:"confirTerms"}],staticStyle:{"width":"15px","height":"15px","margin-right":"5px","color":"#342365"},attrs:{"type":"checkbox","id":"confirTerms","value":"confirTerms"},domProps:{"checked":Array.isArray(_vm.confirTerms)?_vm._i(_vm.confirTerms,"confirTerms")>-1:(_vm.confirTerms)},on:{"change":function($event){var $$a=_vm.confirTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="confirTerms",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.confirTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.confirTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.confirTerms=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"for":"confirTerms"}},[_c('p',{staticClass:"tal_c fs_00r",staticStyle:{"display":"flex","font-size":"12px !important"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBuyBluePix.swapix_terms'))}})])]),_vm._v(" "),(_vm.confirTerms)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticStyle:{"background":"#342365","padding":"5px 15px 5px 15px","border-radius":"10px","cursor":"pointer"},on:{"click":function($event){return _vm.next()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalBuyBluePix.btn_next"))+"\n          ")])]):_vm._e(),_vm._v(" "),(!_vm.confirTerms)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('div',{staticStyle:{"background":"grey","padding":"5px 15px 5px 15px","border-radius":"10px","cursor":"not-allowed"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalBuyBluePix.btn_next"))+"\n          ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.step == 2 || _vm.step == 3)?_c('div',{staticClass:"swapix"},[(_vm.step == 2)?_c('div',{staticClass:"swapix_b"},[_c('div',{staticClass:"welcome_swapix"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.welcome")))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(382),"alt":"swapix"}})]),_vm._v(" "),_c('div',{staticClass:"content_swapix",staticStyle:{"padding-bottom":"1rem"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.payment_being_processed")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.modalBuyBluePix.wait")))])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"payment_being_processed"},[_vm._m(2),_vm._v(" "),_c('svg',{staticClass:"swapix_b_arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","strokeWidth":"{2}"}},[_c('path',{attrs:{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 8l4 4m0 0l-4 4m4-4H3"}})]),_vm._v(" "),_c('img',{staticClass:"processed_coin",attrs:{"src":__webpack_require__(29),"alt":"USDT icon","title":"USDT"}}),_vm._v(" "),_c('svg',{staticClass:"swapix_b_arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","strokeWidth":"{2}"}},[_c('path',{attrs:{"strokeLinecap":"round","strokeLinejoin":"round","d":"M17 8l4 4m0 0l-4 4m4-4H3"}})]),_vm._v(" "),_c('img',{staticClass:"processed_coin",attrs:{"src":__webpack_require__(11),"alt":"BLUE icon","title":"BLUE"}})])]):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('div',{staticClass:"swapix_a"},[_c('div',{staticClass:"content_swapix"},[_c('p',[_vm._v("\n              "+_vm._s(_vm.$t("msg.modalBuyBluePix.payment"))+":\n              "+_vm._s(_vm.amountToSend.toFixed(2))+" USDT\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t("msg.modalBuyBluePix.convert_price"))+":\n              "+_vm._s(_vm.pixData.convertedPrice.toFixed(2))+"\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t("msg.value"))+": R$ "+_vm._s(_vm.pixData.amountBrl.toFixed(2))+"\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              SWAPiX "+_vm._s(_vm.$tc("msg.fee", 1))+" (R$2 + 2.04%): R$\n              "+_vm._s(_vm.pixData.feeBrl.toFixed(2))+"\n            ")]),_vm._v(" "),_c('span',{staticClass:"total_in_BRL"},[_vm._v(_vm._s(_vm.$t("msg.total_to_pay"))+": R$\n              "+_vm._s(_vm.pixData.totalBrl.toFixed(2)))])]),_vm._v(" "),_c('qrcode',{attrs:{"value":_vm.pixData.emv,"options":{ width: 200 }}}),_vm._v(" "),_c('p',{staticClass:"p"},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.pixData.emv),expression:"pixData.emv",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",attrs:{"type":"button"}},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.copy", 1))+"\n            ")])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',{staticClass:"waiting_deposit"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.waiting_deposit"))+" "),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t("msg.expire_in"))+"\n            "+_vm._s(_vm.formatDate(_vm.dateEnd))+" "),_c('br')]),_vm._v(" "),_c('p',{staticStyle:{"padding":"0.5rem 0","color":"#342365"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.average_time"))+"\n          ")])],1):_vm._e()]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connecting_content"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue icon"}}),_vm._v(" "),_c('div',{staticClass:"b"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(382),"alt":"swapix"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"1rem 0"}},[_c('div',{staticClass:"loadingspinner"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"3.5rem"}},[_c('span',{staticStyle:{"color":"black","font-size":"3.2rem"}},[_vm._v("R$")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"1rem 0"}},[_c('div',{staticClass:"loadingspinner"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bitcoin-buyBlue.svg?d04c52b29644d80b9069495db4da5a41";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ethereum-buyBlue.svg?5864262d9945ec716fed48babfbfaefa";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "tether-buyBlue.svg?b6a6e36d87736398650ea16022857b16";

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column landing_buy_blu_buy p0 h100",class:{ selectWay: _vm.selectWay, modalWarning: _vm.modalWarning }},[(!_vm.loading)?_c('div',{staticClass:"loading h100",staticStyle:{"color":"#4a4a4a !important"}},[_c('div',{staticClass:"column main_blue_dk_bg border-radius-8 buy-blue-header"},[_c('h1',{staticClass:"component_title_md fat border-radius-8",staticStyle:{"color":"white"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.buy_tokens"))+"\n      ")]),_vm._v(" "),(_vm.stepForm && !_vm.formFinish)?_c('h1',{staticClass:"component_title_md fat tal_c",staticStyle:{"color":"white"}},[_vm._v("\n        OTC - "+_vm._s(_vm.$t("msg.fill_form"))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.formFinish)?_c('h1',{staticClass:"component_title_md fat tal_c",staticStyle:{"color":"white"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.thank_you"))+"\n      ")]):_vm._e()]),_vm._v(" "),(
        !_vm.selectWay &&
        !_vm.modalWarning &&
        !_vm.stepForm &&
        !_vm.formFinish &&
        !_vm.stepSellerInfoUid
      )?_c('div',{staticClass:"column container_buyblue_mobile"},[_c('div',{staticClass:"column columns p10t"},[_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.beforeSendUnderTitle")))])])]),_vm._v(" "),(_vm.blockMsg)?_c('div',{staticStyle:{"color":"#de350b","text-align":"center"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.blockMsgP")))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column columns"},[_c('div',{staticClass:"column noselect",staticStyle:{"padding":"0rem !important"}},[_c('div',{staticClass:"column p0 blu_input_container",class:{
              has_error: parseFloat(_vm.bluAmount) < parseFloat(_vm.minBlue),
            }},[_c('img',{staticClass:"blu_input_img",attrs:{"src":__webpack_require__(11)}}),_vm._v(" "),_c('div',{staticClass:"blu_input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],attrs:{"placeholder":'min. ' + _vm.minBlue + ' Blu'},domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyBluAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{
                  arrow_disabled:
                    parseFloat(_vm.bluAmount) <= parseFloat(_vm.minBlue),
                },on:{"click":function($event){return _vm.modifyBluAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"text_sm tal_c",class:{
                has_error_text: parseFloat(_vm.bluAmount) < parseFloat(_vm.minBlue),
              }},[_vm._v("\n              "+_vm._s(_vm.$t("msg.amount"))+" "+_vm._s(_vm.$t("msg.min"))+": "+_vm._s(_vm.minBlue)+" BLUE\n              ("+_vm._s(_vm.getMinBluXUsdt())+" USDT)\n              "),(_vm.minBlue == 0.01)?_c('span',[_c('br'),_vm._v(" "),_c('strong',[_vm._v("( this value applies for your test account only.)")])]):_vm._e()])])])]),_vm._v(" "),(_vm.btcAccount)?_c('div',{staticClass:"column split_half_text"},[_c('div',{staticClass:"column split_half_text"},[_c('div',{staticClass:"column p0 split_half_text"},[_c('p',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"},attrs:{"id":"amount_before_fees_"}},[_c('span',{staticClass:"tal_l"},[_vm._v(_vm._s(_vm.$t("msg.subtotal"))+":")]),_vm._v(" "),_c('span',{staticClass:"tal_r"},[_vm._v(_vm._s(_vm._f("decimalsCrypto")((_vm.bluValue[0].value * _vm.bluAmount),2))+"\n                USDT")])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('p',{staticClass:"ft_small",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('span',{staticStyle:{"width":"70%"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.load_fee"))+" "),_c('br'),_vm._v("\n              ( "+_vm._s(_vm._f("percentage")(2,2))+" )")])]),_vm._v(" "),_c('span',{staticClass:"tal_r",staticStyle:{"width":"28%"}},[_vm._v(_vm._s(_vm._f("decimalsCrypto")(((_vm.bluValue[0].value * _vm.bluAmount * 2) / 100),2))+"\n            USDT")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text_xl ft_small",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',{staticClass:"val_t"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.total_to_transfer", 1)))])]),_vm._v(" "),_c('span',{staticClass:"tal_r val_sub"},[_c('b',[_vm._v(_vm._s(_vm._f("decimalsCrypto")((_vm.bluTusd =
                  (_vm.bluValue[0].value * _vm.bluAmount * 2) / 100 +
                  _vm.bluValue[0].value * _vm.bluAmount),2))+"\n              USDT")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"sub_green_lt_bg component_super_button sub_green_lt_bg_hover upper text_lg",staticStyle:{"border-radius":"10px","padding":"20px"},attrs:{"id":"pay_with_btc"},on:{"click":function($event){return _vm.blockPurchaseInfo()}}},[_vm._v("\n          "+_vm._s(_vm.$tc("msg.buy_token", 1))+"\n        ")])]),_vm._v(" "),_c('label',{staticClass:"text_sm",domProps:{"innerHTML":_vm._s(_vm.$t('msg.below_button_1'))}}),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectWay && !_vm.stepSellerInfoUid)?_c('div',{staticClass:"buy_blu_modal_select_way",staticStyle:{"height":"900px","background":"Red"}},[(_vm.paymentMode == 'crypto')?_c('div',{staticClass:"column p0"},[_c('div',{staticClass:"container_select_partners",on:{"click":function($event){return _vm.changeModalWarningState(true, 'crypto')}}},[_vm._m(2)])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.modalWarning && !_vm.stepSellerInfoUid)?_c('div',{staticClass:"buy_blu_modal_warning",staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-around"}},[_c('h1',{staticClass:"component_title_md fat tal_c fs_18r",staticStyle:{"color":"white"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.select_coin_payment"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"column custom_flex_column p0 m10_t"},[_c('div',{staticClass:"m12_t"},[_vm._l((_vm.currencyList),function(currency){return _c('div',{key:currency.symbol,staticClass:"container_coin_select_buy",class:{
              selected: _vm.selectedCurrency == currency.symbol,
              coin_disabled: !currency.isAvailable,
            },on:{"click":function($event){return _vm.selectCurrency(currency.symbol)}}},[_c('img',{staticClass:"buy_coin_icon",attrs:{"src":currency.img,"alt":"icon"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[(currency.symbol == 'USDT')?_c('div',{staticStyle:{"display":"flex","justify-items":"center","align-items":"flex-start","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","justify-items":"center","align-items":"center","justify-content":"space-between","width":"100%"}},[_c('p',{staticClass:"dis_inb capitalize fs_18r fat"},[_vm._v("\n                    "+_vm._s(currency.name)+"\n                  ")]),_vm._v(" "),(_vm.usdtAccount.balance)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_wallet_white)}}),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"10px"}},[_vm._v("\n                      "+_vm._s(_vm._f("decimalsCrypto")(_vm.usdtAccount.balance,6))+"\n                      "+_vm._s(currency.symbol)+"\n                    ")])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"dis_inb fs_small"},[_vm._v("\n                  "+_vm._s(_vm.$t("msg.tether_info"))+"\n                ")])]):_c('div',{staticStyle:{"display":"flex","justify-items":"center","align-items":"center","justify-content":"space-between"}},[_c('p',{staticClass:"dis_inb capitalize fs_18r fat"},[_vm._v("\n                  "+_vm._s(currency.name)+"\n                ")])]),_vm._v(" "),(currency.symbol == 'ETH')?_c('p',{staticClass:"dis_inb fs_small"},[_vm._v("\n                "+_vm._s(_vm.$t("msg.eth_contract_message"))+"\n              ")]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"container_coin_select_buy",on:{"click":function($event){return _vm.showModalPIX()}}},[_c('img',{staticClass:"buy_coin_icon",attrs:{"src":__webpack_require__(383),"alt":"icon"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"13px !important"}},[_c('p',{staticClass:"dis_inb capitalize fs_18r fat"},[_vm._v("\n                "+_vm._s(_vm.$t("msg.buy_pix"))+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"dis_inb fs_small"},[_vm._v("\n                "+_vm._s(_vm.$t("msg.buy_pix_info"))+"\n              ")])])]),_vm._v(" "),(_vm.modalPIX)?_c('div',[_c('modalBuyBluePIX',{attrs:{"blueAmount":_vm.bluAmount,"usdtAmount":_vm.bluTusd},on:{"toggleModalBuyBluePIX":function($event){return _vm.showModalPIX()}}})],1):_vm._e(),_vm._v(" "),(_vm.languageSelected == 'pt')?_c('div',{staticClass:"container_coin_select_buy tal_c",class:{
              selected: _vm.selectedCurrency == 'OTC',
            },on:{"click":function($event){return _vm.selectCurrency('OTC')}}},[_c('div',{staticClass:"buy_coin_icon background_"},[_c('span',{staticClass:"icon_class_3",staticStyle:{"fill":"white","color":"white"},domProps:{"innerHTML":_vm._s(_vm.iconSets.otc_user_icon)}})]),_vm._v(" "),_c('p',{staticClass:"dis_inb capitalize text_lg"},[_vm._v("OTC (Over-the-counter)")])]):_vm._e()],2)]),_vm._v(" "),_c('div',[_c('h2',{staticClass:"fs_05r fat"},[_vm._v(_vm._s(_vm.$t("msg.important"))+"!")]),_vm._v(" "),_c('div',{staticClass:"mw80 combo_0",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirTerms),expression:"confirTerms"}],staticStyle:{"width":"30px","height":"30px"},attrs:{"type":"checkbox","id":"confirTerms","value":"confirTerms"},domProps:{"checked":Array.isArray(_vm.confirTerms)?_vm._i(_vm.confirTerms,"confirTerms")>-1:(_vm.confirTerms)},on:{"change":function($event){var $$a=_vm.confirTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="confirTerms",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.confirTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.confirTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.confirTerms=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"confirTerms"}},[_c('p',{staticClass:"tal_c fs_00r"},[_vm._v(_vm._s(_vm.$t("msg.understand_and_agree")))])])]),_vm._v(" "),_c('div',{staticClass:"column custom_flex_column",staticStyle:{"padding":"40"}},[(
              (!_vm.loadingButton && _vm.selectedCurrency == 'BTC') ||
              (!_vm.loadingButton && _vm.selectedCurrency == 'ETH') ||
              (!_vm.loadingButton && _vm.selectedCurrency == 'USDT')
            )?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper fat",class:{
              disabled_btn_custon: _vm.selectedCurrency == '' || !_vm.confirTerms,
            },on:{"click":function($event){return _vm.callNextState()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.confirm"))+"\n          ")]):_vm._e(),_vm._v(" "),(!_vm.loadingButton && _vm.selectedCurrency == 'OTC')?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper fat",class:{
              disabled_btn_custon: _vm.selectedCurrency == '' || !_vm.confirTerms,
            },on:{"click":function($event){return _vm.changeStepOtc()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.confirm"))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.selectedCurrency == '')?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper disabled_btn_custon fat"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.confirm"))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.loadingButton)?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper",staticStyle:{"cursor":"not-allowed"}},[_c('Loading')],1):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.stepForm && !_vm.formFinish)?_c('div',{staticClass:"buy_blu_modal_warning"},[_c('a',{staticClass:"modal_warning_close close",on:{"click":function($event){return _vm.backReferStep()}}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"column custom_flex_column",staticStyle:{"margin-top":"5vh","padding":"0px 70px 0px 70px !important"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.otc_info")))]),_vm._v(" "),_c('div',{staticClass:"form_block flex_input_label"},[_c('label',{staticClass:"fat top_label"},[_vm._v(_vm._s(_vm.$t("msg.name")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form_white_border",attrs:{"type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_block flex_input_label"},[_c('label',{staticClass:"fat top_label"},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form_white_border",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form_block flex_input_label"},[_c('label',{staticClass:"fat top_label"},[_vm._v(_vm._s(_vm.$t("msg.phone")))]),_vm._v(" "),_c('VuePhoneNumberInput',{attrs:{"border-radius":0,"translations":{
              countrySelectorLabel: _vm.$t('msg.phone_code'),
              phoneNumberLabel: _vm.$t('msg.phone'),
            }},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('div',{staticClass:"form_block flex_input_label"},[_c('label',{staticClass:"fat top_label"},[_vm._v("BLUE "+_vm._s(_vm.$t("msg.quantity")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],staticClass:"form_white_border",domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"column custom_flex_column",staticStyle:{"margin-top":"5vh","padding":"0px 70px 0px 70px !important"}},[(!_vm.loadingButton)?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.sendEmailOtc()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.send"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.loadingButton)?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper",staticStyle:{"cursor":"not-allowed"}},[_c('Loading')],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.stepSellerInfoUid)?_c('div',{staticClass:"buy_blu_modal_warning"},[_c('div',{staticClass:"column custom_flex_column",staticStyle:{"margin-top":"5vh","padding":"0px 70px 0px 70px !important"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.seller_buy")))]),_vm._v(" "),_c('div',{staticClass:"form_block flex_input_label"},[_c('label',{staticClass:"fat top_label"},[_vm._v("UID")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uid),expression:"uid"}],staticClass:"form_white_border",staticStyle:{"width":"85%","height":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uid=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"icon_class_1",staticStyle:{"width":"15%","display":"flex","justify-content":"center","align-items":"center","height":"100%"},attrs:{"variant":"outline-primary"},on:{"click":function($event){return _vm.findMember()}}},[_c('div',{staticClass:"button is-link",staticStyle:{"color":"white"},domProps:{"innerHTML":_vm._s(_vm.iconSets.search_default)}})])])])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5vh","padding":"0px 70px 0px 70px !important"},style:(_vm.foundMember ? 'opacity:1' : 'opacity:0')},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.found_member")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.name"))+": "+_vm._s(_vm.memberFound.name))]),_vm._v(" "),_c('p',[_vm._v("E-mail: "+_vm._s(_vm.memberFound.email))])]),_vm._v(" "),_c('div',{staticClass:"column custom_flex_column",staticStyle:{"margin-top":"5vh","padding":"0px 70px 0px 70px !important"}},[(_vm.foundMember == '')?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper disabled_btn_custon fat"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.confirm"))+"\n        ")]):(!_vm.loadingButton)?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.postOtcPurchase()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.confirm"))+"\n        ")]):(_vm.loadingButton)?_c('button',{staticClass:"general_button_large sub_green_lt_bg main_white_fill text_lg upper",staticStyle:{"cursor":"not-allowed"}},[_c('Loading')],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.formFinish)?_c('div',{staticClass:"buy_blu_modal_warning"},[_c('a',{staticClass:"modal_warning_close close",on:{"click":function($event){return _vm.firstStep()}}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"column custom_flex_column",staticStyle:{"margin-top":"10vh","padding":"0px 70px 0px 70px !important","text-align":"center"}},[_c('p',{staticStyle:{"font-size":"30px"}},[_vm._v(_vm._s(_vm.$t("msg.thank_you"))+"!")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.otc_thank_msg")))])])]):_vm._e()]):_c('div',{staticStyle:{"height":"100%","border-radius":"8px 8px 8px 8px"}},[(_vm.loading)?_c('div',{staticStyle:{"height":"100%","border-radius":"8px 8px 8px 8px"}},[_c('LoadingBuyBlu')],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_border_bottom"},[_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_border_bottom"},[_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns column m0 p0"},[_c('div',{staticClass:"column p0"},[_c('img',{attrs:{"src":__webpack_require__(838)}})]),_vm._v(" "),_c('div',{staticClass:"column p0 custom-flex"},[_c('div',{staticClass:"sub_container m_auto"},[_c('img',{attrs:{"src":__webpack_require__(839)}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "buycrypto_transfer_button.svg?3d1ce608a7937eb62037d1bc33a51b98";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "crypto_icon.png?0302d2d743c3635813f935318ed68556";

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBuyBluWatch_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776d8f3d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBuyBluWatch_vue__ = __webpack_require__(844);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseBuyBluWatch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_776d8f3d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseBuyBluWatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BluWatchStep1_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20715dd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BluWatchStep1_vue__ = __webpack_require__(843);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BluWatchStep1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20715dd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BluWatchStep1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 842 */,
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0"},[(_vm.cancelOrder)?_c('div',{staticClass:"column columns component_card_border_bottom main_red_bg"},[_c('h1',{staticClass:"component_title_md fat"},[_vm._v(_vm._s(_vm.$t("msg.canceling_order")))])]):(_vm.doneOrder)?_c('div',{staticClass:"column columns component_card_border_bottom main_lgreen_bg"},[_c('h1',{staticClass:"component_title_md fat"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.success"))+"\n    ")])]):_c('div',{staticClass:"column columns component_card_border_bottom main_yellow_bg"},[_c('h1',{staticClass:"component_title_md fat main_blue_dk_fill"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.purchase_confirmation"))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"column p0"},[(!this.trade.sellerId)?_c('div',{staticClass:"column tal_c fs_big grey_ntx"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.send_exactly"))+"\n    ")]):_c('div',{staticClass:"column tal_c fs_big grey_ntx"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.otc_purchase_info_to_user"))+"\n    ")]),_vm._v(" "),(_vm.trade.sourceCurrency && !this.trade.sellerId)?_c('div',{staticClass:"column tal_c"},[(_vm.cancelOrder)?_c('p',{staticClass:"info_address fs_10r fat",staticStyle:{"color":"#61717e"}},[_vm._v("\n        "+_vm._s(_vm.currencyFormat(_vm.trade.estimatedAmount, _vm.trade.sourceCurrency.symbol))+"\n        "+_vm._s(_vm.trade.sourceCurrency.symbol)+"\n      ")]):_c('p',{staticClass:"info_address fs_10r fat"},[_vm._v("\n        "+_vm._s(_vm.currencyFormat(_vm.trade.estimatedAmount, _vm.trade.sourceCurrency.symbol))+"\n        "+_vm._s(_vm.trade.sourceCurrency.symbol)+"\n      ")])]):_vm._e(),_vm._v(" "),(!this.trade.sellerId)?_c('div',[_c('div',{staticClass:"column p0"},[_c('div',{staticClass:"column p0"},[_c('div',{staticClass:"combo_1"},[_c('div',{staticClass:"column tal_c"},[_c('div',{staticClass:"column p0 flex_contant_center"},[(this.isMobile)?_c('div',[(_vm.trade.sourceCurrency.symbol == 'USDT')?_c('span',{staticClass:"fs_0001r",staticStyle:{"font-weight":"600"}},[_vm._v("Network: TRON (TRC20)")]):_vm._e(),_vm._v(" "),(!_vm.cancelOrder)?_c('div',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.purchaseHome.targetAddress),expression:"purchaseHome.targetAddress",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"pointer",staticStyle:{"border":"solid #61717e 3px","width":"100%","heigth":"100%","border-radius":"10px"}},[_c('div',{staticStyle:{"height":"35%"}},[_c('span',{staticClass:"fs_00r"},[_vm._v(_vm._s(_vm.$t("msg.copy_address")))])]),_vm._v(" "),_c('div',{staticStyle:{"height":"65%","display":"flex","justify-content":"center","word-break":"break-all","align-items":"center"}},[(_vm.purchaseHome)?_c('span',{staticClass:"fs_03r"},[_vm._v("\n                        "+_vm._s(_vm.purchaseHome.targetAddress)+"\n                      ")]):_vm._e()])]):_vm._e()]):_c('div',{staticClass:"w90"},[_c('div',{staticStyle:{"text-align":"left"}},[_c('span',{staticClass:"fs_0001r"},[_vm._v(_vm._s(_vm.$t("msg.clicl_expand")))]),_vm._v(" "),(_vm.trade.sourceCurrency.symbol == 'USDT')?_c('span',{staticClass:"fs_0001r",staticStyle:{"margin-left":"20px","font-weight":"600"}},[_vm._v("Network: TRON (TRC20)")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"justify_content_between",style:(_vm.qrCodeDiv ? 'opacity:0' : 'opacity:1')},[_c('div',{staticClass:"pointer",staticStyle:{"border":"solid #61717e 3px","width":"17%","heigth":"100%","border-radius":"10px"},on:{"click":function($event){return _vm.qrCodeZoom()}}},[_c('span',{staticClass:"fs_00r"},[_vm._v("Scan or")]),_vm._v(" "),_c('qrcode',{style:(_vm.cancelOrder ? 'opacity: 0' : 'opacity: 1;'),attrs:{"value":_vm.purchaseHome.targetAddress,"options":{ width: 50 }}})],1),_vm._v(" "),(!_vm.cancelOrder)?_c('div',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.purchaseHome.targetAddress),expression:"purchaseHome.targetAddress",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"pointer",staticStyle:{"border":"solid #61717e 3px","width":"80%","heigth":"100%","border-radius":"10px"}},[_c('div',{staticStyle:{"height":"35%"}},[_c('span',{staticClass:"fs_00r"},[_vm._v(_vm._s(_vm.$t("msg.copy_address")))])]),_vm._v(" "),_c('div',{staticStyle:{"height":"65%","display":"flex","justify-content":"center","word-break":"break-all","align-items":"center"}},[_c('span',{staticClass:"fs_03r"},[_vm._v("\n                          "+_vm._s(_vm.purchaseHome.targetAddress)+"\n                        ")])])]):_c('div',{staticStyle:{"border":"solid #61717e 3px","width":"80%","heigth":"100%","border-radius":"10px"}},[_c('div',{staticStyle:{"height":"25%"}},[_c('span',{staticClass:"fs_00r"},[_vm._v(_vm._s(_vm.$t("msg.copy_address")))])]),_vm._v(" "),_c('div',{staticStyle:{"height":"75%","display":"flex","justify-content":"center","align-items":"center","word-break":"break-all"}},[_vm._v("\n                        --- Address unavailable ---\n                      ")])])])])])])])])])]):_vm._e()]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.qrCodeDiv)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","z-index":"10 !important"}},[_c('div',{staticClass:"qr-code effect1",staticStyle:{"background":"#FFFFFF","width":"85%","height":"400px","border-radius":"16px","margin-top":"-180px","margin-bottom":"30px","display":"flex !important","flex-direction":"column","justify-content":"center","align-items":"center","z-index":"10"}},[_c('div',{staticStyle:{"width":"80%","display":"flex","justify-content":"flex-end"}},[_c('a',{staticClass:"pointer",on:{"click":function($event){return _vm.qrCodeZoom()}}},[_vm._v(" X ")])]),_vm._v(" "),_c('div',{staticStyle:{"border":"solid #61717e 5px","width":"70%","height":"80%","border-radius":"20px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"fs_00r fs_18r"},[_vm._v("Scan the QR code")]),_vm._v(" "),_c('qrcode',{style:(_vm.cancelOrder ? 'opacity: 0' : 'opacity: 1;'),attrs:{"value":_vm.purchaseHome.targetAddress,"options":{ width: 250 }}})],1)])]):_vm._e(),_vm._v(" "),(!_vm.qrCodeDiv)?_c('div',{staticClass:"column tal_c"},[(_vm.cancelOrder)?_c('p',[_vm._v(_vm._s(_vm.$t("msg.canceling_order")))]):(_vm.doneOrder)?_c('p',[_vm._v(_vm._s(_vm.$t("msg.deposit_received")))]):_c('div',[(!this.trade.sellerId)?_c('div',{staticClass:"transaction_loading status_border"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconSets.loading)}}),_vm._v(" "),(_vm.usdtPurchase)?_c('p',[_vm._v(_vm._s(_vm.$t("msg.generating_tokens"))+"...")]):_c('p',[_vm._v(_vm._s(_vm.$t("msg.waiting_deposit"))+"...")])]):_c('div',{staticClass:"transaction_loading status_border"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconSets.loading)}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v(_vm._s(_vm.$t("msg.waiting_deposit_otc"))+"...")])])])]):_vm._e(),_vm._v(" "),(!_vm.qrCodeDiv && !this.trade.sellerId)?_c('div',{staticClass:"column",staticStyle:{"display":"flex","justify-content":"center"}},[(_vm.cancelOrder)?_c('Progress',{attrs:{"transitionDuration":0,"radius":65,"strokeWidth":13,"value":100,"strokeColor":"#EE4F50"}},[_c('div',{staticClass:"content",staticStyle:{"color":"#61717e"}},[_c('span',[_vm._v(_vm._s(_vm.$t("msg.canceling")))])])]):(_vm.doneOrder)?_c('Progress',{attrs:{"transitionDuration":0,"radius":65,"strokeWidth":13,"value":100,"strokeColor":"#3A8CEA"}},[_c('div',{staticClass:"content",staticStyle:{"color":"#61717e"}},[_c('span',[_vm._v(_vm._s(_vm.$t("msg.done")))])])]):_c('Progress',{attrs:{"transitionDuration":1000,"radius":65,"strokeWidth":14,"value":_vm.resultPercent,"strokeColor":"#4B5588"}},[_c('div',{staticClass:"content",staticStyle:{"color":"#61717e"}},[(_vm.timer.days > 0)?_c('span',[_vm._v(_vm._s(_vm.timer.days)+" "+_vm._s(_vm.$t("msg.days")))]):_vm._e(),(_vm.timer.days > 0)?_c('br'):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getHours(_vm.timer.minutes)))])])])],1):_vm._e(),_vm._v(" "),(!this.trade.sellerId)?_c('div',{staticClass:"column tal_c"},[(_vm.cancelOrder)?_c('div',{staticStyle:{"background":"#ff5050","color":"white","padding":"10px"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.attention_cancel"))+"!")])]):(_vm.doneOrder)?_c('div',{staticStyle:{"background":"#3a8cea","color":"white","padding":"10px"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.attention_done"))+"!")])]):_c('div',{staticStyle:{"background":"#e3a00a","color":"black","padding":"10px"}},[_c('p',{domProps:{"innerHTML":_vm._s(
          _vm.$t('msg.attention_waiting_days', {
            hours: _vm.getHours(_vm.complete.minutes),
          })
        )}})])]):_vm._e(),_vm._v(" "),(!this.trade.sellerId)?_c('div',{staticClass:"column tal_c m10_t"},[_c('div',{staticClass:"pointer",staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},on:{"click":function($event){_vm.details = !_vm.details}}},[_c('p',{staticClass:"capitalize",staticStyle:{"display":"flex","align-items":"center"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.transaction_details"))+"\n        "),_c('span',{staticClass:"icon_class_1",style:(_vm.details == true ? 'transform: rotate(180deg)' : ''),domProps:{"innerHTML":_vm._s(_vm.iconSets.general_arrow_down)}})])])]):_vm._e(),_vm._v(" "),(_vm.details && _vm.trade.sourceCurrency.symbol)?_c('div',{staticClass:"column"},[_c('div',{staticClass:"landing_buy_blu_transaction_details_inner"},[_c('div',{staticClass:"column p0 split_half_text"},[_c('p',{staticClass:"tal_r_b",attrs:{"id":"amount_before_fees_"}},[_c('span',{staticClass:"tal_l"},[_vm._v(_vm._s(_vm.$t("msg.status"))+":")]),_vm._v(" "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.trade.status))])])]),_vm._v(" "),_c('div',{staticClass:"column p0 split_half_text"},[_c('p',{staticClass:"tal_r_b",attrs:{"id":"amount_before_fees_"}},[(_vm.trade.status == 'done')?_c('span',{staticClass:"tal_l"},[_vm._v(_vm._s(_vm.$t("msg.received"))+" "+_vm._s(_vm.trade.sourceCurrency.symbol)+":")]):_c('span',{staticClass:"tal_l"},[_vm._v(_vm._s(_vm.$t("msg.expected_amount_in"))+"\n            "+_vm._s(_vm.trade.sourceCurrency.symbol)+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currencyFormat(
                _vm.trade.estimatedAmount,
                _vm.trade.sourceCurrency.symbol
              ))+"\n            "+_vm._s(_vm.trade.sourceCurrency.symbol))])])]),_vm._v(" "),(_vm.trade.sourceCurrency.symbol != 'BRL')?_c('div',{staticClass:"column p0 split_half_text"},[_c('p',{staticClass:"tal_r_b",attrs:{"id":"amount_before_fees_"}},[_c('span',{staticClass:"tal_l"},[_vm._v(_vm._s(_vm.$t("msg.estimated_amount_in"))+" BLUE:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getEstimatedAmount())+" BLUE")])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.details && !this.trade.sellerId)?_c('div',{staticClass:"column tal_c"},[_c('div',{staticClass:"pointer",staticStyle:{"display":"flex","justify-content":"center","align-items":"center"},on:{"click":function($event){return _vm.purchaseInformation()}}},[_c('p',{staticClass:"capitalize"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.otc_purcahse_info"))+"\n        "),_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.copy)}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column tal_c m10_t"},[(_vm.allowPurchase)?_c('button',{staticClass:"button is-success fat",staticStyle:{"width":"100%","height":"100%","padding":"20px","border-radius":"10px","margin-bottom":"20px","display":"flex","justify-content":"space-between","background":"#22c8b5 !important"},on:{"click":function($event){return _vm.callPayWithBalance()}}},[_c('div',[_vm._v(_vm._s(_vm.$t("msg.pay_with_USDT")))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","display":"flex"}},[_c('span',{staticClass:"icon_class_1",staticStyle:{"margin-right":"10px"},domProps:{"innerHTML":_vm._s(_vm.iconSets.general_wallet_white)}}),_vm._v("\n        "+_vm._s(_vm._f("decimalsCrypto")(_vm.usdtAccount.balance,6))+"\n        "+_vm._s(_vm.usdtAccount.currency.symbol)+" "),_c('br')])]):_c('button',{staticClass:"button is-success fat",staticStyle:{"width":"100%","height":"100%","padding":"20px","border-radius":"10px","margin-bottom":"10px","display":"flex","justify-content":"space-between","background":"gray !important","cursor":"not-allowed"},on:{"mouseover":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false}}},[_c('div',[_vm._v(_vm._s(_vm.$t("msg.pay_with_USDT")))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","display":"flex"}},[_c('span',{staticClass:"icon_class_1",staticStyle:{"margin-right":"10px"},domProps:{"innerHTML":_vm._s(_vm.iconSets.general_wallet_white)}}),_vm._v("\n        "+_vm._s(_vm._f("decimalsCrypto")(_vm.usdtAccount.balance,6))+"\n        "+_vm._s(_vm.usdtAccount.currency.symbol)+" "),_c('br')])]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showTooltip)?_c('div',{staticClass:"info",staticStyle:{"color":"red","font-weight":"500","margin-bottom":"20px"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.minimum_purchase_USDT'))}}):_vm._e()]),_vm._v(" "),(_vm.cancelOrder || _vm.doneOrder)?_c('button',{staticClass:"button is-info is-outlined fat",staticStyle:{"width":"100%","height":"100%","padding":"20px","border-radius":"10px"},on:{"click":function($event){return _vm.createNewOrder()}}},[_vm._v("\n      "+_vm._s(_vm.$t("msg.create_order"))+"?\n    ")]):_vm._e(),_vm._v(" "),(!_vm.cancelOrder && !_vm.doneOrder && !this.trade.sellerId)?_c('button',{staticClass:"button is-danger is-outlined fat",staticStyle:{"width":"100%","height":"100%","padding":"20px","border-radius":"10px"},on:{"click":function($event){return _vm.confirmCancelPurchase()}}},[_vm._v("\n      "+_vm._s(_vm.$t("msg.cancel_transaction"))+"?\n    ")]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('hr',{staticStyle:{"background":"#d8d6d6"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column landing_buy_blu_watch"},[_c('div',[_c('div',{staticClass:"column columns"},[_c('blu-watch-step1',{attrs:{"purchaseHome":_vm.purchaseWaiting},on:{"backToStart":_vm.backToStart}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('div',{staticClass:"column landing_buy_blu p0 h100 card-boder-bg",attrs:{"id":"landing_buy_blu"}},[_c('div',{staticStyle:{"height":"100%"}},[(_vm.transactionState === 0)?_c('div',{staticClass:"step_1 h100",attrs:{"id":"baseBuyStep_1"}},[_c('base-buy-blu-buy',{attrs:{"fees":_vm.fees},on:{"callNextState":_vm.callNextState}})],1):_vm._e(),_vm._v(" "),(_vm.transactionState === 1)?_c('div',{staticClass:"step_2 h100",attrs:{"id":"baseBuyStep_2"}},[_c('base-buy-blu-watch',{attrs:{"paymentMode":_vm.paymentMode,"fees":_vm.fees,"bluTusd":_vm.bluTusd,"purchaseWaiting":_vm.purchaseWaiting},on:{"callNextState":_vm.callNextState,"maintenanceCheck":_vm.maintenanceCheck,"backToStart":function () { return (_vm.transactionState = 0); }}})],1):_vm._e()])])]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"checked":"","type":"checkbox","id":"buy_blu"}}),_vm._v(" "),_c('label',{staticClass:"tab-label",staticStyle:{"background":"#342365","color":"#fff"}},[_vm._v(_vm._s(_vm.$t("msg.buy_token")))]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"column landing_buy_blu p0 h100",attrs:{"id":"landing_buy_blu"}},[_c('div',{staticStyle:{"height":"100%"}},[(_vm.transactionState === 0)?_c('div',{staticClass:"step_1 h100",attrs:{"id":"baseBuyStep_1"}},[_c('base-buy-blu-buy',{attrs:{"fees":_vm.fees},on:{"callNextState":_vm.callNextState}})],1):_vm._e(),_vm._v(" "),(_vm.transactionState === 1)?_c('div',{staticClass:"step_2 h100",attrs:{"id":"baseBuyStep_2"}},[_c('base-buy-blu-watch',{attrs:{"paymentMode":_vm.paymentMode,"fees":_vm.fees,"bluTusd":_vm.bluTusd,"purchaseWaiting":_vm.purchaseWaiting},on:{"callNextState":_vm.callNextState,"maintenanceCheck":_vm.maintenanceCheck,"backToStart":function () { return (_vm.transactionState = 0); }}})],1):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column landing_buy_redeem p0 h100"},[(_vm.operation == 'NEW')?_c('div',{staticClass:"h100"},[_c('base-buy-blu',{on:{"maintenanceCheck":_vm.maintenanceCheck}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPortfolio_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2700f92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPortfolio_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingPortfolio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2700f92e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingPortfolio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(849);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("a17d1db6", content, true, {});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".coin_bar{width:100%;height:10px;background-color:#d1cccc}.coin_bar_filled{background-color:#2f3577;display:block;height:10px}.percent24{color:green}.is-{color:red}.landing_portfolio_icon{width:40px!important;height:40px!important;display:inline-block;vertical-align:bottom}", ""]);

// exports


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column landing_portfolio"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column component_card_border_bottom"},[_c('p',{staticClass:"p0"},[_vm._v(_vm._s(_vm.$t("msg.portfolio_intro")))])]),_vm._v(" "),_c('div',{staticClass:"column component_card_border_bottom p0"},[_c('div',[_c('div',{staticClass:"block_1"},_vm._l((_vm.assetList),function(coin,index){return (coin.assignedOverallWeight > 0)?_c('div',{key:coin.currency.name,staticClass:"dis_inb landing_portfolio_chart_item",class:{
              'landing_portfolio_chart_highlight ':
                _vm.selectedCoin == coin.currency.symbol,
            },on:{"click":function($event){return _vm.labelClick(coin.currency.symbol)}}},[_c('span',{staticClass:"fat",class:'color_' + coin.currency.symbol},[_vm._v(_vm._s(coin.currency.name == 'TrueUSD' ? 'Tether' : coin.currency.name))]),_vm._v(" "),_c('div',{staticClass:"landing_portfolio_icon dis_inb background_",class:'background_' + coin.currency.symbol}),_vm._v(" "),_c('p',{staticClass:"tal_l landing_portfolio_labels"},[(coin.currency.symbol != 'OTC')?_c('span',[_vm._v(_vm._s(coin.currency.symbol == 'TUSD' ? 'USDT' : coin.currency.symbol)+" |")]):_vm._e(),_vm._v("\n              "+_vm._s(coin.assignedOverallWeight.toFixed(2))+"%\n            ")])]):_vm._e()}),0),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('h1',{staticClass:"title"},[_c('span',{staticClass:"landing_portfolio_icon dis_inb background_",class:'background_' + _vm.selectedCoin}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedCoin))])]),_vm._v(" "),_c('p',{staticClass:"text_md landing_portfolio_footer"},[_vm._v("\n        "+_vm._s(_vm.$t("msg.text_" + _vm.selectedCoin, 1))+"\n      ")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block_2"},[_c('canvas',{attrs:{"id":"mainChart"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingRecentTransactions_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee36d5b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingRecentTransactions_vue__ = __webpack_require__(854);
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LandingRecentTransactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee36d5b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LandingRecentTransactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("320a0d94", content, true, {});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".landing_recent_body_icon{width:15px;height:15px;display:inline-block;margin-right:5px}", ""]);

// exports


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('div',{staticClass:"column landing_recent"},[_c('div',{staticClass:"column title_recent_tx"},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.$tc("msg.recent_transactions", 1))+"\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"all_transactions",attrs:{"to":"/transactions/deposits"}},[_vm._v(_vm._s(_vm.$t("msg.all_transactions")))])],1),_vm._v(" "),_c('div',{staticClass:"columns landing_recent_header"}),_vm._v(" "),_vm._l((_vm.recentTransactions),function(transaction){return _c('div',{key:transaction.id,staticClass:"columns landing_recent_body border-bottom-grey"},[_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center"}},[_c('p',[_vm._v(_vm._s(_vm.fixTimeZone(transaction.createdAt))+" UTC -3")])]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center"}},[_c('p',[_vm._v(_vm._s(_vm._f("upper")(_vm.$t(("msg." + (transaction.type))))))])]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"landing_recent_body_icon icon_class_2 background_",class:'background_' + transaction.status}),_vm._v(" "),_c('p',{staticClass:"dis_inb val_txtb uppercase"},[_vm._v("\n          "+_vm._s(_vm.$t(("msg." + (transaction.status))))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"column tal_r",staticStyle:{"display":"flex","align-items":"center"}},[_c('p',[(transaction.amount)?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(transaction.amount))+"\n            "+_vm._s(_vm.symbAjust(transaction.currencySymbol)))]):_c('span'),_c('br')])])])}),_vm._v(" "),(_vm.recentTransactions == '')?_c('div',{staticClass:"column tal_c"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.no_rec_transactions_found")))])]):_vm._e()],2)]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"transactions"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_vm._v("\n      "+_vm._s(_vm.$tc("msg.recent_transactions", 1))+"\n      "),_c('router-link',{staticClass:"all_transactions",attrs:{"to":"/transactions/deposits"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.all_transactions"))+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"landing_recent text_sm"},[_vm._l((_vm.recentTransactions),function(transaction){return _c('div',{key:transaction.id,staticClass:"columns column landing_recent_body border-bottom-grey"},[_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.fixTimeZone(transaction.createdAt))+" UTC -3")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm._f("upper")(_vm.$t(("msg." + (transaction.type))))))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"landing_recent_body_icon icon_class_2 background_",class:'background_' + transaction.status}),_vm._v(" "),_c('p',{staticClass:"dis_inb val_txtb uppercase"},[_vm._v("\n              "+_vm._s(_vm.$t(("msg." + (transaction.status))))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[(transaction.amount)?_c('span',[_vm._v(_vm._s(_vm._f("decimalsCrypto")(transaction.amount,8))+"\n                "+_vm._s(_vm.symbAjust(transaction.currencySymbol)))]):_c('span')])])])}),_vm._v(" "),(_vm.recentTransactions == '')?_c('div',{staticClass:"column tal_c"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.no_rec_transactions_found")))])]):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("c460dba0", content, true, {});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.wrapper_modal_other_currencies{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_other_currencies .content_other_currencies{position:relative;padding:2rem 2.5rem;border-radius:6px;max-width:385px;max-height:465px;width:100%;background-color:#fff}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies{display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #000!important;padding-bottom:.5rem;width:100%}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies h1{font-size:1rem;font-weight:600;color:#342365}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value{display:flex;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value img{width:1.4rem;margin-right:10px}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_other_currencies .content_other_currencies svg:hover{color:#342365}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent{display:flex;flex-direction:column;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent h2{font-size:1rem;font-weight:600;margin:1.2rem 0}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list{display:flex;flex-direction:column;align-items:flex-end}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list{display:flex;align-items:center;justify-content:space-between;margin-bottom:.8rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list img{width:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list .currencies_icon{width:1.4rem;height:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p{margin-top:.5rem}@media only screen and (max-width:900px){.wrapper_modal_other_currencies .content_other_currencies{padding:2rem 1.5rem;max-width:350px;max-height:450px}}@media only screen and (max-width:350px){.wrapper_modal_other_currencies .content_other_currencies{max-width:300px;max-height:450px}}", ""]);

// exports


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('div',{staticClass:"wrapper_modal_other_currencies"},[_c('div',{staticClass:"content_other_currencies"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),_c('div',{staticClass:"title_other_currencies"},[(_vm.type == 'balance')?_c('h1',[_vm._v(_vm._s(_vm.$t("msg.current_balance")))]):_vm._e(),_vm._v(" "),(_vm.type == 'price')?_c('h1',[_vm._v(_vm._s(_vm.$t("msg.current_value")))]):_vm._e(),_vm._v(" "),(_vm.type == 'supply')?_c('h1',[_vm._v(_vm._s(_vm.$t("msg.fund_value")))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"usdt_value"},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":""}}),_vm._v(" "),(_vm.type == 'balance')?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.bluAccount.balance * _vm.blue.value, "USDT"))+"\n            USDT")]):_vm._e(),_vm._v(" "),(_vm.type == 'price')?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.blue.value, "USDT"))+" USDT")]):_vm._e(),_vm._v(" "),(_vm.type == 'supply')?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.fundTails[0].tokenQuantity * _vm.blue.value, "USDT"))+"\n            USDT")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"currencies_equivalent"},[_c('h2',[_vm._v(_vm._s(_vm.$t("msg.equivalent_to"))+":")]),_vm._v(" "),_c('div',{staticClass:"wrapper_currencies_list"},_vm._l((_vm.pairs),function(coin){return _c('div',{key:coin.symbol,staticClass:"currencies_list"},[(_vm.type == 'balance')?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(
                  (_vm.bluAccount.balance * _vm.blue.value) / coin.value,
                  coin.symbol
                ))+"\n              "+_vm._s(coin.symbol))]):_vm._e(),_vm._v(" "),(_vm.type == 'price')?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.blue.value / coin.value, coin.symbol))+"\n              "+_vm._s(coin.symbol))]):_vm._e(),_vm._v(" "),(_vm.type == 'supply')?_c('span',[_vm._v(_vm._s(_vm.currencyFormat(
                  (_vm.fundTails[0].tokenQuantity * _vm.blue.value) / coin.value,
                  coin.symbol
                ))+"\n              "+_vm._s(coin.symbol))]):_vm._e(),_vm._v(" "),(coin.symbol == 'BRL')?_c('span',{staticClass:"currencies_icon",staticStyle:{"color":"black"}},[_vm._v("\n            R$\n            ")]):_c('span',{staticClass:"currencies_icon background_ icon_class_3 val_m",class:'background_' + coin.symbol})])}),0),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.estimated_info_modal_equivalent")))]),_vm._v("\n        "+_vm._s(_vm.value)+"\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBlueClubInfo_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af0ee4f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBlueClubInfo_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalBlueClubInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af0ee4f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalBlueClubInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(860);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("506e34d7", content, true, {});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}ul li{margin-top:10px}.wrapper_modal_other_currencies{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_other_currencies .content_other_currencies{position:relative;padding:2rem 2.5rem;border-radius:6px;max-width:400px;max-height:465px;width:100%;background-color:#fff}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies{border-bottom:1px solid #b1adad!important;padding-bottom:.5rem;width:100%}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies h1{font-size:1rem;font-weight:600;color:#342365}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value{display:flex;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value img{width:1.4rem;margin-right:10px}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_other_currencies .content_other_currencies svg:hover{color:#342365}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent{display:flex;flex-direction:column;align-items:flex-start}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent h2{font-size:.85rem;font-weight:600;margin:1.2rem 0;text-align:center}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list{display:flex;flex-direction:column;align-items:flex-end}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list{display:flex;align-items:center;justify-content:space-between;margin-bottom:.8rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list img{width:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list .currencies_icon{width:1.4rem;height:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p{margin-top:.5rem}@media only screen and (max-width:900px){.wrapper_modal_other_currencies .content_other_currencies{padding:2rem 1.5rem;max-width:350px;max-height:450px}}@media only screen and (max-width:350px){.wrapper_modal_other_currencies .content_other_currencies{max-width:300px;max-height:450px}}", ""]);

// exports


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('div',{staticClass:"wrapper_modal_other_currencies"},[_c('div',{staticClass:"content_other_currencies"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),_c('div',{staticClass:"title_other_currencies"},[_c('h1',{staticStyle:{"color":"#cb36ee","text-align":"center"}},[_vm._v(_vm._s(_vm.$t("msg.modalBlueClub.title")))])]),_vm._v(" "),_c('div',{staticClass:"currencies_equivalent"},[_c('h2',[_vm._v("\n          "+_vm._s(_vm.$t("msg.modalBlueClub.subTitle"))+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"1.5rem"}},[_c('ul',{staticStyle:{"list-style":"disc"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalBlueClub.text1'))}}),_vm._v(" "),_c('li',[_vm._v("\n              "+_vm._s(_vm.$t("msg.modalBlueClub.text2"))+"\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              "+_vm._s(_vm.$t("msg.modalBlueClub.text3"))+"\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              "+_vm._s(_vm.$t("msg.modalBlueClub.text4"))+"\n            ")]),_vm._v(" "),_c('li',[_vm._v("\n              "+_vm._s(_vm.$t("msg.modalBlueClub.text5"))+"\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalClainBlueClubInfo_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f50d434_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalClainBlueClubInfo_vue__ = __webpack_require__(910);
function injectStyle (ssrContext) {
  __webpack_require__(863)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalClainBlueClubInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f50d434_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalClainBlueClubInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(864);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1b725257", content, true, {});

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}ul li{margin-top:10px}.btn-grey{background:grey;padding:10px;text-align:center;color:#fff;text-transform:uppercase;margin-top:40px;cursor:not-allowed}.btn-grey:active{opacity:.6}.btn-pink{background:#cb36ee;padding:10px;text-align:center;color:#fff;text-transform:uppercase;margin-top:40px;cursor:pointer}.btn-pink:active{opacity:.6}.wrapper_modal_other_currencies{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_other_currencies .content_other_currencies{position:relative;padding:1rem 2rem;border-radius:6px;max-width:440px;width:100%;background-color:#fff}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies{border-bottom:1px solid #b1adad!important;padding-bottom:.5rem;width:100%}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies h1{font-size:1rem;font-weight:600;color:#342365}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value{display:flex;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value img{width:1.4rem;margin-right:10px}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_other_currencies .content_other_currencies svg:hover{color:#342365}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent{display:flex;flex-direction:column;align-items:flex-start;margin-top:20px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent h2{font-size:.8rem!important;font-weight:600;text-align:left!important}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list{display:flex;flex-direction:column;align-items:flex-end}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list{display:flex;align-items:center;justify-content:space-between;margin-bottom:.8rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list img{width:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list .currencies_icon{width:1.4rem;height:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p{margin-top:.5rem}@media only screen and (max-width:900px){.wrapper_modal_other_currencies .content_other_currencies{padding:2rem 1.5rem;max-width:350px}}@media only screen and (max-width:350px){.wrapper_modal_other_currencies .content_other_currencies{max-width:300px}}", ""]);

// exports


/***/ }),
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask"},[_c('div',{staticClass:"wrapper_modal_other_currencies"},[_c('div',{staticClass:"content_other_currencies"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),_c('div',{staticClass:"title_other_currencies"},[_c('h1',{staticStyle:{"color":"#cb36ee","text-align":"center"}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.modalClainBlueClub.title"))+"\n        ")])]),_vm._v(" "),(_vm.step == 1)?_c('div',{staticClass:"currencies_equivalent"},[_c('div',[_c('p',[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text2"))+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text3"))+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text4"))+"\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticStyle:{"width":"100%","height":"35px"},attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"keyup":function($event){return _vm.validAddressCheck()},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}}),_vm._v(" "),_c('span',{staticStyle:{"margin-bottom":"12px","color":"red"},style:(_vm.validAddress || _vm.address == '' ? 'opacity:0' : 'opacity:1')},[_vm._v(_vm._s(_vm.$t("msg.invalid_address")))]),_vm._v(" "),_c('h2',{staticStyle:{"margin-top":"20px"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text5"))+"\n          ")]),_vm._v(" "),_c('h2',[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text6"))+"\n          ")]),_vm._v(" "),(!_vm.validAddress)?_c('div',{staticClass:"btn-grey"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.submit"))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.validAddress)?_c('div',{staticClass:"btn-pink",on:{"click":function($event){return _vm.sendEmail()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.submit"))+"\n          ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('div',{staticClass:"currencies_equivalent"},[_c('div',[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text7"))+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text8"))+"\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text9"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"btn-pink",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.modalClainBlueClub.text10"))+"\n          ")])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0 minH100",attrs:{"id":"page_landing"}},[_c('div',{staticClass:"cointainer_xl grid landing_grid"},[_c('div',{staticClass:"column_landing"},[_c('div',{staticClass:"component_card combo_1"},[_c('landing-balance',{on:{"toggleModalCurrencies":function($event){return _vm.showModalCurrencies('balance')},"toggleModalBlueClub":function($event){return _vm.showModalBlueClub('balance')},"toggleModalClainBlueClub":function($event){return _vm.showModalClainBlueClub('balance')}}})],1),_vm._v(" "),(_vm.modalCurrencies)?_c('div',[_c('modalOtherCurrencies',{attrs:{"type":_vm.type},on:{"toggleModalCurrencies":function($event){return _vm.showModalCurrencies()}}})],1):_vm._e(),_vm._v(" "),(_vm.modalBlueClubInfo)?_c('div',[_c('modalBlueClubInfo',{attrs:{"type":_vm.type},on:{"toggleModalCurrencies":function($event){return _vm.showModalBlueClub()}}})],1):_vm._e(),_vm._v(" "),(_vm.modalClainBlueClubInfo)?_c('div',[_c('modalClainBlueClubInfoVue',{attrs:{"type":_vm.type},on:{"toggleModalCurrencies":function($event){return _vm.showModalClainBlueClub()}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"component_card combo_1"},[_c('todays-market',{on:{"toggleModalCurrencies":function($event){return _vm.showModalCurrencies('price')}}})],1)]),_vm._v(" "),_c('div',{staticClass:"column_landing"},[_c('div',{staticClass:"component_card combo_1"},[_c('landing-buy-redeem',{on:{"maintenanceCheck":_vm.maintenanceCheck}})],1),_vm._v(" "),_c('div',{staticClass:"component_card combo_1"},[_c('landing-recent-transactions')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612e3452_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__(940);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612e3452_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableProbability_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94cfeb74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableProbability_vue__ = __webpack_require__(923);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableProbability_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94cfeb74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableProbability_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('div',{staticStyle:{"padding":"0 0.75rem"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.probability_calculation'))}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.probability_GL'))}}),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"1rem","font-weight":"600"}},[_vm._v("\n        "+_vm._s(_vm.$t('msg.probability_current_GL'))+"\n        "),_c('span',{staticStyle:{"color":"#22c8b5"}},[_vm._v("+14.56%")])]),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","margin-top":"5px"}},[_vm._v("\n        "+_vm._s(_vm.$t('msg.probability_current_wighted'))+" "),_c('span',[_vm._v("350 USDT")])])]),_vm._v(" "),_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.status_done")))]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v(_vm._s(_vm.$tc("msg.status_expired")))]),_vm._v(" "),_c('option',{attrs:{"value":"failed"}},[_vm._v(_vm._s(_vm.$tc("msg.failed", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$tc("msg.new")))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting", 1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.apply_filter", 1))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.clear_filter", 1))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"column tal_r"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"custom_input_white",attrs:{"placeholder":_vm.$t('msg.global_search')},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{ref:"historytable",attrs:{"columns":_vm.columns,"rows":_vm.withdrawsOnPage,"select-options":{ enabled: false },"search-options":{
        enabled: true,
        searchFn: _vm.customSearch,
        externalQuery: _vm.searchBox,
      },"line-numbers":true,"sort-options":{
        enabled: true,
        initialSortBy: { field: 'createdAt', type: 'desc' },
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: '5',
        position: 'down',
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label == 'Redemption Date/Time')?_c('span',[_vm._v("\n          Redemption Date/Time\n        ")]):_vm._e(),_vm._v(" "),(props.column.label == 'Redemption Price')?_c('span',[_vm._v("Redemption Price")]):_vm._e(),_vm._v(" "),(props.column.label == 'Average Purchase Price')?_c('span',[_vm._v("Average Purchase Price")]):_vm._e(),_vm._v(" "),(props.column.label == 'G/L')?_c('span',[_vm._v("G/L")]):_vm._e(),_vm._v(" "),(props.column.label == 'actions')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.actions")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'Redemption Date/Time')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'Redemption Price')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'Average Purchase Price')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[(props.formattedRow[props.column.field])?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field].toFixed(6)))]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.symbAjust(props.row.currency.symbol))+"\n          ")]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'G/L')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status_" + props.formattedRow[props.column.field])))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field]))]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found", 1)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTablePurchase_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5b9f3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTablePurchase_vue__ = __webpack_require__(929);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTablePurchase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f5b9f3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTablePurchase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionDetails_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4323763f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionDetails_vue__ = __webpack_require__(928);
function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4323763f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(927);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("2808a4a6", content, true, {});

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column history_full_data",attrs:{"id":"history_full_data"}},[_c('div',{staticClass:"history_full_data_title tal_c"},[_c('h1',{staticClass:"text_lg fat upper main_blue_dk_fill"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.transaction_details"))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"cointainer_sm combo_1"},[_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.txid"))+":")])]),_vm._v(" "),(_vm.transactionData.tokenTxid)?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://bscscan.com/tx/' +
            _vm.transactionData.tokenTxid,"target":"blank_"}},[_vm._v("\n          "+_vm._s(_vm.transactionData.tokenTxid)+"\n        ")])]):_vm._e()]),_vm._v(" "),(_vm.transactionData.targetAmount)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[(_vm.transactionData.type == 'purchase')?_c('strong',[_vm._v(_vm._s(_vm.$t("msg.quantity"))+" (BLUE):")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(((_vm.transactionData.targetAmount * _vm.transactionData.targetPrice - _vm.transactionData.sourceFee) / _vm.transactionData.targetPrice).toFixed(6))+"\n          "+_vm._s(_vm.symbAjust(_vm.transactionData.targetCurrency.symbol)))])])]):_vm._e(),_vm._v(" "),(!_vm.transactionData.triggerType)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.price"))+":")])]),_vm._v(" "),(
            _vm.transactionData.targetPrice &&
            _vm.transactionData.sourceCurrency.symbol
          )?_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.transactionData.targetPrice.toFixed(8))+"\n          "+_vm._s(_vm.transactionData.sourceCurrency.symbol))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.transactionData.sourceAmount)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[(_vm.transactionData.type == 'purchase')?_c('strong',[_vm._v(_vm._s(_vm.$t("msg.subtotal"))+":")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.getTotalFee(
              _vm.transactionData.targetAmount,
              _vm.transactionData.targetPrice,
              _vm.transactionData.sourceFee
            ))+"\n          "+_vm._s(_vm.transactionData.sourceCurrency.symbol))])])]):_vm._e(),_vm._v(" "),(!_vm.transactionData.triggerType)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$tc("msg.fee", 1))+":")])]),_vm._v(" "),(_vm.transactionData.sourceFee)?_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.transactionData.sourceFee.toFixed(8))+"\n          "+_vm._s(_vm.transactionData.sourceCurrency.symbol))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.transactionData.sourceAmount)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[(_vm.transactionData.type == 'purchase')?_c('strong',[_vm._v(_vm._s(_vm.$t("msg.total"))+":")]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.getTotal(
              _vm.transactionData.targetAmount,
              _vm.transactionData.targetPrice
            ))+"\n          "+_vm._s(_vm.transactionData.sourceCurrency.symbol))])])]):_vm._e(),_vm._v(" "),(_vm.transactionData.amount)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.amount"))+":")])]),_vm._v(" "),(!_vm.transactionData.triggerType)?_c('span',{staticClass:"tal_r_b"},[_vm._v("\n          "+_vm._s(_vm.transactionData.amount)+"\n        ")]):_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.transactionData.amount)+" BLU")])])]):_vm._e(),_vm._v(" "),(_vm.transactionData.status)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.status"))+":")])]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.transactionData.status)))))])])]):_vm._e(),_vm._v(" "),(_vm.transactionData.type)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.type"))+":")])]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.transactionData.type)))))])])]):_vm._e(),_vm._v(" "),(_vm.transactionData.triggerType)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.type"))+":")])]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.transactionData.triggerType)))))])])]):_vm._e(),_vm._v(" "),(_vm.transactionData.createdAt)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.createdAt"))+":")])]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v("\n          "+_vm._s(_vm.formatDate(_vm.transactionData.createdAt))+"\n        ")])])]):_vm._e(),_vm._v(" "),(_vm.transactionData.updatedAt)?_c('div',{staticClass:"history_full_data_data split_half_text"},[_c('p',[_c('span',{staticClass:"tal_l_b"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.updatedAt"))+":")])]),_vm._v(" "),_c('span',{staticClass:"tal_r_b"},[_vm._v("\n          "+_vm._s(_vm.formatDate(_vm.transactionData.updatedAt))+"\n        ")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.status_done")))]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v(_vm._s(_vm.$tc("msg.status_expired")))]),_vm._v(" "),_c('option',{attrs:{"value":"failed"}},[_vm._v(_vm._s(_vm.$tc("msg.failed", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$tc("msg.new")))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting", 1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.apply_filter", 1))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.clear_filter", 1))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"column tal_r"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"custom_input_white",attrs:{"placeholder":_vm.$t('msg.global_search')},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{ref:"historytable",staticClass:"tables_transactions",attrs:{"columns":_vm.columns,"rows":_vm.purchasesOnPage,"select-options":{ enabled: false },"search-options":{
        enabled: true,
        searchFn: _vm.customSearch,
        externalQuery: _vm.searchBox,
      },"line-numbers":true,"sort-options":{
        enabled: true,
        initialSortBy: { field: 'createdAt', type: 'desc' },
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: '5',
        position: 'down',
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label == 'id')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.txid")))]):_vm._e(),_vm._v(" "),(props.column.label == 'createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'updatedAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.updatedAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'targetPrice')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.price")))]):_vm._e(),_vm._v(" "),(props.column.label == 'targetAmount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.quantity")))]):_vm._e(),_vm._v(" "),(props.column.label == 'fee')?_c('span',[_vm._v(_vm._s(_vm.$tc("msg.fee", 1)))]):_vm._e(),_vm._v(" "),(props.column.label == 'subTotal')?_c('span',[_vm._v("Subtotal")]):_vm._e(),_vm._v(" "),(props.column.label == 'total')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.total")))]):_vm._e(),_vm._v(" "),(props.column.label == 'status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status")))]):_vm._e(),_vm._v(" "),(props.column.label == 'actions')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.actions")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'tokenTxid')?_c('span',[(props.row.tokenTxid)?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://bscscan.com/tx/' +
                props.formattedRow[props.column.field],"target":"blank_"}},[_vm._v("\n              "+_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field]))+"\n            ")])]):_c('span',[_vm._v(" ----- ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'createdAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'updatedAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'targetPrice')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field].toFixed(6))+"\n            "+_vm._s(props.formattedRow.sourceCurrency.symbol))]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'targetAmount')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[_vm._v(_vm._s((
                (props.formattedRow.targetAmount *
                  props.formattedRow.targetPrice -
                  props.formattedRow.sourceFee) /
                props.formattedRow.targetPrice
              ).toFixed(6))+"\n            BLUE")]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'sourceFee')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field].toFixed(6))+"\n            "+_vm._s(props.formattedRow.sourceCurrency.symbol))]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'subTotal')?_c('span',[(props.formattedRow.targetPrice > 0)?_c('span',[_vm._v("\n\n            "+_vm._s((
                props.formattedRow.targetAmount *
                  props.formattedRow.targetPrice -
                props.formattedRow.sourceFee
              ).toFixed(6))+"\n            "+_vm._s(props.formattedRow.sourceCurrency.symbol)+"\n          ")]):_vm._e()]):_vm._e(),_vm._v(" "),(props.column.field == 'total')?_c('span',[(
              props.formattedRow.targetPrice &&
              props.formattedRow.targetAmount &&
              props.formattedRow.sourceFee
            )?_c('span',[_vm._v("\n            "+_vm._s((
                props.formattedRow.targetAmount *
                props.formattedRow.targetPrice
              ).toFixed(6))+"\n            "+_vm._s(props.formattedRow.sourceCurrency.symbol)+"\n          ")]):_c('span',[_vm._v(" -- ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',[_vm._v("\n          "+_vm._s(_vm.$t("msg.status_" + props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('a',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.plus)},on:{"click":function($event){return _vm.getDetails(props.row)}}},[_vm._v("Get Details")]),_vm._v(" "),(props.row.type == 'purchase' && props.row.status == 'done')?_c('span',[_c('a',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.download)},on:{"click":function($event){return _vm.getCertificateByID(props.row.id, props.row.type)}}},[_vm._v("Get Certificate")])]):_vm._e()]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found", 1)))])])]),_vm._v(" "),(_vm.transactionData)?_c('div',{staticClass:"page_history_full_data"},[_c('div',{staticClass:"cointainer_lg combo_1 tal_r"},[_c('a',{staticClass:"page_history_full_data_close",on:{"click":function($event){return _vm.clearTransactionData()}}},[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"cointainer_lg combo_1"},[_c('transaction-details',{attrs:{"transactionData":_vm.transactionData},on:{"updateCancelled":_vm.updateCancelled}})],1)]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableRedeem_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d322be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableRedeem_vue__ = __webpack_require__(931);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableRedeem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d322be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableRedeem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.status_done")))]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v(_vm._s(_vm.$tc("msg.status_expired")))]),_vm._v(" "),_c('option',{attrs:{"value":"failed"}},[_vm._v(_vm._s(_vm.$tc("msg.failed", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$tc("msg.new")))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting", 1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v(_vm._s(_vm.$tc("msg.apply_filter",1)))]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.clear_filter", 1))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"column tal_r"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"custom_input_white",attrs:{"placeholder":_vm.$t('msg.global_search')},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{key:_vm.keyTable,ref:"historytable",attrs:{"columns":_vm.columns,"rows":_vm.redeemsOnPage,"select-options":{ enabled: false },"search-options":{
        enabled: true,
        searchFn: _vm.customSearch,
        externalQuery: _vm.searchBox,
      },"line-numbers":true,"sort-options":{
        enabled: true,
        initialSortBy: { field: 'createdAt', type: 'desc' },
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: '5',
        position: 'down',
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label == 'address')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.address")))]):_vm._e(),_vm._v(" "),(props.column.label == 'txid')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.txid")))]):_vm._e(),_vm._v(" "),(props.column.label == 'createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'updatedAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.updatedAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'amount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.amount"))+" BLUE")]):_vm._e(),_vm._v(" "),(props.column.label == 'amountBTC')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.redeemed_value")))]):_vm._e(),_vm._v(" "),(props.column.label == 'status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status")))]):_vm._e(),_vm._v(" "),(props.column.label == 'actions')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.actions")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'targetAddress')?_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'tokenTxid')?_c('span',[(props.row.status == 'done')?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://bscscan.com/tx/' +
                props.formattedRow[props.column.field],"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))])]):_c('span',[_vm._v(" ---- ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'createdAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'updatedAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'sourceAmount')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field].toFixed(6)))]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'targetAmount')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field].toFixed(8))+"\n            "+_vm._s(props.row.targetCurrency.symbol)+"\n          ")]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',[_vm._v("\n          "+_vm._s(_vm.$t("msg.status_" + props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[(
              props.row.step <= 2 &&
              props.row.status != 'cancelled' &&
              props.row.status != 'expired'
            )?_c('div',{staticClass:"container_actions"},[_c('span',{staticClass:"icon_class_1 icon_delete",domProps:{"innerHTML":_vm._s(_vm.iconSets.trash)},on:{"click":function($event){return _vm.cancelRedeem(props.row.id)}}})]):_vm._e()]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found", 1)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableReferral_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c7238e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableReferral_vue__ = __webpack_require__(933);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableReferral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02c7238e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableReferral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  REFERRAL\n  "+_vm._s(_vm.filterType)+"\n  "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterType),expression:"filterType"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all",1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled",1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.done",1)))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting",1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v(_vm._s(_vm.$tc("msg.apply_filter",1)))]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v(_vm._s(_vm.$tc("msg.clear_filter",1)))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_vm._v("\n    search\n    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{ref:"historytable",attrs:{"columns":_vm.columns,"rows":_vm.purchasesOnPage,"select-options":{ enabled: false},"search-options":{ enabled: true,
          searchFn: _vm.customSearch,
          externalQuery: _vm.searchBox, },"line-numbers":true,"sort-options":{
                      enabled: true,
                      initialSortBy: {field: 'createdAt', type: 'desc'}
                   },"pagination-options":{
                    enabled: true,
                    mode: 'records',
                    perPage: '5',
                    position: 'down',
                    perPageDropdown: [10, 15, 20],
                    dropdownAllowAll: false,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label =='id')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.id")))]):_vm._e(),_vm._v(" "),(props.column.label =='sourceAmount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.sourceAmount")))]):_vm._e(),_vm._v(" "),(props.column.label =='createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'createdAt')?_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found",1)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableDeposits_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbb36172_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableDeposits_vue__ = __webpack_require__(935);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableDeposits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbb36172_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableDeposits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.status_done")))]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v(_vm._s(_vm.$tc("msg.status_expired")))]),_vm._v(" "),_c('option',{attrs:{"value":"failed"}},[_vm._v(_vm._s(_vm.$tc("msg.failed", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$tc("msg.new")))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting", 1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.apply_filter", 1))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.clear_filter", 1))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"column tal_r"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"custom_input_white",attrs:{"placeholder":_vm.$t('msg.global_search')},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{ref:"historytable",attrs:{"columns":_vm.columns,"rows":_vm.depositsOnPage,"select-options":{ enabled: false },"search-options":{
        enabled: true,
        searchFn: _vm.customSearch,
        externalQuery: _vm.searchBox,
      },"line-numbers":true,"sort-options":{
        enabled: true,
        initialSortBy: { field: 'createdAt', type: 'desc' },
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: '5',
        position: 'down',
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label == 'id')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.txid")))]):_vm._e(),_vm._v(" "),(props.column.label == 'createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'updatedAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.updatedAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'amount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.deposit_amount")))]):_vm._e(),_vm._v(" "),(props.column.label == 'status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status")))]):_vm._e(),_vm._v(" "),(props.column.label == 'actions')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.actions")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'txID')?_c('span',[(
              props.row.currency.symbol == 'BLUE' ||
              props.row.currency.symbol == 'BLU'
            )?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://bscscan.com/tx/' +
                props.formattedRow[props.column.field],"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))])]):(props.row.currency.symbol == 'USDT')?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://tronscan.org/#/transaction/' +
                props.formattedRow[props.column.field],"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))])]):(props.row.currency.symbol == 'BTC')?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://www.blockchain.com/en/btc/tx/' +
                props.formattedRow[props.column.field],"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))])]):(props.row.currency.symbol == 'ETH')?_c('span',[_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":'https://www.blockchain.com/en/eth/tx/' +
                props.formattedRow[props.column.field],"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))])]):_c('span',[_vm._v(" ----- ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'createdAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'updatedAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amount')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[_vm._v("\n            "+_vm._s(_vm.fixedAmountBySymbol(
                props.formattedRow[props.column.field],
                props.row.currency.symbol
              ))+"\n            "+_vm._s(_vm.returnSymb(props.row.currency.symbol))+"\n          ")]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',[_vm._v("\n          "+_vm._s(_vm.$t("msg.status_" + props.formattedRow[props.column.field]))+"\n        ")]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found", 1)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableWithdraw_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b5e466_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableWithdraw_vue__ = __webpack_require__(937);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableWithdraw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b5e466_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableWithdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.status_done")))]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v(_vm._s(_vm.$tc("msg.status_expired")))]),_vm._v(" "),_c('option',{attrs:{"value":"failed"}},[_vm._v(_vm._s(_vm.$tc("msg.failed", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$tc("msg.new")))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting", 1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v(_vm._s(_vm.$tc("msg.apply_filter",1)))]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v(_vm._s(_vm.$tc("msg.clear_filter",1)))])])]),_vm._v(" "),_c('div',{staticClass:"column tal_r"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"custom_input_white",attrs:{"placeholder":_vm.$t('msg.global_search')},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{ref:"historytable",attrs:{"columns":_vm.columns,"rows":_vm.withdrawsOnPage,"select-options":{ enabled: false},"search-options":{ enabled: true,
          searchFn: _vm.customSearch,
          externalQuery: _vm.searchBox, },"line-numbers":true,"sort-options":{
                      enabled: true,
                      initialSortBy: {field: 'createdAt', type: 'desc'}
                   },"pagination-options":{
                    enabled: true,
                    mode: 'records',
                    perPage: '5',
                    position: 'down',
                    perPageDropdown: [10, 15, 20],
                    dropdownAllowAll: false,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label =='id')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.txid")))]):_vm._e(),_vm._v(" "),(props.column.label =='createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label =='updatedAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.updatedAt")))]):_vm._e(),_vm._v(" "),(props.column.label =='amount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.withdraw_amount")))]):_vm._e(),_vm._v(" "),(props.column.label =='status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status")))]):_vm._e(),_vm._v(" "),(props.column.label =='actions')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.actions")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.label == 'id')?_c('span',[(props.formattedRow[props.column.field])?_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":("https://bscscan.com/tx/" + (props.formattedRow[props.column.field])),"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))]):_vm._e()]):_vm._e(),_vm._v(" "),(props.column.field == 'createdAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'updatedAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amount')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[(props.formattedRow[props.column.field])?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field].toFixed(6)))]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.symbAjust(props.row.currency.symbol))+"\n          ")]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status_"+props.formattedRow[props.column.field])))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field]))]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found",1)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableInternal_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a592196_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableInternal_vue__ = __webpack_require__(939);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTableInternal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a592196_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTableInternal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('div',{staticClass:"custom_table_filters column"},[_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.start_date')},model:{value:(_vm.filterStartDate),callback:function ($$v) {_vm.filterStartDate=$$v},expression:"filterStartDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('datepicker',{staticClass:"dis_inb",attrs:{"name":"uniquename","placeholder":_vm.$t('msg.end_date')},model:{value:(_vm.filterEndDate),callback:function ($$v) {_vm.filterEndDate=$$v},expression:"filterEndDate"}})],1),_vm._v(" "),_c('div',{staticClass:"component_normal_input_block dis_inb main_white_bg"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.statusFilter),expression:"statusFilter"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.statusFilter=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v(_vm._s(_vm.$tc("msg.all", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"cancelled"}},[_vm._v(_vm._s(_vm.$tc("msg.cancelled", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"done"}},[_vm._v(_vm._s(_vm.$tc("msg.status_done")))]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v(_vm._s(_vm.$tc("msg.status_expired")))]),_vm._v(" "),_c('option',{attrs:{"value":"failed"}},[_vm._v(_vm._s(_vm.$tc("msg.failed", 1)))]),_vm._v(" "),_c('option',{attrs:{"value":"new"}},[_vm._v(_vm._s(_vm.$tc("msg.new")))]),_vm._v(" "),_c('option',{attrs:{"value":"waiting"}},[_vm._v(_vm._s(_vm.$tc("msg.waiting", 1)))])])]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.applyFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.apply_filter", 1))+"\n      ")]),_vm._v(" "),_c('button',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",on:{"click":function($event){return _vm.clearFilter()}}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.clear_filter", 1))+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"column tal_r"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchBox),expression:"searchBox"}],staticClass:"custom_input_white",attrs:{"placeholder":_vm.$t('msg.global_search')},domProps:{"value":(_vm.searchBox)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchBox=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('vue-good-table',{ref:"historytable",attrs:{"columns":_vm.columns,"rows":_vm.tableRows,"select-options":{ enabled: false },"search-options":{
        enabled: true,
        searchFn: _vm.customSearch,
        externalQuery: _vm.searchBox,
      },"line-numbers":true,"sort-options":{
        enabled: true,
        initialSortBy: { field: 'createdAt', type: 'desc' },
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: '5',
        position: 'down',
        perPageDropdown: [10, 15, 20],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'per page',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label == 'address')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.userid")))]):_vm._e(),_vm._v(" "),(props.column.label == 'createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'updatedAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.updatedAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'amount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.amount")))]):_vm._e(),_vm._v(" "),(props.column.label == 'status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status")))]):_vm._e(),_vm._v(" "),(props.column.label == 'action')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.action")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.label == 'id')?_c('span',[(props.formattedRow[props.column.field])?_c('a',{attrs:{"title":_vm.$t('msg.details'),"href":("https://bscscan.com/tx/" + (props.formattedRow[props.column.field])),"target":"blank_"}},[_vm._v(_vm._s(_vm.ajustTokenID(props.formattedRow[props.column.field])))]):_vm._e()]):_vm._e(),_vm._v(" "),(props.column.field == 'createdAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'address')?_c('span',[(props.formattedRow.action == 'send')?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field]))]):_vm._e(),_vm._v(" "),(props.formattedRow.action == 'receive')?_c('span',[_vm._v(_vm._s(props.formattedRow.memberUID))]):_vm._e()]):_vm._e(),_vm._v(" "),(props.column.field == 'updatedAt')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.formattedRow[props.column.field]))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amount')?_c('span',[(props.formattedRow[props.column.field] > 0)?_c('span',[(props.formattedRow[props.column.field])?_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field].toFixed(6)))]):_vm._e(),_vm._v("\n            "+_vm._s(_vm.symbAjust(props.row.currency.symbol))+"\n          ")]):_c('span',[_vm._v("-")])]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status_" + props.formattedRow[props.column.field])))]):_vm._e(),_vm._v(" "),(props.column.field == 'action')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.internal_action_" + props.formattedRow[props.column.field])))]):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found", 1)))])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0 minH100",attrs:{"id":"page_history"}},[_c('div',{staticClass:"cointainer_xl column combo_1"},[_c('div',{staticClass:"columns column"},[_c('div',{staticClass:"column page_landing_welcome_title is-three-fifths"},[_c('h1',{staticClass:"component_title_lg fat m0_b"},[_c('div',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_history)}}),_vm._v("\n          "+_vm._s(_vm.$tc("msg.transaction", 2))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"componenet_card_tabs"},[_c('a',{staticClass:"componenet_card_tab",class:{
          componenet_card_tab_selected: _vm.tableSelected == 'internal_transfer',
        },on:{"click":function($event){return _vm.showTable('internal_transfer')}}},[_vm._v(_vm._s(_vm.$t("msg.internal_transfer")))]),_vm._v(" "),_c('a',{staticClass:"componenet_card_tab",class:{
          componenet_card_tab_selected: _vm.tableSelected == 'withdraw',
        },on:{"click":function($event){return _vm.showTable('withdraw')}}},[_vm._v(_vm._s(_vm.$t("msg.withdraws")))]),_vm._v(" "),_c('a',{staticClass:"componenet_card_tab",class:{
          componenet_card_tab_selected: _vm.tableSelected == 'purchase',
        },on:{"click":function($event){return _vm.showTable('purchase')}}},[_vm._v(_vm._s(_vm.$t("msg.purchase")))]),_vm._v(" "),_c('a',{staticClass:"componenet_card_tab",class:{
          componenet_card_tab_selected: _vm.tableSelected == 'redemption',
        },on:{"click":function($event){return _vm.showTable('redemption')}}},[_vm._v(_vm._s(_vm.$t("msg.redemption")))]),_vm._v(" "),_c('a',{staticClass:"componenet_card_tab",class:{
          componenet_card_tab_selected: _vm.tableSelected == 'deposits',
        },on:{"click":function($event){return _vm.showTable('deposits')}}},[_vm._v(_vm._s(_vm.$t("msg.deposits")))])]),_vm._v(" "),_c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"component_title_md fat m0_b"},[_vm._v("\n          "+_vm._s(_vm.$t(("msg." + _vm.tableSelected)))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[(_vm.tableSelected == 'internal_transfer')?_c('transaction-table-internal'):_vm._e(),_vm._v(" "),(_vm.tableSelected == 'redemption')?_c('transaction-table-redeem'):_vm._e(),_vm._v(" "),(_vm.tableSelected == 'purchase')?_c('transaction-table-purchase'):_vm._e(),_vm._v(" "),(_vm.tableSelected == 'referral')?_c('transaction-table-referral'):_vm._e(),_vm._v(" "),(_vm.tableSelected == 'deposits')?_c('transaction-table-deposits'):_vm._e(),_vm._v(" "),(_vm.tableSelected == 'withdraw')?_c('transaction-table-withdraw'):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referrals_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cacc034_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referrals_vue__ = __webpack_require__(944);
function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Referrals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cacc034_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Referrals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0253c5cf", content, true, {});

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".component_main_button{padding:9px 16px;min-width:82px}", ""]);

// exports


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0 minH100",attrs:{"id":"page_referrals"}},[_c('div',{staticClass:"cointainer_xl column combo_1"},[_c('div',{staticClass:"columns column"},[_c('div',{staticClass:"column page_landing_welcome_title is-three-fifths"},[_c('h1',{staticClass:"component_title_lg fat m0_b"},[_c('div',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_peers)}}),_vm._v("\n          "+_vm._s(_vm.$tc("msg.referrals",1))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"cointainer_sm combo_1"},[_c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"tal_c text_lg fat component_card_border_bottom main_blue_dk_fill"},[_vm._v(_vm._s(_vm.$tc("msg.earn_on_referrals",1)))]),_vm._v(" "),(_vm.hasReferrals)?_c('div',{staticClass:"column"},[_c('p',{staticClass:"p"},[_vm._v("\n              "+_vm._s(_vm.$t("msg.referral_text_2"))+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"p"},[_c('a',{staticClass:"dis_inb",attrs:{"href":_vm.referralFullLink}},[_vm._v(_vm._s(_vm.referralFullLink))]),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.referralFullLink),expression:"referralFullLink",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.$tc("msg.copy",1)))])]),_vm._v(" "),_c('p',{staticClass:"p"},[_vm._v("\n              "+_vm._s(_vm.$t("msg.referral_code"))+": "+_vm._s(_vm.member.referCode)+"\n              "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.member.referCode),expression:"member.referCode",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button upper",attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.$tc("msg.copy",1)))])]),_vm._v(" "),(_vm.referrals)?_c('div',{staticClass:"component_table"},[_c('vue-good-table',{attrs:{"columns":_vm.referralColumns,"rows":_vm.referrals,"sort-options":{
                      enabled: true,
                      initialSortBy: {field: 'createdAt', type: 'desc'}
                   },"pagination-options":{
                                      enabled: true,
                                      perPage: 10,
                                      position: 'bottom',
                                      perPageDropdown: [10,50,100],
                                      dropdownAllowAll: true,
                                      setCurrentPage: 1,
                                      nextLabel: _vm.$tc('msg.next',2),
                                      prevLabel: _vm.$tc('msg.previous',2),
                                      rowsPerPageLabel: _vm.$t('msg.rows_per_page'),
                                      ofLabel: _vm.$t('msg.of'),
                                      pageLabel: _vm.$t('msg.page'), // for 'pages' mode
                                      allLabel: _vm.$t('msg.all'),
                                    }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label =='currencySymbol')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.currency")))]):_vm._e(),_vm._v(" "),(props.column.label =='amount')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.amount")))]):_vm._e(),_vm._v(" "),(props.column.label =='createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label =='status')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.status")))]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'createdAt')?_c('span',[_vm._v("\n\n                    "+_vm._s(_vm.fixTimeTest(props.formattedRow[props.column.field]))+"\n                    "),_c('br')]):(props.column.field == 'amount')?_c('span',[_vm._v("\n                    "+_vm._s(props.formattedRow[props.column.field].toFixed(6))+"\n                  ")]):(props.column.field == 'currencySymbol')?_c('span',[_vm._v("\n                    BLUE\n                  ")]):(props.column.field == 'status')?_c('span',[_vm._v("\n                    "+_vm._s(_vm.$t("msg.status_"+props.formattedRow[props.column.field]))+"\n                    "),_c('br')]):_c('span',[_vm._v(_vm._s(props.formattedRow[props.column.field]))])]}}],null,false,1980687823)},[_vm._v(" "),_vm._v(" "),_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[(_vm.loadingRewards)?_c('base-loading',{attrs:{"text":'Loading rewards'}}):_c('p',{staticClass:"tac"},[_vm._v(_vm._s(_vm.$tc("msg.no_data_found",1)))])],1)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{staticClass:"component_main_button main_blue_lt_bg main_blue_lt_bg_hover component_downloader_button combo_1 main_white_fill",attrs:{"to":"/transactions/deposits"}},[_vm._v(_vm._s(_vm.$t("msg.all_transactions")))])],1)]):_c('div',{staticClass:"column"},[_c('p',{staticClass:"p"},[_vm._v("\n              "+_vm._s(_vm.$t("msg.referral_text_3"))+"\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_956698a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(946);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_956698a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0",attrs:{"id":"page_settings"}},[_c('div',{staticClass:"column combo_1",staticStyle:{"margin-bottom":"4rem"}},[_c('div',{staticClass:"columns column"},[_c('div',{staticClass:"title_settings"},[_c('svg',{staticClass:"h-6 w-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"}}),_vm._v(" "),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M15 12a3 3 0 11-6 0 3 3 0 016 0z"}})]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.$t("msg.settings.title")))])])]),_vm._v(" "),_c('nav',{staticClass:"tabs_settings"},_vm._l((_vm.items),function(item,index){return _c('span',{key:index,staticClass:"tabs_item",class:_vm.active == index && 'tabs_item_active',on:{"click":function($event){_vm.active = index}}},[_vm._v("\n        "+_vm._s(item)+"\n      ")])}),0),_vm._v(" "),(_vm.active == 0)?_c('div',{staticClass:"tab_content"},[_c('div',{staticClass:"tab_content_left"},[_c('h2',[_vm._v(_vm._s(_vm.$t("msg.settings.profile")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.settings.updateInfoProfile")))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-top":"20px"}},[_c('p',{staticClass:"fat mr_5"},[_vm._v(_vm._s(_vm.$t("msg.email"))+":")]),_vm._v("\n          "+_vm._s(_vm.member.email)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('p',{staticClass:"fat mr_5"},[_vm._v(_vm._s(_vm.$t("msg.phone"))+":")]),_vm._v("\n          +"+_vm._s(_vm.member.phone)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#6b7280","display":"flex","align-items":"center"}},[_c('p',{staticClass:"fat mr_5"},[_vm._v(_vm._s(_vm.$t("msg.settings.profileStatus")))]),_vm._v(" "),(_vm.member.phone && _vm.member.email)?_c('div',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.shield_true)}}):_c('div',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.shield_false)}})])]),_vm._v(" "),_c('div',{staticClass:"tab_content_right"},[_c('div',{staticClass:"combo_1"},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.country_residency")))]),_vm._v(" "),_c('VuePhoneNumberInput',{staticClass:"VuePhoneNumberInput",attrs:{"border-radius":6,"translations":{
              countrySelectorLabel: _vm.$t('msg.phone_code'),
              phoneNumberLabel: _vm.$t('msg.phone_optional'),
            },"color":"#333364","valid-color":"#342365","no-example":_vm.countriesNotAllowed,"error":_vm.countriesNotAllowed},on:{"update":function($event){return _vm.verifyCountry($event)},"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'phone')}},model:{value:(_vm.signupform.phone),callback:function ($$v) {_vm.$set(_vm.signupform, "phone", $$v)},expression:"signupform.phone"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.phone && !_vm.countriesNotAllowed),expression:"hasError.phone && !countriesNotAllowed"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t("msg.phone_already_registered")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countriesNotAllowed),expression:"countriesNotAllowed"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t("msg.invalid_phone_country")))])],1),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.email")))]),_vm._v(" "),_c('svg',{staticClass:"tooltip_disclaimer_new",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"mouseover":function($event){_vm.showInfo['1a'] = true},"mouseleave":function($event){_vm.showInfo['1a'] = false}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.signupform.email),expression:"signupform.email"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.email),attrs:{"type":"text","id":"email","placeholder":"Email*"},domProps:{"value":(_vm.signupform.email)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.signupform, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError.email),expression:"hasError.email"}],staticClass:"help is-danger"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.email_already_registered")))]),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showInfo['1a'])?_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t('msg.create_new_email_recommendation'))}}):_vm._e()])],1)])]):_vm._e(),_vm._v(" "),(_vm.active == 1)?_c('div',{staticClass:"tab_content"},[_c('div',{staticClass:"tab_content_left"},[_c('h2',[_vm._v(_vm._s(_vm.$t("msg.settings.security")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.settings.updateInfoSecurity")))])]),_vm._v(" "),_c('div',{staticClass:"tab_content_right"},[_c('div',{staticClass:"combo_1"},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.current_password")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordOld),expression:"passwordOld"}],staticClass:"input_write_form",attrs:{"placeholder":_vm.$t('msg.current_password') + '*',"type":"password"},domProps:{"value":(_vm.passwordOld)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordOld=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.new_password")))]),_vm._v(" "),_c('svg',{staticClass:"tooltip_disclaimer_new",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"mouseover":function($event){_vm.showInfo['1b'] = true},"mouseleave":function($event){_vm.showInfo['1b'] = false}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.password),attrs:{"type":"password","placeholder":_vm.$t('msg.password_create') + '*'},domProps:{"value":(_vm.password)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'newPassword')},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"bounce"}},[(_vm.showInfo['1b'])?_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t("msg.password_requirements", 1))}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"combo_1"},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.confirm_password")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.passwordConfirmation),expression:"passwordConfirmation"}],staticClass:"input_write_form",style:(_vm.errorInputStyle.passwordConfirmation),attrs:{"type":"password","placeholder":_vm.$t('msg.confirm_password') + '*'},domProps:{"value":(_vm.passwordConfirmation)},on:{"keyup":function($event){return _vm.onChangeRemoveError(_vm.signupform, 'passwordConfirmation')},"input":function($event){if($event.target.composing){ return; }_vm.passwordConfirmation=$event.target.value}}}),_vm._v(" "),(_vm.showInfo['1c'])?_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.$t("msg.confirm_password_error", 1))}}):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.active == 2)?_c('div',{staticClass:"tab_content"},[_c('div',{staticClass:"tab_content_left"},[_c('h2',[_vm._v(_vm._s(_vm.$t("msg.settings.notifications")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.settings.updateInfoNotifications")))])]),_vm._v(" "),_c('div',{staticClass:"tab_content_right"},[_c('div',{staticClass:"combo_1"},[_c('label',[_vm._v(_vm._s(_vm.$t("msg.settings.toggleEmail")))]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('input',{attrs:{"type":"checkbox","name":"toggle","id":"toggle"},domProps:{"checked":_vm.notify}}),_vm._v(" "),_c('label',{attrs:{"for":"toggle"}})])])])]):_vm._e(),_vm._v(" "),(_vm.active == 0)?_c('div',{staticClass:"tab_content_bottom"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.settings.updateProfile")))]),_vm._v(" "),_c('button',{on:{"click":function () { return _vm.callChangeInfo(); }}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.save"))+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.active == 1)?_c('div',{staticClass:"tab_content_bottom"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.settings.updateSecurity")))]),_vm._v(" "),_c('button',{on:{"click":function () { return _vm.callChangePass(); }}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.save"))+"\n      ")])]):_vm._e(),_vm._v(" "),(_vm.active == 2)?_c('div',{staticClass:"tab_content_bottom"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.settings.updateNotification")))]),_vm._v(" "),_c('button',{on:{"click":function () { return _vm.callChangeNotify(); }}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.save"))+"\n      ")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e4c98a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(948);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e4c98a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0",attrs:{"id":"page_help"}},[_c('div',{staticClass:"cointainer_md column combo_1"},[_c('div',{staticClass:"columns column"},[_c('div',{staticClass:"column page_landing_welcome_title is-three-fifths"},[_c('h1',{staticClass:"component_title_lg fat m0_b"},[_c('div',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_question)}}),_vm._v("\n          "+_vm._s(_vm.$tc("msg.help",1))+"\n        ")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column help_buttons tal_l_b"},[_c('div',{staticClass:"main_blue_lt_bg main_blue_lt_bg_hover component_main_button dis_inb"},[_vm._v("TECHNICAL SUPPORT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('p',[_vm._v("Please visit our Documentation and FAQ pages. If you do not find an answer and need further assistance, send us an email. You may also chat with us during regular business hour.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('p',{staticClass:"text_lg"},[_c('span',{staticClass:"main_blue_dk_fill fat"},[_vm._v("Sales")]),_vm._v(" "),_c('span',[_vm._v("support@bluetoken.io")])]),_vm._v(" "),_c('p',{staticClass:"text_lg"},[_c('span',{staticClass:"main_blue_dk_fill fat"},[_vm._v("Support")]),_vm._v(" "),_c('span',[_vm._v("support@bluetoken.io")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466dc576_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__(1048);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_466dc576_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawMain_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6f4e912_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawMain_vue__ = __webpack_require__(987);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6f4e912_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"text_lg p0 tal_c"},[_c('strong',[_vm._v(_vm._s(_vm.$t('msg.enable_2fa')))])])]),_vm._v(" "),_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('p',[_vm._v(_vm._s(_vm.$t('msg.twofa_info')))])])]),_vm._v(" "),_c('div',{staticClass:"column tal_c"},[(_vm.qrcode)?_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.qrcode.href,"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"tal_c"},[_vm._v("\n            "+_vm._s(_vm.otpCode)+"\n            "),_c('i',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.otpCode),expression:"otpCode",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"icon_class_1",attrs:{"type":"button","options":{ width: 200 }},domProps:{"innerHTML":_vm._s(_vm.iconSets.copy)}},[_vm._v(_vm._s(_vm.$t('msg.copy')))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.copy_twofa'))}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.past_2fa"))+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twoFA),expression:"twoFA"}],staticClass:"amount_address",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.twoFA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twoFA=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.postOptConfirm(_vm.twoFA)}}},[_vm._v(_vm._s(_vm.$t("msg.activate")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep0_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_944055c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep0_vue__ = __webpack_require__(955);
function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-944055c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep0_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_944055c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep0_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("24bf2dfc", content, true, {});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-944055c8]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"component_card_tab_select"},[_c('button',{staticClass:"component_card_tab_select_selected"},[_vm._v(" "+_vm._s(_vm.$t("msg.withdraw")))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.switchMode()}}},[_vm._v(" "+_vm._s(_vm.$t("msg.redemption"))+" ")])]),_vm._v(" "),_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column pb0",class:{'has_error_color':!_vm.validation.amount || _vm.minBlue > _vm.bluAmount }},[_c('p',{staticClass:"tal_c"},[_vm._v(_vm._s(_vm.$t("msg.input_amount_withdraw")))]),_vm._v(" "),_c('p',{staticClass:"tal_c",class:{'notice': _vm.bluAmount < _vm.minBlue}},[_vm._v(_vm._s(_vm.$t("msg.min_amount_is"))+": "+_vm._s(_vm.bluValue[0].withdrawMinimal)+" BLUE")]),_vm._v(" "),_c('div',{staticClass:"column blu_input_container_2"},[_c('img',{staticClass:"blu_input_img_2",attrs:{"src":__webpack_require__(956)}}),_vm._v(" "),_c('div',{staticClass:"blu_input_2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],staticClass:"amount_redeem",class:{'has_error_color':!_vm.validation.amount || _vm.minBlue > _vm.bluAmount },domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyBluAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{'arrow_disabled':parseFloat(_vm.bluAmount) <= parseFloat( _vm.minBlue)},on:{"click":function($event){return _vm.modifyBluAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])]),_vm._v(" "),_c('div',{staticClass:"column tal_c pt0"}),_vm._v(" "),_c('p',{staticClass:"tal_c error_text_min"},[(!_vm.validation.amount || _vm.bluAmount < _vm.minBlue)?_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t('msg.invalid_amount'))+".")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column pt0"},[_c('button',{staticClass:"btn_redeem bg_colorSubMainGreenLT",attrs:{"disabled":!_vm.validation.amount || _vm.bluAmount == '' || _vm.bluAmount == 0},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v(_vm._s(_vm.$t("msg.withdraw")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sblu_symbol_outline.svg?82f5a72327108c21aa7dedf4765e8292";

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep02_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6787e590_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep02_vue__ = __webpack_require__(960);
function injectStyle (ssrContext) {
  __webpack_require__(958)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6787e590"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6787e590_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4e6da0a9", content, true, {});

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-6787e590]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card component_card_select component_card_select_white"},[_c('div',{staticClass:"redeem_form"},[_c('div',{staticClass:"component_card_select_title"},[_c('span',{staticClass:"text_m_blu"},[_vm._v(_vm._s(_vm.$t('msg.select_partner')))])]),_vm._v(" "),_c('div',{staticClass:"component_card_select_body"},[_c('div',{staticClass:"component_card_select_button column",on:{"click":function($event){return _vm.selectPartner('stratum')}}},[_c('div',{staticClass:"partner_icon m5_t"},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.smartwallet_stm_icon)}})]),_vm._v(" "),_c('div',{staticClass:"component_card_select_button_text m15_l"},[_c('div',{staticClass:"logo_text bt_orange"},[_c('img',{staticClass:"mw100",attrs:{"src":__webpack_require__(961)}}),_vm._v(" "),_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.smartwallet_font)}})]),_vm._v(" "),_c('p',{staticClass:"fs_small m5_t",domProps:{"innerHTML":_vm._s(_vm.$t('msg.transfer_blu_stratum'))}})])]),_vm._v(" "),_c('div',{staticClass:"component_card_select_button column disabled_button"},[_c('div',{staticClass:"partner_icon m5_t"},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.saw_icon)}})]),_vm._v(" "),_c('div',{staticClass:"component_card_select_button_text m15_l"},[_c('div',{staticClass:"logo_text bt_orange_sw"},[_c('img',{staticClass:"mw100",attrs:{"src":__webpack_require__(962)}}),_vm._v(" "),_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.crypto_wallet_font)}})]),_vm._v(" "),_c('p',{staticClass:"fs_small m5_t",domProps:{"innerHTML":_vm._s(_vm.$t('msg.transfer_blu_stratum_withdraw_sw'))}})])]),_vm._v(" "),_c('div',{staticClass:"component_card_select_button column disabled_button",on:{"click":function($event){return _vm.selectPartner('stratumx')}}},[_c('div',{staticClass:"partner_icon m5_t"},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.exchange_sx_icon)}})]),_vm._v(" "),_c('div',{staticClass:"component_card_select_button_text m15_l"},[_c('div',{staticClass:"logo_text bt_blue"},[_c('img',{staticClass:"mw100",attrs:{"src":__webpack_require__(963)}}),_vm._v(" "),_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.exchange_font)}})]),_vm._v(" "),_c('p',{staticClass:"fs_small m5_t",domProps:{"innerHTML":_vm._s(_vm.$t('msg.transfer_blu_stx'))}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "withdraw_stm_button_1.svg?89cd299b5696d455d3a1571fb2b2ac38";

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "withdraw_saw_button_stratum.svg?55a8306d761dd6c36996c59898a77a07";

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "withdraw_stmx_button_1.svg?918a5da65f2b3c3e2cd6f00e39163b97";

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep03_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f55ed96_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep03_vue__ = __webpack_require__(971);
function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f55ed96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f55ed96_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("de08d072", content, true, {});

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-7f55ed96]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}.withdraw-step1[data-v-7f55ed96]{display:flex;color:#363636;margin-bottom:12px}.copy-clip[data-v-7f55ed96]{display:flex;color:#60609b;justify-content:space-around}.split-blocks[data-v-7f55ed96]{margin-bottom:12px}.bsc-info[data-v-7f55ed96]{display:flex;justify-content:space-between}.instructs[data-v-7f55ed96]{display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:18px;border-top:1px solid #d8d6d6;border-bottom:1px solid #d8d6d6}.or[data-v-7f55ed96]{text-align:center}.step[data-v-7f55ed96]{width:85%;margin-bottom:18px;text-align:left}", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalWarnWithdraw_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c246018e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalWarnWithdraw_vue__ = __webpack_require__(970);
function injectStyle (ssrContext) {
  __webpack_require__(968)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalWarnWithdraw_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c246018e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalWarnWithdraw_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(969);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("55aee868", content, true, {});

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.modal_wrapper{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:0 auto;display:flex;align-items:center;justify-content:center;max-width:450px;width:100%}.modal_wrapper .modal_container{width:100%;max-width:450px;margin:0 auto;background-color:#fff;border-radius:8px}.modal_wrapper .modal_container .modal_header{position:relative;display:flex;align-items:center;justify-content:center;padding:1rem 10px;border-top-left-radius:8px;border-top-right-radius:8px;border-bottom:1px solid #342365}.modal_wrapper .modal_container .modal_header h1{color:#342365;font-weight:600;font-size:1.2rem}.modal_wrapper .modal_container .modal_header svg{width:1.5rem;position:absolute;right:1rem;cursor:pointer;color:#342365}.modal_wrapper .modal_container .modal_content{display:flex;align-items:start;justify-content:center;flex-direction:column;color:#000;padding:1rem 2rem}.modal_wrapper .modal_container .modal_content .items{display:grid;grid-template-columns:1fr 10fr;padding-bottom:1rem;width:100%}.modal_wrapper .modal_container .modal_content .items svg{margin-top:5px;width:1.2rem;height:1.2rem}.modal_wrapper .modal_container .modal_content .items span{font-size:14px}.modal_wrapper .modal_container .modal_content button{flex:1;outline:none;background:#342365;color:#fff;padding:10px 15px;border-radius:6px;border:none;width:100%}@media only screen and (max-width:400px){.modal_wrapper .modal_container{max-width:350px}}", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal_mask",attrs:{"id":"modal_pool"},on:{"click":function($event){return _vm.closeModalWarnWithdraw()}}}),_vm._v(" "),_c('div',{staticClass:"modal_wrapper"},[_c('div',{staticClass:"modal_container"},[_c('div',{staticClass:"modal_header"},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.modalWarnUser.title")))]),_vm._v(" "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.closeModalWarnWithdraw()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})])]),_vm._v(" "),_c('div',{staticClass:"modal_content"},[_c('div',{staticClass:"items"},[_c('svg',{staticClass:"h-6 w-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M5 13l4 4L19 7"}})]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"start"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalWarnUser.warn1'))}})]),_vm._v(" "),_c('div',{staticClass:"items"},[_c('svg',{staticClass:"h-6 w-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M5 13l4 4L19 7"}})]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"start"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalWarnUser.warn2'))}})]),_vm._v(" "),_c('div',{staticClass:"items"},[_c('svg',{staticClass:"h-6 w-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M5 13l4 4L19 7"}})]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"start"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalWarnUser.warn3'))}})]),_vm._v(" "),_c('div',{staticClass:"items"},[_c('svg',{staticClass:"h-6 w-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M5 13l4 4L19 7"}})]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"start"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.modalWarnUser.warn4'))}})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.understandWarnWithdraw()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.i_understand"))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p0 withdraw_wrapper"},[_c('div',{staticClass:"header_withdraw"},[_c('p',[_vm._v("\n      "+_vm._s(_vm.$t("msg.available_balance"))+"\n      "),(_vm.selectedBlue)?_c('span',[_vm._v(_vm._s(_vm.bluAccount.balanceAvailable.toFixed(6))+" BLUE")]):_c('span',[_vm._v(_vm._s(_vm.usdtAccount.balanceAvailable.toFixed(4))+" USDT")])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"30px","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","font-size":"9px"}},[_c('div',{staticStyle:{"width":"60%","display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"margin-left":"10px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_amount")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.step_recipient")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.step_verification")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.$t("msg.step_authentication")))])])])]),_vm._v(" "),(_vm.selectedBlue)?_c('div',{staticClass:"redeem_form p0"},[_c('div',{staticClass:"tal_c"},[_c('span',{staticClass:"text_m_blu"},[_vm._v(_vm._s(_vm.$t("msg.inform_the_amount_blu_tag")))]),_vm._v(" "),_c('div',{staticClass:"column p0"},[_c('div',{staticClass:"column",class:{
            has_error_color: !_vm.validation.amount || _vm.minBlue > _vm.bluAmount,
          }},[_c('p',{staticClass:"tal_c"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.input_amount_withdraw"))+"\n          ")]),_vm._v(" "),_c('p',{staticClass:"tal_c",class:{ notice: _vm.bluAmount < _vm.minBlue }},[_vm._v("\n            "+_vm._s(_vm.$t("msg.min_amount_is"))+":\n            "+_vm._s(_vm.bluValue[0].withdrawMinimal)+" BLUE\n          ")]),_vm._v(" "),_c('div',{staticClass:"column blu_input_container_2",staticStyle:{"padding-bottom":"0 !important"}},[_c('img',{staticClass:"blu_input_img_2",attrs:{"src":__webpack_require__(11)}}),_vm._v(" "),_c('div',{staticClass:"blu_input_2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],staticClass:"amount_redeem",class:{
                  has_error_color: !_vm.validation.amount || _vm.minBlue > _vm.bluAmount,
                },domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyBluAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{
                  arrow_disabled:
                    parseFloat(_vm.bluAmount) <= parseFloat(_vm.minBlue),
                },on:{"click":function($event){return _vm.modifyBluAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])]),_vm._v(" "),(!_vm.validation.amount || _vm.bluAmount < _vm.minBlue)?_c('p',{staticClass:"tal_c error_text_min"},[_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t("msg.invalid_amount"))+".")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"wrapper_withdraw_form"},[_c('div',{staticClass:"split-blocks"},[_c('div',{staticClass:"tag_container"},[_c('div',{staticStyle:{"width":"60%","display":"flex","align-items":"center","justify-content":"start","text-align":"left","margin-right":"5px","font-size":"0.9rem"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.send_to_blu_adress_on'))}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"custom-flex"},[_c('div',{staticClass:"icon-container"},[_c('i',{staticClass:"icon_class_2 m_auto",domProps:{"innerHTML":_vm._s(_vm.iconSets.blu_wallet)}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"amount_address",staticStyle:{"width":"100%"},attrs:{"type":"text","maxlength":"42"},domProps:{"value":(_vm.address)},on:{"keyup":function($event){return _vm.validateAdress(_vm.address)},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"fs_0001r",class:(_vm.validation.address && _vm.address !== '') ? 'has_error_text' : ''},[_vm._v("\n            "+_vm._s(_vm.$t("msg.make_sure_address"))+"\n          ")])]),_vm._v(" "),(_vm.modalWarn)?_c('div',[_c('modal-warn-withdraw',{on:{"closeModalWarnWithdraw":function($event){return _vm.toggleModalWarn()},"understandWarnWithdraw":function($event){return _vm.understandModalWarn()}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper_withdraw_form"},[_c('button',{staticClass:"btn_redeem",attrs:{"disabled":_vm.onLoadValidation ? _vm.onLoadValidation : _vm.validation.address && _vm.validation.amount},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.next_step"))+"\n          ")])])])])]):_c('div',{staticClass:"redeem_form p0"},[_c('div',{staticClass:"tal_c"},[_c('span',{staticClass:"text_m_blu"},[_vm._v(_vm._s(_vm.$t("msg.input_text_USDT")))]),_vm._v(" "),_c('div',{staticClass:"column p0"},[_c('div',{staticClass:"column",class:{
            has_error_color: !_vm.validation.amount || _vm.minUSDT > _vm.usdtAmount,
          }},[_c('p',{staticClass:"tal_c"},[_vm._v(_vm._s(_vm.$t("msg.input_text_invalid_USDT")))]),_vm._v(" "),_c('p',{staticClass:"tal_c",class:{ notice: _vm.usdtAmount < _vm.minUSDT }},[_vm._v("\n            "+_vm._s(_vm.$t("msg.min_amount_is"))+": 2 USDT\n          ")]),_vm._v(" "),_c('div',{staticClass:"column blu_input_container_2",staticStyle:{"padding-bottom":"0 !important"}},[_c('img',{staticClass:"blu_input_img_2",attrs:{"src":__webpack_require__(29)}}),_vm._v(" "),_c('div',{staticClass:"blu_input_2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usdtAmount),expression:"usdtAmount"}],staticClass:"amount_redeem",class:{
                  has_error_color: !_vm.validation.amount || _vm.usdtAmount < _vm.minUSDT,
                },domProps:{"value":(_vm.usdtAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.usdtAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyUSDTAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{
                  arrow_disabled: parseFloat(_vm.usdtAmount) <= _vm.minUSDT,
                },on:{"click":function($event){return _vm.modifyUSDTAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])]),_vm._v(" "),(!_vm.validation.amount || _vm.usdtAmount < _vm.minUSDT)?_c('p',{staticClass:"tal_c error_text_min"},[_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t("msg.invalid_amount"))+".")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"wrapper_withdraw_form"},[_c('div',{staticClass:"split-blocks"},[_c('div',{staticClass:"tag_container"},[_c('div',{staticStyle:{"width":"70%","display":"flex","align-items":"center","justify-content":"start","text-align":"left","font-size":"0.9rem"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.input_valid_usdt"))+":")])]),_vm._v(" "),_c('div',{staticClass:"balance_tag_reverse tab_black"},[_vm._v("TRON (TRC20)")])])]),_vm._v(" "),_c('div',{staticClass:"custom-flex"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"amount_address",staticStyle:{"width":"100%"},attrs:{"type":"text","maxlength":"34"},domProps:{"value":(_vm.address)},on:{"keyup":function($event){return _vm.validateAdress(_vm.address)},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('span',{staticClass:"fs_0001r",class:(_vm.validation.address && _vm.address !== '') ? 'has_error_text' : '',staticStyle:{"text-align":"left"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.usdt_info_trc20")))])])]),_vm._v(" "),(!_vm.selectedBlue)?_c('div',{staticStyle:{"text-align":"start","margin-top":"0.5rem"}},[_c('p',[_vm._v(_vm._s(_vm.$tc("msg.fee", 1))+": 2 USDT")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"wrapper_withdraw_form"},[_c('button',{staticClass:"btn_redeem",attrs:{"disabled":_vm.onLoadValidation ? _vm.onLoadValidation : _vm.validation.address || !_vm.validation.amount},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.next_step"))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw_steps_img"},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(415)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance_tag_reverse tab_black",staticStyle:{"padding":"0rem 0.7rem"}},[_c('img',{attrs:{"src":__webpack_require__(416)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container",staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"icon_class_2_5 background_ val_m background_USDT"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep1_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765ad56d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep1_vue__ = __webpack_require__(975);
function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-765ad56d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765ad56d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("67a740de", content, true, {});

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-765ad56d]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column",class:{'has_error':!_vm.validation.amount || _vm.minBlue > _vm.bluAmount }},[_c('p',{staticClass:"tal_c"},[_vm._v(_vm._s(_vm.$t("msg.input_amount_withdraw")))]),_vm._v(" "),_c('div',{staticClass:"column blu_input_container"},[_c('img',{staticClass:"blu_input_img",attrs:{"src":__webpack_require__(976)}}),_vm._v(" "),_c('div',{staticClass:"blu_input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],staticClass:"amount_redeem",domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyBluAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{'arrow_disabled':parseFloat(_vm.bluAmount) <= parseFloat( _vm.minBlue)},on:{"click":function($event){return _vm.modifyBluAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])]),_vm._v(" "),_c('p',{staticClass:"tal_c"},[(!_vm.validation.amount || _vm.bluAmount < _vm.minBlue)?_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t('msg.invalid_amount'))+".")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column text_sm",staticStyle:{"display":"flex","align-items":"center"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"column tal_r"}),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.send_to_blu_adress'))}}),_vm._v(" "),_c('div',{staticClass:"custom-flex"},[_c('div',{staticClass:"icon-container"},[_c('i',{staticClass:"icon_class_2 m_auto",domProps:{"innerHTML":_vm._s(_vm.iconSets.blu_wallet)}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address),expression:"address"}],staticClass:"amount_address",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.address)},on:{"keyup":function($event){return _vm.validateAdress(_vm.address)},"input":function($event){if($event.target.composing){ return; }_vm.address=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"tal_c"},[(_vm.validation.address)?_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t("msg.error_withdraw_address")))]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"fat upper m13_t"},[_vm._v(_vm._s(_vm.$t("msg.tag")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.externalId),expression:"externalId"}],staticClass:"amount_address",staticStyle:{"width":"100%"},attrs:{"type":"number"},domProps:{"value":(_vm.externalId)},on:{"keyup":function($event){return _vm.validateAdress(_vm.address)},"input":function($event){if($event.target.composing){ return; }_vm.externalId=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"text_ssm"},[_vm._v(_vm._s(_vm.$t("msg.tag_important")))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",attrs:{"disabled":_vm.validation.address || _vm.externalId == '' || !_vm.validation.amount},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v(_vm._s(_vm.$t("msg.next_step")))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column"},[_c('div',{staticClass:"component_border_bottom"},[_c('span')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "stratumBlue-icon.svg?5dd0756ca4f1c3aea3a884a907c9ee49";

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep2_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cd4432_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep2_vue__ = __webpack_require__(978);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cd4432_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw_step2"},[_c('div',{staticClass:"header_withdraw"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.verify_your_withdraw")))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"30px","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","font-size":"9px"}},[_c('div',{staticStyle:{"width":"60%","display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"margin-left":"10px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_amount")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_recipient")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.step_verification")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t("msg.step_authentication")))])])])]),_vm._v(" "),(_vm.selectedBlue)?_c('div',{staticClass:"redeem_form mw100"},[_c('div',{staticClass:"mw100"},[_c('p',{staticStyle:{"margin-bottom":"1rem","text-align":"center"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.please_verify_information"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"column display_values_redeem",staticStyle:{"border-bottom":"none !important","border-right":"none !important","border-left":"none !important"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.withdrawing")))]),_vm._v(" "),(_vm.previewData.amount)?_c('span',[_vm._v("\n          "+_vm._s(_vm._f("decimalsCrypto")(_vm.previewData.amount,_vm.previewData.currency.precision))+"\n          BLUE\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column display_values_redeem",staticStyle:{"border-bottom":"none !important"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.receiving")))]),_vm._v(" "),(_vm.previewData.amount)?_c('span',{staticClass:"m4_b"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.subtotal"))+":\n          "+_vm._s(_vm._f("decimalsCrypto")(_vm.previewData.amount,_vm.previewData.currency.precision))+"\n          BLUE\n        ")]):_vm._e(),_vm._v(" "),(_vm.previewData.amount)?_c('span',{staticClass:"m4_b"},[_vm._v("\n          "+_vm._s(_vm.$tc("msg.fee", 1))+": 0.00 BLUE\n        ")]):_vm._e(),_vm._v(" "),(_vm.previewData.amount)?_c('span',{staticClass:"fat"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.total"))+":\n          "+_vm._s(_vm._f("decimalsCrypto")(_vm.previewData.amount,_vm.previewData.currency.precision))+"\n          BLUE\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column display_values_redeem"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.send_to_btc_adress"))+":")]),_vm._v(" "),_c('span',{staticClass:"m4_b"},[_vm._v("\n          "+_vm._s(_vm.address)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"fat"},[_vm._v(" "+_vm._s(_vm.$t("msg.network"))+": BSC ")])]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.callBackStep()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.back"))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%","margin-right":"0"},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.next_step"))+"\n        ")])])])]):_c('div',{staticClass:"redeem_form mw100"},[_c('div',{staticClass:"mw100"},[_c('p',{staticStyle:{"margin-bottom":"1rem","text-align":"center"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.please_verify_information"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"column display_values_redeem",staticStyle:{"border-bottom":"none !important"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.withdrawing")))]),_vm._v(" "),(_vm.previewData.amount)?_c('span',[_vm._v("\n          "+_vm._s(_vm._f("decimalsCrypto")(_vm.previewData.amount,_vm.previewData.currency.precision))+"\n          USDT\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column display_values_redeem",staticStyle:{"border-bottom":"none !important"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.receiving")))]),_vm._v(" "),(_vm.previewData.amount)?_c('span',{staticClass:"m4_b"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.subtotal"))+":\n          "+_vm._s(_vm._f("decimalsCrypto")(_vm.previewData.amount,_vm.previewData.currency.precision))+"\n          USDT\n        ")]):_vm._e(),_vm._v(" "),(_vm.previewData.amount)?_c('span',{staticClass:"m4_b"},[_vm._v("\n          "+_vm._s(_vm.$tc("msg.fee", 1))+": "+_vm._s(_vm.feeUsdt)+" USDT\n        ")]):_vm._e(),_vm._v(" "),(_vm.previewData.amount)?_c('span',{staticClass:"fat"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.total"))+":\n          "+_vm._s(_vm._f("decimalsCrypto")((_vm.previewData.amount - _vm.feeUsdt),_vm.previewData.currency.precision))+"\n          USDT\n        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column display_values_redeem"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.send_to_btc_adress"))+":")]),_vm._v(" "),_c('span',{staticClass:"m4_b"},[_vm._v("\n          "+_vm._s(_vm.address)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"fat"},[_vm._v(" "+_vm._s(_vm.$t("msg.network"))+": TRC20 ")])]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.callBackStep()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.back"))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%","margin-right":"0"},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.next_step"))+"\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw_steps_img"},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(419)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep3_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dda5938_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep3_vue__ = __webpack_require__(980);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dda5938_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"header_withdraw"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.authenticate")))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"30px","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","font-size":"9px"}},[_c('div',{staticStyle:{"width":"60%","display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"margin-left":"10px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_amount")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_recipient")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_verification")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t("msg.step_authentication")))])])])]),_vm._v(" "),_c('h1',{staticClass:"text_lg p0 tal_c"},[_c('strong',{staticClass:"text_m_blu"},[_vm._v(_vm._s(_vm.$t("msg.authenticate")))])]),_vm._v(" "),(_vm.selectedBlue)?_c('div',{staticClass:"columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_step_3'))}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_pin")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin),expression:"pin"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pin=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"text_sm"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.check_your_email_for_pin_redeem"))+"\n          "+_vm._s(_vm.$t("msg.if_no_email_spam"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_2fa")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twoFA),expression:"twoFA"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.twoFA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twoFA=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.cancelRedeem()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.cancel"))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.pin || !_vm.twoFA},on:{"click":function($event){return _vm.confirmRedeem()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.withdraw"))+"\n        ")])])])]):_c('div',{staticClass:"columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_step_3'))}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_pin")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin),expression:"pin"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pin=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"text_sm"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.check_your_email_for_pin_redeem"))+"\n          "+_vm._s(_vm.$t("msg.if_no_email_spam"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_2fa")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twoFA),expression:"twoFA"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.twoFA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twoFA=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.cancelRedeem()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.cancel"))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.pin || !_vm.twoFA},on:{"click":function($event){return _vm.confirmRedeem()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.withdraw"))+"\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"withdraw_steps_img"},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(421)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep4_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_405165f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep4_vue__ = __webpack_require__(982);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_405165f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('div',{staticClass:"column upper fat"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.confirm_withdraw"))+"\n        ")]),_vm._v(" "),(_vm.selectedBlue)?_c('div',{staticClass:"column"},[_c('p',{staticClass:"fat amount_withdraw"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.amount_revice_withdraw"))+"\n            "),(_vm.withdrawData.amount)?_c('span',[_vm._v(_vm._s(_vm.withdrawData.amount ? _vm.withdrawData.amount.toFixed(6) : ''))]):_vm._e(),_vm._v("\n            BLUE \n            "),_c('br'),_vm._v(" ("+_vm._s(_vm.$t("msg.amount_revice_withdraw_fee"))+" "+_vm._s(_vm.withdrawData.fee ? _vm.withdrawData.fee.toFixed(6) : '0.00')+" BLUE)\n          ")])]):_c('div',{staticClass:"column"},[_c('p',{staticClass:"fat amount_withdraw"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.amount_revice_withdraw"))+"\n            "),(_vm.withdrawData.amount)?_c('span',[_vm._v(_vm._s(_vm.withdrawData.amount ? _vm.withdrawData.amount.toFixed(2) : ''))]):_vm._e(),_vm._v("\n            USDT \n            "),_c('br'),_vm._v("\n            ("+_vm._s(_vm.$t("msg.amount_revice_withdraw_fee"))+" "+_vm._s(_vm.withdrawData.fee ? _vm.withdrawData.fee.toFixed(2) : '2')+" USDT)\n          ")])]),_vm._v(" "),_c('div',{staticClass:"column email-info"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_address_step_4'))}}),_vm._v(" "),_c('p',{staticClass:"withdraw-address-final-step"},[_vm._v(_vm._s(_vm.withdrawData.address))])]),_vm._v(" "),_c('div',{staticClass:"column email-info"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_email_step_4'))}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_withdraw_step_4'))}})]),_vm._v(" "),_c('div',{staticClass:"column upper"},[_c('router-link',{attrs:{"to":"/transactions/withdraw"}},[_vm._v(_vm._s(_vm.$t("msg.view_status")))])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep9_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3f7c5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep9_vue__ = __webpack_require__(984);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStep9_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3f7c5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStep9_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column columns redeem_form mw100 component_card"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('div',{staticClass:"column upper"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.failed"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"action_blocked_message"},[(_vm.error)?_c('span',[_vm._v(_vm._s(_vm.$t(("msg." + (_vm.error.replaceAll(/\s/g,''))))))]):_c('span',[_vm._v(_vm._s(_vm.$t('msg.redeem_deleted_error')))])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.resetStep()}}},[_vm._v(_vm._s(_vm.$t("msg.back")))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStepStart_vue__ = __webpack_require__(424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a401a2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStepStart_vue__ = __webpack_require__(986);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawStepStart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a401a2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawStepStart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('span',{staticClass:"text_m_blu"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.withdrawal_steps"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem bg_colorSubMainGreenLT",on:{"click":function($event){return _vm.callFirstStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.start_withdrawal"))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing_redeem"}},[(!_vm.authorized)?_c('redeem-2fa',{on:{"getOptStatus":_vm.getOtpStatus,"switchMode":function($event){return _vm.switchMode()}}}):_vm._e(),_vm._v(" "),(_vm.step == 3 && _vm.authorized)?_c('withdraw-step03',{attrs:{"setAmount":this.withdraw.amount,"selectedPartner":this.selectedPartner,"selectedBlue":_vm.selectedBlue},on:{"backToPartners":_vm.backToPartners,"callNext":_vm.callStepPreview,"switchMode":function($event){return _vm.switchMode()}}}):_vm._e(),_vm._v(" "),(_vm.step == 4)?_c('withdraw-step2',{attrs:{"previewData":_vm.previewData,"address":_vm.address,"externalId":_vm.externalId,"selectedBlue":_vm.selectedBlue},on:{"callNext":_vm.callStepWithdraw,"resetStep":_vm.setFirstStep}}):_vm._e(),_vm._v(" "),(_vm.step == 5)?_c('withdraw-step3',{attrs:{"withdrawData":_vm.withdrawData,"selectedBlue":_vm.selectedBlue,"address":_vm.address},on:{"confirmWithdraw":_vm.withdrawConfirm,"cancelRedeem":_vm.resetRedeem,"callWithdrawUsdt":_vm.callWithdrawUsdt}}):_vm._e(),_vm._v(" "),(_vm.step == 6)?_c('withdraw-step4',{attrs:{"withdrawData":_vm.withdrawData,"selectedBlue":_vm.selectedBlue}}):_vm._e(),_vm._v(" "),(_vm.step == 9 && _vm.authorized)?_c('withdraw-step9',{attrs:{"error":_vm.error,"dayEnabled":_vm.redeemInfo.dayAllowed},on:{"resetStep":_vm.setFirstStep}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepositMain_vue__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bef592_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepositMain_vue__ = __webpack_require__(995);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepositMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bef592_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepositMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepoistStepStart_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b759ec4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepoistStepStart_vue__ = __webpack_require__(990);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepoistStepStart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b759ec4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepoistStepStart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('span',{staticClass:"text_m_blu"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.deposit"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column"},[(_vm.buttonBlock)?_c('button',{staticClass:"btn_redeem bg_colorSubMainLatestGreen"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.create_deposit_address"))+"\n          ")]):_c('button',{staticClass:"btn_redeem bg_colorSubMainGreenLT",on:{"click":function($event){return _vm.callFirstStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.create_deposit_address"))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepositStep1_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325f5007_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepositStep1_vue__ = __webpack_require__(994);
function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-325f5007"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DepositStep1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325f5007_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DepositStep1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("371865c8", content, true, {});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-325f5007]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit_wrapper"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","margin-top":"20px"}},[_c('h1',{staticClass:"fat m0_b main_blue_dk_fill",staticStyle:{"font-size":"1.1rem"}},[_vm._v("\n      "+_vm._s(_vm.$tc("msg.deposit", 1))+"\n    ")])]),_vm._v(" "),_c('div',{staticClass:"redeem_form"},[_c('div',{staticStyle:{"justify-content":"center","display":"flex"}},[_c('qrcode',{attrs:{"value":_vm.address,"options":{ width: 200 }}})],1),_vm._v(" "),_c('div',{staticClass:"tag_container"},[(!_vm.selectedBlue)?_c('div',{staticClass:"balance_tag_reverse tab_black_tron tab_black"},[_vm._v("\n        TRON (TRC20)\n      ")]):_c('div',{staticClass:"balance_tag_reverse tab_black",staticStyle:{"padding":"0rem 0.7rem"}},[_c('img',{attrs:{"src":__webpack_require__(416)}})])])]),_vm._v(" "),_c('div',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.address),expression:"address",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"pointer"},[_c('div',{staticClass:"button_address_copy"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.address)+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"capitalize",staticStyle:{"margin-top":"5px"}},[_c('span',{staticClass:"icon_class_1",domProps:{"innerHTML":_vm._s(_vm.iconSets.copy)}})])])]),_vm._v(" "),_c('div',{staticClass:"column redeem_form"},[_c('div',{staticStyle:{"justify-content":"center","display":"flex","font-size":"0.8rem"}},[_c('router-link',{attrs:{"to":"/transactions/deposits"}},[_vm._v(_vm._s(_vm.$t("msg.view_all_transactions")))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0",attrs:{"id":"landing_redeem"}},[(!_vm.authorized)?_c('redeem-2fa',{on:{"getOptStatus":_vm.getOtpStatus,"switchMode":function($event){return _vm.switchMode()}}}):_vm._e(),_vm._v(" "),(_vm.step == 'start' && _vm.authorized)?_c('DepositStepStart',{attrs:{"buttonBlock":this.buttonBlock,"selectedBlue":_vm.selectedBlue},on:{"callFirstStep":_vm.callFirstStep}}):_vm._e(),_vm._v(" "),(_vm.step == 1)?_c('DepositStep1',{attrs:{"selectedBlue":_vm.selectedBlue,"address":this.blueAddress}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedemptionMain_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631481bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedemptionMain_vue__ = __webpack_require__(1027);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedemptionMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631481bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedemptionMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep1_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1a077c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep1_vue__ = __webpack_require__(1016);
function injectStyle (ssrContext) {
  __webpack_require__(998)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd1a077c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1a077c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(999);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("0ea8fcd6", content, true, {});

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-cd1a077c]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports


/***/ }),
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column text_m_blu tal_c p30-l-r main_blue_dk_bg",staticStyle:{"font-size":"18px","color":"white","border-radius":"8px 8px 0px 0px"}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t("msg.available_balance"))+" "+_vm._s(this.getUnlockedBalance())+" BLUE\n    ")])]),_vm._v(" "),_c('div',{staticClass:"redeem_form mw100"},[_c('div',[_c('div',[_c('div',{staticClass:"column pb0",class:{
            has_error_color: !_vm.validation.amount || _vm.bluAmount < _vm.minBlue,
          }},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"30px","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","font-size":"9px"}},[_c('div',{staticStyle:{"width":"60%","display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"margin-left":"10px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_amount")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.step_recipient")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.step_verification")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t("msg.step_authentication")))])])])]),_vm._v(" "),(_vm.redeemPreview.targetCurrency)?_c('p',{staticClass:"tal_c main_blue_dk_fill fat",staticStyle:{"margin-bottom":"30px"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.input_blue_amount"))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.redeemPreview.targetCurrency)?_c('p',{staticClass:"tal_c",staticStyle:{"margin-bottom":"30px"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.input_amount_redeem"))+"\n            "),_c('span',{staticClass:"block"},[_vm._v("\n              "+_vm._s(_vm.$t("msg.min_amount_is"))+": "+_vm._s(_vm.minBlue)+" BLUE\n            ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column blu_input_container_2"},[_c('img',{staticClass:"blu_input_img_2",attrs:{"src":__webpack_require__(11)}}),_vm._v(" "),_c('div',{staticClass:"blu_input_2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],staticClass:"amount_redeem",class:{
                  has_error_color: !_vm.validation.amount || _vm.bluAmount < _vm.minBlue,
                },domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyBluAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{
                  arrow_disabled:
                    parseFloat(_vm.bluAmount) <= parseFloat(_vm.minBlue),
                },on:{"click":function($event){return _vm.modifyBluAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])])]),_vm._v(" "),_c('p',{staticClass:"tal_c"},[(!_vm.validation.amount || _vm.bluAmount < _vm.minBlue)?_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t("msg.invalid_amount"))+".")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column m13_t",staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticClass:"custon-w-m",staticStyle:{"width":"70%"}},[(_vm.bluValue)?_c('p',{staticClass:"fat",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"icon_class_1 background_ val_m background_USDT"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.$t("msg.equivalent"))+" USDT:")]),_vm._v("\n              "+_vm._s(_vm._f("decimalsCrypto")((_vm.bluValue[0].value * _vm.bluAmount),2))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.bluValue)?_c('div',[(
                  _vm.redeemInfo.wave &&
                  _vm.redeemInfo.waveRule >= _vm.bluValue[0].value * _vm.bluAmount
                )?_c('div',[_c('span',{staticClass:"icon_class_1 background_ val_m background_USDT",staticStyle:{"opacity":"0"}}),_vm._v("\n                "+_vm._s(_vm.$tc("msg.fee"))+":\n                "),_c('span',[_vm._v(_vm._s(_vm.redeemInfo.feeWave.toFixed(2))+" USDT")])]):_c('div',[_c('span',{staticClass:"icon_class_1 background_ val_m background_USDT",staticStyle:{"opacity":"0"}}),_vm._v("\n                "+_vm._s(_vm.$tc("msg.fee", 1))+" ("+_vm._s(_vm.feeTax.fee)+"%):\n                "),(
                    (_vm.bluValue[0].value * _vm.bluAmount * _vm.feeTax.fee) / 100 >=
                    _vm.feeTaxAbsolute.fee
                  )?_c('span',[_vm._v(_vm._s((
                      (_vm.bluValue[0].value * _vm.bluAmount * _vm.feeTax.fee) /
                      100
                    ).toFixed(2)))]):_c('span',[_vm._v(_vm._s(_vm.feeTaxAbsolute.fee.toFixed(2))+" USDT")])])]):_vm._e(),_vm._v(" "),(_vm.bluValue)?_c('p',{staticStyle:{"margin-bottom":"5px","font-size":"13px","margin-left":"25px"}},[(
                  _vm.redeemInfo.wave &&
                  _vm.redeemInfo.waveRule >
                    _vm.bluValue[0].value * _vm.bluAmount * _vm.feeTax.fee
                )?_c('span',{staticClass:"fs_0001r"},[_vm._v("\n                "+_vm._s(_vm.$t("msg.fee_redeem_wave_info"))+"\n              ")]):_c('span',{staticClass:"fs_0001r"},[_vm._v("\n                "+_vm._s(_vm.$t("msg.fee_info_redeem_one"))+" "+_vm._s(_vm.feeTax.fee)+"%\n                "+_vm._s(_vm.$t("msg.fee_info_redeem_two"))+"\n                "+_vm._s(_vm.feeTaxAbsolute.fee)+" USDT\n              ")])]):_vm._e(),_vm._v(" "),(_vm.bluValue)?_c('p',{staticClass:"fat"},[_c('span',{staticClass:"icon_class_1 background_ val_m background_USDT",staticStyle:{"opacity":"0"}}),_vm._v("\n              "+_vm._s(_vm.$t("msg.total_to_receive"))+": "+_vm._s(_vm.getTotalWithFee())+" USDT\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem btn_radius",attrs:{"disabled":!_vm.validation.amount || _vm.bluAmount < _vm.minBlue},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.next_step"))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center"}},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(415)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep2_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83bdaf48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep2_vue__ = __webpack_require__(1018);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83bdaf48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column text_m_blu tal_c p30-l-r main_blue_dk_bg",staticStyle:{"font-size":"18px","color":"white","border-radius":"8px 8px 0px 0px"}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t("msg.available_balance"))+" "+_vm._s(this.getUnlockedBalance())+" BLUE\n    ")])]),_vm._v(" "),_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"30px","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","font-size":"9px"}},[_c('div',{staticStyle:{"width":"60%","display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"margin-left":"10px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_amount")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_recipient")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px"}},[_vm._v(_vm._s(_vm.$t("msg.step_verification")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t("msg.step_authentication")))])])])]),_vm._v(" "),_c('p',{staticClass:"tal_c main_blue_dk_fill fat",staticStyle:{"margin-bottom":"30px"}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.input_usdt_address"))+"\n        ")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"15px"}},[_c('p',{staticStyle:{"font-size":"14px"}},[_vm._v("\n              "+_vm._s(_vm.$t("msg.input_valid_usdt"))+"\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usdtAddress),expression:"usdtAddress"}],staticClass:"amount_redeem",domProps:{"value":(_vm.usdtAddress)},on:{"keyup":function($event){return _vm.validateAddress()},"input":function($event){if($event.target.composing){ return; }_vm.usdtAddress=$event.target.value}}})]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.usdt_info_trc20"))+"\n          ")]),_vm._v(" "),(_vm.haveError)?_c('p',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.invalid_address"))+"\n          ")]):_c('p',{staticStyle:{"font-size":"12px","color":"red","opacity":"0"}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.invalid_address"))+"\n          ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.delivery_speed")))]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"display":"flex","font-size":"13px","align-items":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.picked),expression:"picked"}],staticStyle:{"width":"12px"},attrs:{"type":"radio","id":"one","value":"slow"},domProps:{"checked":_vm._q(_vm.picked,"slow")},on:{"change":function($event){_vm.picked="slow"}}}),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"10px"},attrs:{"for":"one"}},[_c('strong',[_vm._v("3 "+_vm._s(_vm.$t("msg.business_day"))+".")]),_vm._v("\n                "+_vm._s(_vm.$t("msg.no_additional_fee"))+"\n              ")])]),_vm._v(" "),(_vm.previewData.targetAmount > _vm.feeTaxRush.fee)?_c('div',{staticStyle:{"display":"flex","font-size":"13px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.picked),expression:"picked"}],staticStyle:{"width":"12px"},attrs:{"type":"radio","id":"two","value":"fast"},domProps:{"checked":_vm._q(_vm.picked,"fast")},on:{"change":function($event){_vm.picked="fast"}}}),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"margin-left":"10px"},attrs:{"for":"two"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.rush_today"))+".")]),_vm._v("\n                  "+_vm._s(_vm.$tc("msg.fee", 1))+" (+"+_vm._s(_vm.feeTaxRush.fee)+" USDT)\n                ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"10px","font-size":"11px"}},[_vm._v("\n                  "+_vm._s(_vm.$t("msg.receive_today_info"))+"\n                ")])])]):_c('div',{staticStyle:{"display":"flex","font-size":"13px","opacity":"0.5"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.picked),expression:"picked"}],staticStyle:{"width":"12px"},attrs:{"type":"radio","id":"two","value":"fast","disabled":true},domProps:{"checked":_vm._q(_vm.picked,"fast")},on:{"change":function($event){_vm.picked="fast"}}}),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"margin-left":"10px"},attrs:{"for":"two"}},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.rush_today"))+".")]),_vm._v("\n                  "+_vm._s(_vm.$tc("msg.fee", 1))+" (+"+_vm._s(_vm.feeTaxRush.fee)+" USDT)\n                ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"10px","font-size":"11px"}},[_vm._v("\n                  "+_vm._s(_vm.$t("msg.receive_today_info"))+"\n                ")])])])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-top":"40px"}},[_c('button',{staticClass:"btn_redeem_back btn_radius",staticStyle:{"background":"#e12d2d","width":"30%"},on:{"click":function($event){return _vm.callBackStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.back"))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn_redeem btn_radius",staticStyle:{"width":"30%"},attrs:{"disabled":this.blockButton || this.picked == ''},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.next_step"))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center"}},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(419)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"1px solid #e3d4d4","width":"15%","border-right":"0px","display":"flex","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"icon_class_2_5 background_ val_m background_USDT"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep25_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_506a2f76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep25_vue__ = __webpack_require__(1020);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep25_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_506a2f76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep25_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column text_m_blu tal_c p30-l-r main_blue_dk_bg",staticStyle:{"font-size":"18px","color":"white","border-radius":"8px 8px 0px 0px"}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t("msg.available_balance"))+" "+_vm._s(this.getUnlockedBalance())+" BLUE\n    ")])]),_vm._v(" "),_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"30px","flex-direction":"column"}},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center","font-size":"9px"}},[_c('div',{staticStyle:{"width":"60%","display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"margin-left":"10px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_amount")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_recipient")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"25px","color":"#02b9a4"}},[_vm._v(_vm._s(_vm.$t("msg.step_verification")))]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t("msg.step_authentication")))])])])]),_vm._v(" "),_c('p',{staticClass:"tal_c main_blue_dk_fill fat",staticStyle:{"margin-bottom":"30px"}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.verify_step"))+"\n        ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"font-size":"14px"}},[_c('div',{staticStyle:{"border-bottom":"#ccc solid 2px","padding":"15px","padding-left":"15px"}},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.redeeming")))]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_vm._v("\n              "+_vm._s(_vm.previewData.sourceAmount)+" BLUE\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"border-bottom":"#ccc solid 2px","padding":"15px","padding-left":"15px"}},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.receiving")))]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_vm._v("\n              "+_vm._s(_vm.$t("msg.subtotal"))+":\n              "+_vm._s((_vm.previewData.sourceAmount * _vm.previewData.targetPrice).toFixed(
                  2
                ))+"\n              USDT\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_c('span',[_vm._v("\n                "+_vm._s(_vm.$tc("msg.fee", 1))+":\n                "+_vm._s(_vm.getFeeToShow())+"\n                USDT\n              ")])]),_vm._v(" "),_c('p',{staticClass:"fat",staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_vm._v("\n              Total:\n              "+_vm._s(_vm.getTotal())+"\n              USDT\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"15px","padding-left":"15px"}},[_c('p',{staticClass:"fat"},[_vm._v(_vm._s(_vm.$t("msg.send_to_btc_adress")))]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_vm._v("\n              "+_vm._s(_vm.address)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"fat",staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_vm._v("\n              Network: TRC20\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"15px","margin-top":"5px","margin-bottom":"5px"}},[_vm._v("\n              "+_vm._s(_vm.$t("msg.delivery_speed"))+":\n              "),(_vm.redeemtype)?_c('span',[_vm._v(" "+_vm._s(_vm.$t("msg.today")))]):_c('span',[_vm._v(" 3 "+_vm._s(_vm.$t("msg.business_day")))])])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"40px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],staticStyle:{"width":"22px","margin-right":"10px"},attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("msg.check_info_redeem")))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-top":"20px"}},[_c('button',{staticClass:"btn_redeem_back btn_radius",staticStyle:{"background":"#e12d2d","width":"30%"},on:{"click":function($event){return _vm.callBackStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.back"))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn_redeem btn_radius",staticStyle:{"width":"30%"},attrs:{"disabled":!this.checked},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.next_step"))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","display":"flex","justify-content":"center"}},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(421)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"10px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep3_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e4afd9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep3_vue__ = __webpack_require__(1022);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e4afd9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"text_lg p0 tal_c"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.redeem")))])]),_vm._v(" "),_c('div',{staticClass:"column tal_c"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_step_3'))}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_pin")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin),expression:"pin"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pin=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"text_sm"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.check_your_email_for_pin_redeem"))+"\n            "+_vm._s(_vm.$t("msg.if_no_email_spam"))+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_2fa")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twoFA),expression:"twoFA"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.twoFA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twoFA=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.pin || !_vm.twoFA || _vm.loading},on:{"click":function($event){return _vm.confirmRedeem()}}},[_vm._v(_vm._s(_vm.$t("msg.redeem")))]),_vm._v(" "),_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.cancelRedeem()}}},[_vm._v(_vm._s(_vm.$t("msg.cancel_redeem")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep4_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046746f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep4_vue__ = __webpack_require__(1024);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_046746f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('div',{staticClass:"column upper fat"},[_vm._v(_vm._s(_vm.$t("msg.confirm_redeem")))]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"fat amount_btc"},[_vm._v(_vm._s(_vm.redeemData.estimatedAmount.toFixed(2))+" USDT")])]),_vm._v(" "),_c('div',{staticClass:"column email-info"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_email_step_4'))}})]),_vm._v(" "),(_vm.rush)?_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_step_4'))}})]):_c('div',{staticClass:"column"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_step_5'))}})]),_vm._v(" "),_c('div',{staticClass:"column upper"},[_c('router-link',{attrs:{"to":"/transactions/redemption"}},[_vm._v(_vm._s(_vm.$t("msg.view_status")))])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep9_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365cdeb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep9_vue__ = __webpack_require__(1026);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedeemStep9_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365cdeb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedeemStep9_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[(parseFloat(_vm.msg) > 0)?_c('div',{staticClass:"column upper"}):_c('div',{staticClass:"column upper"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.failed"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column"},[(_vm.msg)?_c('div',[(parseFloat(_vm.msg) > 0)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.available_to_redeem'))}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.' + _vm.msg))}})]):_c('p',{staticClass:"action_blocked_message"},[_vm._v("\n            "+_vm._s(_vm.$t('msg.redeem_not_allowed_today_1')))])])]),_vm._v(" "),(_vm.msg)?_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.resetStep()}}},[_vm._v(_vm._s(_vm.$t("msg.back")))])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column pt0",attrs:{"id":"landing_redeem"}},[(!_vm.authorized)?_c('redeem-2fa',{on:{"getOptStatus":_vm.getOtpStatus}}):_vm._e(),_vm._v(" "),(_vm.step == 1 && _vm.authorized)?_c('redeem-step1',{attrs:{"feeTax":_vm.feeTax,"feeTaxAbsolute":_vm.feeTaxAbsolute,"redeemInfo":_vm.redeemInfo},on:{"callNext":_vm.callStepPreview}}):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('redeem-step2',{attrs:{"previewData":_vm.previewData,"address":_vm.address,"feeTaxRush":_vm.feeTaxRush},on:{"callNext":_vm.callNextStep,"resetStep":_vm.setFirstStep}}):_vm._e(),_vm._v(" "),(_vm.step == 2.5)?_c('redeem-step25',{attrs:{"previewData":_vm.previewData,"address":_vm.address,"redeemtype":_vm.redeemtype,"feeFixed":_vm.feeTaxAbsolute,"feeTaxRush":_vm.feeTaxRush,"feeTax":_vm.feeTax},on:{"callNext":_vm.callStepRedeem,"resetStep":function($event){_vm.step = 2}}}):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('redeem-step3',{attrs:{"redeemData":_vm.redeemData,"loading":_vm.loading},on:{"confirmRedeem":_vm.redeemConfirm,"cancelRedeem":_vm.resetRedeem}}):_vm._e(),_vm._v(" "),(_vm.step == 4)?_c('redeem-step4',{attrs:{"redeemData":_vm.redeemData,"rush":_vm.redeemtype}}):_vm._e(),_vm._v(" "),(_vm.step == 9 && _vm.authorized)?_c('redeem-step9',{attrs:{"error":_vm.error,"dayEnabled":_vm.redeemInfo.dayAllowed},on:{"resetStep":_vm.setFirstStep}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedemptionBalance_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a51e309_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedemptionBalance_vue__ = __webpack_require__(1029);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RedemptionBalance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a51e309_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RedemptionBalance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column page_redemptions_warning p0"},[(_vm.bluAccount)?_c('div',{staticClass:"balance_container p0"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('h1',{staticClass:"grey_normal"},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.balance", 1))+"\n      ")]),_vm._v(" "),(!_vm.toggleBalance)?_c('img',{staticClass:"pointer",staticStyle:{"width":"35px","margin-left":"10px","margin-top":"5px"},attrs:{"src":__webpack_require__(1030)},on:{"click":function () { return _vm.toggle(); }}}):_c('img',{staticClass:"pointer",staticStyle:{"width":"35px","margin-left":"10px","margin-top":"5px"},attrs:{"src":__webpack_require__(1031)},on:{"click":function () { return _vm.toggle(); }}})]),_vm._v(" "),(_vm.toggleBalance)?_c('div',_vm._l((_vm.balances),function(balance){return _c('div',{key:balance.id,staticClass:"balance_arround"},[(_vm.selectedBlue)?_c('div',{staticClass:"balance_row"},[_c('div',{staticClass:"right_header_content"},[_c('span',{staticClass:"icon_class_1 mr_10",domProps:{"innerHTML":_vm._s(_vm.iconSets[balance.icon])}}),_vm._v(" "),_c('span',{staticClass:"grey_normal"},[_vm._v(_vm._s(_vm.$t(("msg." + (balance.text)))))])]),_vm._v(" "),_c('div',{staticClass:"balance_content_inside capitalize"},[_c('img',{staticClass:"blu_balance_img",attrs:{"src":__webpack_require__(11)}}),_vm._v(" "),_c('div',{staticClass:"balanc_blu grey_normal"},[_c('div',{staticClass:"tal_r"},[_c('span',{staticClass:"right_blu"},[_vm._v(_vm._s(_vm.getBalance(balance.type)))]),_vm._v("\n                BLUE\n                "),_c('span',{staticClass:"icon_class_03",style:(balance.type == 'locked' ? '' : 'color: transparent'),domProps:{"innerHTML":_vm._s(_vm.iconSets.general_lock)}})])])])]):_c('div',{staticClass:"balance_row pb_10"},[_c('div',{staticClass:"right_header_content"},[_c('span',{staticClass:"icon_class_1 mr_10",domProps:{"innerHTML":_vm._s(_vm.iconSets[balance.icon])}}),_vm._v(" "),_c('span',{staticClass:"grey_normal"},[_vm._v(_vm._s(_vm.$t(("msg." + (balance.text_USDT)))))])]),_vm._v(" "),_c('div',{staticClass:"balance_content_inside capitalize",staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((_vm.pairCoins),function(coin){return _c('div',{key:coin.id,staticClass:"balance_content_inside_100"},[_c('span',{staticClass:"blu_balance_img icon_class_1 background_ val_m",class:("background_" + (coin.symbol))}),_vm._v(" "),_c('div',{staticClass:"balanc_blu grey_normal"},[_c('div',{staticClass:"tal_r"},[(coin.symbol == 'USDT')?_c('span',{staticClass:"right_blu"},[_vm._v(_vm._s(_vm.getBalanceUsdt(balance.type)))]):_c('span',{staticClass:"right_blu"},[_vm._v(_vm._s(_vm._f("decimalsCrypto")((_vm.getBalanceUsdt(balance.type) /
                      (coin.value / _vm.bluValue[0].value)),6)))]),_vm._v("\n\n                  "+_vm._s(coin.symbol)+"\n\n                  "),_c('span',{staticClass:"icon_class_03",style:(balance.type == 'locked' ? '' : 'color: transparent'),domProps:{"innerHTML":_vm._s(_vm.iconSets.general_lock)}})])])])}),0)])])}),0):_vm._e()]):_c('div',{staticClass:"column balance_container component_card"},[_c('h2',[_vm._v(_vm._s(_vm.$t("msg.loading_balance")))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hide_balance_icon.png?e7a8eabace7e509b699973d84bb8b661";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "show_balance_icon.png?ee682167ac83460b957a4ea4f4de8491";

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternalMain_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a25fad6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternalMain_vue__ = __webpack_require__(1045);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InternalMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a25fad6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InternalMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepStart_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d560c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepStart_vue__ = __webpack_require__(1034);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepStart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63d560c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepStart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('span',{staticClass:"text_m_blu"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.internal_steps"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"sub_green_lt_bg component_super_button sub_green_lt_bg_hover upper text_lg",on:{"click":function($event){return _vm.callNext()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.start_internal_transfer"))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepAmount_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cfd2ece_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepAmount_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cfd2ece"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepAmount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cfd2ece_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepAmount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1f9a220e", content, true, {});

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".icon-container[data-v-5cfd2ece]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card p0 p20tb"},[_c('div',{staticClass:"column columns redeem_form p0"},[_c('div',{staticClass:"column tal_c"},[_c('span',{staticClass:"text_m_blu"},[_vm._v(_vm._s(_vm.$t("msg.inform_the_amount_user_id")))]),_vm._v(" "),_c('div',{staticClass:"column p0"},[_c('div',{staticClass:"column",class:{
            has_error_color: !_vm.validation.amount || _vm.minBlue > _vm.bluAmount,
          }},[_c('p',{staticClass:"tal_c"},[_vm._v(_vm._s(_vm.$t("msg.input_amount_transfer")))]),_vm._v(" "),_c('p',{staticClass:"capitalize tal_c",class:{ notice: _vm.bluAmount < _vm.minBlue }},[_vm._v("\n            "+_vm._s(_vm.$t("msg.min_amount_is"))+":\n            "+_vm._s(_vm.bluValue[0].withdrawMinimal)+" BLUE\n          ")]),_vm._v(" "),_c('div',{staticClass:"column blu_input_container_2"},[_c('img',{staticClass:"blu_input_img_2",attrs:{"src":__webpack_require__(11)}}),_vm._v(" "),_c('div',{staticClass:"blu_input_2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bluAmount),expression:"bluAmount"}],staticClass:"amount_redeem",class:{
                  has_error_color: !_vm.validation.amount || _vm.minBlue > _vm.bluAmount,
                },domProps:{"value":(_vm.bluAmount)},on:{"keypress":function($event){return _vm.isNumber()},"input":function($event){if($event.target.composing){ return; }_vm.bluAmount=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"blu_input_actions"},[_c('div',{staticClass:"blu_input_plus",on:{"click":function($event){return _vm.modifyBluAmount('+')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_up)}})]),_vm._v(" "),_c('div',{staticClass:"blue_input_minus",class:{
                  arrow_disabled:
                    parseFloat(_vm.bluAmount) <= parseFloat(_vm.minBlue),
                },on:{"click":function($event){return _vm.modifyBluAmount('-')}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.iconSets.general_down)}})])])])]),_vm._v(" "),_c('p',{staticClass:"tal_c error_text_min"},[(!_vm.validation.amount || _vm.bluAmount < _vm.minBlue)?_c('span',{staticClass:"text_sm has_error_text"},[_vm._v(_vm._s(_vm.$t("msg.invalid_amount"))+".")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column p0"},[_c('p',{staticClass:"fat upper m13_t column_p_left tal_l p30-l-r"},[_vm._v("\n            "+_vm._s(_vm.$t("msg.recipients_user_id"))+"\n            "),_c('span',{staticClass:"dis_inb component_info val_init",domProps:{"innerHTML":_vm._s(_vm.iconSets.general_info)},on:{"mouseover":function($event){return _vm.showToolTipBonus()},"mouseout":function($event){return _vm.hideToolTipBonus()}}},[_vm._v("I")]),_vm._v(" "),(_vm.tooltipBonus)?_c('span',{staticClass:"dis_b component_info_data text_xxs_px tooltip_sz1"},[_vm._v("\n              "+_vm._s(_vm.$t("msg.tooltip_internal_withdraw"))+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"column p30-l-r p0_b"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userID),expression:"userID"}],staticClass:"amount_address",staticStyle:{"width":"100%"},attrs:{"type":"number"},domProps:{"value":(_vm.userID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.userID=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column p30-l-r"},[_c('p',{staticClass:"text_ssm"},[_vm._v(_vm._s(_vm.$t("msg.user_id_inportant")))])])]),_vm._v(" "),_c('div',{staticClass:"column p30-l-r"},[_c('button',{staticClass:"btn_redeem",on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.next_step"))+"\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepConfirm_vue__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00582458_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepConfirm_vue__ = __webpack_require__(1040);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00582458_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"text_lg p0 tal_c"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.internal_transfer")))])])]),_vm._v(" "),_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column display_values_redeem"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.total"))+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.whithdraw.amount)+" BLU")])]),_vm._v(" "),_c('div',{staticClass:"column display_btc_adress_redeem tal_c",staticStyle:{"border":"none"}},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.destination_user"))+":")]),_vm._v(" "),_c('p',{staticClass:"fat word_break_word"},[_vm._v(_vm._s(_vm.whithdraw.address))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.callNextStep()}}},[_vm._v(_vm._s(_vm.$t("msg.next_step")))]),_vm._v(" "),_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.callBackStep()}}},[_vm._v(_vm._s(_vm.$t("msg.back")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pinStep_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5ee7c1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pinStep_vue__ = __webpack_require__(1042);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pinStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5ee7c1a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pinStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"text_lg p0 tal_c"},[_c('strong',[_vm._v(_vm._s(_vm.$t("msg.internal_transfer")))])]),_vm._v(" "),_c('div',{staticClass:"column tal_c"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_step_3'))}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_pin")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin),expression:"pin"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.pin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pin=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"text_sm"},[_vm._v(" "+_vm._s(_vm.$t("msg.check_your_email_for_pin_redeem"))+"\n              "+_vm._s(_vm.$t("msg.if_no_email_spam"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.redeem_2fa")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twoFA),expression:"twoFA"}],staticClass:"amount_redeem",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(_vm.twoFA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.twoFA=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('button',{staticClass:"btn_redeem",staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.pin || !_vm.twoFA},on:{"click":function($event){return _vm.confirm()}}},[_vm._v(_vm._s(_vm.$t("msg.finish")))]),_vm._v(" "),(!_vm.loadingCancel)?_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"},on:{"click":function($event){return _vm.cancelRedeem(_vm.withdrawData.id)}}},[_vm._v(_vm._s(_vm.$t("msg.cancel")))]):_vm._e(),_vm._v(" "),(_vm.loadingCancel)?_c('button',{staticClass:"btn_redeem_back",staticStyle:{"background":"#e12d2d","width":"100%"}},[_c('Loading')],1):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepFinish_vue__ = __webpack_require__(441);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014b6036_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepFinish_vue__ = __webpack_require__(1044);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_internalStepFinish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014b6036_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_internalStepFinish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component_card"},[_c('div',{staticClass:"column columns redeem_form mw100"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"column tal_c"},[_c('div',{staticClass:"column upper fat"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.confirm_internal"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"fat amount_btc"},[(_vm.whithdraw)?_c('span',[_vm._v(_vm._s(_vm.whithdraw.amount))]):_vm._e(),_vm._v(" BLU")])]),_vm._v(" "),_c('div',{staticClass:"column email-info"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_redeem_email_step_4'))}})]),_vm._v(" "),_c('div',{staticClass:"column upper"},[_c('router-link',{attrs:{"to":"/transactions/withdraw"}},[_vm._v(_vm._s(_vm.$t("msg.view_status")))])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column pt0",attrs:{"id":"landing_redeem"}},[(!_vm.authorized)?_c('Redeem2fa',{on:{"getOptStatus":_vm.getOtpStatus,"switchMode":function($event){return _vm.switchMode()}}}):_vm._e(),_vm._v(" "),(_vm.step == 0 && _vm.authorized)?_c('InternalStepStart',{on:{"callNext":function($event){return _vm.callNext()}}}):_vm._e(),_vm._v(" "),(_vm.step == 1)?_c('InternalStepAmount',{on:{"callNext":function (amount, userID) { return _vm.withdrawInternal(amount, userID); }}}):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('InternalStepConfirm',{attrs:{"whithdraw":_vm.internalWhithdraw},on:{"callBackStep":function($event){return _vm.callBackStep()},"callNext":function($event){return _vm.callNext()}}}):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('PinStep',{attrs:{"withdrawData":_vm.internalWhithdraw},on:{"confirmWithdraw":function (twoFA, pin) { return _vm.confirmWithdrawInternal(twoFA, pin); },"cancelRedeem":function (idTransactions) { return _vm.cancelRedeem(idTransactions); }}}):_vm._e(),_vm._v(" "),(_vm.step == 4)?_c('InternalStepFinish',{attrs:{"whithdraw":_vm.internalWhithdraw}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FailedTable_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc0ab23_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FailedTable_vue__ = __webpack_require__(1047);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FailedTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc0ab23_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FailedTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw100",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"component_card",staticStyle:{"border":"1px solid rgb(216, 214, 214)","background":"#fff","width":"100%"}},[_c('div',{staticClass:"p20",staticStyle:{"border-bottom":"solid 1px #d8d6d6"}},[_c('h1',{staticClass:"main_blue_dk_fill fat"},[_vm._v(_vm._s(_vm.$t("msg.table_failed_1")))])]),_vm._v(" "),_c('div',{staticClass:"p10"},_vm._l((_vm.failedOrders),function(item,index){return (index < 5)?_c('div',{key:item,staticClass:"order columns",staticStyle:{"display":"flex","justify-content":"space-between","font-size":"13px"}},[_c('div',{staticClass:"column is-one-quarter"},[_vm._v("\n          "+_vm._s(_vm.fixTimeZone(item.updatedAt))+" UTC -3\n        ")]),_vm._v(" "),_c('div',{staticClass:"column is-one-quarter upper tal_c"},[_vm._v("\n          "+_vm._s(_vm.$t("msg.withdraw"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"column is-one-quarter capitalize"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('div',{staticClass:"column is-one-quarter"},[_c('div',[(!_vm.loading)?_c('button',{staticClass:"default-button main_red_lt_bg m10_t",on:{"click":function($event){return _vm.cancelTransaction(item.id)}}},[_vm._v("\n              "+_vm._s(_vm.$t("msg.cancel"))+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('button',{staticClass:"default-button main_red_lt_bg m10_t"},[_c('Loading')],1):_vm._e()])])]):_vm._e()}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0 services minH100",attrs:{"id":"page_redemptions"}},[_c('div',{staticClass:"cointainer_lg column combo_1"},[_c('div',{staticClass:"column p0"},[_c('h1',{staticClass:"fat",staticStyle:{"padding":"0.5rem 0"}},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.services", 1))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"tal_r button_switch_column"},[_c('div',{staticClass:"tal_l p0_b"},[(_vm.mode == 'redeem' && _vm.authorized)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"icon_class_2",domProps:{"innerHTML":_vm._s(_vm.iconSets.blu_redeem_icon_blu)}}),_vm._v(" "),_c('h1',{staticClass:"component_title_md fat m0_b m9_l main_blue_dk_fill",staticStyle:{"font-size":"1.8rem"}},[_vm._v("\n            "+_vm._s(_vm.$tc("msg.redemption", 1))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.mode == 'withdraw' && _vm.authorized)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"icon_class_2",domProps:{"innerHTML":_vm._s(_vm.iconSets.blu_withdraw_icon_blu)}}),_vm._v(" "),_c('h1',{staticClass:"component_title_md fat m0_b m9_l main_blue_dk_fill",staticStyle:{"font-size":"1.8rem"}},[_vm._v("\n            "+_vm._s(_vm.$tc("msg.withdrawal"))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.mode == 'internal' && _vm.authorized)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"icon_class_2",domProps:{"innerHTML":_vm._s(_vm.iconSets.internal_icon_blu)}}),_vm._v(" "),_c('h1',{staticClass:"component_title_md fat m0_b m9_l main_blue_dk_fill",staticStyle:{"font-size":"1.8rem"}},[_vm._v("\n            "+_vm._s(_vm.$tc("msg.internal_transfer", 1))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.mode == 'deposit' && _vm.authorized)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"icon_class_2",domProps:{"innerHTML":_vm._s(_vm.iconSets.blu_deposit_icon_blue)}}),_vm._v(" "),_c('h1',{staticClass:"component_title_md fat m0_b m9_l main_blue_dk_fill",staticStyle:{"font-size":"1.8rem"}},[_vm._v("\n            "+_vm._s(_vm.$tc("msg.deposit", 1))+"\n          ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"p0_t"},[(_vm.mode == 'redeem' && _vm.authorized)?_c('h2',{staticClass:"fs_small_wm",domProps:{"innerHTML":_vm._s(_vm.$t('msg.redemption_sub'))}}):_vm._e(),_vm._v(" "),(_vm.mode == 'redeem' && _vm.authorized)?_c('div',{staticStyle:{"font-weight":"500","padding-left":"20px","margin-top":"10px"}},[_c('ul',{staticClass:"fat",staticStyle:{"list-style-type":"disc"}},[_c('li',[_vm._v(_vm._s(_vm.$t("msg.redemption_sub_one")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("msg.redemption_sub_two")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("msg.redemption_sub_three")))])])]):_vm._e(),_vm._v(" "),(_vm.mode == 'internal' && _vm.authorized)?_c('div',{staticClass:"fs_small_wm"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.internal_sub'))}})]):_vm._e(),_vm._v(" "),((_vm.mode == 'deposit' || _vm.mode == 'withdraw') && _vm.authorized)?_c('div',{staticClass:"deposit_actions"},[_c('button',{class:_vm.selectedBlue && 'selectedBlue',on:{"click":function($event){return _vm.toogleCoin('blue')}}},[(!_vm.selectedBlue)?_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}):_c('img',{attrs:{"src":__webpack_require__(1049),"alt":"blue_token"}}),_vm._v(" "),_c('span',[_vm._v("BLUE")])]),_vm._v(" "),_c('button',{class:!_vm.selectedBlue && 'selectedEther',on:{"click":function($event){return _vm.toogleCoin('usdt')}}},[_c('img',{attrs:{"src":__webpack_require__(136),"alt":"blue_token"}}),_vm._v(" "),_c('span',[_vm._v("USDT")])])]):_vm._e(),_vm._v(" "),(_vm.mode == 'withdraw' && _vm.authorized)?_c('div',{staticClass:"fs_small_wm"},[(_vm.selectedBlue)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.withdraw_sub'))}}):_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.withdraw_sub_usdt'))}})]):_vm._e(),_vm._v(" "),(_vm.mode == 'deposit' && _vm.authorized)?_c('div',{staticClass:"fs_small_wm"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.deposit_sub', { coin: _vm.coin }))}})]):_vm._e(),_vm._v(" "),(!_vm.authorized)?_c('div',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.info_2fa_tip'))}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"page_redemptions_body redeem_grid button_switch_container"},[_c('div',{staticClass:"i2 p0"},[_c('div',{staticStyle:{"padding-bottom":"1rem"}},[(_vm.authorized)?_c('redemption-balance',{attrs:{"selectedBlue":_vm.selectedBlue}}):_vm._e()],1),_vm._v(" "),(_vm.authorized && _vm.mode == 'withdraw' && _vm.selectedBlue)?_c('div',{staticClass:"towFA_instructions"},[_c('div',{staticStyle:{"cursor":"pointer","font-size":"1.1rem","margin-bottom":"1rem"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.tutorial_tittle_withdraw'))},on:{"click":function () { return this$1.toggleTutorial(); }}}),_vm._v(" "),(this.tutorial || this.isWeb)?_c('div',{staticClass:"font-wb-tutorial",staticStyle:{"max-width":"400px","margin-bottom":"1rem"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.tutorial_withdraw'))}}),_vm._v(" "),_c('div',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.$t('msg.contract_address')),expression:"$t('msg.contract_address')",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],staticClass:"copy-clip pointer",staticStyle:{"margin-top":"10px","margin-bottom":"10px","display":"flex","background":"#424b7d","padding":"5px","border-radius":"8px","justify-content":"center"}},[_c('div',{staticClass:"font-address",staticStyle:{"color":"white","line-break":"anywhere"}},[_vm._v("\n                "+_vm._s(_vm.$t("msg.contract_address"))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"icon_class_15",staticStyle:{"margin-left":"10px"},domProps:{"innerHTML":_vm._s(_vm.iconSets.copy_white)}})]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.tutorial_withdraw_pt2'))}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.authorized && _vm.mode == 'deposit')?_c('div',{staticClass:"towFA_instructions"},[_c('div',{staticStyle:{"cursor":"pointer","font-size":"1.2rem"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.tutorial_tittle', { coin: _vm.howDepositCoin }))},on:{"click":function () { return this$1.toggleTutorial(); }}}),_vm._v(" "),((this.tutorial || this.isWeb) && _vm.selectedBlue)?_c('div',{staticClass:"font-wb-tutorial",staticStyle:{"max-width":"400px"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.tutorial_deposit'))}}):_vm._e(),_vm._v(" "),((this.tutorial || this.isWeb) && !_vm.selectedBlue)?_c('div',{staticClass:"font-wb-tutorial",staticStyle:{"max-width":"400px"},domProps:{"innerHTML":_vm._s(_vm.$t('msg.tutorial_deposit_usdt'))}}):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.authorized)?_c('div',{staticClass:"towFA_instructions column"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.reedeem_2fa_text'))}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"i1 p0"},[(_vm.mode == 'redeem')?_c('redemption-main',{on:{"updateOptStatus":_vm.getOtpStatus}}):_vm._e(),_vm._v(" "),(_vm.mode == 'withdraw')?_c('withdraw-main',{attrs:{"selectedBlue":_vm.selectedBlue,"step":_vm.stepWithdraw},on:{"updateOptStatus":_vm.getOtpStatus}}):_vm._e(),_vm._v(" "),(_vm.mode == 'deposit')?_c('deposit-main',{attrs:{"selectedBlue":_vm.selectedBlue},on:{"updateOptStatus":_vm.getOtpStatus}}):_vm._e(),_vm._v(" "),(_vm.mode == 'internal')?_c('internal-main',{attrs:{"openOrder":_vm.openOrder},on:{"updateOptStatus":_vm.getOtpStatus,"cancelOpenWithdraws":function (id) { return _vm.cancelOpenWithdraws(id); }}}):_vm._e(),_vm._v(" "),(this.internalArray && _vm.authorized && this.mode != 'deposit')?_c('failed-table',{attrs:{"failedOrders":this.internalArray},on:{"continueTransaction":function (el) { return _vm.continueTransaction(el); },"cancelTransaction":function (el) { return _vm.cancelOpenWithdraws(el); }}}):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "blue_white_outline_logo.png?95e92befd012c3fe55aba70b86b12e4a";

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pool_vue__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f17015f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pool_vue__ = __webpack_require__(1059);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f17015f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPool_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0910584f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPool_vue__ = __webpack_require__(1054);
function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0910584f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1053);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("3c0d2be2", content, true, {});

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.modal_wrapper{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:0 auto;display:flex;align-items:center;justify-content:center;max-width:600px;width:100%}.modal_wrapper .modal_container{width:100%;max-width:600px;margin:0 auto;background-color:#fff;border-radius:8px}.modal_wrapper .modal_container .modal_header{position:relative;background:#342365;display:flex;align-items:center;justify-content:center;color:#fff;padding:1rem 0;font-weight:600;letter-spacing:2px;border-top-left-radius:8px;border-top-right-radius:8px;text-transform:uppercase}.modal_wrapper .modal_container .modal_header svg{width:1.5rem;position:absolute;right:1rem;cursor:pointer}.modal_wrapper .modal_container .modal_content{display:flex;flex-direction:column;align-items:flex-start;color:#000;padding:1rem 1.5rem;margin-bottom:1rem}.modal_wrapper .modal_container .modal_content h3{text-align:start;margin-bottom:1rem;width:100%}.modal_wrapper .modal_container .modal_content h3 a{width:100px}.modal_wrapper .modal_container .modal_content .wrapper_action_modal{display:flex;flex-direction:column;width:100%;margin-top:1rem;color:gray}.modal_wrapper .modal_container .modal_content .wrapper_action_modal label{color:#342365;font-weight:600}.modal_wrapper .modal_container .modal_content .wrapper_action_modal input{border-radius:8px;outline:none;padding:.5rem;border:1px solid #d2d2d2}.modal_wrapper .modal_container .modal_content .wrapper_action_modal span{color:gray;font-size:14px;margin-bottom:2rem}.modal_wrapper .modal_container .modal_content .wrapper_action_modal .select_avatar{display:flex;justify-content:space-between;align-items:center;margin-top:.5rem;padding:0 1rem}.modal_wrapper .modal_container .modal_content .wrapper_action_modal .select_avatar .icons{border-radius:2rem;border:1px solid transparent}.modal_wrapper .modal_container .modal_content .wrapper_action_modal .select_avatar .icons:hover{opacity:.8;border:1px solid #342365;border-radius:2rem}.modal_wrapper .modal_container .modal_content .wrapper_action_modal .select_avatar .icons img{width:2.5rem;cursor:pointer}.modal_wrapper .modal_container .modal_content .wrapper_action_modal .button_join{margin-top:2rem;border:none;color:#fff;cursor:pointer;font-size:1rem;font-weight:600;border-radius:6px;background:#28a191;padding:8px 30px;transition:all .2s ease-in-out}.modal_wrapper .modal_container .modal_content .wrapper_action_modal .button_join:hover{background:rgba(40,161,145,.8)}.modal_wrapper .modal_container .modal_content .content_welcome .welcome{font-size:20px;text-align:center;color:#4a4a4a}.modal_wrapper .modal_container .modal_content .content_welcome .avatar_icon{display:flex;flex-direction:column;align-items:center}.modal_wrapper .modal_container .modal_content .content_welcome .avatar_icon img{padding:.5rem 0;width:6rem}.modal_wrapper .modal_container .modal_content .content_welcome .avatar_icon span{font-size:20px;color:#444;font-weight:600}.modal_wrapper .modal_container .modal_content .content_welcome p{padding-top:1rem}.modal_wrapper .modal_container .modal_content .content_welcome .action_close{display:flex;flex-direction:column}.modal_wrapper .modal_container .modal_content .content_welcome .action_close span{margin-top:2rem;color:#342365}.modal_wrapper .modal_container .modal_content .content_welcome .action_close p{color:#342365}.modal_wrapper .modal_container .modal_content .content_welcome .action_close .copy_link{display:flex;align-items:center}.modal_wrapper .modal_container .modal_content .content_welcome .action_close .copy_link button{margin-top:0;margin-left:10px;padding:5px 20px}.modal_wrapper .modal_container .modal_content .content_welcome .action_close button{margin-top:2rem;border:none;color:#fff;cursor:pointer;font-size:1rem;font-weight:600;border-radius:6px;background:#28a191;padding:8px 30px;transition:all .2s ease-in-out}.modal_wrapper .modal_container .modal_content .content_welcome .action_close button:hover{background:rgba(40,161,145,.8)}@media only screen and (max-width:627px){.modal_wrapper{max-width:450px}.modal_wrapper .modal_container .modal_content{padding:1rem}.modal_wrapper .modal_container .modal_content .select_avatar{padding:0!important}.modal_wrapper .modal_container .modal_content .select_avatar .icons img{width:1.5rem!important}.modal_wrapper .copy_link{flex-direction:column;align-items:flex-start!important}.modal_wrapper .copy_link button{margin-left:0!important;margin-top:5px!important}}@media only screen and (max-width:470px){.modal_wrapper{max-width:360px}}", ""]);

// exports


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal_mask",attrs:{"id":"modal_pool"},on:{"click":function($event){return _vm.closeModalPool()}}}),_vm._v(" "),_c('div',{staticClass:"modal_wrapper"},[_c('div',{staticClass:"modal_container"},[_c('div',{staticClass:"modal_header"},[_vm._v("\n        "+_vm._s(_vm.$tc("msg.modal_pool_title", 1))+"\n\n        "),_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.closeModalPool()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})])]),_vm._v(" "),(_vm.firstScreenModal)?_c('div',{staticClass:"modal_content"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.modal_pool_text'))}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_text2", 1)))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_important", 1))+":")]),_vm._v("\n          "+_vm._s(_vm.$tc("msg.modal_pool_text3", 1)))]),_vm._v(" "),_c('div',{staticClass:"wrapper_action_modal"},[_c('label',{attrs:{"for":"nickname"}},[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_nick", 1)))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nickname),expression:"nickname"}],attrs:{"id":"nickname","type":"text"},domProps:{"value":(_vm.nickname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nickname=$event.target.value}}}),_vm._v(" "),_c('span',[_vm._v("\n            "+_vm._s(_vm.$tc("msg.modal_pool_nick_span", 1))+"\n          ")]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_avatar", 1)))]),_vm._v(" "),_c('div',{staticClass:"select_avatar"},_vm._l((_vm.icons),function(icon,index){return _c('div',{key:index,staticClass:"icons",style:(_vm.selectedAvatar === index ? _vm.selectedAvatarStyle : null),on:{"click":function($event){_vm.selectedAvatar = index}}},[_c('img',{attrs:{"src":icon,"alt":"avatar"}})])}),0),_vm._v(" "),_c('button',{staticClass:"button_join",on:{"click":function($event){return _vm.joinPoolAction()}}},[_vm._v("\n            "+_vm._s(_vm.$tc("msg.modal_pool_btn", 1))+"\n          ")])])]):_c('div',{staticClass:"modal_content"},[_c('div',{staticClass:"content_welcome"},[_c('h3',{staticClass:"welcome"},[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_welcome", 1)))]),_vm._v(" "),_c('div',{staticClass:"avatar_icon"},[_c('span',[_vm._v(_vm._s(_vm.memberRespPoolConfirm.nickname))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.renderImage(_vm.memberRespPoolConfirm.avatar),"alt":_vm.memberRespPoolConfirm.avatar}})]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$tc("msg.modal_pool_span", 1))+"\n          ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_span2", 1)))]),_vm._v(" "),_c('div',{staticClass:"action_close"},[_c('div',{staticClass:"copy_link",staticStyle:{"display":"flex","align-items":"flex-end"}},[_c('span',[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_referral", 1))+"\n                "+_vm._s(_vm.member.referCode))]),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.member.referCode),expression:"member.referCode",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],attrs:{"type":"button"}},[_vm._v("\n                "+_vm._s(_vm.$tc("msg.copy", 1))+"\n              ")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc("msg.modal_pool_referral_link", 1))+":")]),_vm._v(" "),_c('div',{staticClass:"copy_link"},[_c('a',{attrs:{"href":("https://bluetoken.io/app/referralcode=" + (_vm.member.referCode)),"target":"_blank"}},[_vm._v("https://bluetoken.io/app/referralcode="+_vm._s(_vm.member.referCode))]),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(
                  ("https://bluetoken.io/app/referralcode=" + (_vm.member.referCode))
                ),expression:"\n                  `https://bluetoken.io/app/referralcode=${member.referCode}`\n                ",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopySuccess),expression:"onCopySuccess",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onCopyError),expression:"onCopyError",arg:"error"}],attrs:{"type":"button"}},[_vm._v("\n                "+_vm._s(_vm.$tc("msg.copy", 1))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"button_join",on:{"click":function($event){return _vm.closeModalPool()}}},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.modal_pool_close", 1))+"\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalLastPool_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5821dc4f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalLastPool_vue__ = __webpack_require__(1058);
function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalLastPool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5821dc4f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalLastPool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1057);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("1776f710", content, true, {});

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".table_pool{display:flex;flex-direction:column;align-items:center;justify-content:center}.table_pool .header_title{display:flex;align-items:center;justify-content:space-between;width:100%;margin:.5rem 0}.table_pool .header_title h3{font-size:1.5rem;color:#999797;font-weight:600}.table_pool .header_title a{color:#61b574;font-weight:500}.table_pool .header_title a:hover{text-decoration:underline!important}.table_pool .table_container{border-radius:.5rem;display:flex;flex-direction:column;align-items:center;justify-content:center}.table_pool .table_container table{margin:.5rem;padding:0;width:100%;table-layout:fixed;border-collapse:collapse;overflow-x:auto}.table_pool .table_container table td,.table_pool .table_container table th{padding:.5rem;font-weight:500}.table_pool .table_container table th{padding:.5em;font-size:1em;color:#132787;border-bottom:2px solid #9b9999}.table_pool .table_container table .icon_table{display:flex;align-items:center}.table_pool .table_container table .icon_table img{width:1.5rem;margin-right:5px}.table_pool .header_title h3{font-size:1rem;margin-bottom:0}.table_pool .header_title a{font-size:.6rem}.modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:200%;left:0;top:0;z-index:998;overflow:auto}.wrapper_modal_other_currencies{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_other_currencies .content_other_currencies{position:relative;padding:2rem;border-radius:6px;max-width:60%;max-height:500px;width:100%;background-color:#fff}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies{display:flex;border-bottom:1px solid #342365!important;padding-bottom:.5rem;width:100%;font-size:1.5rem;text-align:center;justify-content:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies h1{font-size:1rem;font-weight:600;color:#342365}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value{display:flex;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value img{width:1.4rem;margin-right:10px}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_other_currencies .content_other_currencies svg:hover{color:#342365}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent{display:flex;flex-direction:column;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent h2{font-size:1rem;font-weight:600;margin:1.2rem 0}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list{display:flex;flex-direction:column;align-items:flex-end}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list{display:flex;align-items:center;justify-content:space-between;margin-bottom:.8rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list img{width:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list .currencies_icon{width:1.4rem;height:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p{margin-top:.5rem}@media only screen and (max-width:350px){.wrapper_modal_other_currencies .content_other_currencies{max-width:300px;max-height:450px}}", ""]);

// exports


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('div',{staticClass:"wrapper_modal_other_currencies"},[_c('div',{staticClass:"content_other_currencies"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),(_vm.membersOnPoolProgram.length > 0)?_c('div',{staticClass:"column table_pool"},[_c('div',{staticClass:"header_title"},[_c('h3',[_vm._v("\n            "+_vm._s(_vm.$t("msg.last_month_winners"))+":\n            "+_vm._s(_vm.$t(("msg.months." + _vm.month)))+"\n          ")]),_vm._v(" "),_c('h3',[_vm._v("\n            "+_vm._s(_vm.$t("msg.last_month_blue_total"))+": "+_vm._s(_vm.totalValue())+" BLUE\n          ")])]),_vm._v(" "),_c('div',{staticClass:"table_container"},[_c('table',{staticStyle:{"font-size":"1rem !important"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Avatar")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("\n                  "+_vm._s(_vm.$t("msg.referral_volume"))+"\n                ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("\n                  "+_vm._s(_vm.$t("msg.reward_pool"))+"\n                ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("\n                  "+_vm._s(_vm.$t("msg.earned_pool"))+"\n                ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.membersOnPoolProgram),function(item,index){return _c('tr',{key:index},[_c('td',[_c('div',{staticClass:"icon_table"},[_c('img',{attrs:{"src":_vm.renderImage(item.avatar),"alt":item.avatar}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.nickname))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"icon_table",staticStyle:{"margin-left":"calc(100% - 50px)"}},[_c('img',{staticStyle:{"width":"1.2rem !important"},attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.referralVolume && item.referralVolume.toFixed(2)))])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v("\n                  "+_vm._s(item.rewardPercent && item.rewardPercent.toFixed(2))+"%\n                ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"icon_table",staticStyle:{"margin-left":"calc(100% - 50px)"}},[_c('img',{staticStyle:{"width":"1.2rem !important"},attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v("\n                    "+_vm._s(item.estimated && item.estimated.toFixed(2))+"\n                  ")])])])}),0)])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0 minH100",attrs:{"id":"page_pool"}},[(_vm.pageLoad)?_c('div',{staticClass:"cointainer_lg column combo_1"},[_vm._m(0),_vm._v(" "),(_vm.modalLast)?_c('div',{staticClass:"backgorund_modal",staticStyle:{"overflow-x":"unset !important"}},[_c('modal-last-pool',{attrs:{"membersOnPoolProgram":_vm.lastMonthPools,"month":_vm.monthToRender},on:{"toggleModalCurrencies":function($event){return _vm.toogleModal()}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cointainer_lg combo_1 container_pool"},[(_vm.member.poolProgram && _vm.pool)?_c('div',{staticClass:"column rewards_container"},[_c('div',{staticClass:"rewards_box"},[_c('h3',[_vm._v("\n            "+_vm._s(_vm.$t("msg.monthly_rewards", {
                month: _vm.$t(("msg.months." + (this.poolMonth))),
              }))+":\n          ")]),_vm._v(" "),(_vm.pool.amount)?_c('div',{staticClass:"content_rewards"},[_c('img',{staticClass:"blue_token_rewards",attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('div',{staticClass:"data_rewards"},[_c('p',[_vm._v(_vm._s(_vm.pool.amount))]),_vm._v(" "),(_vm.pool.amount * _vm.bluValue[0].value > 0)?_c('div',[_c('span',[_vm._v("≈\n                  "+_vm._s(parseInt(_vm.pool.amount * _vm.bluValue[0].value))+" USDT")])]):_vm._e()])]):_c('div',{staticStyle:{"height":"100%"}},[_c('loading')],1)]),_vm._v(" "),_c('div',{staticClass:"arrow_reward"},[_c('svg',{staticClass:"arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z","clip-rule":"evenodd"}})])]),_vm._v(" "),_c('div',{staticClass:"rewards_box"},[_c('h3',[_vm._v(_vm._s(_vm.$tc("msg.my_rewards", 1))+":")]),_vm._v(" "),(_vm.memberPoolInfo)?_c('div',{staticClass:"content_rewards"},[_c('img',{staticClass:"blue_token_rewards",attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('div',{staticClass:"data_rewards"},[(_vm.memberPoolInfo.referralVolume >= 1)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.memberPoolInfo.estimated.toFixed(2)))]),_vm._v(" "),_c('span',[_vm._v("≈\n                  "+_vm._s((_vm.memberPoolInfo.estimated * _vm.bluValue[0].value).toFixed(2))+"\n                  USDT")])]):_c('div',[_c('p',[_vm._v("0.00")])])])]):_c('div',{staticStyle:{"height":"100%"}},[_c('loading')],1)])]):_c('div',{staticClass:"column rewards_container"},[_c('div',{staticClass:"rewards_box"},[_c('h3',{style:(_vm.pool ? '' : 'color:transparent')},[_vm._v("\n            "+_vm._s(_vm.$t("msg.monthly_rewards", {
                month: _vm.$t(("msg.months." + (this.poolMonth))),
              }))+":\n          ")]),_vm._v(" "),_c('div',{staticClass:"content_rewards"},[_c('img',{staticClass:"blue_token_rewards",attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),(_vm.pool)?_c('div',{staticClass:"data_rewards"},[(_vm.pool && _vm.bluValue[0])?_c('div',[_c('p',[_vm._v(_vm._s(_vm.pool.amount))]),_vm._v(" "),_c('div',[_c('span',[_vm._v("≈\n                    "+_vm._s(parseInt(_vm.pool.amount * _vm.bluValue[0].value))+" USDT")])])]):_c('div',{staticStyle:{"height":"20%"}},[_c('loading')],1)]):_c('div',{staticClass:"calculating"},[_c('span',[_vm._v(_vm._s(_vm.$tc("msg.calculating", 1)))])])])]),_vm._v(" "),_c('div',{staticClass:"arrow_reward"},[_c('svg',{staticClass:"arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z","clip-rule":"evenodd"}})])]),_vm._v(" "),_c('div',{staticClass:"rewards_box"},[_c('h3',[_vm._v(_vm._s(_vm.$tc("msg.my_rewards", 1))+":")]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),(_vm.modal)?_c('div',[_c('modalPool',{attrs:{"joinPool":_vm.joinPool},on:{"closeModalPool":function($event){return _vm.showModal()},"reloadUser":function($event){return _vm.reloadUsers()}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","text-align":"right"}},[(_vm.lastMonthPools.length > 0)?_c('span',{staticStyle:{"color":"orange","text-decoration":"underline","cursor":"pointer","margin-right":"20px"},on:{"click":function($event){return _vm.toogleModal()}}},[_vm._v(_vm._s(_vm.$tc("msg.last_month_winners", 1))+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.member.poolProgram && _vm.pool && _vm.referralVolume < 1)?_c('div',{staticClass:"column qualification_status"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('h2',[_vm._v(_vm._s(_vm.$tc("msg.qualification_status", 1)))])]),_vm._v(" "),_c('div',{staticClass:"wrapper_bar"},[_c('div',{staticClass:"bar"},[_c('p',{style:({
                marginLeft: [(_vm.referralVolume * 100).toFixed(2) + '%'],
              })},[_vm._v("\n              "+_vm._s(_vm.referralVolume.toFixed(2))+" BLUE\n            ")]),_vm._v(" "),_c('span',{staticClass:"left_to_qualification",style:({
                marginLeft: [(_vm.referralVolume * 100).toFixed(2) + '%'],
              })},[_vm._v("\n              "+_vm._s(_vm.$tc("msg.need_to_qualify", 1))+"\n              "+_vm._s((1 - _vm.referralVolume).toFixed(2))+" BLUE\n              "+_vm._s(_vm.$tc("msg.to_qualify", 1))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"coin_bar m13_t"},[_c('span',{staticClass:"coin_bar_filled",style:({
                  width: [(_vm.referralVolume * 100).toFixed(2) + '%'],
                })})])]),_vm._v(" "),_vm._m(2)])]):_vm._e(),_vm._v(" "),(
          _vm.pool && (_vm.membersOnPoolProgram.length > 0 || !_vm.member.poolProgram)
        )?_c('div',{staticClass:"column wrapper_join_pool"},[_c('div',{staticClass:"wrapper_winners"},[_c('a',{domProps:{"innerHTML":_vm._s(_vm.$t('msg.how_it_works'))}})]),_vm._v(" "),_c('div',{staticClass:"title_and_btn"},[(_vm.membersOnPoolProgram.length > 0)?_c('h3',[_vm._v("\n            "+_vm._s(_vm.$tc("msg.leaderboard", 1))+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"title_and_btn"},[(!_vm.member.poolProgram)?_c('button',{on:{"click":function($event){return _vm.showModal()}}},[_vm._v("\n            "+_vm._s(_vm.$tc("msg.join_pool", 1))+"\n          ")]):_c('div',{staticClass:"wrapper_winners",staticStyle:{"color":"transparent"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"}})])])])]):_vm._e(),_vm._v(" "),(_vm.pool)?_c('div',{staticClass:"table_pool"},[(_vm.membersOnPoolProgram.length > 0)?_c('div',[_c('div',{staticClass:"table_container"},[_c('table',[_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Avatar")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("\n                    "+_vm._s(_vm.$tc("msg.referral_volume", 1))+"\n                  ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("\n                    "+_vm._s(_vm.$tc("msg.reward_pool", 1))+"\n                  ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("\n                    "+_vm._s(_vm.$tc("msg.estimated_pool", 1))+"\n                  ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.membersOnPoolProgram),function(item,index){return _c('tr',{key:index,style:(_vm.memberPoolInfo.nickname == item.nickname
                      ? 'background: #b5c2f0; font-weight: 600'
                      : '')},[_c('td',[_c('div',{staticClass:"icon_table"},[_c('img',{attrs:{"src":_vm.renderImage(item.avatar),"alt":item.avatar}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.nickname))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"icon_table_numbers"},[_c('img',{staticStyle:{"width":"1.2rem !important"},attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.referralVolume && item.referralVolume.toFixed(2)))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"icon_table_numbers"},[_c('div'),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.rewardPercent && item.rewardPercent.toFixed(2))+"%")])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"icon_table_numbers"},[_c('img',{staticStyle:{"width":"1.2rem !important"},attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v("\n                      "+_vm._s(item.estimated && item.estimated.toFixed(2))+"\n                    ")])])])}),0)]),_vm._v(" "),(_vm.membersOnPoolProgram.length > 10)?_c('button',[_vm._v("\n              "+_vm._s(_vm.$tc("msg.view_all", 1))+"\n            ")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.loadingTable)?_c('div',{staticStyle:{"height":"20%"}},[_c('loading')],1):(!_vm.loadingTable && _vm.membersOnPoolProgram.length == 0)?_c('div',{staticClass:"nobody_has_qualified"},[_c('p',[_vm._v("\n            "+_vm._s(_vm.$tc("msg.nobody_qualified", 1))+"\n          ")])]):_vm._e()]):_c('div',{staticClass:"check_again_soon"},[_c('p',[_vm._v(_vm._s(_vm.$tc("msg.posted_soon", 1)))])])])]):_c('div',{staticClass:"cointainer_lg column combo_1"},[_vm._m(3),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","flex-direction":"column","align-items":"center","margin-top":"2rem"}},[_c('loading',{staticStyle:{"background":"#e2e2e2","width":"200px","padding":"10px","padding-bottom":"20px","border-radius":"20px"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc("msg.loading", 1)))])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_landing_welcome_title"},[_c('h1',{staticClass:"component_title_lg fat m0_b"},[_vm._v("Blue Pool")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_rewards",staticStyle:{"justify-content":"space-between"}},[_c('img',{staticClass:"blue_token_rewards",attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('div',{staticClass:"data_rewards"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue_image"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('p',[_vm._v("1 BLUE")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_landing_welcome_title"},[_c('h1',{staticClass:"component_title_lg fat m0_b"},[_vm._v("Blue Pool")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Insights_vue__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313a35de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Insights_vue__ = __webpack_require__(1094);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Insights_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_313a35de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Insights_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsHoldings_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e83120_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsHoldings_vue__ = __webpack_require__(1062);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsHoldings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e83120_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsHoldings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('div',{staticClass:"insights_holding column"},[_c('div',{staticClass:"title_insights"},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.$t("msg.fund_holdings").toUpperCase())+"\n      ")])]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"start"}},[_vm._v(_vm._s(_vm.$t("msg.component_hold")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("msg.quantity")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("msg.allocation")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("msg.current_weight")))]),_vm._v(" "),_c('th',[_vm._v("Staking APY")])])]),_vm._v(" "),_vm._l((_vm.assetList),function(item){return (item.overallWeight > 0)?_c('tbody',{key:item.id,staticClass:"teste_active"},[_c('tr',{staticClass:"teste_active",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectCurrency(item)}}},[_c('td',[_c('div',{staticClass:"isights_coin_icon background_",class:'background_' + item.currency.symbol}),_vm._v(" "),_c('p',{staticClass:"dis_inb"},[_vm._v("\n              "+_vm._s(item.currency.name == "TrueUSD" ? "USDT" : item.currency.name)+"\n            ")]),_vm._v(" "),(_vm.greenDot(item.apyPercent))?_c('button'):_vm._e()]),_vm._v(" "),(item.quantity)?_c('td',[_vm._v("\n            "+_vm._s(_vm.currencyFormat(item.quantity))+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percentage")(item.assignedOverallWeight,2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percentage")(item.overallWeight,2)))]),_vm._v(" "),_c('td',{staticStyle:{"color":"#3ed18f","font-weight":"600"}},[(item.apyPercent )?_c('span',[(item.apyPercent > 0)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(" "+_vm._s(item.apyPercent)+"%")]):_vm._e()])])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"currently_generating"},[_c('button'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.currently_generating")))])])])]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"insights_holding"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_vm._v(_vm._s(_vm.$t("msg.fund_holdings")))]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"insights_holding"},[_c('table',[_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"start"}},[_vm._v("\n                "+_vm._s(_vm.$t("msg.component_hold"))+"\n              ")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("msg.quantity")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("msg.current_weight")))])])]),_vm._v(" "),_vm._l((_vm.assetList),function(item){return (item.overallWeight > 0)?_c('tbody',{key:item.id,staticClass:"teste_active"},[_c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectCurrency(item)}}},[_c('td',[_c('div',{staticClass:"isights_coin_icon background_",class:'background_' + item.currency.symbol}),_vm._v(" "),_c('p',{staticClass:"dis_inb"},[_vm._v(_vm._s(item.currency.symbol))]),_vm._v(" "),(_vm.greenDot(item.currency.symbol))?_c('button'):_vm._e()]),_vm._v(" "),(item.quantity)?_c('td',[_vm._v("\n                "+_vm._s(_vm.currencyFormat(item.quantity))+"\n              ")]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("percentage")(item.assignedOverallWeight,2)))])])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"currently_generating"},[_c('button'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.currently_generating")))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsReports_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28226260_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsReports_vue__ = __webpack_require__(1064);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28226260_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('div',{staticClass:"column",attrs:{"id":"report_insights"}},[_c('div',{staticClass:"title_insights"},[_c('h1',[_vm._v("\n        "+_vm._s(_vm.$t("msg.report"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"column p10"},[_c('div',{staticClass:"column p0 content_report"},[_c('div',{staticClass:"val_m p10"},[_c('a',{staticClass:"report_link m4_b",attrs:{"href":_vm.returnLink(),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t("msg.report_link_download_quarter"))+"\n          ")]),_vm._v(" "),_c('span',{staticClass:"report_link"},[_vm._v(_vm._s(_vm.$t("msg.report_link_span")))])]),_vm._v(" "),_c('a',{staticClass:"icon_class_3",attrs:{"href":_vm.returnLink(),"target":"_blank"}},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.download)}})])])])])]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"report_insights"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_vm._v(_vm._s(_vm.$t("msg.report")))]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{attrs:{"id":"report_insights"}},[_c('div',[_c('div',{staticClass:"column p0 content_report"},[_c('div',{staticClass:"val_m p10"},[_c('a',{staticClass:"report_link m4_b",attrs:{"href":_vm.returnLink(),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t("msg.report_link_download_quarter"))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"report_link"},[_vm._v(_vm._s(_vm.$t("msg.report_link_span")))])]),_vm._v(" "),_c('a',{staticClass:"icon_class_3",attrs:{"href":_vm.returnLink(),"target":"_blank"}},[_c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSets.download)}})])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralCharts_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13feb97c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralCharts_vue__ = __webpack_require__(1066);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralCharts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13feb97c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralCharts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('div',{staticClass:"column landing_charts",attrs:{"id":"landing_charts"}},[_c('div',{staticClass:"title_insights"},[_c('h1',{staticStyle:{"text-transform":"uppercase"}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.performance"))+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"wrapper_chart_insights"},[_c('p',{staticClass:"expand_chart",on:{"click":function($event){return _vm.toggleModalExpandChart()}}},[_vm._v("\n        "+_vm._s(_vm.$t("msg.expand_chart"))+"\n        "),_c('img',{attrs:{"src":__webpack_require__(147),"alt":"external-link"}})]),_vm._v(" "),_c('a',{staticClass:"price_history",attrs:{"href":"#"},on:{"click":function($event){return _vm.toggleModalPriceHist()}}},[_vm._v(_vm._s(_vm.$t("msg.price_history_list")))]),_vm._v(" "),_c('div',{staticClass:"period"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.g_l"))+":")]),_vm._v(" "),(this.chartMode == 'hour')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeHour()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'week')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeWeek()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'day')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeDay()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'month')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeMonth()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'year')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeYear()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'ytd')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeYTD()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'all')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeAll()))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"column landing_charts_label p0"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('span',{staticClass:"landing_charts_label_block"}),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.$tc("msg.price", 1))+"\n          "),_c('strong',[_vm._v("BLUE | USDT")])])]),_vm._v(" "),_c('div',{staticClass:"combo_buttons_charts",class:{ loading_action: _vm.chartLoading }},[_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'day' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'day' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('day')}}},[_vm._v("1D")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'week' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'week' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('week')}}},[_vm._v("1"+_vm._s(_vm.$t("msg.w")))]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'month' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'month' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('month')}}},[_vm._v("1M")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'year' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'year' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('year')}}},[_vm._v("1Y")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'ytd' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'ytd' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('ytd')}}},[_vm._v("YTD")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'all' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'all' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('all')}}},[_vm._v(_vm._s(_vm.$t("msg.all")))])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('chart-line-custom',{attrs:{"chartData":_vm.chartParams,"bluValue":_vm.bluValue[0]},on:{"chartLoaded":function($event){return _vm.setChartLoading(false)},"chartLoading":function($event){return _vm.setChartLoading(true)}}})],1)])]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"landing_charts"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.performance"))+"\n      "),_c('div',{staticClass:"period"},[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue_token"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("msg.g_l"))+":")])]),_vm._v(" "),(this.chartMode == 'hour')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeHour()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'week')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeWeek()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'day')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeDay()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'month')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeMonth()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'year')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeYear()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'ytd')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeYTD()))]):_vm._e(),_vm._v(" "),(this.chartMode == 'all')?_c('span',{style:(_vm.positiveTotal ? 'color:#22c9b6' : 'color:red')},[_vm._v(_vm._s(_vm.getPercentChangeAll()))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"landing_charts",attrs:{"id":"landing_charts"}},[_c('div',{staticClass:"wrapper_chart_insights"},[_c('p',{staticClass:"expand_chart",on:{"click":function($event){return _vm.toggleModalExpandChart()}}},[_vm._v("\n            "+_vm._s(_vm.$t("msg.expand_chart"))+"\n            "),_c('img',{attrs:{"src":__webpack_require__(147),"alt":"external-link"}})]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.toggleModalPriceHist()}}},[_vm._v(_vm._s(_vm.$t("msg.price_history_list")))])]),_vm._v(" "),_c('div',{staticClass:"column landing_charts_label p0"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('p',[_vm._v("\n              "+_vm._s(_vm.$tc("msg.price", 1))+"\n              BLUE | USDT\n            ")])]),_vm._v(" "),_c('div',{staticClass:"combo_buttons_charts",class:{ loading_action: _vm.chartLoading }},[_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'day' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'day' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('day')}}},[_vm._v("1D")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'week' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'week' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('week')}}},[_vm._v("1"+_vm._s(_vm.$t("msg.w")))]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'month' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'month' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('month')}}},[_vm._v("1M")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'year' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'year' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('year')}}},[_vm._v("1Y")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'ytd' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'ytd' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('ytd')}}},[_vm._v("YTD")]),_vm._v(" "),_c('a',{staticClass:"link_switch",class:{ link_switch_active: _vm.chartMode == 'all' },staticStyle:{"padding":"0 5px !important"},attrs:{"disabled":_vm.chartMode == 'all' || _vm.chartLoading},on:{"click":function($event){return _vm.toggleChart('all')}}},[_vm._v(_vm._s(_vm.$t("msg.all")))])])]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0.75rem 0"}},[_c('chart-line-custom',{attrs:{"chartData":_vm.chartParams,"bluValue":_vm.bluValue[0]},on:{"chartLoaded":function($event){return _vm.setChartLoading(false)},"chartLoading":function($event){return _vm.setChartLoading(true)}}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsCharity_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3328caa4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsCharity_vue__ = __webpack_require__(1070);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsCharity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3328caa4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsCharity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bitgive.png?0f4521d9d47843dc665bbe06fb9047e3";

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4h.png?1f74e34dc54c1b39c9d2b17ca16df064";

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p-component-card",attrs:{"id":"page_insights_charity"}},[_c('div',{staticClass:"component_card_border_bottom"},[_c('h1',{staticClass:"component_title_md fat main_blue_dk_fill tal_c"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.charity")))])])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"column tal_c"},[_c('p',[_vm._v(_vm._s(_vm.$t("msg.charity_sub")))])])]),_vm._v(" "),_c('div',{staticClass:"columns component_card_border_bottom"},[_c('div',{staticClass:"column"},[_c('a',{staticClass:"charity-image",attrs:{"href":"https://www.bitgivefoundation.org/","target":"_blank"}},[_c('img',{staticClass:"charity-image",attrs:{"src":_vm.charity[0].image}})])]),_vm._v(" "),_c('div',{staticClass:"column text-charity"},[_c('span',{staticClass:"tal_r_b val_m"},[_vm._v(_vm._s(_vm.charity[0].amout)+" BTC")])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"columns split_half_text"},[_c('div',{staticClass:"column"},[_c('a',{staticClass:"charity-image",attrs:{"href":"https://www.b4h.world/","target":"_blank"}},[_c('img',{staticClass:"charity-image",attrs:{"src":_vm.charity[1].image}})])]),_vm._v(" "),_c('div',{staticClass:"column text-charity"},[_c('span',{staticClass:"tal_r_b val_m"},[_vm._v(_vm._s(_vm.charity[0].amout)+" BTC")])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"column p0 text_ssm"},[_vm._v(_vm._s(_vm.$t("msg.last_update"))+" 01/04/2020")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsSupply_vue__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78c9856e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsSupply_vue__ = __webpack_require__(1072);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InsightsSupply_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78c9856e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InsightsSupply_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',{staticClass:"card-boder-bg"},[_c('div',{staticClass:"basket_insights"},[_c('div',{staticClass:"token_supply"},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.token_supply")))]),_vm._v(" "),_c('img',{staticStyle:{"width":"1.2rem","margin-left":"0.5rem","cursor":"pointer"},attrs:{"src":__webpack_require__(147),"alt":"external-link"},on:{"click":function($event){return _vm.openSite()}}})]),_vm._v(" "),(_vm.fundTails[0].tokenQuantity > 0)?_c('div',{staticClass:"basket_insights_content",staticStyle:{"align-items":"end"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.fundTails[0].tokenQuantity))+" BLUE")])])]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"basket_value"},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.basket_value")))]),_vm._v(" "),_c('div',{staticClass:"basket_insights_content",staticStyle:{"flex-direction":"column","align-items":"end"}},[(_vm.fundTails[0].tokenQuantity > 0)?_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":"USDT"}}),_vm._v(" "),_c('span',[_vm._v("  \n            "+_vm._s(_vm.currencyFormat(_vm.bluValue[0].value * _vm.fundTails[0].tokenQuantity))+" USDT\n          ")])]):_vm._e(),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v("\n          "+_vm._s(_vm.$t("msg.view_other_currencies"))+"\n        ")])])])])]):_c('div',{staticClass:"tabs_mobile"},[_c('div',{staticClass:"tab"},[_c('input',{staticClass:"tab_input",attrs:{"type":"checkbox","id":"token_supply"}}),_vm._v(" "),_c('label',{staticClass:"tab-label"},[_vm._v("\n      "+_vm._s(_vm.$t("msg.token_supply"))+"\n      "),_c('div',{staticClass:"basket_insights"},[(_vm.fundTails[0].tokenQuantity > 0)?_c('div',{staticClass:"token_supply"},[_c('div',{staticClass:"basket_insights_content"},[_c('img',{attrs:{"src":__webpack_require__(11),"alt":"blue icon"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currencyFormat(_vm.fundTails[0].tokenQuantity))+" BLUE")])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"basket_insights"},[_c('div',{staticClass:"basket_value"},[_c('h1',[_vm._v(_vm._s(_vm.$t("msg.basket_value")))]),_vm._v(" "),_c('div',{staticClass:"basket_insights_content",staticStyle:{"align-items":"center"}},[_c('img',{attrs:{"src":__webpack_require__(29),"alt":"USDT"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"end"}},[(_vm.fundTails[0].tokenQuantity > 0)?_c('span',[_vm._v("\n                "+_vm._s(_vm.currencyFormat(_vm.bluValue[0].value * _vm.fundTails[0].tokenQuantity))+" USDT\n              ")]):_vm._e(),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_vm._v("\n                "+_vm._s(_vm.$t("msg.view_other_currencies"))+"\n              ")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalExpandChart_vue__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5dfbbc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalExpandChart_vue__ = __webpack_require__(1085);
function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalExpandChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a5dfbbc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalExpandChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("745ac21a", content, true, {});

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.wrapper_modal_expand_chart{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_expand_chart .content_expand_chart{position:relative;padding:2rem 2.5rem;border-radius:6px;max-width:1000px;height:auto;width:100%;background-color:#fff}.wrapper_modal_expand_chart .content_expand_chart svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_expand_chart .content_expand_chart svg:hover{color:#342365}.wrapper_modal_expand_chart .content_expand_chart .landing_charts_label .price_blue_chart{display:flex}@media only screen and (max-width:900px){.wrapper_modal_expand_chart .content_expand_chart{max-width:600px;padding:1rem 1.5rem}.wrapper_modal_expand_chart .content_expand_chart svg{top:.3rem;right:.3rem;width:1rem}}@media only screen and (max-width:380px){.wrapper_modal_expand_chart .content_expand_chart{max-width:350px;padding:.5rem 1rem}.wrapper_modal_expand_chart .content_expand_chart #landing_charts .combo_buttons_charts{justify-content:center!important}.wrapper_modal_expand_chart .content_expand_chart .landing_charts_label{padding:0!important;justify-content:center;flex-wrap:nowrap;flex-direction:column;align-items:center}.wrapper_modal_expand_chart .content_expand_chart .link_switch{margin:1%!important}}@media only screen and (max-width:350px){.wrapper_modal_expand_chart .content_expand_chart{max-width:300px}}", ""]);

// exports


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TradeChart_vue__ = __webpack_require__(453);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27157ecf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeChart_vue__ = __webpack_require__(1084);
function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TradeChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27157ecf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradeChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1078);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4f58df8c", content, true, {});

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".k-line-chart-container{display:flex;flex-direction:column;margin:auto;border-radius:2px;box-shadow:0 2px 4px rgba(0,0,0,.3);background-color:#fff;width:900px;height:520px;padding:1rem .5rem}@media screen and (max-width:600px){.k-line-chart-container{width:98%;padding:0}}.k-line-chart-title{margin:0;color:#252525;padding-bottom:10px}.k-line-chart{display:flex;flex:1}.k-line-chart-menu-container{display:flex;flex-direction:row;align-items:center;margin-top:10px;font-size:12px;color:#606060}.k-line-chart-menu-container button{cursor:pointer;background-color:#342365;border-radius:4px;margin-right:8px;height:24px;line-height:26px;padding:0 6px;font-size:12px;color:#fff;border:none;outline:none}", ""]);

// exports


/***/ }),
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c09937_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__(1083);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31c09937_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-line-chart-container"},[_c('h3',{staticClass:"k-line-chart-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-line-chart-container"},[_c('div',{staticClass:"k-line-chart",attrs:{"id":"technical-indicator-k-line"}}),_vm._v(" "),_c('div',{staticClass:"k-line-chart-menu-container"},[_vm._l((_vm.shapes),function(ref){
var key = ref.key;
var text = ref.text;
return _c('button',{key:key,on:{"click":function($event){return _vm.setShapeType(key)}}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.removeAllShape()}}},[_vm._v("Clear")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask",attrs:{"id":"landing_charts"}},[_c('div',{staticClass:"wrapper_modal_expand_chart"},[_c('div',{staticClass:"content_expand_chart"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalExpandChart()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),(_vm.chartData.length > 0)?_c('trade-chart',{attrs:{"chartData":_vm.chartData}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalCurrencyInfo_vue__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7bf25c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalCurrencyInfo_vue__ = __webpack_require__(1089);
function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalCurrencyInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e7bf25c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalCurrencyInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1088);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("6707e86e", content, true, {});

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.wrapper_modal_other_currencies{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_other_currencies .content_other_currencies{position:relative;padding:2rem 2.5rem;border-radius:6px;max-width:585px;max-height:465px;width:100%;background-color:#fff}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies{display:flex;border-bottom:1px solid #000!important;padding-bottom:.5rem;width:100%;font-size:1.5rem;text-align:center;justify-content:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies h1{font-size:1rem;font-weight:600;color:#342365}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value{display:flex;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value img{width:1.4rem;margin-right:10px}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_other_currencies .content_other_currencies svg:hover{color:#342365}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent{display:flex;flex-direction:column;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent h2{font-size:1rem;font-weight:600;margin:1.2rem 0}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list{display:flex;flex-direction:column;align-items:flex-end}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list{display:flex;align-items:center;justify-content:space-between;margin-bottom:.8rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list img{width:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list .currencies_icon{width:1.4rem;height:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p{margin-top:.5rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p:last-child{margin-top:1rem}@media only screen and (max-width:900px){.wrapper_modal_other_currencies .content_other_currencies{padding:2rem 1.5rem;max-width:350px;max-height:450px}}@media only screen and (max-width:350px){.wrapper_modal_other_currencies .content_other_currencies{max-width:300px;max-height:450px}}", ""]);

// exports


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask",on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('div',{staticClass:"wrapper_modal_other_currencies"},[_c('div',{staticClass:"content_other_currencies"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalCurrencies()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),(_vm.selectedCurrency.currency.symbol == 'TUSD')?_c('div',{staticClass:"title_other_currencies",staticStyle:{"text-align":"center"}},[_vm._v("\n        Tether (USDT)\n      ")]):_c('div',{staticClass:"title_other_currencies",staticStyle:{"text-align":"center"}},[_vm._v("\n        "+_vm._s(_vm.selectedCurrency.currency.name)+" ("+_vm._s(_vm.selectedCurrency.currency.symbol)+")\n      ")]),_vm._v(" "),_c('div',{staticClass:"currencies_equivalent"},[_c('div',{staticClass:"wrapper_currencies_list",staticStyle:{"margin-top":"20px"}},[_c('span',{staticClass:"currencies_icon background_ icon_class_10 val_m",class:'background_' + _vm.selectedCurrency.currency.symbol})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(("msg.text_" + (_vm.selectedCurrency.currency.symbol)))))]),_vm._v(" "),(_vm.selectedCurrency.apy)?_c('p',[_vm._v("\n          Staking APY:\n          "),_c('span',{staticStyle:{"color":"#3ed18f","font-weight":"600"}},[(_vm.selectedCurrency.apy > 0)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.selectedCurrency.apy)+"%")])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPriceHist_vue__ = __webpack_require__(456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d87b8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPriceHist_vue__ = __webpack_require__(1093);
function injectStyle (ssrContext) {
  __webpack_require__(1091)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPriceHist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d87b8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalPriceHist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("35395a28", content, true, {});

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".modal_mask{position:absolute;background-color:rgba(0,0,0,.6);width:100%;height:100%;left:0;top:0;z-index:998;overflow:auto}.wrapper_modal_other_currencies{position:fixed;left:0;top:0;right:0;bottom:0;z-index:999;margin:auto;display:flex;align-items:center;justify-content:center;flex-direction:column}.wrapper_modal_other_currencies .content_other_currencies{position:relative;padding:1rem;border-radius:6px;max-width:500px;width:100%;background-color:#fff;display:flex;flex-direction:column;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .component-table{overflow-y:auto;width:100%}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies{display:flex;border-bottom:1px solid #342365!important;padding-bottom:.5rem;width:100%;font-size:1.5rem;font-weight:600;text-align:center;justify-content:center;color:#342365}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value{display:flex;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value img{width:1.4rem;margin-right:10px}.wrapper_modal_other_currencies .content_other_currencies .title_other_currencies .usdt_value span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies svg{position:absolute;top:.5rem;width:1.2rem;right:.5rem;cursor:pointer}.wrapper_modal_other_currencies .content_other_currencies svg:hover{color:#342365}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent{display:flex;flex-direction:column;align-items:center}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent h2{font-size:1rem;font-weight:600;margin:1.2rem 0}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list{display:flex;flex-direction:column;align-items:flex-end}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list{display:flex;align-items:center;justify-content:space-between;margin-bottom:.8rem}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list span{font-size:1rem;font-weight:600}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list img{width:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent .wrapper_currencies_list .currencies_list .currencies_icon{width:1.4rem;height:1.4rem;margin-left:15px}.wrapper_modal_other_currencies .content_other_currencies .currencies_equivalent p{margin-top:.5rem}.wrapper_modal_other_currencies .content_other_currencies button{outline:none;padding:8px 20px;color:#fff;border-radius:6px;background:#342365;border:none;cursor:pointer;font-size:1rem;transition:all .2s ease-in-out}.wrapper_modal_other_currencies .content_other_currencies button:hover{opacity:.9}@media only screen and (max-width:500px){.wrapper_modal_other_currencies .content_other_currencies{padding:2rem 1.5rem;max-width:350px}}@media only screen and (max-width:350px){.wrapper_modal_other_currencies .content_other_currencies{max-width:300px}}", ""]);

// exports


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_mask"},[_c('div',{staticClass:"wrapper_modal_other_currencies"},[_c('div',{staticClass:"content_other_currencies"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke":"currentColor","stroke-width":"2"},on:{"click":function($event){return _vm.toggleModalPriceHist()}}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M6 18L18 6M6 6l12 12"}})]),_vm._v(" "),_c('div',{staticClass:"title_other_currencies",staticStyle:{"text-align":"center"}},[_vm._v("\n\n        "+_vm._s(_vm.$t("msg.price_history_list"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"component_table"},[_c('vue-good-table',{attrs:{"columns":_vm.tableColumns,"rows":_vm.priceHist.data,"sort-options":{
            enabled: true,
            initialSortBy: { field: 'at', type: 'asc' },
          },"pagination-options":{
            enabled: true,
            perPage: 10,
            position: 'bottom',
            perPageDropdown: [10, 15, 20],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: _vm.$tc('msg.next', 2),
            prevLabel: _vm.$tc('msg.previous', 2),
            rowsPerPageLabel: _vm.$t('msg.rows_per_page'),
            ofLabel: _vm.$t('msg.of'),
            pageLabel: _vm.$t('msg.page'), // for 'pages' mode
            allLabel: _vm.$t('msg.all'),
          }},scopedSlots:_vm._u([{key:"table-column",fn:function(props){return [(props.column.label == 'createdAt')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.createdAt")))]):_vm._e(),_vm._v(" "),(props.column.label == 'price')?_c('span',[_vm._v(_vm._s(_vm.$t("msg.price"))+" USDT")]):_vm._e()]}},{key:"table-row",fn:function(props){return [(props.column.field == 'at')?_c('span',[_vm._v("\n              "+_vm._s(_vm.fixTimeTest(props.formattedRow[props.column.field]).slice(
                  0,
                  -10
                ))+"\n              "),_c('br')]):(props.column.field == 'max')?_c('span',[_vm._v("\n              "+_vm._s(props.formattedRow[props.column.field].toFixed(2))+"\n            ")]):_vm._e()]}}])})],1),_vm._v(" "),_c('button',[_vm._v(_vm._s(_vm.$t("msg.download_csv")))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column p0 minH100",attrs:{"id":"page_insights"}},[_c('div',{staticClass:"cointainer_xl grid insights_grid"},[_c('div',{staticClass:"column_insights",staticStyle:{"grid-column":"span 2 / span 2"}},[_c('div',{staticClass:"component_card combo_1"},[_c('insights-supply',{on:{"toggleModalCurrencies":function($event){return _vm.showModalCurrencies('supply')}}})],1),_vm._v(" "),(_vm.modalCurrencies)?_c('div',[_c('modalOtherCurrencies',{attrs:{"type":_vm.type},on:{"toggleModalCurrencies":function($event){return _vm.showModalCurrencies()}}})],1):_vm._e(),_vm._v(" "),(_vm.modalCurrencyInfo)?_c('div',[_c('modalCurrencyInfo',{attrs:{"selectedCurrency":_vm.selectedCurrency},on:{"toggleModalCurrencies":function($event){return _vm.showModalCurrencyInfo()}}})],1):_vm._e(),_vm._v(" "),(_vm.modalPriceHist)?_c('div',[_c('modalPriceHist',{attrs:{"priceHist":_vm.priceHistory},on:{"toggleModal":function($event){return _vm.showModalPriceHist()}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"component_card combo_1"},[_c('general-charts',{on:{"toggleModalExpandChart":function($event){return _vm.showModalExpandChart()},"toggleModalPriceHist":function($event){return _vm.showModalPriceHist()},"createPriceHist":function (el) { return _vm.createPriceHist(el); }}})],1),_vm._v(" "),(_vm.modalExpandChart)?_c('div',[_c('modalExpandChart',{on:{"toggleModalExpandChart":function($event){return _vm.showModalExpandChart()}}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"component_card combo_1"},[_c('insights-reports')],1)]),_vm._v(" "),_c('div',{staticClass:"column_insights",staticStyle:{"grid-column":"span 3 / span 3"}},[_c('div',{staticClass:"component_card combo_1",staticStyle:{"border-bottom":"0rem"}},[_c('insigths-holdings',{on:{"toggleModal":function (el) { return _vm.showModalCurrencyInfo(el); }}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1096);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("159e9682", content, true, {});

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "/*! bulma.io v0.7.1 | MIT License | github.com/jgthms/bulma */@-webkit-keyframes spinAround{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg,1)}}@keyframes spinAround{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg,1)}}.breadcrumb,.button,.delete,.file,.is-unselectable,.modal-close,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.tabs{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.navbar-link:after,.select:not(.is-multiple):not(.is-loading):after{border:3px solid transparent;border-radius:2px;border-right:0;border-top:0;content:\" \";display:block;height:.625em;margin-top:-.4375em;pointer-events:none;position:absolute;top:50%;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:center;transform-origin:center;width:.625em}.block:not(:last-child),.box:not(:last-child),.breadcrumb:not(:last-child),.content:not(:last-child),.highlight:not(:last-child),.level:not(:last-child),.message:not(:last-child),.notification:not(:last-child),.progress:not(:last-child),.subtitle:not(:last-child),.table-container:not(:last-child),.table:not(:last-child),.tabs:not(:last-child),.title:not(:last-child){margin-bottom:1.5rem}.delete,.modal-close{-moz-appearance:none;-webkit-appearance:none;background-color:hsla(0,0%,4%,.2);border:none;border-radius:290486px;cursor:pointer;display:inline-block;flex-grow:0;flex-shrink:0;font-size:0;height:20px;max-height:20px;max-width:20px;min-height:20px;min-width:20px;outline:0;position:relative;vertical-align:top;width:20px}.delete:after,.delete:before,.modal-close:after,.modal-close:before{background-color:#fff;content:\"\";display:block;left:50%;position:absolute;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);-webkit-transform-origin:center center;transform-origin:center center}.delete:before,.modal-close:before{height:2px;width:50%}.delete:after,.modal-close:after{height:50%;width:2px}.delete:focus,.delete:hover,.modal-close:focus,.modal-close:hover{background-color:hsla(0,0%,4%,.3)}.delete:active,.modal-close:active{background-color:hsla(0,0%,4%,.4)}.is-small.delete,.is-small.modal-close{height:16px;max-height:16px;max-width:16px;min-height:16px;min-width:16px;width:16px}.is-medium.delete,.is-medium.modal-close{height:24px;max-height:24px;max-width:24px;min-height:24px;min-width:24px;width:24px}.is-large.delete,.is-large.modal-close{height:32px;max-height:32px;max-width:32px;min-height:32px;min-width:32px;width:32px}.button.is-loading:after,.control.is-loading:after,.loader,.select.is-loading:after{-webkit-animation:spinAround .5s infinite linear;animation:spinAround .5s infinite linear;border:2px solid #dbdbdb;border-radius:290486px;border-right-color:transparent;border-top-color:transparent;content:\"\";display:block;height:1em;position:relative;width:1em}.hero-video,.image.is-1by1 img,.image.is-1by2 img,.image.is-1by3 img,.image.is-2by1 img,.image.is-2by3 img,.image.is-3by1 img,.image.is-3by2 img,.image.is-3by4 img,.image.is-3by5 img,.image.is-4by3 img,.image.is-4by5 img,.image.is-5by3 img,.image.is-5by4 img,.image.is-9by16 img,.image.is-16by9 img,.image.is-square img,.is-overlay,.modal,.modal-background{bottom:0;left:0;position:absolute;right:0;top:0}.button,.file-cta,.file-name,.input,.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous,.select select,.textarea{-moz-appearance:none;-webkit-appearance:none;align-items:center;border:1px solid transparent;border-radius:4px;box-shadow:none;display:inline-flex;font-size:1rem;height:2.25em;justify-content:flex-start;line-height:1.5;padding:calc(.375em - 1px) calc(.625em - 1px);position:relative;vertical-align:top}.button:active,.button:focus,.file-cta:active,.file-cta:focus,.file-name:active,.file-name:focus,.input:active,.input:focus,.is-active.button,.is-active.file-cta,.is-active.file-name,.is-active.input,.is-active.pagination-ellipsis,.is-active.pagination-link,.is-active.pagination-next,.is-active.pagination-previous,.is-active.textarea,.is-focused.button,.is-focused.file-cta,.is-focused.file-name,.is-focused.input,.is-focused.pagination-ellipsis,.is-focused.pagination-link,.is-focused.pagination-next,.is-focused.pagination-previous,.is-focused.textarea,.pagination-ellipsis:active,.pagination-ellipsis:focus,.pagination-link:active,.pagination-link:focus,.pagination-next:active,.pagination-next:focus,.pagination-previous:active,.pagination-previous:focus,.select select.is-active,.select select.is-focused,.select select:active,.select select:focus,.textarea:active,.textarea:focus{outline:0}.button[disabled],.file-cta[disabled],.file-name[disabled],.input[disabled],.pagination-ellipsis[disabled],.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled],.select select[disabled],.textarea[disabled]{cursor:not-allowed}/*! minireset.css v0.0.3 | MIT License | github.com/jgthms/minireset.css */blockquote,body,dd,dl,dt,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,html,iframe,legend,li,ol,p,pre,textarea,ul{margin:0;padding:0}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}ul{list-style:none}button,input,select,textarea{margin:0}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}audio,img,video{height:auto;max-width:100%}iframe{border:0}table{border-collapse:collapse;border-spacing:0}td,th{padding:0;text-align:left}html{background-color:#fff;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;min-width:300px;overflow-x:hidden;overflow-y:scroll;text-rendering:optimizeLegibility;-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;-ms-text-size-adjust:100%;text-size-adjust:100%}article,aside,figure,footer,header,hgroup,section{display:block}body,button,input,select,textarea{font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif}code,pre{-moz-osx-font-smoothing:auto;-webkit-font-smoothing:auto;font-family:monospace}body{color:#4a4a4a;font-size:1rem;font-weight:400;line-height:1.5}a{color:#3273dc;cursor:pointer;text-decoration:none}a strong{color:currentColor}a:hover{color:#363636}code{color:#ff3860;font-size:.875em;font-weight:400;padding:.25em .5em}code,hr{background-color:#f5f5f5}hr{border:none;display:block;height:2px;margin:1.5rem 0}img{height:auto;max-width:100%}input[type=checkbox],input[type=radio]{vertical-align:baseline}small{font-size:.875em}span{font-style:inherit;font-weight:inherit}strong{color:#363636;font-weight:700}pre{-webkit-overflow-scrolling:touch;background-color:#f5f5f5;color:#4a4a4a;font-size:.875em;overflow-x:auto;padding:1.25rem 1.5rem;white-space:pre;word-wrap:normal}pre code{background-color:transparent;color:currentColor;font-size:1em;padding:0}table td,table th{text-align:left;vertical-align:top}table th{color:#363636}.is-clearfix:after{clear:both;content:\" \";display:table}.is-pulled-left{float:left!important}.is-pulled-right{float:right!important}.is-clipped{overflow:hidden!important}.is-size-1{font-size:3rem!important}.is-size-2{font-size:2.5rem!important}.is-size-3{font-size:2rem!important}.is-size-4{font-size:1.5rem!important}.is-size-5{font-size:1.25rem!important}.is-size-6{font-size:1rem!important}.is-size-7{font-size:.75rem!important}@media screen and (max-width:768px){.is-size-1-mobile{font-size:3rem!important}.is-size-2-mobile{font-size:2.5rem!important}.is-size-3-mobile{font-size:2rem!important}.is-size-4-mobile{font-size:1.5rem!important}.is-size-5-mobile{font-size:1.25rem!important}.is-size-6-mobile{font-size:1rem!important}.is-size-7-mobile{font-size:.75rem!important}}@media print,screen and (min-width:769px){.is-size-1-tablet{font-size:3rem!important}.is-size-2-tablet{font-size:2.5rem!important}.is-size-3-tablet{font-size:2rem!important}.is-size-4-tablet{font-size:1.5rem!important}.is-size-5-tablet{font-size:1.25rem!important}.is-size-6-tablet{font-size:1rem!important}.is-size-7-tablet{font-size:.75rem!important}}@media screen and (max-width:1087px){.is-size-1-touch{font-size:3rem!important}.is-size-2-touch{font-size:2.5rem!important}.is-size-3-touch{font-size:2rem!important}.is-size-4-touch{font-size:1.5rem!important}.is-size-5-touch{font-size:1.25rem!important}.is-size-6-touch{font-size:1rem!important}.is-size-7-touch{font-size:.75rem!important}}@media screen and (min-width:1088px){.is-size-1-desktop{font-size:3rem!important}.is-size-2-desktop{font-size:2.5rem!important}.is-size-3-desktop{font-size:2rem!important}.is-size-4-desktop{font-size:1.5rem!important}.is-size-5-desktop{font-size:1.25rem!important}.is-size-6-desktop{font-size:1rem!important}.is-size-7-desktop{font-size:.75rem!important}}@media screen and (min-width:1280px){.is-size-1-widescreen{font-size:3rem!important}.is-size-2-widescreen{font-size:2.5rem!important}.is-size-3-widescreen{font-size:2rem!important}.is-size-4-widescreen{font-size:1.5rem!important}.is-size-5-widescreen{font-size:1.25rem!important}.is-size-6-widescreen{font-size:1rem!important}.is-size-7-widescreen{font-size:.75rem!important}}@media screen and (min-width:1472px){.is-size-1-fullhd{font-size:3rem!important}.is-size-2-fullhd{font-size:2.5rem!important}.is-size-3-fullhd{font-size:2rem!important}.is-size-4-fullhd{font-size:1.5rem!important}.is-size-5-fullhd{font-size:1.25rem!important}.is-size-6-fullhd{font-size:1rem!important}.is-size-7-fullhd{font-size:.75rem!important}}.has-text-centered{text-align:center!important}.has-text-justified{text-align:justify!important}.has-text-left{text-align:left!important}.has-text-right{text-align:right!important}@media screen and (max-width:768px){.has-text-centered-mobile{text-align:center!important}}@media print,screen and (min-width:769px){.has-text-centered-tablet{text-align:center!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-centered-tablet-only{text-align:center!important}}@media screen and (max-width:1087px){.has-text-centered-touch{text-align:center!important}}@media screen and (min-width:1088px){.has-text-centered-desktop{text-align:center!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-centered-desktop-only{text-align:center!important}}@media screen and (min-width:1280px){.has-text-centered-widescreen{text-align:center!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-centered-widescreen-only{text-align:center!important}}@media screen and (min-width:1472px){.has-text-centered-fullhd{text-align:center!important}}@media screen and (max-width:768px){.has-text-justified-mobile{text-align:justify!important}}@media print,screen and (min-width:769px){.has-text-justified-tablet{text-align:justify!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-justified-tablet-only{text-align:justify!important}}@media screen and (max-width:1087px){.has-text-justified-touch{text-align:justify!important}}@media screen and (min-width:1088px){.has-text-justified-desktop{text-align:justify!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-justified-desktop-only{text-align:justify!important}}@media screen and (min-width:1280px){.has-text-justified-widescreen{text-align:justify!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-justified-widescreen-only{text-align:justify!important}}@media screen and (min-width:1472px){.has-text-justified-fullhd{text-align:justify!important}}@media screen and (max-width:768px){.has-text-left-mobile{text-align:left!important}}@media print,screen and (min-width:769px){.has-text-left-tablet{text-align:left!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-left-tablet-only{text-align:left!important}}@media screen and (max-width:1087px){.has-text-left-touch{text-align:left!important}}@media screen and (min-width:1088px){.has-text-left-desktop{text-align:left!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-left-desktop-only{text-align:left!important}}@media screen and (min-width:1280px){.has-text-left-widescreen{text-align:left!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-left-widescreen-only{text-align:left!important}}@media screen and (min-width:1472px){.has-text-left-fullhd{text-align:left!important}}@media screen and (max-width:768px){.has-text-right-mobile{text-align:right!important}}@media print,screen and (min-width:769px){.has-text-right-tablet{text-align:right!important}}@media screen and (min-width:769px) and (max-width:1087px){.has-text-right-tablet-only{text-align:right!important}}@media screen and (max-width:1087px){.has-text-right-touch{text-align:right!important}}@media screen and (min-width:1088px){.has-text-right-desktop{text-align:right!important}}@media screen and (min-width:1088px) and (max-width:1279px){.has-text-right-desktop-only{text-align:right!important}}@media screen and (min-width:1280px){.has-text-right-widescreen{text-align:right!important}}@media screen and (min-width:1280px) and (max-width:1471px){.has-text-right-widescreen-only{text-align:right!important}}@media screen and (min-width:1472px){.has-text-right-fullhd{text-align:right!important}}.is-capitalized{text-transform:capitalize!important}.is-lowercase{text-transform:lowercase!important}.is-uppercase{text-transform:uppercase!important}.is-italic{font-style:italic!important}.has-text-white{color:#fff!important}a.has-text-white:focus,a.has-text-white:hover{color:#e6e6e6!important}.has-background-white{background-color:#fff!important}.has-text-black{color:#0a0a0a!important}a.has-text-black:focus,a.has-text-black:hover{color:#000!important}.has-background-black{background-color:#0a0a0a!important}.has-text-light{color:#f5f5f5!important}a.has-text-light:focus,a.has-text-light:hover{color:#dbdbdb!important}.has-background-light{background-color:#f5f5f5!important}.has-text-dark{color:#363636!important}a.has-text-dark:focus,a.has-text-dark:hover{color:#1c1c1c!important}.has-background-dark{background-color:#363636!important}.has-text-primary{color:#00d1b2!important}a.has-text-primary:focus,a.has-text-primary:hover{color:#009e86!important}.has-background-primary{background-color:#00d1b2!important}.has-text-link{color:#3273dc!important}a.has-text-link:focus,a.has-text-link:hover{color:#205bbc!important}.has-background-link{background-color:#3273dc!important}.has-text-info{color:#209cee!important}a.has-text-info:focus,a.has-text-info:hover{color:#0f81cc!important}.has-background-info{background-color:#209cee!important}.has-text-success{color:#23d160!important}a.has-text-success:focus,a.has-text-success:hover{color:#1ca64c!important}.has-background-success{background-color:#23d160!important}.has-text-warning{color:#ffdd57!important}a.has-text-warning:focus,a.has-text-warning:hover{color:#ffd324!important}.has-background-warning{background-color:#ffdd57!important}.has-text-danger{color:#ff3860!important}a.has-text-danger:focus,a.has-text-danger:hover{color:#ff0537!important}.has-background-danger{background-color:#ff3860!important}.has-text-black-bis{color:#121212!important}.has-background-black-bis{background-color:#121212!important}.has-text-black-ter{color:#242424!important}.has-background-black-ter{background-color:#242424!important}.has-text-grey-darker{color:#363636!important}.has-background-grey-darker{background-color:#363636!important}.has-text-grey-dark{color:#4a4a4a!important}.has-background-grey-dark{background-color:#4a4a4a!important}.has-text-grey{color:#7a7a7a!important}.has-background-grey{background-color:#7a7a7a!important}.has-text-grey-light{color:#b5b5b5!important}.has-background-grey-light{background-color:#b5b5b5!important}.has-text-grey-lighter{color:#dbdbdb!important}.has-background-grey-lighter{background-color:#dbdbdb!important}.has-text-white-ter{color:#f5f5f5!important}.has-background-white-ter{background-color:#f5f5f5!important}.has-text-white-bis{color:#fafafa!important}.has-background-white-bis{background-color:#fafafa!important}.has-text-weight-light{font-weight:300!important}.has-text-weight-normal{font-weight:400!important}.has-text-weight-semibold{font-weight:600!important}.has-text-weight-bold{font-weight:700!important}.is-block{display:block!important}@media screen and (max-width:768px){.is-block-mobile{display:block!important}}@media print,screen and (min-width:769px){.is-block-tablet{display:block!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-block-tablet-only{display:block!important}}@media screen and (max-width:1087px){.is-block-touch{display:block!important}}@media screen and (min-width:1088px){.is-block-desktop{display:block!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-block-desktop-only{display:block!important}}@media screen and (min-width:1280px){.is-block-widescreen{display:block!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-block-widescreen-only{display:block!important}}@media screen and (min-width:1472px){.is-block-fullhd{display:block!important}}.is-flex{display:flex!important}@media screen and (max-width:768px){.is-flex-mobile{display:flex!important}}@media print,screen and (min-width:769px){.is-flex-tablet{display:flex!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-flex-tablet-only{display:flex!important}}@media screen and (max-width:1087px){.is-flex-touch{display:flex!important}}@media screen and (min-width:1088px){.is-flex-desktop{display:flex!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-flex-desktop-only{display:flex!important}}@media screen and (min-width:1280px){.is-flex-widescreen{display:flex!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-flex-widescreen-only{display:flex!important}}@media screen and (min-width:1472px){.is-flex-fullhd{display:flex!important}}.is-inline{display:inline!important}@media screen and (max-width:768px){.is-inline-mobile{display:inline!important}}@media print,screen and (min-width:769px){.is-inline-tablet{display:inline!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-tablet-only{display:inline!important}}@media screen and (max-width:1087px){.is-inline-touch{display:inline!important}}@media screen and (min-width:1088px){.is-inline-desktop{display:inline!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-desktop-only{display:inline!important}}@media screen and (min-width:1280px){.is-inline-widescreen{display:inline!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-widescreen-only{display:inline!important}}@media screen and (min-width:1472px){.is-inline-fullhd{display:inline!important}}.is-inline-block{display:inline-block!important}@media screen and (max-width:768px){.is-inline-block-mobile{display:inline-block!important}}@media print,screen and (min-width:769px){.is-inline-block-tablet{display:inline-block!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-block-tablet-only{display:inline-block!important}}@media screen and (max-width:1087px){.is-inline-block-touch{display:inline-block!important}}@media screen and (min-width:1088px){.is-inline-block-desktop{display:inline-block!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-block-desktop-only{display:inline-block!important}}@media screen and (min-width:1280px){.is-inline-block-widescreen{display:inline-block!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-block-widescreen-only{display:inline-block!important}}@media screen and (min-width:1472px){.is-inline-block-fullhd{display:inline-block!important}}.is-inline-flex{display:inline-flex!important}@media screen and (max-width:768px){.is-inline-flex-mobile{display:inline-flex!important}}@media print,screen and (min-width:769px){.is-inline-flex-tablet{display:inline-flex!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-inline-flex-tablet-only{display:inline-flex!important}}@media screen and (max-width:1087px){.is-inline-flex-touch{display:inline-flex!important}}@media screen and (min-width:1088px){.is-inline-flex-desktop{display:inline-flex!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-inline-flex-desktop-only{display:inline-flex!important}}@media screen and (min-width:1280px){.is-inline-flex-widescreen{display:inline-flex!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-inline-flex-widescreen-only{display:inline-flex!important}}@media screen and (min-width:1472px){.is-inline-flex-fullhd{display:inline-flex!important}}.is-hidden{display:none!important}@media screen and (max-width:768px){.is-hidden-mobile{display:none!important}}@media print,screen and (min-width:769px){.is-hidden-tablet{display:none!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-hidden-tablet-only{display:none!important}}@media screen and (max-width:1087px){.is-hidden-touch{display:none!important}}@media screen and (min-width:1088px){.is-hidden-desktop{display:none!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-hidden-desktop-only{display:none!important}}@media screen and (min-width:1280px){.is-hidden-widescreen{display:none!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-hidden-widescreen-only{display:none!important}}@media screen and (min-width:1472px){.is-hidden-fullhd{display:none!important}}.is-invisible{visibility:hidden!important}@media screen and (max-width:768px){.is-invisible-mobile{visibility:hidden!important}}@media print,screen and (min-width:769px){.is-invisible-tablet{visibility:hidden!important}}@media screen and (min-width:769px) and (max-width:1087px){.is-invisible-tablet-only{visibility:hidden!important}}@media screen and (max-width:1087px){.is-invisible-touch{visibility:hidden!important}}@media screen and (min-width:1088px){.is-invisible-desktop{visibility:hidden!important}}@media screen and (min-width:1088px) and (max-width:1279px){.is-invisible-desktop-only{visibility:hidden!important}}@media screen and (min-width:1280px){.is-invisible-widescreen{visibility:hidden!important}}@media screen and (min-width:1280px) and (max-width:1471px){.is-invisible-widescreen-only{visibility:hidden!important}}@media screen and (min-width:1472px){.is-invisible-fullhd{visibility:hidden!important}}.is-marginless{margin:0!important}.is-paddingless{padding:0!important}.is-radiusless{border-radius:0!important}.is-shadowless{box-shadow:none!important}.box{background-color:#fff;border-radius:6px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;display:block;padding:1.25rem}a.box:focus,a.box:hover{box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px #3273dc}a.box:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2),0 0 0 1px #3273dc}.button{background-color:#fff;border-color:#dbdbdb;border-width:1px;color:#363636;cursor:pointer;justify-content:center;padding:calc(.375em - 1px) .75em;text-align:center;white-space:nowrap}.button strong{color:inherit}.button .icon,.button .icon.is-large,.button .icon.is-medium,.button .icon.is-small{height:1.5em;width:1.5em}.button .icon:first-child:not(:last-child){margin-left:calc(-.375em - 1px);margin-right:.1875em}.button .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:calc(-.375em - 1px)}.button .icon:first-child:last-child{margin-left:calc(-.375em - 1px);margin-right:calc(-.375em - 1px)}.button.is-hovered,.button:hover{border-color:#b5b5b5;color:#363636}.button.is-focused,.button:focus{border-color:#3273dc;color:#363636}.button.is-focused:not(:active),.button:focus:not(:active){box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.button.is-active,.button:active{border-color:#4a4a4a;color:#363636}.button.is-text{background-color:transparent;border-color:transparent;color:#4a4a4a;text-decoration:underline}.button.is-text.is-focused,.button.is-text.is-hovered,.button.is-text:focus,.button.is-text:hover{background-color:#f5f5f5;color:#363636}.button.is-text.is-active,.button.is-text:active{background-color:#e8e8e8;color:#363636}.button.is-text[disabled]{background-color:transparent;border-color:transparent;box-shadow:none}.button.is-white{background-color:#fff;border-color:transparent;color:#0a0a0a}.button.is-white.is-hovered,.button.is-white:hover{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.button.is-white.is-focused,.button.is-white:focus{border-color:transparent;color:#0a0a0a}.button.is-white.is-focused:not(:active),.button.is-white:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.button.is-white.is-active,.button.is-white:active{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.button.is-white[disabled]{background-color:#fff;border-color:transparent;box-shadow:none}.button.is-white.is-inverted{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted:hover{background-color:#000}.button.is-white.is-inverted[disabled]{background-color:#0a0a0a;border-color:transparent;box-shadow:none;color:#fff}.button.is-white.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-white.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-white.is-outlined:focus,.button.is-white.is-outlined:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.button.is-white.is-outlined.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-white.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-white.is-inverted.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-white.is-inverted.is-outlined:focus,.button.is-white.is-inverted.is-outlined:hover{background-color:#0a0a0a;color:#fff}.button.is-white.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.button.is-black{background-color:#0a0a0a;border-color:transparent;color:#fff}.button.is-black.is-hovered,.button.is-black:hover{background-color:#040404;border-color:transparent;color:#fff}.button.is-black.is-focused,.button.is-black:focus{border-color:transparent;color:#fff}.button.is-black.is-focused:not(:active),.button.is-black:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.button.is-black.is-active,.button.is-black:active{background-color:#000;border-color:transparent;color:#fff}.button.is-black[disabled]{background-color:#0a0a0a;border-color:transparent;box-shadow:none}.button.is-black.is-inverted{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted:hover{background-color:#f2f2f2}.button.is-black.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#0a0a0a}.button.is-black.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-black.is-outlined{background-color:transparent;border-color:#0a0a0a;color:#0a0a0a}.button.is-black.is-outlined:focus,.button.is-black.is-outlined:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.button.is-black.is-outlined.is-loading:after{border-color:transparent transparent #0a0a0a #0a0a0a!important}.button.is-black.is-outlined[disabled]{background-color:transparent;border-color:#0a0a0a;box-shadow:none;color:#0a0a0a}.button.is-black.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-black.is-inverted.is-outlined:focus,.button.is-black.is-inverted.is-outlined:hover{background-color:#fff;color:#0a0a0a}.button.is-black.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-light{background-color:#f5f5f5;border-color:transparent;color:#363636}.button.is-light.is-hovered,.button.is-light:hover{background-color:#eee;border-color:transparent;color:#363636}.button.is-light.is-focused,.button.is-light:focus{border-color:transparent;color:#363636}.button.is-light.is-focused:not(:active),.button.is-light:focus:not(:active){box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.button.is-light.is-active,.button.is-light:active{background-color:#e8e8e8;border-color:transparent;color:#363636}.button.is-light[disabled]{background-color:#f5f5f5;border-color:transparent;box-shadow:none}.button.is-light.is-inverted{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted:hover{background-color:#292929}.button.is-light.is-inverted[disabled]{background-color:#363636;border-color:transparent;box-shadow:none;color:#f5f5f5}.button.is-light.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-light.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-light.is-outlined:focus,.button.is-light.is-outlined:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.button.is-light.is-outlined.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-light.is-outlined[disabled]{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.button.is-light.is-inverted.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-light.is-inverted.is-outlined:focus,.button.is-light.is-inverted.is-outlined:hover{background-color:#363636;color:#f5f5f5}.button.is-light.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.button.is-dark{background-color:#363636;border-color:transparent;color:#f5f5f5}.button.is-dark.is-hovered,.button.is-dark:hover{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused,.button.is-dark:focus{border-color:transparent;color:#f5f5f5}.button.is-dark.is-focused:not(:active),.button.is-dark:focus:not(:active){box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.button.is-dark.is-active,.button.is-dark:active{background-color:#292929;border-color:transparent;color:#f5f5f5}.button.is-dark[disabled]{background-color:#363636;border-color:transparent;box-shadow:none}.button.is-dark.is-inverted{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted:hover{background-color:#e8e8e8}.button.is-dark.is-inverted[disabled]{background-color:#f5f5f5;border-color:transparent;box-shadow:none;color:#363636}.button.is-dark.is-loading:after{border-color:transparent transparent #f5f5f5 #f5f5f5!important}.button.is-dark.is-outlined{background-color:transparent;border-color:#363636;color:#363636}.button.is-dark.is-outlined:focus,.button.is-dark.is-outlined:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.button.is-dark.is-outlined.is-loading:after{border-color:transparent transparent #363636 #363636!important}.button.is-dark.is-outlined[disabled]{background-color:transparent;border-color:#363636;box-shadow:none;color:#363636}.button.is-dark.is-inverted.is-outlined{background-color:transparent;border-color:#f5f5f5;color:#f5f5f5}.button.is-dark.is-inverted.is-outlined:focus,.button.is-dark.is-inverted.is-outlined:hover{background-color:#f5f5f5;color:#363636}.button.is-dark.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#f5f5f5;box-shadow:none;color:#f5f5f5}.button.is-primary{background-color:#00d1b2;border-color:transparent;color:#fff}.button.is-primary.is-hovered,.button.is-primary:hover{background-color:#00c4a7;border-color:transparent;color:#fff}.button.is-primary.is-focused,.button.is-primary:focus{border-color:transparent;color:#fff}.button.is-primary.is-focused:not(:active),.button.is-primary:focus:not(:active){box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.button.is-primary.is-active,.button.is-primary:active{background-color:#00b89c;border-color:transparent;color:#fff}.button.is-primary[disabled]{background-color:#00d1b2;border-color:transparent;box-shadow:none}.button.is-primary.is-inverted{background-color:#fff;color:#00d1b2}.button.is-primary.is-inverted:hover{background-color:#f2f2f2}.button.is-primary.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#00d1b2}.button.is-primary.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-primary.is-outlined{background-color:transparent;border-color:#00d1b2;color:#00d1b2}.button.is-primary.is-outlined:focus,.button.is-primary.is-outlined:hover{background-color:#00d1b2;border-color:#00d1b2;color:#fff}.button.is-primary.is-outlined.is-loading:after{border-color:transparent transparent #00d1b2 #00d1b2!important}.button.is-primary.is-outlined[disabled]{background-color:transparent;border-color:#00d1b2;box-shadow:none;color:#00d1b2}.button.is-primary.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-primary.is-inverted.is-outlined:focus,.button.is-primary.is-inverted.is-outlined:hover{background-color:#fff;color:#00d1b2}.button.is-primary.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-link{background-color:#3273dc;border-color:transparent;color:#fff}.button.is-link.is-hovered,.button.is-link:hover{background-color:#276cda;border-color:transparent;color:#fff}.button.is-link.is-focused,.button.is-link:focus{border-color:transparent;color:#fff}.button.is-link.is-focused:not(:active),.button.is-link:focus:not(:active){box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.button.is-link.is-active,.button.is-link:active{background-color:#2366d1;border-color:transparent;color:#fff}.button.is-link[disabled]{background-color:#3273dc;border-color:transparent;box-shadow:none}.button.is-link.is-inverted{background-color:#fff;color:#3273dc}.button.is-link.is-inverted:hover{background-color:#f2f2f2}.button.is-link.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#3273dc}.button.is-link.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-link.is-outlined{background-color:transparent;border-color:#3273dc;color:#3273dc}.button.is-link.is-outlined:focus,.button.is-link.is-outlined:hover{background-color:#3273dc;border-color:#3273dc;color:#fff}.button.is-link.is-outlined.is-loading:after{border-color:transparent transparent #3273dc #3273dc!important}.button.is-link.is-outlined[disabled]{background-color:transparent;border-color:#3273dc;box-shadow:none;color:#3273dc}.button.is-link.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-link.is-inverted.is-outlined:focus,.button.is-link.is-inverted.is-outlined:hover{background-color:#fff;color:#3273dc}.button.is-link.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-info{background-color:#209cee;border-color:transparent;color:#fff}.button.is-info.is-hovered,.button.is-info:hover{background-color:#1496ed;border-color:transparent;color:#fff}.button.is-info.is-focused,.button.is-info:focus{border-color:transparent;color:#fff}.button.is-info.is-focused:not(:active),.button.is-info:focus:not(:active){box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.button.is-info.is-active,.button.is-info:active{background-color:#118fe4;border-color:transparent;color:#fff}.button.is-info[disabled]{background-color:#209cee;border-color:transparent;box-shadow:none}.button.is-info.is-inverted{background-color:#fff;color:#209cee}.button.is-info.is-inverted:hover{background-color:#f2f2f2}.button.is-info.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#209cee}.button.is-info.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-info.is-outlined{background-color:transparent;border-color:#209cee;color:#209cee}.button.is-info.is-outlined:focus,.button.is-info.is-outlined:hover{background-color:#209cee;border-color:#209cee;color:#fff}.button.is-info.is-outlined.is-loading:after{border-color:transparent transparent #209cee #209cee!important}.button.is-info.is-outlined[disabled]{background-color:transparent;border-color:#209cee;box-shadow:none;color:#209cee}.button.is-info.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-info.is-inverted.is-outlined:focus,.button.is-info.is-inverted.is-outlined:hover{background-color:#fff;color:#209cee}.button.is-info.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-success{background-color:#23d160;border-color:transparent;color:#fff}.button.is-success.is-hovered,.button.is-success:hover{background-color:#22c65b;border-color:transparent;color:#fff}.button.is-success.is-focused,.button.is-success:focus{border-color:transparent;color:#fff}.button.is-success.is-focused:not(:active),.button.is-success:focus:not(:active){box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.button.is-success.is-active,.button.is-success:active{background-color:#20bc56;border-color:transparent;color:#fff}.button.is-success[disabled]{background-color:#23d160;border-color:transparent;box-shadow:none}.button.is-success.is-inverted{background-color:#fff;color:#23d160}.button.is-success.is-inverted:hover{background-color:#f2f2f2}.button.is-success.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#23d160}.button.is-success.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-success.is-outlined{background-color:transparent;border-color:#23d160;color:#23d160}.button.is-success.is-outlined:focus,.button.is-success.is-outlined:hover{background-color:#23d160;border-color:#23d160;color:#fff}.button.is-success.is-outlined.is-loading:after{border-color:transparent transparent #23d160 #23d160!important}.button.is-success.is-outlined[disabled]{background-color:transparent;border-color:#23d160;box-shadow:none;color:#23d160}.button.is-success.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-success.is-inverted.is-outlined:focus,.button.is-success.is-inverted.is-outlined:hover{background-color:#fff;color:#23d160}.button.is-success.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-warning{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-hovered,.button.is-warning:hover{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused,.button.is-warning:focus{border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning.is-focused:not(:active),.button.is-warning:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.button.is-warning.is-active,.button.is-warning:active{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.button.is-warning[disabled]{background-color:#ffdd57;border-color:transparent;box-shadow:none}.button.is-warning.is-inverted{color:#ffdd57}.button.is-warning.is-inverted,.button.is-warning.is-inverted:hover{background-color:rgba(0,0,0,.7)}.button.is-warning.is-inverted[disabled]{background-color:rgba(0,0,0,.7);border-color:transparent;box-shadow:none;color:#ffdd57}.button.is-warning.is-loading:after{border-color:transparent transparent rgba(0,0,0,.7) rgba(0,0,0,.7)!important}.button.is-warning.is-outlined{background-color:transparent;border-color:#ffdd57;color:#ffdd57}.button.is-warning.is-outlined:focus,.button.is-warning.is-outlined:hover{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.button.is-warning.is-outlined.is-loading:after{border-color:transparent transparent #ffdd57 #ffdd57!important}.button.is-warning.is-outlined[disabled]{background-color:transparent;border-color:#ffdd57;box-shadow:none;color:#ffdd57}.button.is-warning.is-inverted.is-outlined{background-color:transparent;border-color:rgba(0,0,0,.7);color:rgba(0,0,0,.7)}.button.is-warning.is-inverted.is-outlined:focus,.button.is-warning.is-inverted.is-outlined:hover{background-color:rgba(0,0,0,.7);color:#ffdd57}.button.is-warning.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:rgba(0,0,0,.7);box-shadow:none;color:rgba(0,0,0,.7)}.button.is-danger{background-color:#ff3860;border-color:transparent;color:#fff}.button.is-danger.is-hovered,.button.is-danger:hover{background-color:#ff2b56;border-color:transparent;color:#fff}.button.is-danger.is-focused,.button.is-danger:focus{border-color:transparent;color:#fff}.button.is-danger.is-focused:not(:active),.button.is-danger:focus:not(:active){box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.button.is-danger.is-active,.button.is-danger:active{background-color:#ff1f4b;border-color:transparent;color:#fff}.button.is-danger[disabled]{background-color:#ff3860;border-color:transparent;box-shadow:none}.button.is-danger.is-inverted{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted:hover{background-color:#f2f2f2}.button.is-danger.is-inverted[disabled]{background-color:#fff;border-color:transparent;box-shadow:none;color:#ff3860}.button.is-danger.is-loading:after{border-color:transparent transparent #fff #fff!important}.button.is-danger.is-outlined{background-color:transparent;border-color:#ff3860;color:#ff3860}.button.is-danger.is-outlined:focus,.button.is-danger.is-outlined:hover{background-color:#ff3860;border-color:#ff3860;color:#fff}.button.is-danger.is-outlined.is-loading:after{border-color:transparent transparent #ff3860 #ff3860!important}.button.is-danger.is-outlined[disabled]{background-color:transparent;border-color:#ff3860;box-shadow:none;color:#ff3860}.button.is-danger.is-inverted.is-outlined{background-color:transparent;border-color:#fff;color:#fff}.button.is-danger.is-inverted.is-outlined:focus,.button.is-danger.is-inverted.is-outlined:hover{background-color:#fff;color:#ff3860}.button.is-danger.is-inverted.is-outlined[disabled]{background-color:transparent;border-color:#fff;box-shadow:none;color:#fff}.button.is-small{border-radius:2px;font-size:.75rem}.button.is-medium{font-size:1.25rem}.button.is-large{font-size:1.5rem}.button[disabled]{background-color:#fff;border-color:#dbdbdb;box-shadow:none;opacity:.5}.button.is-fullwidth{display:flex;width:100%}.button.is-loading{color:transparent!important;pointer-events:none}.button.is-loading:after{position:absolute;left:calc(50% - 0.5em);top:calc(50% - 0.5em);position:absolute!important}.button.is-static{background-color:#f5f5f5;border-color:#dbdbdb;color:#7a7a7a;box-shadow:none;pointer-events:none}.button.is-rounded{border-radius:290486px;padding-left:1em;padding-right:1em}.buttons{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.buttons .button{margin-bottom:.5rem}.buttons .button:not(:last-child){margin-right:.5rem}.buttons:last-child{margin-bottom:-.5rem}.buttons:not(:last-child){margin-bottom:1rem}.buttons.has-addons .button:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.buttons.has-addons .button:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;margin-right:-1px}.buttons.has-addons .button:last-child{margin-right:0}.buttons.has-addons .button.is-hovered,.buttons.has-addons .button:hover{z-index:2}.buttons.has-addons .button.is-active,.buttons.has-addons .button.is-focused,.buttons.has-addons .button.is-selected,.buttons.has-addons .button:active,.buttons.has-addons .button:focus{z-index:3}.buttons.has-addons .button.is-active:hover,.buttons.has-addons .button.is-focused:hover,.buttons.has-addons .button.is-selected:hover,.buttons.has-addons .button:active:hover,.buttons.has-addons .button:focus:hover{z-index:4}.buttons.has-addons .button.is-expanded{flex-grow:1}.buttons.is-centered{justify-content:center}.buttons.is-right{justify-content:flex-end}.container{margin:0 auto;position:relative}@media screen and (min-width:1088px){.container{max-width:960px;width:960px}.container.is-fluid{margin-left:64px;margin-right:64px;max-width:none;width:auto}}@media screen and (max-width:1279px){.container.is-widescreen{max-width:1152px;width:auto}}@media screen and (max-width:1471px){.container.is-fullhd{max-width:1344px;width:auto}}@media screen and (min-width:1280px){.container{max-width:1152px;width:1152px}}@media screen and (min-width:1472px){.container{max-width:1344px;width:1344px}}.content li+li{margin-top:.25em}.content blockquote:not(:last-child),.content dl:not(:last-child),.content ol:not(:last-child),.content p:not(:last-child),.content pre:not(:last-child),.content table:not(:last-child),.content ul:not(:last-child){margin-bottom:1em}.content h1,.content h2,.content h3,.content h4,.content h5,.content h6{color:#363636;font-weight:600;line-height:1.125}.content h1{font-size:2em;margin-bottom:.5em}.content h1:not(:first-child){margin-top:1em}.content h2{font-size:1.75em;margin-bottom:.5714em}.content h2:not(:first-child){margin-top:1.1428em}.content h3{font-size:1.5em;margin-bottom:.6666em}.content h3:not(:first-child){margin-top:1.3333em}.content h4{font-size:1.25em;margin-bottom:.8em}.content h5{font-size:1.125em;margin-bottom:.8888em}.content h6{font-size:1em;margin-bottom:1em}.content blockquote{background-color:#f5f5f5;border-left:5px solid #dbdbdb;padding:1.25em 1.5em}.content ol{list-style:decimal outside}.content ol,.content ul{margin-left:2em;margin-top:1em}.content ul{list-style:disc outside}.content ul ul{list-style-type:circle;margin-top:.5em}.content ul ul ul{list-style-type:square}.content dd{margin-left:2em}.content figure{margin-left:2em;margin-right:2em;text-align:center}.content figure:not(:first-child){margin-top:2em}.content figure:not(:last-child){margin-bottom:2em}.content figure img{display:inline-block}.content figure figcaption{font-style:italic}.content pre{-webkit-overflow-scrolling:touch;overflow-x:auto;padding:1.25em 1.5em;white-space:pre;word-wrap:normal}.content sub,.content sup{font-size:75%}.content table{width:100%}.content table td,.content table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.content table th{color:#363636;text-align:left}.content table thead td,.content table thead th{border-width:0 0 2px;color:#363636}.content table tfoot td,.content table tfoot th{border-width:2px 0 0;color:#363636}.content table tbody tr:last-child td,.content table tbody tr:last-child th{border-bottom-width:0}.content.is-small{font-size:.75rem}.content.is-medium{font-size:1.25rem}.content.is-large{font-size:1.5rem}.input,.textarea{background-color:#fff;border-color:#dbdbdb;color:#363636;box-shadow:inset 0 1px 2px hsla(0,0%,4%,.1);max-width:100%;width:100%}.input::-moz-placeholder,.textarea::-moz-placeholder{color:rgba(54,54,54,.3)}.input::-webkit-input-placeholder,.textarea::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.input:-moz-placeholder,.textarea:-moz-placeholder{color:rgba(54,54,54,.3)}.input:-ms-input-placeholder,.textarea:-ms-input-placeholder{color:rgba(54,54,54,.3)}.input.is-hovered,.input:hover,.textarea.is-hovered,.textarea:hover{border-color:#b5b5b5}.input.is-active,.input.is-focused,.input:active,.input:focus,.textarea.is-active,.textarea.is-focused,.textarea:active,.textarea:focus{border-color:#3273dc;box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.input[disabled],.textarea[disabled]{background-color:#f5f5f5;border-color:#f5f5f5;box-shadow:none;color:#7a7a7a}.input[disabled]::-moz-placeholder,.textarea[disabled]::-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]::-webkit-input-placeholder,.textarea[disabled]::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-moz-placeholder,.textarea[disabled]:-moz-placeholder{color:hsla(0,0%,48%,.3)}.input[disabled]:-ms-input-placeholder,.textarea[disabled]:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.input[readonly],.textarea[readonly]{box-shadow:none}.input.is-white,.textarea.is-white{border-color:#fff}.input.is-white.is-active,.input.is-white.is-focused,.input.is-white:active,.input.is-white:focus,.textarea.is-white.is-active,.textarea.is-white.is-focused,.textarea.is-white:active,.textarea.is-white:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.input.is-black,.textarea.is-black{border-color:#0a0a0a}.input.is-black.is-active,.input.is-black.is-focused,.input.is-black:active,.input.is-black:focus,.textarea.is-black.is-active,.textarea.is-black.is-focused,.textarea.is-black:active,.textarea.is-black:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.input.is-light,.textarea.is-light{border-color:#f5f5f5}.input.is-light.is-active,.input.is-light.is-focused,.input.is-light:active,.input.is-light:focus,.textarea.is-light.is-active,.textarea.is-light.is-focused,.textarea.is-light:active,.textarea.is-light:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.input.is-dark,.textarea.is-dark{border-color:#363636}.input.is-dark.is-active,.input.is-dark.is-focused,.input.is-dark:active,.input.is-dark:focus,.textarea.is-dark.is-active,.textarea.is-dark.is-focused,.textarea.is-dark:active,.textarea.is-dark:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.input.is-primary,.textarea.is-primary{border-color:#00d1b2}.input.is-primary.is-active,.input.is-primary.is-focused,.input.is-primary:active,.input.is-primary:focus,.textarea.is-primary.is-active,.textarea.is-primary.is-focused,.textarea.is-primary:active,.textarea.is-primary:focus{box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.input.is-link,.textarea.is-link{border-color:#3273dc}.input.is-link.is-active,.input.is-link.is-focused,.input.is-link:active,.input.is-link:focus,.textarea.is-link.is-active,.textarea.is-link.is-focused,.textarea.is-link:active,.textarea.is-link:focus{box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.input.is-info,.textarea.is-info{border-color:#209cee}.input.is-info.is-active,.input.is-info.is-focused,.input.is-info:active,.input.is-info:focus,.textarea.is-info.is-active,.textarea.is-info.is-focused,.textarea.is-info:active,.textarea.is-info:focus{box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.input.is-success,.textarea.is-success{border-color:#23d160}.input.is-success.is-active,.input.is-success.is-focused,.input.is-success:active,.input.is-success:focus,.textarea.is-success.is-active,.textarea.is-success.is-focused,.textarea.is-success:active,.textarea.is-success:focus{box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.input.is-warning,.textarea.is-warning{border-color:#ffdd57}.input.is-warning.is-active,.input.is-warning.is-focused,.input.is-warning:active,.input.is-warning:focus,.textarea.is-warning.is-active,.textarea.is-warning.is-focused,.textarea.is-warning:active,.textarea.is-warning:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.input.is-danger,.textarea.is-danger{border-color:#ff3860}.input.is-danger.is-active,.input.is-danger.is-focused,.input.is-danger:active,.input.is-danger:focus,.textarea.is-danger.is-active,.textarea.is-danger.is-focused,.textarea.is-danger:active,.textarea.is-danger:focus{box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.input.is-small,.textarea.is-small{border-radius:2px;font-size:.75rem}.input.is-medium,.textarea.is-medium{font-size:1.25rem}.input.is-large,.textarea.is-large{font-size:1.5rem}.input.is-fullwidth,.textarea.is-fullwidth{display:block;width:100%}.input.is-inline,.textarea.is-inline{display:inline;width:auto}.input.is-rounded{border-radius:290486px;padding-left:1em;padding-right:1em}.input.is-static{background-color:transparent;border-color:transparent;box-shadow:none;padding-left:0;padding-right:0}.textarea{display:block;max-width:100%;min-width:100%;padding:.625em;resize:vertical}.textarea:not([rows]){max-height:600px;min-height:120px}.textarea[rows]{height:auto}.textarea.has-fixed-size{resize:none}.checkbox,.radio{cursor:pointer;display:inline-block;line-height:1.25;position:relative}.checkbox input,.radio input{cursor:pointer}.checkbox:hover,.radio:hover{color:#363636}.checkbox[disabled],.radio[disabled]{color:#7a7a7a;cursor:not-allowed}.radio+.radio{margin-left:.5em}.select{display:inline-block;max-width:100%;position:relative;vertical-align:top}.select:not(.is-multiple){height:2.25em}.select:not(.is-multiple):not(.is-loading):after{border-color:#3273dc;right:1.125em;z-index:4}.select.is-rounded select{border-radius:290486px;padding-left:1em}.select select{background-color:#fff;border-color:#dbdbdb;color:#363636;cursor:pointer;display:block;font-size:1em;max-width:100%;outline:0}.select select::-moz-placeholder{color:rgba(54,54,54,.3)}.select select::-webkit-input-placeholder{color:rgba(54,54,54,.3)}.select select:-moz-placeholder{color:rgba(54,54,54,.3)}.select select:-ms-input-placeholder{color:rgba(54,54,54,.3)}.select select.is-hovered,.select select:hover{border-color:#b5b5b5}.select select.is-active,.select select.is-focused,.select select:active,.select select:focus{border-color:#3273dc;box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.select select[disabled]{background-color:#f5f5f5;border-color:#f5f5f5;box-shadow:none;color:#7a7a7a}.select select[disabled]::-moz-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]::-webkit-input-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]:-moz-placeholder{color:hsla(0,0%,48%,.3)}.select select[disabled]:-ms-input-placeholder{color:hsla(0,0%,48%,.3)}.select select::-ms-expand{display:none}.select select[disabled]:hover{border-color:#f5f5f5}.select select:not([multiple]){padding-right:2.5em}.select select[multiple]{height:auto;padding:0}.select select[multiple] option{padding:.5em 1em}.select:not(.is-multiple):not(.is-loading):hover:after{border-color:#363636}.select.is-white:not(:hover):after,.select.is-white select{border-color:#fff}.select.is-white select.is-hovered,.select.is-white select:hover{border-color:#f2f2f2}.select.is-white select.is-active,.select.is-white select.is-focused,.select.is-white select:active,.select.is-white select:focus{box-shadow:0 0 0 .125em hsla(0,0%,100%,.25)}.select.is-black:not(:hover):after,.select.is-black select{border-color:#0a0a0a}.select.is-black select.is-hovered,.select.is-black select:hover{border-color:#000}.select.is-black select.is-active,.select.is-black select.is-focused,.select.is-black select:active,.select.is-black select:focus{box-shadow:0 0 0 .125em hsla(0,0%,4%,.25)}.select.is-light:not(:hover):after,.select.is-light select{border-color:#f5f5f5}.select.is-light select.is-hovered,.select.is-light select:hover{border-color:#e8e8e8}.select.is-light select.is-active,.select.is-light select.is-focused,.select.is-light select:active,.select.is-light select:focus{box-shadow:0 0 0 .125em hsla(0,0%,96%,.25)}.select.is-dark:not(:hover):after,.select.is-dark select{border-color:#363636}.select.is-dark select.is-hovered,.select.is-dark select:hover{border-color:#292929}.select.is-dark select.is-active,.select.is-dark select.is-focused,.select.is-dark select:active,.select.is-dark select:focus{box-shadow:0 0 0 .125em rgba(54,54,54,.25)}.select.is-primary:not(:hover):after,.select.is-primary select{border-color:#00d1b2}.select.is-primary select.is-hovered,.select.is-primary select:hover{border-color:#00b89c}.select.is-primary select.is-active,.select.is-primary select.is-focused,.select.is-primary select:active,.select.is-primary select:focus{box-shadow:0 0 0 .125em rgba(0,209,178,.25)}.select.is-link:not(:hover):after,.select.is-link select{border-color:#3273dc}.select.is-link select.is-hovered,.select.is-link select:hover{border-color:#2366d1}.select.is-link select.is-active,.select.is-link select.is-focused,.select.is-link select:active,.select.is-link select:focus{box-shadow:0 0 0 .125em rgba(50,115,220,.25)}.select.is-info:not(:hover):after,.select.is-info select{border-color:#209cee}.select.is-info select.is-hovered,.select.is-info select:hover{border-color:#118fe4}.select.is-info select.is-active,.select.is-info select.is-focused,.select.is-info select:active,.select.is-info select:focus{box-shadow:0 0 0 .125em rgba(32,156,238,.25)}.select.is-success:not(:hover):after,.select.is-success select{border-color:#23d160}.select.is-success select.is-hovered,.select.is-success select:hover{border-color:#20bc56}.select.is-success select.is-active,.select.is-success select.is-focused,.select.is-success select:active,.select.is-success select:focus{box-shadow:0 0 0 .125em rgba(35,209,96,.25)}.select.is-warning:not(:hover):after,.select.is-warning select{border-color:#ffdd57}.select.is-warning select.is-hovered,.select.is-warning select:hover{border-color:#ffd83d}.select.is-warning select.is-active,.select.is-warning select.is-focused,.select.is-warning select:active,.select.is-warning select:focus{box-shadow:0 0 0 .125em rgba(255,221,87,.25)}.select.is-danger:not(:hover):after,.select.is-danger select{border-color:#ff3860}.select.is-danger select.is-hovered,.select.is-danger select:hover{border-color:#ff1f4b}.select.is-danger select.is-active,.select.is-danger select.is-focused,.select.is-danger select:active,.select.is-danger select:focus{box-shadow:0 0 0 .125em rgba(255,56,96,.25)}.select.is-small{border-radius:2px;font-size:.75rem}.select.is-medium{font-size:1.25rem}.select.is-large{font-size:1.5rem}.select.is-disabled:after{border-color:#7a7a7a}.select.is-fullwidth,.select.is-fullwidth select{width:100%}.select.is-loading:after{margin-top:0;position:absolute;right:.625em;top:.625em;-webkit-transform:none;transform:none}.select.is-loading.is-small:after{font-size:.75rem}.select.is-loading.is-medium:after{font-size:1.25rem}.select.is-loading.is-large:after{font-size:1.5rem}.file{align-items:stretch;display:flex;justify-content:flex-start;position:relative}.file.is-white .file-cta{background-color:#fff;border-color:transparent;color:#0a0a0a}.file.is-white.is-hovered .file-cta,.file.is-white:hover .file-cta{background-color:#f9f9f9;border-color:transparent;color:#0a0a0a}.file.is-white.is-focused .file-cta,.file.is-white:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,100%,.25);color:#0a0a0a}.file.is-white.is-active .file-cta,.file.is-white:active .file-cta{background-color:#f2f2f2;border-color:transparent;color:#0a0a0a}.file.is-black .file-cta{background-color:#0a0a0a;border-color:transparent;color:#fff}.file.is-black.is-hovered .file-cta,.file.is-black:hover .file-cta{background-color:#040404;border-color:transparent;color:#fff}.file.is-black.is-focused .file-cta,.file.is-black:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,4%,.25);color:#fff}.file.is-black.is-active .file-cta,.file.is-black:active .file-cta{background-color:#000;border-color:transparent;color:#fff}.file.is-light .file-cta{background-color:#f5f5f5;border-color:transparent;color:#363636}.file.is-light.is-hovered .file-cta,.file.is-light:hover .file-cta{background-color:#eee;border-color:transparent;color:#363636}.file.is-light.is-focused .file-cta,.file.is-light:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em hsla(0,0%,96%,.25);color:#363636}.file.is-light.is-active .file-cta,.file.is-light:active .file-cta{background-color:#e8e8e8;border-color:transparent;color:#363636}.file.is-dark .file-cta{background-color:#363636;border-color:transparent;color:#f5f5f5}.file.is-dark.is-hovered .file-cta,.file.is-dark:hover .file-cta{background-color:#2f2f2f;border-color:transparent;color:#f5f5f5}.file.is-dark.is-focused .file-cta,.file.is-dark:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(54,54,54,.25);color:#f5f5f5}.file.is-dark.is-active .file-cta,.file.is-dark:active .file-cta{background-color:#292929;border-color:transparent;color:#f5f5f5}.file.is-primary .file-cta{background-color:#00d1b2;border-color:transparent;color:#fff}.file.is-primary.is-hovered .file-cta,.file.is-primary:hover .file-cta{background-color:#00c4a7;border-color:transparent;color:#fff}.file.is-primary.is-focused .file-cta,.file.is-primary:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(0,209,178,.25);color:#fff}.file.is-primary.is-active .file-cta,.file.is-primary:active .file-cta{background-color:#00b89c;border-color:transparent;color:#fff}.file.is-link .file-cta{background-color:#3273dc;border-color:transparent;color:#fff}.file.is-link.is-hovered .file-cta,.file.is-link:hover .file-cta{background-color:#276cda;border-color:transparent;color:#fff}.file.is-link.is-focused .file-cta,.file.is-link:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(50,115,220,.25);color:#fff}.file.is-link.is-active .file-cta,.file.is-link:active .file-cta{background-color:#2366d1;border-color:transparent;color:#fff}.file.is-info .file-cta{background-color:#209cee;border-color:transparent;color:#fff}.file.is-info.is-hovered .file-cta,.file.is-info:hover .file-cta{background-color:#1496ed;border-color:transparent;color:#fff}.file.is-info.is-focused .file-cta,.file.is-info:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(32,156,238,.25);color:#fff}.file.is-info.is-active .file-cta,.file.is-info:active .file-cta{background-color:#118fe4;border-color:transparent;color:#fff}.file.is-success .file-cta{background-color:#23d160;border-color:transparent;color:#fff}.file.is-success.is-hovered .file-cta,.file.is-success:hover .file-cta{background-color:#22c65b;border-color:transparent;color:#fff}.file.is-success.is-focused .file-cta,.file.is-success:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(35,209,96,.25);color:#fff}.file.is-success.is-active .file-cta,.file.is-success:active .file-cta{background-color:#20bc56;border-color:transparent;color:#fff}.file.is-warning .file-cta{background-color:#ffdd57;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-hovered .file-cta,.file.is-warning:hover .file-cta{background-color:#ffdb4a;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-warning.is-focused .file-cta,.file.is-warning:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,221,87,.25);color:rgba(0,0,0,.7)}.file.is-warning.is-active .file-cta,.file.is-warning:active .file-cta{background-color:#ffd83d;border-color:transparent;color:rgba(0,0,0,.7)}.file.is-danger .file-cta{background-color:#ff3860;border-color:transparent;color:#fff}.file.is-danger.is-hovered .file-cta,.file.is-danger:hover .file-cta{background-color:#ff2b56;border-color:transparent;color:#fff}.file.is-danger.is-focused .file-cta,.file.is-danger:focus .file-cta{border-color:transparent;box-shadow:0 0 .5em rgba(255,56,96,.25);color:#fff}.file.is-danger.is-active .file-cta,.file.is-danger:active .file-cta{background-color:#ff1f4b;border-color:transparent;color:#fff}.file.is-small{font-size:.75rem}.file.is-medium{font-size:1.25rem}.file.is-medium .file-icon .fa{font-size:21px}.file.is-large{font-size:1.5rem}.file.is-large .file-icon .fa{font-size:28px}.file.has-name .file-cta{border-bottom-right-radius:0;border-top-right-radius:0}.file.has-name .file-name{border-bottom-left-radius:0;border-top-left-radius:0}.file.has-name.is-empty .file-cta{border-radius:4px}.file.has-name.is-empty .file-name{display:none}.file.is-boxed .file-label{flex-direction:column}.file.is-boxed .file-cta{flex-direction:column;height:auto;padding:1em 3em}.file.is-boxed .file-name{border-width:0 1px 1px}.file.is-boxed .file-icon{height:1.5em;width:1.5em}.file.is-boxed .file-icon .fa{font-size:21px}.file.is-boxed.is-small .file-icon .fa{font-size:14px}.file.is-boxed.is-medium .file-icon .fa{font-size:28px}.file.is-boxed.is-large .file-icon .fa{font-size:35px}.file.is-boxed.has-name .file-cta{border-radius:4px 4px 0 0}.file.is-boxed.has-name .file-name{border-radius:0 0 4px 4px;border-width:0 1px 1px}.file.is-centered{justify-content:center}.file.is-fullwidth .file-label{width:100%}.file.is-fullwidth .file-name{flex-grow:1;max-width:none}.file.is-right{justify-content:flex-end}.file.is-right .file-cta{border-radius:0 4px 4px 0}.file.is-right .file-name{border-radius:4px 0 0 4px;border-width:1px 0 1px 1px;order:-1}.file-label{align-items:stretch;display:flex;cursor:pointer;justify-content:flex-start;overflow:hidden;position:relative}.file-label:hover .file-cta{background-color:#eee;color:#363636}.file-label:hover .file-name{border-color:#d5d5d5}.file-label:active .file-cta{background-color:#e8e8e8;color:#363636}.file-label:active .file-name{border-color:#cfcfcf}.file-input{height:.01em;left:0;outline:0;position:absolute;top:0;width:.01em}.file-cta,.file-name{border-color:#dbdbdb;border-radius:4px;font-size:1em;padding-left:1em;padding-right:1em;white-space:nowrap}.file-cta{background-color:#f5f5f5;color:#4a4a4a}.file-name{border-color:#dbdbdb;border-style:solid;border-width:1px 1px 1px 0;display:block;max-width:16em;overflow:hidden;text-align:left;text-overflow:ellipsis}.file-icon{align-items:center;display:flex;height:1em;justify-content:center;margin-right:.5em;width:1em}.file-icon .fa{font-size:14px}.label{color:#363636;display:block;font-size:1rem;font-weight:700}.label:not(:last-child){margin-bottom:.5em}.label.is-small{font-size:.75rem}.label.is-medium{font-size:1.25rem}.label.is-large{font-size:1.5rem}.help{display:block;font-size:.75rem;margin-top:.25rem}.help.is-white{color:#fff}.help.is-black{color:#0a0a0a}.help.is-light{color:#f5f5f5}.help.is-dark{color:#363636}.help.is-primary{color:#00d1b2}.help.is-link{color:#3273dc}.help.is-info{color:#209cee}.help.is-success{color:#23d160}.help.is-warning{color:#ffdd57}.help.is-danger{color:#ff3860}.field:not(:last-child){margin-bottom:.75rem}.field.has-addons{display:flex;justify-content:flex-start}.field.has-addons .control:not(:last-child){margin-right:-1px}.field.has-addons .control:not(:first-child):not(:last-child) .button,.field.has-addons .control:not(:first-child):not(:last-child) .input,.field.has-addons .control:not(:first-child):not(:last-child) .select select{border-radius:0}.field.has-addons .control:first-child .button,.field.has-addons .control:first-child .input,.field.has-addons .control:first-child .select select{border-bottom-right-radius:0;border-top-right-radius:0}.field.has-addons .control:last-child .button,.field.has-addons .control:last-child .input,.field.has-addons .control:last-child .select select{border-bottom-left-radius:0;border-top-left-radius:0}.field.has-addons .control .button.is-hovered,.field.has-addons .control .button:hover,.field.has-addons .control .input.is-hovered,.field.has-addons .control .input:hover,.field.has-addons .control .select select.is-hovered,.field.has-addons .control .select select:hover{z-index:2}.field.has-addons .control .button.is-active,.field.has-addons .control .button.is-focused,.field.has-addons .control .button:active,.field.has-addons .control .button:focus,.field.has-addons .control .input.is-active,.field.has-addons .control .input.is-focused,.field.has-addons .control .input:active,.field.has-addons .control .input:focus,.field.has-addons .control .select select.is-active,.field.has-addons .control .select select.is-focused,.field.has-addons .control .select select:active,.field.has-addons .control .select select:focus{z-index:3}.field.has-addons .control .button.is-active:hover,.field.has-addons .control .button.is-focused:hover,.field.has-addons .control .button:active:hover,.field.has-addons .control .button:focus:hover,.field.has-addons .control .input.is-active:hover,.field.has-addons .control .input.is-focused:hover,.field.has-addons .control .input:active:hover,.field.has-addons .control .input:focus:hover,.field.has-addons .control .select select.is-active:hover,.field.has-addons .control .select select.is-focused:hover,.field.has-addons .control .select select:active:hover,.field.has-addons .control .select select:focus:hover{z-index:4}.field.has-addons .control.is-expanded{flex-grow:1}.field.has-addons.has-addons-centered{justify-content:center}.field.has-addons.has-addons-right{justify-content:flex-end}.field.has-addons.has-addons-fullwidth .control{flex-grow:1;flex-shrink:0}.field.is-grouped{display:flex;justify-content:flex-start}.field.is-grouped>.control{flex-shrink:0}.field.is-grouped>.control:not(:last-child){margin-bottom:0;margin-right:.75rem}.field.is-grouped>.control.is-expanded{flex-grow:1;flex-shrink:1}.field.is-grouped.is-grouped-centered{justify-content:center}.field.is-grouped.is-grouped-right{justify-content:flex-end}.field.is-grouped.is-grouped-multiline{flex-wrap:wrap}.field.is-grouped.is-grouped-multiline>.control:last-child,.field.is-grouped.is-grouped-multiline>.control:not(:last-child){margin-bottom:.75rem}.field.is-grouped.is-grouped-multiline:last-child{margin-bottom:-.75rem}.field.is-grouped.is-grouped-multiline:not(:last-child){margin-bottom:0}@media print,screen and (min-width:769px){.field.is-horizontal{display:flex}}.field-label .label{font-size:inherit}@media screen and (max-width:768px){.field-label{margin-bottom:.5rem}}@media print,screen and (min-width:769px){.field-label{flex-basis:0;flex-grow:1;flex-shrink:0;margin-right:1.5rem;text-align:right}.field-label.is-small{font-size:.75rem;padding-top:.375em}.field-label.is-normal{padding-top:.375em}.field-label.is-medium{font-size:1.25rem;padding-top:.375em}.field-label.is-large{font-size:1.5rem;padding-top:.375em}}.field-body .field .field{margin-bottom:0}@media print,screen and (min-width:769px){.field-body{display:flex;flex-basis:0;flex-grow:5;flex-shrink:1}.field-body .field{margin-bottom:0}.field-body>.field{flex-shrink:1}.field-body>.field:not(.is-narrow){flex-grow:1}.field-body>.field:not(:last-child){margin-right:.75rem}}.control{font-size:1rem;position:relative;text-align:left}.control.has-icon .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icon .input:focus+.icon{color:#7a7a7a}.control.has-icon .input.is-small+.icon{font-size:.75rem}.control.has-icon .input.is-medium+.icon{font-size:1.25rem}.control.has-icon .input.is-large+.icon{font-size:1.5rem}.control.has-icon:not(.has-icon-right) .icon{left:0}.control.has-icon:not(.has-icon-right) .input{padding-left:2.25em}.control.has-icon.has-icon-right .icon{right:0}.control.has-icon.has-icon-right .input{padding-right:2.25em}.control.has-icons-left .input:focus~.icon,.control.has-icons-left .select:focus~.icon,.control.has-icons-right .input:focus~.icon,.control.has-icons-right .select:focus~.icon{color:#7a7a7a}.control.has-icons-left .input.is-small~.icon,.control.has-icons-left .select.is-small~.icon,.control.has-icons-right .input.is-small~.icon,.control.has-icons-right .select.is-small~.icon{font-size:.75rem}.control.has-icons-left .input.is-medium~.icon,.control.has-icons-left .select.is-medium~.icon,.control.has-icons-right .input.is-medium~.icon,.control.has-icons-right .select.is-medium~.icon{font-size:1.25rem}.control.has-icons-left .input.is-large~.icon,.control.has-icons-left .select.is-large~.icon,.control.has-icons-right .input.is-large~.icon,.control.has-icons-right .select.is-large~.icon{font-size:1.5rem}.control.has-icons-left .icon,.control.has-icons-right .icon{color:#dbdbdb;height:2.25em;pointer-events:none;position:absolute;top:0;width:2.25em;z-index:4}.control.has-icons-left .input,.control.has-icons-left .select select{padding-left:2.25em}.control.has-icons-left .icon.is-left{left:0}.control.has-icons-right .input,.control.has-icons-right .select select{padding-right:2.25em}.control.has-icons-right .icon.is-right{right:0}.control.is-loading:after{position:absolute!important;right:.625em;top:.625em;z-index:4}.control.is-loading.is-small:after{font-size:.75rem}.control.is-loading.is-medium:after{font-size:1.25rem}.control.is-loading.is-large:after{font-size:1.5rem}.icon{align-items:center;display:inline-flex;justify-content:center;height:1.5rem;width:1.5rem}.icon.is-small{height:1rem;width:1rem}.icon.is-medium{height:2rem;width:2rem}.icon.is-large{height:3rem;width:3rem}.image{display:block;position:relative}.image img{display:block;height:auto;width:100%}.image img.is-rounded{border-radius:290486px}.image.is-1by1 img,.image.is-1by2 img,.image.is-1by3 img,.image.is-2by1 img,.image.is-2by3 img,.image.is-3by1 img,.image.is-3by2 img,.image.is-3by4 img,.image.is-3by5 img,.image.is-4by3 img,.image.is-4by5 img,.image.is-5by3 img,.image.is-5by4 img,.image.is-9by16 img,.image.is-16by9 img,.image.is-square img{height:100%;width:100%}.image.is-1by1,.image.is-square{padding-top:100%}.image.is-5by4{padding-top:80%}.image.is-4by3{padding-top:75%}.image.is-3by2{padding-top:66.6666%}.image.is-5by3{padding-top:60%}.image.is-16by9{padding-top:56.25%}.image.is-2by1{padding-top:50%}.image.is-3by1{padding-top:33.3333%}.image.is-4by5{padding-top:125%}.image.is-3by4{padding-top:133.3333%}.image.is-2by3{padding-top:150%}.image.is-3by5{padding-top:166.6666%}.image.is-9by16{padding-top:177.7777%}.image.is-1by2{padding-top:200%}.image.is-1by3{padding-top:300%}.image.is-16x16{height:16px;width:16px}.image.is-24x24{height:24px;width:24px}.image.is-32x32{height:32px;width:32px}.image.is-48x48{height:48px;width:48px}.image.is-64x64{height:64px;width:64px}.image.is-96x96{height:96px;width:96px}.image.is-128x128{height:128px;width:128px}.notification{background-color:#f5f5f5;border-radius:4px;padding:1.25rem 2.5rem 1.25rem 1.5rem;position:relative}.notification a:not(.button){color:currentColor;text-decoration:underline}.notification strong{color:currentColor}.notification code,.notification pre{background:#fff}.notification pre code{background:0 0}.notification>.delete{position:absolute;right:.5rem;top:.5rem}.notification .content,.notification .subtitle,.notification .title{color:currentColor}.notification.is-white{background-color:#fff;color:#0a0a0a}.notification.is-black{background-color:#0a0a0a;color:#fff}.notification.is-light{background-color:#f5f5f5;color:#363636}.notification.is-dark{background-color:#363636;color:#f5f5f5}.notification.is-primary{background-color:#00d1b2;color:#fff}.notification.is-link{background-color:#3273dc;color:#fff}.notification.is-info{background-color:#209cee;color:#fff}.notification.is-success{background-color:#23d160;color:#fff}.notification.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.notification.is-danger{background-color:#ff3860;color:#fff}.progress{-moz-appearance:none;-webkit-appearance:none;border:none;border-radius:290486px;display:block;height:1rem;overflow:hidden;padding:0;width:100%}.progress::-webkit-progress-bar{background-color:#dbdbdb}.progress::-webkit-progress-value{background-color:#4a4a4a}.progress::-moz-progress-bar{background-color:#4a4a4a}.progress::-ms-fill{background-color:#4a4a4a;border:none}.progress.is-white::-webkit-progress-value{background-color:#fff}.progress.is-white::-moz-progress-bar{background-color:#fff}.progress.is-white::-ms-fill{background-color:#fff}.progress.is-black::-webkit-progress-value{background-color:#0a0a0a}.progress.is-black::-moz-progress-bar{background-color:#0a0a0a}.progress.is-black::-ms-fill{background-color:#0a0a0a}.progress.is-light::-webkit-progress-value{background-color:#f5f5f5}.progress.is-light::-moz-progress-bar{background-color:#f5f5f5}.progress.is-light::-ms-fill{background-color:#f5f5f5}.progress.is-dark::-webkit-progress-value{background-color:#363636}.progress.is-dark::-moz-progress-bar{background-color:#363636}.progress.is-dark::-ms-fill{background-color:#363636}.progress.is-primary::-webkit-progress-value{background-color:#00d1b2}.progress.is-primary::-moz-progress-bar{background-color:#00d1b2}.progress.is-primary::-ms-fill{background-color:#00d1b2}.progress.is-link::-webkit-progress-value{background-color:#3273dc}.progress.is-link::-moz-progress-bar{background-color:#3273dc}.progress.is-link::-ms-fill{background-color:#3273dc}.progress.is-info::-webkit-progress-value{background-color:#209cee}.progress.is-info::-moz-progress-bar{background-color:#209cee}.progress.is-info::-ms-fill{background-color:#209cee}.progress.is-success::-webkit-progress-value{background-color:#23d160}.progress.is-success::-moz-progress-bar{background-color:#23d160}.progress.is-success::-ms-fill{background-color:#23d160}.progress.is-warning::-webkit-progress-value{background-color:#ffdd57}.progress.is-warning::-moz-progress-bar{background-color:#ffdd57}.progress.is-warning::-ms-fill{background-color:#ffdd57}.progress.is-danger::-webkit-progress-value{background-color:#ff3860}.progress.is-danger::-moz-progress-bar{background-color:#ff3860}.progress.is-danger::-ms-fill{background-color:#ff3860}.progress.is-small{height:.75rem}.progress.is-medium{height:1.25rem}.progress.is-large{height:1.5rem}.table{background-color:#fff;color:#363636}.table td,.table th{border:1px solid #dbdbdb;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.table td.is-white,.table th.is-white{background-color:#fff;border-color:#fff;color:#0a0a0a}.table td.is-black,.table th.is-black{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.table td.is-light,.table th.is-light{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.table td.is-dark,.table th.is-dark{background-color:#363636;border-color:#363636;color:#f5f5f5}.table td.is-primary,.table th.is-primary{background-color:#00d1b2;border-color:#00d1b2;color:#fff}.table td.is-link,.table th.is-link{background-color:#3273dc;border-color:#3273dc;color:#fff}.table td.is-info,.table th.is-info{background-color:#209cee;border-color:#209cee;color:#fff}.table td.is-success,.table th.is-success{background-color:#23d160;border-color:#23d160;color:#fff}.table td.is-warning,.table th.is-warning{background-color:#ffdd57;border-color:#ffdd57;color:rgba(0,0,0,.7)}.table td.is-danger,.table th.is-danger{background-color:#ff3860;border-color:#ff3860;color:#fff}.table td.is-narrow,.table th.is-narrow{white-space:nowrap;width:1%}.table td.is-selected,.table th.is-selected{background-color:#00d1b2;color:#fff}.table td.is-selected a,.table td.is-selected strong,.table th.is-selected a,.table th.is-selected strong{color:currentColor}.table th{color:#363636;text-align:left}.table tr.is-selected{background-color:#00d1b2;color:#fff}.table tr.is-selected a,.table tr.is-selected strong{color:currentColor}.table tr.is-selected td,.table tr.is-selected th{border-color:#fff;color:currentColor}.table thead td,.table thead th{border-width:0 0 2px;color:#363636}.table tfoot td,.table tfoot th{border-width:2px 0 0;color:#363636}.table tbody tr:last-child td,.table tbody tr:last-child th{border-bottom-width:0}.table.is-bordered td,.table.is-bordered th{border-width:1px}.table.is-bordered tr:last-child td,.table.is-bordered tr:last-child th{border-bottom-width:1px}.table.is-fullwidth{width:100%}.table.is-hoverable tbody tr:not(.is-selected):hover{background-color:#fafafa}.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover{background-color:#f5f5f5}.table.is-narrow td,.table.is-narrow th{padding:.25em .5em}.table.is-striped tbody tr:not(.is-selected):nth-child(2n){background-color:#fafafa}.table-container{-webkit-overflow-scrolling:touch;overflow:auto;overflow-y:hidden;max-width:100%}.tags{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start}.tags .tag{margin-bottom:.5rem}.tags .tag:not(:last-child){margin-right:.5rem}.tags:last-child{margin-bottom:-.5rem}.tags:not(:last-child){margin-bottom:1rem}.tags.has-addons .tag{margin-right:0}.tags.has-addons .tag:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.tags.has-addons .tag:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.tags.is-centered{justify-content:center}.tags.is-centered .tag{margin-right:.25rem;margin-left:.25rem}.tags.is-right{justify-content:flex-end}.tags.is-right .tag:not(:first-child){margin-left:.5rem}.tags.is-right .tag:not(:last-child){margin-right:0}.tag:not(body){align-items:center;background-color:#f5f5f5;border-radius:4px;color:#4a4a4a;display:inline-flex;font-size:.75rem;height:2em;justify-content:center;line-height:1.5;padding-left:.75em;padding-right:.75em;white-space:nowrap}.tag:not(body) .delete{margin-left:.25rem;margin-right:-.375rem}.tag:not(body).is-white{background-color:#fff;color:#0a0a0a}.tag:not(body).is-black{background-color:#0a0a0a;color:#fff}.tag:not(body).is-light{background-color:#f5f5f5;color:#363636}.tag:not(body).is-dark{background-color:#363636;color:#f5f5f5}.tag:not(body).is-primary{background-color:#00d1b2;color:#fff}.tag:not(body).is-link{background-color:#3273dc;color:#fff}.tag:not(body).is-info{background-color:#209cee;color:#fff}.tag:not(body).is-success{background-color:#23d160;color:#fff}.tag:not(body).is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.tag:not(body).is-danger{background-color:#ff3860;color:#fff}.tag:not(body).is-medium{font-size:1rem}.tag:not(body).is-large{font-size:1.25rem}.tag:not(body) .icon:first-child:not(:last-child){margin-left:-.375em;margin-right:.1875em}.tag:not(body) .icon:last-child:not(:first-child){margin-left:.1875em;margin-right:-.375em}.tag:not(body) .icon:first-child:last-child{margin-left:-.375em;margin-right:-.375em}.tag:not(body).is-delete{margin-left:1px;padding:0;position:relative;width:2em}.tag:not(body).is-delete:after,.tag:not(body).is-delete:before{background-color:currentColor;content:\"\";display:block;left:50%;position:absolute;top:50%;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);-webkit-transform-origin:center center;transform-origin:center center}.tag:not(body).is-delete:before{height:1px;width:50%}.tag:not(body).is-delete:after{height:50%;width:1px}.tag:not(body).is-delete:focus,.tag:not(body).is-delete:hover{background-color:#e8e8e8}.tag:not(body).is-delete:active{background-color:#dbdbdb}.tag:not(body).is-rounded{border-radius:290486px}a.tag:hover{text-decoration:underline}.subtitle,.title{word-break:break-word}.subtitle em,.subtitle span,.title em,.title span{font-weight:inherit}.subtitle sub,.subtitle sup,.title sub,.title sup{font-size:.75em}.subtitle .tag,.title .tag{vertical-align:middle}.title{color:#363636;font-size:2rem;font-weight:600;line-height:1.125}.title strong{color:inherit;font-weight:inherit}.title+.highlight{margin-top:-.75rem}.title:not(.is-spaced)+.subtitle{margin-top:-1.25rem}.title.is-1{font-size:3rem}.title.is-2{font-size:2.5rem}.title.is-3{font-size:2rem}.title.is-4{font-size:1.5rem}.title.is-5{font-size:1.25rem}.title.is-6{font-size:1rem}.title.is-7{font-size:.75rem}.subtitle{color:#4a4a4a;font-size:1.25rem;font-weight:400;line-height:1.25}.subtitle strong{color:#363636;font-weight:600}.subtitle:not(.is-spaced)+.title{margin-top:-1.25rem}.subtitle.is-1{font-size:3rem}.subtitle.is-2{font-size:2.5rem}.subtitle.is-3{font-size:2rem}.subtitle.is-4{font-size:1.5rem}.subtitle.is-5{font-size:1.25rem}.subtitle.is-6{font-size:1rem}.subtitle.is-7{font-size:.75rem}.heading{display:block;font-size:11px;letter-spacing:1px;margin-bottom:5px;text-transform:uppercase}.highlight{font-weight:400;max-width:100%;overflow:hidden;padding:0}.highlight pre{overflow:auto;max-width:100%}.number{align-items:center;background-color:#f5f5f5;border-radius:290486px;display:inline-flex;font-size:1.25rem;height:2em;justify-content:center;margin-right:1.5rem;min-width:2.5em;padding:.25rem .5rem;text-align:center;vertical-align:top}.breadcrumb{font-size:1rem;white-space:nowrap}.breadcrumb a{align-items:center;color:#3273dc;display:flex;justify-content:center;padding:0 .75em}.breadcrumb a:hover{color:#363636}.breadcrumb li{align-items:center;display:flex}.breadcrumb li:first-child a{padding-left:0}.breadcrumb li.is-active a{color:#363636;cursor:default;pointer-events:none}.breadcrumb li+li:before{color:#b5b5b5;content:\"/\"}.breadcrumb ol,.breadcrumb ul{align-items:flex-start;display:flex;flex-wrap:wrap;justify-content:flex-start}.breadcrumb .icon:first-child{margin-right:.5em}.breadcrumb .icon:last-child{margin-left:.5em}.breadcrumb.is-centered ol,.breadcrumb.is-centered ul{justify-content:center}.breadcrumb.is-right ol,.breadcrumb.is-right ul{justify-content:flex-end}.breadcrumb.is-small{font-size:.75rem}.breadcrumb.is-medium{font-size:1.25rem}.breadcrumb.is-large{font-size:1.5rem}.breadcrumb.has-arrow-separator li+li:before{content:\"\\2192\"}.breadcrumb.has-bullet-separator li+li:before{content:\"\\2022\"}.breadcrumb.has-dot-separator li+li:before{content:\"\\B7\"}.breadcrumb.has-succeeds-separator li+li:before{content:\"\\227B\"}.card{background-color:#fff;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);color:#4a4a4a;max-width:100%;position:relative}.card-header{background-color:none;align-items:stretch;box-shadow:0 1px 2px hsla(0,0%,4%,.1);display:flex}.card-header-title{align-items:center;color:#363636;display:flex;flex-grow:1;font-weight:700;padding:.75rem}.card-header-icon,.card-header-title.is-centered{justify-content:center}.card-header-icon{align-items:center;cursor:pointer;display:flex;padding:.75rem}.card-image{display:block;position:relative}.card-content{background-color:none;padding:1.5rem}.card-footer{background-color:none;border-top:1px solid #dbdbdb;align-items:stretch;display:flex}.card-footer-item{align-items:center;display:flex;flex-basis:0;flex-grow:1;flex-shrink:0;justify-content:center;padding:.75rem}.card-footer-item:not(:last-child){border-right:1px solid #dbdbdb}.card .media:not(:last-child){margin-bottom:.75rem}.dropdown{display:inline-flex;position:relative;vertical-align:top}.dropdown.is-active .dropdown-menu,.dropdown.is-hoverable:hover .dropdown-menu{display:block}.dropdown.is-right .dropdown-menu{left:auto;right:0}.dropdown.is-up .dropdown-menu{bottom:100%;padding-bottom:4px;padding-top:0;top:auto}.dropdown-menu{display:none;left:0;min-width:12rem;padding-top:4px;position:absolute;top:100%;z-index:20}.dropdown-content{background-color:#fff;border-radius:4px;box-shadow:0 2px 3px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);padding-bottom:.5rem;padding-top:.5rem}.dropdown-item{color:#4a4a4a;display:block;font-size:.875rem;line-height:1.5;padding:.375rem 1rem;position:relative}a.dropdown-item{padding-right:3rem;white-space:nowrap}a.dropdown-item:hover{background-color:#f5f5f5;color:#0a0a0a}a.dropdown-item.is-active{background-color:#3273dc;color:#fff}.dropdown-divider{background-color:#dbdbdb;border:none;display:block;height:1px;margin:.5rem 0}.level{align-items:center;justify-content:space-between}.level code{border-radius:4px}.level img{display:inline-block;vertical-align:top}.level.is-mobile,.level.is-mobile .level-left,.level.is-mobile .level-right{display:flex}.level.is-mobile .level-left+.level-right{margin-top:0}.level.is-mobile .level-item{margin-right:.75rem}.level.is-mobile .level-item:not(:last-child){margin-bottom:0}.level.is-mobile .level-item:not(.is-narrow){flex-grow:1}@media print,screen and (min-width:769px){.level{display:flex}.level>.level-item:not(.is-narrow){flex-grow:1}}.level-item{align-items:center;display:flex;flex-basis:auto;flex-grow:0;flex-shrink:0;justify-content:center}.level-item .subtitle,.level-item .title{margin-bottom:0}@media screen and (max-width:768px){.level-item:not(:last-child){margin-bottom:.75rem}}.level-left,.level-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.level-left .level-item.is-flexible,.level-right .level-item.is-flexible{flex-grow:1}@media print,screen and (min-width:769px){.level-left .level-item:not(:last-child),.level-right .level-item:not(:last-child){margin-right:.75rem}}.level-left{align-items:center;justify-content:flex-start}@media screen and (max-width:768px){.level-left+.level-right{margin-top:1.5rem}}@media print,screen and (min-width:769px){.level-left{display:flex}}.level-right{align-items:center;justify-content:flex-end}@media print,screen and (min-width:769px){.level-right{display:flex}}.media{align-items:flex-start;display:flex;text-align:left}.media .content:not(:last-child){margin-bottom:.75rem}.media .media{border-top:1px solid hsla(0,0%,86%,.5);display:flex;padding-top:.75rem}.media .media .content:not(:last-child),.media .media .control:not(:last-child){margin-bottom:.5rem}.media .media .media{padding-top:.5rem}.media .media .media+.media{margin-top:.5rem}.media+.media{border-top:1px solid hsla(0,0%,86%,.5);margin-top:1rem;padding-top:1rem}.media.is-large+.media{margin-top:1.5rem;padding-top:1.5rem}.media-left,.media-right{flex-basis:auto;flex-grow:0;flex-shrink:0}.media-left{margin-right:1rem}.media-right{margin-left:1rem}.media-content{flex-basis:auto;flex-grow:1;flex-shrink:1;text-align:left}.menu{font-size:1rem}.menu.is-small{font-size:.75rem}.menu.is-medium{font-size:1.25rem}.menu.is-large{font-size:1.5rem}.menu-list{line-height:1.25}.menu-list a{border-radius:2px;color:#4a4a4a;display:block;padding:.5em .75em}.menu-list a:hover{background-color:#f5f5f5;color:#363636}.menu-list a.is-active{background-color:#3273dc;color:#fff}.menu-list li ul{border-left:1px solid #dbdbdb;margin:.75em;padding-left:.75em}.menu-label{color:#7a7a7a;font-size:.75em;letter-spacing:.1em;text-transform:uppercase}.menu-label:not(:first-child){margin-top:1em}.menu-label:not(:last-child){margin-bottom:1em}.message{background-color:#f5f5f5;border-radius:4px;font-size:1rem}.message strong{color:currentColor}.message a:not(.button):not(.tag){color:currentColor;text-decoration:underline}.message.is-small{font-size:.75rem}.message.is-medium{font-size:1.25rem}.message.is-large{font-size:1.5rem}.message.is-white{background-color:#fff}.message.is-white .message-header{background-color:#fff;color:#0a0a0a}.message.is-white .message-body{border-color:#fff;color:#4d4d4d}.message.is-black{background-color:#fafafa}.message.is-black .message-header{background-color:#0a0a0a;color:#fff}.message.is-black .message-body{border-color:#0a0a0a;color:#090909}.message.is-light{background-color:#fafafa}.message.is-light .message-header{background-color:#f5f5f5;color:#363636}.message.is-light .message-body{border-color:#f5f5f5;color:#505050}.message.is-dark{background-color:#fafafa}.message.is-dark .message-header{background-color:#363636;color:#f5f5f5}.message.is-dark .message-body{border-color:#363636;color:#2a2a2a}.message.is-primary{background-color:#f5fffd}.message.is-primary .message-header{background-color:#00d1b2;color:#fff}.message.is-primary .message-body{border-color:#00d1b2;color:#021310}.message.is-link{background-color:#f6f9fe}.message.is-link .message-header{background-color:#3273dc;color:#fff}.message.is-link .message-body{border-color:#3273dc;color:#22509a}.message.is-info{background-color:#f6fbfe}.message.is-info .message-header{background-color:#209cee;color:#fff}.message.is-info .message-body{border-color:#209cee;color:#12537e}.message.is-success{background-color:#f6fef9}.message.is-success .message-header{background-color:#23d160;color:#fff}.message.is-success .message-body{border-color:#23d160;color:#0e301a}.message.is-warning{background-color:#fffdf5}.message.is-warning .message-header{background-color:#ffdd57;color:rgba(0,0,0,.7)}.message.is-warning .message-body{border-color:#ffdd57;color:#3b3108}.message.is-danger{background-color:#fff5f7}.message.is-danger .message-header{background-color:#ff3860;color:#fff}.message.is-danger .message-body{border-color:#ff3860;color:#cd0930}.message-header{align-items:center;background-color:#4a4a4a;border-radius:4px 4px 0 0;color:#fff;display:flex;font-weight:700;justify-content:space-between;line-height:1.25;padding:.75em 1em;position:relative}.message-header .delete{flex-grow:0;flex-shrink:0;margin-left:.75em}.message-header+.message-body{border-width:0;border-top-left-radius:0;border-top-right-radius:0}.message-body{border-color:#dbdbdb;border-radius:4px;border-style:solid;border-width:0 0 0 4px;color:#4a4a4a;padding:1.25em 1.5em}.message-body code,.message-body pre{background-color:#fff}.message-body pre code{background-color:transparent}.modal{align-items:center;display:none;justify-content:center;overflow:hidden;position:fixed;z-index:40}.modal.is-active{display:flex}.modal-background{background-color:hsla(0,0%,4%,.86)}.modal-card,.modal-content{margin:0 20px;max-height:calc(100vh - 160px);overflow:auto;position:relative;width:100%}@media print,screen and (min-width:769px){.modal-card,.modal-content{margin:0 auto;max-height:calc(100vh - 40px);width:640px}}.modal-close{background:0 0;height:40px;position:fixed;right:20px;top:20px;width:40px}.modal-card{display:flex;flex-direction:column;max-height:calc(100vh - 40px);overflow:hidden}.modal-card-foot,.modal-card-head{align-items:center;background-color:#f5f5f5;display:flex;flex-shrink:0;justify-content:flex-start;padding:20px;position:relative}.modal-card-head{border-bottom:1px solid #dbdbdb;border-top-left-radius:6px;border-top-right-radius:6px}.modal-card-title{color:#363636;flex-grow:1;flex-shrink:0;font-size:1.5rem;line-height:1}.modal-card-foot{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:1px solid #dbdbdb}.modal-card-foot .button:not(:last-child){margin-right:10px}.modal-card-body{-webkit-overflow-scrolling:touch;background-color:#fff;flex-grow:1;flex-shrink:1;overflow:auto;padding:20px}.navbar{background-color:#fff;min-height:3.25rem;position:relative;z-index:30}.navbar.is-white{background-color:#fff;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link,.navbar.is-white .navbar-brand>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link.is-active,.navbar.is-white .navbar-brand .navbar-link:hover,.navbar.is-white .navbar-brand>a.navbar-item.is-active,.navbar.is-white .navbar-brand>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-brand .navbar-link:after{border-color:#0a0a0a}@media screen and (min-width:1088px){.navbar.is-white .navbar-end .navbar-link,.navbar.is-white .navbar-end>.navbar-item,.navbar.is-white .navbar-start .navbar-link,.navbar.is-white .navbar-start>.navbar-item{color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link.is-active,.navbar.is-white .navbar-end .navbar-link:hover,.navbar.is-white .navbar-end>a.navbar-item.is-active,.navbar.is-white .navbar-end>a.navbar-item:hover,.navbar.is-white .navbar-start .navbar-link.is-active,.navbar.is-white .navbar-start .navbar-link:hover,.navbar.is-white .navbar-start>a.navbar-item.is-active,.navbar.is-white .navbar-start>a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-end .navbar-link:after,.navbar.is-white .navbar-start .navbar-link:after{border-color:#0a0a0a}.navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-white .navbar-item.has-dropdown:hover .navbar-link{background-color:#f2f2f2;color:#0a0a0a}.navbar.is-white .navbar-dropdown a.navbar-item.is-active{background-color:#fff;color:#0a0a0a}}.navbar.is-black{background-color:#0a0a0a;color:#fff}.navbar.is-black .navbar-brand .navbar-link,.navbar.is-black .navbar-brand>.navbar-item{color:#fff}.navbar.is-black .navbar-brand .navbar-link.is-active,.navbar.is-black .navbar-brand .navbar-link:hover,.navbar.is-black .navbar-brand>a.navbar-item.is-active,.navbar.is-black .navbar-brand>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-black .navbar-end .navbar-link,.navbar.is-black .navbar-end>.navbar-item,.navbar.is-black .navbar-start .navbar-link,.navbar.is-black .navbar-start>.navbar-item{color:#fff}.navbar.is-black .navbar-end .navbar-link.is-active,.navbar.is-black .navbar-end .navbar-link:hover,.navbar.is-black .navbar-end>a.navbar-item.is-active,.navbar.is-black .navbar-end>a.navbar-item:hover,.navbar.is-black .navbar-start .navbar-link.is-active,.navbar.is-black .navbar-start .navbar-link:hover,.navbar.is-black .navbar-start>a.navbar-item.is-active,.navbar.is-black .navbar-start>a.navbar-item:hover{background-color:#000;color:#fff}.navbar.is-black .navbar-end .navbar-link:after,.navbar.is-black .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-black .navbar-item.has-dropdown:hover .navbar-link{background-color:#000;color:#fff}.navbar.is-black .navbar-dropdown a.navbar-item.is-active{background-color:#0a0a0a;color:#fff}}.navbar.is-light{background-color:#f5f5f5;color:#363636}.navbar.is-light .navbar-brand .navbar-link,.navbar.is-light .navbar-brand>.navbar-item{color:#363636}.navbar.is-light .navbar-brand .navbar-link.is-active,.navbar.is-light .navbar-brand .navbar-link:hover,.navbar.is-light .navbar-brand>a.navbar-item.is-active,.navbar.is-light .navbar-brand>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-brand .navbar-link:after{border-color:#363636}@media screen and (min-width:1088px){.navbar.is-light .navbar-end .navbar-link,.navbar.is-light .navbar-end>.navbar-item,.navbar.is-light .navbar-start .navbar-link,.navbar.is-light .navbar-start>.navbar-item{color:#363636}.navbar.is-light .navbar-end .navbar-link.is-active,.navbar.is-light .navbar-end .navbar-link:hover,.navbar.is-light .navbar-end>a.navbar-item.is-active,.navbar.is-light .navbar-end>a.navbar-item:hover,.navbar.is-light .navbar-start .navbar-link.is-active,.navbar.is-light .navbar-start .navbar-link:hover,.navbar.is-light .navbar-start>a.navbar-item.is-active,.navbar.is-light .navbar-start>a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-end .navbar-link:after,.navbar.is-light .navbar-start .navbar-link:after{border-color:#363636}.navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-light .navbar-item.has-dropdown:hover .navbar-link{background-color:#e8e8e8;color:#363636}.navbar.is-light .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#363636}}.navbar.is-dark{background-color:#363636;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link,.navbar.is-dark .navbar-brand>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link.is-active,.navbar.is-dark .navbar-brand .navbar-link:hover,.navbar.is-dark .navbar-brand>a.navbar-item.is-active,.navbar.is-dark .navbar-brand>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-brand .navbar-link:after{border-color:#f5f5f5}@media screen and (min-width:1088px){.navbar.is-dark .navbar-end .navbar-link,.navbar.is-dark .navbar-end>.navbar-item,.navbar.is-dark .navbar-start .navbar-link,.navbar.is-dark .navbar-start>.navbar-item{color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link.is-active,.navbar.is-dark .navbar-end .navbar-link:hover,.navbar.is-dark .navbar-end>a.navbar-item.is-active,.navbar.is-dark .navbar-end>a.navbar-item:hover,.navbar.is-dark .navbar-start .navbar-link.is-active,.navbar.is-dark .navbar-start .navbar-link:hover,.navbar.is-dark .navbar-start>a.navbar-item.is-active,.navbar.is-dark .navbar-start>a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-end .navbar-link:after,.navbar.is-dark .navbar-start .navbar-link:after{border-color:#f5f5f5}.navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link{background-color:#292929;color:#f5f5f5}.navbar.is-dark .navbar-dropdown a.navbar-item.is-active{background-color:#363636;color:#f5f5f5}}.navbar.is-primary{background-color:#00d1b2;color:#fff}.navbar.is-primary .navbar-brand .navbar-link,.navbar.is-primary .navbar-brand>.navbar-item{color:#fff}.navbar.is-primary .navbar-brand .navbar-link.is-active,.navbar.is-primary .navbar-brand .navbar-link:hover,.navbar.is-primary .navbar-brand>a.navbar-item.is-active,.navbar.is-primary .navbar-brand>a.navbar-item:hover{background-color:#00b89c;color:#fff}.navbar.is-primary .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-primary .navbar-end .navbar-link,.navbar.is-primary .navbar-end>.navbar-item,.navbar.is-primary .navbar-start .navbar-link,.navbar.is-primary .navbar-start>.navbar-item{color:#fff}.navbar.is-primary .navbar-end .navbar-link.is-active,.navbar.is-primary .navbar-end .navbar-link:hover,.navbar.is-primary .navbar-end>a.navbar-item.is-active,.navbar.is-primary .navbar-end>a.navbar-item:hover,.navbar.is-primary .navbar-start .navbar-link.is-active,.navbar.is-primary .navbar-start .navbar-link:hover,.navbar.is-primary .navbar-start>a.navbar-item.is-active,.navbar.is-primary .navbar-start>a.navbar-item:hover{background-color:#00b89c;color:#fff}.navbar.is-primary .navbar-end .navbar-link:after,.navbar.is-primary .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link{background-color:#00b89c;color:#fff}.navbar.is-primary .navbar-dropdown a.navbar-item.is-active{background-color:#00d1b2;color:#fff}}.navbar.is-link{background-color:#3273dc;color:#fff}.navbar.is-link .navbar-brand .navbar-link,.navbar.is-link .navbar-brand>.navbar-item{color:#fff}.navbar.is-link .navbar-brand .navbar-link.is-active,.navbar.is-link .navbar-brand .navbar-link:hover,.navbar.is-link .navbar-brand>a.navbar-item.is-active,.navbar.is-link .navbar-brand>a.navbar-item:hover{background-color:#2366d1;color:#fff}.navbar.is-link .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-link .navbar-end .navbar-link,.navbar.is-link .navbar-end>.navbar-item,.navbar.is-link .navbar-start .navbar-link,.navbar.is-link .navbar-start>.navbar-item{color:#fff}.navbar.is-link .navbar-end .navbar-link.is-active,.navbar.is-link .navbar-end .navbar-link:hover,.navbar.is-link .navbar-end>a.navbar-item.is-active,.navbar.is-link .navbar-end>a.navbar-item:hover,.navbar.is-link .navbar-start .navbar-link.is-active,.navbar.is-link .navbar-start .navbar-link:hover,.navbar.is-link .navbar-start>a.navbar-item.is-active,.navbar.is-link .navbar-start>a.navbar-item:hover{background-color:#2366d1;color:#fff}.navbar.is-link .navbar-end .navbar-link:after,.navbar.is-link .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-link .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-link .navbar-item.has-dropdown:hover .navbar-link{background-color:#2366d1;color:#fff}.navbar.is-link .navbar-dropdown a.navbar-item.is-active{background-color:#3273dc;color:#fff}}.navbar.is-info{background-color:#209cee;color:#fff}.navbar.is-info .navbar-brand .navbar-link,.navbar.is-info .navbar-brand>.navbar-item{color:#fff}.navbar.is-info .navbar-brand .navbar-link.is-active,.navbar.is-info .navbar-brand .navbar-link:hover,.navbar.is-info .navbar-brand>a.navbar-item.is-active,.navbar.is-info .navbar-brand>a.navbar-item:hover{background-color:#118fe4;color:#fff}.navbar.is-info .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-info .navbar-end .navbar-link,.navbar.is-info .navbar-end>.navbar-item,.navbar.is-info .navbar-start .navbar-link,.navbar.is-info .navbar-start>.navbar-item{color:#fff}.navbar.is-info .navbar-end .navbar-link.is-active,.navbar.is-info .navbar-end .navbar-link:hover,.navbar.is-info .navbar-end>a.navbar-item.is-active,.navbar.is-info .navbar-end>a.navbar-item:hover,.navbar.is-info .navbar-start .navbar-link.is-active,.navbar.is-info .navbar-start .navbar-link:hover,.navbar.is-info .navbar-start>a.navbar-item.is-active,.navbar.is-info .navbar-start>a.navbar-item:hover{background-color:#118fe4;color:#fff}.navbar.is-info .navbar-end .navbar-link:after,.navbar.is-info .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-info .navbar-item.has-dropdown:hover .navbar-link{background-color:#118fe4;color:#fff}.navbar.is-info .navbar-dropdown a.navbar-item.is-active{background-color:#209cee;color:#fff}}.navbar.is-success{background-color:#23d160;color:#fff}.navbar.is-success .navbar-brand .navbar-link,.navbar.is-success .navbar-brand>.navbar-item{color:#fff}.navbar.is-success .navbar-brand .navbar-link.is-active,.navbar.is-success .navbar-brand .navbar-link:hover,.navbar.is-success .navbar-brand>a.navbar-item.is-active,.navbar.is-success .navbar-brand>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-success .navbar-end .navbar-link,.navbar.is-success .navbar-end>.navbar-item,.navbar.is-success .navbar-start .navbar-link,.navbar.is-success .navbar-start>.navbar-item{color:#fff}.navbar.is-success .navbar-end .navbar-link.is-active,.navbar.is-success .navbar-end .navbar-link:hover,.navbar.is-success .navbar-end>a.navbar-item.is-active,.navbar.is-success .navbar-end>a.navbar-item:hover,.navbar.is-success .navbar-start .navbar-link.is-active,.navbar.is-success .navbar-start .navbar-link:hover,.navbar.is-success .navbar-start>a.navbar-item.is-active,.navbar.is-success .navbar-start>a.navbar-item:hover{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-end .navbar-link:after,.navbar.is-success .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-success .navbar-item.has-dropdown:hover .navbar-link{background-color:#20bc56;color:#fff}.navbar.is-success .navbar-dropdown a.navbar-item.is-active{background-color:#23d160;color:#fff}}.navbar.is-warning{background-color:#ffdd57}.navbar.is-warning,.navbar.is-warning .navbar-brand .navbar-link,.navbar.is-warning .navbar-brand>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link.is-active,.navbar.is-warning .navbar-brand .navbar-link:hover,.navbar.is-warning .navbar-brand>a.navbar-item.is-active,.navbar.is-warning .navbar-brand>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-brand .navbar-link:after{border-color:rgba(0,0,0,.7)}@media screen and (min-width:1088px){.navbar.is-warning .navbar-end .navbar-link,.navbar.is-warning .navbar-end>.navbar-item,.navbar.is-warning .navbar-start .navbar-link,.navbar.is-warning .navbar-start>.navbar-item{color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link.is-active,.navbar.is-warning .navbar-end .navbar-link:hover,.navbar.is-warning .navbar-end>a.navbar-item.is-active,.navbar.is-warning .navbar-end>a.navbar-item:hover,.navbar.is-warning .navbar-start .navbar-link.is-active,.navbar.is-warning .navbar-start .navbar-link:hover,.navbar.is-warning .navbar-start>a.navbar-item.is-active,.navbar.is-warning .navbar-start>a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-end .navbar-link:after,.navbar.is-warning .navbar-start .navbar-link:after{border-color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link{background-color:#ffd83d;color:rgba(0,0,0,.7)}.navbar.is-warning .navbar-dropdown a.navbar-item.is-active{background-color:#ffdd57;color:rgba(0,0,0,.7,1)}}.navbar.is-danger{background-color:#ff3860;color:#fff}.navbar.is-danger .navbar-brand .navbar-link,.navbar.is-danger .navbar-brand>.navbar-item{color:#fff}.navbar.is-danger .navbar-brand .navbar-link.is-active,.navbar.is-danger .navbar-brand .navbar-link:hover,.navbar.is-danger .navbar-brand>a.navbar-item.is-active,.navbar.is-danger .navbar-brand>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-brand .navbar-link:after{border-color:#fff}@media screen and (min-width:1088px){.navbar.is-danger .navbar-end .navbar-link,.navbar.is-danger .navbar-end>.navbar-item,.navbar.is-danger .navbar-start .navbar-link,.navbar.is-danger .navbar-start>.navbar-item{color:#fff}.navbar.is-danger .navbar-end .navbar-link.is-active,.navbar.is-danger .navbar-end .navbar-link:hover,.navbar.is-danger .navbar-end>a.navbar-item.is-active,.navbar.is-danger .navbar-end>a.navbar-item:hover,.navbar.is-danger .navbar-start .navbar-link.is-active,.navbar.is-danger .navbar-start .navbar-link:hover,.navbar.is-danger .navbar-start>a.navbar-item.is-active,.navbar.is-danger .navbar-start>a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-end .navbar-link:after,.navbar.is-danger .navbar-start .navbar-link:after{border-color:#fff}.navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link{background-color:#ff1f4b;color:#fff}.navbar.is-danger .navbar-dropdown a.navbar-item.is-active{background-color:#ff3860;color:#fff}}.navbar>.container{align-items:stretch;display:flex;min-height:3.25rem;width:100%}.navbar.has-shadow{box-shadow:0 2px 0 0 #f5f5f5}.navbar.is-fixed-bottom,.navbar.is-fixed-top{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom{bottom:0}.navbar.is-fixed-bottom.has-shadow{box-shadow:0 -2px 0 0 #f5f5f5}.navbar.is-fixed-top{top:0}body.has-navbar-fixed-top,html.has-navbar-fixed-top{padding-top:3.25rem}body.has-navbar-fixed-bottom,html.has-navbar-fixed-bottom{padding-bottom:3.25rem}.navbar-brand,.navbar-tabs{align-items:stretch;display:flex;flex-shrink:0;min-height:3.25rem}.navbar-brand a.navbar-item:hover{background-color:transparent}.navbar-tabs{-webkit-overflow-scrolling:touch;max-width:100vw;overflow-x:auto;overflow-y:hidden}.navbar-burger{cursor:pointer;display:block;height:3.25rem;position:relative;width:3.25rem;margin-left:auto}.navbar-burger span{background-color:currentColor;display:block;height:1px;left:calc(50% - 8px);position:absolute;-webkit-transform-origin:center;transform-origin:center;transition-duration:86ms;transition-property:background-color,opacity,-webkit-transform;transition-property:background-color,opacity,transform;transition-property:background-color,opacity,transform,-webkit-transform;transition-timing-function:ease-out;width:16px}.navbar-burger span:first-child{top:calc(50% - 6px)}.navbar-burger span:nth-child(2){top:calc(50% - 1px)}.navbar-burger span:nth-child(3){top:calc(50% + 4px)}.navbar-burger:hover{background-color:rgba(0,0,0,.05)}.navbar-burger.is-active span:first-child{-webkit-transform:translateY(5px) rotate(45deg);transform:translateY(5px) rotate(45deg)}.navbar-burger.is-active span:nth-child(2){opacity:0}.navbar-burger.is-active span:nth-child(3){-webkit-transform:translateY(-5px) rotate(-45deg);transform:translateY(-5px) rotate(-45deg)}.navbar-menu{display:none}.navbar-item,.navbar-link{color:#4a4a4a;display:block;line-height:1.5;padding:.5rem .75rem;position:relative}.navbar-item .icon:only-child,.navbar-link .icon:only-child{margin-left:-.25rem;margin-right:-.25rem}.navbar-link,a.navbar-item{cursor:pointer}.navbar-link.is-active,.navbar-link:hover,a.navbar-item.is-active,a.navbar-item:hover{background-color:#fafafa;color:#3273dc}.navbar-item{display:block;flex-grow:0;flex-shrink:0}.navbar-item img{max-height:1.75rem}.navbar-item.has-dropdown{padding:0}.navbar-item.is-expanded{flex-grow:1;flex-shrink:1}.navbar-item.is-tab{border-bottom:1px solid transparent;min-height:3.25rem;padding-bottom:calc(.5rem - 1px)}.navbar-item.is-tab.is-active,.navbar-item.is-tab:hover{background-color:transparent;border-bottom-color:#3273dc}.navbar-item.is-tab.is-active{border-bottom-style:solid;border-bottom-width:3px;color:#3273dc;padding-bottom:calc(.5rem - 3px)}.navbar-content{flex-grow:1;flex-shrink:1}.navbar-link{padding-right:2.5em}.navbar-link:after{border-color:#3273dc;margin-top:-.375em;right:1.125em}.navbar-dropdown{font-size:.875rem;padding-bottom:.5rem;padding-top:.5rem}.navbar-dropdown .navbar-item{padding-left:1.5rem;padding-right:1.5rem}.navbar-divider{background-color:#f5f5f5;border:none;display:none;height:2px;margin:.5rem 0}@media screen and (max-width:1087px){.navbar>.container{display:block}.navbar-brand .navbar-item,.navbar-tabs .navbar-item{align-items:center;display:flex}.navbar-link:after{display:none}.navbar-menu{background-color:#fff;box-shadow:0 8px 16px hsla(0,0%,4%,.1);padding:.5rem 0}.navbar-menu.is-active{display:block}.navbar.is-fixed-bottom-touch,.navbar.is-fixed-top-touch{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-touch{bottom:0}.navbar.is-fixed-bottom-touch.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-touch{top:0}.navbar.is-fixed-top-touch .navbar-menu,.navbar.is-fixed-top .navbar-menu{-webkit-overflow-scrolling:touch;max-height:calc(100vh - 3.25rem);overflow:auto}body.has-navbar-fixed-top-touch,html.has-navbar-fixed-top-touch{padding-top:3.25rem}body.has-navbar-fixed-bottom-touch,html.has-navbar-fixed-bottom-touch{padding-bottom:3.25rem}}@media screen and (min-width:1088px){.navbar,.navbar-end,.navbar-menu,.navbar-start{align-items:stretch;display:flex}.navbar{min-height:3.25rem}.navbar.is-spaced{padding:1rem 2rem}.navbar.is-spaced .navbar-end,.navbar.is-spaced .navbar-start{align-items:center}.navbar.is-spaced .navbar-link,.navbar.is-spaced a.navbar-item{border-radius:4px}.navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,.navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link,.navbar.is-transparent .navbar-link.is-active,.navbar.is-transparent .navbar-link:hover,.navbar.is-transparent a.navbar-item.is-active,.navbar.is-transparent a.navbar-item:hover{background-color:transparent!important}.navbar.is-transparent .navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar.is-transparent .navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.navbar-burger{display:none}.navbar-item,.navbar-link{align-items:center;display:flex}.navbar-item{display:flex}.navbar-item.has-dropdown{align-items:stretch}.navbar-item.has-dropdown-up .navbar-link:after{-webkit-transform:rotate(135deg) translate(.25em,-.25em);transform:rotate(135deg) translate(.25em,-.25em)}.navbar-item.has-dropdown-up .navbar-dropdown{border-bottom:2px solid #dbdbdb;border-radius:6px 6px 0 0;border-top:none;bottom:100%;box-shadow:0 -8px 8px hsla(0,0%,4%,.1);top:auto}.navbar-item.is-active .navbar-dropdown,.navbar-item.is-hoverable:hover .navbar-dropdown{display:block}.navbar-item.is-active .navbar-dropdown.is-boxed,.navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-item.is-active .navbar-dropdown,.navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown{opacity:1;pointer-events:auto;-webkit-transform:translateY(0);transform:translateY(0)}.navbar-menu{flex-grow:1;flex-shrink:0}.navbar-start{justify-content:flex-start;margin-right:auto}.navbar-end{justify-content:flex-end;margin-left:auto}.navbar-dropdown{background-color:#fff;border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top:2px solid #dbdbdb;box-shadow:0 8px 8px hsla(0,0%,4%,.1);display:none;font-size:.875rem;left:0;min-width:100%;position:absolute;top:100%;z-index:20}.navbar-dropdown .navbar-item{padding:.375rem 1rem;white-space:nowrap}.navbar-dropdown a.navbar-item{padding-right:3rem}.navbar-dropdown a.navbar-item:hover{background-color:#f5f5f5;color:#0a0a0a}.navbar-dropdown a.navbar-item.is-active{background-color:#f5f5f5;color:#3273dc}.navbar-dropdown.is-boxed,.navbar.is-spaced .navbar-dropdown{border-radius:6px;border-top:none;box-shadow:0 8px 8px hsla(0,0%,4%,.1),0 0 0 1px hsla(0,0%,4%,.1);display:block;opacity:0;pointer-events:none;top:calc(100% + -4px);-webkit-transform:translateY(-5px);transform:translateY(-5px);transition-duration:86ms;transition-property:opacity,-webkit-transform;transition-property:opacity,transform;transition-property:opacity,transform,-webkit-transform}.navbar-dropdown.is-right{left:auto;right:0}.navbar-divider{display:block}.container>.navbar .navbar-brand,.navbar>.container .navbar-brand{margin-left:-1rem}.container>.navbar .navbar-menu,.navbar>.container .navbar-menu{margin-right:-1rem}.navbar.is-fixed-bottom-desktop,.navbar.is-fixed-top-desktop{left:0;position:fixed;right:0;z-index:30}.navbar.is-fixed-bottom-desktop{bottom:0}.navbar.is-fixed-bottom-desktop.has-shadow{box-shadow:0 -2px 3px hsla(0,0%,4%,.1)}.navbar.is-fixed-top-desktop{top:0}body.has-navbar-fixed-top-desktop,html.has-navbar-fixed-top-desktop{padding-top:3.25rem}body.has-navbar-fixed-bottom-desktop,html.has-navbar-fixed-bottom-desktop{padding-bottom:3.25rem}body.has-spaced-navbar-fixed-top,html.has-spaced-navbar-fixed-top{padding-top:5.25rem}body.has-spaced-navbar-fixed-bottom,html.has-spaced-navbar-fixed-bottom{padding-bottom:5.25rem}.navbar-link.is-active,a.navbar-item.is-active{color:#0a0a0a}.navbar-link.is-active:not(:hover),a.navbar-item.is-active:not(:hover){background-color:transparent}.navbar-item.has-dropdown.is-active .navbar-link,.navbar-item.has-dropdown:hover .navbar-link{background-color:#fafafa}}.pagination{font-size:1rem;margin:-.25rem}.pagination.is-small{font-size:.75rem}.pagination.is-medium{font-size:1.25rem}.pagination.is-large{font-size:1.5rem}.pagination.is-rounded .pagination-next,.pagination.is-rounded .pagination-previous{padding-left:1em;padding-right:1em;border-radius:290486px}.pagination.is-rounded .pagination-link{border-radius:290486px}.pagination,.pagination-list{align-items:center;display:flex;justify-content:center;text-align:center}.pagination-ellipsis,.pagination-link,.pagination-next,.pagination-previous{font-size:1em;padding-left:.5em;padding-right:.5em;justify-content:center;margin:.25rem;text-align:center}.pagination-link,.pagination-next,.pagination-previous{border-color:#dbdbdb;color:#363636;min-width:2.25em}.pagination-link:hover,.pagination-next:hover,.pagination-previous:hover{border-color:#b5b5b5;color:#363636}.pagination-link:focus,.pagination-next:focus,.pagination-previous:focus{border-color:#3273dc}.pagination-link:active,.pagination-next:active,.pagination-previous:active{box-shadow:inset 0 1px 2px hsla(0,0%,4%,.2)}.pagination-link[disabled],.pagination-next[disabled],.pagination-previous[disabled]{background-color:#dbdbdb;border-color:#dbdbdb;box-shadow:none;color:#7a7a7a;opacity:.5}.pagination-next,.pagination-previous{padding-left:.75em;padding-right:.75em;white-space:nowrap}.pagination-link.is-current{background-color:#3273dc;border-color:#3273dc;color:#fff}.pagination-ellipsis{color:#b5b5b5;pointer-events:none}.pagination-list{flex-wrap:wrap}@media screen and (max-width:768px){.pagination{flex-wrap:wrap}.pagination-list li,.pagination-next,.pagination-previous{flex-grow:1;flex-shrink:1}}@media print,screen and (min-width:769px){.pagination-list{flex-grow:1;flex-shrink:1;justify-content:flex-start;order:1}.pagination-previous{order:2}.pagination-next{order:3}.pagination{justify-content:space-between}.pagination.is-centered .pagination-previous{order:1}.pagination.is-centered .pagination-list{justify-content:center;order:2}.pagination.is-centered .pagination-next{order:3}.pagination.is-right .pagination-previous{order:1}.pagination.is-right .pagination-next{order:2}.pagination.is-right .pagination-list{justify-content:flex-end;order:3}}.panel{font-size:1rem}.panel:not(:last-child){margin-bottom:1.5rem}.panel-block,.panel-heading,.panel-tabs{border-bottom:1px solid #dbdbdb;border-left:1px solid #dbdbdb;border-right:1px solid #dbdbdb}.panel-block:first-child,.panel-heading:first-child,.panel-tabs:first-child{border-top:1px solid #dbdbdb}.panel-heading{background-color:#f5f5f5;border-radius:4px 4px 0 0;color:#363636;font-size:1.25em;font-weight:300;line-height:1.25;padding:.5em .75em}.panel-tabs{align-items:flex-end;display:flex;font-size:.875em;justify-content:center}.panel-tabs a{border-bottom:1px solid #dbdbdb;margin-bottom:-1px;padding:.5em}.panel-tabs a.is-active{border-bottom-color:#4a4a4a;color:#363636}.panel-list a{color:#4a4a4a}.panel-list a:hover{color:#3273dc}.panel-block{align-items:center;color:#363636;display:flex;justify-content:flex-start;padding:.5em .75em}.panel-block input[type=checkbox]{margin-right:.75em}.panel-block>.control{flex-grow:1;flex-shrink:1;width:100%}.panel-block.is-wrapped{flex-wrap:wrap}.panel-block.is-active{border-left-color:#3273dc;color:#363636}.panel-block.is-active .panel-icon{color:#3273dc}a.panel-block,label.panel-block{cursor:pointer}a.panel-block:hover,label.panel-block:hover{background-color:#f5f5f5}.panel-icon{display:inline-block;font-size:14px;height:1em;line-height:1em;text-align:center;vertical-align:top;width:1em;color:#7a7a7a;margin-right:.75em}.panel-icon .fa{font-size:inherit;line-height:inherit}.tabs{-webkit-overflow-scrolling:touch;align-items:stretch;display:flex;font-size:1rem;justify-content:space-between;overflow:hidden;overflow-x:auto;white-space:nowrap}.tabs a{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;color:#4a4a4a;display:flex;justify-content:center;margin-bottom:-1px;padding:.5em 1em;vertical-align:top}.tabs a:hover{border-bottom-color:#363636;color:#363636}.tabs li{display:block}.tabs li.is-active a{border-bottom-color:#3273dc;color:#3273dc}.tabs ul{align-items:center;border-bottom-color:#dbdbdb;border-bottom-style:solid;border-bottom-width:1px;display:flex;flex-grow:1;flex-shrink:0;justify-content:flex-start}.tabs ul.is-center,.tabs ul.is-left{padding-right:.75em}.tabs ul.is-center{flex:none;justify-content:center;padding-left:.75em}.tabs ul.is-right{justify-content:flex-end;padding-left:.75em}.tabs .icon:first-child{margin-right:.5em}.tabs .icon:last-child{margin-left:.5em}.tabs.is-centered ul{justify-content:center}.tabs.is-right ul{justify-content:flex-end}.tabs.is-boxed a{border:1px solid transparent;border-radius:4px 4px 0 0}.tabs.is-boxed a:hover{background-color:#f5f5f5;border-bottom-color:#dbdbdb}.tabs.is-boxed li.is-active a{background-color:#fff;border-color:#dbdbdb;border-bottom-color:transparent!important}.tabs.is-fullwidth li{flex-grow:1;flex-shrink:0}.tabs.is-toggle a{border:1px solid #dbdbdb;margin-bottom:0;position:relative}.tabs.is-toggle a:hover{background-color:#f5f5f5;border-color:#b5b5b5;z-index:2}.tabs.is-toggle li+li{margin-left:-1px}.tabs.is-toggle li:first-child a{border-radius:4px 0 0 4px}.tabs.is-toggle li:last-child a{border-radius:0 4px 4px 0}.tabs.is-toggle li.is-active a{background-color:#3273dc;border-color:#3273dc;color:#fff;z-index:1}.tabs.is-toggle ul{border-bottom:none}.tabs.is-toggle.is-toggle-rounded li:first-child a{border-bottom-left-radius:290486px;border-top-left-radius:290486px;padding-left:1.25em}.tabs.is-toggle.is-toggle-rounded li:last-child a{border-bottom-right-radius:290486px;border-top-right-radius:290486px;padding-right:1.25em}.tabs.is-small{font-size:.75rem}.tabs.is-medium{font-size:1.25rem}.tabs.is-large{font-size:1.5rem}.column{display:block;flex-basis:0;flex-grow:1;flex-shrink:1;padding:.75rem}.columns.is-mobile>.column.is-narrow{flex:none}.columns.is-mobile>.column.is-full{flex:none;width:100%}.columns.is-mobile>.column.is-three-quarters{flex:none;width:75%}.columns.is-mobile>.column.is-two-thirds{flex:none;width:66.6666%}.columns.is-mobile>.column.is-half{flex:none;width:50%}.columns.is-mobile>.column.is-one-third{flex:none;width:33.3333%}.columns.is-mobile>.column.is-one-quarter{flex:none;width:25%}.columns.is-mobile>.column.is-one-fifth{flex:none;width:20%}.columns.is-mobile>.column.is-two-fifths{flex:none;width:40%}.columns.is-mobile>.column.is-three-fifths{flex:none;width:60%}.columns.is-mobile>.column.is-four-fifths{flex:none;width:80%}.columns.is-mobile>.column.is-offset-three-quarters{margin-left:75%}.columns.is-mobile>.column.is-offset-two-thirds{margin-left:66.6666%}.columns.is-mobile>.column.is-offset-half{margin-left:50%}.columns.is-mobile>.column.is-offset-one-third{margin-left:33.3333%}.columns.is-mobile>.column.is-offset-one-quarter{margin-left:25%}.columns.is-mobile>.column.is-offset-one-fifth{margin-left:20%}.columns.is-mobile>.column.is-offset-two-fifths{margin-left:40%}.columns.is-mobile>.column.is-offset-three-fifths{margin-left:60%}.columns.is-mobile>.column.is-offset-four-fifths{margin-left:80%}.columns.is-mobile>.column.is-1{flex:none;width:8.33333%}.columns.is-mobile>.column.is-offset-1{margin-left:8.33333%}.columns.is-mobile>.column.is-2{flex:none;width:16.66667%}.columns.is-mobile>.column.is-offset-2{margin-left:16.66667%}.columns.is-mobile>.column.is-3{flex:none;width:25%}.columns.is-mobile>.column.is-offset-3{margin-left:25%}.columns.is-mobile>.column.is-4{flex:none;width:33.33333%}.columns.is-mobile>.column.is-offset-4{margin-left:33.33333%}.columns.is-mobile>.column.is-5{flex:none;width:41.66667%}.columns.is-mobile>.column.is-offset-5{margin-left:41.66667%}.columns.is-mobile>.column.is-6{flex:none;width:50%}.columns.is-mobile>.column.is-offset-6{margin-left:50%}.columns.is-mobile>.column.is-7{flex:none;width:58.33333%}.columns.is-mobile>.column.is-offset-7{margin-left:58.33333%}.columns.is-mobile>.column.is-8{flex:none;width:66.66667%}.columns.is-mobile>.column.is-offset-8{margin-left:66.66667%}.columns.is-mobile>.column.is-9{flex:none;width:75%}.columns.is-mobile>.column.is-offset-9{margin-left:75%}.columns.is-mobile>.column.is-10{flex:none;width:83.33333%}.columns.is-mobile>.column.is-offset-10{margin-left:83.33333%}.columns.is-mobile>.column.is-11{flex:none;width:91.66667%}.columns.is-mobile>.column.is-offset-11{margin-left:91.66667%}.columns.is-mobile>.column.is-12{flex:none;width:100%}.columns.is-mobile>.column.is-offset-12{margin-left:100%}@media screen and (max-width:768px){.column.is-narrow-mobile{flex:none}.column.is-full-mobile{flex:none;width:100%}.column.is-three-quarters-mobile{flex:none;width:75%}.column.is-two-thirds-mobile{flex:none;width:66.6666%}.column.is-half-mobile{flex:none;width:50%}.column.is-one-third-mobile{flex:none;width:33.3333%}.column.is-one-quarter-mobile{flex:none;width:25%}.column.is-one-fifth-mobile{flex:none;width:20%}.column.is-two-fifths-mobile{flex:none;width:40%}.column.is-three-fifths-mobile{flex:none;width:60%}.column.is-four-fifths-mobile{flex:none;width:80%}.column.is-offset-three-quarters-mobile{margin-left:75%}.column.is-offset-two-thirds-mobile{margin-left:66.6666%}.column.is-offset-half-mobile{margin-left:50%}.column.is-offset-one-third-mobile{margin-left:33.3333%}.column.is-offset-one-quarter-mobile{margin-left:25%}.column.is-offset-one-fifth-mobile{margin-left:20%}.column.is-offset-two-fifths-mobile{margin-left:40%}.column.is-offset-three-fifths-mobile{margin-left:60%}.column.is-offset-four-fifths-mobile{margin-left:80%}.column.is-1-mobile{flex:none;width:8.33333%}.column.is-offset-1-mobile{margin-left:8.33333%}.column.is-2-mobile{flex:none;width:16.66667%}.column.is-offset-2-mobile{margin-left:16.66667%}.column.is-3-mobile{flex:none;width:25%}.column.is-offset-3-mobile{margin-left:25%}.column.is-4-mobile{flex:none;width:33.33333%}.column.is-offset-4-mobile{margin-left:33.33333%}.column.is-5-mobile{flex:none;width:41.66667%}.column.is-offset-5-mobile{margin-left:41.66667%}.column.is-6-mobile{flex:none;width:50%}.column.is-offset-6-mobile{margin-left:50%}.column.is-7-mobile{flex:none;width:58.33333%}.column.is-offset-7-mobile{margin-left:58.33333%}.column.is-8-mobile{flex:none;width:66.66667%}.column.is-offset-8-mobile{margin-left:66.66667%}.column.is-9-mobile{flex:none;width:75%}.column.is-offset-9-mobile{margin-left:75%}.column.is-10-mobile{flex:none;width:83.33333%}.column.is-offset-10-mobile{margin-left:83.33333%}.column.is-11-mobile{flex:none;width:91.66667%}.column.is-offset-11-mobile{margin-left:91.66667%}.column.is-12-mobile{flex:none;width:100%}.column.is-offset-12-mobile{margin-left:100%}}@media print,screen and (min-width:769px){.column.is-narrow,.column.is-narrow-tablet{flex:none}.column.is-full,.column.is-full-tablet{flex:none;width:100%}.column.is-three-quarters,.column.is-three-quarters-tablet{flex:none;width:75%}.column.is-two-thirds,.column.is-two-thirds-tablet{flex:none;width:66.6666%}.column.is-half,.column.is-half-tablet{flex:none;width:50%}.column.is-one-third,.column.is-one-third-tablet{flex:none;width:33.3333%}.column.is-one-quarter,.column.is-one-quarter-tablet{flex:none;width:25%}.column.is-one-fifth,.column.is-one-fifth-tablet{flex:none;width:20%}.column.is-two-fifths,.column.is-two-fifths-tablet{flex:none;width:40%}.column.is-three-fifths,.column.is-three-fifths-tablet{flex:none;width:60%}.column.is-four-fifths,.column.is-four-fifths-tablet{flex:none;width:80%}.column.is-offset-three-quarters,.column.is-offset-three-quarters-tablet{margin-left:75%}.column.is-offset-two-thirds,.column.is-offset-two-thirds-tablet{margin-left:66.6666%}.column.is-offset-half,.column.is-offset-half-tablet{margin-left:50%}.column.is-offset-one-third,.column.is-offset-one-third-tablet{margin-left:33.3333%}.column.is-offset-one-quarter,.column.is-offset-one-quarter-tablet{margin-left:25%}.column.is-offset-one-fifth,.column.is-offset-one-fifth-tablet{margin-left:20%}.column.is-offset-two-fifths,.column.is-offset-two-fifths-tablet{margin-left:40%}.column.is-offset-three-fifths,.column.is-offset-three-fifths-tablet{margin-left:60%}.column.is-offset-four-fifths,.column.is-offset-four-fifths-tablet{margin-left:80%}.column.is-1,.column.is-1-tablet{flex:none;width:8.33333%}.column.is-offset-1,.column.is-offset-1-tablet{margin-left:8.33333%}.column.is-2,.column.is-2-tablet{flex:none;width:16.66667%}.column.is-offset-2,.column.is-offset-2-tablet{margin-left:16.66667%}.column.is-3,.column.is-3-tablet{flex:none;width:25%}.column.is-offset-3,.column.is-offset-3-tablet{margin-left:25%}.column.is-4,.column.is-4-tablet{flex:none;width:33.33333%}.column.is-offset-4,.column.is-offset-4-tablet{margin-left:33.33333%}.column.is-5,.column.is-5-tablet{flex:none;width:41.66667%}.column.is-offset-5,.column.is-offset-5-tablet{margin-left:41.66667%}.column.is-6,.column.is-6-tablet{flex:none;width:50%}.column.is-offset-6,.column.is-offset-6-tablet{margin-left:50%}.column.is-7,.column.is-7-tablet{flex:none;width:58.33333%}.column.is-offset-7,.column.is-offset-7-tablet{margin-left:58.33333%}.column.is-8,.column.is-8-tablet{flex:none;width:66.66667%}.column.is-offset-8,.column.is-offset-8-tablet{margin-left:66.66667%}.column.is-9,.column.is-9-tablet{flex:none;width:75%}.column.is-offset-9,.column.is-offset-9-tablet{margin-left:75%}.column.is-10,.column.is-10-tablet{flex:none;width:83.33333%}.column.is-offset-10,.column.is-offset-10-tablet{margin-left:83.33333%}.column.is-11,.column.is-11-tablet{flex:none;width:91.66667%}.column.is-offset-11,.column.is-offset-11-tablet{margin-left:91.66667%}.column.is-12,.column.is-12-tablet{flex:none;width:100%}.column.is-offset-12,.column.is-offset-12-tablet{margin-left:100%}}@media screen and (max-width:1087px){.column.is-narrow-touch{flex:none}.column.is-full-touch{flex:none;width:100%}.column.is-three-quarters-touch{flex:none;width:75%}.column.is-two-thirds-touch{flex:none;width:66.6666%}.column.is-half-touch{flex:none;width:50%}.column.is-one-third-touch{flex:none;width:33.3333%}.column.is-one-quarter-touch{flex:none;width:25%}.column.is-one-fifth-touch{flex:none;width:20%}.column.is-two-fifths-touch{flex:none;width:40%}.column.is-three-fifths-touch{flex:none;width:60%}.column.is-four-fifths-touch{flex:none;width:80%}.column.is-offset-three-quarters-touch{margin-left:75%}.column.is-offset-two-thirds-touch{margin-left:66.6666%}.column.is-offset-half-touch{margin-left:50%}.column.is-offset-one-third-touch{margin-left:33.3333%}.column.is-offset-one-quarter-touch{margin-left:25%}.column.is-offset-one-fifth-touch{margin-left:20%}.column.is-offset-two-fifths-touch{margin-left:40%}.column.is-offset-three-fifths-touch{margin-left:60%}.column.is-offset-four-fifths-touch{margin-left:80%}.column.is-1-touch{flex:none;width:8.33333%}.column.is-offset-1-touch{margin-left:8.33333%}.column.is-2-touch{flex:none;width:16.66667%}.column.is-offset-2-touch{margin-left:16.66667%}.column.is-3-touch{flex:none;width:25%}.column.is-offset-3-touch{margin-left:25%}.column.is-4-touch{flex:none;width:33.33333%}.column.is-offset-4-touch{margin-left:33.33333%}.column.is-5-touch{flex:none;width:41.66667%}.column.is-offset-5-touch{margin-left:41.66667%}.column.is-6-touch{flex:none;width:50%}.column.is-offset-6-touch{margin-left:50%}.column.is-7-touch{flex:none;width:58.33333%}.column.is-offset-7-touch{margin-left:58.33333%}.column.is-8-touch{flex:none;width:66.66667%}.column.is-offset-8-touch{margin-left:66.66667%}.column.is-9-touch{flex:none;width:75%}.column.is-offset-9-touch{margin-left:75%}.column.is-10-touch{flex:none;width:83.33333%}.column.is-offset-10-touch{margin-left:83.33333%}.column.is-11-touch{flex:none;width:91.66667%}.column.is-offset-11-touch{margin-left:91.66667%}.column.is-12-touch{flex:none;width:100%}.column.is-offset-12-touch{margin-left:100%}}@media screen and (min-width:1088px){.column.is-narrow-desktop{flex:none}.column.is-full-desktop{flex:none;width:100%}.column.is-three-quarters-desktop{flex:none;width:75%}.column.is-two-thirds-desktop{flex:none;width:66.6666%}.column.is-half-desktop{flex:none;width:50%}.column.is-one-third-desktop{flex:none;width:33.3333%}.column.is-one-quarter-desktop{flex:none;width:25%}.column.is-one-fifth-desktop{flex:none;width:20%}.column.is-two-fifths-desktop{flex:none;width:40%}.column.is-three-fifths-desktop{flex:none;width:60%}.column.is-four-fifths-desktop{flex:none;width:80%}.column.is-offset-three-quarters-desktop{margin-left:75%}.column.is-offset-two-thirds-desktop{margin-left:66.6666%}.column.is-offset-half-desktop{margin-left:50%}.column.is-offset-one-third-desktop{margin-left:33.3333%}.column.is-offset-one-quarter-desktop{margin-left:25%}.column.is-offset-one-fifth-desktop{margin-left:20%}.column.is-offset-two-fifths-desktop{margin-left:40%}.column.is-offset-three-fifths-desktop{margin-left:60%}.column.is-offset-four-fifths-desktop{margin-left:80%}.column.is-1-desktop{flex:none;width:8.33333%}.column.is-offset-1-desktop{margin-left:8.33333%}.column.is-2-desktop{flex:none;width:16.66667%}.column.is-offset-2-desktop{margin-left:16.66667%}.column.is-3-desktop{flex:none;width:25%}.column.is-offset-3-desktop{margin-left:25%}.column.is-4-desktop{flex:none;width:33.33333%}.column.is-offset-4-desktop{margin-left:33.33333%}.column.is-5-desktop{flex:none;width:41.66667%}.column.is-offset-5-desktop{margin-left:41.66667%}.column.is-6-desktop{flex:none;width:50%}.column.is-offset-6-desktop{margin-left:50%}.column.is-7-desktop{flex:none;width:58.33333%}.column.is-offset-7-desktop{margin-left:58.33333%}.column.is-8-desktop{flex:none;width:66.66667%}.column.is-offset-8-desktop{margin-left:66.66667%}.column.is-9-desktop{flex:none;width:75%}.column.is-offset-9-desktop{margin-left:75%}.column.is-10-desktop{flex:none;width:83.33333%}.column.is-offset-10-desktop{margin-left:83.33333%}.column.is-11-desktop{flex:none;width:91.66667%}.column.is-offset-11-desktop{margin-left:91.66667%}.column.is-12-desktop{flex:none;width:100%}.column.is-offset-12-desktop{margin-left:100%}}@media screen and (min-width:1280px){.column.is-narrow-widescreen{flex:none}.column.is-full-widescreen{flex:none;width:100%}.column.is-three-quarters-widescreen{flex:none;width:75%}.column.is-two-thirds-widescreen{flex:none;width:66.6666%}.column.is-half-widescreen{flex:none;width:50%}.column.is-one-third-widescreen{flex:none;width:33.3333%}.column.is-one-quarter-widescreen{flex:none;width:25%}.column.is-one-fifth-widescreen{flex:none;width:20%}.column.is-two-fifths-widescreen{flex:none;width:40%}.column.is-three-fifths-widescreen{flex:none;width:60%}.column.is-four-fifths-widescreen{flex:none;width:80%}.column.is-offset-three-quarters-widescreen{margin-left:75%}.column.is-offset-two-thirds-widescreen{margin-left:66.6666%}.column.is-offset-half-widescreen{margin-left:50%}.column.is-offset-one-third-widescreen{margin-left:33.3333%}.column.is-offset-one-quarter-widescreen{margin-left:25%}.column.is-offset-one-fifth-widescreen{margin-left:20%}.column.is-offset-two-fifths-widescreen{margin-left:40%}.column.is-offset-three-fifths-widescreen{margin-left:60%}.column.is-offset-four-fifths-widescreen{margin-left:80%}.column.is-1-widescreen{flex:none;width:8.33333%}.column.is-offset-1-widescreen{margin-left:8.33333%}.column.is-2-widescreen{flex:none;width:16.66667%}.column.is-offset-2-widescreen{margin-left:16.66667%}.column.is-3-widescreen{flex:none;width:25%}.column.is-offset-3-widescreen{margin-left:25%}.column.is-4-widescreen{flex:none;width:33.33333%}.column.is-offset-4-widescreen{margin-left:33.33333%}.column.is-5-widescreen{flex:none;width:41.66667%}.column.is-offset-5-widescreen{margin-left:41.66667%}.column.is-6-widescreen{flex:none;width:50%}.column.is-offset-6-widescreen{margin-left:50%}.column.is-7-widescreen{flex:none;width:58.33333%}.column.is-offset-7-widescreen{margin-left:58.33333%}.column.is-8-widescreen{flex:none;width:66.66667%}.column.is-offset-8-widescreen{margin-left:66.66667%}.column.is-9-widescreen{flex:none;width:75%}.column.is-offset-9-widescreen{margin-left:75%}.column.is-10-widescreen{flex:none;width:83.33333%}.column.is-offset-10-widescreen{margin-left:83.33333%}.column.is-11-widescreen{flex:none;width:91.66667%}.column.is-offset-11-widescreen{margin-left:91.66667%}.column.is-12-widescreen{flex:none;width:100%}.column.is-offset-12-widescreen{margin-left:100%}}@media screen and (min-width:1472px){.column.is-narrow-fullhd{flex:none}.column.is-full-fullhd{flex:none;width:100%}.column.is-three-quarters-fullhd{flex:none;width:75%}.column.is-two-thirds-fullhd{flex:none;width:66.6666%}.column.is-half-fullhd{flex:none;width:50%}.column.is-one-third-fullhd{flex:none;width:33.3333%}.column.is-one-quarter-fullhd{flex:none;width:25%}.column.is-one-fifth-fullhd{flex:none;width:20%}.column.is-two-fifths-fullhd{flex:none;width:40%}.column.is-three-fifths-fullhd{flex:none;width:60%}.column.is-four-fifths-fullhd{flex:none;width:80%}.column.is-offset-three-quarters-fullhd{margin-left:75%}.column.is-offset-two-thirds-fullhd{margin-left:66.6666%}.column.is-offset-half-fullhd{margin-left:50%}.column.is-offset-one-third-fullhd{margin-left:33.3333%}.column.is-offset-one-quarter-fullhd{margin-left:25%}.column.is-offset-one-fifth-fullhd{margin-left:20%}.column.is-offset-two-fifths-fullhd{margin-left:40%}.column.is-offset-three-fifths-fullhd{margin-left:60%}.column.is-offset-four-fifths-fullhd{margin-left:80%}.column.is-1-fullhd{flex:none;width:8.33333%}.column.is-offset-1-fullhd{margin-left:8.33333%}.column.is-2-fullhd{flex:none;width:16.66667%}.column.is-offset-2-fullhd{margin-left:16.66667%}.column.is-3-fullhd{flex:none;width:25%}.column.is-offset-3-fullhd{margin-left:25%}.column.is-4-fullhd{flex:none;width:33.33333%}.column.is-offset-4-fullhd{margin-left:33.33333%}.column.is-5-fullhd{flex:none;width:41.66667%}.column.is-offset-5-fullhd{margin-left:41.66667%}.column.is-6-fullhd{flex:none;width:50%}.column.is-offset-6-fullhd{margin-left:50%}.column.is-7-fullhd{flex:none;width:58.33333%}.column.is-offset-7-fullhd{margin-left:58.33333%}.column.is-8-fullhd{flex:none;width:66.66667%}.column.is-offset-8-fullhd{margin-left:66.66667%}.column.is-9-fullhd{flex:none;width:75%}.column.is-offset-9-fullhd{margin-left:75%}.column.is-10-fullhd{flex:none;width:83.33333%}.column.is-offset-10-fullhd{margin-left:83.33333%}.column.is-11-fullhd{flex:none;width:91.66667%}.column.is-offset-11-fullhd{margin-left:91.66667%}.column.is-12-fullhd{flex:none;width:100%}.column.is-offset-12-fullhd{margin-left:100%}}.columns{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.columns:last-child{margin-bottom:-.75rem}.columns:not(:last-child){margin-bottom:0.75rem}.columns.is-centered{justify-content:center}.columns.is-gapless{margin-left:0;margin-right:0;margin-top:0}.columns.is-gapless>.column{margin:0;padding:0!important}.columns.is-gapless:not(:last-child){margin-bottom:1.5rem}.columns.is-gapless:last-child{margin-bottom:0}.columns.is-mobile{display:flex}.columns.is-multiline{flex-wrap:wrap}.columns.is-vcentered{align-items:center}@media print,screen and (min-width:769px){.columns:not(.is-desktop){display:flex}}@media screen and (min-width:1088px){.columns.is-desktop{display:flex}}.columns.is-variable{--columnGap:0.75rem;margin-left:calc(-1 * var(--columnGap));margin-right:calc(-1 * var(--columnGap))}.columns.is-variable .column{padding-left:var(--columnGap);padding-right:var(--columnGap)}.columns.is-variable.is-0{--columnGap:0rem}.columns.is-variable.is-1{--columnGap:0.25rem}.columns.is-variable.is-2{--columnGap:0.5rem}.columns.is-variable.is-3{--columnGap:0.75rem}.columns.is-variable.is-4{--columnGap:1rem}.columns.is-variable.is-5{--columnGap:1.25rem}.columns.is-variable.is-6{--columnGap:1.5rem}.columns.is-variable.is-7{--columnGap:1.75rem}.columns.is-variable.is-8{--columnGap:2rem}.tile{align-items:stretch;display:block;flex-basis:0;flex-grow:1;flex-shrink:1;min-height:-webkit-min-content;min-height:-moz-min-content;min-height:min-content}.tile.is-ancestor{margin-left:-.75rem;margin-right:-.75rem;margin-top:-.75rem}.tile.is-ancestor:last-child{margin-bottom:-.75rem}.tile.is-ancestor:not(:last-child){margin-bottom:.75rem}.tile.is-child{margin:0!important}.tile.is-parent{padding:.75rem}.tile.is-vertical{flex-direction:column}.tile.is-vertical>.tile.is-child:not(:last-child){margin-bottom:1.5rem!important}@media print,screen and (min-width:769px){.tile:not(.is-child){display:flex}.tile.is-1{flex:none;width:8.33333%}.tile.is-2{flex:none;width:16.66667%}.tile.is-3{flex:none;width:25%}.tile.is-4{flex:none;width:33.33333%}.tile.is-5{flex:none;width:41.66667%}.tile.is-6{flex:none;width:50%}.tile.is-7{flex:none;width:58.33333%}.tile.is-8{flex:none;width:66.66667%}.tile.is-9{flex:none;width:75%}.tile.is-10{flex:none;width:83.33333%}.tile.is-11{flex:none;width:91.66667%}.tile.is-12{flex:none;width:100%}}.hero{align-items:stretch;display:flex;flex-direction:column;justify-content:space-between}.hero .navbar{background:0 0}.hero .tabs ul{border-bottom:none}.hero.is-white{background-color:#fff;color:#0a0a0a}.hero.is-white a:not(.button):not(.dropdown-item):not(.tag),.hero.is-white strong{color:inherit}.hero.is-white .title{color:#0a0a0a}.hero.is-white .subtitle{color:hsla(0,0%,4%,.9)}.hero.is-white .subtitle a:not(.button),.hero.is-white .subtitle strong{color:#0a0a0a}@media screen and (max-width:1087px){.hero.is-white .navbar-menu{background-color:#fff}}.hero.is-white .navbar-item,.hero.is-white .navbar-link{color:hsla(0,0%,4%,.7)}.hero.is-white .navbar-link.is-active,.hero.is-white .navbar-link:hover,.hero.is-white a.navbar-item.is-active,.hero.is-white a.navbar-item:hover{background-color:#f2f2f2;color:#0a0a0a}.hero.is-white .tabs a{color:#0a0a0a;opacity:.9}.hero.is-white .tabs a:hover,.hero.is-white .tabs li.is-active a{opacity:1}.hero.is-white .tabs.is-boxed a,.hero.is-white .tabs.is-toggle a{color:#0a0a0a}.hero.is-white .tabs.is-boxed a:hover,.hero.is-white .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-white .tabs.is-boxed li.is-active a,.hero.is-white .tabs.is-boxed li.is-active a:hover,.hero.is-white .tabs.is-toggle li.is-active a,.hero.is-white .tabs.is-toggle li.is-active a:hover{background-color:#0a0a0a;border-color:#0a0a0a;color:#fff}.hero.is-white.is-bold{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff)}@media screen and (max-width:768px){.hero.is-white.is-bold .navbar-menu{background-image:linear-gradient(141deg,#e6e6e6,#fff 71%,#fff 100%,1)}}.hero.is-black{background-color:#0a0a0a;color:#fff}.hero.is-black a:not(.button):not(.dropdown-item):not(.tag),.hero.is-black strong{color:inherit}.hero.is-black .title{color:#fff}.hero.is-black .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-black .subtitle a:not(.button),.hero.is-black .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-black .navbar-menu{background-color:#0a0a0a}}.hero.is-black .navbar-item,.hero.is-black .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-black .navbar-link.is-active,.hero.is-black .navbar-link:hover,.hero.is-black a.navbar-item.is-active,.hero.is-black a.navbar-item:hover{background-color:#000;color:#fff}.hero.is-black .tabs a{color:#fff;opacity:.9}.hero.is-black .tabs a:hover,.hero.is-black .tabs li.is-active a{opacity:1}.hero.is-black .tabs.is-boxed a,.hero.is-black .tabs.is-toggle a{color:#fff}.hero.is-black .tabs.is-boxed a:hover,.hero.is-black .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-black .tabs.is-boxed li.is-active a,.hero.is-black .tabs.is-boxed li.is-active a:hover,.hero.is-black .tabs.is-toggle li.is-active a,.hero.is-black .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#0a0a0a}.hero.is-black.is-bold{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616)}@media screen and (max-width:768px){.hero.is-black.is-bold .navbar-menu{background-image:linear-gradient(141deg,#000,#0a0a0a 71%,#181616 100%,1)}}.hero.is-light{background-color:#f5f5f5;color:#363636}.hero.is-light a:not(.button):not(.dropdown-item):not(.tag),.hero.is-light strong{color:inherit}.hero.is-light .title{color:#363636}.hero.is-light .subtitle{color:rgba(54,54,54,.9)}.hero.is-light .subtitle a:not(.button),.hero.is-light .subtitle strong{color:#363636}@media screen and (max-width:1087px){.hero.is-light .navbar-menu{background-color:#f5f5f5}}.hero.is-light .navbar-item,.hero.is-light .navbar-link{color:rgba(54,54,54,.7)}.hero.is-light .navbar-link.is-active,.hero.is-light .navbar-link:hover,.hero.is-light a.navbar-item.is-active,.hero.is-light a.navbar-item:hover{background-color:#e8e8e8;color:#363636}.hero.is-light .tabs a{color:#363636;opacity:.9}.hero.is-light .tabs a:hover,.hero.is-light .tabs li.is-active a{opacity:1}.hero.is-light .tabs.is-boxed a,.hero.is-light .tabs.is-toggle a{color:#363636}.hero.is-light .tabs.is-boxed a:hover,.hero.is-light .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-light .tabs.is-boxed li.is-active a,.hero.is-light .tabs.is-boxed li.is-active a:hover,.hero.is-light .tabs.is-toggle li.is-active a,.hero.is-light .tabs.is-toggle li.is-active a:hover{background-color:#363636;border-color:#363636;color:#f5f5f5}.hero.is-light.is-bold{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff)}@media screen and (max-width:768px){.hero.is-light.is-bold .navbar-menu{background-image:linear-gradient(141deg,#dfd8d9,#f5f5f5 71%,#fff 100%,1)}}.hero.is-dark{background-color:#363636;color:#f5f5f5}.hero.is-dark a:not(.button):not(.dropdown-item):not(.tag),.hero.is-dark strong{color:inherit}.hero.is-dark .title{color:#f5f5f5}.hero.is-dark .subtitle{color:hsla(0,0%,96%,.9)}.hero.is-dark .subtitle a:not(.button),.hero.is-dark .subtitle strong{color:#f5f5f5}@media screen and (max-width:1087px){.hero.is-dark .navbar-menu{background-color:#363636}}.hero.is-dark .navbar-item,.hero.is-dark .navbar-link{color:hsla(0,0%,96%,.7)}.hero.is-dark .navbar-link.is-active,.hero.is-dark .navbar-link:hover,.hero.is-dark a.navbar-item.is-active,.hero.is-dark a.navbar-item:hover{background-color:#292929;color:#f5f5f5}.hero.is-dark .tabs a{color:#f5f5f5;opacity:.9}.hero.is-dark .tabs a:hover,.hero.is-dark .tabs li.is-active a{opacity:1}.hero.is-dark .tabs.is-boxed a,.hero.is-dark .tabs.is-toggle a{color:#f5f5f5}.hero.is-dark .tabs.is-boxed a:hover,.hero.is-dark .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-dark .tabs.is-boxed li.is-active a,.hero.is-dark .tabs.is-boxed li.is-active a:hover,.hero.is-dark .tabs.is-toggle li.is-active a,.hero.is-dark .tabs.is-toggle li.is-active a:hover{background-color:#f5f5f5;border-color:#f5f5f5;color:#363636}.hero.is-dark.is-bold{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f)}@media screen and (max-width:768px){.hero.is-dark.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1f191a,#363636 71%,#46403f 100%,1)}}.hero.is-primary{background-color:#00d1b2;color:#fff}.hero.is-primary a:not(.button):not(.dropdown-item):not(.tag),.hero.is-primary strong{color:inherit}.hero.is-primary .title{color:#fff}.hero.is-primary .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-primary .subtitle a:not(.button),.hero.is-primary .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-primary .navbar-menu{background-color:#00d1b2}}.hero.is-primary .navbar-item,.hero.is-primary .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-primary .navbar-link.is-active,.hero.is-primary .navbar-link:hover,.hero.is-primary a.navbar-item.is-active,.hero.is-primary a.navbar-item:hover{background-color:#00b89c;color:#fff}.hero.is-primary .tabs a{color:#fff;opacity:.9}.hero.is-primary .tabs a:hover,.hero.is-primary .tabs li.is-active a{opacity:1}.hero.is-primary .tabs.is-boxed a,.hero.is-primary .tabs.is-toggle a{color:#fff}.hero.is-primary .tabs.is-boxed a:hover,.hero.is-primary .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-primary .tabs.is-boxed li.is-active a,.hero.is-primary .tabs.is-boxed li.is-active a:hover,.hero.is-primary .tabs.is-toggle li.is-active a,.hero.is-primary .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#00d1b2}.hero.is-primary.is-bold{background-image:linear-gradient(141deg,#009e6c,#00d1b2 71%,#00e7eb)}@media screen and (max-width:768px){.hero.is-primary.is-bold .navbar-menu{background-image:linear-gradient(141deg,#009e6c,#00d1b2 71%,#00e7eb 100%,1)}}.hero.is-link{background-color:#3273dc;color:#fff}.hero.is-link a:not(.button):not(.dropdown-item):not(.tag),.hero.is-link strong{color:inherit}.hero.is-link .title{color:#fff}.hero.is-link .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-link .subtitle a:not(.button),.hero.is-link .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-link .navbar-menu{background-color:#3273dc}}.hero.is-link .navbar-item,.hero.is-link .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-link .navbar-link.is-active,.hero.is-link .navbar-link:hover,.hero.is-link a.navbar-item.is-active,.hero.is-link a.navbar-item:hover{background-color:#2366d1;color:#fff}.hero.is-link .tabs a{color:#fff;opacity:.9}.hero.is-link .tabs a:hover,.hero.is-link .tabs li.is-active a{opacity:1}.hero.is-link .tabs.is-boxed a,.hero.is-link .tabs.is-toggle a{color:#fff}.hero.is-link .tabs.is-boxed a:hover,.hero.is-link .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-link .tabs.is-boxed li.is-active a,.hero.is-link .tabs.is-boxed li.is-active a:hover,.hero.is-link .tabs.is-toggle li.is-active a,.hero.is-link .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#3273dc}.hero.is-link.is-bold{background-image:linear-gradient(141deg,#1577c6,#3273dc 71%,#4366e5)}@media screen and (max-width:768px){.hero.is-link.is-bold .navbar-menu{background-image:linear-gradient(141deg,#1577c6,#3273dc 71%,#4366e5 100%,1)}}.hero.is-info{background-color:#209cee;color:#fff}.hero.is-info a:not(.button):not(.dropdown-item):not(.tag),.hero.is-info strong{color:inherit}.hero.is-info .title{color:#fff}.hero.is-info .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-info .subtitle a:not(.button),.hero.is-info .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-info .navbar-menu{background-color:#209cee}}.hero.is-info .navbar-item,.hero.is-info .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-info .navbar-link.is-active,.hero.is-info .navbar-link:hover,.hero.is-info a.navbar-item.is-active,.hero.is-info a.navbar-item:hover{background-color:#118fe4;color:#fff}.hero.is-info .tabs a{color:#fff;opacity:.9}.hero.is-info .tabs a:hover,.hero.is-info .tabs li.is-active a{opacity:1}.hero.is-info .tabs.is-boxed a,.hero.is-info .tabs.is-toggle a{color:#fff}.hero.is-info .tabs.is-boxed a:hover,.hero.is-info .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-info .tabs.is-boxed li.is-active a,.hero.is-info .tabs.is-boxed li.is-active a:hover,.hero.is-info .tabs.is-toggle li.is-active a,.hero.is-info .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#209cee}.hero.is-info.is-bold{background-image:linear-gradient(141deg,#04a6d7,#209cee 71%,#3287f5)}@media screen and (max-width:768px){.hero.is-info.is-bold .navbar-menu{background-image:linear-gradient(141deg,#04a6d7,#209cee 71%,#3287f5 100%,1)}}.hero.is-success{background-color:#23d160;color:#fff}.hero.is-success a:not(.button):not(.dropdown-item):not(.tag),.hero.is-success strong{color:inherit}.hero.is-success .title{color:#fff}.hero.is-success .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-success .subtitle a:not(.button),.hero.is-success .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-success .navbar-menu{background-color:#23d160}}.hero.is-success .navbar-item,.hero.is-success .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-success .navbar-link.is-active,.hero.is-success .navbar-link:hover,.hero.is-success a.navbar-item.is-active,.hero.is-success a.navbar-item:hover{background-color:#20bc56;color:#fff}.hero.is-success .tabs a{color:#fff;opacity:.9}.hero.is-success .tabs a:hover,.hero.is-success .tabs li.is-active a{opacity:1}.hero.is-success .tabs.is-boxed a,.hero.is-success .tabs.is-toggle a{color:#fff}.hero.is-success .tabs.is-boxed a:hover,.hero.is-success .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-success .tabs.is-boxed li.is-active a,.hero.is-success .tabs.is-boxed li.is-active a:hover,.hero.is-success .tabs.is-toggle li.is-active a,.hero.is-success .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#23d160}.hero.is-success.is-bold{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a)}@media screen and (max-width:768px){.hero.is-success.is-bold .navbar-menu{background-image:linear-gradient(141deg,#12af2f,#23d160 71%,#2ce28a 100%,1)}}.hero.is-warning{background-color:#ffdd57;color:rgba(0,0,0,.7)}.hero.is-warning a:not(.button):not(.dropdown-item):not(.tag),.hero.is-warning strong{color:inherit}.hero.is-warning .title{color:rgba(0,0,0,.7)}.hero.is-warning .subtitle{color:rgba(0,0,0,.9)}.hero.is-warning .subtitle a:not(.button),.hero.is-warning .subtitle strong{color:rgba(0,0,0,.7)}@media screen and (max-width:1087px){.hero.is-warning .navbar-menu{background-color:#ffdd57}}.hero.is-warning .navbar-item,.hero.is-warning .navbar-link{color:rgba(0,0,0,.7)}.hero.is-warning .navbar-link.is-active,.hero.is-warning .navbar-link:hover,.hero.is-warning a.navbar-item.is-active,.hero.is-warning a.navbar-item:hover{background-color:#ffd83d;color:rgba(0,0,0,.7)}.hero.is-warning .tabs a{color:rgba(0,0,0,.7);opacity:.9}.hero.is-warning .tabs a:hover,.hero.is-warning .tabs li.is-active a{opacity:1}.hero.is-warning .tabs.is-boxed a,.hero.is-warning .tabs.is-toggle a{color:rgba(0,0,0,.7)}.hero.is-warning .tabs.is-boxed a:hover,.hero.is-warning .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-warning .tabs.is-boxed li.is-active a,.hero.is-warning .tabs.is-boxed li.is-active a:hover,.hero.is-warning .tabs.is-toggle li.is-active a,.hero.is-warning .tabs.is-toggle li.is-active a:hover{background-color:rgba(0,0,0,.7);border-color:rgba(0,0,0,.7);color:#ffdd57}.hero.is-warning.is-bold{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70)}@media screen and (max-width:768px){.hero.is-warning.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ffaf24,#ffdd57 71%,#fffa70 100%,1)}}.hero.is-danger{background-color:#ff3860;color:#fff}.hero.is-danger a:not(.button):not(.dropdown-item):not(.tag),.hero.is-danger strong{color:inherit}.hero.is-danger .title{color:#fff}.hero.is-danger .subtitle{color:hsla(0,0%,100%,.9)}.hero.is-danger .subtitle a:not(.button),.hero.is-danger .subtitle strong{color:#fff}@media screen and (max-width:1087px){.hero.is-danger .navbar-menu{background-color:#ff3860}}.hero.is-danger .navbar-item,.hero.is-danger .navbar-link{color:hsla(0,0%,100%,.7)}.hero.is-danger .navbar-link.is-active,.hero.is-danger .navbar-link:hover,.hero.is-danger a.navbar-item.is-active,.hero.is-danger a.navbar-item:hover{background-color:#ff1f4b;color:#fff}.hero.is-danger .tabs a{color:#fff;opacity:.9}.hero.is-danger .tabs a:hover,.hero.is-danger .tabs li.is-active a{opacity:1}.hero.is-danger .tabs.is-boxed a,.hero.is-danger .tabs.is-toggle a{color:#fff}.hero.is-danger .tabs.is-boxed a:hover,.hero.is-danger .tabs.is-toggle a:hover{background-color:hsla(0,0%,4%,.1)}.hero.is-danger .tabs.is-boxed li.is-active a,.hero.is-danger .tabs.is-boxed li.is-active a:hover,.hero.is-danger .tabs.is-toggle li.is-active a,.hero.is-danger .tabs.is-toggle li.is-active a:hover{background-color:#fff;border-color:#fff;color:#ff3860}.hero.is-danger.is-bold{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257)}@media screen and (max-width:768px){.hero.is-danger.is-bold .navbar-menu{background-image:linear-gradient(141deg,#ff0561,#ff3860 71%,#ff5257 100%,1)}}.hero.is-small .hero-body{padding-bottom:1.5rem;padding-top:1.5rem}@media print,screen and (min-width:769px){.hero.is-medium .hero-body{padding-bottom:9rem;padding-top:9rem}}@media print,screen and (min-width:769px){.hero.is-large .hero-body{padding-bottom:18rem;padding-top:18rem}}.hero.is-fullheight .hero-body,.hero.is-halfheight .hero-body{align-items:center;display:flex}.hero.is-fullheight .hero-body>.container,.hero.is-halfheight .hero-body>.container{flex-grow:1;flex-shrink:1}.hero.is-halfheight{min-height:50vh}.hero.is-fullheight{min-height:100vh}.hero-video{overflow:hidden}.hero-video video{left:50%;min-height:100%;min-width:100%;position:absolute;top:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.hero-video.is-transparent{opacity:.3}@media screen and (max-width:768px){.hero-video{display:none}}.hero-buttons{margin-top:1.5rem}@media screen and (max-width:768px){.hero-buttons .button{display:flex}.hero-buttons .button:not(:last-child){margin-bottom:.75rem}}@media print,screen and (min-width:769px){.hero-buttons{display:flex;justify-content:center}.hero-buttons .button:not(:last-child){margin-right:1.5rem}}.hero-foot,.hero-head{flex-grow:0;flex-shrink:0}.hero-body{flex-grow:1;flex-shrink:0}.hero-body,.section{padding:3rem 1.5rem}@media screen and (min-width:1088px){.section.is-medium{padding:9rem 1.5rem}.section.is-large{padding:18rem 1.5rem}}.footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}", ""]);

// exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1098);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("34efca0e", content, true, {});

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".button.is-primary{background-color:#456997}.columns{padding:10px}.custom_table{padding-bottom:35px}.custom_table .vgt-wrap__footer{background:transparent;border:transparent}.custom_table .vgt-table thead th{background:transparent!important}.custom_table .vgt-global-search{background:transparent!important;border:none;width:100%}.custom_table .vgt-global-search input{height:40px;background-color:hsla(0,0%,100%,.86)}.custom_table .vgt-global-search__input .input__icon .magnifying-glass{fill:#5e5b5b}.custom_table .vgt-global-search__input .input__icon .magnifying-glass:before{background-color:#5e5b5b}.custom_table .line-numbers{display:none}.custom_table .vgt-table thead th{border:none!important;border-bottom:2px solid #817f7f!important}.custom_table .vgt-table{border:none!important;background-color:transparent}.custom_table .vgt-table.bordered td{border:none;border-bottom:1px solid #c9bebe}.custom_table .vgt-table thead th.sorting-desc:after{border-top:6px solid #4d5fe4}.custom_table .vdp-datepicker{padding-left:10px!important;text-align:center}", ""]);

// exports


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("038586c1", content, true, {});

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".custon-w-m{width:95%!important}@media screen and (min-width:1370px){.custon-w-m{width:70%!important}}.button_address_copy{display:flex;flex-direction:column;justify-content:center;align-items:center;background:#e3e3e3;margin-left:50px;margin-right:50px;padding:10px 0;word-break:break-all;border-radius:5px}.button_address_copy:active{background-color:#ffebcd!important}@media screen and (max-width:1200px){.button_address_copy{font-size:.7rem;margin-left:10px;margin-right:10px}}.self_end{align-self:end}.self_center{align-self:center}.tal_c{text-align:center}.tal_l{text-align:left!important}.tal_l_b{text-align:center}@media screen and (min-width:768px){.tal_l_b{text-align:left}}.tal_r{text-align:right}@media screen and (min-width:768px){.tal_r_b{text-align:right}}.fat{font-weight:600}.capitalize{text-transform:capitalize}.underline{text-decoration:underline!important}.upper{text-transform:uppercase}.word_break_no{word-break:normal!important}.word_break_word{word-wrap:break-word}.text_yellow{color:#ffe62e!important}.grey_ntx{color:#61717e}.text_grey{color:#80817b!important}.text_purple{color:#342365}.fs_small{font-size:.8em}.fs_big{font-size:1.3em!important}.fs_two_r{font-size:2rem!important}.fs_three_r{font-size:3rem!important}.fs_0001r{font-size:.8rem!important}.fs_00r{font-size:1rem!important}.fs_03r{font-size:1.1rem!important}.fs_05r{font-size:1.3rem!important}.fs_18r{font-size:1.5rem!important}@media screen and (max-width:768px){.fs_18r{font-size:1rem!important}}.fs_10r{font-size:2.5rem!important}.fs_small_wm{font-size:100%!important}@media screen and (max-width:768px){.fs_small_wm{font-size:1em!important}}.over_flow{overflow:auto!important}@media screen and (max-width:1200px){.over_flow{overflow:inherit!important}}.margin-mobile-right{margin-right:30px!important}@media screen and (max-width:768px){.margin-mobile-right{margin-right:0!important}}.font-wb-tutorial{font-size:1rem!important}@media screen and (max-width:768px){.font-wb-tutorial{font-size:.8rem!important}}.pointer{cursor:pointer}.minH100{min-height:100vh}.h100{height:100%}.h90{height:90%}.w10{width:10%}.w20{width:20%}.w100{width:100%}.w80{width:80%}.mw60{max-width:60%}.mw80{max-width:80%}.w90{width:90%}.mw100{max-width:100%}.combo_0,.combo_1{display:block;margin-left:auto;margin-right:auto}.combo_1{max-width:100%}.flex_input_label{display:flex;flex-direction:column;margin-top:20px}.flex_input_label input{border:none;height:45px;padding:10px;font-size:15px;width:100%}.flex_input_label:first-child{margin-top:0}.p0{padding:0!important}.pb0{padding-bottom:0!important}.pt0{padding-top:0!important}.p10{padding:10px!important}.p20{padding:20px!important}.p0_b{padding-bottom:0!important}.p0_t{padding-top:0!important}.p0_l{padding-left:0}.p5_r{padding-right:5px}.p5_l{padding-left:5px}.p10t{padding-top:10px!important}.p10b{padding-bottom:10px}.p30-l-r{padding-left:30px!important;padding-right:30px!important}.p20-15tb{padding-bottom:20px;padding-top:15px}.p20tb{padding-bottom:20px!important;padding-top:20px!important}.p-component-card{padding:15px 50px 0}.dis_inb{display:inline-block}.dis_b{display:block}.full_inline a,.full_inline img,.full_inline p{display:inline-block}@media screen and (max-width:768px){.m_hidden{display:none!important}}.m0{margin:0!important}.m0_b{margin-bottom:0!important}.mauto{margin-right:auto}.mauto,.mauto_l{margin-left:auto}.m2_t,.m10_t{margin-top:5%}.m8_t{margin-top:8%}.m25_t{margin-top:25%!important}@media screen and (max-width:1000px){.m20_top_mobile{margin-top:40%}}.other_currencies{font-size:.8rem;text-decoration:underline;color:#f77f0d;cursor:pointer;font-weight:400}@media screen and (max-width:300px){.other_currencies{font-size:.6rem!important}}.mb_card_grey{border-bottom:2px solid #c7c7c7!important}.closed_card{min-height:90px;font-size:1.1rem!important;padding-right:0}@media screen and (max-width:400px){.closed_card{font-size:1rem!important}}@media screen and (max-width:300px){.closed_card{font-size:.9rem!important}.closed_card .hide{display:none}}.closed_card .title_card{display:flex;align-items:center;justify-content:start;width:40%}@media screen and (max-width:300px){.closed_card .title_card{width:50%}}@media screen and (max-width:1000px){.m10_top_mobile{margin-top:10%}}.m10_top_mobile_ajust{margin-left:15%;margin-top:5%}@media screen and (max-width:1000px){.m10_top_mobile_ajust{margin-left:0;margin-top:10%}}.mobile_size_font{font-size:.9rem}@media screen and (max-width:1000px){.mobile_size_font{font-size:.6rem}}.m40_t{margin-top:40%}.m5_t{margin-top:5px}.m9_t{margin-top:9px}.m13_t{margin-top:13px}.m9_l{margin-left:9px}.m15_l,.m15_l_r{margin-left:15px}.m15_l_r{margin-right:15px}.mr_10{margin-right:10px}.mr_5{margin-right:5px}.m4_b{margin-bottom:4px!important}.m20_b{margin-bottom:20px!important}.m40_b{margin-bottom:40px!important}.m_auto{margin:auto}.mb_inherit{margin-bottom:inherit}.val_m{vertical-align:middle}.val_t{vertical-align:top}.val_sub{vertical-align:sub}.val_txtb{vertical-align:text-bottom}.flex_end{display:flex;align-items:flex-end}.flex_contant_center{display:flex;justify-content:center}.justify_between_ai_center,.justify_content_between{display:flex;justify-content:space-between}.justify_between_ai_center{align-items:flex-end}.space_v_sm{display:block;height:15px}", ""]);

// exports


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("4f04784e", content, true, {});

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(208);
exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, ".custon-w-m{width:95%!important}@media screen and (min-width:1370px){.custon-w-m{width:70%!important}}.button_address_copy{display:flex;flex-direction:column;justify-content:center;align-items:center;background:#e3e3e3;margin-left:50px;margin-right:50px;padding:10px 0;word-break:break-all;border-radius:5px}.button_address_copy:active{background-color:#ffebcd!important}@media screen and (max-width:1200px){.button_address_copy{font-size:.7rem;margin-left:10px;margin-right:10px}}.self_end{align-self:end}.self_center{align-self:center}.tal_c{text-align:center}.tal_l{text-align:left!important}.tal_l_b{text-align:center}@media screen and (min-width:768px){.tal_l_b{text-align:left}}.tal_r{text-align:right}@media screen and (min-width:768px){.tal_r_b{text-align:right}}.fat{font-weight:600}.capitalize{text-transform:capitalize}.underline{text-decoration:underline!important}.upper{text-transform:uppercase}.word_break_no{word-break:normal!important}.word_break_word{word-wrap:break-word}.text_yellow{color:#ffe62e!important}.grey_ntx{color:#61717e}.text_grey{color:#80817b!important}.text_purple{color:#342365}.fs_small{font-size:.8em}.fs_big{font-size:1.3em!important}.fs_two_r{font-size:2rem!important}.fs_three_r{font-size:3rem!important}.fs_0001r{font-size:.8rem!important}.fs_00r{font-size:1rem!important}.fs_03r{font-size:1.1rem!important}.fs_05r{font-size:1.3rem!important}.fs_18r{font-size:1.5rem!important}@media screen and (max-width:768px){.fs_18r{font-size:1rem!important}}.fs_10r{font-size:2.5rem!important}.fs_small_wm{font-size:100%!important}@media screen and (max-width:768px){.fs_small_wm{font-size:1em!important}}.over_flow{overflow:auto!important}@media screen and (max-width:1200px){.over_flow{overflow:inherit!important}}.margin-mobile-right{margin-right:30px!important}@media screen and (max-width:768px){.margin-mobile-right{margin-right:0!important}}.font-wb-tutorial{font-size:1rem!important}@media screen and (max-width:768px){.font-wb-tutorial{font-size:.8rem!important}}.pointer{cursor:pointer}.minH100{min-height:100vh}.h100{height:100%}.h90{height:90%}.w10{width:10%}.w20{width:20%}.w100{width:100%}.w80{width:80%}.mw60{max-width:60%}.mw80{max-width:80%}.w90{width:90%}.mw100{max-width:100%}.combo_0,.combo_1{display:block;margin-left:auto;margin-right:auto}.combo_1{max-width:100%}.flex_input_label{display:flex;flex-direction:column;margin-top:20px}.flex_input_label input{border:none;height:45px;padding:10px;font-size:15px;width:100%}.flex_input_label:first-child{margin-top:0}.p0{padding:0!important}.pb0{padding-bottom:0!important}.pt0{padding-top:0!important}.p10{padding:10px!important}.p20{padding:20px!important}.p0_b{padding-bottom:0!important}.p0_t{padding-top:0!important}.p0_l{padding-left:0}.p5_r{padding-right:5px}.p5_l{padding-left:5px}.p10t{padding-top:10px!important}.p10b{padding-bottom:10px}.p30-l-r{padding-left:30px!important;padding-right:30px!important}.p20-15tb{padding-bottom:20px;padding-top:15px}.p20tb{padding-bottom:20px!important;padding-top:20px!important}.p-component-card{padding:15px 50px 0}.dis_inb{display:inline-block}.dis_b{display:block}.full_inline a,.full_inline img,.full_inline p{display:inline-block}@media screen and (max-width:768px){.m_hidden{display:none!important}}.m0{margin:0!important}.m0_b{margin-bottom:0!important}.mauto{margin-right:auto}.mauto,.mauto_l{margin-left:auto}.m2_t,.m10_t{margin-top:5%}.m8_t{margin-top:8%}.m25_t{margin-top:25%!important}@media screen and (max-width:1000px){.m20_top_mobile{margin-top:40%}}.other_currencies{font-size:.8rem;text-decoration:underline;color:#f77f0d;cursor:pointer;font-weight:400}@media screen and (max-width:300px){.other_currencies{font-size:.6rem!important}}.mb_card_grey{border-bottom:2px solid #c7c7c7!important}.closed_card{min-height:90px;font-size:1.1rem!important;padding-right:0}@media screen and (max-width:400px){.closed_card{font-size:1rem!important}}@media screen and (max-width:300px){.closed_card{font-size:.9rem!important}.closed_card .hide{display:none}}.closed_card .title_card{display:flex;align-items:center;justify-content:start;width:40%}@media screen and (max-width:300px){.closed_card .title_card{width:50%}}@media screen and (max-width:1000px){.m10_top_mobile{margin-top:10%}}.m10_top_mobile_ajust{margin-left:15%;margin-top:5%}@media screen and (max-width:1000px){.m10_top_mobile_ajust{margin-left:0;margin-top:10%}}.mobile_size_font{font-size:.9rem}@media screen and (max-width:1000px){.mobile_size_font{font-size:.6rem}}.m40_t{margin-top:40%}.m5_t{margin-top:5px}.m9_t{margin-top:9px}.m13_t{margin-top:13px}.m9_l{margin-left:9px}.m15_l,.m15_l_r{margin-left:15px}.m15_l_r{margin-right:15px}.mr_10{margin-right:10px}.mr_5{margin-right:5px}.m4_b{margin-bottom:4px!important}.m20_b{margin-bottom:20px!important}.m40_b{margin-bottom:40px!important}.m_auto{margin:auto}.mb_inherit{margin-bottom:inherit}.val_m{vertical-align:middle}.val_t{vertical-align:top}.val_sub{vertical-align:sub}.val_txtb{vertical-align:text-bottom}.flex_end{display:flex;align-items:flex-end}.flex_contant_center{display:flex;justify-content:center}.justify_between_ai_center,.justify_content_between{display:flex;justify-content:space-between}.justify_between_ai_center{align-items:flex-end}.space_v_sm{display:block;height:15px}.custom-flex{display:flex}.card-boder-bg{border:1px solid #dddbdb;background-color:#f5f5f5}.block_center{display:block;margin-left:auto;margin-right:auto}.t_center{text-align:center}.inblock{display:inline-block}.regular_section{padding-top:40px;padding-bottom:40px}.cointainer_lg,.cointainer_md,.cointainer_sm,.cointainer_xl,.cointainer_xs{max-width:100%}.cointainer_xs{width:450px}.cointainer_sm{width:600px;width:638px}.cointainer_md{width:700px}.cointainer_lg{width:1100px}.cointainer_xl{width:1600px}.cointainer_full{width:100%}.template_sub_menu{background-color:#eaf3ea!important;padding:15px 5px}.template_sub_menu a{font-size:.9em;color:#535768;margin:2px;text-decoration:none}.languageSelector{width:auto;border:none;cursor:pointer;padding:0 5px!important;font-size:1rem!important}.languageSelector select{background-color:transparent!important;color:#fff!important;border:none}.languageSelector option{color:#4d4b4b;background-color:transparent}.languageSelector li{color:#fff}.component_info{width:11px;height:12px;background-color:#fff;display:inline-block;text-align:center;color:#47576f;border-radius:0;vertical-align:middle;font-size:9px;border-radius:28%;cursor:pointer}.component_info svg{width:auto;height:90%;padding:1px}.component_info_data{background-color:rgba(17,43,129,.877);position:absolute;margin-bottom:13%;color:#fff;text-align:center;border-radius:3px;max-width:100%;padding:2px 3px;padding:10px}.component_info_data a{color:#76ca7d}.icon_class_06{width:25px;height:25px;display:inline-block;fill:#535768;color:#535768}.icon_class_06 svg{width:auto;height:auto}.icon_class_03{width:10px;height:10px;display:inline-block;fill:#535768;color:#535768}.icon_class_03 svg{width:auto;height:auto}.icon_class_05{width:12px;height:12px;display:inline-block;fill:#535768;color:#535768}.icon_class_05 svg{width:auto;height:auto}.icon_class_arrow_balance{width:10px;height:20px;display:inline-block;fill:#a2a2a2;color:#a2a2a2}.icon_class_arrow_balance svg{width:100%;height:100%}.icon_class_15{width:15px;height:15px;display:inline-block;fill:\"#fff\";color:\"#fff\"}.icon_class_15 svg{width:100%;height:100%}.icon_class_1{width:20px;height:20px;display:inline-block;fill:#535768;color:#535768}.icon_class_1 svg{width:100%;height:100%}.icon_class_2_5{width:25px;height:25px;display:inline-block;fill:#535768;color:#535768}.icon_class_2_5 svg{width:100%;height:100%}.icon_class_2{width:35px;height:35px;display:inline-block;fill:#535768;color:#535768}.icon_class_2 svg{width:100%;height:100%}.icon_class_3{width:50px;height:50px;display:inline-block;fill:#535768;color:#535768}.icon_class_3 svg{width:100%;height:100%}.icon_class_10{width:80px;height:80px;display:inline-block;fill:#535768;color:#535768}.icon_class_10 svg{width:100%;height:100%}.icon_class_4{display:inline-block;fill:#535768;color:#535768;padding:3px}.icon_class_4 svg{height:13px}.icon_class_7{display:inline-block;fill:#535768;color:#535768;padding:3px}.icon_class_7 svg{height:20px}.icon_class_8l{height:20px;display:block}.icon_class_8l svg{height:20px;max-width:100%;width:90px}.icon_class_9l{display:block}.icon_class_9l svg{max-width:100%;height:80px}.component_title_lg{font-size:2.2em;margin-bottom:30px}.component_title_md{font-size:1.6em;margin-bottom:8px;text-transform:capitalize}@media screen and (max-width:1370px){.component_title_md{font-size:1.3em}}.text_xl{font-size:1.6em!important}@media screen and (max-width:1370px){.text_xl{font-size:1.3em!important}}.text_lg{font-size:1.3em!important}.text_sm{font-size:.8em!important}.text_normal{font-size:1.1rem}@media screen and (max-width:768px){.m_text_sm{font-size:.8em!important}}.text_ssm{font-size:.7em!important}@media screen and (max-width:300px){.ft_small{font-size:.8rem!important}}.split_half_text{padding:20px 0}.split_half_text p span{margin:5px 0;display:inline-block;width:49%}.component_main_button,.uppercase{text-transform:uppercase}.component_main_button{border:none;margin-top:5px;padding:12px 30px;min-width:124px;width:auto;text-align:center;color:#fff;font-weight:700;cursor:pointer}.component_main_button:hover{color:#fff}.component_super_button{width:100%;padding:30px 10px;border:none;color:#fff;cursor:pointer;font-weight:700;font-size:1em}.component_downloader_button{display:block;text-align:center;cursor:pointer;width:330px;max-width:100%;padding:22px 5px!important}.simple_button{border:none;padding:8px;text-transform:uppercase;background:#b7e3dc;color:#727481;opacity:.8;cursor:pointer}.simple_button:hover{opacity:1}.simple_button_selected{background:#6dbfc2;color:#414141;opacity:1}.component_cancel_button{font-size:2em;color:#000}.component_cancel_button:hover{color:#211c54}.tab_column_margin_fix{margin-bottom:-3px;padding-right:5px!important;margin-top:1.6%}.tab_button{padding:0 10px;min-width:110px;text-align:center;min-height:40px;font-weight:600;box-sizing:border-box;box-shadow:none;border:0;border-radius:5px 5px 0 0;cursor:pointer}.inactive_tab_button{background-color:#dadada;color:#999;border-bottom:1px solid #f6f6f6;margin-bottom:1px}.active_tab_button{margin-bottom:0;background-color:#f8f8f8;color:#534a4a;border:1px solid #d8d6d6;border-bottom:1px solid transparent}.chart{max-width:100%;display:block;margin-left:auto;margin-right:auto;margin-top:30px}.chart .chart_under_label{margin-top:2px}.form_container{padding:25px 15px;width:450px;max-width:98%}.form_container .form_block{width:95%;margin-top:25px}.form_container .regular_input{width:100%;padding:12px 10px}.form_container .regular_submit{width:100%;padding:16px 10px;border-radius:0;border:none;background-color:#211c54;color:#fff;cursor:pointer}.form_container .regular_submit:hover{background-color:#33296e}.form_container .regular_submit:disabled{background-color:grey;cursor:not-allowed}.form_container .form_white_border{background-color:transparent;border:1px solid #fff}.form_container .form_white_border:disabled{background-color:#696969}.form_container .form_block_checkbox{padding:10px;text-align:left}.form_container .form_block_checkbox .label_box{display:inline-block!important;width:19px!important;vertical-align:text-top;font-weight:500!important;margin-top:0!important;cursor:pointer}.form_container .form_block_checkbox .label_text{display:inline-block;width:250px;max-width:90%;vertical-align:top;width:100%;text-align:left}.form_container .form_block_checkbox label input{display:none}.form_container .form_block_checkbox label span{position:relative;height:15px;width:15px;border-radius:3px;border:1px solid #fff;display:flex;align-items:center;justify-content:center;top:3px}.form_container .form_block_checkbox [type=checkbox]:checked+span:before{content:\"\\2714\"}.form_container .form_block_checkbox p{display:inline-block;vertical-align:middle}.component_no_space{height:0}.component_border_bottom{height:4px;margin-top:-4px;margin-bottom:15px;width:100%;text-align:center;display:block}.component_border_bottom span{border-bottom:2px dotted #c7c4c4;height:2px;display:block;margin-left:auto;margin-right:auto}.component_normal_input_block{display:inline-block}.component_normal_input_block input,.component_normal_input_block select{height:40px;background-color:transparent;border:1px solid grey}.component_normal_input_block select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:url(" + escape(__webpack_require__(148)) + ") 96%/15% no-repeat hsla(0,0%,100%,.1);background-size:contain;padding-right:35px;background-position:100%;padding-left:5px}.component_normal_input_block select:disabled{background:#fff!important}.component_normal_input_block .vdp-datepicker input{padding-left:14px}.component_full_input_block{display:block}.component_full_input_block label{padding:10px 0;display:block}.component_full_input_block input,.component_full_input_block select{height:50px;background-color:transparent;border:1px solid grey;width:100%;padding:10px}.component_full_input_block select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background:url(" + escape(__webpack_require__(148)) + ") 96%/15% no-repeat hsla(0,0%,100%,.1);background-size:contain;padding-right:90px}.fake_input{display:block;background-color:#f3f3f3;height:51px;padding-top:10px;border:1px solid #ded8d8;margin-top:0}.componenet_card_tabs{width:95%;margin-left:auto;margin-right:42px;text-align:right}.componenet_card_tabs .componenet_card_tab{display:inline-block;text-align:center;padding:5px 5px 3px;background-color:#e4e4e4;margin-bottom:-1px;border:1px solid #d8d6d6;border-radius:5px 5px 0 0;color:#9c9a9a;max-width:32%}@media screen and (max-width:768px){.componenet_card_tabs .componenet_card_tab{width:100%;font-size:9px!important}}.componenet_card_tabs .componenet_card_tab_selected{background-color:#f6f6f6;background-color:#fcfcfc;color:#727171;border-bottom:1px solid #f6f6f6;border-bottom:1px solid #fcfcfc}.component_card{height:100%;margin:0;border-radius:8px;width:98%}.component_card .component_card_block{display:block;width:300px;max-width:100%}.component_card .component_card_block .component_card_block_select{padding:2px 10px;background-color:transparent;border:1px solid #c5bcbc;border-radius:7px;width:180px;max-width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:url(" + escape(__webpack_require__(148)) + ") 96%/15% no-repeat hsla(0,0%,100%,.1)}.component_card .component_card_block .card_block_dropdown_icon_main{vertical-align:middle}.component_card .component_card_block .custum_column_1{width:20px}.component_card .component_card_border_right{border-right:1px solid #d8d6d6}.component_card .component_card_border_bottom{border-bottom:1px solid #d8d6d6}.component_card .component_card_border_bottom:last-child{border-bottom:none}.component_card .component_card_ball{width:12px;height:12px;display:inline-block;border-radius:50%;margin-right:3px}.component_card .component_card_coin .icon_class_1{vertical-align:middle}.component_card .component_card_coin .short,.component_card .component_card_coin .value{vertical-align:super;font-size:.8em;vertical-align:middle}.component_card .component_card_coin .value{min-width:120px;display:inline-block;text-align:right;padding-right:10px}.component_card .component_card_coin .short{min-width:50px;text-align:left;display:inline-block;text-transform:uppercase}.component_card .component_card_coin .balance_text{vertical-align:middle;padding-left:20px}.component_card_tab_select{background:#ebebeb;display:block;width:100%;text-align:center}.component_card_tab_select button{padding-top:20px;width:49%;margin:0 1px;display:inline-block;padding:0;min-height:40px;margin-bottom:-4px;border-radius:10px 10px 0 0;margin-top:1px;border:none;background-color:transparent;font-size:1.3em;font-weight:600;cursor:pointer;color:#93949b}@media screen and (max-width:768px){.component_card_tab_select button{width:calc(49% - 3px);font-size:.9em}}.component_card_tab_select .component_card_tab_select_selected{background-color:#fcfcfc;border:none;color:#424b7d}.background_{background-size:contain;background-position:bottom;background-repeat:no-repeat}.background_BLU,.background_blu{background-image:url(" + escape(__webpack_require__(1103)) + ")}.background_BTC,.background_btc{background-image:url(" + escape(__webpack_require__(1104)) + ")}.background_BCH{background-image:url(" + escape(__webpack_require__(1105)) + ")}.background_ADA{background-image:url(" + escape(__webpack_require__(1106)) + ")}.background_ETH,.background_eth{background-image:url(" + escape(__webpack_require__(457)) + ")}.background_ETC,.background_etc{background-image:url(" + escape(__webpack_require__(1107)) + ")}.background_DASH{background-image:url(" + escape(__webpack_require__(1108)) + ")}.background_EOS{background-image:url(" + escape(__webpack_require__(1109)) + ")}.background_LTC{background-image:url(" + escape(__webpack_require__(1110)) + ")}.background_XMR{background-image:url(" + escape(__webpack_require__(1111)) + ")}.background_MSTND,.background_operations,.background_OPERATIONS,.background_Operations,.background_OTC{background-image:url(" + escape(__webpack_require__(1112)) + ")}.background_ARB{background-image:url(" + escape(__webpack_require__(458)) + ")}.background_XRP{background-image:url(" + escape(__webpack_require__(1113)) + ")}.background_SMART{background-image:url(" + escape(__webpack_require__(1114)) + ")}.background_XLM{background-image:url(" + escape(__webpack_require__(459)) + ")}.background_XEM{background-image:url(" + escape(__webpack_require__(1115)) + ")}.background_USDT{background-image:url(" + escape(__webpack_require__(136)) + ")}.background_TUSD,.background_tusd{background-image:url(" + escape(__webpack_require__(136)) + ")}.background_USDT,.background_usdt{background-image:url(" + escape(__webpack_require__(29)) + ")}.background_ZCR{background-image:url(" + escape(__webpack_require__(1116)) + ")}.background_IOTA{background-image:url(" + escape(__webpack_require__(1117)) + ")}.background_BRL{background-image:url(" + escape(__webpack_require__(1118)) + ")}.background_TRX{background-image:url(" + escape(__webpack_require__(1119)) + ")}.background_BNB{background-image:url(" + escape(__webpack_require__(1120)) + ")}.background_LUNA{background-image:url(" + escape(__webpack_require__(1121)) + ")}.background_DASHG{background-image:url(" + escape(__webpack_require__(1122)) + ")}.background_XBI{background-image:url(" + escape(__webpack_require__(1123)) + ")}.background_DKPC{background-image:url(" + escape(__webpack_require__(1124)) + ")}.background_C2P{background-image:url(" + escape(__webpack_require__(1125)) + ")}.background_NXS{background-image:url(" + escape(__webpack_require__(460)) + ");background-image:url(" + escape(__webpack_require__(460)) + ")}.background_ARB{background-image:url(" + escape(__webpack_require__(458)) + ")}.background_white_BTC,.background_white_btc{background-image:url(" + escape(__webpack_require__(1126)) + ")}.background_white_PIX,.background_white_pix{background-image:url(" + escape(__webpack_require__(1127)) + ")}.background_MANA,.background_mana{background-image:url(" + escape(__webpack_require__(1128)) + ")}.background_white_ETH,.background_white_eth{background-image:url(" + escape(__webpack_require__(457)) + ")}.background_white_TUSD,.background_white_tusd{background-image:url(" + escape(__webpack_require__(1129)) + ")}.background_white_USDT,.background_white_usdt{background-image:url(" + escape(__webpack_require__(29)) + ")}.background_white_RAS,.background_white_ras{background-image:url(" + escape(__webpack_require__(1130)) + ")}.background_ras,.background_RAS{background-image:url(" + escape(__webpack_require__(1131)) + ")}.background_HKD,.background_hkd{background-image:url(" + escape(__webpack_require__(1132)) + ")}.background_CAD,.background_cad{background-image:url(" + escape(__webpack_require__(1133)) + ")}.background_AUD,.background_aud{background-image:url(" + escape(__webpack_require__(1134)) + ")}.background_ZAR,.background_zar{background-image:url(" + escape(__webpack_require__(1135)) + ")}.background_EUR,.background_eur{background-image:url(" + escape(__webpack_require__(1136)) + ")}.background_GBP,.background_gbp{background-image:url(" + escape(__webpack_require__(1137)) + ")}.background_CHF,.background_chf{background-image:url(" + escape(__webpack_require__(1138)) + ")}.background_CNY,.background_cny{background-image:url(" + escape(__webpack_require__(1139)) + ")}.background_TON,.background_ton{background-image:url(" + escape(__webpack_require__(1140)) + ")}.background_XLM,.background_xlm{background-image:url(" + escape(__webpack_require__(459)) + ")}.background_new,.background_PROCESSING,.background_processing,.background_waiting{background-image:url(" + escape(__webpack_require__(1141)) + ")}.background_COMPLETED,.background_done{background-image:url(" + escape(__webpack_require__(461)) + ")}.background_cancelled,.background_denied,.background_expired,.background_FAILED,.background_failed{background-image:url(" + escape(__webpack_require__(1142)) + ")}.background_LINK,.background_link{background-image:url(" + escape(__webpack_require__(1143)) + ")}.background_ALGO,.background_algo{background-image:url(" + escape(__webpack_require__(1144)) + ")}.background_MKR,.background_mkr{background-image:url(" + escape(__webpack_require__(1145)) + ")}.background_LEND,.background_lend{background-image:url(" + escape(__webpack_require__(1146)) + ")}.background_AAVE,.background_aave{background-image:url(" + escape(__webpack_require__(1147)) + ")}.background_DASH,.background_dash{background-image:url(" + escape(__webpack_require__(1148)) + ")}.background_XMR,.background_xmr{background-image:url(" + escape(__webpack_require__(1149)) + ")}.background_DOT,.background_dot{background-image:url(" + escape(__webpack_require__(1150)) + ")}.background_UNI,.background_uni{background-image:url(" + escape(__webpack_require__(462)) + ")}.background_FIL,.background_fil{background-image:url(" + escape(__webpack_require__(1151)) + ")}.background_THETA,.background_theta{background-image:url(" + escape(__webpack_require__(462)) + ")}.background_CAKE,.background_cake{background-image:url(" + escape(__webpack_require__(1152)) + ")}.background_MBOX,.background_mbox{background-image:url(" + escape(__webpack_require__(1153)) + ")}.background_SAND,.background_sand{background-image:url(" + escape(__webpack_require__(1154)) + ")}.background_XTZ,.background_xtz{background-image:url(" + escape(__webpack_require__(1155)) + ")}.background_EGLD,.background_egld{background-image:url(" + escape(__webpack_require__(1156)) + ")}.background_AXS,.background_axs{background-image:url(" + escape(__webpack_require__(1157)) + ")}.background_AVAX,.background_avax{background-image:url(" + escape(__webpack_require__(1158)) + ")}.background_MATIC,.background_matic{background-image:url(" + escape(__webpack_require__(1159)) + ")}.background_CRV,.background_crv{background-image:url(" + escape(__webpack_require__(1160)) + ")}.background_SOL,.background_sol{background-image:url(" + escape(__webpack_require__(1161)) + ")}.component_table{padding:15px 10px}.component_table table{margin-left:auto;margin-right:auto}.component_table table tr th{border-bottom:1px solid #5c5b5b}.component_table table tr td{padding:2px 7px;border-bottom:1px solid #bfbcbc}.table_icon{width:20px;height:20px;display:inline-block;vertical-align:bottom;background-size:contain;background-repeat:no-repeat;background-position:50%}@media screen and (max-width:500px){.custom_table_filters .component_normal_input_block{width:100%}.custom_table_filters .component_normal_input_block .vdp-datepicker,.custom_table_filters .component_normal_input_block input,.custom_table_filters .component_normal_input_block select{width:100%!important;display:block}.custom_table_filters .component_main_button{width:100%}}#part_confirm_pin{background-color:hsla(0,0%,4%,.5);width:100%;height:100vh;position:fixed;top:0;left:0;overflow:auto}#part_confirm_pin p{font-size:.9em}#part_confirm_pin .form_container{width:550px}#part_confirm_pin .form_container .label_text{width:100%}#part_confirm_pin .part_confirm_pin_cancel{width:25px;text-align:center;height:25px;padding:0;display:block;border-radius:50%;margin-left:auto}#part_confirm_pin .part_confirm_pin_cancel a{padding:2px 0;color:#211c54;font-size:14px}.after_btc:after,.after_BTC:after{content:\" BTC\"}.after_blu:after,.after_BLU:after{content:\" BLU\"}.charity-image{width:80px;margin-left:auto;margin-right:auto}.page_redemptions_warning .balance_container{border-radius:10px}.page_redemptions_warning .balance_container h1{font-size:1.8rem;font-weight:600}@media screen and (max-width:1200px){.page_redemptions_warning .balance_container h1{font-size:1.5rem}}.page_redemptions_warning .balance_container .blu_balance_img{width:20px}.custom_flex_block{display:flex;align-items:center}.custom_flex_column{display:flex;flex-direction:column}.custom_flex_row{display:flex;flex-direction:row}.buy_coin_icon{width:65px;height:65px;display:inline-block;vertical-align:bottom;margin-right:30px}@media screen and (max-width:768px){.buy_coin_icon{margin-right:15px;width:50px;height:50px}}.container_coin_select_buy{display:flex;flex-direction:row;padding:20px 15%;margin-bottom:15px;align-items:center;border:2px solid transparent;margin-left:10px;margin-right:10px;border-radius:5px;cursor:pointer}.container_coin_select_buy:hover{border:2px solid #6c63b8}@media screen and (max-width:768px){.container_coin_select_buy{padding:10px}}.sub_container{border:1px solid #5b5ed6;max-width:90%;width:200px;height:50px;padding:3px;display:flex}.container_select_partners{margin-bottom:15px;align-items:center;border:2px solid #5b5ed6;border-radius:10px;cursor:pointer}.container_select_partners:hover{border:2px solid #0086cc}.container_select_partners:hover .sub_container{border:1px solid #0086cc}.container_select_partners .best_way_tag{background-color:#0086cc;width:180px;max-width:100%;border-radius:7px 0 7px 0}.selected{border:2px solid #888ae5;background-color:#888ae5}.coin_disabled{cursor:not-allowed;pointer-events:none;opacity:.2}.sliderBlock .icon_class_3{margin-right:5px}.link_switch{text-decoration:none;padding:6px 20px;border-bottom:4px solid transparent;color:#60609b;margin:5px}@media screen and (max-width:768px){.link_switch{padding:6px 0;margin:5%}}.link_switch_active{pointer-events:none;cursor:not-allowed;border-bottom:4px solid #60609b!important;color:#60609b;font-weight:600}.button_switch_column{padding-bottom:0;padding-right:5%}.button_switch_container{padding:0 10px!important;border-radius:5px}.button_switch{min-width:125px;min-height:40px;border-radius:7px;color:#fff;font-size:15px;padding:0;border:none;vertical-align:middle;cursor:pointer;background-color:#989cbf;background-color:#bbbdd3;font-size:13px;opacity:.9}.button_switch_active{font-size:18px;font-weight:600;opacity:1}.fill-white{fill:#fff!important;color:#fff!important}.cst_disabled:disabled{background-color:#a9a9a9!important}.text_m_blu{font-size:1.3rem;color:#424b7d;font-weight:600}@media screen and (max-width:1200px){.text_m_blu{font-size:1rem}}@media screen and (max-width:600px){.withdraw-address-final-step{font-size:.8rem}}.comp_modal{width:90%;max-width:700px}.comp_modal_container_md{max-width:400px;width:100%}.comp_modal_container_lg{max-width:600px;width:100%}.comp_input_lg{width:96%;display:block;padding:4px 15px}.comp_warning{background-color:#426184;padding:20px;color:#fff}.comp_warning h1{font-size:30px}.comp_warning a{color:#9be1b7;margin-top:10px}.loading_block{padding-top:20px;margin:auto;padding-bottom:20px;width:93%;margin-left:auto;margin-right:auto;min-height:300px;vertical-align:inherit;display:flex;justify-content:center;flex-direction:column;text-align:center;border-radius:3px;border:1px solid #eeeaea}.border-bottom-grey{border-bottom:1px solid #eae3e3;margin:0 9px}.loading_action a,.loading_action button{cursor:progress!important}#pay_with_fiat{color:orange;font-weight:600;cursor:pointer}.general_button_large{width:90%;padding:20px 5px;display:block;margin:auto;border:none;border-radius:10px;cursor:pointer}.link_coin_slide{font-weight:600;padding:0 20px;color:grey;margin-left:30px}#slider_balance .min-width-custom{min-height:76.89px}#slider_balance .info_slider{font-size:12px;min-height:58px}#slider_balance .mar_left{margin-left:10px}#slider_balance .sliderBlock{width:100%}#slider_balance .sliderBlock .arrow{width:40px;display:inline-block}#slider_balance .sliderBlock .isDisabled{opacity:.5;cursor:not-allowed}#slider_balance .sliderBlock .content{overflow:hidden;vertical-align:middle;margin-bottom:0;min-height:58px;width:calc(97% - 82px)}#slider_balance .sliderBlock .content .column{padding-bottom:0;margin-bottom:0}#slider_balance .woosh-enter-active{animation:enterFade 1s}#slider_balance .woosh-leave-active{display:none}@keyframes enterFade{0%{opacity:0;transform:scale(.8)}35%{opacity:0}90%{transform:scale(1)}to{transform:scale(1);opacity:1}}.circle__progress--path{stroke:#fcaf1d!important}.vue-circular-progress .circle__progress{stroke-opacity:1}.effect1{-webkit-box-shadow:0 12px 40px #0000004B;-moz-box-shadow:0 12px 40px #0000004B;box-shadow:0 12px 40px #0000004B}#page_landing{display:block;margin:0;padding:25px 5px!important}#page_landing .qualification_status{width:100%}#page_landing .qualification_status h2{font-size:1.2rem;margin-bottom:1rem;color:#989696;font-weight:600}#page_landing .qualification_status .wrapper_bar{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:20px}#page_landing .qualification_status .wrapper_bar .bar{position:relative;grid-column:span 6/span 6}#page_landing .qualification_status .wrapper_bar .bar p{position:absolute;bottom:1.5rem;font-weight:600;color:#000;font-size:.8rem}#page_landing .qualification_status .wrapper_bar .bar .left_to_qualification{position:absolute;top:2rem;font-size:.8rem;color:#000;font-weight:600}#page_landing .qualification_status .wrapper_bar .bar .coin_bar{width:100%;height:10px;background-color:#d1cccc}#page_landing .qualification_status .wrapper_bar .bar .coin_bar .coin_bar_filled{background-color:#cb36ee;display:block;height:10px}#page_landing .qualification_status .wrapper_bar .blue_image{display:flex;align-items:center;padding-top:4px}#page_landing .qualification_status .wrapper_bar .blue_image img{width:1.5rem}#page_landing .qualification_status .wrapper_bar .blue_image p{font-weight:600;font-size:1rem;padding-left:5px}#page_landing .column_landing{padding:.75rem}#page_landing .column_landing .component_card:first-child{margin-bottom:2rem}@media screen and (max-width:1200px){#page_landing{padding:0!important}}#page_landing .landing_grid{width:100%;max-width:1400px;margin-left:auto;margin-right:auto;display:grid;padding:0;grid-template-columns:1fr 1fr;grid-template-rows:auto}@media screen and (max-width:1200px){#page_landing .landing_grid{display:block;max-width:900px}#page_landing .landing_grid .component_card{margin:0}#page_landing .landing_grid hr{margin:.5rem 0!important}}#page_landing .component_card{height:auto;margin:5px;width:auto}#page_landing .balance_basket{padding:1rem}#page_landing .balance_basket h1{color:#342365;font-weight:600;font-size:1.2rem}#page_landing .balance_basket hr{background-color:#dddbdb;margin:1rem 0}#page_landing .balance_basket .wrapper_balance{display:flex;justify-content:space-between;align-items:center}#page_landing .balance_basket .wrapper_balance .balance_title{display:flex;align-items:center}#page_landing .balance_basket .wrapper_balance .balance_title img{width:1.5rem;margin-left:.5rem;cursor:pointer}#page_landing .balance_basket .wrapper_balance .balance_value{position:relative;display:flex;flex-direction:column;align-items:end}#page_landing .balance_basket .wrapper_balance .balance_value .other_currencies{font-size:.8rem;text-decoration:underline;color:#f77f0d;cursor:pointer;font-weight:600}#page_landing .balance_basket .wrapper_balance .my_balance_content{display:flex;align-items:center;width:100%;justify-content:space-between}#page_landing .balance_basket .wrapper_balance .my_balance_content span{font-size:1.2rem;text-align:end}#page_landing .balance_basket .wrapper_balance .my_balance_content img{width:1.5rem;margin-right:10px}#page_landing .balance_basket .wrapper_balance .gain_Loss{color:#3ed18f;font-size:1.2rem;font-weight:600}#page_landing .wrapper_market{border-bottom:1px solid #666!important;display:flex;align-items:flex-start;justify-content:space-between;padding-bottom:.5rem;width:100%}#page_landing .wrapper_market .todays_market{display:flex;align-items:center}#page_landing .wrapper_market .todays_market h1{color:#342365;font-weight:600;font-size:1.2rem}#page_landing .wrapper_market .todays_market .blue_valuation{display:flex;justify-content:center;align-items:center;margin-left:15px}#page_landing .wrapper_market .todays_market .blue_valuation img{width:1.3rem}#page_landing .wrapper_market .todays_market .blue_valuation p{color:#2ac8b5;font-weight:600;margin-left:5px;font-size:1.2rem}#page_landing .wrapper_market .wrapper_live_price_market{display:flex;flex-direction:column;align-items:end}#page_landing .wrapper_market .wrapper_live_price_market .live_price_market{display:flex;align-items:center}#page_landing .wrapper_market .wrapper_live_price_market .live_price_market .live_price{display:flex;align-items:center;margin-right:15px}#page_landing .wrapper_market .wrapper_live_price_market .live_price_market .live_price button{margin-right:5px;height:12px;width:12px;border-radius:50%;outline:none;border:none;background:#f70707}#page_landing .wrapper_market .wrapper_live_price_market .live_price_market .live_price_usdt{display:flex;align-items:center}#page_landing .wrapper_market .wrapper_live_price_market .live_price_market .live_price_usdt p{font-weight:500;font-size:1.2rem;text-align:right}#page_landing .wrapper_market .wrapper_live_price_market .live_price_market .live_price_usdt img{width:1.3rem;margin-right:5px}#page_landing .wrapper_market .wrapper_live_price_market span{color:#f77f0d;font-size:.8rem;cursor:pointer;text-decoration:underline;margin-top:3px}#page_landing .title_recent_tx{border-bottom:1px solid #342365!important;display:flex;align-items:flex-start;justify-content:space-between;padding-bottom:.5rem}#page_landing .title_recent_tx h1{color:#342365;font-weight:600;font-size:1.2rem}#page_landing .title_recent_tx .all_transactions{color:#3ed18f;text-decoration:underline;font-size:1rem}#page_landing .container_buyblue_mobile{padding:2rem!important}#page_landing .tabs_mobile .tab{position:relative;width:100%;overflow:hidden}#page_landing .tabs_mobile .tab-label{display:flex;justify-content:space-between;padding:1em;background:#fff;height:100%;min-height:90px;align-items:center;color:#342365;font-weight:700;cursor:pointer;width:100%;font-size:1rem}#page_landing .tabs_mobile .tab-label:after{content:\"\\276F\";width:1em;height:1em;text-align:center;transition:all .35s;color:gray;font-weight:100;z-index:0}#page_landing .tabs_mobile .tab-label .eye_balance{width:1.6rem;margin-left:5px}#page_landing .tabs_mobile .tab-label .tab_balance{display:flex;font-weight:500}#page_landing .tabs_mobile .tab-label .tab_balance span{padding-top:.1rem;margin-left:5px}#page_landing .tabs_mobile .tab-label .tab_balance img{width:1rem}#page_landing .tabs_mobile .tab-content{max-height:0;padding:0 1em;color:#342365;background:#fff;transition:all .35s}#page_landing .tabs_mobile .tab-close{display:flex;justify-content:flex-end;padding:1em;font-size:.75em;cursor:pointer;background:#342365}#page_landing .tabs_mobile .tab .tab_input{position:absolute;opacity:0;right:0;width:15%;height:100%;max-height:90px;z-index:10}#page_landing .tabs_mobile .tab_input:checked+.tab-label{align-items:center}#page_landing .tabs_mobile .tab_input:checked+.tab-label:after{transform:rotate(90deg)}#page_landing .tabs_mobile .tab_input:checked~.tab-content{max-height:100%;padding:1rem}#page_landing .tabs_mobile .balance_basket{padding:0}#page_landing .tabs_mobile .balance_basket .wrapper_balance h1{font-size:1rem}#page_landing .tabs_mobile .balance_basket .wrapper_balance .balance_value .my_balance_content img{width:1rem;margin-right:5px}#page_landing .tabs_mobile .balance_basket .wrapper_balance .balance_value .my_balance_content span{font-size:1rem}#page_landing .tabs_mobile .todays_market .blue_valuation{display:flex}#page_landing .tabs_mobile .todays_market .blue_valuation img{width:1rem}#page_landing .tabs_mobile .todays_market .blue_valuation p{color:#2ad2da;margin-left:5px}#page_landing .tabs_mobile .wrapper_market{display:block!important;border-bottom:0!important;padding:0!important;width:auto!important}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market{align-items:center!important}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market .live_price_market{flex-direction:column!important}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market .live_price_market .live_price{margin-right:0;font-size:.8rem}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market .live_price_market .live_price button{margin-right:0!important;margin-left:5px!important}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market .live_price_market .live_price_usdt{margin-top:2px}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market .live_price_market .live_price_usdt img{width:1rem}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market .live_price_market .live_price_usdt p{font-size:1rem}#page_landing .tabs_mobile .wrapper_market .wrapper_live_price_market span{margin-top:2px}#page_landing .tabs_mobile .landing_portfolio_header{margin-bottom:0}#page_landing .tabs_mobile .landing_portfolio_header .landing_portfolio_title{padding:.5rem .2rem!important}#page_landing .tabs_mobile .landing_portfolio_header .landing_portfolio_title p{font-size:.8rem!important}#page_landing .tabs_mobile .landing_portfolio_body .landing_portfolio_item{padding:.5rem .3rem!important}#page_landing .tabs_mobile .landing_portfolio_body .landing_portfolio_item p,#page_landing .tabs_mobile .landing_portfolio_body .landing_portfolio_item span{font-size:1rem!important}#page_landing .tabs_mobile .landing_portfolio_body .landing_portfolio_item .background_{width:30px!important;height:30px!important}#page_landing .tabs_mobile .buy-blue-header{display:none}#page_landing .tabs_mobile .container_buyblue_mobile{padding:0!important}#page_landing .tabs_mobile .all_transactions{color:#3ed18f;text-decoration:underline;font-size:1rem}@media screen and (max-width:900px){#page_landing .column_landing{padding:0}#page_landing .column_landing .component_card:first-child{margin-bottom:0}#page_landing .column_landing .component_card:last-child{border-bottom:0}#page_landing .column_landing .component_card{margin:0;border-top:none;border-bottom:2px solid #d8d6d6;border-left:none;border-right:none;border-radius:0}}#page_landing .landing_buy_redeem .accept_cont{margin-left:10px;border:1px solid #6e6ea1;border-radius:5px;padding:0 5px;color:#6e6ea1;font-size:14px}#page_landing .funds_main_maintanance_section{position:fixed;background-color:hsla(0,0%,4%,.6);width:100%;height:100%;left:0;top:0;z-index:9999;overflow-x:auto}#page_landing #modal_member_details{background-color:#f3f3f3;margin-top:5vh;width:100%;max-width:650px;display:block;margin-left:auto;margin-right:auto;border-radius:7px;word-wrap:break-word;font-size:.9em;padding:14px;font-size:1.2em}@media screen and (max-width:768px){#page_landing #modal_member_details{font-size:.8em}}#page_landing #modal_member_details .general_modal_underline{border-bottom:2px solid #dad5d5}#page_landing #modal_member_details .general_modal_underline .column:first-child{font-weight:600}#page_landing #modal_member_details .close_modal{width:20px;height:20px;text-align:center;display:block;margin-left:auto}#page_landing #modal_member_details .close_modal svg{width:20px;height:20px}#page_landing #modal_member_details .modal_title{color:#5f5d5d;font-size:31px;border-bottom:3px solid #cfcfcf}#page_landing #modal_member_details .modal_header{height:55px;color:#fff;display:flex;align-items:center;justify-content:center;border-radius:7px 7px 0 0}#page_landing #modal_member_details .modal_body{background-color:#f3f3f3}#page_landing #modal_member_details .no_after:after{content:none}#page_landing #modal_member_details .md-field.md-theme-default:before{background-color:#342365}#page_landing #modal_member_details .md-field.md-theme-default.md-focused label{color:#342365}#page_landing #modal_member_details .p_custon{padding:60px;padding-top:10px}#page_landing #modal_member_details .hover-highlight{border-bottom:2px solid #c4c0c0!important}#page_landing #modal_member_details .hover-highlight:disabled{opacity:.3}#page_landing #modal_member_details .hover-highlight:hover{box-shadow:none;border-bottom:2px solid #342365!important;color:#342365}#page_landing #modal_member_details .hover-highlight:hover .input-group input{color:#342365}#page_landing #modal_member_details .hover-highlight:hover .input-group input::placeholder{color:#342365}#page_landing #modal_member_details .hover-highlight:hover:disabled{border-bottom:2px solid #c4c0c0!important;cursor:not-allowed}#page_landing #modal_member_details .button-slips{background-color:#342365;padding:10px;font-size:20px;color:#fff!important;border:none;border-radius:3px;cursor:pointer;min-width:249.91px;min-height:46.67px}#page_landing #modal_member_details .button-slips:active{background-color:#6246b3}#page_landing #modal_member_details .button-slips:disabled{opacity:.5;cursor:not-allowed}.landing_portfolio .landing_portfolio_body .mini_chart canvas{margin-bottom:80px}.landing_portfolio .landing_portfolio_body .mini_chart .h_100{height:70px;width:167px}@media screen and (max-width:700px){.landing_portfolio .landing_portfolio_body .mini_chart .h_100{height:40px;width:120px}}.landing_portfolio .landing_portfolio_body .mini_chart .h_s{height:45px;width:167px}@media screen and (max-width:700px){.landing_portfolio .landing_portfolio_body .mini_chart .h_s{height:40px;width:120px}}@media screen and (max-width:730px){.landing_portfolio .custom_tal_c{text-align:center}}.landing_portfolio .coin_bar{width:100%;height:10px;background-color:#d1cccc}@media screen and (max-width:730px){.landing_portfolio .coin_bar{display:none}}.landing_portfolio .coin_bar_filled{background-color:#2f3577;display:block;height:10px}.landing_portfolio .percent_positive{color:#2ac8b5}.landing_portfolio .percent_negative{color:red}.landing_portfolio .landing_portfolio_icon{width:30px;height:30px;display:inline-block;vertical-align:bottom;margin-right:10px}.landing_portfolio .chart_label{width:20px;display:inline-block;height:20px;background-color:#e6e3e3;margin-top:25px;margin-left:8px;cursor:pointer}.landing_portfolio .landing_portfolio_chart_block{display:block;margin-left:auto;text-align:center}.landing_portfolio #mainChart{margin-bottom:30px;margin-top:30px;width:100%}.landing_portfolio .landing_portfolio_chart_item{margin-top:10px;border:2px solid transparent;padding:10px;cursor:pointer}.landing_portfolio .landing_portfolio_labels{font-size:.8em}.landing_portfolio .landing_portfolio_footer{min-height:80px}.landing_portfolio .landing_portfolio_chart_highlight{border:2px solid #ceccc3;border-radius:6px;background-color:#ececec}.landing_portfolio .landing_portfolio_coin_description{margin-top:-125px;margin-bottom:116px;background-color:hsla(0,13%,81%,.5);z-index:9999;position:relative}.landing_portfolio .custom_flex_block{display:flex;align-items:center}.landing_portfolio .custom_flex_block .block_1{display:flex;flex-direction:column}.landing_portfolio .border_b_2{font-size:13px}.landing_portfolio .border_b_1,.landing_portfolio .border_b_2{border-bottom:2px solid #dddbdb}.landing_portfolio .border_b_1:last-child{border-bottom:0}.landing_portfolio .color_BTC{color:#ff9a28}.landing_portfolio .color_MANA{color:#ff3955}.landing_portfolio .color_ETH{color:#6374bf}.landing_portfolio .color_LINK{color:#2a5ada}.landing_portfolio .color_LEND{color:#149aca}.landing_portfolio .color_AAVE{color:#b6509e}.landing_portfolio .color_DOT{color:#e6007a}.landing_portfolio .color_XRP{color:#23292f}.landing_portfolio .color_BCH{color:#86cb5c}.landing_portfolio .color_LTC{color:#345d9d}.landing_portfolio .color_EOS{color:#807979}.landing_portfolio .color_BNB{color:#f2c353}.landing_portfolio .color_LUNA{color:#172852}.landing_portfolio .color_XMR{color:#ff6501}.landing_portfolio .color_IOTA{color:#786262}.landing_portfolio .color_ADA{color:#3cc8c8}.landing_portfolio .color_TRX{color:#c34e4e}.landing_portfolio .color_XLM{color:#000}.landing_portfolio .color_DASH{color:#1c81bc}.landing_portfolio .color_ALGO{color:#000}.landing_portfolio .color_MKR{color:#17ab99}.landing_portfolio .color_FIL{color:#018fff}.landing_portfolio .color_UNI{color:#ff0179}.landing_portfolio .color_THETA{color:#29b8e6}.landing_portfolio .color_CAKE{color:#d1884f}.landing_portfolio .color_SOL{color:#62b9c4}.landing_portfolio .color_MATIC{color:#9767e9}.landing_portfolio .color_CRV{color:#c71a16}.landing_portfolio .color_AVAX{color:#e84142}.landing_portfolio .color_MBOX{color:#1b53f5}.landing_portfolio .color_TUSD{color:#57ae96}#landing_charity .charity_card{margin-top:15px}#landing_charity .charity_card img{width:33%;vertical-align:middle}@media screen and (max-width:768px){#landing_charity .charity_card img{display:block;width:70%;margin-left:auto;margin-right:auto}}#landing_charity .charity_card p{width:65%;vertical-align:text-bottom;color:#000;vertical-align:middle}@media screen and (max-width:768px){#landing_charity .charity_card p{display:block;width:80%;margin-left:auto;margin-right:auto}}#landing_charity .charity_card_amount{padding-left:5%;font-size:18px;background-color:#35a4b1;padding-top:10px;padding-bottom:10px;color:#fff;margin-top:10px}@media screen and (max-width:500px){#landing_charity .component_title_lg{font-size:27px}}#landing_charity #balances_cards .icon_class_1,#landing_charity #balances_cards .icon_class_05{background-position:50%;background-size:contain}#landing_charity .page_landing_welcome_title h1{display:inline-block;width:auto}#landing_charity .page_landing_welcome_title span{display:inline-block}#landing_charity .landing_portfolio .landing_portfolio_header{max-width:98%;margin-left:auto;margin-right:auto;border-bottom:1px solid #c1b3b3}@media screen and (max-width:500px){#landing_charity .landing_portfolio .landing_portfolio_header{font-size:.6em}}#landing_charity .landing_portfolio .landing_portfolio_body{background:red;max-width:98%;margin-left:auto;margin-right:auto}@media screen and (max-width:500px){#landing_charity .landing_portfolio .landing_portfolio_body{font-size:.8em}}#landing_charity .landing_recent .landing_recent_body{font-size:1rem;border-bottom:1px solid #e7e1e1}#landing_charity .landing_recent .landing_recent_body:last-child,#landing_charity .landing_recent .landing_recent_body:nth-last-child(2){border-bottom:none}#landing_charity .landing_recent .landing_recent_link{width:180px;text-align:center;margin-left:auto}#landing_charity .landing_recent .component_super_button{width:500px;max-width:100%;margin-top:10vh}#landing_charity .landing_presale .landing_presale_map{display:block;text-align:center}#landing_charity .landing_presale .landing_presale_map svg{fill:transparent;stroke:#828ed1;max-width:100%;width:450px}#landing_charity .landing_presale .landing_presale_map .c1,#landing_charity .landing_presale .landing_presale_map .c2,#landing_charity .landing_presale .landing_presale_map .c3,#landing_charity .landing_presale .landing_presale_map .c4{fill:#24244d}#landing_charity .landing_presale .landing_presale_text{margin-top:30px}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child strong,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) strong,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) strong{color:#b9b5b5}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(4) p{border-radius:5px}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child span p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) span p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) span p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(4) span p{padding:0;border:none}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) p{opacity:.3;padding:20px 10px;border:1px solid #e4e4e4;background:#efefef;color:#4b4949}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child p .landing_presale_text_phase_date,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child p .landing_presale_text_phase_date strong,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) p .landing_presale_text_phase_date,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) p .landing_presale_text_phase_date strong,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) p .landing_presale_text_phase_date,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) p .landing_presale_text_phase_date strong{color:#4b4949}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:first-child p p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(2) p p,#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(3) p p{opacity:1}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(4) p{background-color:#4e5e86;padding:20px 10px;color:#fff}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase:nth-child(4) p strong{color:#fff}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase p{margin-left:auto;margin-right:auto;display:block;width:100%;max-width:100%}#landing_charity .landing_presale .landing_presale_text .landing_presale_text_phase .landing_presale_text_phase_details{margin-top:9px;display:block}#page_redemptions .page_redemptions_body .page_redemptions_warning .green{background:#02b9a4}#page_redemptions .page_redemptions_body .page_redemptions_warning .dark_yellow{background:#e3a00a}#page_redemptions .page_redemptions_body .page_redemptions_warning .grey{background:#8f969b}#page_redemptions .page_redemptions_body .page_redemptions_warning .grey_color{color:#8f969b}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_tag{margin-bottom:5px;width:4%}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_container{max-width:400px}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_details{display:flex;justify-content:flex-end;flex-direction:column}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_arround{border-bottom:1px solid #d8d6d6}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_arround:last-child{border-bottom:1px solid transparent}#page_redemptions .page_redemptions_body .page_redemptions_warning .no_border{border:none}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_row{display:flex;align-items:center}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_row .right_header_content{display:flex;align-items:center;width:100%;font-size:.8rem;padding:10px 0}#page_redemptions .page_redemptions_body .page_redemptions_warning .right_arrow_content{display:flex;align-items:center;justify-content:flex-end;width:20%}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_content_inside{display:flex;align-items:center;width:100%}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_content_inside_100{display:flex;align-items:center;width:100%;padding:5px 0}#page_redemptions .page_redemptions_body .page_redemptions_warning .balanc_blu{display:flex;justify-content:space-evenly;font-weight:600;word-break:break-all;width:100%}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_symbol{display:flex;justify-content:flex-end;word-break:break-all;width:70%}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_converte{display:flex;word-break:break-all;margin-left:15px}#page_redemptions .page_redemptions_body .page_redemptions_warning .equivalent{display:flex;font-size:1rem;font-weight:500}#page_redemptions .page_redemptions_body .page_redemptions_warning .blu_tag{margin-left:20px}#page_redemptions .page_redemptions_body .page_redemptions_warning .right_blu{margin-right:10px}#page_redemptions .page_redemptions_body .page_redemptions_warning .left_btc{margin-left:26px;margin-right:2px}#page_redemptions .page_redemptions_body .page_redemptions_warning .left_tusd{margin-left:15px;margin-right:2px}#page_redemptions .page_redemptions_body .page_redemptions_warning .left_realt{margin-left:10px;margin-right:2px}@media only screen and (max-width:500px){#page_redemptions .page_redemptions_body .page_redemptions_warning .redeem_balance_body{margin-left:auto;margin-right:auto}#page_redemptions .page_redemptions_body .page_redemptions_warning .balance_tag{width:10%;max-width:500px}#page_redemptions .page_redemptions_body .page_redemptions_warning .redeem_balance_body{margin-top:30px}}.redeem_grid{width:100%;max-width:1600px;margin-left:auto;margin-right:auto;display:grid;padding:0;margin-top:40px;padding:0!important;grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr;grid-template-rows:auto}@media screen and (max-width:1200px){.redeem_grid{display:block;max-width:900px;margin-top:1rem}}.redeem_grid .i1,.redeem_grid .i2,.redeem_grid .i3,.redeem_grid .i4,.redeem_grid .i5,.redeem_grid .i6{padding:0 10px 20px}.redeem_grid .i1{grid-column-start:4;grid-column-end:7;grid-row-start:1;grid-row-end:2}.redeem_grid .i2{grid-column-start:1;grid-column-end:4;grid-row-start:1;grid-row-end:2}.redeem_grid .i3{grid-column-start:4;grid-column-end:7;grid-row-start:2;grid-row-end:3}.redeem_grid .display_values_redeem{display:flex;justify-content:space-between;flex-direction:column;border:1px solid #d3d3d3;border-right:none!important;border-left:none!important}.redeem_grid .display_values_redeem p{margin-bottom:5px;font-weight:600}.redeem_grid .display_values_redeem span{font-size:.85rem;margin-left:10px}.redeem_grid .display_btc_adress_redeem{border-bottom:1px solid #d3d3d3}.redeem_grid .amount_withdraw{font-size:1.3em}.redeem_grid .amount_btc{font-size:2.2em}.redeem_grid .email-info{font-size:1.3em!important}.redeem_card_header{background-color:#697cb1;color:#fff}.redeem_card_header strong{color:#fff}.redeem_form input{display:block;min-height:39px;padding:8px;width:95%;border:1px solid #e3d4d4}.redeem_form button{margin-left:auto;display:block;margin-right:5%;border:none;color:#fff;padding:15px;text-transform:uppercase;font-weight:600;cursor:pointer}.btn_redeem{background-color:#02b9a4;border-radius:8px;width:100%}.btn_redeem:hover{opacity:.9}.btn_redeem:disabled{background-color:#ddd;cursor:not-allowed}.btn_radius,.btn_redeem_back{border-radius:8px}.btn_redeem_back{background-color:red;width:100%}.btn_with_fees{background-color:#f9a341}.landing_redeem_close{display:block;width:100%;text-align:center}.landing_redeem_close button{cursor:pointer;background-color:#f36638;color:#fff;padding:6px 25px;border:none;border-radius:2px}.landing_redeem_close button:hover{background-color:#ff6c00}#landing_redeem input[type=number]::-webkit-inner-spin-button,#landing_redeem input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}#landing_redeem .component_card{border:1px solid #d8d6d6}.towFA_instructions,.towFA_instructions a,.towFA_instructions p{display:block}#page_funds .page_wallets_actions{padding:10px 8px;border-bottom:1px solid #e7e7e7;max-width:95%;margin-left:auto;margin-right:auto}#page_funds .page_wallets_actions:last-child{border-bottom:none}#page_funds .page_wallets_actions .page_wallets_actions_title .page_wallets_actions_title_img{vertical-align:text-bottom}#page_insights{display:block;margin:0;padding:25px 5px!important}#page_insights .column_insights{padding:.75rem}#page_insights .column_insights .component_card{margin-bottom:2rem}@media screen and (max-width:1200px){#page_insights{padding:0!important}}#page_insights .insights_grid{width:100%;max-width:1600px;margin-left:auto;margin-right:auto;display:grid;padding:0;grid-template-columns:repeat(5,minmax(0,1fr));grid-template-rows:auto}@media screen and (max-width:1200px){#page_insights .insights_grid{display:block;max-width:900px}#page_insights .insights_grid .component_card:nth-child(3){margin-bottom:0}#page_insights .insights_grid hr{margin:.5rem 0!important}}#page_insights .basket_insights{padding:1rem}#page_insights .basket_insights .token_supply{display:flex;justify-content:space-between;align-items:center}#page_insights .basket_insights .token_supply .token_supply_content{display:flex;align-items:center}#page_insights .basket_insights .token_supply .token_supply_content img{width:1.2rem;margin-left:.5rem;cursor:pointer}#page_insights .basket_insights h1{color:#211c54;font-weight:600;font-size:1.2rem}#page_insights .basket_insights .basket_value{display:flex;justify-content:space-between;align-items:center}#page_insights .basket_insights .basket_insights_content{display:flex;align-items:center;justify-content:center}#page_insights .basket_insights .basket_insights_content span{font-size:1.2rem;color:#211c54}#page_insights .basket_insights .basket_insights_content img{width:1.5rem;margin-right:10px}#page_insights .basket_insights .basket_insights_content p{color:#f5680d;font-size:.9rem;cursor:pointer;text-decoration:underline;margin-top:.3rem}#page_insights .title_insights{border-bottom:1px solid #211c54!important}#page_insights .title_insights h1{color:#211c54;padding-bottom:1rem;font-weight:600;font-size:1.2rem}#page_insights .wrapper_chart_insights{display:flex;justify-content:space-between;align-items:center;padding:1rem 0;width:100%}#page_insights .wrapper_chart_insights .expand_chart{display:flex;align-items:center;color:#f4680d;cursor:pointer}#page_insights .wrapper_chart_insights .expand_chart img{width:1rem;margin-left:5px;cursor:pointer}#page_insights .wrapper_chart_insights .expand_chart:hover{text-decoration:underline}#page_insights .wrapper_chart_insights .price_history{color:#f4680d}#page_insights .wrapper_chart_insights .period{display:flex;align-items:center}#page_insights .wrapper_chart_insights .period img{width:1rem}#page_insights .wrapper_chart_insights .period p{font-weight:600;margin:5px}#page_insights .wrapper_chart_insights .period span{font-weight:600}#page_insights .insights_holding table{width:100%}#page_insights .insights_holding table thead tr th{padding:1rem;text-align:right}#page_insights .insights_holding table tbody tr{border-bottom:1px solid #ccc;border-top:1px solid #ccc}#page_insights .insights_holding table tbody tr td:first-child{display:flex;text-align:start;align-items:center}#page_insights .insights_holding table tbody tr td:first-child p{margin-left:5px}#page_insights .insights_holding table tbody tr td{padding:.6rem;text-align:right}#page_insights .insights_holding table tbody tr td button{margin-left:8px;height:15px;width:15px;border-radius:50%;outline:none;border:none;background:#3ed18f;padding:0;-webkit-appearance:none}#page_insights .insights_holding .isights_coin_icon{width:20px;height:20px;display:inline-block;vertical-align:middle}#page_insights .insights_holding .teste_active:hover{background-color:#eaeaea}#page_insights .currently_generating{display:flex;align-items:center;justify-content:end;margin-top:1rem}#page_insights .currently_generating button{margin-right:8px;height:15px;width:15px;border-radius:50%;outline:none;border:none;background:#3ed18f;padding:0;-webkit-appearance:none}#page_insights .component_card{height:auto;margin:5px;width:auto}#page_insights .footer_card{text-align:center;padding:20px}#page_insights hr{display:block;border:0;border-top:1px solid #ccc;margin:1em 0;padding:0}#page_insights .tabs_mobile .tab{position:relative;width:100%;overflow:hidden}#page_insights .tabs_mobile .tab-label{display:flex;justify-content:space-between;padding:1em;background:#fff;height:100%;min-height:90px;align-items:center;color:#342365;font-weight:700;cursor:pointer;width:100%;font-size:1rem}#page_insights .tabs_mobile .tab-label:after{content:\"\\276F\";width:1em;height:1em;text-align:center;transition:all .35s;color:gray;font-weight:100;z-index:0}#page_insights .tabs_mobile .tab-content{max-height:0;padding:0 1em;color:#342365;background:#fff;transition:all .35s}#page_insights .tabs_mobile .tab-close{display:flex;justify-content:flex-end;padding:1em;font-size:.75em;background:#342365;cursor:pointer}#page_insights .tabs_mobile .tab .tab_input{position:absolute;opacity:0;right:0;width:15%;height:100%;max-height:90px;z-index:10}#page_insights .tabs_mobile .tab_input:checked+.tab-label{align-items:center}#page_insights .tabs_mobile .tab_input:checked+.tab-label:after{transform:rotate(90deg)}#page_insights .tabs_mobile .tab_input:checked~.tab-content{max-height:100%;padding:1rem}#page_insights .tabs_mobile .basket_insights{padding:0}#page_insights .tabs_mobile .basket_insights .token_supply .token_supply_content h1{font-size:1rem}#page_insights .tabs_mobile .basket_insights .token_supply .token_supply_content img{width:1rem;margin-left:5px}#page_insights .tabs_mobile .basket_insights .token_supply .basket_insights_content img{width:1rem;margin-right:5px}#page_insights .tabs_mobile .basket_insights .token_supply .basket_insights_content span{font-size:1rem;font-weight:500}#page_insights .tabs_mobile .basket_insights .basket_value h1{font-size:1rem}#page_insights .tabs_mobile .basket_insights .basket_value .basket_insights_content img{width:1rem;margin-right:5px}#page_insights .tabs_mobile .basket_insights .basket_value .basket_insights_content p{margin-top:2px}#page_insights .tabs_mobile .basket_insights .basket_value .basket_insights_content span{font-size:1rem}#page_insights .tabs_mobile .period{display:flex;align-items:center;flex-wrap:wrap}#page_insights .tabs_mobile .period img{width:1rem}#page_insights .tabs_mobile .period p{font-weight:500;margin:0 5px;font-size:1rem}#page_insights .tabs_mobile .period span{font-weight:600}#page_insights .tabs_mobile .wrapper_chart_insights{padding:0;margin-bottom:1rem}#page_insights .tabs_mobile .wrapper_chart_insights p{font-size:1rem}#page_insights .tabs_mobile .wrapper_chart_insights p img{width:1rem}#page_insights .tabs_mobile .wrapper_chart_insights a{color:#f4680d;font-size:1rem}#page_insights .tabs_mobile .landing_charts_label{padding:0!important}#page_insights .tabs_mobile .landing_charts_label p{font-weight:600}#page_insights .tabs_mobile .landing_charts_label .landing_charts_label_block{width:20px;height:10px}#page_insights .tabs_mobile .landing_charts_label .combo_buttons_charts .link_switch{margin:0;font-size:.8rem;padding:0!important}#page_insights .tabs_mobile .report_link{font-size:1rem}#page_insights .tabs_mobile .insights_holding{color:#4a4a4a}#page_insights .tabs_mobile .insights_holding table thead tr th{padding:.5rem;font-size:1rem}#page_insights .tabs_mobile .insights_holding table tbody tr td{padding:.6rem 0;font-size:1rem}#page_insights .tabs_mobile .insights_holding table tbody tr td button{margin-bottom:2px;margin-left:7px;height:12px;width:12px}#page_insights .tabs_mobile .insights_holding .isights_coin_icon{width:20px;height:20px;display:inline-block;vertical-align:middle}#page_insights .tabs_mobile .insights_holding .currently_generating p{font-size:1rem}@media screen and (max-width:900px){#page_insights .column_insights{padding:0}#page_insights .column_insights .component_card{margin-bottom:0;margin:0;border-top:none;border-bottom:2px solid #d8d6d6;border-left:none;border-right:none;border-radius:0}}@media screen and (max-width:350px){#page_insights .wrapper_chart_insights{flex-direction:column!important}}#page_referrals .p{margin-left:auto;margin-right:auto;width:500px;display:block;margin-top:20px}#page_referrals a{word-break:break-all}#page_settings{width:100%;max-width:80rem;margin:auto}#page_settings .title_settings{display:flex;align-items:center;margin-bottom:1rem}#page_settings .title_settings svg{margin-right:6px;margin-top:4px;width:2.5rem}#page_settings .title_settings h1{font-size:2rem;font-weight:600}#page_settings .tabs_settings{display:flex;border-bottom:1px solid #e5e7eb}#page_settings .tabs_settings .tabs_item{white-space:nowrap;padding-bottom:1rem;margin-left:2rem;cursor:pointer;font-size:1.1rem;font-weight:600;border-bottom:2px solid transparent}#page_settings .tabs_settings .tabs_item:hover{color:#342365;border-bottom:2px solid #342365}#page_settings .tabs_settings .tabs_item_active{white-space:nowrap;padding-bottom:1rem;margin-left:2rem;cursor:pointer;font-size:1.1rem;font-weight:600;color:#342365;border-bottom:2px solid #342365}#page_settings .tab_content{border-top-left-radius:8px;border-top-right-radius:8px;height:100%;border:2px solid #e2e8f0;border-bottom:none;display:grid;grid-template-columns:1fr 2fr;margin:auto;margin-top:2rem}#page_settings .tab_content .tab_content_left{background:#f7fafc;padding:2rem;border-radius:8px}#page_settings .tab_content .tab_content_left h2{margin-bottom:1rem;color:#342365;letter-spacing:.025em;font-size:1.2rem;text-transform:uppercase;font-weight:500}#page_settings .tab_content .tab_content_left p{color:#000;font-size:1rem}#page_settings .tab_content .tab_content_right{background-color:rgba(52,35,101,.1);backdrop-filter:blur(10px);padding:2rem}#page_settings .tab_content .tab_content_right .combo_1{position:relative;margin-bottom:1rem}#page_settings .tab_content .tab_content_right .combo_1 label{color:#342365;font-size:1rem}#page_settings .tab_content .tab_content_right .combo_1 .input_write_form{display:block;height:50px;width:100%;background-color:rgba(25,23,75,.1)!important;color:#000!important;border-radius:6px;padding:0 10px;margin-top:4px;font-size:14px;font-weight:300;outline:none;border:2px solid transparent}#page_settings .tab_content .tab_content_right .combo_1 .input_write_form:focus{border:2px solid rgba(25,23,75,.5)}#page_settings .tab_content .tab_content_right .combo_1 ::placeholder{color:#342365}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput{margin-top:4px!important;border-radius:8px;border:rgba(25,23,75,.5)!important}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput label{margin-top:0!important;font-size:11px!important}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput .input-tel__label{color:#333364}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput .country-selector{height:50px!important}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput .country-selector__country-flag{top:25px}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput input{height:50px!important;border:0!important}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput input:first-child{background-color:rgba(25,23,75,.1)!important;color:#000!important;margin-left:1px}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput .country-selector__list{margin-top:5px;box-shadow:0 0 40px #08071099;border:1px solid hsla(0,0%,100%,.1);backdrop-filter:blur(10px)}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput button{padding:0 10px!important;font-size:15px!important;border-radius:0!important}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput button:hover{background:#333364;color:#fff}#page_settings .tab_content .tab_content_right .combo_1 .VuePhoneNumberInput:hover{border:none}#page_settings .tab_content .tab_content_right .combo_1 .tooltip_disclaimer_new{color:gray;width:1rem;margin-left:10px}#page_settings .tab_content .tab_content_right .combo_1 .tooltip_disclaimer_new:hover{cursor:pointer;color:#19174b;transition:all .3s ease-out}#page_settings .tab_content .tab_content_right .combo_1 .info{background:rgba(25,23,75,.7);color:#fff;padding:10px;border-radius:4px;box-shadow:0 0 5px 1px rgba(0,0,0,.2);font-size:13px;margin-top:5px}#page_settings .tab_content .tab_content_right .action{margin-top:1rem;width:50px;height:25px;background-color:rgba(62,62,70,.3);text-align:right;border-radius:25px}#page_settings .tab_content .tab_content_right .action input{display:none}#page_settings .tab_content .tab_content_right .action label{height:25px;width:100%;display:block;position:relative}#page_settings .tab_content .tab_content_right .action label:before{content:\"\";left:0;height:25px;width:25px;display:block;border-radius:25px;position:absolute;background-color:#924f39;transition:left .3s,background-color .3s}#page_settings .tab_content .tab_content_right .action input:checked+label:before{left:calc(100% - 25px);background-color:#4f9239}#page_settings .tab_content_bottom{padding:2rem 4rem;display:flex;align-items:center;justify-content:space-between;width:100%;border:2px solid #e2e8f0;border-top:none;background:#cbd5e1;border-bottom-left-radius:8px;border-bottom-right-radius:8px}#page_settings .tab_content_bottom p{color:#6b7280;font-size:1.1rem;font-weight:600}#page_settings .tab_content_bottom button{background:#342365;padding:10px 20px;border-radius:6px;outline:none;border:none;color:#fff;font-size:1rem;text-transform:uppercase;font-weight:600;cursor:pointer;transition:all .2s ease-in-out}#page_settings .tab_content_bottom button:hover{background-color:rgba(52,35,101,.9)}@media screen and (max-width:750px){#page_settings .tabs_settings .tabs_item,#page_settings .tabs_settings .tabs_item_active{margin-left:1.5rem;font-size:1rem}#page_settings .tab_content{display:flex;flex-direction:column}#page_settings .tab_content .tab_content_left{padding:1rem}#page_settings .tab_content .tab_content_left h2{margin-bottom:.5rem}#page_settings .tab_content .tab_content_right{padding:1rem}#page_settings .tab_content .tab_content_right h2{margin:.5rem}#page_settings .tab_content_bottom{padding:1rem}#page_settings .tab_content_bottom p{font-size:.9rem}}#page_settings .settings_menu a{padding:13px 15px;color:#535768;border-bottom:1px solid #e6e4e4;width:96%;display:block;margin-left:auto;margin-right:auto}#page_settings .settings_menu a strong{vertical-align:text-bottom}#page_settings select{padding:0 10px;height:50px;border-radius:8px;border:1px solid #bfb8b8;text-transform:uppercase}@media screen and (min-width:768px){#page_settings select{text-align:center}}#page_settings .form_block_checkbox label span{border-radius:560%}#page_settings .form_block_checkbox [type=checkbox]{border-radius:50%!important}#page_settings .form_block_checkbox [type=checkbox]:checked+span:before{color:transparent;background-image:url(" + escape(__webpack_require__(461)) + ");background-size:contain;background-repeat:no-repeat;background-position:50%;top:-3px;left:-2px;height:18px;width:18px}#page_settings .step{width:25px;height:25px;border-radius:50%;text-align:center;display:inline-block;background-color:#19d1a9;color:#fff;margin-right:5px}#page_settings .component_normal_input_block{margin-top:15px}#page_settings .component_normal_input_block input{padding:5px}.services .deposit_actions{display:flex;padding:1rem 0}.services .deposit_actions button{border-radius:4px;outline:none;font-weight:700;font-size:1rem;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:3px 5px}.services .deposit_actions button img{width:1.5rem;margin-right:4px}.services .deposit_actions button span{margin-bottom:3px;font-size:1.2rem}.services .deposit_actions .selectedBlue{background:#332365!important;color:#fff!important}.services .deposit_actions .selectedEther{background:#02b9a4!important;color:#fff!important}.services .deposit_actions button:first-child{background:#fff;border:1px solid #332365;color:#332365;transition:all .2s ease-in-out}.services .deposit_actions button:first-child:hover{background:#332365;color:#fff}.services .deposit_actions button:last-child{background:#fff;margin-left:10px;border:1px solid #02b9a4;color:#02b9a4}.services .deposit_actions button:last-child:hover{background:#02b9a4;color:#fff}.services .deposit_wrapper{background:#fff}.services .deposit_wrapper,.services .withdraw_wrapper{border:1px solid #d8d6d6;border-radius:8px}@media screen and (max-width:768px){.services .withdraw_wrapper{border:none}}.services .withdraw_steps_img{width:100%;display:flex;justify-content:center}@media screen and (max-width:768px){.services .withdraw_steps_img{margin-top:5rem}}.services .withdraw_step2{border-radius:8px;border:1px solid #d8d6d6}@media screen and (max-width:768px){.services .withdraw_step2{border:none}}.services .header_withdraw{padding:1rem;background-color:#332365;color:#fff;margin-bottom:20px;border-top-left-radius:8px;border-top-right-radius:8px;font-size:1.3rem;text-align:center}@media screen and (max-width:768px){.services .header_withdraw{font-size:1.1rem;position:absolute;left:0;right:0;border-radius:0}}.services .wrapper_withdraw_form{padding:10px 30px}@media screen and (max-width:768px){.services .wrapper_withdraw_form{padding:0}}.container_pool{display:flex;align-items:center;justify-content:center;flex-direction:column;overflow:hidden;width:80%;margin-top:1rem;max-width:100%}.container_pool .rewards_container{display:flex;align-items:center;justify-content:space-between;width:100%}.container_pool .rewards_container .rewards_box{display:flex;align-items:center;justify-content:center;flex-direction:column;width:100%;max-width:350px}.container_pool .rewards_container .rewards_box h3{padding-bottom:5px;color:#989696;font-size:1.1rem;font-weight:700}.container_pool .rewards_container .rewards_box .content_rewards{display:flex;align-items:center;justify-content:space-evenly;background:#b5c2f0;padding:1rem;border-radius:8px;width:100%;max-width:250px;height:100px}.container_pool .rewards_container .rewards_box .content_rewards .calculating{color:#4555a7;font-weight:500;font-size:1.5rem;margin-left:10px}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards{display:flex;align-items:center;justify-content:center;flex-direction:column}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards p{color:#4555a7;font-weight:500;font-size:2.5rem}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards span{color:#595a61;font-size:1rem;font-weight:700}.container_pool .rewards_container .rewards_box .content_rewards img{width:3rem}.container_pool .rewards_container .arrow_reward{width:3rem;margin-top:2.5rem}.container_pool .rewards_container .arrow_reward .arrow{color:#4555a7}.container_pool .wrapper_join_pool{display:flex;align-items:center;justify-content:space-between;width:100%;padding-top:2rem}.container_pool .wrapper_join_pool .title_and_btn{display:flex;align-items:center}.container_pool .wrapper_join_pool .title_and_btn h3{font-size:1.5rem;color:#989696;font-weight:600}.container_pool .wrapper_join_pool .title_and_btn button{border:none;color:#fff;cursor:pointer;font-size:1rem;font-weight:600;border-radius:6px;background:#28a191;padding:8px 20px;transition:all .2s ease-in-out}.container_pool .wrapper_join_pool .title_and_btn button:hover{background:rgba(40,161,145,.8)}.container_pool .wrapper_join_pool .wrapper_winners{display:flex;align-items:center;text-decoration:underline}.container_pool .wrapper_join_pool .wrapper_winners svg{height:1rem;width:auto;padding-left:5px}.container_pool .table_pool,.container_pool .table_pool .table_container{display:flex;flex-direction:column;align-items:center;justify-content:center}.container_pool .table_pool .table_container{border-radius:.5rem;border:1.5px solid #d8d6d6;padding:20px}.container_pool .table_pool .table_container table{padding:0;width:100%;table-layout:fixed;border-collapse:collapse;overflow-x:auto}.container_pool .table_pool .table_container table td,.container_pool .table_pool .table_container table th{padding:.5rem;font-weight:500;color:#707070}.container_pool .table_pool .table_container table th{padding:.5rem;font-size:1rem;font-weight:600;color:#132787;text-align:center}.container_pool .table_pool .table_container table .icon_table{display:flex;align-items:center;justify-content:flex-start}.container_pool .table_pool .table_container table .icon_table img{margin-right:10px;width:1.5rem}.container_pool .table_pool .table_container table .icon_table_numbers{display:flex;align-items:center;margin-left:calc(95% - 50px)}.container_pool .table_pool .table_container table .icon_table_numbers img{margin-right:10px;width:1.5rem}.container_pool .table_pool .table_container button{display:flex;justify-content:center;background:transparent;border:none;color:#132787;cursor:pointer;font-weight:700;font-size:.8rem;transition:all .1s ease-in-out}.container_pool .table_pool .table_container button:hover{color:rgba(19,39,135,.8);text-decoration:underline}.container_pool .table_pool .nobody_has_qualified{padding:1rem 0;padding-top:2rem;width:100%;max-width:450px}.container_pool .table_pool .nobody_has_qualified p{font-weight:600;font-size:1.2rem;text-align:center;color:#989696}.container_pool .check_again_soon{padding:2rem 0;width:100%;max-width:450px}.container_pool .check_again_soon p{font-weight:600;font-size:1.4rem;text-align:center;color:#989696}.container_pool .qualification_status{width:100%;margin:2rem 0}.container_pool .qualification_status h2{font-size:1.2rem;margin-bottom:1rem;color:#989696;font-weight:600}.container_pool .qualification_status .wrapper_bar{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:20px}.container_pool .qualification_status .wrapper_bar .bar{position:relative;grid-column:span 6/span 6}.container_pool .qualification_status .wrapper_bar .bar p{position:absolute;bottom:1.5rem;font-weight:600;color:#000;font-size:.8rem}.container_pool .qualification_status .wrapper_bar .bar .left_to_qualification{position:absolute;top:2rem;font-size:.8rem;color:#000;font-weight:600}.container_pool .qualification_status .wrapper_bar .bar .coin_bar{width:100%;height:10px;background-color:#d1cccc}.container_pool .qualification_status .wrapper_bar .bar .coin_bar .coin_bar_filled{background-color:#40baa2;display:block;height:10px}.container_pool .qualification_status .wrapper_bar .blue_image{display:flex;align-items:center;padding-top:4px}.container_pool .qualification_status .wrapper_bar .blue_image img{width:1.5rem}.container_pool .qualification_status .wrapper_bar .blue_image p{font-weight:600;font-size:1rem;padding-left:5px}@media only screen and (max-width:930px){.container_pool{width:90%}}@media only screen and (max-width:870px){.container_pool .qualification_status h2{font-size:1rem}.container_pool .qualification_status .wrapper_bar{gap:25px}.container_pool .qualification_status .wrapper_bar .bar p{bottom:2.5rem}.container_pool .qualification_status .wrapper_bar .blue_image{flex-direction:column}.container_pool .qualification_status .wrapper_bar .blue_image img{width:1.5rem;padding-bottom:1px}.container_pool .qualification_status .wrapper_bar .blue_image p{font-size:.8rem;padding-left:0}}@media only screen and (max-width:720px){.container_pool{width:100%}}@media only screen and (max-width:640px){.container_pool .rewards_container .rewards_box{width:100%;max-width:200px}.container_pool .rewards_container .rewards_box h3{padding-bottom:2px;font-size:1rem}.container_pool .rewards_container .rewards_box .content_rewards{max-width:200px;height:100px}.container_pool .rewards_container .rewards_box .content_rewards .calculating{font-size:1rem;margin-left:5px}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards p{font-size:2rem}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards span{font-size:.8rem}.container_pool .rewards_container .rewards_box .content_rewards img{width:2.5rem}}@media only screen and (max-width:560px){.container_pool .rewards_container{padding:0!important}.container_pool .rewards_container .rewards_box h3{padding-bottom:2px;font-size:1rem}.container_pool .rewards_container .rewards_box .content_rewards{max-width:180px;height:80px}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards p{font-size:1.7rem}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards span{font-size:.7rem}.container_pool .rewards_container .rewards_box .content_rewards img{width:2rem}.container_pool .rewards_container .arrow_reward{margin-top:1.8rem;width:2rem}.container_pool .wrapper_join_pool{align-items:flex-start}.container_pool .wrapper_join_pool .title_and_btn{flex-direction:column;align-items:flex-start}.container_pool .wrapper_join_pool .title_and_btn h3{font-size:1.2rem}.container_pool .wrapper_join_pool .title_and_btn button{font-size:.8rem;padding:6px 20px}.container_pool .wrapper_join_pool .wrapper_winners{display:flex;align-items:center;text-decoration:underline;font-weight:600;font-size:.8rem;cursor:pointer}.container_pool .wrapper_join_pool .wrapper_winners svg{height:.8rem;width:auto;padding-left:5px}.container_pool .table_pool .table_container table th{padding:0}.container_pool .table_pool .table_container table td{padding:.5em 0}.container_pool .table_pool .table_container table th{font-size:.9rem}.container_pool .table_pool .table_container table .icon_table img{width:1.2rem}.container_pool .table_pool .nobody_has_qualified{padding-top:1rem;max-width:400px}.container_pool .check_again_soon{padding:1rem 0;width:100%;max-width:400px}.container_pool .check_again_soon p{font-size:1rem}.container_pool .qualification_status{width:100%;margin:2rem 0}.container_pool .qualification_status h2{font-size:1rem;color:#989696;font-weight:600}.container_pool .qualification_status .wrapper_bar{gap:0}.container_pool .qualification_status .wrapper_bar .bar p{bottom:2.7rem;font-size:.7rem!important}.container_pool .qualification_status .wrapper_bar .bar .left_to_qualification{font-size:.7rem!important;top:2rem}.container_pool .qualification_status .wrapper_bar .blue_image{display:flex;align-items:center;padding-top:4px}.container_pool .qualification_status .wrapper_bar .blue_image img{width:1.5rem}.container_pool .qualification_status .wrapper_bar .blue_image p{font-weight:600;font-size:.8rem}}@media only screen and (max-width:470px){.container_pool .rewards_container .rewards_box{width:150px}.container_pool .rewards_container .rewards_box h3{font-size:.8rem}.container_pool .rewards_container .rewards_box .content_rewards{width:150px}.container_pool .table_pool .table_container table td,.container_pool .table_pool .table_container table th{font-size:.8rem}.container_pool .table_pool .table_container table .icon_table img{width:.9rem;margin-right:5px}.container_pool .qualification_status .wrapper_bar .bar .left_to_qualification{margin-left:0!important}}@media only screen and (max-width:350px){.container_pool .rewards_container{padding:0!important}.container_pool .rewards_container .rewards_box h3{font-size:.7rem;padding:.3rem 0}.container_pool .rewards_container .rewards_box .content_rewards{padding:.5rem .3rem}.container_pool .rewards_container .rewards_box .content_rewards img{width:2rem}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards{padding-left:.5rem}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards p{font-size:1.2rem}.container_pool .rewards_container .rewards_box .content_rewards .data_rewards span{font-size:.8rem}.container_pool .table_pool .table_container table td{font-size:.7rem}.container_pool .table_pool .table_container table .icon_table img{width:.7rem;margin-right:3px}}#auth_signup{width:1800px;max-width:100%;margin-left:auto;margin-right:auto}#auth_signup .help.is-danger{color:#d20505!important;font-weight:600!important}#auth_signup .VuePhoneNumberInput{margin-top:4px!important;border-radius:8px;border-color:rgba(25,23,75,.5)!important}#auth_signup .VuePhoneNumberInput label{margin-top:0!important;font-size:11px!important}#auth_signup .VuePhoneNumberInput .input-tel__label{color:#333364}#auth_signup .VuePhoneNumberInput .country-selector{height:50px!important}#auth_signup .VuePhoneNumberInput .country-selector__country-flag{top:25px}#auth_signup .VuePhoneNumberInput input{height:50px!important;border:0!important}#auth_signup .VuePhoneNumberInput input:first-child{background-color:rgba(25,23,75,.2)!important;color:#fff!important;margin-left:1px}#auth_signup .VuePhoneNumberInput .country-selector__list{margin-top:5px;box-shadow:0 0 40px #08071099;border:1px solid hsla(0,0%,100%,.1);backdrop-filter:blur(10px)}#auth_signup .VuePhoneNumberInput button{padding:0 10px!important;font-size:15px!important;border-radius:0!important}#auth_signup .VuePhoneNumberInput button:hover{background:#333364;color:#fff}#auth_signup .VuePhoneNumberInput:hover{border:none}#auth_signup .tooltip_disclaimer_new{color:#a9a9a9;width:1rem;margin-top:10px;margin-left:10px}#auth_signup .tooltip_disclaimer_new:hover{cursor:pointer;color:#19174b;transition:all .3s ease-out}#auth_signup .info{background:rgba(25,23,75,.7);color:#fff;padding:10px;border-radius:4px;box-shadow:0 0 5px 1px rgba(0,0,0,.2);font-size:13px;margin-top:5px}#auth_signup .bounce-enter-active{animation:bounce-in .5s}#auth_signup .bounce-leave-active{animation:bounce-in .5s reverse}@keyframes bounce-in{0%{transform:scale(0)}50%{transform:scale(1.1)}to{transform:scale(1)}}#auth_signup .input-tel__input[data-v-e59be3b4]{background-color:transparent;border:1px solid #fff}#auth_signup .country-selector__input{color:#747474!important}#auth_signup .auth_signup_left .auth_signup_left_container{width:541px;max-width:100%;display:block;margin-left:auto;margin-top:8vh}#auth_signup .auth_signup_left_img{display:inline-block;width:142px;margin-right:20px}#auth_signup .auth_signup_left_img .taller{display:none}@media screen and (max-width:1000px){#auth_signup .auth_signup_left_img{width:120px;margin-top:15%}}@media screen and (max-width:767px){#auth_signup .auth_signup_left_img{margin-top:0;width:95px;padding:0;margin-right:0}#auth_signup .auth_signup_left_img .taller{display:block}#auth_signup .auth_signup_left_img .tall{display:none}}@media screen and (max-width:400px){#auth_signup .auth_signup_left_img{width:95px;max-width:26%;margin-top:35px}}@media screen and (max-width:300px){#auth_signup .auth_signup_left_img{display:none}}#auth_signup .auth_signup_left_img svg{width:100%;height:auto;stroke:#fff!important;fill:transparent}#auth_signup .auth_signup_left_img svg .c1,#auth_signup .auth_signup_left_img svg .c2,#auth_signup .auth_signup_left_img svg .c3{fill:rgba(37,82,111,.9);fill:#fff}#auth_signup .auth_signup_left_text{width:230px;display:inline-block;vertical-align:top}@media screen and (max-width:400px){#auth_signup .auth_signup_left_text{font-size:12px;max-width:60%}}@media screen and (max-width:300px){#auth_signup .auth_signup_left_text{display:none;max-width:100%}}#auth_signup .auth_signup_left_text p{text-align:left;color:#fff;margin-bottom:40px}#auth_signup .auth_signup_left_text p:first-child,#auth_signup .auth_signup_left_text p:nth-child(2){color:#e2e1e1;opacity:.7}#auth_signup .auth_signup_left_text p:first-child strong,#auth_signup .auth_signup_left_text p:nth-child(2) strong{color:#e2e1e1}#auth_signup .auth_signup_left_text p strong{color:#fff;font-size:19px}@media screen and (min-width:768px){#auth_signup .auth_signup_right .form_container{margin-right:auto;margin-left:0}}#auth_signup .suggestion-box{border-radius:5px;background:#fff;padding:5px;color:#9b9b9b;display:flex;z-index:9999999;margin-bottom:-50px;position:relative;box-shadow:1px 10px 25px #010753}#auth_signup .suggestion-box button{border:1px solid #fff;color:#fff;cursor:pointer;background-color:#211c54}#auth_signup .suggestion-box button i{fill:#fff;color:#fff}#auth_signup .suggestion-box button:hover{background-color:#33296e}#auth_signup .suggestion-box .content_lock{display:flex;align-items:flex-end}#auth_signup .suggestion-box .suggestion_input{background-color:#e8e8e8;padding:3px;border-radius:5px;color:#46719e}#auth_signup .pointer,#auth_signup .suggestion-box .suggestion_input i{cursor:pointer}#auth_signup .rool{animation:roll infinite;animation-duration:3s}#auth_signup .slideOutUp{animation-name:slideOutUp;animation-duration:2s;animation-fill-mode:forwards;-webkit-animation-name:slideOutUp;-webkit-animation-duration:2s;-webkit-animation-fill-mode:forwards}@keyframes roll{0%{transform:rotate(-1turn)}to{transform:rotate(1turn)}}@keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0);z-index:-9999;opacity:0}}@-webkit-keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);z-index:-9999;opacity:0}}#auth_signup .input-container{display:flex;width:100%}#auth_signup .input-container input{border-right:none}#auth_signup .input-container .icon-content{border:1px solid #fff;border-left:none;background-color:transparent;width:30px;padding:5px}#auth_signup .input-container .icon-content i{color:#fff}#auth_signup .input-container .icon-content i svg{vertical-align:-webkit-baseline-middle}#page_history .page_history_full_data{overflow-x:auto;width:100%;height:100vh;position:fixed;background-color:rgba(41,38,38,.6);top:0;left:0}#page_history .page_history_full_data .cointainer_lg{max-width:90%;background-color:#c9c1c1;border-radius:0 0 3px 3px;background-color:#fff}#page_history .page_history_full_data .cointainer_lg:first-child{margin-top:5%;border-radius:3px 3px 0 0}#page_history .page_history_full_data .cointainer_lg:first-child a{padding:5px 12px;padding-top:5px;display:block;color:#161450;width:32px;margin-left:auto;font-size:19px;margin-right:16px;padding-top:16px}#page_history .page_history_full_data .cointainer_lg .history_full_data{padding-bottom:50px}#page_history .page_history_full_data .cointainer_lg .history_full_data .history_full_data_title{padding-bottom:20px;max-width:98%;display:block;margin-left:auto;margin-right:auto;margin-bottom:20px}#page_history .page_history_full_data .cointainer_lg .history_full_data .history_full_data_data{padding:0;border-bottom:1px solid #c4c1c1;padding-bottom:4px}#page_history .icon_delete:hover{color:red;size:15px;width:22px;height:22px;cursor:pointer}#page_history .icon_details:hover{color:#19d1a9;size:15px;width:22px;height:22px;cursor:pointer}#page_history .container_actions{display:flex;justify-content:space-between;width:75%;margin-left:auto;margin-right:auto}#page_history .custom_input_white{height:40px;background-color:transparent;border:1px solid grey;padding-left:14px;background:#fff}.md-theme-default a:not(.md-button){color:#60609b}.router-link-active{color:#22c8b5!important}.font-address{font-size:85%}canvas{max-height:100%}.notice{color:#f01a0b}.red{background:red;color:purple}.disabled{color:#c9c9c9;cursor:not-allowed}.disabled_bg{background-color:#c9c9c9!important;color:#80817b!important;cursor:not-allowed}.flex-fix{flex-basis:auto}#public_loading{font-weight:500}#public_loading .public_loading_1,#public_loading .public_loading_2,#public_loading .public_loading_3{font-size:20px;width:2px;display:inline-block;animation:animationBlink 2.4s infinite;opacity:.5}#public_loading .public_loading_1{animation-delay:.8s}#public_loading .public_loading_2{animation-delay:1.6s}#public_loading .public_loading_3{animation-delay:2.4s}@keyframes animationBlink{0%{opacity:.5}70%{opacity:1}to{opacity:.5}}.main_withdraw_bg{background-color:#9db2cb;background-color:#7578df}.main_yellow_bg{background-color:#e3a00a;border-radius:8px 8px 0 0}.main_red_bg{background-color:#ff5050}.main_lgreen_bg,.main_red_bg{color:#fff!important;fill:#fff!important;border-radius:8px 8px 0 0}.main_lgreen_bg{background-color:#23ddb2}.main_redeem_bg{background-color:#4c34ad}.main_green_md_bg{background-color:#2faba7}.main_blue_dk_bg,.main_blue_lt_normal{background-color:#342365}.main_blue_dk_bg_hover:hover{background-color:#4e4f99}.main_blue_dk_fill{color:#211c54!important;fill:#211c54!important}.grey_normal{color:#61717e!important;fill:#61717e!important;justify-content:space-between}.sub_sub_blue_dk_bg{background-color:#4e4f99}.sub_sub_blue_dk_bg_hover:hover{background-color:#60609b!important}.sub_green_lt_bg{background-color:#22c9b6!important}.sub_green_lt_bg_hover:hover{background-color:#11b5a2!important}.sub_purple_lt_bg{background-color:#4e4f99!important}.sub_purple_lt_bg:hover{background-color:#6d6dd4!important}.sub_sub_grey_dk_bg_hover:hover{background-color:#f8f8f8!important;color:#534a4a;border:1px solid #9d9595;border-bottom:none}.main_blue_md_bg{background-color:#42a4f5}.main_blue_md_fill{color:#42a4f5;fill:#42a4f5}.main_blue_lt_bg{background-color:#19d1a9}.main_blue_lt_fill{color:#19d1a9;fill:#19d1a9}.main_blue_lt_bg_hover:hover{background-color:#2ac2a1}.main_red_lt_bg{background-color:#d12828!important}.main_blue_md_fill{color:#80817b!important;fill:#80817b!important}.main_red_lt_bg{background-color:#d04e4e}.main_red_lt_fill{color:#d04e4e;fill:#d04e4e}.main_white_bg{background-color:#fff}.sub_blue_md_fill{fill:#6e6ea1;color:#6e6ea1}.main_white_fill{fill:#fff!important;color:#fff!important}.main_white_fill:hover{color:#d1d8df}html{scroll-behavior:smooth}html body{padding:0;margin:0}html body a,html body h1,html body h2,html body h3,html body p{display:block;max-width:100%}.infoblock,html body img{max-width:100%}.infoblock{text-align:center;position:fixed;bottom:0;right:0;background-color:rgba(213,116,55,.9);display:block;width:100%;padding:20px 10px;min-height:70px;box-shadow:-4px 0 2px rgba(68,51,51,.55);color:#fff}#main_header{padding:0 15px;display:block}#main_header .service-option-nav{color:#fff;display:flex;align-items:center;width:100px;justify-content:space-between}#main_header .service-dropdown{background:#342365;position:absolute;width:350px;color:#fff;padding:20px;margin-left:-20px}#main_header .service-dropdown-mobile{background:transparent;width:300px;color:#fff;padding:20px}#main_header .text_service_info{font-weight:100;font-size:13px;color:#a3a3e6}#main_header .text_service_disabled{color:#676767!important}#main_header .text_service_info_mobile{font-weight:100;font-size:13px;color:#fff}#main_header .service-dropdown-item{border-bottom:2px solid transparent}#main_header .service-dropdown-item:hover{border-bottom:2px solid #fff!important;width:80%!important}#main_header .main_header_left img{width:150px}#main_header .main_header_right{font-weight:400}#main_header .main_header_right ul li{display:inline-block;margin-left:20px}#main_header .main_header_right ul li a{display:block;color:#fff}#main_header .main_header_right ul li .router-link-active{color:#22c8b5!important;font-weight:600}@keyframes headerUnderline{0%{opacity:.1}to{opacity:1}}#main_header .main_header_bottom{background-color:#33296e;background-color:#424b7d}#main_header .main_header_bottom .blue_highlight{color:#91a8c5;font-size:10px!important;display:block}#main_header .main_header_bottom img{width:24px;vertical-align:middle;margin-right:7px}#main_header .main_header_bottom p{color:#fff}#main_header .main_header_bottom p span{margin-right:0}#main_header .main_header_bottom p span:first-child{margin-left:0;margin-right:4px}#main_header .container_header{max-width:1600px;width:100%;margin-left:auto;margin-right:auto;display:flex;justify-content:space-between;align-items:center}#main_header .container_header .wrapper_user{display:flex;padding:0 .5rem;color:#fff}#main_header .container_header .wrapper_user .user_id_email{display:flex;justify-content:start;width:100%}#main_header .container_header .wrapper_user .user_id_email .user_id{text-align:left}#main_header .container_header .wrapper_user .user_id_email .user_id span:last-child{border-right:1px solid #fff;padding-right:5px}#main_header .container_header .wrapper_user .user_id_email .member_email{margin-left:5px}#main_header .container_header .live_price{display:flex;align-items:center;padding:0 .5rem}#main_header .container_header .live_price .live_price_btn{display:flex;align-items:center;margin-right:12px}#main_header .container_header .live_price .live_price_btn button{margin-right:5px;height:12px;width:12px;border-radius:50%;outline:none;border:none;background:#f70707}@media screen and (max-width:900px){#main_header .container_header{flex-direction:column;font-size:.9rem}#main_header .container_header .wrapper_user{width:100%}#main_header .container_header .wrapper_user .user_id_email{justify-content:space-between}#main_header .container_header .wrapper_user .user_id_email .user_id span:last-child{border-right:none;padding-right:0}#main_header .container_header .wrapper_user .user_id_email .member_email{margin-left:0}#main_header .container_header .live_price{width:100%;justify-content:space-between;margin-top:5px}}@media screen and (max-width:350px){#main_header .container_header .live_price,#main_header .container_header .wrapper_user{padding:0}}.mobile_menu{padding-top:10px;padding-bottom:10px;padding-right:12px}.mobile_menu img{width:240px;max-width:90%;display:inline-block;vertical-align:text-bottom}.mobile_menu .menu_icon{width:25px;max-width:80%;margin-left:auto;margin-top:32px}@media screen and (max-width:1200px){.mobile_menu .menu_icon{margin-top:20px}}@media screen and (max-width:460px){.mobile_menu .menu_icon{margin-top:5px}}.mobile_menu .menu_icon_close{width:15px;max-width:80%;margin-left:auto;margin-top:32px}@media screen and (max-width:1200px){.mobile_menu .menu_icon_close{margin-top:20px}}@media screen and (max-width:460px){.mobile_menu .menu_icon_close{margin-top:5px}}.mobile_menu .mobile_menu_opened{position:fixed;top:0;background-color:hsla(0,0%,4%,.8);width:100%;height:100vh;z-index:9999}.mobile_menu .mobile_menu_opened .mobile_menu_opened_inner{background-color:rgba(31,35,66,.92);height:100vh;width:330px;max-width:100%;margin-left:auto}.mobile_menu .mobile_menu_opened .mobile_menu_opened_inner img{padding-top:15px}.mobile_menu .mobile_menu_opened .mobile_menu_opened_inner ul{width:200px;max-width:100%}.mobile_menu .mobile_menu_opened .mobile_menu_opened_inner ul li a{color:#fff}.prices_header{margin-left:10px;vertical-align:text-top}#main_footer .footer-content-background{background:#342365}#main_footer .footer-content-background .footer-content{display:flex;align-items:center;justify-content:space-between;margin:auto;max-width:1300px;width:100%;padding-bottom:.5rem}#main_footer .footer-content-background .footer-content .logo-center{display:flex;align-items:center;flex-direction:column;padding-left:2rem}#main_footer .footer-content-background .footer-content .logo-center img{width:15rem}#main_footer .footer-content-background .footer-content .logo-center p{color:#fff}#main_footer .footer-content-background .footer-content ul{display:flex;align-items:center;width:100%;justify-content:end;flex-wrap:wrap;padding-right:2rem}#main_footer .footer-content-background .footer-content ul li{margin-left:2%}#main_footer .footer-content-background .footer-content ul li a{color:#fff}@media screen and (max-width:900px){#main_footer .footer-content{flex-direction:column}#main_footer .footer-content .logo-center{align-items:center;padding-left:0!important}#main_footer .footer-content .logo-center img{width:10rem!important}#main_footer .footer-content ul{margin-top:1rem;justify-content:center!important;padding-right:0!important}}.landing_buy_redeem .buy_redeem_mode_button{display:inline-block}.landing_buy_redeem .buy_redeem_mode_button h1{padding:9px 5px 5px;border:hsla(0,0%,4%,.31);border-bottom-color:hsla(0,0%,4%,.31);border-bottom-style:none;border-bottom-width:medium;border-radius:15px 15px 0 0;min-width:130px;border-bottom:none;box-shadow:0 -2px 1px hsla(0,0%,4%,.19);background-color:#e9e9ec;color:#807b7b}.landing_buy_redeem .buy_redeem_mode_button_selected h1{background-color:#f8f8f8;margin-bottom:-4px!important;color:#7c7093}.selectWay{background-color:#2c2a39}.modalWarning,.selectWay{border-radius:0 0 7px 7px}.modalWarning{background-color:#5859a3}.balance_block{border-radius:5px;text-align:center;padding:10px;margin-bottom:10px;background-color:#747c95;color:#151313;background-color:#efefef}.blu_input_actions{display:inline-block;vertical-align:middle}.blu_input_plus,.blue_input_minus{display:block;width:50px;margin-top:3px;margin-bottom:3px;text-align:center;color:#fff;cursor:pointer}.blu_input_plus p,.blue_input_minus p{display:block;min-height:18px;padding:3px 0;border-radius:6px}.blu_input_plus svg,.blue_input_minus svg{width:17px;height:auto;fill:#0f1e72;color:#0f1e72;cursor:pointer}.arrow_disabled svg{width:17px;height:auto;fill:rgba(87,87,90,.3);color:hsla(230,3%,60%,.3);cursor:not-allowed}.has_error .blu_input{border:1px solid red!important;background-color:#e01414}.has_error .amount_address,.has_error .amount_redeem{border:2px solid red!important}.has_error_text{color:red;transform:scale(1.3)}.has_error_color{color:red}.blu_input_container{text-align:center;padding:16px 3px!important}.blu_input{vertical-align:bottom;background-color:#373869;display:inline-block;padding:10px 17px;color:#fff;font-size:27px;max-width:90%;text-align:right;margin-left:auto;margin-right:auto;border:1px solid #3b454e66;margin-bottom:2px;border-radius:8px;min-width:104px;vertical-align:top}.blu_input input{background-color:transparent;color:#fff;border:none;font-size:21px;text-align:right;width:147px}.blu_input input::placeholder{color:hsla(0,12%,90%,.685)}@media screen and (max-width:1180px){.blu_input{padding:4px;vertical-align:middle}.blu_input input{vertical-align:middle;font-size:17px;width:120px}}.blu_input input::-webkit-inner-spin-button,.blu_input input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.blu_input input[type=number]{-moz-appearance:textfield}.buy_blu_equivalent{margin-top:10px}.buy_blu_equivalent span{font-weight:600}.blu_input_img{width:55px;vertical-align:middle;display:inline-block}@media screen and (max-width:1180px){.blu_input_img{width:40px}}.blu_input_container_2{display:flex;align-items:center;justify-content:center;text-align:center}.blu_input_container_2 .has_error_color{color:red}@media screen and (max-width:768px){.blu_input_container_2{padding:.75rem 0}}.blu_input_2{vertical-align:bottom;background-color:#211b54;display:inline-block;font-size:27px;max-width:90%;border:1px solid transparent;margin-bottom:2px;border-radius:8px;vertical-align:top;width:40%}.blu_input_2 input{background-color:transparent;color:#fff;border:none;font-size:28px;width:100%;font-weight:500;text-align:right}.blu_input_2 input::placeholder{color:hsla(0,12%,90%,.685)}@media screen and (max-width:1180px){.blu_input_2{padding:4px;vertical-align:middle;width:100%}.blu_input_2 input{vertical-align:middle;font-size:20px;text-align:center}}.blu_input_2 input::-webkit-inner-spin-button,.blu_input_2 input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.blu_input_2 input[type=number]{-moz-appearance:textfield}.blu_input_img_2{width:auto;height:3.5rem!important;margin-right:.5rem;vertical-align:middle;display:inline-block}@media screen and (max-width:1200px){.blu_input_img_2{height:2.5rem!important}}.status_border{border-bottom:1px dashed #fff;margin-bottom:17px;padding-bottom:11px}.forcechange{background:#67ae81;min-width:248px;width:60%;min-height:30px;position:relative;bottom:0;right:0;text-align:center;cursor:pointer;border-radius:8px;padding:7px 4px;max-width:100%;color:#fff;display:block;margin-top:29px;margin-left:auto;margin-right:auto}.baseBuyFooter{padding:33px 14px 0;border-top:1px solid #bdbdbd}.forcechange2{position:relative;bottom:0;right:0;cursor:pointer;border-radius:8px;padding:0 4px;color:#fff;margin-top:0;margin-left:auto;margin-right:auto;color:#0d1c50;font-weight:600}.forcechange2,.transaction_loading{text-align:center}.transaction_loading svg{width:50px;display:block;text-align:center;margin-left:auto;margin-right:auto;animation-name:transaction_loading;animation-duration:4s;animation-iteration-count:infinite}.close_landing_buy_blu_watch{display:block;margin-left:auto;width:30px;text-align:center;font-size:20px;border-radius:50%;color:#554d86;margin-bottom:-59px;z-index:9999;position:relative;padding-top:17px}.close_landing_buy_blu_watch:hover{color:#11325f}.buy_blu_modal_warning{position:relative;width:100%;background-color:#5859a3;padding:15px 0;color:#fff;height:88%}.buy_blu_modal_warning .close{color:#fff;text-align:center;width:25px;border-radius:50%;background-color:#fff;color:#5372a8;height:24px;margin-bottom:-19px;margin-left:auto;margin-right:10px;text-decoration:none!important}.buy_blu_modal_warning h1{font-size:20px;color:#fcf9f4;text-align:center}.buy_blu_modal_warning h2{font-size:12px;text-transform:uppercase;color:#fcf9f4;text-align:center}.buy_blu_modal_warning button{border:2px solid transparent!important}.buy_blu_modal_warning .disabled_btn_custon{color:#404286!important;border:2px solid #404286!important;background-color:transparent!important;cursor:not-allowed;pointer-events:none}.buy_blu_modal_warning .link_wallet{max-width:280px;display:block;text-transform:uppercase;background-color:#ffa91f;border-radius:6px;padding:7px 0;margin-left:auto;margin-right:auto;height:auto;margin-bottom:0;color:#fff!important}.buy_blu_modal_warning .link_wallet img,.buy_blu_modal_warning .link_wallet p{display:inline-block;vertical-align:middle}.buy_blu_modal_warning .link_wallet img{width:30px}.buy_blu_modal_warning .link_footer_wallet a{display:inline;color:#fb0}.buy_blu_modal_select_way{position:relative;width:100%;background-color:#2c2a39;padding:15px 10px;color:#fff;height:70%}.buy_blu_modal_select_way .close{color:#fff;text-align:center;width:25px;border-radius:50%;background-color:#5372a8;height:24px;margin-bottom:-19px;margin-left:auto;margin-right:10px}.buy_blu_modal_select_way h1{font-size:20px;color:#fcf9f4;text-align:center}.buy_blu_modal_select_way h2{font-size:12px;text-transform:uppercase;color:#fcf9f4;text-align:center}.buy_blu_modal_select_way button{border:2px solid transparent!important}.buy_blu_modal_select_way .disabled_btn_custon{color:#404286!important;border:2px solid #404286!important;background-color:transparent!important;cursor:not-allowed;pointer-events:none}.buy_blu_modal_select_way .link_wallet{max-width:280px;display:block;text-transform:uppercase;background-color:#ffa91f;border-radius:6px;padding:7px 0;margin-left:auto;margin-right:auto;height:auto;margin-bottom:0;color:#fff!important}.buy_blu_modal_select_way .link_wallet p{display:inline-block;vertical-align:middle}.buy_blu_modal_select_way .link_wallet img{display:inline-block;vertical-align:middle;width:30px}.buy_blu_modal_select_way .link_footer_wallet a{display:inline;color:#fb0}.action_blocked_message{background-color:#565c8d;width:100%;max-width:468px;display:block;margin:26% auto 121px;padding:67px 3px;color:#fff;margin-top:40px;text-align:center;padding:42px}.pay_cash{margin-top:19px;max-width:507px;display:block;width:100%;margin-left:auto;margin-right:auto;padding:13px;font-size:15px}.pay_cash img{width:338px;max-width:97%;padding:7px;background-color:rgba(77,101,134,.9)}.pay_cash .pay_cash_text{max-width:287px;display:block;margin-left:auto;margin-right:auto}.pay_cash .pay_cash_text a{margin-top:11px}.pay_cash .pay_cash_text a:hover{color:#fff}@keyframes transaction_loading{50%{transform:rotate(1turn)}to{transform:rotate(0deg)}}p::-moz-selection,p::-webkit-selection,p::selection,p:focus,span::-moz-selection,span::-webkit-selection,span::selection,span:focus{background:hsla(0,0%,4%,0)!important;outline:none!important}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#landing_buy_blu .input_address{background:#eaeefa;border-radius:5px;display:flex;justify-content:space-between}#landing_buy_blu .input_address .input_address_container{padding:5px}#landing_buy_blu .input_address .input_address_button{background-color:#5859a3;height:100%;border-radius:0 5px 5px 0;padding:3px;width:10%;cursor:pointer}#landing_buy_blu .info_address{color:#0c8cea;font-size:25px}#landing_buy_blu .red_highlight{color:red}#landing_buy_blu .temporary_balance_warning{color:#31cb49;font-size:13px;font-weight:600}#landing_buy_blu .landing_buy_blu_qr_code_intro_text{text-align:center;margin-bottom:5px;font-size:13px!important}#landing_buy_blu .landing_buy_blu_amount_highlight{background-color:#4e5e86;text-align:center;color:#fff;padding:12px 10px;border-radius:2px}#landing_buy_blu .landing_buy_blu_amount_highlight span{display:block;font-size:1.6em}#landing_buy_blu .landing_buy_blu_transaction_details .landing_buy_blu_transaction_details_inner{background-color:#4e5e86;padding:20px 10px;color:#fff}#landing_buy_blu .landing_buy_blu_transaction_details .landing_buy_blu_transaction_details_inner .text_sm{display:block;color:#fff581}#landing_buy_blu .landing_buy_blu_transaction_details .landing_buy_blu_transaction_details_info{background-color:#4dc6a7;padding:20px 10px;color:#fff}#landing_buy_blu .landing_buy_blu_transaction_details .landing_buy_blu_transaction_details_info h1{font-size:26px}#landing_buy_blu .landing_buy_blu_processing_icon svg{fill:#8abec2;color:#8abec2;width:90px;max-width:100%;height:auto}#landing_buy_blu .landing_buy_blu_processing_active .landing_buy_blu_processing_icon svg{fill:#352763;color:#352763;fill:#19d1a9;color:#19d1a9}#landing_buy_blu .cash_icon{fill:#fff;color:#fff;vertical-align:middle}#landing_buy_blu .component_super_button{padding:10px;padding:9px 2px;font-size:12px}.bg_transparent{background-color:transparent;border:none;display:inline-block;width:50px;height:20px;margin-right:30px;cursor:pointer}#landing_charts .landing_charts_label{display:flex;justify-content:space-between;align-items:center;width:100%;margin-left:auto;margin-right:auto;flex-wrap:wrap;padding:0 1rem}#landing_charts .landing_charts_label .landing_charts_label_block{width:30px;height:15px;background:#424b7d;margin-right:5px}#landing_charts .landing_charts_label p{font-size:.8rem}#landing_charts .combo_buttons_charts{display:flex;justify-content:flex-end}@media screen and (max-width:768px){#landing_charts .combo_buttons_charts{padding:0}}#landing_charts .combo_buttons_charts button{padding:11px 22px;min-width:100px;background-color:#7f80ac;padding:6px;font-size:12px!important;border:none;color:#fff;cursor:pointer;font-weight:700;border-radius:5px;margin-left:10px}#landing_charts #mainChart{background-color:#f2f2f7;padding:10px;border-radius:5px;width:90%!important;margin-left:auto;margin-right:auto;margin-top:10px}#part_send .component_full_input_block{margin:10px 0}#part_send .component_full_input_block input{background-color:#fff}#part_receive p{width:360px;margin:10px auto 20px;word-break:break-all;max-width:100%}#part_receive .part_receive_warning span{width:500px;padding:10px 25px;margin-left:auto;margin-right:auto;max-width:100%;display:block;background-color:#211c54}#part_receive .part_receive_warning span p{color:#fff}#part_coin_buy{min-height:690px}#part_coin_buy .part_coin_buy_switch{display:flex;text-align:center}#part_coin_buy .part_coin_buy_switch .part_coin_buy_switch_icon{background-color:#e1dbdb;vertical-align:bottom;cursor:pointer}#part_coin_buy .part_coin_buy_switch .part_coin_buy_switch_icon .icon_class_2{margin-top:90%}#part_coin_buy .part_coin_buy_switch .part_coin_buy_switch_data{width:100%}#part_coin_buy .part_coin_buy_switch .part_coin_buy_switch_data input{display:block;background-color:#fff;border:none;width:100%;padding:15px 4px;border:1px solid grey}#part_coin_buy .part_coin_buy_switch .part_coin_buy_switch_data input:first-child{border-bottom:1px solid grey}#part_coin_buy #part_coin_buy_select_coin_column{margin-left:auto;margin-right:auto;max-width:95%;display:flex}.text_highlight{color:#d8d370}#page_auth{background:url(" + escape(__webpack_require__(1162)) + ");background-size:cover;background-repeat:no-repeat;background-attachment:fixed;background-position:50%;min-height:40vh;padding:0}#page_auth ::-webkit-input-placeholder{color:#e2e1e1;opacity:.9}#page_auth ::-moz-placeholder{color:#e2e1e1;opacity:.9}#page_auth :-ms-input-placeholder{color:#e2e1e1;opacity:.9}#page_auth :-moz-placeholder{color:#e2e1e1;opacity:.9}#page_auth .regular_submit{font-size:16px;font-weight:500}#page_auth .form_block_checkbox{padding:0}#page_auth .auth_header{position:absolute;width:100%;justify-content:space-between;padding:0 2rem;padding-top:1rem}#page_auth .auth_header,#page_auth .auth_header .price_container{display:flex;align-items:center}#page_auth .auth_header .price_container img{width:35px;height:auto;margin-right:10px}#page_auth .auth_header .price_container .price{display:inline-block;color:#fff}#page_auth .auth_header .price_container .price span{margin-left:5px;margin-right:5px}#page_auth .auth_header .price_container .price strong{color:#fff}@media screen and (max-width:768px){#page_auth .auth_header{display:none}}#page_auth .auth_body{min-height:100vh;padding:4rem 0}@media screen and (max-width:768px){#page_auth .auth_body{padding:2rem 0}}#page_auth .auth_footer{background-color:#fff}#page_auth .help.is-danger{color:#d20505!important;font-weight:600!important}#page_auth #auth_forgot_password .form_container,#page_auth #auth_forgot_userid .form_container,#page_auth #auth_login .form_container,#page_auth #auth_signup .form_container{background-color:hsla(0,0%,100%,.1);color:#fff;border-radius:10px;backdrop-filter:blur(10px);border:2px solid hsla(0,0%,100%,.1);box-shadow:0 0 40px rgba(8,7,16,.6);padding:30px 35px}#page_auth #auth_forgot_password .form_container .input_write_form,#page_auth #auth_forgot_userid .form_container .input_write_form,#page_auth #auth_login .form_container .input_write_form,#page_auth #auth_signup .form_container .input_write_form{display:block;height:50px;width:100%;background-color:rgba(25,23,75,.2)!important;color:#fff!important;border-radius:6px;padding:0 10px;margin-top:4px;font-size:14px;font-weight:300;outline:none;border:none}#page_auth #auth_forgot_password .form_container .input_write_form:focus,#page_auth #auth_forgot_userid .form_container .input_write_form:focus,#page_auth #auth_login .form_container .input_write_form:focus,#page_auth #auth_signup .form_container .input_write_form:focus{border:1px solid rgba(25,23,75,.5)}#page_auth #auth_forgot_password .form_container ::placeholder,#page_auth #auth_forgot_userid .form_container ::placeholder,#page_auth #auth_login .form_container ::placeholder,#page_auth #auth_signup .form_container ::placeholder{color:#fff}#page_auth #auth_forgot_password .form_container label,#page_auth #auth_forgot_userid .form_container label,#page_auth #auth_login .form_container label,#page_auth #auth_signup .form_container label{display:block;margin-top:10px;font-size:.9rem;font-weight:600}#page_auth #auth_forgot_password .form_container .your_id_is,#page_auth #auth_forgot_userid .form_container .your_id_is,#page_auth #auth_login .form_container .your_id_is,#page_auth #auth_signup .form_container .your_id_is{font-size:.8rem;text-align:center;padding-top:5px}#page_auth #auth_forgot_password .form_container button,#page_auth #auth_forgot_userid .form_container button,#page_auth #auth_login .form_container button,#page_auth #auth_signup .form_container button{width:100%;background-color:rgba(25,23,75,.7);color:#fff;padding:15px 0;font-size:18px;font-weight:600;border-radius:5px;cursor:pointer;outline:none;border:none;transition:all .3s ease-in-out}#page_auth #auth_forgot_password .form_container button:hover,#page_auth #auth_forgot_userid .form_container button:hover,#page_auth #auth_login .form_container button:hover,#page_auth #auth_signup .form_container button:hover{background-color:rgba(25,23,75,.9)}#page_auth #auth_forgot_password .form_container .not_member_yet,#page_auth #auth_forgot_userid .form_container .not_member_yet,#page_auth #auth_login .form_container .not_member_yet,#page_auth #auth_signup .form_container .not_member_yet{display:flex;align-items:center;margin-top:1.5rem}#page_auth #auth_forgot_password .form_container .not_member_yet a,#page_auth #auth_forgot_userid .form_container .not_member_yet a,#page_auth #auth_login .form_container .not_member_yet a,#page_auth #auth_signup .form_container .not_member_yet a{width:100%;color:#fff;text-align:center}#page_auth #auth_forgot_password .form_container .not_member_yet:after,#page_auth #auth_forgot_password .form_container .not_member_yet:before,#page_auth #auth_forgot_userid .form_container .not_member_yet:after,#page_auth #auth_forgot_userid .form_container .not_member_yet:before,#page_auth #auth_login .form_container .not_member_yet:after,#page_auth #auth_login .form_container .not_member_yet:before,#page_auth #auth_signup .form_container .not_member_yet:after,#page_auth #auth_signup .form_container .not_member_yet:before{content:\"\";width:100%;height:1px;background:#19174b;margin-top:1px}#page_auth #auth_forgot_password .form_container .blu-prices,#page_auth #auth_forgot_password .form_container .language-bar,#page_auth #auth_forgot_userid .form_container .blu-prices,#page_auth #auth_forgot_userid .form_container .language-bar,#page_auth #auth_login .form_container .blu-prices,#page_auth #auth_login .form_container .language-bar,#page_auth #auth_signup .form_container .blu-prices,#page_auth #auth_signup .form_container .language-bar{display:none}@media screen and (max-width:768px){#page_auth #auth_forgot_password .form_container,#page_auth #auth_forgot_userid .form_container,#page_auth #auth_login .form_container,#page_auth #auth_signup .form_container{margin-top:0;padding:15px;max-width:350px}#page_auth #auth_forgot_password .form_container .your_id_is,#page_auth #auth_forgot_userid .form_container .your_id_is,#page_auth #auth_login .form_container .your_id_is,#page_auth #auth_signup .form_container .your_id_is{font-size:.7rem!important}#page_auth #auth_forgot_password .form_container .language-bar,#page_auth #auth_forgot_userid .form_container .language-bar,#page_auth #auth_login .form_container .language-bar,#page_auth #auth_signup .form_container .language-bar{display:flex;justify-content:center;padding-bottom:15px}#page_auth #auth_forgot_password .form_container .blu-prices,#page_auth #auth_forgot_userid .form_container .blu-prices,#page_auth #auth_login .form_container .blu-prices,#page_auth #auth_signup .form_container .blu-prices{display:flex;justify-content:center;margin-bottom:15px}#page_auth #auth_forgot_password .form_container .blu-prices strong,#page_auth #auth_forgot_userid .form_container .blu-prices strong,#page_auth #auth_login .form_container .blu-prices strong,#page_auth #auth_signup .form_container .blu-prices strong{color:#fff!important}}@media screen and (max-width:350px){#page_auth #auth_forgot_password .form_container,#page_auth #auth_forgot_userid .form_container,#page_auth #auth_login .form_container,#page_auth #auth_signup .form_container{margin-top:0;padding:15px 10px;max-width:300px}#page_auth #auth_forgot_password .form_container .your_id_is,#page_auth #auth_forgot_userid .form_container .your_id_is,#page_auth #auth_login .form_container .your_id_is,#page_auth #auth_signup .form_container .your_id_is{font-size:.7rem!important}}#page_auth #auth_forgot_password .auth_logo,#page_auth #auth_forgot_userid .auth_logo,#page_auth #auth_login .auth_logo,#page_auth #auth_signup .auth_logo{width:200px;margin-bottom:15px;margin-left:auto;margin-right:auto;display:block}.page_banner_countdown .clock{text-align:center;background-color:rgba(68,75,144,.18);padding:6px 2px;margin-top:10px}.page_banner_countdown .clock div{display:inline-block}#documents_insights .link-content{padding:15px!important;width:80%;text-align:left}#documents_insights .bot-border{border-bottom:2px solid #d0d0d0}#report_insights .report_link{color:#717171;text-align:left;padding:0;margin:0;display:block}#report_insights .content_report{display:flex;justify-content:space-between;align-items:center}.backgorund_modal{height:100%;overflow-x:auto;padding:20px}.backgorund_modal,.form_bg{position:fixed;background-color:rgba(164,157,188,.39);width:100%;left:0;top:0;z-index:9999}.form_bg{height:100vh;display:none}.form_showing{display:flex;animation-name:opacityUp;animation-duration:.7s;animation-iteration-count:1}.form_showing .contact_form{animation-name:pop-from-side;animation-duration:.8s;animation-iteration-count:1}@keyframes opacityUp{0%{opacity:0}to{opacity:1}}@keyframes pop-from-side{0%{right:-500px;opacity:0}60%{opacity:1}80%{right:0}}.form_outside{background-color:transparent;flex-grow:1}.contact_form{background-color:#fff;top:0;right:0;max-width:96%;width:500px;height:100vh;overflow-y:auto;box-shadow:-5px 0 15px rgba(52,53,56,.52)}.contact_form .form_warning{background-color:#e9ce3d;margin-top:-4px;z-index:9;position:relative;border-radius:0 0 5px 5px;text-align:center}.contact_form .contact_form_body{text-align:justify;text-justify:inter-word}.contact_form .contact_form_body .contact_form_body_body{padding:0 20px}.contact_form .contact_form_body label{display:block;text-align:left}.contact_form .contact_form_body input{width:100%;padding:14px 10px;border-radius:5px;background-color:#fff;border:1px solid #b9b6b6}.contact_form .contact_form_body input:disabled{background-color:#cccaca;border:transparent;cursor:not-allowed}.contact_form .contact_form_body input:invalid,.contact_form .contact_form_body textarea:invalid{box-shadow:none}.contact_form .contact_form_body textarea{display:block;width:100%;resize:none;min-height:121px;padding:10px}.contact_form .contact_form_body button{width:201px;padding:20px 2px!important;border:none;color:#fff;cursor:pointer;font-weight:700;font-size:1em;border-radius:5px;display:block;margin-left:auto;background-color:#6fce8c}.contact_form .contact_form_body button:hover{background-color:#37b46b}.contact_form .contact_form_body button:disabled{background-color:#cec6c6;cursor:not-allowed;color:#ada8a8}.contact_form .contact_form_header{padding:21px 33px;background-color:#e36c6c;width:100%;color:#fff;text-transform:uppercase;font-weight:600;margin-bottom:30px;box-shadow:0 3px 4px #d5d0d0}.contact_form .contact_form_header h1{display:flex;font-weight:600}.contact_form .contact_form_header h1 .form_title{flex-grow:1;text-align:left}.contact_form .contact_form_header h1 .form_title svg{fill:#fff;color:#fff}.contact_form .contact_form_header h1 .form_close{display:block;width:29px;border-radius:50%;font-size:18px;height:29px;padding:6px 0;text-align:center;cursor:pointer}.bg_colorSubMainLatestGreen{background-color:#02b9a4}.bg_colorSubMainGreenLT{background-color:#22c9b6}.bg_colorSubMainGrey{background-color:grey}.component_card_select_2{width:100%;background:#fcfdfc 0 0 no-repeat;border-radius:8px}.component_card_select{width:100%;background-color:#342365;border-radius:8px;color:#fff}.component_card_select .component_card_select_title{padding:10px 0 10px 9px;text-align:center;border-radius:8px 8px 0 0}.component_card_select .component_card_select_body{padding:9px;border-radius:0 0 8px 8px;background-color:#2c2a39}.component_card_select .component_card_select_body .disabled_button{opacity:.3;cursor:not-allowed!important;pointer-events:none!important}.component_card_select .component_card_select_body .component_card_select_button{border:2px solid #404286;border-radius:10px;margin-bottom:12px;display:flex;flex-direction:row;align-items:flex-end}.component_card_select .component_card_select_body .component_card_select_button:hover{border:2px solid #0086cc;cursor:pointer}.component_card_select .component_card_select_body .component_card_select_button:last-child{margin-bottom:10px}.component_card_select .component_card_select_body .component_card_select_button .component_card_select_button_text .logo_text{display:flex;align-items:baseline;justify-content:space-between}.component_card_select .component_card_select_body .component_card_select_button .component_card_select_button_text .bt_orange{border-bottom:1px solid #f9ac1a}.component_card_select .component_card_select_body .component_card_select_button .component_card_select_button_text .bt_orange_sw{border-bottom:1px solid #f28e1c}.component_card_select .component_card_select_body .component_card_select_button .component_card_select_button_text .bt_blue{border-bottom:1px solid #5296ff}.component_card_select .component_card_select_body .component_card_select_button .component_card_select_button_text .custom_highlight{color:#5296ff}.component_card_select_white{background-color:transparent}.component_card_select_white .component_card_select_title{color:#7d7d7d}.component_card_select_white .component_card_select_body{background-color:transparent}.component_card_select_white .component_card_select_body .component_card_select_button{background-color:#2c2a39}.component_card_select_white .component_card_select_body .component_card_select_button:hover{background-color:#4b4862}.tag_container{position:relative;margin-bottom:10px;display:flex;width:100%;justify-content:end}.balance_tag_reverse{color:#fff;padding-left:20px;border-radius:24px 0 0 24px;width:40%;display:flex;align-items:center}.balance_tag_reverse img{height:60%}@media screen and (max-width:1200px){.balance_tag_reverse{width:50%}}.balance_tag_reverse:last-child{padding:.4rem .7rem;color:#22c8b5;font-weight:600}.balance_tag_reverse-c1{margin-right:-75px}@media screen and (max-width:768px){.balance_tag_reverse-c1{margin-right:-39px}}.tab_black{background:#3d3c3c}.tab_black_tron{width:30%;display:flex;align-items:center;padding:.4rem .7rem;color:#22c8b5;font-weight:600}.split-blocks .div_6{width:59%}.split-blocks .div_4{width:30%}.split-blocks .div_4,.split-blocks .div_6{display:inline-block;vertical-align:middle}@media screen and (max-width:768px){.split-blocks .div_4,.split-blocks .div_6{width:100%;display:block}}.link_highlight{text-decoration:underline;color:#4263b3;font-weight:600}.text_xxs_px{font-size:10px}.tooltip_sz1{max-width:500px}.val_init{vertical-align:initial}.error_text_min{font-weight:600;display:block}.column_p_left{padding-left:.75rem}.no_transform{text-transform:none}.block{display:block}.default-button{margin-left:auto;display:block;border:none;color:#fff;padding:10px;text-transform:uppercase;font-weight:600;cursor:pointer;width:100%;border-radius:8px}.vgt-table{font-size:14px!important}", ""]);

// exports


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_BLU.png?da18ad3a43f642b2de4ab6e74d68364c";

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bitcoin-btc-logo.svg?f92890de8d6512e2597d378f00254e71";

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bitcoin-cash-bch-logo.svg?0afaa6a2677c0731279424992179d098";

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cardano_coin.svg?6aea691c581b22a12b85bbe81506ae8b";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ethereum-classic-etc-logo.svg?9d4534ae68dc2efc7ee6f7186e3c8b6b";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_DASH.png?0a68317914a188936c9af28703743cad";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eos-eos-logo.svg?88afb8dbf83299f8a42baa6f78479130";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "litecoin-ltc-logo.svg?6046cca14ef5741d48469675250f8d1a";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_MONERO.png?2d95271c9ff5a1e1fd1e15c125297a1e";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_OTHER.png?24bf1c74c33a5d4c7d8a360045f8635e";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_RIPPLE.png?77508cc6cabdb53658279ea2adc14926";

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_SMARTCASH.png?4ad5ca745eb8f10a8329e2ab326458ea";

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_XEM.png?e08c65d8aed964d1e630f42e5c15ae5b";

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_ZCORE.png?dd58d652805658b02a688eb307b42fad";

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_IOTA.png?420a88202d584f3cafba15cd9bee70c0";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "real_icon.svg?f8e7bc1f1872012b834b8da38e105f59";

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_TRX.png?f6d12061229b4b16a1c0c3fe3336004f";

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_BNB.svg?1aa88810b9f05826b0ce034c0799f7e6";

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_LUNA.png?736137520a68d49f7dfba7e21d87e8f9";

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_DASHG.png?ddece040005c1c166ef8cb450e37ca45";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_XBI.png?278ae07c02293b63f20278738d1832f3";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_DKPC.png?46d3ddd7d9c4cbaecdd72e2aaea64c83";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_C2P.png?80e864d5875be64cc378ad1c84c3d50f";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Bitcoin.svg?a83b2040f2facc5d3feea4770c18fcde";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pix.svg?90f26310afd08045d3268c69e92bd994";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mana.png?aecf42b4b85cb5ee1c0e393e2661bd20";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "TUSD.svg?cdb7aa9ecbd2df3503ba41093996484c";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ras_icon_white.svg?fea4a34e132ca51881bdb85648c57b4a";

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ras_icon.svg?0908e16c1f66065a6c58dafb2e18e4cc";

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_HKD.svg?0a2a99c1a58342aa1f5cbdcf3165b5e6";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cad_icon.svg?a71776d8749ca4693ff576ac0b5e9234";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aud_icon.svg?dacc942534d43bbc7e8b52fa5010a786";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_ZAR.svg?22c322317584fc761c430dd34cddb912";

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_EUR.svg?2903db48e3ab0651a7e9ff2d445e71c5";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_GBP.svg?fc66a228dd861819299a16641e6d8fb4";

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_CHF.svg?d92728e92bfdd2ad0bf9dc52dc3c83c4";

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_CNY.svg?676403bc53355b612f37bf5986f32b9d";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "coin_TON.svg?198aeeb8ef4406cf3654cd6d28d007ae";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "hourglass.png?d88b77b38e76dfa04289d33b3e37f960";

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "notokay.png?f15b984445ab0a3ddf2bbbabd1a47293";

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "chainlink-link-logo.svg?4b02bc11930246d53d859deaa960862f";

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "algo_icon.svg?a25dd812295506712679a989e55d504a";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mkr_icon.svg?ccae70ca190740a89660cc0a37676ce8";

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lend_icon.svg?979372604c438d6449f28ab6bf00a47b";

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aave_icon.svg?3f624769537ffdeaff8f53c7fbba1a37";

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dash_icon.svg?94b9ae90fc721072b5f8199a6ab9a747";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "xmr_icon.svg?d8ace92feda2a87e89037a34bb1db871";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dot_coin.svg?7544a7dc0217267f00df8da7abbf25f5";

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fil_icon.svg?db474a72881fcbd29464e9da254b34fe";

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-cake.svg?af6957bb6863296ca3dc3dce9fce16d8";

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mbox.png?6c83ea5f25276eb877c7e3dfbd236275";

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-sand.svg?726bbf44bd84cc2daa0ca92d151b3eb4";

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-xtz.svg?7e1e4e74cab85258c94df54edf3ac9d0";

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-egld.svg?c9d5c6f2fb5be5164c08481803970575";

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-axs.svg?20c5555bdd39ab70c5900a84c9335095";

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-avax.svg?d37554b41cd1343f55f99f160aad0180";

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-matic.svg?1087d3d671ac2ca5eeea49c18e1175bf";

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-crv.svg?d756baa6a49d3f0ce6bd6836f58e5a40";

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ico-crypto-sol.svg?4e6fecb2c83dd517ad34f5851b99ca82";

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "page_contact_bg.png?d81da17dad0cab5ddfb648679627a548";

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(5)("d4c39f0e", content, true, {});

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(false);
// imports


// module
exports.push([module.i, "#main,.scroll-hidden{min-height:100vh}.scroll-hidden{overflow:hidden;height:100vh}#template_header{background-color:#535768}#template_header img{width:100px;max-width:100%}.template_sample_body{padding-top:11vh;margin-top:-11vh;min-height:80vh}.template_sub_menu{text-align:right}.template_input{background-color:#f4efef;width:150px;max-width:90%;padding:5px;min-height:35px}.template_input_border{border:none;border-radius:4px;box-shadow:inset 0 0 10px hsla(0,1%,41%,.493)}", ""]);

// exports


/***/ })
],[464]);


// WEBPACK FOOTER //
// main.680c39814d977fee7095.js